var NinjaStudio = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __export = (target2, all) => {
    for (var name in all)
      __defProp(target2, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to2, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to2, key) && key !== except)
          __defProp(to2, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to2;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // src/index.js
  var src_exports = {};
  __export(src_exports, {
    MODES: () => MODES,
    config: () => cfg,
    mount: () => mount
  });

  // node_modules/fabric/dist/index.min.mjs
  var e = Object.defineProperty;
  var t = (t2, n2) => {
    let r2 = {};
    for (var i2 in t2) e(r2, i2, { get: t2[i2], enumerable: true });
    return n2 || e(r2, Symbol.toStringTag, { value: `Module` }), r2;
  };
  function n(e24) {
    return n = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(e25) {
      return typeof e25;
    } : function(e25) {
      return e25 && typeof Symbol == `function` && e25.constructor === Symbol && e25 !== Symbol.prototype ? `symbol` : typeof e25;
    }, n(e24);
  }
  function r(e24) {
    var t2 = function(e25, t3) {
      if (n(e25) != `object` || !e25) return e25;
      var r2 = e25[Symbol.toPrimitive];
      if (r2 !== void 0) {
        var i2 = r2.call(e25, t3 || `default`);
        if (n(i2) != `object`) return i2;
        throw TypeError(`@@toPrimitive must return a primitive value.`);
      }
      return (t3 === `string` ? String : Number)(e25);
    }(e24, `string`);
    return n(t2) == `symbol` ? t2 : t2 + ``;
  }
  function i(e24, t2, n2) {
    return (t2 = r(t2)) in e24 ? Object.defineProperty(e24, t2, { value: n2, enumerable: true, configurable: true, writable: true }) : e24[t2] = n2, e24;
  }
  var a = class {
    constructor() {
      i(this, `browserShadowBlurConstant`, 1), i(this, `DPI`, 96), i(this, `devicePixelRatio`, typeof window < `u` ? window.devicePixelRatio : 1), i(this, `perfLimitSizeTotal`, 2097152), i(this, `maxCacheSideLimit`, 4096), i(this, `minCacheSideLimit`, 256), i(this, `disableStyleCopyPaste`, false), i(this, `enableGLFiltering`, true), i(this, `textureSize`, 4096), i(this, `forceGLPutImageData`, false), i(this, `cachesBoundsOfCurve`, false), i(this, `fontPaths`, {}), i(this, `NUM_FRACTION_DIGITS`, 4);
    }
  };
  var o = new class extends a {
    constructor(e24) {
      super(), this.configure(e24);
    }
    configure(e24 = {}) {
      Object.assign(this, e24);
    }
    addFonts(e24 = {}) {
      this.fontPaths = { ...this.fontPaths, ...e24 };
    }
    removeFonts(e24 = []) {
      e24.forEach((e25) => {
        delete this.fontPaths[e25];
      });
    }
    clearFonts() {
      this.fontPaths = {};
    }
    restoreDefaults(e24) {
      let t2 = new a(), n2 = (e24 == null ? void 0 : e24.reduce((e25, n3) => (e25[n3] = t2[n3], e25), {})) || t2;
      this.configure(n2);
    }
  }();
  var s = (e24, ...t2) => console[e24](`fabric`, ...t2);
  var c = class extends Error {
    constructor(e24, t2) {
      super(`fabric: ${e24}`, t2);
    }
  };
  var l = class extends c {
    constructor(e24) {
      super(`${e24} 'options.signal' is in 'aborted' state`);
    }
  };
  var u = class {
  };
  var d = class extends u {
    testPrecision(e24, t2) {
      let n2 = `precision ${t2} float;
void main(){}`, r2 = e24.createShader(e24.FRAGMENT_SHADER);
      return !!r2 && (e24.shaderSource(r2, n2), e24.compileShader(r2), !!e24.getShaderParameter(r2, e24.COMPILE_STATUS));
    }
    queryWebGL(e24) {
      let t2 = e24.getContext(`webgl`);
      t2 && (this.maxTextureSize = t2.getParameter(t2.MAX_TEXTURE_SIZE), this.GLPrecision = [`highp`, `mediump`, `lowp`].find((e25) => this.testPrecision(t2, e25)), t2.getExtension(`WEBGL_lose_context`).loseContext(), s(`log`, `WebGL: max texture size ${this.maxTextureSize}`));
    }
    isSupported(e24) {
      return !!this.maxTextureSize && this.maxTextureSize >= e24;
    }
  };
  var f = {};
  var p;
  var h = () => p || (p = { document, window, isTouchSupported: `ontouchstart` in window || `ontouchstart` in document || window && window.navigator && window.navigator.maxTouchPoints > 0, WebGLProbe: new d(), dispose() {
  }, copyPasteData: f });
  var g = () => h().document;
  var _ = () => h().window;
  var v = () => {
    var e24;
    return Math.max((e24 = o.devicePixelRatio) == null ? _().devicePixelRatio : e24, 1);
  };
  var y = new class {
    constructor() {
      i(this, `boundsOfCurveCache`, {}), this.charWidthsCache = /* @__PURE__ */ new Map();
    }
    getFontCache({ fontFamily: e24, fontStyle: t2, fontWeight: n2 }) {
      e24 = e24.toLowerCase();
      let r2 = this.charWidthsCache;
      r2.has(e24) || r2.set(e24, /* @__PURE__ */ new Map());
      let i2 = r2.get(e24), a2 = `${t2.toLowerCase()}_${(n2 + ``).toLowerCase()}`;
      return i2.has(a2) || i2.set(a2, /* @__PURE__ */ new Map()), i2.get(a2);
    }
    clearFontCache(e24) {
      e24 ? this.charWidthsCache.delete((e24 || ``).toLowerCase()) : this.charWidthsCache = /* @__PURE__ */ new Map();
    }
    limitDimsByArea(e24) {
      let { perfLimitSizeTotal: t2 } = o, n2 = Math.sqrt(t2 * e24);
      return [Math.floor(n2), Math.floor(t2 / n2)];
    }
  }();
  var b = `7.4.0`;
  function x() {
  }
  var S = Math.PI / 2;
  var C = Math.PI / 4;
  var w = 2 * Math.PI;
  var ee = Math.PI / 180;
  var T = Object.freeze([1, 0, 0, 1, 0, 0]);
  var E = `center`;
  var D = `left`;
  var O = `bottom`;
  var k = `right`;
  var te = `none`;
  var ne = /\r?\n/;
  var re = `moving`;
  var ie = `scaling`;
  var ae = `rotating`;
  var oe = `rotate`;
  var A = `skewing`;
  var se = `resizing`;
  var ce = `modifyPoly`;
  var le = `changed`;
  var ue = `scale`;
  var de = `scaleX`;
  var fe = `scaleY`;
  var pe = `skewX`;
  var me = `skewY`;
  var j = `fill`;
  var he = `stroke`;
  var ge = `modified`;
  var _e = `normal`;
  var ve = `json`;
  var M = new class {
    constructor() {
      this[ve] = /* @__PURE__ */ new Map(), this.svg = /* @__PURE__ */ new Map();
    }
    has(e24) {
      return this[ve].has(e24);
    }
    getClass(e24) {
      let t2 = this[ve].get(e24);
      if (!t2) throw new c(`No class registered for ${e24}`);
      return t2;
    }
    setClass(e24, t2) {
      t2 ? this[ve].set(t2, e24) : (this[ve].set(e24.type, e24), this[ve].set(e24.type.toLowerCase(), e24));
    }
    getSVGClass(e24) {
      return this.svg.get(e24);
    }
    setSVGClass(e24, t2) {
      this.svg.set(t2 == null ? e24.type.toLowerCase() : t2, e24);
    }
  }();
  var ye = new class extends Array {
    remove(e24) {
      let t2 = this.indexOf(e24);
      t2 > -1 && this.splice(t2, 1);
    }
    cancelAll() {
      let e24 = this.splice(0);
      return e24.forEach((e25) => e25.abort()), e24;
    }
    cancelByCanvas(e24) {
      if (!e24) return [];
      let t2 = this.filter((t3) => {
        var n2;
        return t3.target === e24 || typeof t3.target == `object` && ((n2 = t3.target) == null ? void 0 : n2.canvas) === e24;
      });
      return t2.forEach((e25) => e25.abort()), t2;
    }
    cancelByTarget(e24) {
      if (!e24) return [];
      let t2 = this.filter((t3) => t3.target === e24);
      return t2.forEach((e25) => e25.abort()), t2;
    }
  }();
  var be = class {
    constructor() {
      i(this, `__eventListeners`, {});
    }
    on(e24, t2) {
      if (this.__eventListeners || (this.__eventListeners = {}), typeof e24 == `object`) return Object.entries(e24).forEach(([e25, t3]) => {
        this.on(e25, t3);
      }), () => this.off(e24);
      if (t2) {
        let n2 = e24;
        return this.__eventListeners[n2] || (this.__eventListeners[n2] = []), this.__eventListeners[n2].push(t2), () => this.off(n2, t2);
      }
      return () => false;
    }
    once(e24, t2) {
      if (typeof e24 == `object`) {
        let t3 = [];
        return Object.entries(e24).forEach(([e25, n2]) => {
          t3.push(this.once(e25, n2));
        }), () => t3.forEach((e25) => e25());
      }
      if (t2) {
        let n2 = this.on(e24, function(...e25) {
          t2.call(this, ...e25), n2();
        });
        return n2;
      }
      return () => false;
    }
    _removeEventListener(e24, t2) {
      if (this.__eventListeners[e24]) if (t2) {
        let n2 = this.__eventListeners[e24], r2 = n2.indexOf(t2);
        r2 > -1 && n2.splice(r2, 1);
      } else this.__eventListeners[e24] = [];
    }
    off(e24, t2) {
      if (this.__eventListeners) if (e24 === void 0) for (let e25 in this.__eventListeners) this._removeEventListener(e25);
      else typeof e24 == `object` ? Object.entries(e24).forEach(([e25, t3]) => {
        this._removeEventListener(e25, t3);
      }) : this._removeEventListener(e24, t2);
    }
    fire(e24, t2) {
      var n2;
      if (!this.__eventListeners) return;
      let r2 = (n2 = this.__eventListeners[e24]) == null ? void 0 : n2.concat();
      if (r2) for (let e25 = 0; e25 < r2.length; e25++) r2[e25].call(this, t2 || {});
    }
  };
  var xe = (e24, t2) => {
    let n2 = e24.indexOf(t2);
    return n2 !== -1 && e24.splice(n2, 1), e24;
  };
  var Se = (e24) => {
    if (e24 === 0) return 1;
    switch (Math.abs(e24) / S) {
      case 1:
      case 3:
        return 0;
      case 2:
        return -1;
    }
    return Math.cos(e24);
  };
  var Ce = (e24) => {
    if (e24 === 0) return 0;
    let t2 = e24 / S, n2 = Math.sign(e24);
    switch (t2) {
      case 1:
        return n2;
      case 2:
        return 0;
      case 3:
        return -n2;
    }
    return Math.sin(e24);
  };
  var N = class e2 {
    constructor(e24 = 0, t2 = 0) {
      typeof e24 == `object` ? (this.x = e24.x, this.y = e24.y) : (this.x = e24, this.y = t2);
    }
    add(t2) {
      return new e2(this.x + t2.x, this.y + t2.y);
    }
    addEquals(e24) {
      return this.x += e24.x, this.y += e24.y, this;
    }
    scalarAdd(t2) {
      return new e2(this.x + t2, this.y + t2);
    }
    scalarAddEquals(e24) {
      return this.x += e24, this.y += e24, this;
    }
    subtract(t2) {
      return new e2(this.x - t2.x, this.y - t2.y);
    }
    subtractEquals(e24) {
      return this.x -= e24.x, this.y -= e24.y, this;
    }
    scalarSubtract(t2) {
      return new e2(this.x - t2, this.y - t2);
    }
    scalarSubtractEquals(e24) {
      return this.x -= e24, this.y -= e24, this;
    }
    multiply(t2) {
      return new e2(this.x * t2.x, this.y * t2.y);
    }
    scalarMultiply(t2) {
      return new e2(this.x * t2, this.y * t2);
    }
    scalarMultiplyEquals(e24) {
      return this.x *= e24, this.y *= e24, this;
    }
    divide(t2) {
      return new e2(this.x / t2.x, this.y / t2.y);
    }
    scalarDivide(t2) {
      return new e2(this.x / t2, this.y / t2);
    }
    scalarDivideEquals(e24) {
      return this.x /= e24, this.y /= e24, this;
    }
    eq(e24) {
      return this.x === e24.x && this.y === e24.y;
    }
    lt(e24) {
      return this.x < e24.x && this.y < e24.y;
    }
    lte(e24) {
      return this.x <= e24.x && this.y <= e24.y;
    }
    gt(e24) {
      return this.x > e24.x && this.y > e24.y;
    }
    gte(e24) {
      return this.x >= e24.x && this.y >= e24.y;
    }
    lerp(t2, n2 = 0.5) {
      return n2 = Math.max(Math.min(1, n2), 0), new e2(this.x + (t2.x - this.x) * n2, this.y + (t2.y - this.y) * n2);
    }
    distanceFrom(e24) {
      let t2 = this.x - e24.x, n2 = this.y - e24.y;
      return Math.sqrt(t2 * t2 + n2 * n2);
    }
    midPointFrom(e24) {
      return this.lerp(e24);
    }
    min(t2) {
      return new e2(Math.min(this.x, t2.x), Math.min(this.y, t2.y));
    }
    max(t2) {
      return new e2(Math.max(this.x, t2.x), Math.max(this.y, t2.y));
    }
    toString() {
      return `${this.x},${this.y}`;
    }
    setXY(e24, t2) {
      return this.x = e24, this.y = t2, this;
    }
    setX(e24) {
      return this.x = e24, this;
    }
    setY(e24) {
      return this.y = e24, this;
    }
    setFromPoint(e24) {
      return this.x = e24.x, this.y = e24.y, this;
    }
    swap(e24) {
      let t2 = this.x, n2 = this.y;
      this.x = e24.x, this.y = e24.y, e24.x = t2, e24.y = n2;
    }
    clone() {
      return new e2(this.x, this.y);
    }
    rotate(t2, n2 = we) {
      let r2 = Ce(t2), i2 = Se(t2), a2 = this.subtract(n2);
      return new e2(a2.x * i2 - a2.y * r2, a2.x * r2 + a2.y * i2).add(n2);
    }
    transform(t2, n2 = false) {
      return new e2(t2[0] * this.x + t2[2] * this.y + (n2 ? 0 : t2[4]), t2[1] * this.x + t2[3] * this.y + (n2 ? 0 : t2[5]));
    }
  };
  var we = new N(0, 0);
  var Te = (e24) => !!e24 && Array.isArray(e24._objects);
  function Ee(e24) {
    class t2 extends e24 {
      constructor(...e25) {
        super(...e25), i(this, `_objects`, []);
      }
      _onObjectAdded(e25) {
      }
      _onObjectRemoved(e25) {
      }
      _onStackOrderChanged(e25) {
      }
      add(...e25) {
        let t3 = this._objects.push(...e25);
        return e25.forEach((e26) => this._onObjectAdded(e26)), t3;
      }
      insertAt(e25, ...t3) {
        return this._objects.splice(e25, 0, ...t3), t3.forEach((e26) => this._onObjectAdded(e26)), this._objects.length;
      }
      remove(...e25) {
        let t3 = this._objects, n2 = [];
        return e25.forEach((e26) => {
          let r2 = t3.indexOf(e26);
          r2 !== -1 && (t3.splice(r2, 1), n2.push(e26), this._onObjectRemoved(e26));
        }), n2;
      }
      forEachObject(e25) {
        this.getObjects().forEach((t3, n2, r2) => e25(t3, n2, r2));
      }
      getObjects(...e25) {
        return e25.length === 0 ? [...this._objects] : this._objects.filter((t3) => t3.isType(...e25));
      }
      item(e25) {
        return this._objects[e25];
      }
      isEmpty() {
        return this._objects.length === 0;
      }
      size() {
        return this._objects.length;
      }
      contains(e25, n2) {
        return !!this._objects.includes(e25) || !!n2 && this._objects.some((n3) => n3 instanceof t2 && n3.contains(e25, true));
      }
      complexity() {
        return this._objects.reduce((e25, t3) => e25 += t3.complexity ? t3.complexity() : 0, 0);
      }
      sendObjectToBack(e25) {
        return !(!e25 || e25 === this._objects[0]) && (xe(this._objects, e25), this._objects.unshift(e25), this._onStackOrderChanged(e25), true);
      }
      bringObjectToFront(e25) {
        return !(!e25 || e25 === this._objects[this._objects.length - 1]) && (xe(this._objects, e25), this._objects.push(e25), this._onStackOrderChanged(e25), true);
      }
      sendObjectBackwards(e25, t3) {
        if (!e25) return false;
        let n2 = this._objects.indexOf(e25);
        if (n2 !== 0) {
          let r2 = this.findNewLowerIndex(e25, n2, t3);
          return xe(this._objects, e25), this._objects.splice(r2, 0, e25), this._onStackOrderChanged(e25), true;
        }
        return false;
      }
      bringObjectForward(e25, t3) {
        if (!e25) return false;
        let n2 = this._objects.indexOf(e25);
        if (n2 !== this._objects.length - 1) {
          let r2 = this.findNewUpperIndex(e25, n2, t3);
          return xe(this._objects, e25), this._objects.splice(r2, 0, e25), this._onStackOrderChanged(e25), true;
        }
        return false;
      }
      moveObjectTo(e25, t3) {
        return e25 !== this._objects[t3] && (xe(this._objects, e25), this._objects.splice(t3, 0, e25), this._onStackOrderChanged(e25), true);
      }
      findNewLowerIndex(e25, t3, n2) {
        let r2;
        if (n2) {
          r2 = t3;
          for (let n3 = t3 - 1; n3 >= 0; --n3) if (e25.isOverlapping(this._objects[n3])) {
            r2 = n3;
            break;
          }
        } else r2 = t3 - 1;
        return r2;
      }
      findNewUpperIndex(e25, t3, n2) {
        let r2;
        if (n2) {
          r2 = t3;
          for (let n3 = t3 + 1; n3 < this._objects.length; ++n3) if (e25.isOverlapping(this._objects[n3])) {
            r2 = n3;
            break;
          }
        } else r2 = t3 + 1;
        return r2;
      }
      collectObjects({ left: e25, top: t3, width: n2, height: r2 }, { includeIntersecting: i2 = true } = {}) {
        let a2 = [], o2 = new N(e25, t3), s3 = o2.add(new N(n2, r2));
        for (let e26 = this._objects.length - 1; e26 >= 0; e26--) {
          let t4 = this._objects[e26];
          t4.selectable && t4.visible && (i2 && t4.intersectsWithRect(o2, s3) || t4.isContainedWithinRect(o2, s3) || i2 && t4.containsPoint(o2) || i2 && t4.containsPoint(s3)) && a2.push(t4);
        }
        return a2;
      }
    }
    return t2;
  }
  var De = class extends be {
    _setOptions(e24 = {}) {
      for (let t2 in e24) this.set(t2, e24[t2]);
    }
    _setObject(e24) {
      for (let t2 in e24) this._set(t2, e24[t2]);
    }
    set(e24, t2) {
      return typeof e24 == `object` ? this._setObject(e24) : this._set(e24, t2), this;
    }
    _set(e24, t2) {
      this[e24] = t2;
    }
    toggle(e24) {
      let t2 = this.get(e24);
      return typeof t2 == `boolean` && this.set(e24, !t2), this;
    }
    get(e24) {
      return this[e24];
    }
  };
  function Oe(e24) {
    return _().requestAnimationFrame(e24);
  }
  function ke(e24) {
    return _().cancelAnimationFrame(e24);
  }
  var Ae = 0;
  var je = () => Ae++;
  var P = () => {
    let e24 = g().createElement(`canvas`);
    if (!e24 || e24.getContext === void 0) throw new c("Failed to create `canvas` element");
    return e24;
  };
  var Me = () => g().createElement(`img`);
  var Ne = (e24) => {
    var t2;
    let n2 = F(e24);
    return (t2 = n2.getContext(`2d`)) == null || t2.drawImage(e24, 0, 0), n2;
  };
  var F = (e24) => {
    let t2 = P();
    return t2.width = e24.width, t2.height = e24.height, t2;
  };
  var Pe = (e24, t2, n2) => e24.toDataURL(`image/${t2}`, n2);
  var Fe = (e24, t2, n2) => new Promise((r2, i2) => {
    e24.toBlob(r2, `image/${t2}`, n2);
  });
  var I = (e24) => e24 * ee;
  var Ie = (e24) => e24 / ee;
  var Le = (e24) => e24.every((e25, t2) => e25 === T[t2]);
  var L = (e24, t2, n2) => new N(e24).transform(t2, n2);
  var R = (e24) => {
    let t2 = 1 / (e24[0] * e24[3] - e24[1] * e24[2]), n2 = [t2 * e24[3], -t2 * e24[1], -t2 * e24[2], t2 * e24[0], 0, 0], { x: r2, y: i2 } = new N(e24[4], e24[5]).transform(n2, true);
    return n2[4] = -r2, n2[5] = -i2, n2;
  };
  var z = (e24, t2, n2) => [e24[0] * t2[0] + e24[2] * t2[1], e24[1] * t2[0] + e24[3] * t2[1], e24[0] * t2[2] + e24[2] * t2[3], e24[1] * t2[2] + e24[3] * t2[3], n2 ? 0 : e24[0] * t2[4] + e24[2] * t2[5] + e24[4], n2 ? 0 : e24[1] * t2[4] + e24[3] * t2[5] + e24[5]];
  var Re = (e24, t2) => e24.reduceRight((e25, n2) => n2 && e25 ? z(n2, e25, t2) : n2 || e25, void 0) || T.concat();
  var ze = ([e24, t2]) => Math.atan2(t2, e24);
  var Be = ([e24, t2]) => Math.sqrt(e24 * e24 + t2 * t2);
  var Ve = ([, , e24, t2]) => Math.sqrt(e24 * e24 + t2 * t2);
  var He = (e24) => {
    let t2 = ze(e24), n2 = e24[0] ** 2 + e24[1] ** 2, r2 = Math.sqrt(n2), i2 = (e24[0] * e24[3] - e24[2] * e24[1]) / r2, a2 = Math.atan2(e24[0] * e24[2] + e24[1] * e24[3], n2);
    return { angle: Ie(t2), scaleX: r2, scaleY: i2, skewX: Ie(a2), skewY: 0, translateX: e24[4] || 0, translateY: e24[5] || 0 };
  };
  var Ue = (e24, t2 = 0) => [1, 0, 0, 1, e24, t2];
  function We({ angle: e24 = 0 } = {}, { x: t2 = 0, y: n2 = 0 } = {}) {
    let r2 = I(e24), i2 = Se(r2), a2 = Ce(r2);
    return [i2, a2, -a2, i2, t2 ? t2 - (i2 * t2 - a2 * n2) : 0, n2 ? n2 - (a2 * t2 + i2 * n2) : 0];
  }
  var Ge = (e24, t2 = e24) => [e24, 0, 0, t2, 0, 0];
  var Ke = (e24) => Math.tan(I(e24));
  var qe = (e24) => [1, 0, Ke(e24), 1, 0, 0];
  var Je = (e24) => [1, Ke(e24), 0, 1, 0, 0];
  var Ye = ({ scaleX: e24 = 1, scaleY: t2 = 1, flipX: n2 = false, flipY: r2 = false, skewX: i2 = 0, skewY: a2 = 0 }) => {
    let o2 = Ge(n2 ? -e24 : e24, r2 ? -t2 : t2);
    return i2 && (o2 = z(o2, qe(i2), true)), a2 && (o2 = z(o2, Je(a2), true)), o2;
  };
  var Xe = (e24) => {
    let { translateX: t2 = 0, translateY: n2 = 0, angle: r2 = 0 } = e24, i2 = Ue(t2, n2);
    r2 && (i2 = z(i2, We({ angle: r2 })));
    let a2 = Ye(e24);
    return Le(a2) || (i2 = z(i2, a2)), i2;
  };
  var Ze = (e24, { signal: t2, crossOrigin: n2 = null } = {}) => new Promise(function(r2, i2) {
    if (t2 && t2.aborted) return i2(new l(`loadImage`));
    let a2 = Me(), o2;
    t2 && (o2 = function(e25) {
      a2.src = ``, i2(e25);
    }, t2.addEventListener(`abort`, o2, { once: true }));
    let s3 = function() {
      a2.onload = a2.onerror = null, o2 && (t2 == null || t2.removeEventListener(`abort`, o2)), r2(a2);
    };
    e24 ? (a2.onload = s3, a2.onerror = function() {
      o2 && (t2 == null || t2.removeEventListener(`abort`, o2)), i2(new c(`Error loading ${a2.src}`));
    }, n2 && (a2.crossOrigin = n2), a2.src = e24) : s3();
  });
  var Qe = (e24, { signal: t2, reviver: n2 = x } = {}) => new Promise((r2, i2) => {
    let a2 = [];
    t2 && t2.addEventListener(`abort`, i2, { once: true }), Promise.allSettled(e24.map((e25) => M.getClass(e25.type).fromObject(e25, { signal: t2 }))).then(async (t3) => {
      for (let [r3, i3] of t3.entries()) if (i3.status === `fulfilled` && (await n2(e24[r3], i3.value), a2.push(i3.value)), i3.status === `rejected`) {
        let t4 = await n2(e24[r3], void 0, i3.reason);
        t4 && a2.push(t4);
      }
      r2(a2);
    }).catch((e25) => {
      a2.forEach((e26) => {
        e26.dispose && e26.dispose();
      }), i2(e25);
    }).finally(() => {
      t2 && t2.removeEventListener(`abort`, i2);
    });
  });
  var $e = (e24, { signal: t2 } = {}) => new Promise((n2, r2) => {
    let i2 = [];
    t2 && t2.addEventListener(`abort`, r2, { once: true });
    let a2 = Object.values(e24).map((e25) => e25 && e25.type && M.has(e25.type) ? Qe([e25], { signal: t2 }).then(([e26]) => (i2.push(e26), e26)) : e25), o2 = Object.keys(e24);
    Promise.all(a2).then((e25) => e25.reduce((e26, t3, n3) => (e26[o2[n3]] = t3, e26), {})).then(n2).catch((e25) => {
      i2.forEach((e26) => {
        e26.dispose && e26.dispose();
      }), r2(e25);
    }).finally(() => {
      t2 && t2.removeEventListener(`abort`, r2);
    });
  });
  var et = (e24, t2 = []) => t2.reduce((t3, n2) => (n2 in e24 && (t3[n2] = e24[n2]), t3), {});
  var tt = (e24, t2) => Object.keys(e24).reduce((n2, r2) => (t2(e24[r2], r2, e24) && (n2[r2] = e24[r2]), n2), {});
  var B = (e24, t2) => parseFloat(Number(e24).toFixed(t2));
  var nt = (e24) => `matrix(` + e24.map((e25) => B(e25, o.NUM_FRACTION_DIGITS)).join(` `) + `)`;
  var V = (e24) => !!e24 && e24.toLive !== void 0;
  var rt = (e24) => !!e24 && typeof e24.toObject == `function`;
  var it = (e24) => !!e24 && e24.offsetX !== void 0 && `source` in e24;
  var at = (e24) => !!e24 && `multiSelectionStacking` in e24;
  function ot(e24) {
    let t2 = e24 && H(e24), n2 = 0, r2 = 0;
    if (!e24 || !t2) return { left: n2, top: r2 };
    let i2 = e24, a2 = t2.documentElement, o2 = t2.body || { scrollLeft: 0, scrollTop: 0 };
    for (; i2 && (i2.parentNode || i2.host) && (i2 = i2.parentNode || i2.host, i2 === t2 ? (n2 = o2.scrollLeft || a2.scrollLeft || 0, r2 = o2.scrollTop || a2.scrollTop || 0) : (n2 += i2.scrollLeft || 0, r2 += i2.scrollTop || 0), i2.nodeType !== 1 || i2.style.position !== `fixed`); ) ;
    return { left: n2, top: r2 };
  }
  var H = (e24) => e24.ownerDocument || null;
  var st = (e24) => {
    var t2;
    return ((t2 = e24.ownerDocument) == null ? void 0 : t2.defaultView) || null;
  };
  var ct = (e24, t2, { width: n2, height: r2 }, i2 = 1) => {
    e24.width = n2, e24.height = r2, i2 > 1 && (e24.setAttribute(`width`, (n2 * i2).toString()), e24.setAttribute(`height`, (r2 * i2).toString()), t2.scale(i2, i2));
  };
  var lt = (e24, { width: t2, height: n2 }) => {
    t2 && (e24.style.width = typeof t2 == `number` ? `${t2}px` : t2), n2 && (e24.style.height = typeof n2 == `number` ? `${n2}px` : n2);
  };
  function ut(e24) {
    return e24.onselectstart !== void 0 && (e24.onselectstart = () => false), e24.style.userSelect = te, e24;
  }
  var dt = class {
    constructor(e24) {
      i(this, `_originalCanvasStyle`, void 0), i(this, `lower`, void 0);
      let t2 = this.createLowerCanvas(e24);
      this.lower = { el: t2, ctx: t2.getContext(`2d`) };
    }
    createLowerCanvas(e24) {
      let t2 = (n2 = e24) && n2.getContext !== void 0 ? e24 : e24 && g().getElementById(e24) || P();
      var n2;
      if (t2.hasAttribute(`data-fabric`)) throw new c(`Trying to initialize a canvas that has already been initialized. Did you forget to dispose the canvas?`);
      return this._originalCanvasStyle = t2.style.cssText, t2.setAttribute(`data-fabric`, `main`), t2.classList.add(`lower-canvas`), t2;
    }
    cleanupDOM({ width: e24, height: t2 }) {
      let { el: n2 } = this.lower;
      n2.classList.remove(`lower-canvas`), n2.removeAttribute(`data-fabric`), n2.setAttribute(`width`, `${e24}`), n2.setAttribute(`height`, `${t2}`), n2.style.cssText = this._originalCanvasStyle || ``, this._originalCanvasStyle = void 0;
    }
    setDimensions(e24, t2) {
      let { el: n2, ctx: r2 } = this.lower;
      ct(n2, r2, e24, t2);
    }
    setCSSDimensions(e24) {
      lt(this.lower.el, e24);
    }
    calcOffset() {
      return function(e24) {
        var t2;
        let n2 = e24 && H(e24), r2 = { left: 0, top: 0 };
        if (!n2) return r2;
        let i2 = ((t2 = st(e24)) == null ? void 0 : t2.getComputedStyle(e24, null)) || {};
        r2.left += parseInt(i2.borderLeftWidth, 10) || 0, r2.top += parseInt(i2.borderTopWidth, 10) || 0, r2.left += parseInt(i2.paddingLeft, 10) || 0, r2.top += parseInt(i2.paddingTop, 10) || 0;
        let a2 = { left: 0, top: 0 }, o2 = n2.documentElement;
        e24.getBoundingClientRect !== void 0 && (a2 = e24.getBoundingClientRect());
        let s3 = ot(e24);
        return { left: a2.left + s3.left - (o2.clientLeft || 0) + r2.left, top: a2.top + s3.top - (o2.clientTop || 0) + r2.top };
      }(this.lower.el);
    }
    dispose() {
      h().dispose(this.lower.el), delete this.lower;
    }
  };
  var ft = { backgroundVpt: true, backgroundColor: ``, overlayVpt: true, overlayColor: ``, includeDefaultValues: true, svgViewportTransformation: true, renderOnAddRemove: true, skipOffscreen: true, enableRetinaScaling: true, imageSmoothingEnabled: true, controlsAboveOverlay: false, allowTouchScrolling: false, viewportTransform: [...T], patternQuality: `best` };
  var pt = t({ capitalize: () => mt, escapeXml: () => U, graphemeSplit: () => gt });
  var mt = (e24, t2 = false) => `${e24.charAt(0).toUpperCase()}${t2 ? e24.slice(1) : e24.slice(1).toLowerCase()}`;
  var U = (e24) => e24.toString().replace(/&/g, `&amp;`).replace(/"/g, `&quot;`).replace(/'/g, `&apos;`).replace(/</g, `&lt;`).replace(/>/g, `&gt;`);
  var ht;
  var gt = (e24) => {
    if (ht || ht || (ht = `Intl` in _() && `Segmenter` in Intl && new Intl.Segmenter(void 0, { granularity: `grapheme` })), ht) {
      let t2 = ht.segment(e24);
      return Array.from(t2).map(({ segment: e25 }) => e25);
    }
    return _t(e24);
  };
  var _t = (e24) => {
    let t2 = [];
    for (let n2, r2 = 0; r2 < e24.length; r2++) false !== (n2 = vt(e24, r2)) && t2.push(n2);
    return t2;
  };
  var vt = (e24, t2) => {
    let n2 = e24.charCodeAt(t2);
    if (isNaN(n2)) return ``;
    if (n2 < 55296 || n2 > 57343) return e24.charAt(t2);
    if (55296 <= n2 && n2 <= 56319) {
      if (e24.length <= t2 + 1) throw `High surrogate without following low surrogate`;
      let n3 = e24.charCodeAt(t2 + 1);
      if (56320 > n3 || n3 > 57343) throw `High surrogate without following low surrogate`;
      return e24.charAt(t2) + e24.charAt(t2 + 1);
    }
    if (t2 === 0) throw `Low surrogate without preceding high surrogate`;
    let r2 = e24.charCodeAt(t2 - 1);
    if (55296 > r2 || r2 > 56319) throw `Low surrogate without preceding high surrogate`;
    return false;
  };
  var yt = class e3 extends Ee(De) {
    get lowerCanvasEl() {
      var e24;
      return (e24 = this.elements.lower) == null ? void 0 : e24.el;
    }
    get contextContainer() {
      var e24;
      return (e24 = this.elements.lower) == null ? void 0 : e24.ctx;
    }
    static getDefaults() {
      return e3.ownDefaults;
    }
    constructor(e24, t2 = {}) {
      super(), Object.assign(this, this.constructor.getDefaults()), this.set(t2), this.initElements(e24), this._setDimensionsImpl({ width: this.width || this.elements.lower.el.width || 0, height: this.height || this.elements.lower.el.height || 0 }), this.skipControlsDrawing = false, this.viewportTransform = [...this.viewportTransform], this.calcViewportBoundaries();
    }
    initElements(e24) {
      this.elements = new dt(e24);
    }
    add(...e24) {
      let t2 = super.add(...e24);
      return e24.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), t2;
    }
    insertAt(e24, ...t2) {
      let n2 = super.insertAt(e24, ...t2);
      return t2.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), n2;
    }
    remove(...e24) {
      let t2 = super.remove(...e24);
      return t2.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), t2;
    }
    _onObjectAdded(e24) {
      e24.canvas && e24.canvas !== this && (s(`warn`, `Canvas is trying to add an object that belongs to a different canvas.
Resulting to default behavior: removing object from previous canvas and adding to new canvas`), e24.canvas.remove(e24)), e24._set(`canvas`, this), e24.setCoords(), this.fire(`object:added`, { target: e24 }), e24.fire(`added`, { target: this });
    }
    _onObjectRemoved(e24) {
      e24._set(`canvas`, void 0), this.fire(`object:removed`, { target: e24 }), e24.fire(`removed`, { target: this });
    }
    _onStackOrderChanged() {
      this.renderOnAddRemove && this.requestRenderAll();
    }
    getRetinaScaling() {
      return this.enableRetinaScaling ? v() : 1;
    }
    calcOffset() {
      return this._offset = this.elements.calcOffset();
    }
    getWidth() {
      return this.width;
    }
    getHeight() {
      return this.height;
    }
    _setDimensionsImpl(e24, { cssOnly: t2 = false, backstoreOnly: n2 = false } = {}) {
      if (!t2) {
        let t3 = { width: this.width, height: this.height, ...e24 };
        this.elements.setDimensions(t3, this.getRetinaScaling()), this.hasLostContext = true, this.width = t3.width, this.height = t3.height;
      }
      n2 || this.elements.setCSSDimensions(e24), this.calcOffset();
    }
    setDimensions(e24, t2) {
      this._setDimensionsImpl(e24, t2), t2 && t2.cssOnly || this.requestRenderAll();
    }
    getZoom() {
      return Be(this.viewportTransform);
    }
    setViewportTransform(e24) {
      this.viewportTransform = e24, this.calcViewportBoundaries(), this.renderOnAddRemove && this.requestRenderAll();
    }
    zoomToPoint(e24, t2) {
      let n2 = e24, r2 = [...this.viewportTransform], i2 = L(e24, R(r2));
      r2[0] = t2, r2[3] = t2;
      let a2 = L(i2, r2);
      r2[4] += n2.x - a2.x, r2[5] += n2.y - a2.y, this.setViewportTransform(r2);
    }
    setZoom(e24) {
      this.zoomToPoint(new N(0, 0), e24);
    }
    absolutePan(e24) {
      let t2 = [...this.viewportTransform];
      return t2[4] = -e24.x, t2[5] = -e24.y, this.setViewportTransform(t2);
    }
    relativePan(e24) {
      return this.absolutePan(new N(-e24.x - this.viewportTransform[4], -e24.y - this.viewportTransform[5]));
    }
    getElement() {
      return this.elements.lower.el;
    }
    clearContext(e24) {
      e24.clearRect(0, 0, this.width, this.height);
    }
    getContext() {
      return this.elements.lower.ctx;
    }
    clear() {
      this.remove(...this.getObjects()), this.backgroundImage = void 0, this.overlayImage = void 0, this.backgroundColor = ``, this.overlayColor = ``, this.clearContext(this.getContext()), this.fire(`canvas:cleared`), this.renderOnAddRemove && this.requestRenderAll();
    }
    renderAll() {
      this.cancelRequestedRender(), this.destroyed || this.renderCanvas(this.getContext(), this._objects);
    }
    renderAndReset() {
      this.nextRenderHandle = 0, this.renderAll();
    }
    requestRenderAll() {
      this.nextRenderHandle || this.disposed || this.destroyed || (this.nextRenderHandle = Oe(() => this.renderAndReset()));
    }
    calcViewportBoundaries() {
      let e24 = this.width, t2 = this.height, n2 = R(this.viewportTransform), r2 = L({ x: 0, y: 0 }, n2), i2 = L({ x: e24, y: t2 }, n2), a2 = r2.min(i2), o2 = r2.max(i2);
      return this.vptCoords = { tl: a2, tr: new N(o2.x, a2.y), bl: new N(a2.x, o2.y), br: o2 };
    }
    cancelRequestedRender() {
      this.nextRenderHandle && (ke(this.nextRenderHandle), this.nextRenderHandle = 0);
    }
    drawControls(e24) {
    }
    renderCanvas(e24, t2) {
      if (this.destroyed) return;
      let n2 = this.viewportTransform, r2 = this.clipPath;
      this.calcViewportBoundaries(), this.clearContext(e24), e24.imageSmoothingEnabled = this.imageSmoothingEnabled, e24.patternQuality = this.patternQuality, this.fire(`before:render`, { ctx: e24 }), this._renderBackground(e24), e24.save(), e24.transform(n2[0], n2[1], n2[2], n2[3], n2[4], n2[5]), this._renderObjects(e24, t2), e24.restore(), this.controlsAboveOverlay || this.skipControlsDrawing || this.drawControls(e24), r2 && (r2._set(`canvas`, this), r2.shouldCache(), r2._transformDone = true, r2.renderCache({ forClipping: true }), this.drawClipPathOnCanvas(e24, r2)), this._renderOverlay(e24), this.controlsAboveOverlay && !this.skipControlsDrawing && this.drawControls(e24), this.fire(`after:render`, { ctx: e24 }), this.__cleanupTask && (this.__cleanupTask(), this.__cleanupTask = void 0);
    }
    drawClipPathOnCanvas(e24, t2) {
      let n2 = this.viewportTransform;
      e24.save(), e24.transform(...n2), e24.globalCompositeOperation = `destination-in`, t2.transform(e24), e24.scale(1 / t2.zoomX, 1 / t2.zoomY), e24.drawImage(t2._cacheCanvas, -t2.cacheTranslationX, -t2.cacheTranslationY), e24.restore();
    }
    _renderObjects(e24, t2) {
      for (let n2 = 0, r2 = t2.length; n2 < r2; ++n2) t2[n2] && t2[n2].render(e24);
    }
    _renderBackgroundOrOverlay(e24, t2) {
      let n2 = this[`${t2}Color`], r2 = this[`${t2}Image`], i2 = this.viewportTransform, a2 = this[`${t2}Vpt`];
      if (!n2 && !r2) return;
      let o2 = V(n2);
      if (n2) {
        if (e24.save(), e24.beginPath(), e24.moveTo(0, 0), e24.lineTo(this.width, 0), e24.lineTo(this.width, this.height), e24.lineTo(0, this.height), e24.closePath(), e24.fillStyle = o2 ? n2.toLive(e24) : n2, a2 && e24.transform(...i2), o2) {
          e24.transform(1, 0, 0, 1, n2.offsetX || 0, n2.offsetY || 0);
          let t3 = n2.gradientTransform || n2.patternTransform;
          t3 && e24.transform(...t3);
        }
        e24.fill(), e24.restore();
      }
      if (r2) {
        e24.save();
        let { skipOffscreen: t3 } = this;
        this.skipOffscreen = a2, a2 && e24.transform(...i2), r2.render(e24), this.skipOffscreen = t3, e24.restore();
      }
    }
    _renderBackground(e24) {
      this._renderBackgroundOrOverlay(e24, `background`);
    }
    _renderOverlay(e24) {
      this._renderBackgroundOrOverlay(e24, `overlay`);
    }
    getCenterPoint() {
      return new N(this.width / 2, this.height / 2);
    }
    centerObjectH(e24) {
      return this._centerObject(e24, new N(this.getCenterPoint().x, e24.getCenterPoint().y));
    }
    centerObjectV(e24) {
      return this._centerObject(e24, new N(e24.getCenterPoint().x, this.getCenterPoint().y));
    }
    centerObject(e24) {
      return this._centerObject(e24, this.getCenterPoint());
    }
    viewportCenterObject(e24) {
      return this._centerObject(e24, this.getVpCenter());
    }
    viewportCenterObjectH(e24) {
      return this._centerObject(e24, new N(this.getVpCenter().x, e24.getCenterPoint().y));
    }
    viewportCenterObjectV(e24) {
      return this._centerObject(e24, new N(e24.getCenterPoint().x, this.getVpCenter().y));
    }
    getVpCenter() {
      return L(this.getCenterPoint(), R(this.viewportTransform));
    }
    _centerObject(e24, t2) {
      e24.setXY(t2, E, E), e24.setCoords(), this.renderOnAddRemove && this.requestRenderAll();
    }
    toDatalessJSON(e24) {
      return this.toDatalessObject(e24);
    }
    toObject(e24) {
      return this._toObjectMethod(`toObject`, e24);
    }
    toJSON() {
      return this.toObject();
    }
    toDatalessObject(e24) {
      return this._toObjectMethod(`toDatalessObject`, e24);
    }
    _toObjectMethod(e24, t2) {
      let n2 = this.clipPath, r2 = n2 && !n2.excludeFromExport ? this._toObject(n2, e24, t2) : null;
      return { version: b, ...et(this, t2), objects: this._objects.filter((e25) => !e25.excludeFromExport).map((n3) => this._toObject(n3, e24, t2)), ...this.__serializeBgOverlay(e24, t2), ...r2 ? { clipPath: r2 } : null };
    }
    _toObject(e24, t2, n2) {
      let r2;
      this.includeDefaultValues || (r2 = e24.includeDefaultValues, e24.includeDefaultValues = false);
      let i2 = e24[t2](n2);
      return this.includeDefaultValues || (e24.includeDefaultValues = !!r2), i2;
    }
    __serializeBgOverlay(e24, t2) {
      let n2 = {}, r2 = this.backgroundImage, i2 = this.overlayImage, a2 = this.backgroundColor, o2 = this.overlayColor;
      return V(a2) ? a2.excludeFromExport || (n2.background = a2.toObject(t2)) : a2 && (n2.background = a2), V(o2) ? o2.excludeFromExport || (n2.overlay = o2.toObject(t2)) : o2 && (n2.overlay = o2), r2 && !r2.excludeFromExport && (n2.backgroundImage = this._toObject(r2, e24, t2)), i2 && !i2.excludeFromExport && (n2.overlayImage = this._toObject(i2, e24, t2)), n2;
    }
    toSVG(e24 = {}, t2) {
      e24.reviver = t2;
      let n2 = [];
      var r2;
      return (this._setSVGPreamble(n2, e24), this._setSVGHeader(n2, e24), this.clipPath) && n2.push(`<g clip-path="url(#${U((r2 = this.clipPath.clipPathId) == null ? `` : r2)})" >
`), this._setSVGBgOverlayColor(n2, `background`), this._setSVGBgOverlayImage(n2, `backgroundImage`, t2), this._setSVGObjects(n2, t2), this.clipPath && n2.push(`</g>
`), this._setSVGBgOverlayColor(n2, `overlay`), this._setSVGBgOverlayImage(n2, `overlayImage`, t2), n2.push(`</svg>`), n2.join(``);
    }
    _setSVGPreamble(e24, t2) {
      t2.suppressPreamble || e24.push(`<?xml version="1.0" encoding="`, t2.encoding || `UTF-8`, `" standalone="no" ?>
`, `<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" `, `"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
`);
    }
    _setSVGHeader(e24, t2) {
      let n2 = t2.width || `${this.width}`, r2 = t2.height || `${this.height}`, i2 = o.NUM_FRACTION_DIGITS, a2 = t2.viewBox, s3;
      if (a2) s3 = `viewBox="${a2.x} ${a2.y} ${a2.width} ${a2.height}" `;
      else if (this.svgViewportTransformation) {
        let e25 = this.viewportTransform;
        s3 = `viewBox="${B(-e25[4] / e25[0], i2)} ${B(-e25[5] / e25[3], i2)} ${B(this.width / e25[0], i2)} ${B(this.height / e25[3], i2)}" `;
      } else s3 = `viewBox="0 0 ${this.width} ${this.height}" `;
      e24.push(`<svg `, `xmlns="http://www.w3.org/2000/svg" `, `xmlns:xlink="http://www.w3.org/1999/xlink" `, `version="1.1" `, `width="`, n2, `" `, `height="`, r2, `" `, s3, `xml:space="preserve">
`, `<desc>Created with Fabric.js `, b, `</desc>
`, `<defs>
`, this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(t2), `</defs>
`);
    }
    createSVGClipPathMarkup(e24) {
      let t2 = this.clipPath;
      return t2 ? (t2.clipPathId = `CLIPPATH_${je()}`, `<clipPath id="${t2.clipPathId}" >
${t2.toClipPathSVG(e24.reviver)}</clipPath>
`) : ``;
    }
    createSVGRefElementsMarkup() {
      return [`background`, `overlay`].map((e24) => {
        let t2 = this[`${e24}Color`];
        if (V(t2)) {
          let n2 = this[`${e24}Vpt`], r2 = this.viewportTransform, i2 = { isType: () => false, width: this.width / (n2 ? r2[0] : 1), height: this.height / (n2 ? r2[3] : 1) };
          return t2.toSVG(i2, { additionalTransform: n2 ? nt(r2) : `` });
        }
      }).join(``);
    }
    createSVGFontFacesMarkup() {
      let e24 = [], t2 = {}, n2 = o.fontPaths;
      this._objects.forEach(function t3(n3) {
        e24.push(n3), Te(n3) && n3._objects.forEach(t3);
      }), e24.forEach((e25) => {
        if (!(r3 = e25) || typeof r3._renderText != `function`) return;
        var r3;
        let { styles: i2, fontFamily: a2 } = e25;
        !t2[a2] && n2[a2] && (t2[a2] = true, i2 && Object.values(i2).forEach((e26) => {
          Object.values(e26).forEach(({ fontFamily: e27 = `` }) => {
            !t2[e27] && n2[e27] && (t2[e27] = true);
          });
        }));
      });
      let r2 = Object.keys(t2).map((e25) => `		@font-face {
			font-family: '${e25}';
			src: url('${n2[e25]}');
		}
`).join(``);
      return r2 ? `	<style type="text/css"><![CDATA[
${r2}]]></style>
` : ``;
    }
    _setSVGObjects(e24, t2) {
      this.forEachObject((n2) => {
        n2.excludeFromExport || this._setSVGObject(e24, n2, t2);
      });
    }
    _setSVGObject(e24, t2, n2) {
      e24.push(t2.toSVG(n2));
    }
    _setSVGBgOverlayImage(e24, t2, n2) {
      let r2 = this[t2];
      r2 && !r2.excludeFromExport && r2.toSVG && e24.push(r2.toSVG(n2));
    }
    _setSVGBgOverlayColor(e24, t2) {
      let n2 = this[`${t2}Color`];
      if (n2) if (V(n2)) {
        let r2 = n2.repeat || ``, i2 = this.width, a2 = this.height, o2 = this[`${t2}Vpt`] ? nt(R(this.viewportTransform)) : ``;
        e24.push(`<rect transform="${o2} translate(${i2 / 2},${a2 / 2})" x="${n2.offsetX - i2 / 2}" y="${n2.offsetY - a2 / 2}" width="${r2 !== `repeat-y` && r2 !== `no-repeat` || !it(n2) ? i2 : n2.source.width}" height="${r2 !== `repeat-x` && r2 !== `no-repeat` || !it(n2) ? a2 : n2.source.height}" fill="url(#SVGID_${n2.id})"></rect>
`);
      } else e24.push(`<rect x="0" y="0" width="100%" height="100%" `, `fill="`, n2, `"`, `></rect>
`);
    }
    loadFromJSON(e24, t2, { signal: n2 } = {}) {
      if (!e24) return Promise.reject(new c("`json` is undefined"));
      let { objects: r2 = [], ...i2 } = typeof e24 == `string` ? JSON.parse(e24) : e24, { backgroundImage: a2, background: o2, overlayImage: s3, overlay: l2, clipPath: u2 } = i2, d2 = this.renderOnAddRemove;
      return this.renderOnAddRemove = false, Promise.all([Qe(r2, { reviver: t2, signal: n2 }), $e({ backgroundImage: a2, backgroundColor: o2, overlayImage: s3, overlayColor: l2, clipPath: u2 }, { signal: n2 })]).then(([e25, t3]) => (this.clear(), this.add(...e25), this.set(i2), this.set(t3), this.renderOnAddRemove = d2, this));
    }
    clone(e24) {
      let t2 = this.toObject(e24);
      return this.cloneWithoutData().loadFromJSON(t2);
    }
    cloneWithoutData() {
      let e24 = F(this);
      return new this.constructor(e24);
    }
    toDataURL(e24 = {}) {
      let { format: t2 = `png`, quality: n2 = 1, multiplier: r2 = 1, enableRetinaScaling: i2 = false } = e24, a2 = r2 * (i2 ? this.getRetinaScaling() : 1);
      return Pe(this.toCanvasElement(a2, e24), t2, n2);
    }
    toBlob(e24 = {}) {
      let { format: t2 = `png`, quality: n2 = 1, multiplier: r2 = 1, enableRetinaScaling: i2 = false } = e24, a2 = r2 * (i2 ? this.getRetinaScaling() : 1);
      return Fe(this.toCanvasElement(a2, e24), t2, n2);
    }
    toCanvasElement(e24 = 1, { width: t2, height: n2, left: r2, top: i2, filter: a2 } = {}) {
      let o2 = (t2 || this.width) * e24, s3 = (n2 || this.height) * e24, c2 = this.getZoom(), l2 = this.width, u2 = this.height, d2 = this.skipControlsDrawing, f2 = c2 * e24, p2 = this.viewportTransform, m = [f2, 0, 0, f2, (p2[4] - (r2 || 0)) * e24, (p2[5] - (i2 || 0)) * e24], h2 = this.enableRetinaScaling, g2 = F({ width: o2, height: s3 }), _2 = a2 ? this._objects.filter((e25) => a2(e25)) : this._objects;
      return this.enableRetinaScaling = false, this.viewportTransform = m, this.width = o2, this.height = s3, this.skipControlsDrawing = true, this.calcViewportBoundaries(), this.renderCanvas(g2.getContext(`2d`), _2), this.viewportTransform = p2, this.width = l2, this.height = u2, this.calcViewportBoundaries(), this.enableRetinaScaling = h2, this.skipControlsDrawing = d2, g2;
    }
    dispose() {
      return !this.disposed && this.elements.cleanupDOM({ width: this.width, height: this.height }), ye.cancelByCanvas(this), this.disposed = true, new Promise((e24, t2) => {
        let n2 = () => {
          this.destroy(), e24(true);
        };
        n2.kill = t2, this.__cleanupTask && this.__cleanupTask.kill(`aborted`), this.destroyed ? e24(false) : this.nextRenderHandle ? this.__cleanupTask = n2 : n2();
      });
    }
    destroy() {
      this.destroyed = true, this.cancelRequestedRender(), this.forEachObject((e24) => e24.dispose()), this._objects = [], this.backgroundImage && this.backgroundImage.dispose(), this.backgroundImage = void 0, this.overlayImage && this.overlayImage.dispose(), this.overlayImage = void 0, this.elements.dispose();
    }
    toString() {
      return `#<Canvas (${this.complexity()}): { objects: ${this._objects.length} }>`;
    }
  };
  i(yt, `ownDefaults`, ft);
  var bt = [`touchstart`, `touchmove`, `touchend`];
  var xt = (e24) => {
    let t2 = ot(e24.target), n2 = function(e25) {
      let t3 = e25.changedTouches;
      return t3 && t3[0] ? t3[0] : e25;
    }(e24);
    return new N(n2.clientX + t2.left, n2.clientY + t2.top);
  };
  var St = (e24) => bt.includes(e24.type) || e24.pointerType === `touch`;
  var Ct = (e24) => {
    e24.preventDefault(), e24.stopPropagation();
  };
  var wt = (e24) => {
    let t2 = 0, n2 = 0, r2 = 0, i2 = 0;
    for (let a2 = 0, o2 = e24.length; a2 < o2; a2++) {
      let { x: o3, y: s3 } = e24[a2];
      (o3 > r2 || !a2) && (r2 = o3), (o3 < t2 || !a2) && (t2 = o3), (s3 > i2 || !a2) && (i2 = s3), (s3 < n2 || !a2) && (n2 = s3);
    }
    return { left: t2, top: n2, width: r2 - t2, height: i2 - n2 };
  };
  var Tt = (e24, t2) => {
    Dt(e24, z(R(t2), e24.calcOwnMatrix()));
  };
  var Et = (e24, t2) => Dt(e24, z(t2, e24.calcOwnMatrix()));
  var Dt = (e24, t2) => {
    let { translateX: n2, translateY: r2, scaleX: i2, scaleY: a2, ...o2 } = He(t2), s3 = new N(n2, r2);
    e24.flipX = false, e24.flipY = false, Object.assign(e24, o2), e24.set({ scaleX: i2, scaleY: a2 }), e24.setPositionByOrigin(s3, E, E);
  };
  var Ot = (e24) => {
    e24.scaleX = 1, e24.scaleY = 1, e24.skewX = 0, e24.skewY = 0, e24.flipX = false, e24.flipY = false, e24.rotate(0);
  };
  var kt = (e24) => ({ scaleX: e24.scaleX, scaleY: e24.scaleY, skewX: e24.skewX, skewY: e24.skewY, angle: e24.angle, left: e24.left, flipX: e24.flipX, flipY: e24.flipY, top: e24.top });
  var At = (e24, t2, n2) => {
    let r2 = e24 / 2, i2 = t2 / 2, a2 = wt([new N(-r2, -i2), new N(r2, -i2), new N(-r2, i2), new N(r2, i2)].map((e25) => e25.transform(n2)));
    return new N(a2.width, a2.height);
  };
  var jt = (e24 = T, t2 = T) => z(R(t2), e24);
  var Mt = (e24, t2 = T, n2 = T) => e24.transform(jt(t2, n2));
  var Nt = (e24, t2 = T, n2 = T) => e24.transform(jt(t2, n2), true);
  var Pt = (e24, t2, n2) => {
    let r2 = jt(t2, n2);
    return Dt(e24, z(r2, e24.calcOwnMatrix())), r2;
  };
  var Ft = { left: -0.5, top: -0.5, center: 0, bottom: 0.5, right: 0.5 };
  var W = (e24) => typeof e24 == `string` ? Ft[e24] : e24 - 0.5;
  var It = new N(1, 0);
  var Lt = new N();
  var Rt = (e24, t2) => e24.rotate(t2);
  var zt = (e24, t2) => new N(t2).subtract(e24);
  var Bt = (e24) => e24.distanceFrom(Lt);
  var Vt = (e24, t2) => Math.atan2(Gt(e24, t2), Kt(e24, t2));
  var Ht = (e24) => Vt(It, e24);
  var Ut = (e24) => e24.eq(Lt) ? e24 : e24.scalarDivide(Bt(e24));
  var Wt = (e24, t2 = true) => Ut(new N(-e24.y, e24.x).scalarMultiply(t2 ? 1 : -1));
  var Gt = (e24, t2) => e24.x * t2.y - e24.y * t2.x;
  var Kt = (e24, t2) => e24.x * t2.x + e24.y * t2.y;
  var qt = (e24, t2, n2) => {
    if (e24.eq(t2) || e24.eq(n2)) return true;
    let r2 = Gt(t2, n2), i2 = Gt(t2, e24), a2 = Gt(n2, e24);
    return r2 >= 0 ? i2 >= 0 && a2 <= 0 : !(i2 <= 0 && a2 >= 0);
  };
  var Jt = `not-allowed`;
  function Yt(e24) {
    return W(e24.originX) === W(`center`) && W(e24.originY) === W(`center`);
  }
  function Xt(e24) {
    return 0.5 - W(e24);
  }
  var Zt = (e24, t2) => e24[t2];
  var Qt = (e24, t2, n2, r2) => ({ e: e24, transform: t2, pointer: new N(n2, r2) });
  function $t(e24, t2, n2) {
    let r2 = n2, i2 = Ht(zt(Mt(e24.getCenterPoint(), e24.canvas.viewportTransform, void 0), r2)) + w;
    return Math.round(i2 % w / C);
  }
  function en({ target: e24, corner: t2 }, n2, r2, i2, a2) {
    var o2;
    let s3 = e24.controls[t2], c2 = ((o2 = e24.canvas) == null ? void 0 : o2.getZoom()) || 1, l2 = e24.padding / c2, u2 = function(e25, t3, n3, r3) {
      let i3 = e25.getRelativeCenterPoint(), a3 = n3 !== void 0 && r3 !== void 0 ? e25.translateToGivenOrigin(i3, E, E, n3, r3) : new N(e25.left, e25.top);
      return (e25.angle ? t3.rotate(-I(e25.angle), i3) : t3).subtract(a3);
    }(e24, new N(i2, a2), n2, r2);
    return u2.x >= l2 && (u2.x -= l2), u2.x <= -l2 && (u2.x += l2), u2.y >= l2 && (u2.y -= l2), u2.y <= l2 && (u2.y += l2), u2.x -= s3.offsetX, u2.y -= s3.offsetY, u2;
  }
  var tn = new RegExp(String.raw`[\0-\x1F\x7F;<>\\]|\/\*|\*\/|url\s*\(|expression\s*\(|(?:java|vb)script\s*:|data\s*:|@import\b`, `iu`);
  var nn = (e24) => typeof e24 == `string` && e24.trim().length > 0 && !tn.test(e24);
  var rn = (e24, t2 = ``) => {
    let n2 = Number(e24);
    return Number.isFinite(n2) ? `${n2}` : t2;
  };
  var an = (e24, t2 = ``) => typeof e24 == `string` && nn(e24) ? e24 : t2;
  var on = (e24) => e24.replace(/\s+/g, ` `);
  var sn = { aliceblue: `#F0F8FF`, antiquewhite: `#FAEBD7`, aqua: `#0FF`, aquamarine: `#7FFFD4`, azure: `#F0FFFF`, beige: `#F5F5DC`, bisque: `#FFE4C4`, black: `#000`, blanchedalmond: `#FFEBCD`, blue: `#00F`, blueviolet: `#8A2BE2`, brown: `#A52A2A`, burlywood: `#DEB887`, cadetblue: `#5F9EA0`, chartreuse: `#7FFF00`, chocolate: `#D2691E`, coral: `#FF7F50`, cornflowerblue: `#6495ED`, cornsilk: `#FFF8DC`, crimson: `#DC143C`, cyan: `#0FF`, darkblue: `#00008B`, darkcyan: `#008B8B`, darkgoldenrod: `#B8860B`, darkgray: `#A9A9A9`, darkgrey: `#A9A9A9`, darkgreen: `#006400`, darkkhaki: `#BDB76B`, darkmagenta: `#8B008B`, darkolivegreen: `#556B2F`, darkorange: `#FF8C00`, darkorchid: `#9932CC`, darkred: `#8B0000`, darksalmon: `#E9967A`, darkseagreen: `#8FBC8F`, darkslateblue: `#483D8B`, darkslategray: `#2F4F4F`, darkslategrey: `#2F4F4F`, darkturquoise: `#00CED1`, darkviolet: `#9400D3`, deeppink: `#FF1493`, deepskyblue: `#00BFFF`, dimgray: `#696969`, dimgrey: `#696969`, dodgerblue: `#1E90FF`, firebrick: `#B22222`, floralwhite: `#FFFAF0`, forestgreen: `#228B22`, fuchsia: `#F0F`, gainsboro: `#DCDCDC`, ghostwhite: `#F8F8FF`, gold: `#FFD700`, goldenrod: `#DAA520`, gray: `#808080`, grey: `#808080`, green: `#008000`, greenyellow: `#ADFF2F`, honeydew: `#F0FFF0`, hotpink: `#FF69B4`, indianred: `#CD5C5C`, indigo: `#4B0082`, ivory: `#FFFFF0`, khaki: `#F0E68C`, lavender: `#E6E6FA`, lavenderblush: `#FFF0F5`, lawngreen: `#7CFC00`, lemonchiffon: `#FFFACD`, lightblue: `#ADD8E6`, lightcoral: `#F08080`, lightcyan: `#E0FFFF`, lightgoldenrodyellow: `#FAFAD2`, lightgray: `#D3D3D3`, lightgrey: `#D3D3D3`, lightgreen: `#90EE90`, lightpink: `#FFB6C1`, lightsalmon: `#FFA07A`, lightseagreen: `#20B2AA`, lightskyblue: `#87CEFA`, lightslategray: `#789`, lightslategrey: `#789`, lightsteelblue: `#B0C4DE`, lightyellow: `#FFFFE0`, lime: `#0F0`, limegreen: `#32CD32`, linen: `#FAF0E6`, magenta: `#F0F`, maroon: `#800000`, mediumaquamarine: `#66CDAA`, mediumblue: `#0000CD`, mediumorchid: `#BA55D3`, mediumpurple: `#9370DB`, mediumseagreen: `#3CB371`, mediumslateblue: `#7B68EE`, mediumspringgreen: `#00FA9A`, mediumturquoise: `#48D1CC`, mediumvioletred: `#C71585`, midnightblue: `#191970`, mintcream: `#F5FFFA`, mistyrose: `#FFE4E1`, moccasin: `#FFE4B5`, navajowhite: `#FFDEAD`, navy: `#000080`, oldlace: `#FDF5E6`, olive: `#808000`, olivedrab: `#6B8E23`, orange: `#FFA500`, orangered: `#FF4500`, orchid: `#DA70D6`, palegoldenrod: `#EEE8AA`, palegreen: `#98FB98`, paleturquoise: `#AFEEEE`, palevioletred: `#DB7093`, papayawhip: `#FFEFD5`, peachpuff: `#FFDAB9`, peru: `#CD853F`, pink: `#FFC0CB`, plum: `#DDA0DD`, powderblue: `#B0E0E6`, purple: `#800080`, rebeccapurple: `#639`, red: `#F00`, rosybrown: `#BC8F8F`, royalblue: `#4169E1`, saddlebrown: `#8B4513`, salmon: `#FA8072`, sandybrown: `#F4A460`, seagreen: `#2E8B57`, seashell: `#FFF5EE`, sienna: `#A0522D`, silver: `#C0C0C0`, skyblue: `#87CEEB`, slateblue: `#6A5ACD`, slategray: `#708090`, slategrey: `#708090`, snow: `#FFFAFA`, springgreen: `#00FF7F`, steelblue: `#4682B4`, tan: `#D2B48C`, teal: `#008080`, thistle: `#D8BFD8`, tomato: `#FF6347`, turquoise: `#40E0D0`, violet: `#EE82EE`, wheat: `#F5DEB3`, white: `#FFF`, whitesmoke: `#F5F5F5`, yellow: `#FF0`, yellowgreen: `#9ACD32` };
  var cn = (e24, t2, n2) => (n2 < 0 && (n2 += 1), n2 > 1 && --n2, n2 < 1 / 6 ? e24 + 6 * (t2 - e24) * n2 : n2 < 0.5 ? t2 : n2 < 2 / 3 ? e24 + (t2 - e24) * (2 / 3 - n2) * 6 : e24);
  var ln = (e24, t2, n2, r2) => {
    e24 /= 255, t2 /= 255, n2 /= 255;
    let i2 = Math.max(e24, t2, n2), a2 = Math.min(e24, t2, n2), o2, s3, c2 = (i2 + a2) / 2;
    if (i2 === a2) o2 = s3 = 0;
    else {
      let r3 = i2 - a2;
      switch (s3 = c2 > 0.5 ? r3 / (2 - i2 - a2) : r3 / (i2 + a2), i2) {
        case e24:
          o2 = (t2 - n2) / r3 + (t2 < n2 ? 6 : 0);
          break;
        case t2:
          o2 = (n2 - e24) / r3 + 2;
          break;
        case n2:
          o2 = (e24 - t2) / r3 + 4;
      }
      o2 /= 6;
    }
    return [Math.round(360 * o2), Math.round(100 * s3), Math.round(100 * c2), r2];
  };
  var un = (e24 = `1`) => parseFloat(e24) / (e24.endsWith(`%`) ? 100 : 1);
  var dn = (e24) => Math.min(Math.round(e24), 255).toString(16).toUpperCase().padStart(2, `0`);
  var fn = ([e24, t2, n2, r2 = 1]) => {
    let i2 = Math.round(0.3 * e24 + 0.59 * t2 + 0.11 * n2);
    return [i2, i2, i2, r2];
  };
  var G = class e4 {
    constructor(t2) {
      if (i(this, `isUnrecognised`, false), t2) if (t2 instanceof e4) this.setSource([...t2._source]);
      else if (Array.isArray(t2)) {
        let [e24, n2, r2, i2 = 1] = t2;
        this.setSource([e24, n2, r2, i2]);
      } else this.setSource(this._tryParsingColor(t2));
      else this.setSource([0, 0, 0, 1]);
    }
    _tryParsingColor(t2) {
      return (t2 = t2.toLowerCase()) in sn && (t2 = sn[t2]), t2 === `transparent` ? [255, 255, 255, 0] : e4.sourceFromHex(t2) || e4.sourceFromRgb(t2) || e4.sourceFromHsl(t2) || (this.isUnrecognised = true) && [0, 0, 0, 1];
    }
    getSource() {
      return this._source;
    }
    setSource(e24) {
      this._source = e24;
    }
    toRgb() {
      let [e24, t2, n2] = this.getSource();
      return `rgb(${e24},${t2},${n2})`;
    }
    toRgba() {
      return `rgba(${this.getSource().join(`,`)})`;
    }
    toHsl() {
      let [e24, t2, n2] = ln(...this.getSource());
      return `hsl(${e24},${t2}%,${n2}%)`;
    }
    toHsla() {
      let [e24, t2, n2, r2] = ln(...this.getSource());
      return `hsla(${e24},${t2}%,${n2}%,${r2})`;
    }
    toHex() {
      return this.toHexa().slice(0, 6);
    }
    toHexa() {
      let [e24, t2, n2, r2] = this.getSource();
      return `${dn(e24)}${dn(t2)}${dn(n2)}${dn(Math.round(255 * r2))}`;
    }
    getAlpha() {
      return this.getSource()[3];
    }
    setAlpha(e24) {
      return this._source[3] = e24, this;
    }
    toGrayscale() {
      return this.setSource(fn(this.getSource())), this;
    }
    toBlackWhite(e24) {
      let [t2, , , n2] = fn(this.getSource()), r2 = t2 < (e24 || 127) ? 0 : 255;
      return this.setSource([r2, r2, r2, n2]), this;
    }
    overlayWith(t2) {
      t2 instanceof e4 || (t2 = new e4(t2));
      let n2 = this.getSource(), r2 = t2.getSource(), [i2, a2, o2] = n2.map((e24, t3) => Math.round(0.5 * e24 + 0.5 * r2[t3]));
      return this.setSource([i2, a2, o2, n2[3]]), this;
    }
    static fromRgb(t2) {
      return e4.fromRgba(t2);
    }
    static fromRgba(t2) {
      return new e4(e4.sourceFromRgb(t2));
    }
    static sourceFromRgb(e24) {
      let t2 = on(e24).match(/^rgba?\(\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?(?:\s?[,/]\s?(\d{0,3}(?:\.\d+)?%?)\s?)?\)$/i);
      if (t2) {
        let [e25, n2, r2] = t2.slice(1, 4).map((e26) => {
          let t3 = parseFloat(e26);
          return e26.endsWith(`%`) ? Math.round(2.55 * t3) : t3;
        });
        return [e25, n2, r2, un(t2[4])];
      }
    }
    static fromHsl(t2) {
      return e4.fromHsla(t2);
    }
    static fromHsla(t2) {
      return new e4(e4.sourceFromHsl(t2));
    }
    static sourceFromHsl(t2) {
      let n2 = on(t2).match(/^hsla?\(\s?([+-]?\d{0,3}(?:\.\d+)?(?:deg|turn|rad)?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?(?:\s?[,/]\s?(\d*(?:\.\d+)?%?)\s?)?\)$/i);
      if (!n2) return;
      let r2 = (e4.parseAngletoDegrees(n2[1]) % 360 + 360) % 360 / 360, i2 = parseFloat(n2[2]) / 100, a2 = parseFloat(n2[3]) / 100, o2, s3, c2;
      if (i2 === 0) o2 = s3 = c2 = a2;
      else {
        let e24 = a2 <= 0.5 ? a2 * (i2 + 1) : a2 + i2 - a2 * i2, t3 = 2 * a2 - e24;
        o2 = cn(t3, e24, r2 + 1 / 3), s3 = cn(t3, e24, r2), c2 = cn(t3, e24, r2 - 1 / 3);
      }
      return [Math.round(255 * o2), Math.round(255 * s3), Math.round(255 * c2), un(n2[4])];
    }
    static fromHex(t2) {
      return new e4(e4.sourceFromHex(t2));
    }
    static sourceFromHex(e24) {
      if (e24.match(/^#?(([0-9a-f]){3,4}|([0-9a-f]{2}){3,4})$/i)) {
        let t2 = e24.slice(e24.indexOf(`#`) + 1), n2;
        n2 = t2.length <= 4 ? t2.split(``).map((e25) => e25 + e25) : t2.match(/.{2}/g);
        let [r2, i2, a2, o2 = 255] = n2.map((e25) => parseInt(e25, 16));
        return [r2, i2, a2, o2 / 255];
      }
    }
    static parseAngletoDegrees(e24) {
      let t2 = e24.toLowerCase(), n2 = parseFloat(t2);
      return t2.includes(`rad`) ? Ie(n2) : t2.includes(`turn`) ? 360 * n2 : n2;
    }
  };
  var pn = (e24) => {
    let t2 = [`instantiated_by_use`, `style`, `id`, `class`];
    switch (e24) {
      case `linearGradient`:
        return t2.concat([`x1`, `y1`, `x2`, `y2`, `gradientUnits`, `gradientTransform`]);
      case `radialGradient`:
        return t2.concat([`gradientUnits`, `gradientTransform`, `cx`, `cy`, `r`, `fx`, `fy`, `fr`]);
      case `stop`:
        return t2.concat([`offset`, `stop-color`, `stop-opacity`]);
    }
    return t2;
  };
  var K = (e24, t2 = 16) => {
    let n2 = /\D{0,2}$/.exec(e24), r2 = parseFloat(e24), i2 = o.DPI;
    switch (n2 == null ? void 0 : n2[0]) {
      case `mm`:
        return r2 * i2 / 25.4;
      case `cm`:
        return r2 * i2 / 2.54;
      case `in`:
        return r2 * i2;
      case `pt`:
        return r2 * i2 / 72;
      case `pc`:
        return r2 * i2 / 72 * 12;
      case `em`:
        return r2 * t2;
      default:
        return r2;
    }
  };
  var mn = (e24) => {
    let [t2, n2] = e24.trim().split(` `), [r2, i2] = (a2 = t2) && a2 !== `none` ? [a2.slice(1, 4), a2.slice(5, 8)] : a2 === `none` ? [a2, a2] : [`Mid`, `Mid`];
    var a2;
    return { meetOrSlice: n2 || `meet`, alignX: r2, alignY: i2 };
  };
  var hn = (e24, t2, n2 = true) => {
    let r2, i2;
    if (t2) if (t2.toLive) r2 = `url(#SVGID_${U(t2.id)})`;
    else {
      let e25 = String(t2);
      if (nn(e25)) {
        let t3 = new G(e25), n3 = t3.getAlpha();
        r2 = t3.toRgb(), n3 !== 1 && (i2 = n3.toString());
      } else r2 = new G(`black`).toRgb();
    }
    else r2 = `none`;
    return n2 ? `${e24}: ${r2}; ${i2 ? `${e24}-opacity: ${i2}; ` : ``}` : `${e24}="${r2}" ${i2 ? `${e24}-opacity="${i2}" ` : ``}`;
  };
  var gn = class {
    getSvgStyles(e24) {
      let t2 = this.fillRule == null ? `nonzero` : an(this.fillRule), n2 = this.strokeWidth == null ? `0` : rn(this.strokeWidth), r2 = this.strokeDashArray == null ? te : this.strokeDashArray.every((e25) => Number.isFinite(Number(e25))) ? this.strokeDashArray.join(` `) : ``, i2 = this.strokeDashOffset == null ? `0` : rn(this.strokeDashOffset), a2 = this.strokeLineCap == null ? `butt` : an(this.strokeLineCap), o2 = this.strokeLineJoin == null ? `miter` : an(this.strokeLineJoin), s3 = this.strokeMiterLimit == null ? `4` : rn(this.strokeMiterLimit), c2 = this.opacity == null ? `1` : rn(this.opacity), l2 = this.visible ? `` : ` visibility: hidden;`, u2 = e24 ? `` : this.getSvgFilter(), d2 = hn(j, this.fill);
      return [hn(he, this.stroke), n2 ? `stroke-width: ${n2}; ` : ``, r2 ? `stroke-dasharray: ${r2}; ` : ``, a2 ? `stroke-linecap: ${a2}; ` : ``, i2 ? `stroke-dashoffset: ${i2}; ` : ``, o2 ? `stroke-linejoin: ${o2}; ` : ``, s3 ? `stroke-miterlimit: ${s3}; ` : ``, d2, t2 ? `fill-rule: ${t2}; ` : ``, c2 ? `opacity: ${c2};` : ``, u2, l2].map((e25) => U(e25)).join(``);
    }
    getSvgFilter() {
      return this.shadow ? `filter: url(#SVGID_${U(this.shadow.id)});` : ``;
    }
    getSvgCommons() {
      return [this.id ? `id="${U(String(this.id))}" ` : ``, this.clipPath ? `clip-path="url(#${U(this.clipPath.clipPathId)})" ` : ``].join(``);
    }
    getSvgTransform(e24, t2 = ``) {
      return `transform="${nt(e24 ? this.calcTransformMatrix() : this.calcOwnMatrix())}${t2}" `;
    }
    _toSVG(e24) {
      return [``];
    }
    toSVG(e24) {
      return this._createBaseSVGMarkup(this._toSVG(e24), { reviver: e24 });
    }
    toClipPathSVG(e24) {
      return `	` + this._createBaseClipPathSVGMarkup(this._toSVG(e24), { reviver: e24 });
    }
    _createBaseClipPathSVGMarkup(e24, { reviver: t2, additionalTransform: n2 = `` } = {}) {
      let r2 = [this.getSvgTransform(true, n2), this.getSvgCommons()].join(``), i2 = e24.indexOf(`COMMON_PARTS`);
      return e24[i2] = r2, t2 ? t2(e24.join(``)) : e24.join(``);
    }
    _createBaseSVGMarkup(e24, { noStyle: t2, reviver: n2, withShadow: r2, additionalTransform: i2 } = {}) {
      let a2 = t2 ? `` : `style="${this.getSvgStyles()}" `, o2 = r2 ? `style="${this.getSvgFilter()}" ` : ``, s3 = this.clipPath, c2 = this.strokeUniform ? `vector-effect="non-scaling-stroke" ` : ``, l2 = s3 && s3.absolutePositioned, u2 = this.stroke, d2 = this.fill, f2 = this.shadow, p2 = [], m = e24.indexOf(`COMMON_PARTS`), h2;
      return s3 && (s3.clipPathId = `CLIPPATH_${je()}`, h2 = `<clipPath id="${s3.clipPathId}" >
${s3.toClipPathSVG(n2)}</clipPath>
`), l2 && p2.push(`<g `, o2, this.getSvgCommons(), ` >
`), p2.push(`<g `, this.getSvgTransform(false), l2 ? `` : o2 + this.getSvgCommons(), ` >
`), e24[m] = [a2, c2, t2 ? `` : this.addPaintOrder(), ` `, i2 ? `transform="${i2}" ` : ``].join(``), V(d2) && p2.push(d2.toSVG(this)), V(u2) && p2.push(u2.toSVG(this)), f2 && p2.push(f2.toSVG(this)), s3 && p2.push(h2), p2.push(e24.join(``)), p2.push(`</g>
`), l2 && p2.push(`</g>
`), n2 ? n2(p2.join(``)) : p2.join(``);
    }
    addPaintOrder() {
      return this.paintFirst === `fill` ? `` : ` paint-order="${U(this.paintFirst)}" `;
    }
  };
  function _n(e24) {
    return RegExp(`^(` + e24.join(`|`) + `)\\b`, `i`);
  }
  var vn = `textDecorationThickness`;
  var yn = `textDecorationColor`;
  var bn = [`fontSize`, `fontWeight`, `fontFamily`, `fontStyle`];
  var xn = [`underline`, `overline`, `linethrough`];
  var Sn = [...bn, `lineHeight`, `text`, `charSpacing`, `textAlign`, `styles`, `path`, `pathStartOffset`, `pathSide`, `pathAlign`];
  var Cn = [...Sn, ...xn, `textBackgroundColor`, `direction`, vn, yn];
  var wn = [...bn, ...xn, he, `strokeWidth`, j, `deltaY`, `textBackgroundColor`, vn, yn];
  var Tn = { _reNewline: ne, _reSpacesAndTabs: /[ \t\r]/g, _reSpaceAndTab: /[ \t\r]/, _reWords: /\S+/g, fontSize: 40, fontWeight: _e, fontFamily: `Times New Roman`, underline: false, overline: false, linethrough: false, textAlign: D, fontStyle: _e, lineHeight: 1.16, textBackgroundColor: ``, stroke: null, shadow: null, path: void 0, pathStartOffset: 0, pathSide: D, pathAlign: `baseline`, charSpacing: 0, deltaY: 0, direction: `ltr`, CACHE_FONT_SIZE: 400, MIN_TEXT_WIDTH: 2, superscript: { size: 0.6, baseline: -0.35 }, subscript: { size: 0.6, baseline: 0.11 }, _fontSizeFraction: 0.222, offsets: { underline: 0.1, linethrough: -0.28167, overline: -0.81333 }, _fontSizeMult: 1.13, [vn]: 66.667 };
  var En = `justify`;
  var Dn = String.raw`[-+]?(?:\d*\.\d+|\d+\.?)(?:[eE][-+]?\d+)?`;
  var On = String.raw`(?:\s*,?\s+|\s*,\s*)`;
  var An = RegExp(`(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(` + Dn + `(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|` + Dn + `))?\\s+(.*)`);
  var jn = { cx: D, x: D, r: `radius`, cy: `top`, y: `top`, display: `visible`, visibility: `visible`, transform: `transformMatrix`, "fill-opacity": `fillOpacity`, "fill-rule": `fillRule`, "font-family": `fontFamily`, "font-size": `fontSize`, "font-style": `fontStyle`, "font-weight": `fontWeight`, "letter-spacing": `charSpacing`, "paint-order": `paintFirst`, "stroke-dasharray": `strokeDashArray`, "stroke-dashoffset": `strokeDashOffset`, "stroke-linecap": `strokeLineCap`, "stroke-linejoin": `strokeLineJoin`, "stroke-miterlimit": `strokeMiterLimit`, "stroke-opacity": `strokeOpacity`, "stroke-width": `strokeWidth`, "text-decoration": `textDecoration`, "text-anchor": `textAnchor`, opacity: `opacity`, "clip-path": `clipPath`, "clip-rule": `clipRule`, "vector-effect": `strokeUniform`, "image-rendering": `imageSmoothing`, "text-decoration-thickness": vn, "text-decoration-color": yn };
  var Mn = `font-size`;
  var Nn = `clip-path`;
  var Pn = _n([`path`, `circle`, `polygon`, `polyline`, `ellipse`, `rect`, `line`, `image`, `text`]);
  var Fn = _n([`symbol`, `image`, `marker`, `pattern`, `view`, `svg`]);
  var In = _n([`symbol`, `g`, `a`, `svg`, `clipPath`, `defs`]);
  var Ln = new RegExp(String.raw`^\s*(${Dn})${On}(${Dn})${On}(${Dn})${On}(${Dn})\s*$`);
  var Rn = `(-?\\d+(?:\\.\\d*)?(?:px)?(?:\\s?|$))?`;
  var zn = RegExp(`(?:\\s|^)` + Rn + Rn + `(` + Dn + `?(?:px)?)?(?:\\s?|$)(?:$|\\s)`);
  var Bn = class e5 {
    constructor(t2 = {}) {
      let n2 = typeof t2 == `string` ? e5.parseShadow(t2) : t2;
      Object.assign(this, e5.ownDefaults, n2), this.id = je();
    }
    static parseShadow(e24) {
      let t2 = e24.trim(), [, n2 = 0, r2 = 0, i2 = 0] = (zn.exec(t2) || []).map((e25) => parseFloat(e25) || 0);
      return { color: (t2.replace(zn, ``) || `rgb(0,0,0)`).trim(), offsetX: n2, offsetY: r2, blur: i2 };
    }
    toString() {
      return [this.offsetX, this.offsetY, this.blur, this.color].join(`px `);
    }
    toSVG(e24) {
      let t2 = Rt(new N(this.offsetX, this.offsetY), I(-e24.angle)), n2 = o.NUM_FRACTION_DIGITS, r2 = new G(this.color), i2 = 40, a2 = 40;
      return e24.width && e24.height && (i2 = 100 * B((Math.abs(t2.x) + this.blur) / e24.width, n2) + 20, a2 = 100 * B((Math.abs(t2.y) + this.blur) / e24.height, n2) + 20), e24.flipX && (t2.x *= -1), e24.flipY && (t2.y *= -1), `<filter id="SVGID_${U(this.id)}" y="-${a2}%" height="${100 + 2 * a2}%" x="-${i2}%" width="${100 + 2 * i2}%" >
	<feGaussianBlur in="SourceAlpha" stdDeviation="${B(this.blur ? this.blur / 2 : 0, n2)}"></feGaussianBlur>
	<feOffset dx="${B(t2.x, n2)}" dy="${B(t2.y, n2)}" result="oBlur" ></feOffset>
	<feFlood flood-color="${r2.toRgb()}" flood-opacity="${r2.getAlpha()}"/>
	<feComposite in2="oBlur" operator="in" />
	<feMerge>
		<feMergeNode></feMergeNode>
		<feMergeNode in="SourceGraphic"></feMergeNode>
	</feMerge>
</filter>
`;
    }
    toObject() {
      let t2 = { color: this.color, blur: this.blur, offsetX: this.offsetX, offsetY: this.offsetY, affectStroke: this.affectStroke, nonScaling: this.nonScaling, type: this.constructor.type }, n2 = e5.ownDefaults;
      return this.includeDefaultValues ? t2 : tt(t2, (e24, t3) => e24 !== n2[t3]);
    }
    static async fromObject(e24) {
      return new this(e24);
    }
  };
  i(Bn, `ownDefaults`, { color: `rgb(0,0,0)`, blur: 0, offsetX: 0, offsetY: 0, affectStroke: false, includeDefaultValues: true, nonScaling: false }), i(Bn, `type`, `shadow`), M.setClass(Bn, `shadow`);
  var Vn = (e24, t2, n2) => Math.max(e24, Math.min(t2, n2));
  var Hn = [`top`, D, de, fe, `flipX`, `flipY`, `originX`, `originY`, `angle`, `opacity`, `globalCompositeOperation`, `shadow`, `visible`, pe, me];
  var Un = [j, he, `strokeWidth`, `strokeDashArray`, `width`, `height`, `paintFirst`, `strokeUniform`, `strokeLineCap`, `strokeDashOffset`, `strokeLineJoin`, `strokeMiterLimit`, `backgroundColor`, `clipPath`];
  var Wn = { top: 0, left: 0, width: 0, height: 0, angle: 0, flipX: false, flipY: false, scaleX: 1, scaleY: 1, minScaleLimit: 0, skewX: 0, skewY: 0, originX: E, originY: E, strokeWidth: 1, strokeUniform: false, padding: 0, opacity: 1, paintFirst: j, fill: `rgb(0,0,0)`, fillRule: `nonzero`, stroke: null, strokeDashArray: null, strokeDashOffset: 0, strokeLineCap: `butt`, strokeLineJoin: `miter`, strokeMiterLimit: 4, globalCompositeOperation: `source-over`, backgroundColor: ``, shadow: null, visible: true, includeDefaultValues: true, excludeFromExport: false, objectCaching: true, clipPath: void 0, inverted: false, absolutePositioned: false, centeredRotation: true, centeredScaling: false, dirty: true };
  var Gn = t({ defaultEasing: () => Jn, easeInBack: () => gr, easeInBounce: () => br, easeInCirc: () => ur, easeInCubic: () => Yn, easeInElastic: () => pr, easeInExpo: () => sr, easeInOutBack: () => vr, easeInOutBounce: () => xr, easeInOutCirc: () => fr, easeInOutCubic: () => Zn, easeInOutElastic: () => hr, easeInOutExpo: () => lr, easeInOutQuad: () => wr, easeInOutQuart: () => er, easeInOutQuint: () => rr, easeInOutSine: () => or, easeInQuad: () => Sr, easeInQuart: () => Qn, easeInQuint: () => tr, easeInSine: () => ir, easeOutBack: () => _r, easeOutBounce: () => yr, easeOutCirc: () => dr, easeOutCubic: () => Xn, easeOutElastic: () => mr, easeOutExpo: () => cr, easeOutQuad: () => Cr, easeOutQuart: () => $n, easeOutQuint: () => nr, easeOutSine: () => ar });
  var Kn = (e24, t2, n2, r2) => (e24 < Math.abs(t2) ? (e24 = t2, r2 = n2 / 4) : r2 = t2 === 0 && e24 === 0 ? n2 / w * Math.asin(1) : n2 / w * Math.asin(t2 / e24), { a: e24, c: t2, p: n2, s: r2 });
  var qn = (e24, t2, n2, r2, i2) => e24 * 2 ** (10 * --r2) * Math.sin((r2 * i2 - t2) * w / n2);
  var Jn = (e24, t2, n2, r2) => -n2 * Math.cos(e24 / r2 * S) + n2 + t2;
  var Yn = (e24, t2, n2, r2) => n2 * (e24 / r2) ** 3 + t2;
  var Xn = (e24, t2, n2, r2) => n2 * ((e24 / r2 - 1) ** 3 + 1) + t2;
  var Zn = (e24, t2, n2, r2) => (e24 /= r2 / 2) < 1 ? n2 / 2 * e24 ** 3 + t2 : n2 / 2 * ((e24 - 2) ** 3 + 2) + t2;
  var Qn = (e24, t2, n2, r2) => n2 * (e24 /= r2) * e24 ** 3 + t2;
  var $n = (e24, t2, n2, r2) => -n2 * ((e24 = e24 / r2 - 1) * e24 ** 3 - 1) + t2;
  var er = (e24, t2, n2, r2) => (e24 /= r2 / 2) < 1 ? n2 / 2 * e24 ** 4 + t2 : -n2 / 2 * ((e24 -= 2) * e24 ** 3 - 2) + t2;
  var tr = (e24, t2, n2, r2) => n2 * (e24 / r2) ** 5 + t2;
  var nr = (e24, t2, n2, r2) => n2 * ((e24 / r2 - 1) ** 5 + 1) + t2;
  var rr = (e24, t2, n2, r2) => (e24 /= r2 / 2) < 1 ? n2 / 2 * e24 ** 5 + t2 : n2 / 2 * ((e24 - 2) ** 5 + 2) + t2;
  var ir = (e24, t2, n2, r2) => -n2 * Math.cos(e24 / r2 * S) + n2 + t2;
  var ar = (e24, t2, n2, r2) => n2 * Math.sin(e24 / r2 * S) + t2;
  var or = (e24, t2, n2, r2) => -n2 / 2 * (Math.cos(Math.PI * e24 / r2) - 1) + t2;
  var sr = (e24, t2, n2, r2) => e24 === 0 ? t2 : n2 * 2 ** (10 * (e24 / r2 - 1)) + t2;
  var cr = (e24, t2, n2, r2) => e24 === r2 ? t2 + n2 : n2 * -(2 ** (-10 * e24 / r2) + 1) + t2;
  var lr = (e24, t2, n2, r2) => e24 === 0 ? t2 : e24 === r2 ? t2 + n2 : (e24 /= r2 / 2) < 1 ? n2 / 2 * 2 ** (10 * (e24 - 1)) + t2 : n2 / 2 * -(2 ** (-10 * (e24 - 1)) + 2) + t2;
  var ur = (e24, t2, n2, r2) => -n2 * (Math.sqrt(1 - (e24 /= r2) * e24) - 1) + t2;
  var dr = (e24, t2, n2, r2) => n2 * Math.sqrt(1 - (e24 = e24 / r2 - 1) * e24) + t2;
  var fr = (e24, t2, n2, r2) => (e24 /= r2 / 2) < 1 ? -n2 / 2 * (Math.sqrt(1 - e24 ** 2) - 1) + t2 : n2 / 2 * (Math.sqrt(1 - (e24 -= 2) * e24) + 1) + t2;
  var pr = (e24, t2, n2, r2) => {
    let i2 = n2, a2 = 0;
    if (e24 === 0) return t2;
    if ((e24 /= r2) === 1) return t2 + n2;
    a2 || (a2 = 0.3 * r2);
    let { a: o2, s: s3, p: c2 } = Kn(i2, n2, a2, 1.70158);
    return -qn(o2, s3, c2, e24, r2) + t2;
  };
  var mr = (e24, t2, n2, r2) => {
    let i2 = n2, a2 = 0;
    if (e24 === 0) return t2;
    if ((e24 /= r2) === 1) return t2 + n2;
    a2 || (a2 = 0.3 * r2);
    let { a: o2, s: s3, p: c2, c: l2 } = Kn(i2, n2, a2, 1.70158);
    return o2 * 2 ** (-10 * e24) * Math.sin((e24 * r2 - s3) * w / c2) + l2 + t2;
  };
  var hr = (e24, t2, n2, r2) => {
    let i2 = n2, a2 = 0;
    if (e24 === 0) return t2;
    if ((e24 /= r2 / 2) == 2) return t2 + n2;
    a2 || (a2 = 0.3 * 1.5 * r2);
    let { a: o2, s: s3, p: c2, c: l2 } = Kn(i2, n2, a2, 1.70158);
    return e24 < 1 ? -0.5 * qn(o2, s3, c2, e24, r2) + t2 : o2 * 2 ** (-10 * --e24) * Math.sin((e24 * r2 - s3) * w / c2) * 0.5 + l2 + t2;
  };
  var gr = (e24, t2, n2, r2, i2 = 1.70158) => n2 * (e24 /= r2) * e24 * ((i2 + 1) * e24 - i2) + t2;
  var _r = (e24, t2, n2, r2, i2 = 1.70158) => n2 * ((e24 = e24 / r2 - 1) * e24 * ((i2 + 1) * e24 + i2) + 1) + t2;
  var vr = (e24, t2, n2, r2, i2 = 1.70158) => (e24 /= r2 / 2) < 1 ? n2 / 2 * (e24 * e24 * ((1 + (i2 *= 1.525)) * e24 - i2)) + t2 : n2 / 2 * ((e24 -= 2) * e24 * ((1 + (i2 *= 1.525)) * e24 + i2) + 2) + t2;
  var yr = (e24, t2, n2, r2) => (e24 /= r2) < 1 / 2.75 ? n2 * (7.5625 * e24 * e24) + t2 : e24 < 2 / 2.75 ? n2 * (7.5625 * (e24 -= 1.5 / 2.75) * e24 + 0.75) + t2 : e24 < 2.5 / 2.75 ? n2 * (7.5625 * (e24 -= 2.25 / 2.75) * e24 + 0.9375) + t2 : n2 * (7.5625 * (e24 -= 2.625 / 2.75) * e24 + 0.984375) + t2;
  var br = (e24, t2, n2, r2) => n2 - yr(r2 - e24, 0, n2, r2) + t2;
  var xr = (e24, t2, n2, r2) => e24 < r2 / 2 ? 0.5 * br(2 * e24, 0, n2, r2) + t2 : 0.5 * yr(2 * e24 - r2, 0, n2, r2) + 0.5 * n2 + t2;
  var Sr = (e24, t2, n2, r2) => n2 * (e24 /= r2) * e24 + t2;
  var Cr = (e24, t2, n2, r2) => -n2 * (e24 /= r2) * (e24 - 2) + t2;
  var wr = (e24, t2, n2, r2) => (e24 /= r2 / 2) < 1 ? n2 / 2 * e24 ** 2 + t2 : -n2 / 2 * (--e24 * (e24 - 2) - 1) + t2;
  var Tr = () => false;
  var Er = class {
    constructor({ startValue: e24, byValue: t2, duration: n2 = 500, delay: r2 = 0, easing: a2 = Jn, onStart: o2 = x, onChange: s3 = x, onComplete: c2 = x, abort: l2 = Tr, target: u2 }) {
      i(this, `_state`, `pending`), i(this, `durationProgress`, 0), i(this, `valueProgress`, 0), this.tick = this.tick.bind(this), this.duration = n2, this.delay = r2, this.easing = a2, this._onStart = o2, this._onChange = s3, this._onComplete = c2, this._abort = l2, this.target = u2, this.startValue = e24, this.byValue = t2, this.value = this.startValue, this.endValue = Object.freeze(this.calculate(this.duration).value);
    }
    get state() {
      return this._state;
    }
    isDone() {
      return this._state === `aborted` || this._state === `completed`;
    }
    start() {
      let e24 = (e25) => {
        this._state === `pending` && (this.startTime = e25 || +/* @__PURE__ */ new Date(), this._state = `running`, this._onStart(), this.tick(this.startTime));
      };
      this.register(), this.delay > 0 ? this.timeout = _().setTimeout(() => Oe(e24), this.delay) : Oe(e24);
    }
    tick(e24) {
      let t2 = (e24 || +/* @__PURE__ */ new Date()) - this.startTime, n2 = Math.min(t2, this.duration);
      this.durationProgress = n2 / this.duration;
      let { value: r2, valueProgress: i2 } = this.calculate(n2);
      this.value = Object.freeze(r2), this.valueProgress = i2, this._state !== `aborted` && (this._abort(this.value, this.valueProgress, this.durationProgress) ? (this._state = `aborted`, this.unregister()) : t2 >= this.duration ? (this.durationProgress = this.valueProgress = 1, this._onChange(this.endValue, this.valueProgress, this.durationProgress), this._state = `completed`, this._onComplete(this.endValue, this.valueProgress, this.durationProgress), this.unregister(), this.timeout = null) : (this._onChange(this.value, this.valueProgress, this.durationProgress), Oe(this.tick)));
    }
    register() {
      ye.push(this);
    }
    unregister() {
      ye.remove(this);
    }
    abort() {
      this._state = `aborted`, this.unregister(), this.timeout && _().clearTimeout(this.timeout);
    }
  };
  var Dr = class extends Er {
    constructor({ startValue: e24 = 0, endValue: t2 = 100, ...n2 }) {
      super({ ...n2, startValue: e24, byValue: t2 - e24 });
    }
    calculate(e24) {
      let t2 = this.easing(e24, this.startValue, this.byValue, this.duration);
      return { value: t2, valueProgress: Math.abs((t2 - this.startValue) / this.byValue) };
    }
  };
  var Or = class extends Er {
    constructor({ startValue: e24 = [0], endValue: t2 = [100], ...n2 }) {
      super({ ...n2, startValue: e24, byValue: t2.map((t3, n3) => t3 - e24[n3]) });
    }
    calculate(e24) {
      let t2 = this.startValue.map((t3, n2) => this.easing(e24, t3, this.byValue[n2], this.duration, n2));
      return { value: t2, valueProgress: Math.abs((t2[0] - this.startValue[0]) / this.byValue[0]) };
    }
  };
  var kr = (e24, t2, n2, r2) => t2 + n2 * (1 - Math.cos(e24 / r2 * S));
  var Ar = (e24) => e24 && ((t2, n2, r2) => e24(new G(t2).toRgba(), n2, r2));
  var jr = class extends Er {
    constructor({ startValue: e24, endValue: t2, easing: n2 = kr, onChange: r2, onComplete: i2, abort: a2, ...o2 }) {
      let s3 = new G(e24).getSource(), c2 = new G(t2).getSource();
      super({ ...o2, startValue: s3, byValue: c2.map((e25, t3) => e25 - s3[t3]), easing: n2, onChange: Ar(r2), onComplete: Ar(i2), abort: Ar(a2) });
    }
    calculate(e24) {
      let [t2, n2, r2, i2] = this.startValue.map((t3, n3) => this.easing(e24, t3, this.byValue[n3], this.duration, n3)), a2 = [...[t2, n2, r2].map(Math.round), Vn(0, i2, 1)];
      return { value: a2, valueProgress: a2.map((e25, t3) => this.byValue[t3] === 0 ? 0 : Math.abs((e25 - this.startValue[t3]) / this.byValue[t3])).find((e25) => e25 !== 0) || 0 };
    }
  };
  function Mr(e24) {
    let t2 = ((e25) => Array.isArray(e25.startValue) || Array.isArray(e25.endValue))(e24) ? new Or(e24) : new Dr(e24);
    return t2.start(), t2;
  }
  function Nr(e24) {
    let t2 = new jr(e24);
    return t2.start(), t2;
  }
  var Pr = class e6 {
    constructor(e24) {
      this.status = e24, this.points = [];
    }
    includes(e24) {
      return this.points.some((t2) => t2.eq(e24));
    }
    append(...e24) {
      return this.points = this.points.concat(e24.filter((e25) => !this.includes(e25))), this;
    }
    static isPointContained(e24, t2, n2, r2 = false) {
      if (t2.eq(n2)) return e24.eq(t2);
      if (t2.x === n2.x) return e24.x === t2.x && (r2 || e24.y >= Math.min(t2.y, n2.y) && e24.y <= Math.max(t2.y, n2.y));
      if (t2.y === n2.y) return e24.y === t2.y && (r2 || e24.x >= Math.min(t2.x, n2.x) && e24.x <= Math.max(t2.x, n2.x));
      {
        let i2 = zt(t2, n2), a2 = zt(t2, e24).divide(i2);
        return r2 ? Math.abs(a2.x) === Math.abs(a2.y) : a2.x === a2.y && a2.x >= 0 && a2.x <= 1;
      }
    }
    static isPointInPolygon(e24, t2) {
      let n2 = new N(e24).setX(Math.min(e24.x - 1, ...t2.map((e25) => e25.x))), r2 = 0;
      for (let i2 = 0; i2 < t2.length; i2++) {
        let a2 = this.intersectSegmentSegment(t2[i2], t2[(i2 + 1) % t2.length], e24, n2);
        if (a2.includes(e24)) return true;
        r2 += Number(a2.status === `Intersection`);
      }
      return r2 % 2 == 1;
    }
    static intersectLineLine(t2, n2, r2, i2, a2 = true, o2 = true) {
      let s3 = n2.x - t2.x, c2 = n2.y - t2.y, l2 = i2.x - r2.x, u2 = i2.y - r2.y, d2 = t2.x - r2.x, f2 = t2.y - r2.y, p2 = l2 * f2 - u2 * d2, m = s3 * f2 - c2 * d2, h2 = u2 * s3 - l2 * c2;
      if (h2 !== 0) {
        let n3 = p2 / h2, r3 = m / h2;
        return (a2 || 0 <= n3 && n3 <= 1) && (o2 || 0 <= r3 && r3 <= 1) ? new e6(`Intersection`).append(new N(t2.x + n3 * s3, t2.y + n3 * c2)) : new e6();
      }
      return new e6(p2 === 0 || m === 0 ? a2 || o2 || e6.isPointContained(t2, r2, i2) || e6.isPointContained(n2, r2, i2) || e6.isPointContained(r2, t2, n2) || e6.isPointContained(i2, t2, n2) ? `Coincident` : void 0 : `Parallel`);
    }
    static intersectSegmentLine(t2, n2, r2, i2) {
      return e6.intersectLineLine(t2, n2, r2, i2, false, true);
    }
    static intersectSegmentSegment(t2, n2, r2, i2) {
      return e6.intersectLineLine(t2, n2, r2, i2, false, false);
    }
    static intersectLinePolygon(t2, n2, r2, i2 = true) {
      let a2 = new e6(), o2 = r2.length;
      for (let s3, c2, l2, u2 = 0; u2 < o2; u2++) {
        if (s3 = r2[u2], c2 = r2[(u2 + 1) % o2], l2 = e6.intersectLineLine(t2, n2, s3, c2, i2, false), l2.status === `Coincident`) return l2;
        a2.append(...l2.points);
      }
      return a2.points.length > 0 && (a2.status = `Intersection`), a2;
    }
    static intersectSegmentPolygon(t2, n2, r2) {
      return e6.intersectLinePolygon(t2, n2, r2, false);
    }
    static intersectPolygonPolygon(t2, n2) {
      let r2 = new e6(), i2 = t2.length, a2 = [];
      for (let o2 = 0; o2 < i2; o2++) {
        let s3 = t2[o2], c2 = t2[(o2 + 1) % i2], l2 = e6.intersectSegmentPolygon(s3, c2, n2);
        l2.status === `Coincident` ? (a2.push(l2), r2.append(s3, c2)) : r2.append(...l2.points);
      }
      return a2.length > 0 && a2.length === t2.length ? new e6(`Coincident`) : (r2.points.length > 0 && (r2.status = `Intersection`), r2);
    }
    static intersectPolygonRectangle(t2, n2, r2) {
      let i2 = n2.min(r2), a2 = n2.max(r2), o2 = new N(a2.x, i2.y), s3 = new N(i2.x, a2.y);
      return e6.intersectPolygonPolygon(t2, [i2, o2, a2, s3]);
    }
  };
  var Fr = class extends De {
    getX() {
      return this.getXY().x;
    }
    setX(e24) {
      this.setXY(this.getXY().setX(e24));
    }
    getY() {
      return this.getXY().y;
    }
    setY(e24) {
      this.setXY(this.getXY().setY(e24));
    }
    getRelativeX() {
      return this.left;
    }
    setRelativeX(e24) {
      this.left = e24;
    }
    getRelativeY() {
      return this.top;
    }
    setRelativeY(e24) {
      this.top = e24;
    }
    getXY() {
      let e24 = this.getRelativeXY();
      return this.group ? L(e24, this.group.calcTransformMatrix()) : e24;
    }
    setXY(e24, t2, n2) {
      this.group && (e24 = L(e24, R(this.group.calcTransformMatrix()))), this.setRelativeXY(e24, t2, n2);
    }
    getRelativeXY() {
      return new N(this.left, this.top);
    }
    setRelativeXY(e24, t2 = this.originX, n2 = this.originY) {
      this.setPositionByOrigin(e24, t2, n2);
    }
    isStrokeAccountedForInDimensions() {
      return false;
    }
    getCoords() {
      let { tl: e24, tr: t2, br: n2, bl: r2 } = this.aCoords || (this.aCoords = this.calcACoords()), i2 = [e24, t2, n2, r2];
      if (this.group) {
        let e25 = this.group.calcTransformMatrix();
        return i2.map((t3) => L(t3, e25));
      }
      return i2;
    }
    intersectsWithRect(e24, t2) {
      return Pr.intersectPolygonRectangle(this.getCoords(), e24, t2).status === `Intersection`;
    }
    intersectsWithObject(e24) {
      let t2 = Pr.intersectPolygonPolygon(this.getCoords(), e24.getCoords());
      return t2.status === `Intersection` || t2.status === `Coincident` || e24.isContainedWithinObject(this) || this.isContainedWithinObject(e24);
    }
    isContainedWithinObject(e24) {
      return this.getCoords().every((t2) => e24.containsPoint(t2));
    }
    isContainedWithinRect(e24, t2) {
      let { left: n2, top: r2, width: i2, height: a2 } = this.getBoundingRect();
      return n2 >= e24.x && n2 + i2 <= t2.x && r2 >= e24.y && r2 + a2 <= t2.y;
    }
    isOverlapping(e24) {
      return this.intersectsWithObject(e24) || this.isContainedWithinObject(e24) || e24.isContainedWithinObject(this);
    }
    containsPoint(e24) {
      return Pr.isPointInPolygon(e24, this.getCoords());
    }
    isOnScreen() {
      if (!this.canvas) return false;
      let { tl: e24, br: t2 } = this.canvas.vptCoords;
      return !!this.getCoords().some((n2) => n2.x <= t2.x && n2.x >= e24.x && n2.y <= t2.y && n2.y >= e24.y) || !!this.intersectsWithRect(e24, t2) || this.containsPoint(e24.midPointFrom(t2));
    }
    isPartiallyOnScreen() {
      if (!this.canvas) return false;
      let { tl: e24, br: t2 } = this.canvas.vptCoords;
      return !!this.intersectsWithRect(e24, t2) || this.getCoords().every((n2) => (n2.x >= t2.x || n2.x <= e24.x) && (n2.y >= t2.y || n2.y <= e24.y)) && this.containsPoint(e24.midPointFrom(t2));
    }
    getBoundingRect() {
      return wt(this.getCoords());
    }
    getScaledWidth() {
      return this._getTransformedDimensions().x;
    }
    getScaledHeight() {
      return this._getTransformedDimensions().y;
    }
    scale(e24) {
      this._set(de, e24), this._set(fe, e24), this.setCoords();
    }
    scaleToWidth(e24) {
      let t2 = this.getBoundingRect().width / this.getScaledWidth();
      return this.scale(e24 / this.width / t2);
    }
    scaleToHeight(e24) {
      let t2 = this.getBoundingRect().height / this.getScaledHeight();
      return this.scale(e24 / this.height / t2);
    }
    getCanvasRetinaScaling() {
      var e24;
      return ((e24 = this.canvas) == null ? void 0 : e24.getRetinaScaling()) || 1;
    }
    getTotalAngle() {
      return this.group ? Ie(ze(this.calcTransformMatrix())) : this.angle;
    }
    getViewportTransform() {
      var e24;
      return ((e24 = this.canvas) == null ? void 0 : e24.viewportTransform) || T.concat();
    }
    calcACoords() {
      let e24 = We({ angle: this.angle }), { x: t2, y: n2 } = this.getRelativeCenterPoint(), r2 = z(Ue(t2, n2), e24), i2 = this._getTransformedDimensions(), a2 = i2.x / 2, o2 = i2.y / 2;
      return { tl: L({ x: -a2, y: -o2 }, r2), tr: L({ x: a2, y: -o2 }, r2), bl: L({ x: -a2, y: o2 }, r2), br: L({ x: a2, y: o2 }, r2) };
    }
    setCoords() {
      this.aCoords = this.calcACoords();
    }
    transformMatrixKey(e24 = false) {
      let t2 = [];
      return !e24 && this.group && (t2 = this.group.transformMatrixKey(e24)), t2.push(this.top, this.left, this.width, this.height, this.scaleX, this.scaleY, this.angle, this.strokeWidth, this.skewX, this.skewY, +this.flipX, +this.flipY, W(this.originX), W(this.originY)), t2;
    }
    calcTransformMatrix(e24 = false) {
      let t2 = this.calcOwnMatrix();
      if (e24 || !this.group) return t2;
      let n2 = this.transformMatrixKey(e24), r2 = this.matrixCache;
      return r2 && r2.key.every((e25, t3) => e25 === n2[t3]) ? r2.value : (this.group && (t2 = z(this.group.calcTransformMatrix(false), t2)), this.matrixCache = { key: n2, value: t2 }, t2);
    }
    calcOwnMatrix() {
      let e24 = this.transformMatrixKey(true), t2 = this.ownMatrixCache;
      if (t2 && t2.key.every((t3, n3) => t3 === e24[n3])) return t2.value;
      let n2 = this.getRelativeCenterPoint(), r2 = Xe({ angle: this.angle, translateX: n2.x, translateY: n2.y, scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, flipX: this.flipX, flipY: this.flipY });
      return this.ownMatrixCache = { key: e24, value: r2 }, r2;
    }
    _getNonTransformedDimensions() {
      return new N(this.width, this.height).scalarAdd(this.strokeWidth);
    }
    _calculateCurrentDimensions(e24) {
      var t2;
      let n2 = (t2 = this.canvas) == null ? void 0 : t2.viewportTransform, r2 = this._getTransformedDimensions(e24);
      return n2 ? r2.multiply(new N(Be(n2), Ve(n2))).scalarAdd(2 * this.padding) : r2.scalarAdd(2 * this.padding);
    }
    _getTransformedDimensions(e24 = {}) {
      let t2 = { scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, width: this.width, height: this.height, strokeWidth: this.strokeWidth, ...e24 }, n2 = t2.strokeWidth, r2 = n2, i2 = 0;
      this.strokeUniform && (r2 = 0, i2 = n2);
      let a2 = t2.width + r2, o2 = t2.height + r2, s3;
      return s3 = t2.skewX === 0 && t2.skewY === 0 ? new N(a2 * t2.scaleX, o2 * t2.scaleY) : At(a2, o2, Ye(t2)), s3.scalarAdd(i2);
    }
    translateToGivenOrigin(e24, t2, n2, r2, i2) {
      let a2 = e24.x, o2 = e24.y, s3 = W(r2) - W(t2), c2 = W(i2) - W(n2);
      if (s3 || c2) {
        let e25 = this._getTransformedDimensions();
        a2 += s3 * e25.x, o2 += c2 * e25.y;
      }
      return new N(a2, o2);
    }
    translateToCenterPoint(e24, t2, n2) {
      if (t2 === `center` && n2 === `center`) return e24;
      let r2 = this.translateToGivenOrigin(e24, t2, n2, E, E);
      return this.angle ? r2.rotate(I(this.angle), e24) : r2;
    }
    translateToOriginPoint(e24, t2, n2) {
      let r2 = this.translateToGivenOrigin(e24, E, E, t2, n2);
      return this.angle ? r2.rotate(I(this.angle), e24) : r2;
    }
    getCenterPoint() {
      let e24 = this.getRelativeCenterPoint();
      return this.group ? L(e24, this.group.calcTransformMatrix()) : e24;
    }
    getRelativeCenterPoint() {
      return this.translateToCenterPoint(new N(this.left, this.top), this.originX, this.originY);
    }
    getPointByOrigin(e24, t2) {
      return this.getPositionByOrigin(e24, t2);
    }
    getPositionByOrigin(e24, t2) {
      return this.translateToOriginPoint(this.getRelativeCenterPoint(), e24, t2);
    }
    setPositionByOrigin(e24, t2, n2) {
      let r2 = this.translateToCenterPoint(e24, t2, n2), i2 = this.translateToOriginPoint(r2, this.originX, this.originY);
      this.set({ left: i2.x, top: i2.y });
    }
    _getLeftTopCoords() {
      return this.getPositionByOrigin(D, `top`);
    }
    positionByLeftTop(e24) {
      return this.setPositionByOrigin(e24, D, `top`);
    }
  };
  var Ir = class e7 extends Fr {
    static getDefaults() {
      return e7.ownDefaults;
    }
    get type() {
      let e24 = this.constructor.type;
      return e24 === `FabricObject` ? `object` : e24.toLowerCase();
    }
    set type(e24) {
      s(`warn`, `Setting type has no effect`, e24);
    }
    constructor(t2) {
      super(), i(this, `_cacheContext`, null), Object.assign(this, e7.ownDefaults), this.setOptions(t2);
    }
    _createCacheCanvas() {
      this._cacheCanvas = P(), this._cacheContext = this._cacheCanvas.getContext(`2d`), this._updateCacheCanvas(), this.dirty = true;
    }
    _limitCacheSize(e24) {
      let t2 = e24.width, n2 = e24.height, r2 = o.maxCacheSideLimit, i2 = o.minCacheSideLimit;
      if (t2 <= r2 && n2 <= r2 && t2 * n2 <= o.perfLimitSizeTotal) return t2 < i2 && (e24.width = i2), n2 < i2 && (e24.height = i2), e24;
      let a2 = t2 / n2, [s3, c2] = y.limitDimsByArea(a2), l2 = Vn(i2, s3, r2), u2 = Vn(i2, c2, r2);
      return t2 > l2 && (e24.zoomX /= t2 / l2, e24.width = l2, e24.capped = true), n2 > u2 && (e24.zoomY /= n2 / u2, e24.height = u2, e24.capped = true), e24;
    }
    _getCacheCanvasDimensions() {
      let e24 = this.getTotalObjectScaling(), t2 = this._getTransformedDimensions({ skewX: 0, skewY: 0 }), n2 = t2.x * e24.x / this.scaleX, r2 = t2.y * e24.y / this.scaleY;
      return { width: Math.ceil(n2 + 2), height: Math.ceil(r2 + 2), zoomX: e24.x, zoomY: e24.y, x: n2, y: r2 };
    }
    _updateCacheCanvas() {
      let e24 = this._cacheCanvas, t2 = this._cacheContext, { width: n2, height: r2, zoomX: i2, zoomY: a2, x: o2, y: s3 } = this._limitCacheSize(this._getCacheCanvasDimensions()), c2 = n2 !== e24.width || r2 !== e24.height, l2 = this.zoomX !== i2 || this.zoomY !== a2;
      if (!e24 || !t2) return false;
      if (c2 || l2) {
        n2 !== e24.width || r2 !== e24.height ? (e24.width = n2, e24.height = r2) : (t2.setTransform(1, 0, 0, 1, 0, 0), t2.clearRect(0, 0, e24.width, e24.height));
        let c3 = o2 / 2, l3 = s3 / 2;
        return this.cacheTranslationX = Math.round(e24.width / 2 - c3) + c3, this.cacheTranslationY = Math.round(e24.height / 2 - l3) + l3, t2.translate(this.cacheTranslationX, this.cacheTranslationY), t2.scale(i2, a2), this.zoomX = i2, this.zoomY = a2, true;
      }
      return false;
    }
    setOptions(e24 = {}) {
      this._setOptions(e24);
    }
    transform(e24) {
      let t2 = this.group && !this.group._transformDone || this.group && this.canvas && e24 === this.canvas.contextTop, n2 = this.calcTransformMatrix(!t2);
      e24.transform(n2[0], n2[1], n2[2], n2[3], n2[4], n2[5]);
    }
    getObjectScaling() {
      if (!this.group) return new N(Math.abs(this.scaleX), Math.abs(this.scaleY));
      let e24 = He(this.calcTransformMatrix());
      return new N(Math.abs(e24.scaleX), Math.abs(e24.scaleY));
    }
    getTotalObjectScaling() {
      let e24 = this.getObjectScaling();
      if (this.canvas) {
        let t2 = this.canvas.getZoom(), n2 = this.getCanvasRetinaScaling();
        return e24.scalarMultiply(t2 * n2);
      }
      return e24;
    }
    getObjectOpacity() {
      let e24 = this.opacity;
      return this.group && (e24 *= this.group.getObjectOpacity()), e24;
    }
    _constrainScale(e24) {
      return Math.abs(e24) < this.minScaleLimit ? e24 < 0 ? -this.minScaleLimit : this.minScaleLimit : e24 === 0 ? 1e-4 : e24;
    }
    _set(e24, t2) {
      e24 !== `scaleX` && e24 !== `scaleY` || (t2 = this._constrainScale(t2)), e24 === `scaleX` && t2 < 0 ? (this.flipX = !this.flipX, t2 *= -1) : e24 === `scaleY` && t2 < 0 ? (this.flipY = !this.flipY, t2 *= -1) : e24 !== `shadow` || !t2 || t2 instanceof Bn || (t2 = new Bn(t2));
      let n2 = this[e24] !== t2;
      return this[e24] = t2, n2 && this.constructor.cacheProperties.includes(e24) && (this.dirty = true), this.parent && (this.dirty || n2 && this.constructor.stateProperties.includes(e24)) && this.parent._set(`dirty`, true), this;
    }
    isNotVisible() {
      return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
    }
    render(e24) {
      this.isNotVisible() || this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (e24.save(), this._setupCompositeOperation(e24), this.drawSelectionBackground(e24), this.transform(e24), this._setOpacity(e24), this._setShadow(e24), this.shouldCache() ? (this.renderCache(), this.drawCacheOnCanvas(e24)) : (this._removeCacheCanvas(), this.drawObject(e24, false, {}), this.dirty = false), e24.restore());
    }
    drawSelectionBackground(e24) {
    }
    renderCache(e24) {
      if (e24 = e24 || {}, this._cacheCanvas && this._cacheContext || this._createCacheCanvas(), this.isCacheDirty() && this._cacheContext) {
        let { zoomX: t2, zoomY: n2, cacheTranslationX: r2, cacheTranslationY: i2 } = this, { width: a2, height: o2 } = this._cacheCanvas;
        this.drawObject(this._cacheContext, e24.forClipping, { zoomX: t2, zoomY: n2, cacheTranslationX: r2, cacheTranslationY: i2, width: a2, height: o2, parentClipPaths: [] }), this.dirty = false;
      }
    }
    _removeCacheCanvas() {
      this._cacheCanvas = void 0, this._cacheContext = null;
    }
    hasStroke() {
      return !!this.stroke && this.stroke !== `transparent` && this.strokeWidth !== 0;
    }
    hasFill() {
      return !!this.fill && this.fill !== `transparent`;
    }
    needsItsOwnCache() {
      return !!(this.paintFirst === `stroke` && this.hasFill() && this.hasStroke() && this.shadow) || !!this.clipPath;
    }
    shouldCache() {
      return this.ownCaching = this.objectCaching && (!this.parent || !this.parent.isOnACache()) || this.needsItsOwnCache(), this.ownCaching;
    }
    willDrawShadow() {
      return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    }
    drawClipPathOnCache(e24, t2, n2) {
      e24.save(), t2.inverted ? e24.globalCompositeOperation = `destination-out` : e24.globalCompositeOperation = `destination-in`, e24.setTransform(1, 0, 0, 1, 0, 0), e24.drawImage(n2, 0, 0), e24.restore();
    }
    drawObject(e24, t2, n2) {
      let r2 = this.fill, i2 = this.stroke;
      t2 ? (this.fill = `black`, this.stroke = ``, this._setClippingProperties(e24)) : this._renderBackground(e24), this.fire(`before:render`, { ctx: e24 }), this._render(e24), this._drawClipPath(e24, this.clipPath, n2), this.fill = r2, this.stroke = i2;
    }
    createClipPathLayer(e24, t2) {
      let n2 = F(t2), r2 = n2.getContext(`2d`);
      if (r2.translate(t2.cacheTranslationX, t2.cacheTranslationY), r2.scale(t2.zoomX, t2.zoomY), e24._cacheCanvas = n2, t2.parentClipPaths.forEach((e25) => {
        e25.transform(r2);
      }), t2.parentClipPaths.push(e24), e24.absolutePositioned) {
        let e25 = R(this.calcTransformMatrix());
        r2.transform(e25[0], e25[1], e25[2], e25[3], e25[4], e25[5]);
      }
      return e24.transform(r2), e24.drawObject(r2, true, t2), n2;
    }
    _drawClipPath(e24, t2, n2) {
      if (!t2) return;
      t2._transformDone = true;
      let r2 = this.createClipPathLayer(t2, n2);
      this.drawClipPathOnCache(e24, t2, r2);
    }
    drawCacheOnCanvas(e24) {
      e24.scale(1 / this.zoomX, 1 / this.zoomY), e24.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    }
    isCacheDirty(e24 = false) {
      if (this.isNotVisible()) return false;
      let t2 = this._cacheCanvas, n2 = this._cacheContext;
      return !(!t2 || !n2 || e24 || !this._updateCacheCanvas()) || !!(this.dirty || this.clipPath && this.clipPath.absolutePositioned) && (t2 && n2 && !e24 && (n2.save(), n2.setTransform(1, 0, 0, 1, 0, 0), n2.clearRect(0, 0, t2.width, t2.height), n2.restore()), true);
    }
    _renderBackground(e24) {
      if (!this.backgroundColor) return;
      let t2 = this._getNonTransformedDimensions();
      e24.fillStyle = this.backgroundColor, e24.fillRect(-t2.x / 2, -t2.y / 2, t2.x, t2.y), this._removeShadow(e24);
    }
    _setOpacity(e24) {
      this.group && !this.group._transformDone ? e24.globalAlpha = this.getObjectOpacity() : e24.globalAlpha *= this.opacity;
    }
    _setStrokeStyles(e24, t2) {
      let n2 = t2.stroke;
      n2 && (e24.lineWidth = t2.strokeWidth, e24.lineCap = t2.strokeLineCap, e24.lineDashOffset = t2.strokeDashOffset, e24.lineJoin = t2.strokeLineJoin, e24.miterLimit = t2.strokeMiterLimit, V(n2) ? n2.gradientUnits === `percentage` || n2.gradientTransform || n2.patternTransform ? this._applyPatternForTransformedGradient(e24, n2) : (e24.strokeStyle = n2.toLive(e24), this._applyPatternGradientTransform(e24, n2)) : e24.strokeStyle = t2.stroke);
    }
    _setFillStyles(e24, { fill: t2 }) {
      t2 && (V(t2) ? (e24.fillStyle = t2.toLive(e24), this._applyPatternGradientTransform(e24, t2)) : e24.fillStyle = t2);
    }
    _setClippingProperties(e24) {
      e24.globalAlpha = 1, e24.strokeStyle = `transparent`, e24.fillStyle = `#000000`;
    }
    _setLineDash(e24, t2) {
      t2 && t2.length !== 0 && e24.setLineDash(t2);
    }
    _setShadow(e24) {
      if (!this.shadow) return;
      let t2 = this.shadow, n2 = this.canvas, r2 = this.getCanvasRetinaScaling(), [i2, , , a2] = (n2 == null ? void 0 : n2.viewportTransform) || T, s3 = i2 * r2, c2 = a2 * r2, l2 = t2.nonScaling ? new N(1, 1) : this.getObjectScaling();
      e24.shadowColor = t2.color, e24.shadowBlur = t2.blur * o.browserShadowBlurConstant * (s3 + c2) * (l2.x + l2.y) / 4, e24.shadowOffsetX = t2.offsetX * s3 * l2.x, e24.shadowOffsetY = t2.offsetY * c2 * l2.y;
    }
    _removeShadow(e24) {
      this.shadow && (e24.shadowColor = ``, e24.shadowBlur = e24.shadowOffsetX = e24.shadowOffsetY = 0);
    }
    _applyPatternGradientTransform(e24, t2) {
      if (!V(t2)) return { offsetX: 0, offsetY: 0 };
      let n2 = t2.gradientTransform || t2.patternTransform, r2 = -this.width / 2 + t2.offsetX || 0, i2 = -this.height / 2 + t2.offsetY || 0;
      return t2.gradientUnits === `percentage` ? e24.transform(this.width, 0, 0, this.height, r2, i2) : e24.transform(1, 0, 0, 1, r2, i2), n2 && e24.transform(n2[0], n2[1], n2[2], n2[3], n2[4], n2[5]), { offsetX: r2, offsetY: i2 };
    }
    _renderPaintInOrder(e24) {
      this.paintFirst === `stroke` ? (this._renderStroke(e24), this._renderFill(e24)) : (this._renderFill(e24), this._renderStroke(e24));
    }
    _render(e24) {
    }
    _renderFill(e24) {
      this.fill && (e24.save(), this._setFillStyles(e24, this), this.fillRule === `evenodd` ? e24.fill(`evenodd`) : e24.fill(), e24.restore());
    }
    _renderStroke(e24) {
      if (this.stroke && this.strokeWidth !== 0) {
        if (this.shadow && !this.shadow.affectStroke && this._removeShadow(e24), e24.save(), this.strokeUniform) {
          let t2 = this.getObjectScaling();
          e24.scale(1 / t2.x, 1 / t2.y);
        }
        this._setLineDash(e24, this.strokeDashArray), this._setStrokeStyles(e24, this), e24.stroke(), e24.restore();
      }
    }
    _applyPatternForTransformedGradient(e24, t2) {
      var n2;
      let r2 = this._limitCacheSize(this._getCacheCanvasDimensions()), i2 = this.getCanvasRetinaScaling(), a2 = r2.x / this.scaleX / i2, o2 = r2.y / this.scaleY / i2, s3 = F({ width: Math.ceil(a2), height: Math.ceil(o2) }), c2 = s3.getContext(`2d`);
      c2 && (c2.beginPath(), c2.moveTo(0, 0), c2.lineTo(a2, 0), c2.lineTo(a2, o2), c2.lineTo(0, o2), c2.closePath(), c2.translate(a2 / 2, o2 / 2), c2.scale(r2.zoomX / this.scaleX / i2, r2.zoomY / this.scaleY / i2), this._applyPatternGradientTransform(c2, t2), c2.fillStyle = t2.toLive(e24), c2.fill(), e24.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2), e24.scale(i2 * this.scaleX / r2.zoomX, i2 * this.scaleY / r2.zoomY), e24.strokeStyle = (n2 = c2.createPattern(s3, `no-repeat`)) == null ? `` : n2);
    }
    _findCenterFromElement() {
      return new N(this.left + this.width / 2, this.top + this.height / 2);
    }
    clone(e24) {
      let t2 = this.toObject(e24);
      return this.constructor.fromObject(t2);
    }
    cloneAsImage(e24) {
      let t2 = this.toCanvasElement(e24);
      return new (M.getClass(`image`))(t2);
    }
    toCanvasElement(e24 = {}) {
      let t2 = kt(this), n2 = this.group, r2 = this.shadow, i2 = Math.abs, a2 = e24.enableRetinaScaling ? v() : 1, o2 = (e24.multiplier || 1) * a2, s3 = e24.canvasProvider || ((e25) => new yt(e25, { enableRetinaScaling: false, renderOnAddRemove: false, skipOffscreen: false }));
      delete this.group, e24.withoutTransform && Ot(this), e24.withoutShadow && (this.shadow = null), e24.viewportTransform && Pt(this, this.getViewportTransform()), this.setCoords();
      let c2 = P(), l2 = this.getBoundingRect(), u2 = this.shadow, d2 = new N();
      if (u2) {
        let e25 = u2.blur, t3 = u2.nonScaling ? new N(1, 1) : this.getObjectScaling();
        d2.x = 2 * Math.round(i2(u2.offsetX) + e25) * i2(t3.x), d2.y = 2 * Math.round(i2(u2.offsetY) + e25) * i2(t3.y);
      }
      let f2 = l2.width + d2.x, p2 = l2.height + d2.y;
      c2.width = Math.ceil(f2), c2.height = Math.ceil(p2);
      let m = s3(c2);
      e24.format === `jpeg` && (m.backgroundColor = `#fff`), this.setPositionByOrigin(new N(m.width / 2, m.height / 2), E, E);
      let h2 = this.canvas;
      m._objects = [this], this.set(`canvas`, m), this.setCoords();
      let g2 = m.toCanvasElement(o2 || 1, e24);
      return this.set(`canvas`, h2), this.shadow = r2, n2 && (this.group = n2), this.set(t2), this.setCoords(), m._objects = [], m.destroy(), g2;
    }
    toDataURL(e24 = {}) {
      return Pe(this.toCanvasElement(e24), e24.format || `png`, e24.quality || 1);
    }
    toBlob(e24 = {}) {
      return Fe(this.toCanvasElement(e24), e24.format || `png`, e24.quality || 1);
    }
    isType(...e24) {
      return e24.includes(this.constructor.type) || e24.includes(this.type);
    }
    complexity() {
      return 1;
    }
    toJSON() {
      return this.toObject();
    }
    rotate(e24) {
      let { centeredRotation: t2, originX: n2, originY: r2 } = this;
      if (t2) {
        let { x: e25, y: t3 } = this.getRelativeCenterPoint();
        this.originX = E, this.originY = E, this.left = e25, this.top = t3;
      }
      if (this.set(`angle`, e24), t2) {
        let { x: e25, y: t3 } = this.getPositionByOrigin(n2, r2);
        this.left = e25, this.top = t3, this.originX = n2, this.originY = r2;
      }
    }
    setOnGroup() {
    }
    _setupCompositeOperation(e24) {
      this.globalCompositeOperation && (e24.globalCompositeOperation = this.globalCompositeOperation);
    }
    dispose() {
      ye.cancelByTarget(this), this.off(), this._set(`canvas`, void 0), this._cacheCanvas && h().dispose(this._cacheCanvas), this._cacheCanvas = void 0, this._cacheContext = null;
    }
    animate(e24, t2) {
      return Object.entries(e24).reduce((e25, [n2, r2]) => (e25[n2] = this._animate(n2, r2, t2), e25), {});
    }
    _animate(e24, t2, n2 = {}) {
      let r2 = e24.split(`.`), i2 = this.constructor.colorProperties.includes(r2[r2.length - 1]), { abort: a2, startValue: o2, onChange: s3, onComplete: c2 } = n2, l2 = { ...n2, target: this, startValue: o2 == null ? r2.reduce((e25, t3) => e25[t3], this) : o2, endValue: t2, abort: a2 == null ? void 0 : a2.bind(this), onChange: (e25, t3, n3) => {
        r2.reduce((t4, n4, i3) => (i3 === r2.length - 1 && (t4[n4] = e25), t4[n4]), this), s3 && s3(e25, t3, n3);
      }, onComplete: (e25, t3, n3) => {
        this.setCoords(), c2 && c2(e25, t3, n3);
      } };
      return i2 ? Nr(l2) : Mr(l2);
    }
    isDescendantOf(e24) {
      let { parent: t2, group: n2 } = this;
      return t2 === e24 || n2 === e24 || !!t2 && t2.isDescendantOf(e24) || !!n2 && n2 !== t2 && n2.isDescendantOf(e24);
    }
    getAncestors() {
      let e24 = [], t2 = this;
      do
        t2 = t2.parent, t2 && e24.push(t2);
      while (t2);
      return e24;
    }
    findCommonAncestors(e24) {
      if (this === e24) return { fork: [], otherFork: [], common: [this, ...this.getAncestors()] };
      let t2 = this.getAncestors(), n2 = e24.getAncestors();
      if (t2.length === 0 && n2.length > 0 && this === n2[n2.length - 1]) return { fork: [], otherFork: [e24, ...n2.slice(0, n2.length - 1)], common: [this] };
      for (let r2, i2 = 0; i2 < t2.length; i2++) {
        if (r2 = t2[i2], r2 === e24) return { fork: [this, ...t2.slice(0, i2)], otherFork: [], common: t2.slice(i2) };
        for (let a2 = 0; a2 < n2.length; a2++) {
          if (this === n2[a2]) return { fork: [], otherFork: [e24, ...n2.slice(0, a2)], common: [this, ...t2] };
          if (r2 === n2[a2]) return { fork: [this, ...t2.slice(0, i2)], otherFork: [e24, ...n2.slice(0, a2)], common: t2.slice(i2) };
        }
      }
      return { fork: [this, ...t2], otherFork: [e24, ...n2], common: [] };
    }
    hasCommonAncestors(e24) {
      let t2 = this.findCommonAncestors(e24);
      return t2 && !!t2.common.length;
    }
    isInFrontOf(e24) {
      if (this === e24) return;
      let t2 = this.findCommonAncestors(e24);
      if (t2.fork.includes(e24)) return true;
      if (t2.otherFork.includes(this)) return false;
      let n2 = t2.common[0] || this.canvas;
      if (!n2) return;
      let r2 = t2.fork.pop(), i2 = t2.otherFork.pop(), a2 = n2._objects.indexOf(r2), o2 = n2._objects.indexOf(i2);
      return a2 > -1 && a2 > o2;
    }
    toObject(t2 = []) {
      let n2 = t2.concat(e7.customProperties, this.constructor.customProperties || []), r2, i2 = o.NUM_FRACTION_DIGITS, { clipPath: a2, fill: s3, stroke: c2, shadow: l2, strokeDashArray: u2, left: d2, top: f2, originX: p2, originY: m, width: h2, height: g2, strokeWidth: _2, strokeLineCap: v2, strokeDashOffset: y2, strokeLineJoin: x2, strokeUniform: S2, strokeMiterLimit: C2, scaleX: w2, scaleY: ee2, angle: T2, flipX: E2, flipY: D2, opacity: O2, visible: k2, backgroundColor: te2, fillRule: ne2, paintFirst: re2, globalCompositeOperation: ie2, skewX: ae2, skewY: oe2 } = this;
      a2 && !a2.excludeFromExport && (r2 = a2.toObject(n2.concat(`inverted`, `absolutePositioned`)));
      let A2 = (e24) => B(e24, i2), se2 = { ...et(this, n2), type: this.constructor.type, version: b, originX: p2, originY: m, left: A2(d2), top: A2(f2), width: A2(h2), height: A2(g2), fill: rt(s3) ? s3.toObject() : s3, stroke: rt(c2) ? c2.toObject() : c2, strokeWidth: A2(_2), strokeDashArray: u2 && u2.concat(), strokeLineCap: v2, strokeDashOffset: y2, strokeLineJoin: x2, strokeUniform: S2, strokeMiterLimit: A2(C2), scaleX: A2(w2), scaleY: A2(ee2), angle: A2(T2), flipX: E2, flipY: D2, opacity: A2(O2), shadow: l2 && l2.toObject(), visible: k2, backgroundColor: te2, fillRule: ne2, paintFirst: re2, globalCompositeOperation: ie2, skewX: A2(ae2), skewY: A2(oe2), ...r2 ? { clipPath: r2 } : null };
      return this.includeDefaultValues ? se2 : this._removeDefaultValues(se2);
    }
    toDatalessObject(e24) {
      return this.toObject(e24);
    }
    _removeDefaultValues(e24) {
      let t2 = this.constructor.getDefaults(), n2 = Object.keys(t2).length > 0 ? t2 : Object.getPrototypeOf(this);
      return tt(e24, (e25, t3) => {
        if (t3 === `left` || t3 === `top` || t3 === `type`) return true;
        let r2 = n2[t3];
        return e25 !== r2 && !(Array.isArray(e25) && Array.isArray(r2) && e25.length === 0 && r2.length === 0);
      });
    }
    toString() {
      return `#<${this.constructor.type}>`;
    }
    static _fromObject({ type: e24, ...t2 }, { extraParam: n2, ...r2 } = {}) {
      return $e(t2, r2).then((e25) => n2 ? (delete e25[n2], new this(t2[n2], e25)) : new this(e25));
    }
    static fromObject(e24, t2) {
      return this._fromObject(e24, t2);
    }
  };
  i(Ir, `stateProperties`, Hn), i(Ir, `cacheProperties`, Un), i(Ir, `ownDefaults`, Wn), i(Ir, `type`, `FabricObject`), i(Ir, `colorProperties`, [j, he, `backgroundColor`]), i(Ir, `customProperties`, []), M.setClass(Ir), M.setClass(Ir, `object`);
  var Lr = (e24, t2) => {
    var n2;
    let { transform: { target: r2 } } = t2;
    (n2 = r2.canvas) == null || n2.fire(`object:${e24}`, { ...t2, target: r2 }), r2.fire(e24, t2);
  };
  var Rr = (e24, t2, n2) => (r2, i2, a2, o2) => {
    let s3 = t2(r2, i2, a2, o2);
    return s3 && Lr(e24, { ...Qt(r2, i2, a2, o2), ...n2 }), s3;
  };
  function zr(e24) {
    return (t2, n2, r2, i2) => {
      let { target: a2, originX: o2, originY: s3 } = n2, c2 = a2.getPositionByOrigin(o2, s3), l2 = e24(t2, n2, r2, i2);
      return a2.setPositionByOrigin(c2, n2.originX, n2.originY), l2;
    };
  }
  var Br = (e24, t2, n2, r2) => (i2, a2, o2, s3) => {
    let c2 = en(a2, a2.originX, a2.originY, o2, s3)[n2], l2 = W(a2[t2]);
    if (l2 === 0 || l2 > 0 && c2 < 0 || l2 < 0 && c2 > 0) {
      let { target: t3 } = a2, n3 = t3.strokeWidth / (t3.strokeUniform ? t3[r2] : 1), i3 = Yt(a2) ? 2 : 1, o3 = t3[e24], s4 = Math.abs(c2 * i3 / t3[r2]) - n3;
      return t3.set(e24, Math.max(s4, 1)), o3 !== t3[e24];
    }
    return false;
  };
  var Vr = Br(`width`, `originX`, `x`, `scaleX`);
  var Hr = Br(`height`, `originY`, `y`, `scaleY`);
  var Ur = Rr(se, zr(Vr));
  var Wr = Rr(se, zr(Hr));
  function Gr(e24, t2, n2, r2, i2) {
    e24.save();
    let { stroke: a2, xSize: o2, ySize: s3, opName: c2 } = this.commonRenderProps(e24, t2, n2, i2, r2), l2 = o2;
    o2 > s3 ? e24.scale(1, s3 / o2) : s3 > o2 && (l2 = s3, e24.scale(o2 / s3, 1)), e24.beginPath(), e24.arc(0, 0, l2 / 2, 0, w, false), e24[c2](), a2 && e24.stroke(), e24.restore();
  }
  function Kr(e24, t2, n2, r2, i2) {
    e24.save();
    let { stroke: a2, xSize: o2, ySize: s3, opName: c2 } = this.commonRenderProps(e24, t2, n2, i2, r2), l2 = o2 / 2, u2 = s3 / 2;
    e24[`${c2}Rect`](-l2, -u2, o2, s3), a2 && e24.strokeRect(-l2, -u2, o2, s3), e24.restore();
  }
  var q = class {
    constructor(e24) {
      i(this, `visible`, true), i(this, `actionName`, ue), i(this, `angle`, 0), i(this, `x`, 0), i(this, `y`, 0), i(this, `offsetX`, 0), i(this, `offsetY`, 0), i(this, `sizeX`, 0), i(this, `sizeY`, 0), i(this, `touchSizeX`, 0), i(this, `touchSizeY`, 0), i(this, `cursorStyle`, `crosshair`), i(this, `withConnection`, false), Object.assign(this, e24);
    }
    getTransformAnchorPoint() {
      var e24;
      return (e24 = this.transformAnchorPoint) == null ? new N(0.5 - this.x, 0.5 - this.y) : e24;
    }
    shouldActivate(e24, t2, n2, { tl: r2, tr: i2, br: a2, bl: o2 }) {
      var s3;
      return ((s3 = t2.canvas) == null ? void 0 : s3.getActiveObject()) === t2 && t2.isControlVisible(e24) && Pr.isPointInPolygon(n2, [r2, i2, a2, o2]);
    }
    getActionHandler(e24, t2, n2) {
      return this.actionHandler;
    }
    getMouseDownHandler(e24, t2, n2) {
      return this.mouseDownHandler;
    }
    getMouseUpHandler(e24, t2, n2) {
      return this.mouseUpHandler;
    }
    cursorStyleHandler(e24, t2, n2, r2) {
      return t2.cursorStyle;
    }
    getActionName(e24, t2, n2) {
      return t2.actionName;
    }
    getVisibility(e24, t2) {
      var n2, r2;
      return (n2 = (r2 = e24._controlsVisibility) == null ? void 0 : r2[t2]) == null ? this.visible : n2;
    }
    setVisibility(e24, t2, n2) {
      this.visible = e24;
    }
    positionHandler(e24, t2, n2, r2) {
      return new N(this.x * e24.x + this.offsetX, this.y * e24.y + this.offsetY).transform(t2);
    }
    calcCornerCoords(e24, t2, n2, r2, i2, a2) {
      let o2 = Re([Ue(n2, r2), We({ angle: e24 }), Ge((i2 ? this.touchSizeX : this.sizeX) || t2, (i2 ? this.touchSizeY : this.sizeY) || t2)]);
      return { tl: new N(-0.5, -0.5).transform(o2), tr: new N(0.5, -0.5).transform(o2), br: new N(0.5, 0.5).transform(o2), bl: new N(-0.5, 0.5).transform(o2) };
    }
    commonRenderProps(e24, t2, n2, r2, i2 = {}) {
      let { cornerSize: a2, cornerColor: o2, transparentCorners: s3, cornerStrokeColor: c2 } = i2, l2 = a2 || r2.cornerSize, u2 = this.sizeX || l2, d2 = this.sizeY || l2, f2 = s3 === void 0 ? r2.transparentCorners : s3, p2 = f2 ? he : j, m = c2 || r2.cornerStrokeColor, h2 = !f2 && !!m;
      return e24.fillStyle = o2 || r2.cornerColor || ``, e24.strokeStyle = m || ``, e24.translate(t2, n2), e24.rotate(I(r2.getTotalAngle())), { stroke: h2, xSize: u2, ySize: d2, transparentCorners: f2, opName: p2 };
    }
    render(e24, t2, n2, r2, i2) {
      ((r2 = r2 || {}).cornerStyle || i2.cornerStyle) === `circle` ? Gr.call(this, e24, t2, n2, r2, i2) : Kr.call(this, e24, t2, n2, r2, i2);
    }
  };
  var qr = (e24, t2, n2) => n2.lockRotation ? Jt : t2.cursorStyle;
  var Jr = Rr(ae, zr((e24, { target: t2, ex: n2, ey: r2, theta: i2, originX: a2, originY: o2 }, s3, c2) => {
    let l2 = t2.getPositionByOrigin(a2, o2);
    if (Zt(t2, `lockRotation`)) return false;
    let u2 = Math.atan2(r2 - l2.y, n2 - l2.x), d2 = Ie(Math.atan2(c2 - l2.y, s3 - l2.x) - u2 + i2);
    if (t2.snapAngle && t2.snapAngle > 0) {
      let e25 = t2.snapAngle, n3 = t2.snapThreshold || e25, r3 = Math.ceil(d2 / e25) * e25, i3 = Math.floor(d2 / e25) * e25;
      Math.abs(d2 - i3) < n3 ? d2 = i3 : Math.abs(d2 - r3) < n3 && (d2 = r3);
    }
    d2 < 0 && (d2 = 360 + d2), d2 %= 360;
    let f2 = t2.angle !== d2;
    return t2.angle = d2, f2;
  }));
  function Yr(e24, t2) {
    let n2 = t2.canvas, r2 = e24[n2.uniScaleKey];
    return n2.uniformScaling && !r2 || !n2.uniformScaling && r2;
  }
  function Xr(e24, t2, n2) {
    let r2 = Zt(e24, `lockScalingX`), i2 = Zt(e24, `lockScalingY`);
    if (r2 && i2 || !t2 && (r2 || i2) && n2 || r2 && t2 === `x` || i2 && t2 === `y`) return true;
    let { width: a2, height: o2, strokeWidth: s3 } = e24;
    return a2 === 0 && s3 === 0 && t2 !== `y` || o2 === 0 && s3 === 0 && t2 !== `x`;
  }
  var Zr = [`e`, `se`, `s`, `sw`, `w`, `nw`, `n`, `ne`, `e`];
  var Qr = (e24, t2, n2, r2) => {
    let i2 = Yr(e24, n2);
    return Xr(n2, t2.x !== 0 && t2.y === 0 ? `x` : t2.x === 0 && t2.y !== 0 ? `y` : ``, i2) ? Jt : `${Zr[$t(n2, 0, r2)]}-resize`;
  };
  function $r(e24, t2, n2, r2, i2 = {}) {
    let a2 = t2.target, o2 = i2.by, s3 = Yr(e24, a2), c2, l2, u2, d2, f2, p2;
    if (Xr(a2, o2, s3)) return false;
    if (t2.gestureScale) l2 = t2.scaleX * t2.gestureScale, u2 = t2.scaleY * t2.gestureScale;
    else {
      if (c2 = en(t2, t2.originX, t2.originY, n2, r2), f2 = o2 === `y` ? 1 : Math.sign(c2.x || t2.signX || 1), p2 = o2 === `x` ? 1 : Math.sign(c2.y || t2.signY || 1), t2.signX || (t2.signX = f2), t2.signY || (t2.signY = p2), Zt(a2, `lockScalingFlip`) && (t2.signX !== f2 || t2.signY !== p2)) return false;
      if (d2 = a2._getTransformedDimensions(), s3 && !o2) {
        let e25 = Math.abs(c2.x) + Math.abs(c2.y), { original: n3 } = t2, r3 = e25 / (Math.abs(d2.x * n3.scaleX / a2.scaleX) + Math.abs(d2.y * n3.scaleY / a2.scaleY));
        l2 = n3.scaleX * r3, u2 = n3.scaleY * r3;
      } else l2 = Math.abs(c2.x * a2.scaleX / d2.x), u2 = Math.abs(c2.y * a2.scaleY / d2.y);
      Yt(t2) && (l2 *= 2, u2 *= 2), t2.signX !== f2 && o2 !== `y` && (t2.originX = Xt(t2.originX), l2 *= -1, t2.signX = f2), t2.signY !== p2 && o2 !== `x` && (t2.originY = Xt(t2.originY), u2 *= -1, t2.signY = p2);
    }
    let m = a2.scaleX, h2 = a2.scaleY;
    return o2 ? (o2 === `x` && a2.set(`scaleX`, l2), o2 === `y` && a2.set(`scaleY`, u2)) : (!Zt(a2, `lockScalingX`) && a2.set(`scaleX`, l2), !Zt(a2, `lockScalingY`) && a2.set(`scaleY`, u2)), m !== a2.scaleX || h2 !== a2.scaleY;
  }
  var ei = Rr(ie, zr((e24, t2, n2, r2) => $r(e24, t2, n2, r2)));
  var ti = Rr(ie, zr((e24, t2, n2, r2) => $r(e24, t2, n2, r2, { by: `x` })));
  var ni = Rr(ie, zr((e24, t2, n2, r2) => $r(e24, t2, n2, r2, { by: `y` })));
  var ri = { x: { counterAxis: `y`, scale: de, skew: pe, lockSkewing: `lockSkewingX`, origin: `originX`, flip: `flipX` }, y: { counterAxis: `x`, scale: fe, skew: me, lockSkewing: `lockSkewingY`, origin: `originY`, flip: `flipY` } };
  var ii = [`ns`, `nesw`, `ew`, `nwse`];
  var ai = (e24, t2, n2, r2) => t2.x !== 0 && Zt(n2, `lockSkewingY`) || t2.y !== 0 && Zt(n2, `lockSkewingX`) ? Jt : `${ii[$t(n2, 0, r2) % 4]}-resize`;
  function oi(e24, t2, n2, r2, i2) {
    let { target: a2 } = n2, { counterAxis: o2, origin: s3, lockSkewing: c2, skew: l2, flip: u2 } = ri[e24];
    if (Zt(a2, c2)) return false;
    let { origin: d2, flip: f2 } = ri[o2], p2 = W(n2[d2]) * (a2[f2] ? -1 : 1), m = -Math.sign(p2) * (a2[u2] ? -1 : 1), h2 = -(a2[l2] === 0 && en(n2, `center`, `center`, r2, i2)[e24] > 0 || a2[l2] > 0 ? 1 : -1) * m * 0.5 + 0.5;
    return Rr(A, zr((t3, n3, r3, i3) => function(e25, { target: t4, ex: n4, ey: r4, skewingSide: i4, ...a3 }, o3) {
      let { skew: s4 } = ri[e25], c3 = o3.subtract(new N(n4, r4)).divide(new N(t4.scaleX, t4.scaleY))[e25], l3 = t4[s4], u3 = a3[s4], d3 = Math.tan(I(u3)), f3 = e25 === `y` ? t4._getTransformedDimensions({ scaleX: 1, scaleY: 1, skewX: 0 }).x : t4._getTransformedDimensions({ scaleX: 1, scaleY: 1 }).y, p3 = 2 * c3 * i4 / Math.max(f3, 1) + d3, m2 = Ie(Math.atan(p3));
      t4.set(s4, m2);
      let h3 = l3 !== t4[s4];
      if (h3 && e25 === `y`) {
        let { skewX: e26, scaleX: n5 } = t4, r5 = t4._getTransformedDimensions({ skewY: l3 }), i5 = t4._getTransformedDimensions(), a4 = e26 === 0 ? 1 : r5.x / i5.x;
        a4 !== 1 && t4.set(`scaleX`, a4 * n5);
      }
      return h3;
    }(e24, n3, new N(r3, i3))))(t2, { ...n2, [s3]: h2, skewingSide: m }, r2, i2);
  }
  var si = (e24, t2, n2, r2) => oi(`x`, e24, t2, n2, r2);
  var ci = (e24, t2, n2, r2) => oi(`y`, e24, t2, n2, r2);
  function li(e24, t2) {
    return e24[t2.canvas.altActionKey];
  }
  var ui = (e24, t2, n2) => {
    let r2 = li(e24, n2);
    return t2.x === 0 ? r2 ? pe : fe : t2.y === 0 ? r2 ? me : de : ``;
  };
  var di = (e24, t2, n2, r2) => li(e24, n2) ? ai(0, t2, n2, r2) : Qr(e24, t2, n2, r2);
  var fi = (e24, t2, n2, r2) => li(e24, t2.target) ? ci(e24, t2, n2, r2) : ti(e24, t2, n2, r2);
  var pi = (e24, t2, n2, r2) => li(e24, t2.target) ? si(e24, t2, n2, r2) : ni(e24, t2, n2, r2);
  var mi = () => ({ ml: new q({ x: -0.5, y: 0, cursorStyleHandler: di, actionHandler: fi, getActionName: ui }), mr: new q({ x: 0.5, y: 0, cursorStyleHandler: di, actionHandler: fi, getActionName: ui }), mb: new q({ x: 0, y: 0.5, cursorStyleHandler: di, actionHandler: pi, getActionName: ui }), mt: new q({ x: 0, y: -0.5, cursorStyleHandler: di, actionHandler: pi, getActionName: ui }), tl: new q({ x: -0.5, y: -0.5, cursorStyleHandler: Qr, actionHandler: ei }), tr: new q({ x: 0.5, y: -0.5, cursorStyleHandler: Qr, actionHandler: ei }), bl: new q({ x: -0.5, y: 0.5, cursorStyleHandler: Qr, actionHandler: ei }), br: new q({ x: 0.5, y: 0.5, cursorStyleHandler: Qr, actionHandler: ei }), mtr: new q({ x: 0, y: -0.5, actionHandler: Jr, cursorStyleHandler: qr, offsetY: -40, withConnection: true, actionName: oe }) });
  var hi = () => ({ mr: new q({ x: 0.5, y: 0, actionHandler: Ur, cursorStyleHandler: di, actionName: se }), ml: new q({ x: -0.5, y: 0, actionHandler: Ur, cursorStyleHandler: di, actionName: se }) });
  var gi = () => ({ ...mi(), ...hi() });
  var _i = class e8 extends Ir {
    static getDefaults() {
      return { ...super.getDefaults(), ...e8.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, this.constructor.createControls(), e8.ownDefaults), this.setOptions(t2);
    }
    static createControls() {
      return { controls: mi() };
    }
    _updateCacheCanvas() {
      let e24 = this.canvas;
      if (this.noScaleCache && e24 && e24._currentTransform) {
        let t2 = e24._currentTransform, n2 = t2.target, r2 = t2.action;
        if (this === n2 && r2 && r2.startsWith(`scale`)) return false;
      }
      return super._updateCacheCanvas();
    }
    getActiveControl() {
      let e24 = this.__corner;
      return e24 ? { key: e24, control: this.controls[e24], coord: this.oCoords[e24] } : void 0;
    }
    findControl(e24, t2 = false) {
      if (!this.hasControls || !this.canvas) return;
      this.__corner = void 0;
      let n2 = Object.entries(this.oCoords);
      for (let r2 = n2.length - 1; r2 >= 0; r2--) {
        let [i2, a2] = n2[r2], o2 = this.controls[i2];
        if (o2.shouldActivate(i2, this, e24, t2 ? a2.touchCorner : a2.corner)) return this.__corner = i2, { key: i2, control: o2, coord: this.oCoords[i2] };
      }
    }
    calcOCoords() {
      let e24 = this.getViewportTransform(), t2 = Be(e24), n2 = Ve(e24), r2 = this.getCenterPoint(), i2 = z(z(e24, z(Ue(r2.x, r2.y), We({ angle: this.getTotalAngle() - (this.group && this.flipX ? 180 : 0) }))), [1 / t2, 0, 0, 1 / n2, 0, 0]), a2 = this.group ? He(this.calcTransformMatrix()) : void 0;
      a2 && (a2.scaleX = Math.abs(a2.scaleX), a2.scaleY = Math.abs(a2.scaleY));
      let o2 = this._calculateCurrentDimensions(a2), s3 = {};
      return this.forEachControl((e25, t3) => {
        let n3 = e25.positionHandler(o2, i2, this, e25);
        s3[t3] = Object.assign(n3, this._calcCornerCoords(e25, n3));
      }), s3;
    }
    _calcCornerCoords(e24, t2) {
      let n2 = this.getTotalAngle();
      return { corner: e24.calcCornerCoords(n2, this.cornerSize, t2.x, t2.y, false, this), touchCorner: e24.calcCornerCoords(n2, this.touchCornerSize, t2.x, t2.y, true, this) };
    }
    setCoords() {
      super.setCoords(), this.canvas && (this.oCoords = this.calcOCoords());
    }
    forEachControl(e24) {
      for (let t2 in this.controls) e24(this.controls[t2], t2, this);
    }
    drawSelectionBackground(e24) {
      if (!this.selectionBackgroundColor || this.canvas && this.canvas._activeObject !== this) return;
      e24.save();
      let t2 = this.getRelativeCenterPoint(), n2 = this._calculateCurrentDimensions(), r2 = this.getViewportTransform();
      e24.translate(t2.x, t2.y), e24.scale(1 / r2[0], 1 / r2[3]), e24.rotate(I(this.angle)), e24.fillStyle = this.selectionBackgroundColor, e24.fillRect(-n2.x / 2, -n2.y / 2, n2.x, n2.y), e24.restore();
    }
    strokeBorders(e24, t2) {
      e24.strokeRect(-t2.x / 2, -t2.y / 2, t2.x, t2.y);
    }
    _drawBorders(e24, t2, n2 = {}) {
      let r2 = { hasControls: this.hasControls, borderColor: this.borderColor, borderDashArray: this.borderDashArray, ...n2 };
      e24.save(), e24.strokeStyle = r2.borderColor, this._setLineDash(e24, r2.borderDashArray), this.strokeBorders(e24, t2), r2.hasControls && this.drawControlsConnectingLines(e24, t2), e24.restore();
    }
    _renderControls(e24, t2 = {}) {
      let { hasBorders: n2, hasControls: r2 } = this, i2 = { hasBorders: n2, hasControls: r2, ...t2 }, a2 = this.getViewportTransform(), o2 = i2.hasBorders, s3 = i2.hasControls, c2 = He(z(a2, this.calcTransformMatrix()));
      e24.save(), e24.translate(c2.translateX, c2.translateY), e24.lineWidth = this.borderScaleFactor, this.group === this.parent && (e24.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1), this.flipX && (c2.angle -= 180);
      let l2 = ze(a2);
      e24.rotate(this.group ? I(c2.angle) : I(this.angle) + l2), o2 && this.drawBorders(e24, c2, t2), s3 && this.drawControls(e24, t2), e24.restore();
    }
    drawBorders(e24, t2, n2) {
      let r2;
      if (n2 && n2.forActiveSelection || this.group) {
        let e25 = At(this.width, this.height, Ye(t2)), n3 = this.isStrokeAccountedForInDimensions() ? we : (this.strokeUniform ? new N().scalarAdd(this.canvas ? this.canvas.getZoom() : 1) : new N(t2.scaleX, t2.scaleY)).scalarMultiply(this.strokeWidth);
        r2 = e25.add(n3).scalarAdd(this.borderScaleFactor).scalarAdd(2 * this.padding);
      } else r2 = this._calculateCurrentDimensions().scalarAdd(this.borderScaleFactor);
      this._drawBorders(e24, r2, n2);
    }
    drawControlsConnectingLines(e24, t2) {
      let n2 = false;
      e24.beginPath(), this.forEachControl((r2, i2) => {
        r2.withConnection && r2.getVisibility(this, i2) && (n2 = true, e24.moveTo(r2.x * t2.x, r2.y * t2.y), e24.lineTo(r2.x * t2.x + r2.offsetX, r2.y * t2.y + r2.offsetY));
      }), n2 && e24.stroke();
    }
    drawControls(e24, t2 = {}) {
      e24.save();
      let n2 = this.getCanvasRetinaScaling(), { cornerStrokeColor: r2, cornerDashArray: i2, cornerColor: a2 } = this, o2 = { cornerStrokeColor: r2, cornerDashArray: i2, cornerColor: a2, ...t2 };
      e24.setTransform(n2, 0, 0, n2, 0, 0), e24.strokeStyle = e24.fillStyle = o2.cornerColor, this.transparentCorners || (e24.strokeStyle = o2.cornerStrokeColor), this._setLineDash(e24, o2.cornerDashArray), this.forEachControl((t3, n3) => {
        if (t3.getVisibility(this, n3)) {
          let r3 = this.oCoords[n3];
          t3.render(e24, r3.x, r3.y, o2, this);
        }
      }), e24.restore();
    }
    isControlVisible(e24) {
      return this.controls[e24] && this.controls[e24].getVisibility(this, e24);
    }
    setControlVisible(e24, t2) {
      this._controlsVisibility || (this._controlsVisibility = {}), this._controlsVisibility[e24] = t2;
    }
    setControlsVisibility(e24 = {}) {
      Object.entries(e24).forEach(([e25, t2]) => this.setControlVisible(e25, t2));
    }
    clearContextTop(e24) {
      if (!this.canvas) return;
      let t2 = this.canvas.contextTop;
      if (!t2) return;
      let n2 = this.canvas.viewportTransform;
      t2.save(), t2.transform(n2[0], n2[1], n2[2], n2[3], n2[4], n2[5]), this.transform(t2);
      let r2 = this.width + 4, i2 = this.height + 4;
      return t2.clearRect(-r2 / 2, -i2 / 2, r2, i2), e24 || t2.restore(), t2;
    }
    onDeselect(e24) {
      return false;
    }
    onSelect(e24) {
      return false;
    }
    shouldStartDragging(e24) {
      return false;
    }
    onDragStart(e24) {
      return false;
    }
    canDrop(e24) {
      return false;
    }
    renderDragSourceEffect(e24) {
    }
    renderDropTargetEffect(e24) {
    }
  };
  function vi(e24, t2) {
    return t2.forEach((t3) => {
      Object.getOwnPropertyNames(t3.prototype).forEach((n2) => {
        n2 !== `constructor` && Object.defineProperty(e24.prototype, n2, Object.getOwnPropertyDescriptor(t3.prototype, n2) || /* @__PURE__ */ Object.create(null));
      });
    }), e24;
  }
  i(_i, `ownDefaults`, { noScaleCache: true, lockMovementX: false, lockMovementY: false, lockRotation: false, lockScalingX: false, lockScalingY: false, lockSkewingX: false, lockSkewingY: false, lockScalingFlip: false, cornerSize: 13, touchCornerSize: 24, transparentCorners: true, cornerColor: `rgb(178,204,255)`, cornerStrokeColor: ``, cornerStyle: `rect`, cornerDashArray: null, hasControls: true, borderColor: `rgb(178,204,255)`, borderDashArray: null, borderOpacityWhenMoving: 0.4, borderScaleFactor: 1, hasBorders: true, selectionBackgroundColor: ``, selectable: true, evented: true, perPixelTargetFind: false, activeOn: `down`, hoverCursor: null, moveCursor: null });
  var J = class extends _i {
  };
  vi(J, [gn]), M.setClass(J), M.setClass(J, `object`);
  var yi = (e24, t2, n2, r2) => {
    let i2 = 2 * (r2 = Math.round(r2)) + 1, { data: a2 } = e24.getImageData(t2 - r2, n2 - r2, i2, i2);
    for (let e25 = 3; e25 < a2.length; e25 += 4) if (a2[e25] > 0) return false;
    return true;
  };
  var bi = class {
    constructor(e24) {
      this.options = e24, this.strokeProjectionMagnitude = this.options.strokeWidth / 2, this.scale = new N(this.options.scaleX, this.options.scaleY), this.strokeUniformScalar = this.options.strokeUniform ? new N(1 / this.options.scaleX, 1 / this.options.scaleY) : new N(1, 1);
    }
    createSideVector(e24, t2) {
      let n2 = zt(e24, t2);
      return this.options.strokeUniform ? n2.multiply(this.scale) : n2;
    }
    projectOrthogonally(e24, t2, n2) {
      return this.applySkew(e24.add(this.calcOrthogonalProjection(e24, t2, n2)));
    }
    isSkewed() {
      return this.options.skewX !== 0 || this.options.skewY !== 0;
    }
    applySkew(e24) {
      let t2 = new N(e24);
      return t2.y += t2.x * Math.tan(I(this.options.skewY)), t2.x += t2.y * Math.tan(I(this.options.skewX)), t2;
    }
    scaleUnitVector(e24, t2) {
      return e24.multiply(this.strokeUniformScalar).scalarMultiply(t2);
    }
  };
  var xi = new N();
  var Si = class e9 extends bi {
    static getOrthogonalRotationFactor(e24, t2) {
      let n2 = t2 ? Vt(e24, t2) : Ht(e24);
      return Math.abs(n2) < S ? -1 : 1;
    }
    constructor(e24, t2, n2, r2) {
      super(r2), i(this, `AB`, void 0), i(this, `AC`, void 0), i(this, `alpha`, void 0), i(this, `bisector`, void 0), this.A = new N(e24), this.B = new N(t2), this.C = new N(n2), this.AB = this.createSideVector(this.A, this.B), this.AC = this.createSideVector(this.A, this.C), this.alpha = Vt(this.AB, this.AC), this.bisector = Ut(Rt(this.AB.eq(xi) ? this.AC : this.AB, this.alpha / 2));
    }
    calcOrthogonalProjection(t2, n2, r2 = this.strokeProjectionMagnitude) {
      let i2 = Wt(this.createSideVector(t2, n2)), a2 = e9.getOrthogonalRotationFactor(i2, this.bisector);
      return this.scaleUnitVector(i2, r2 * a2);
    }
    projectBevel() {
      let e24 = [];
      return (this.alpha % w === 0 ? [this.B] : [this.B, this.C]).forEach((t2) => {
        e24.push(this.projectOrthogonally(this.A, t2)), e24.push(this.projectOrthogonally(this.A, t2, -this.strokeProjectionMagnitude));
      }), e24;
    }
    projectMiter() {
      let e24 = [], t2 = Math.abs(this.alpha), n2 = 1 / Math.sin(t2 / 2), r2 = this.scaleUnitVector(this.bisector, -this.strokeProjectionMagnitude * n2), i2 = this.options.strokeUniform ? Bt(this.scaleUnitVector(this.bisector, this.options.strokeMiterLimit)) : this.options.strokeMiterLimit;
      return Bt(r2) / this.strokeProjectionMagnitude <= i2 && e24.push(this.applySkew(this.A.add(r2))), e24.push(...this.projectBevel()), e24;
    }
    projectRoundNoSkew(t2, n2) {
      let r2 = [], i2 = new N(e9.getOrthogonalRotationFactor(this.bisector), e9.getOrthogonalRotationFactor(new N(this.bisector.y, this.bisector.x)));
      return [new N(1, 0).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(i2), new N(0, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(i2)].forEach((e24) => {
        qt(e24, t2, n2) && r2.push(this.A.add(e24));
      }), r2;
    }
    projectRoundWithSkew(e24, t2) {
      let n2 = [], { skewX: r2, skewY: i2, scaleX: a2, scaleY: o2, strokeUniform: s3 } = this.options, c2 = new N(Math.tan(I(r2)), Math.tan(I(i2))), l2 = this.strokeProjectionMagnitude, u2 = s3 ? l2 / o2 / Math.sqrt(1 / o2 ** 2 + 1 / a2 ** 2 * c2.y ** 2) : l2 / Math.sqrt(1 + c2.y ** 2), d2 = new N(Math.sqrt(Math.max(l2 ** 2 - u2 ** 2, 0)), u2), f2 = s3 ? l2 / Math.sqrt(1 + c2.x ** 2 * (1 / o2) ** 2 / (1 / a2 + 1 / a2 * c2.x * c2.y) ** 2) : l2 / Math.sqrt(1 + c2.x ** 2 / (1 + c2.x * c2.y) ** 2), p2 = new N(f2, Math.sqrt(Math.max(l2 ** 2 - f2 ** 2, 0)));
      return [p2, p2.scalarMultiply(-1), d2, d2.scalarMultiply(-1)].map((e25) => this.applySkew(s3 ? e25.multiply(this.strokeUniformScalar) : e25)).forEach((r3) => {
        qt(r3, e24, t2) && n2.push(this.applySkew(this.A).add(r3));
      }), n2;
    }
    projectRound() {
      let e24 = [];
      e24.push(...this.projectBevel());
      let t2 = this.alpha % w === 0, n2 = this.applySkew(this.A), r2 = e24[t2 ? 0 : 2].subtract(n2), i2 = e24[+!!t2].subtract(n2), a2 = Gt(r2, t2 ? this.applySkew(this.AB.scalarMultiply(-1)) : this.applySkew(this.bisector.multiply(this.strokeUniformScalar).scalarMultiply(-1))) > 0, o2 = a2 ? r2 : i2, s3 = a2 ? i2 : r2;
      return this.isSkewed() ? e24.push(...this.projectRoundWithSkew(o2, s3)) : e24.push(...this.projectRoundNoSkew(o2, s3)), e24;
    }
    projectPoints() {
      switch (this.options.strokeLineJoin) {
        case `miter`:
          return this.projectMiter();
        case `round`:
          return this.projectRound();
        default:
          return this.projectBevel();
      }
    }
    project() {
      return this.projectPoints().map((e24) => ({ originPoint: this.A, projectedPoint: e24, angle: this.alpha, bisector: this.bisector }));
    }
  };
  var Ci = class extends bi {
    constructor(e24, t2, n2) {
      super(n2), this.A = new N(e24), this.T = new N(t2);
    }
    calcOrthogonalProjection(e24, t2, n2 = this.strokeProjectionMagnitude) {
      let r2 = this.createSideVector(e24, t2);
      return this.scaleUnitVector(Wt(r2), n2);
    }
    projectButt() {
      return [this.projectOrthogonally(this.A, this.T, this.strokeProjectionMagnitude), this.projectOrthogonally(this.A, this.T, -this.strokeProjectionMagnitude)];
    }
    projectRound() {
      let e24 = [];
      if (!this.isSkewed() && this.A.eq(this.T)) {
        let t2 = new N(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
        e24.push(this.applySkew(this.A.add(t2)), this.applySkew(this.A.subtract(t2)));
      } else e24.push(...new Si(this.A, this.T, this.T, this.options).projectRound());
      return e24;
    }
    projectSquare() {
      let e24 = [];
      if (this.A.eq(this.T)) {
        let t2 = new N(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
        e24.push(this.A.add(t2), this.A.subtract(t2));
      } else {
        let t2 = this.calcOrthogonalProjection(this.A, this.T, this.strokeProjectionMagnitude), n2 = this.scaleUnitVector(Ut(this.createSideVector(this.A, this.T)), -this.strokeProjectionMagnitude), r2 = this.A.add(n2);
        e24.push(r2.add(t2), r2.subtract(t2));
      }
      return e24.map((e25) => this.applySkew(e25));
    }
    projectPoints() {
      switch (this.options.strokeLineCap) {
        case `round`:
          return this.projectRound();
        case `square`:
          return this.projectSquare();
        default:
          return this.projectButt();
      }
    }
    project() {
      return this.projectPoints().map((e24) => ({ originPoint: this.A, projectedPoint: e24 }));
    }
  };
  var wi = (e24, t2, n2 = false) => {
    let r2 = [];
    if (e24.length === 0) return r2;
    let i2 = e24.reduce((e25, t3) => (e25[e25.length - 1].eq(t3) || e25.push(new N(t3)), e25), [new N(e24[0])]);
    if (i2.length === 1) n2 = true;
    else if (!n2) {
      let e25 = i2[0], t3 = ((e26, t4) => {
        for (let n3 = e26.length - 1; n3 >= 0; n3--) if (t4(e26[n3], n3, e26)) return n3;
        return -1;
      })(i2, (t4) => !t4.eq(e25));
      i2.splice(t3 + 1);
    }
    return i2.forEach((e25, i3, a2) => {
      let o2, s3;
      i3 === 0 ? (s3 = a2[1], o2 = n2 ? e25 : a2[a2.length - 1]) : i3 === a2.length - 1 ? (o2 = a2[i3 - 1], s3 = n2 ? e25 : a2[0]) : (o2 = a2[i3 - 1], s3 = a2[i3 + 1]), n2 && a2.length === 1 ? r2.push(...new Ci(e25, e25, t2).project()) : !n2 || i3 !== 0 && i3 !== a2.length - 1 ? r2.push(...new Si(e25, o2, s3, t2).project()) : r2.push(...new Ci(e25, i3 === 0 ? s3 : o2, t2).project());
    }), r2;
  };
  var Ti = (e24) => {
    let t2 = {};
    return Object.keys(e24).forEach((n2) => {
      t2[n2] = {}, Object.keys(e24[n2]).forEach((r2) => {
        t2[n2][r2] = { ...e24[n2][r2] };
      });
    }), t2;
  };
  var Ei = (e24, t2, n2 = false) => e24.fill !== t2.fill || e24.stroke !== t2.stroke || e24.strokeWidth !== t2.strokeWidth || e24.fontSize !== t2.fontSize || e24.fontFamily !== t2.fontFamily || e24.fontWeight !== t2.fontWeight || e24.fontStyle !== t2.fontStyle || e24.textDecorationThickness !== t2.textDecorationThickness || e24.textDecorationColor !== t2.textDecorationColor || e24.textBackgroundColor !== t2.textBackgroundColor || e24.deltaY !== t2.deltaY || n2 && (e24.overline !== t2.overline || e24.underline !== t2.underline || e24.linethrough !== t2.linethrough);
  var Di = (e24, t2) => {
    let n2 = t2.split(`
`), r2 = [], i2 = -1, a2 = {};
    e24 = Ti(e24);
    for (let t3 = 0; t3 < n2.length; t3++) {
      let o2 = gt(n2[t3]);
      if (e24[t3]) for (let n3 = 0; n3 < o2.length; n3++) {
        i2++;
        let o3 = e24[t3][n3];
        o3 && Object.keys(o3).length > 0 && (Ei(a2, o3, true) ? r2.push({ start: i2, end: i2 + 1, style: o3 }) : r2[r2.length - 1].end++), a2 = o3 || {};
      }
      else i2 += o2.length, a2 = {};
    }
    return r2;
  };
  var Oi = (e24, t2) => {
    if (!Array.isArray(e24)) return Ti(e24);
    let n2 = t2.split(ne), r2 = {}, i2 = -1, a2 = 0;
    for (let t3 = 0; t3 < n2.length; t3++) {
      let o2 = gt(n2[t3]);
      for (let n3 = 0; n3 < o2.length; n3++) i2++, e24[a2] && e24[a2].start <= i2 && i2 < e24[a2].end && (r2[t3] = r2[t3] || {}, r2[t3][n3] = { ...e24[a2].style }, i2 === e24[a2].end - 1 && a2++);
    }
    return r2;
  };
  var ki = [`display`, `transform`, j, `fill-opacity`, `fill-rule`, `opacity`, he, `stroke-dasharray`, `stroke-linecap`, `stroke-dashoffset`, `stroke-linejoin`, `stroke-miterlimit`, `stroke-opacity`, `stroke-width`, `id`, `paint-order`, `vector-effect`, `instantiated_by_use`, `clip-path`];
  function Ai(e24, t2) {
    let n2 = e24.nodeName, r2 = e24.getAttribute(`class`), i2 = e24.getAttribute(`id`), a2 = `(?![a-zA-Z\\-]+)`, o2;
    if (o2 = RegExp(`^` + n2, `i`), t2 = t2.replace(o2, ``), i2 && t2.length && (o2 = RegExp(`#` + i2 + a2, `i`), t2 = t2.replace(o2, ``)), r2 && t2.length) {
      let e25 = r2.split(` `);
      for (let n3 = e25.length; n3--; ) o2 = RegExp(`\\.` + e25[n3] + a2, `i`), t2 = t2.replace(o2, ``);
    }
    return t2.length === 0;
  }
  function ji(e24, t2) {
    let n2 = true, r2 = Ai(e24, t2.pop());
    return r2 && t2.length && (n2 = function(e25, t3) {
      let n3, r3 = true;
      for (; e25.parentElement && e25.parentElement.nodeType === 1 && t3.length; ) r3 && (n3 = t3.pop()), r3 = Ai(e25 = e25.parentElement, n3);
      return t3.length === 0;
    }(e24, t2)), r2 && n2 && t2.length === 0;
  }
  function Mi(e24, t2 = {}) {
    let n2 = {};
    for (let r2 in t2) ji(e24, r2.split(` `)) && (n2 = { ...n2, ...t2[r2] });
    return n2;
  }
  var Ni = (e24) => {
    var t2;
    return (t2 = jn[e24]) == null ? e24 : t2;
  };
  var Pi = RegExp(`(${Dn})`, `gi`);
  var Y = `(${Dn})`;
  var Fi = String.raw`(skewX)\(${Y}\)`;
  var Ii = String.raw`(skewY)\(${Y}\)`;
  var Li = String.raw`(rotate)\(${Y}(?: ${Y} ${Y})?\)`;
  var Ri = String.raw`(scale)\(${Y}(?: ${Y})?\)`;
  var zi = String.raw`(translate)\(${Y}(?: ${Y})?\)`;
  var Bi = `(?:${String.raw`(matrix)\(${Y} ${Y} ${Y} ${Y} ${Y} ${Y}\)`}|${zi}|${Li}|${Ri}|${Fi}|${Ii})`;
  var Vi = `(?:${Bi}*)`;
  var Hi = String.raw`^\s*(?:${Vi}?)\s*$`;
  var Ui = new RegExp(Hi);
  var Wi = new RegExp(Bi);
  var Gi = new RegExp(Bi, `g`);
  function Ki(e24) {
    let t2 = [];
    if (!(e24 = ((e25) => on(e25.replace(Pi, ` $1 `).replace(/,/gi, ` `)))(e24).replace(/\s*([()])\s*/gi, `$1`)) || e24 && !Ui.test(e24)) return [...T];
    for (let n2 of e24.matchAll(Gi)) {
      let e25 = Wi.exec(n2[0]);
      if (!e25) continue;
      let r2 = T, [, i2, ...a2] = e25.filter((e26) => !!e26), [o2, s3, c2, l2, u2, d2] = a2.map((e26) => parseFloat(e26));
      switch (i2) {
        case `translate`:
          r2 = Ue(o2, s3);
          break;
        case oe:
          r2 = We({ angle: o2 }, { x: s3, y: c2 });
          break;
        case ue:
          r2 = Ge(o2, s3);
          break;
        case pe:
          r2 = qe(o2);
          break;
        case me:
          r2 = Je(o2);
          break;
        case `matrix`:
          r2 = [o2, s3, c2, l2, u2, d2];
      }
      t2.push(r2);
    }
    return Re(t2);
  }
  function qi(e24, t2, n2, r2) {
    let i2 = Array.isArray(t2), a2, o2 = t2;
    if (e24 !== `fill` && e24 !== `stroke` || t2 !== `none`) {
      if (e24 === `strokeUniform`) return t2 === `non-scaling-stroke`;
      if (e24 === `strokeDashArray`) o2 = t2 === `none` ? null : t2.replace(/,/g, ` `).split(/\s+/).map(parseFloat);
      else if (e24 === `transformMatrix`) o2 = n2 && n2.transformMatrix ? z(n2.transformMatrix, Ki(t2)) : Ki(t2);
      else if (e24 === `visible`) o2 = t2 !== `none` && t2 !== `hidden`, n2 && false === n2.visible && (o2 = false);
      else if (e24 === `opacity`) o2 = parseFloat(t2), n2 && n2.opacity !== void 0 && (o2 *= n2.opacity);
      else if (e24 === `textAnchor`) o2 = t2 === `start` ? D : t2 === `end` ? k : E;
      else if (e24 === `charSpacing` || e24 === `textDecorationThickness`) a2 = K(t2, r2) / r2 * 1e3;
      else if (e24 === `paintFirst`) {
        let e25 = t2.indexOf(j), n3 = t2.indexOf(he);
        o2 = j, (e25 > -1 && n3 > -1 && n3 < e25 || e25 === -1 && n3 > -1) && (o2 = he);
      } else {
        if (e24 === `href` || e24 === `xlink:href` || e24 === `font` || e24 === `id`) return t2;
        if (e24 === `imageSmoothing`) return t2 === `optimizeQuality`;
        a2 = i2 ? t2.map(K) : K(t2, r2);
      }
    } else o2 = ``;
    return !i2 && isNaN(a2) ? o2 : a2;
  }
  function Ji(e24, t2) {
    e24.replace(/;\s*$/, ``).split(`;`).forEach((e25) => {
      if (!e25) return;
      let [n2, r2] = e25.split(`:`);
      t2[n2.trim().toLowerCase()] = r2.trim();
    });
  }
  function Yi(e24) {
    let t2 = {}, n2 = e24.getAttribute(`style`);
    return n2 && (typeof n2 == `string` ? Ji(n2, t2) : function(e25, t3) {
      Object.entries(e25).forEach(([e26, n3]) => {
        n3 !== void 0 && (t3[e26.toLowerCase()] = n3);
      });
    }(n2, t2)), t2;
  }
  var Xi = { stroke: `strokeOpacity`, fill: `fillOpacity` };
  function Zi(e24, t2, n2) {
    if (!e24) return {};
    let r2, i2 = {}, a2 = 16;
    e24.parentNode && In.test(e24.parentNode.nodeName) && (i2 = Zi(e24.parentElement, t2, n2), i2.fontSize && (r2 = a2 = K(i2.fontSize)));
    let o2 = { ...t2.reduce((t3, n3) => {
      let r3 = e24.getAttribute(n3);
      return r3 && (t3[n3] = r3), t3;
    }, {}), ...Mi(e24, n2), ...Yi(e24) };
    o2[`clip-path`] && e24.setAttribute(Nn, o2[Nn]), o2[`font-size`] && (r2 = K(o2[Mn], a2), o2[Mn] = `${r2}`);
    let s3 = {};
    for (let e25 in o2) {
      let t3 = Ni(e25);
      s3[t3] = qi(t3, o2[e25], i2, r2);
    }
    s3 && s3.font && function(e25, t3) {
      let n3 = e25.match(An);
      if (!n3) return;
      let r3 = n3[1], i3 = n3[3], a3 = n3[4], o3 = n3[5], s4 = n3[6];
      r3 && (t3.fontStyle = r3), i3 && (t3.fontWeight = isNaN(parseFloat(i3)) ? i3 : parseFloat(i3)), a3 && (t3.fontSize = K(a3)), s4 && (t3.fontFamily = s4), o3 && (t3.lineHeight = o3 === `normal` ? 1 : o3);
    }(s3.font, s3);
    let c2 = { ...i2, ...s3 };
    return In.test(e24.nodeName) ? c2 : function(e25) {
      let t3 = J.getDefaults();
      return Object.entries(Xi).forEach(([n3, r3]) => {
        if (e25[r3] === void 0 || e25[n3] === ``) return;
        if (e25[n3] === void 0) {
          if (!t3[n3]) return;
          e25[n3] = t3[n3];
        }
        if (e25[n3].indexOf(`url(`) === 0) return;
        let i3 = new G(e25[n3]);
        e25[n3] = i3.setAlpha(B(i3.getAlpha() * e25[r3], 2)).toRgba();
      }), e25;
    }(c2);
  }
  var Qi = [`rx`, `ry`];
  var $i = class e10 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e10.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, e10.ownDefaults), this.setOptions(t2), this._initRxRy();
    }
    _initRxRy() {
      let { rx: e24, ry: t2 } = this;
      e24 && !t2 ? this.ry = e24 : t2 && !e24 && (this.rx = t2);
    }
    _render(e24) {
      let { width: t2, height: n2 } = this, r2 = -t2 / 2, i2 = -n2 / 2, a2 = this.rx ? Math.min(this.rx, t2 / 2) : 0, o2 = this.ry ? Math.min(this.ry, n2 / 2) : 0, s3 = a2 !== 0 || o2 !== 0;
      e24.beginPath(), e24.moveTo(r2 + a2, i2), e24.lineTo(r2 + t2 - a2, i2), s3 && e24.bezierCurveTo(r2 + t2 - 0.4477152502 * a2, i2, r2 + t2, i2 + 0.4477152502 * o2, r2 + t2, i2 + o2), e24.lineTo(r2 + t2, i2 + n2 - o2), s3 && e24.bezierCurveTo(r2 + t2, i2 + n2 - 0.4477152502 * o2, r2 + t2 - 0.4477152502 * a2, i2 + n2, r2 + t2 - a2, i2 + n2), e24.lineTo(r2 + a2, i2 + n2), s3 && e24.bezierCurveTo(r2 + 0.4477152502 * a2, i2 + n2, r2, i2 + n2 - 0.4477152502 * o2, r2, i2 + n2 - o2), e24.lineTo(r2, i2 + o2), s3 && e24.bezierCurveTo(r2, i2 + 0.4477152502 * o2, r2 + 0.4477152502 * a2, i2, r2 + a2, i2), e24.closePath(), this._renderPaintInOrder(e24);
    }
    toObject(e24 = []) {
      return super.toObject([...Qi, ...e24]);
    }
    _toSVG() {
      let { width: e24, height: t2, rx: n2, ry: r2 } = this;
      return [`<rect `, `COMMON_PARTS`, `x="${-e24 / 2}" y="${-t2 / 2}" rx="${U(n2)}" ry="${U(r2)}" width="${U(e24)}" height="${U(t2)}" />
`];
    }
    static async fromElement(e24, t2, n2) {
      let { left: r2 = 0, top: i2 = 0, width: a2 = 0, height: o2 = 0, visible: s3 = true, ...c2 } = Zi(e24, this.ATTRIBUTE_NAMES, n2);
      return new this({ ...t2, ...c2, left: r2, top: i2, width: a2, height: o2, visible: !!(s3 && a2 && o2) });
    }
  };
  i($i, `type`, `Rect`), i($i, `cacheProperties`, [...Un, ...Qi]), i($i, `ownDefaults`, { rx: 0, ry: 0 }), i($i, `ATTRIBUTE_NAMES`, [...ki, `x`, `y`, `rx`, `ry`, `width`, `height`]), M.setClass($i), M.setSVGClass($i);
  var ea = `initialization`;
  var ta = `added`;
  var na = (e24, t2) => {
    let { strokeUniform: n2, strokeWidth: r2, width: i2, height: a2, group: o2 } = t2, s3 = o2 && o2 !== e24 ? jt(o2.calcTransformMatrix(), e24.calcTransformMatrix()) : null, c2 = s3 ? t2.getRelativeCenterPoint().transform(s3) : t2.getRelativeCenterPoint(), l2 = !t2.isStrokeAccountedForInDimensions(), u2 = n2 && l2 ? Nt(new N(r2, r2), void 0, e24.calcTransformMatrix()) : we, d2 = !n2 && l2 ? r2 : 0, f2 = At(i2 + d2, a2 + d2, Re([s3, t2.calcOwnMatrix()], true)).add(u2).scalarDivide(2);
    return [c2.subtract(f2), c2.add(f2)];
  };
  var ra = class {
    calcLayoutResult(e24, t2) {
      if (this.shouldPerformLayout(e24)) return this.calcBoundingBox(t2, e24);
    }
    shouldPerformLayout({ type: e24, prevStrategy: t2, strategy: n2 }) {
      return e24 === `initialization` || e24 === `imperative` || !!t2 && n2 !== t2;
    }
    shouldLayoutClipPath({ type: e24, target: { clipPath: t2 } }) {
      return e24 !== `initialization` && t2 && !t2.absolutePositioned;
    }
    getInitialSize(e24, t2) {
      return t2.size;
    }
    calcBoundingBox(e24, t2) {
      let { type: n2, target: r2 } = t2;
      if (n2 === `imperative` && t2.overrides) return t2.overrides;
      if (e24.length === 0) return;
      let { left: i2, top: a2, width: o2, height: s3 } = wt(e24.map((e25) => na(r2, e25)).reduce((e25, t3) => e25.concat(t3), [])), c2 = new N(o2, s3), l2 = new N(i2, a2).add(c2.scalarDivide(2));
      if (n2 === `initialization`) {
        let e25 = this.getInitialSize(t2, { size: c2, center: l2 });
        return { center: l2, relativeCorrection: new N(0, 0), size: e25 };
      }
      return { center: l2.transform(r2.calcOwnMatrix()), size: c2 };
    }
  };
  i(ra, `type`, `strategy`);
  var ia = class extends ra {
    shouldPerformLayout(e24) {
      return true;
    }
  };
  i(ia, `type`, `fit-content`), M.setClass(ia);
  var aa = `layoutManager`;
  var oa = class {
    constructor(e24 = new ia()) {
      i(this, `strategy`, void 0), this.strategy = e24, this._subscriptions = /* @__PURE__ */ new Map();
    }
    performLayout(e24) {
      let t2 = { bubbles: true, strategy: this.strategy, ...e24, prevStrategy: this._prevLayoutStrategy, stopPropagation() {
        this.bubbles = false;
      } };
      this.onBeforeLayout(t2);
      let n2 = this.getLayoutResult(t2);
      n2 && this.commitLayout(t2, n2), this.onAfterLayout(t2, n2), this._prevLayoutStrategy = t2.strategy;
    }
    attachHandlers(e24, t2) {
      let { target: n2 } = t2;
      return [ge, re, se, ae, ie, A, le, ce, `modifyPath`].map((t3) => e24.on(t3, (e25) => this.performLayout(t3 === `modified` ? { type: `object_modified`, trigger: t3, e: e25, target: n2 } : { type: `object_modifying`, trigger: t3, e: e25, target: n2 })));
    }
    subscribe(e24, t2) {
      this.unsubscribe(e24, t2);
      let n2 = this.attachHandlers(e24, t2);
      this._subscriptions.set(e24, n2);
    }
    unsubscribe(e24, t2) {
      (this._subscriptions.get(e24) || []).forEach((e25) => e25()), this._subscriptions.delete(e24);
    }
    unsubscribeTargets(e24) {
      e24.targets.forEach((t2) => this.unsubscribe(t2, e24));
    }
    subscribeTargets(e24) {
      e24.targets.forEach((t2) => this.subscribe(t2, e24));
    }
    onBeforeLayout(e24) {
      let { target: t2, type: n2 } = e24, { canvas: r2 } = t2;
      if (n2 === `initialization` || n2 === `added` ? this.subscribeTargets(e24) : n2 === `removed` && this.unsubscribeTargets(e24), t2.fire(`layout:before`, { context: e24 }), r2 && r2.fire(`object:layout:before`, { target: t2, context: e24 }), n2 === `imperative` && e24.deep) {
        let { strategy: n3, ...r3 } = e24;
        t2.forEachObject((e25) => e25.layoutManager && e25.layoutManager.performLayout({ ...r3, bubbles: false, target: e25 }));
      }
    }
    getLayoutResult(e24) {
      let { target: t2, strategy: n2, type: r2 } = e24, i2 = n2.calcLayoutResult(e24, t2.getObjects());
      if (!i2) return;
      let a2 = r2 === `initialization` ? new N() : t2.getRelativeCenterPoint(), { center: o2, correction: s3 = new N(), relativeCorrection: c2 = new N() } = i2;
      return { result: i2, prevCenter: a2, nextCenter: o2, offset: a2.subtract(o2).add(s3).transform(r2 === `initialization` ? T : R(t2.calcOwnMatrix()), true).add(c2) };
    }
    commitLayout(e24, t2) {
      let { target: n2 } = e24, { result: { size: r2 }, nextCenter: i2 } = t2;
      var a2, o2;
      n2.set({ width: r2.x, height: r2.y }), this.layoutObjects(e24, t2), e24.type === `initialization` ? n2.set({ left: (a2 = e24.x) == null ? i2.x + r2.x * W(n2.originX) : a2, top: (o2 = e24.y) == null ? i2.y + r2.y * W(n2.originY) : o2 }) : (n2.setPositionByOrigin(i2, E, E), n2.setCoords(), n2.set(`dirty`, true));
    }
    layoutObjects(e24, t2) {
      let { target: n2 } = e24;
      n2.forEachObject((r2) => {
        r2.group === n2 && this.layoutObject(e24, t2, r2);
      }), e24.strategy.shouldLayoutClipPath(e24) && this.layoutObject(e24, t2, n2.clipPath);
    }
    layoutObject(e24, { offset: t2 }, n2) {
      n2.set({ left: n2.left + t2.x, top: n2.top + t2.y });
    }
    onAfterLayout(e24, t2) {
      let { target: n2, strategy: r2, bubbles: i2, prevStrategy: a2, ...o2 } = e24, { canvas: s3 } = n2;
      n2.fire(`layout:after`, { context: e24, result: t2 }), s3 && s3.fire(`object:layout:after`, { context: e24, result: t2, target: n2 });
      let c2 = n2.parent;
      i2 && c2 != null && c2.layoutManager && ((o2.path || (o2.path = [])).push(n2), c2.layoutManager.performLayout({ ...o2, target: c2 })), n2.set(`dirty`, true);
    }
    dispose() {
      let { _subscriptions: e24 } = this;
      e24.forEach((e25) => e25.forEach((e26) => e26())), e24.clear();
    }
    toObject() {
      return { type: aa, strategy: this.strategy.constructor.type };
    }
    toJSON() {
      return this.toObject();
    }
  };
  M.setClass(oa, aa);
  var sa = class extends oa {
    performLayout() {
    }
  };
  var ca = class e11 extends Ee(J) {
    static getDefaults() {
      return { ...super.getDefaults(), ...e11.ownDefaults };
    }
    constructor(t2 = [], n2 = {}) {
      super(), i(this, `_activeObjects`, []), i(this, `__objectSelectionTracker`, void 0), i(this, `__objectSelectionDisposer`, void 0), Object.assign(this, e11.ownDefaults), this.setOptions(n2), this.groupInit(t2, n2);
    }
    groupInit(e24, t2) {
      var n2;
      this._objects = [...e24], this.__objectSelectionTracker = this.__objectSelectionMonitor.bind(this, true), this.__objectSelectionDisposer = this.__objectSelectionMonitor.bind(this, false), this.forEachObject((e25) => {
        this.enterGroup(e25, false);
      }), this.layoutManager = (n2 = t2.layoutManager) == null ? new oa() : n2, this.layoutManager.performLayout({ type: ea, target: this, targets: [...e24], x: t2.left, y: t2.top });
    }
    canEnterGroup(e24) {
      return e24 === this || this.isDescendantOf(e24) ? (s(`error`, `Group: circular object trees are not supported, this call has no effect`), false) : this._objects.indexOf(e24) === -1 || (s(`error`, `Group: duplicate objects are not supported inside group, this call has no effect`), false);
    }
    _filterObjectsBeforeEnteringGroup(e24) {
      return e24.filter((e25, t2, n2) => this.canEnterGroup(e25) && n2.indexOf(e25) === t2);
    }
    add(...e24) {
      let t2 = this._filterObjectsBeforeEnteringGroup(e24), n2 = super.add(...t2);
      return this._onAfterObjectsChange(ta, t2), n2;
    }
    insertAt(e24, ...t2) {
      let n2 = this._filterObjectsBeforeEnteringGroup(t2), r2 = super.insertAt(e24, ...n2);
      return this._onAfterObjectsChange(ta, n2), r2;
    }
    remove(...e24) {
      let t2 = super.remove(...e24);
      return this._onAfterObjectsChange(`removed`, t2), t2;
    }
    _onObjectAdded(e24) {
      this.enterGroup(e24, true), this.fire(`object:added`, { target: e24 }), e24.fire(`added`, { target: this });
    }
    _onObjectRemoved(e24, t2) {
      this.exitGroup(e24, t2), this.fire(`object:removed`, { target: e24 }), e24.fire(`removed`, { target: this });
    }
    _onAfterObjectsChange(e24, t2) {
      this.layoutManager.performLayout({ type: e24, targets: t2, target: this });
    }
    _onStackOrderChanged() {
      this._set(`dirty`, true);
    }
    _set(e24, t2) {
      let n2 = this[e24];
      return super._set(e24, t2), e24 === `canvas` && n2 !== t2 && (this._objects || []).forEach((n3) => {
        n3._set(e24, t2);
      }), this;
    }
    _shouldSetNestedCoords() {
      return this.subTargetCheck;
    }
    removeAll() {
      return this._activeObjects = [], this.remove(...this._objects);
    }
    __objectSelectionMonitor(e24, { target: t2 }) {
      let n2 = this._activeObjects;
      if (e24) n2.push(t2), this._set(`dirty`, true);
      else if (n2.length > 0) {
        let e25 = n2.indexOf(t2);
        e25 > -1 && (n2.splice(e25, 1), this._set(`dirty`, true));
      }
    }
    _watchObject(e24, t2) {
      e24 && this._watchObject(false, t2), e24 ? (t2.on(`selected`, this.__objectSelectionTracker), t2.on(`deselected`, this.__objectSelectionDisposer)) : (t2.off(`selected`, this.__objectSelectionTracker), t2.off(`deselected`, this.__objectSelectionDisposer));
    }
    enterGroup(e24, t2) {
      e24.group && e24.group.remove(e24), e24._set(`parent`, this), this._enterGroup(e24, t2);
    }
    _enterGroup(e24, t2) {
      t2 && Dt(e24, z(R(this.calcTransformMatrix()), e24.calcTransformMatrix())), this._shouldSetNestedCoords() && e24.setCoords(), e24._set(`group`, this), e24._set(`canvas`, this.canvas), this._watchObject(true, e24);
      let n2 = this.canvas && this.canvas.getActiveObject && this.canvas.getActiveObject();
      n2 && (n2 === e24 || e24.isDescendantOf(n2)) && this._activeObjects.push(e24);
    }
    exitGroup(e24, t2) {
      this._exitGroup(e24, t2), e24._set(`parent`, void 0), e24._set(`canvas`, void 0);
    }
    _exitGroup(e24, t2) {
      e24._set(`group`, void 0), t2 || (Dt(e24, z(this.calcTransformMatrix(), e24.calcTransformMatrix())), e24.setCoords()), this._watchObject(false, e24);
      let n2 = this._activeObjects.length > 0 ? this._activeObjects.indexOf(e24) : -1;
      n2 > -1 && this._activeObjects.splice(n2, 1);
    }
    shouldCache() {
      let e24 = J.prototype.shouldCache.call(this);
      if (e24) {
        for (let e25 = 0; e25 < this._objects.length; e25++) if (this._objects[e25].willDrawShadow()) return this.ownCaching = false, false;
      }
      return e24;
    }
    willDrawShadow() {
      if (super.willDrawShadow()) return true;
      for (let e24 = 0; e24 < this._objects.length; e24++) if (this._objects[e24].willDrawShadow()) return true;
      return false;
    }
    isOnACache() {
      return this.ownCaching || !!this.parent && this.parent.isOnACache();
    }
    drawObject(e24, t2, n2) {
      this._renderBackground(e24);
      for (let t3 = 0; t3 < this._objects.length; t3++) {
        var r2;
        let n3 = this._objects[t3];
        (r2 = this.canvas) != null && r2.preserveObjectStacking && n3.group !== this ? (e24.save(), e24.transform(...R(this.calcTransformMatrix())), n3.render(e24), e24.restore()) : n3.group === this && n3.render(e24);
      }
      this._drawClipPath(e24, this.clipPath, n2);
    }
    setCoords() {
      super.setCoords(), this._shouldSetNestedCoords() && this.forEachObject((e24) => e24.setCoords());
    }
    triggerLayout(e24 = {}) {
      this.layoutManager.performLayout({ target: this, type: `imperative`, ...e24 });
    }
    render(e24) {
      this._transformDone = true, super.render(e24), this._transformDone = false;
    }
    __serializeObjects(e24, t2) {
      let n2 = this.includeDefaultValues;
      return this._objects.filter(function(e25) {
        return !e25.excludeFromExport;
      }).map(function(r2) {
        let i2 = r2.includeDefaultValues;
        r2.includeDefaultValues = n2;
        let a2 = r2[e24 || `toObject`](t2);
        return r2.includeDefaultValues = i2, a2;
      });
    }
    toObject(e24 = []) {
      let t2 = this.layoutManager.toObject();
      return { ...super.toObject([`subTargetCheck`, `interactive`, ...e24]), ...t2.strategy !== `fit-content` || this.includeDefaultValues ? { layoutManager: t2 } : {}, objects: this.__serializeObjects(`toObject`, e24) };
    }
    toString() {
      return `#<Group: (${this.complexity()})>`;
    }
    dispose() {
      this.layoutManager.unsubscribeTargets({ targets: this.getObjects(), target: this }), this._activeObjects = [], this.forEachObject((e24) => {
        this._watchObject(false, e24), e24.dispose();
      }), super.dispose();
    }
    _createSVGBgRect(e24) {
      if (!this.backgroundColor) return ``;
      let t2 = $i.prototype._toSVG.call(this), n2 = t2.indexOf(`COMMON_PARTS`);
      t2[n2] = `for="group" `;
      let r2 = t2.join(``);
      return e24 ? e24(r2) : r2;
    }
    _toSVG(e24) {
      let t2 = [`<g `, `COMMON_PARTS`, ` >
`], n2 = this._createSVGBgRect(e24);
      n2 && t2.push(`		`, n2);
      for (let n3 = 0; n3 < this._objects.length; n3++) t2.push(`		`, this._objects[n3].toSVG(e24));
      return t2.push(`</g>
`), t2;
    }
    getSvgStyles() {
      let e24 = this.opacity !== void 0 && this.opacity !== 1 ? `opacity: ${U(this.opacity)};` : ``, t2 = this.visible ? `` : ` visibility: hidden;`;
      return [e24, this.getSvgFilter(), t2].join(``);
    }
    toClipPathSVG(e24) {
      let t2 = [], n2 = this._createSVGBgRect(e24);
      n2 && t2.push(`	`, n2);
      for (let n3 = 0; n3 < this._objects.length; n3++) t2.push(`	`, this._objects[n3].toClipPathSVG(e24));
      return this._createBaseClipPathSVGMarkup(t2, { reviver: e24 });
    }
    static fromObject({ type: e24, objects: t2 = [], layoutManager: n2, ...r2 }, i2) {
      return Promise.all([Qe(t2, i2), $e(r2, i2)]).then(([e25, t3]) => {
        let i3 = new this(e25, { ...r2, ...t3, layoutManager: new sa() });
        return i3.layoutManager = n2 ? new (M.getClass(n2.type))(new (M.getClass(n2.strategy))()) : new oa(), i3.layoutManager.subscribeTargets({ type: ea, target: i3, targets: i3.getObjects() }), i3.setCoords(), i3;
      });
    }
  };
  i(ca, `type`, `Group`), i(ca, `ownDefaults`, { strokeWidth: 0, subTargetCheck: false, interactive: false }), M.setClass(ca);
  var la = (e24, t2) => e24 && e24.length === 1 ? e24[0] : new ca(e24, t2);
  var ua = (e24, t2) => Math.min(t2.width / e24.width, t2.height / e24.height);
  var da = (e24, t2) => Math.max(t2.width / e24.width, t2.height / e24.height);
  var fa = `\\s*,?\\s*`;
  var pa = `${fa}(${Dn})`;
  var ma = `${pa}${pa}${pa}${fa}([01])${fa}([01])${pa}${pa}`;
  var ha = { m: `l`, M: `L` };
  var ga = (e24, t2, n2, r2, i2, a2, o2, s3, c2, l2, u2) => {
    let d2 = Se(e24), f2 = Ce(e24), p2 = Se(t2), m = Ce(t2), h2 = n2 * i2 * p2 - r2 * a2 * m + o2, g2 = r2 * i2 * p2 + n2 * a2 * m + s3;
    return [`C`, l2 + c2 * (-n2 * i2 * f2 - r2 * a2 * d2), u2 + c2 * (-r2 * i2 * f2 + n2 * a2 * d2), h2 + c2 * (n2 * i2 * m + r2 * a2 * p2), g2 + c2 * (r2 * i2 * m - n2 * a2 * p2), h2, g2];
  };
  var _a = (e24, t2, n2, r2) => {
    let i2 = Math.atan2(t2, e24), a2 = Math.atan2(r2, n2);
    return a2 >= i2 ? a2 - i2 : 2 * Math.PI - (i2 - a2);
  };
  function va(e24, t2, n2, r2, i2, a2, s3, c2) {
    let l2;
    if (o.cachesBoundsOfCurve && (l2 = [...arguments].join(), y.boundsOfCurveCache[l2])) return y.boundsOfCurveCache[l2];
    let u2 = Math.sqrt, d2 = Math.abs, f2 = [], p2 = [[0, 0], [0, 0]], m = 6 * e24 - 12 * n2 + 6 * i2, h2 = -3 * e24 + 9 * n2 - 9 * i2 + 3 * s3, g2 = 3 * n2 - 3 * e24;
    for (let e25 = 0; e25 < 2; ++e25) {
      if (e25 > 0 && (m = 6 * t2 - 12 * r2 + 6 * a2, h2 = -3 * t2 + 9 * r2 - 9 * a2 + 3 * c2, g2 = 3 * r2 - 3 * t2), d2(h2) < 1e-12) {
        if (d2(m) < 1e-12) continue;
        let e26 = -g2 / m;
        0 < e26 && e26 < 1 && f2.push(e26);
        continue;
      }
      let n3 = m * m - 4 * g2 * h2;
      if (n3 < 0) continue;
      let i3 = u2(n3), o2 = (-m + i3) / (2 * h2);
      0 < o2 && o2 < 1 && f2.push(o2);
      let s4 = (-m - i3) / (2 * h2);
      0 < s4 && s4 < 1 && f2.push(s4);
    }
    let _2 = f2.length, v2 = _2, b2 = Sa(e24, t2, n2, r2, i2, a2, s3, c2);
    for (; _2--; ) {
      let { x: e25, y: t3 } = b2(f2[_2]);
      p2[0][_2] = e25, p2[1][_2] = t3;
    }
    p2[0][v2] = e24, p2[1][v2] = t2, p2[0][v2 + 1] = s3, p2[1][v2 + 1] = c2;
    let x2 = [new N(Math.min(...p2[0]), Math.min(...p2[1])), new N(Math.max(...p2[0]), Math.max(...p2[1]))];
    return o.cachesBoundsOfCurve && (y.boundsOfCurveCache[l2] = x2), x2;
  }
  var ya = (e24, t2, [n2, r2, i2, a2, o2, s3, c2, l2]) => {
    let u2 = ((e25, t3, n3, r3, i3, a3, o3) => {
      if (n3 === 0 || r3 === 0) return [];
      let s4 = 0, c3 = 0, l3 = 0, u3 = Math.PI, d2 = o3 * ee, f2 = Ce(d2), p2 = Se(d2), m = 0.5 * (-p2 * e25 - f2 * t3), h2 = 0.5 * (-p2 * t3 + f2 * e25), g2 = n3 ** 2, _2 = r3 ** 2, v2 = h2 ** 2, y2 = m ** 2, b2 = g2 * _2 - g2 * v2 - _2 * y2, x2 = Math.abs(n3), S2 = Math.abs(r3);
      if (b2 < 0) {
        let e26 = Math.sqrt(1 - b2 / (g2 * _2));
        x2 *= e26, S2 *= e26;
      } else l3 = (i3 === a3 ? -1 : 1) * Math.sqrt(b2 / (g2 * v2 + _2 * y2));
      let C2 = l3 * x2 * h2 / S2, w2 = -l3 * S2 * m / x2, T2 = p2 * C2 - f2 * w2 + 0.5 * e25, E2 = f2 * C2 + p2 * w2 + 0.5 * t3, D2 = _a(1, 0, (m - C2) / x2, (h2 - w2) / S2), O2 = _a((m - C2) / x2, (h2 - w2) / S2, (-m - C2) / x2, (-h2 - w2) / S2);
      a3 === 0 && O2 > 0 ? O2 -= 2 * u3 : a3 === 1 && O2 < 0 && (O2 += 2 * u3);
      let k2 = Math.ceil(Math.abs(O2 / u3 * 2)), te2 = [], ne2 = O2 / k2, re2 = 8 / 3 * Math.sin(ne2 / 4) * Math.sin(ne2 / 4) / Math.sin(ne2 / 2), ie2 = D2 + ne2;
      for (let e26 = 0; e26 < k2; e26++) te2[e26] = ga(D2, ie2, p2, f2, x2, S2, T2, E2, re2, s4, c3), s4 = te2[e26][5], c3 = te2[e26][6], D2 = ie2, ie2 += ne2;
      return te2;
    })(c2 - e24, l2 - t2, r2, i2, o2, s3, a2);
    for (let n3 = 0, r3 = u2.length; n3 < r3; n3++) u2[n3][1] += e24, u2[n3][2] += t2, u2[n3][3] += e24, u2[n3][4] += t2, u2[n3][5] += e24, u2[n3][6] += t2;
    return u2;
  };
  var ba = (e24) => {
    let t2 = 0, n2 = 0, r2 = 0, i2 = 0, a2 = [], o2, s3 = 0, c2 = 0;
    for (let l2 of e24) {
      let e25 = [...l2], u2;
      switch (e25[0]) {
        case `l`:
          e25[1] += t2, e25[2] += n2;
        case `L`:
          t2 = e25[1], n2 = e25[2], u2 = [`L`, t2, n2];
          break;
        case `h`:
          e25[1] += t2;
        case `H`:
          t2 = e25[1], u2 = [`L`, t2, n2];
          break;
        case `v`:
          e25[1] += n2;
        case `V`:
          n2 = e25[1], u2 = [`L`, t2, n2];
          break;
        case `m`:
          e25[1] += t2, e25[2] += n2;
        case `M`:
          t2 = e25[1], n2 = e25[2], r2 = e25[1], i2 = e25[2], u2 = [`M`, t2, n2];
          break;
        case `c`:
          e25[1] += t2, e25[2] += n2, e25[3] += t2, e25[4] += n2, e25[5] += t2, e25[6] += n2;
        case `C`:
          s3 = e25[3], c2 = e25[4], t2 = e25[5], n2 = e25[6], u2 = [`C`, e25[1], e25[2], s3, c2, t2, n2];
          break;
        case `s`:
          e25[1] += t2, e25[2] += n2, e25[3] += t2, e25[4] += n2;
        case `S`:
          o2 === `C` ? (s3 = 2 * t2 - s3, c2 = 2 * n2 - c2) : (s3 = t2, c2 = n2), t2 = e25[3], n2 = e25[4], u2 = [`C`, s3, c2, e25[1], e25[2], t2, n2], s3 = u2[3], c2 = u2[4];
          break;
        case `q`:
          e25[1] += t2, e25[2] += n2, e25[3] += t2, e25[4] += n2;
        case `Q`:
          s3 = e25[1], c2 = e25[2], t2 = e25[3], n2 = e25[4], u2 = [`Q`, s3, c2, t2, n2];
          break;
        case `t`:
          e25[1] += t2, e25[2] += n2;
        case `T`:
          o2 === `Q` ? (s3 = 2 * t2 - s3, c2 = 2 * n2 - c2) : (s3 = t2, c2 = n2), t2 = e25[1], n2 = e25[2], u2 = [`Q`, s3, c2, t2, n2];
          break;
        case `a`:
          e25[6] += t2, e25[7] += n2;
        case `A`:
          ya(t2, n2, e25).forEach((e26) => a2.push(e26)), t2 = e25[6], n2 = e25[7];
          break;
        case `z`:
        case `Z`:
          t2 = r2, n2 = i2, u2 = [`Z`];
      }
      u2 ? (a2.push(u2), o2 = u2[0]) : o2 = ``;
    }
    return a2;
  };
  var xa = (e24, t2, n2, r2) => Math.sqrt((n2 - e24) ** 2 + (r2 - t2) ** 2);
  var Sa = (e24, t2, n2, r2, i2, a2, o2, s3) => (c2) => {
    let l2 = c2 ** 3, u2 = ((e25) => 3 * e25 ** 2 * (1 - e25))(c2), d2 = ((e25) => 3 * e25 * (1 - e25) ** 2)(c2), f2 = ((e25) => (1 - e25) ** 3)(c2);
    return new N(o2 * l2 + i2 * u2 + n2 * d2 + e24 * f2, s3 * l2 + a2 * u2 + r2 * d2 + t2 * f2);
  };
  var Ca = (e24) => e24 ** 2;
  var wa = (e24) => 2 * e24 * (1 - e24);
  var Ta = (e24) => (1 - e24) ** 2;
  var Ea = (e24, t2, n2, r2, i2, a2, o2, s3) => (c2) => {
    let l2 = Ca(c2), u2 = wa(c2), d2 = Ta(c2), f2 = 3 * (d2 * (n2 - e24) + u2 * (i2 - n2) + l2 * (o2 - i2)), p2 = 3 * (d2 * (r2 - t2) + u2 * (a2 - r2) + l2 * (s3 - a2));
    return Math.atan2(p2, f2);
  };
  var Da = (e24, t2, n2, r2, i2, a2) => (o2) => {
    let s3 = Ca(o2), c2 = wa(o2), l2 = Ta(o2);
    return new N(i2 * s3 + n2 * c2 + e24 * l2, a2 * s3 + r2 * c2 + t2 * l2);
  };
  var Oa = (e24, t2, n2, r2, i2, a2) => (o2) => {
    let s3 = 1 - o2, c2 = 2 * (s3 * (n2 - e24) + o2 * (i2 - n2)), l2 = 2 * (s3 * (r2 - t2) + o2 * (a2 - r2));
    return Math.atan2(l2, c2);
  };
  var ka = (e24, t2, n2) => {
    let r2 = new N(t2, n2), i2 = 0;
    for (let t3 = 1; t3 <= 100; t3 += 1) {
      let n3 = e24(t3 / 100);
      i2 += xa(r2.x, r2.y, n3.x, n3.y), r2 = n3;
    }
    return i2;
  };
  var Aa = (e24, t2) => {
    let n2, r2 = 0, i2 = 0, a2 = { x: e24.x, y: e24.y }, o2 = { ...a2 }, s3 = 0.01, c2 = 0, l2 = e24.iterator, u2 = e24.angleFinder;
    for (; i2 < t2 && s3 > 1e-4; ) o2 = l2(r2), c2 = r2, n2 = xa(a2.x, a2.y, o2.x, o2.y), n2 + i2 > t2 ? (r2 -= s3, s3 /= 2) : (a2 = o2, r2 += s3, i2 += n2);
    return { ...o2, angle: u2(c2) };
  };
  var ja = (e24) => {
    let t2, n2, r2 = 0, i2 = 0, a2 = 0, o2 = 0, s3 = 0, c2 = [];
    for (let l2 of e24) {
      let e25 = { x: i2, y: a2, command: l2[0], length: 0 };
      switch (l2[0]) {
        case `M`:
          n2 = e25, n2.x = o2 = i2 = l2[1], n2.y = s3 = a2 = l2[2];
          break;
        case `L`:
          n2 = e25, n2.length = xa(i2, a2, l2[1], l2[2]), i2 = l2[1], a2 = l2[2];
          break;
        case `C`:
          t2 = Sa(i2, a2, l2[1], l2[2], l2[3], l2[4], l2[5], l2[6]), n2 = e25, n2.iterator = t2, n2.angleFinder = Ea(i2, a2, l2[1], l2[2], l2[3], l2[4], l2[5], l2[6]), n2.length = ka(t2, i2, a2), i2 = l2[5], a2 = l2[6];
          break;
        case `Q`:
          t2 = Da(i2, a2, l2[1], l2[2], l2[3], l2[4]), n2 = e25, n2.iterator = t2, n2.angleFinder = Oa(i2, a2, l2[1], l2[2], l2[3], l2[4]), n2.length = ka(t2, i2, a2), i2 = l2[3], a2 = l2[4];
          break;
        case `Z`:
          n2 = e25, n2.destX = o2, n2.destY = s3, n2.length = xa(i2, a2, o2, s3), i2 = o2, a2 = s3;
      }
      r2 += n2.length, c2.push(n2);
    }
    return c2.push({ length: r2, x: i2, y: a2 }), c2;
  };
  var Ma = (e24, t2, n2 = ja(e24)) => {
    let r2 = 0;
    for (; t2 - n2[r2].length > 0 && r2 < n2.length - 2; ) t2 -= n2[r2].length, r2++;
    let i2 = n2[r2], a2 = t2 / i2.length, o2 = e24[r2];
    switch (i2.command) {
      case `M`:
        return { x: i2.x, y: i2.y, angle: 0 };
      case `Z`:
        return { ...new N(i2.x, i2.y).lerp(new N(i2.destX, i2.destY), a2), angle: Math.atan2(i2.destY - i2.y, i2.destX - i2.x) };
      case `L`:
        return { ...new N(i2.x, i2.y).lerp(new N(o2[1], o2[2]), a2), angle: Math.atan2(o2[2] - i2.y, o2[1] - i2.x) };
      case `C`:
      case `Q`:
        return Aa(i2, t2);
    }
  };
  var Na = RegExp(`[mzlhvcsqta][^mzlhvcsqta]*`, `gi`);
  var Pa = new RegExp(ma, `g`);
  var Fa = new RegExp(Dn, `gi`);
  var Ia = { m: 2, l: 2, h: 1, v: 1, c: 6, s: 4, q: 4, t: 2, a: 7 };
  var La = (e24) => {
    var t2;
    let n2 = [], r2 = (t2 = e24.match(Na)) == null ? [] : t2;
    for (let e25 of r2) {
      let t3 = e25[0];
      if (t3 === `z` || t3 === `Z`) {
        n2.push([t3]);
        continue;
      }
      let r3 = Ia[t3.toLowerCase()], i2 = [];
      if (t3 === `a` || t3 === `A`) {
        let t4;
        for (Pa.lastIndex = 0; t4 = Pa.exec(e25); ) i2.push(...t4.slice(1));
      } else i2 = e25.match(Fa) || [];
      for (let e26 = 0; e26 < i2.length; e26 += r3) {
        let a2 = Array(r3), o2 = ha[t3];
        a2[0] = e26 > 0 && o2 ? o2 : t3;
        for (let t4 = 0; t4 < r3; t4++) a2[t4 + 1] = parseFloat(i2[e26 + t4]);
        n2.push(a2);
      }
    }
    return n2;
  };
  var Ra = (e24, t2 = 0) => {
    let n2 = new N(e24[0]), r2 = new N(e24[1]), i2 = 1, a2 = 0, o2 = [], s3 = e24.length, c2 = s3 > 2, l2;
    for (c2 && (i2 = e24[2].x < r2.x ? -1 : e24[2].x === r2.x ? 0 : 1, a2 = e24[2].y < r2.y ? -1 : e24[2].y === r2.y ? 0 : 1), o2.push([`M`, n2.x - i2 * t2, n2.y - a2 * t2]), l2 = 1; l2 < s3; l2++) {
      if (!n2.eq(r2)) {
        let e25 = n2.midPointFrom(r2);
        o2.push([`Q`, n2.x, n2.y, e25.x, e25.y]);
      }
      n2 = e24[l2], l2 + 1 < e24.length && (r2 = e24[l2 + 1]);
    }
    return c2 && (i2 = n2.x > e24[l2 - 2].x ? 1 : n2.x === e24[l2 - 2].x ? 0 : -1, a2 = n2.y > e24[l2 - 2].y ? 1 : n2.y === e24[l2 - 2].y ? 0 : -1), o2.push([`L`, n2.x + i2 * t2, n2.y + a2 * t2]), o2;
  };
  var za = (e24, t2, n2) => (n2 && (t2 = z(t2, [1, 0, 0, 1, -n2.x, -n2.y])), e24.map((e25) => {
    let n3 = [...e25];
    for (let r2 = 1; r2 < e25.length - 1; r2 += 2) {
      let { x: i2, y: a2 } = L({ x: e25[r2], y: e25[r2 + 1] }, t2);
      n3[r2] = i2, n3[r2 + 1] = a2;
    }
    return n3;
  }));
  var Ba = (e24, t2) => {
    let n2 = 2 * Math.PI / e24, r2 = -S;
    e24 % 2 == 0 && (r2 += n2 / 2);
    let i2 = Array(e24 + 1);
    for (let a2 = 0; a2 < e24; a2++) {
      let e25 = a2 * n2 + r2, { x: o2, y: s3 } = new N(Se(e25), Ce(e25)).scalarMultiply(t2);
      i2[a2] = [a2 === 0 ? `M` : `L`, o2, s3];
    }
    return i2[e24] = [`Z`], i2;
  };
  var Va = (e24, t2) => e24.map((e25) => e25.map((e26, n2) => n2 === 0 || t2 === void 0 ? e26 : B(e26, t2)).join(` `)).join(` `);
  var Ha = (e24, t2) => {
    var n2;
    let r2 = e24, i2 = t2;
    r2.inverted && !i2.inverted && (r2 = t2, i2 = e24), Pt(i2, (n2 = i2.group) == null ? void 0 : n2.calcTransformMatrix(), r2.calcTransformMatrix());
    let a2 = r2.inverted && i2.inverted;
    return a2 && (r2.inverted = i2.inverted = false), new ca([r2], { clipPath: i2, inverted: a2 });
  };
  var Ua = (e24, t2) => Math.floor(Math.random() * (t2 - e24 + 1)) + e24;
  var Wa = (e24, t2) => {
    let n2 = e24._findCenterFromElement();
    e24.transformMatrix && (((e25) => {
      if (e25.transformMatrix) {
        let { scaleX: t3, scaleY: n3, angle: r2, skewX: i2 } = He(e25.transformMatrix);
        e25.flipX = false, e25.flipY = false, e25.set(de, t3), e25.set(fe, n3), e25.angle = r2, e25.skewX = i2, e25.skewY = 0;
      }
    })(e24), n2 = n2.transform(e24.transformMatrix)), delete e24.transformMatrix, t2 && (e24.scaleX *= t2.scaleX, e24.scaleY *= t2.scaleY, e24.cropX = t2.cropX, e24.cropY = t2.cropY, n2.x += t2.offsetLeft, n2.y += t2.offsetTop, e24.width = t2.width, e24.height = t2.height), e24.setPositionByOrigin(n2, E, E);
  };
  var Ga = t({ addTransformToObject: () => Et, animate: () => Mr, animateColor: () => Nr, applyTransformToObject: () => Dt, calcAngleBetweenVectors: () => Vt, calcDimensionsMatrix: () => Ye, calcPlaneChangeMatrix: () => jt, calcVectorRotation: () => Ht, cancelAnimFrame: () => ke, capValue: () => Vn, composeMatrix: () => Xe, copyCanvasElement: () => Ne, cos: () => Se, createCanvasElement: () => P, createImage: () => Me, createRotateMatrix: () => We, createScaleMatrix: () => Ge, createSkewXMatrix: () => qe, createSkewYMatrix: () => Je, createTranslateMatrix: () => Ue, createVector: () => zt, crossProduct: () => Gt, degreesToRadians: () => I, dotProduct: () => Kt, ease: () => Gn, enlivenObjectEnlivables: () => $e, enlivenObjects: () => Qe, findScaleToCover: () => da, findScaleToFit: () => ua, getBoundsOfCurve: () => va, getOrthonormalVector: () => Wt, getPathSegmentsInfo: () => ja, getPointOnPath: () => Ma, getPointer: () => xt, getRandomInt: () => Ua, getRegularPolygonPath: () => Ba, getSmoothPathFromPoints: () => Ra, getSvgAttributes: () => pn, getUnitVector: () => Ut, groupSVGElements: () => la, hasStyleChanged: () => Ei, invertTransform: () => R, isBetweenVectors: () => qt, isIdentityMatrix: () => Le, isTouchEvent: () => St, isTransparent: () => yi, joinPath: () => Va, loadImage: () => Ze, magnitude: () => Bt, makeBoundingBoxFromPoints: () => wt, makePathSimpler: () => ba, matrixToSVG: () => nt, mergeClipPaths: () => Ha, multiplyTransformMatrices: () => z, multiplyTransformMatrixArray: () => Re, parsePath: () => La, parsePreserveAspectRatioAttribute: () => mn, parseUnit: () => K, pick: () => et, projectStrokeOnPoints: () => wi, qrDecompose: () => He, radiansToDegrees: () => Ie, removeFromArray: () => xe, removeTransformFromObject: () => Tt, removeTransformMatrixForSvgParsing: () => Wa, requestAnimFrame: () => Oe, resetObjectTransform: () => Ot, rotateVector: () => Rt, saveObjectTransform: () => kt, sendObjectToPlane: () => Pt, sendPointToPlane: () => Mt, sendVectorToPlane: () => Nt, sin: () => Ce, sizeAfterTransform: () => At, string: () => pt, stylesFromArray: () => Oi, stylesToArray: () => Di, toBlob: () => Fe, toDataURL: () => Pe, toFixed: () => B, transformPath: () => za, transformPoint: () => L });
  function Ka(e24, t2) {
    let n2 = e24.style;
    n2 && Object.entries(t2).forEach(([e25, t3]) => n2.setProperty(e25, t3));
  }
  var qa = class extends dt {
    constructor(e24, { allowTouchScrolling: t2 = false, containerClass: n2 = `` } = {}) {
      super(e24), i(this, `upper`, void 0), i(this, `container`, void 0);
      let { el: r2 } = this.lower, a2 = this.createUpperCanvas();
      this.upper = { el: a2, ctx: a2.getContext(`2d`) }, this.applyCanvasStyle(r2, { allowTouchScrolling: t2 }), this.applyCanvasStyle(a2, { allowTouchScrolling: t2, styles: { position: `absolute`, left: `0`, top: `0` } });
      let o2 = this.createContainerElement();
      o2.classList.add(n2), r2.parentNode && r2.parentNode.replaceChild(o2, r2), o2.append(r2, a2), this.container = o2;
    }
    createUpperCanvas() {
      let { el: e24 } = this.lower, t2 = P();
      return t2.className = e24.className, t2.classList.remove(`lower-canvas`), t2.classList.add(`upper-canvas`), t2.setAttribute(`data-fabric`, `top`), t2.style.cssText = e24.style.cssText, t2.setAttribute(`draggable`, `true`), t2;
    }
    createContainerElement() {
      let e24 = g().createElement(`div`);
      return e24.setAttribute(`data-fabric`, `wrapper`), Ka(e24, { position: `relative` }), ut(e24), e24;
    }
    applyCanvasStyle(e24, t2) {
      let { styles: n2, allowTouchScrolling: r2 } = t2;
      Ka(e24, { ...n2, "touch-action": r2 ? `manipulation` : te }), ut(e24);
    }
    setDimensions(e24, t2) {
      super.setDimensions(e24, t2);
      let { el: n2, ctx: r2 } = this.upper;
      ct(n2, r2, e24, t2);
    }
    setCSSDimensions(e24) {
      super.setCSSDimensions(e24), lt(this.upper.el, e24), lt(this.container, e24);
    }
    cleanupDOM(e24) {
      let t2 = this.container, { el: n2 } = this.lower, { el: r2 } = this.upper;
      super.cleanupDOM(e24), t2.removeChild(r2), t2.removeChild(n2), t2.parentNode && t2.parentNode.replaceChild(n2, t2);
    }
    dispose() {
      super.dispose(), h().dispose(this.upper.el), delete this.upper, delete this.container;
    }
  };
  var Ja = (e24, t2, n2, r2) => {
    let { target: i2, offsetX: a2, offsetY: o2 } = t2, s3 = n2 - a2, c2 = r2 - o2, l2 = !Zt(i2, `lockMovementX`) && i2.left !== s3, u2 = !Zt(i2, `lockMovementY`) && i2.top !== c2;
    return l2 && i2.set(`left`, s3), u2 && i2.set(`top`, c2), (l2 || u2) && Lr(re, Qt(e24, t2, n2, r2)), l2 || u2;
  };
  var Ya = ce;
  var Xa = (e24) => function(t2, n2, r2) {
    let { points: i2, pathOffset: a2 } = r2;
    return new N(i2[e24]).subtract(a2).transform(z(r2.getViewportTransform(), r2.calcTransformMatrix()));
  };
  var Za = (e24, t2, n2, r2) => {
    let { target: i2, pointIndex: a2 } = t2, o2 = i2, s3 = Mt(new N(n2, r2), void 0, o2.calcOwnMatrix());
    return o2.points[a2] = s3.add(o2.pathOffset), o2.setDimensions(), o2.set(`dirty`, true), true;
  };
  var Qa = (e24, t2) => function(n2, r2, i2, a2) {
    let o2 = r2.target, s3 = new N(o2.points[(e24 > 0 ? e24 : o2.points.length) - 1]), c2 = s3.subtract(o2.pathOffset).transform(o2.calcOwnMatrix()), l2 = t2(n2, { ...r2, pointIndex: e24 }, i2, a2), u2 = s3.subtract(o2.pathOffset).transform(o2.calcOwnMatrix()).subtract(c2);
    return o2.left -= u2.x, o2.top -= u2.y, l2;
  };
  var $a = (e24) => Rr(Ya, Qa(e24, Za));
  function eo(e24, t2 = {}) {
    let n2 = {};
    for (let r2 = 0; r2 < (typeof e24 == `number` ? e24 : e24.points.length); r2++) n2[`p${r2}`] = new q({ actionName: Ya, positionHandler: Xa(r2), actionHandler: $a(r2), ...t2 });
    return n2;
  }
  var to = (e24, t2, n2) => {
    let { path: r2, pathOffset: i2 } = e24, a2 = r2[t2];
    return new N(a2[n2] - i2.x, a2[n2 + 1] - i2.y).transform(z(e24.getViewportTransform(), e24.calcTransformMatrix()));
  };
  function no(e24, t2, n2) {
    let { commandIndex: r2, pointIndex: i2 } = this;
    return to(n2, r2, i2);
  }
  function ro(e24, t2, n2, r2) {
    let { target: i2 } = t2, { commandIndex: a2, pointIndex: o2 } = this, s3 = ((e25, t3, n3, r3, i3) => {
      let { path: a3, pathOffset: o3 } = e25, s4 = a3[(r3 > 0 ? r3 : a3.length) - 1], c2 = new N(s4[i3], s4[i3 + 1]), l2 = c2.subtract(o3).transform(e25.calcOwnMatrix()), u2 = Mt(new N(t3, n3), void 0, e25.calcOwnMatrix());
      a3[r3][i3] = u2.x + o3.x, a3[r3][i3 + 1] = u2.y + o3.y, e25.setDimensions();
      let d2 = c2.subtract(e25.pathOffset).transform(e25.calcOwnMatrix()).subtract(l2);
      return e25.left -= d2.x, e25.top -= d2.y, e25.set(`dirty`, true), true;
    })(i2, n2, r2, a2, o2);
    return s3 && Lr(this.actionName, { ...Qt(e24, t2, n2, r2), commandIndex: a2, pointIndex: o2 }), s3;
  }
  var io = class extends q {
    constructor(e24) {
      super(e24);
    }
    render(e24, t2, n2, r2, i2) {
      let a2 = { ...r2, cornerColor: this.controlFill, cornerStrokeColor: this.controlStroke, transparentCorners: !this.controlFill };
      super.render(e24, t2, n2, a2, i2);
    }
  };
  var ao = class extends io {
    constructor(e24) {
      super(e24);
    }
    render(e24, t2, n2, r2, i2) {
      let { path: a2 } = i2, { commandIndex: o2, pointIndex: s3, connectToCommandIndex: c2, connectToPointIndex: l2 } = this;
      e24.save(), e24.strokeStyle = this.controlStroke, this.connectionDashArray && e24.setLineDash(this.connectionDashArray);
      let [u2] = a2[o2], d2 = to(i2, c2, l2);
      if (u2 === `Q`) {
        let r3 = to(i2, o2, s3 + 2);
        e24.moveTo(r3.x, r3.y), e24.lineTo(t2, n2);
      } else e24.moveTo(t2, n2);
      e24.lineTo(d2.x, d2.y), e24.stroke(), e24.restore(), super.render(e24, t2, n2, r2, i2);
    }
  };
  var oo = (e24, t2, n2, r2, i2, a2) => new (n2 ? ao : io)({ commandIndex: e24, pointIndex: t2, actionName: `modifyPath`, positionHandler: no, actionHandler: ro, connectToCommandIndex: i2, connectToPointIndex: a2, ...r2, ...n2 ? r2.controlPointStyle : r2.pointStyle });
  function so(e24, t2 = {}) {
    let n2 = {}, r2 = `M`;
    return e24.path.forEach((e25, i2) => {
      let a2 = e25[0];
      switch (a2 !== `Z` && (n2[`c_${i2}_${a2}`] = oo(i2, e25.length - 2, false, t2)), a2) {
        case `C`:
          n2[`c_${i2}_C_CP_1`] = oo(i2, 1, true, t2, i2 - 1, /* @__PURE__ */ ((e26) => e26 === `C` ? 5 : e26 === `Q` ? 3 : 1)(r2)), n2[`c_${i2}_C_CP_2`] = oo(i2, 3, true, t2, i2, 5);
          break;
        case `Q`:
          n2[`c_${i2}_Q_CP_1`] = oo(i2, 1, true, t2, i2, 3);
      }
      r2 = a2;
    }), n2;
  }
  var co = t({ changeHeight: () => Wr, changeObjectHeight: () => Hr, changeObjectWidth: () => Vr, changeWidth: () => Ur, createObjectDefaultControls: () => mi, createPathControls: () => so, createPolyActionHandler: () => $a, createPolyControls: () => eo, createPolyPositionHandler: () => Xa, createResizeControls: () => hi, createTextboxDefaultControls: () => gi, dragHandler: () => Ja, factoryPolyActionHandler: () => Qa, getLocalPoint: () => en, polyActionHandler: () => Za, renderCircleControl: () => Gr, renderSquareControl: () => Kr, rotationStyleHandler: () => qr, rotationWithSnapping: () => Jr, scaleCursorStyleHandler: () => Qr, scaleOrSkewActionName: () => ui, scaleSkewCursorStyleHandler: () => di, scalingEqually: () => ei, scalingX: () => ti, scalingXOrSkewingY: () => fi, scalingY: () => ni, scalingYOrSkewingX: () => pi, skewCursorStyleHandler: () => ai, skewHandlerX: () => si, skewHandlerY: () => ci, wrapWithFireEvent: () => Rr, wrapWithFixedAnchor: () => zr });
  var lo = class e12 extends yt {
    constructor(...e24) {
      super(...e24), i(this, `_hoveredTargets`, []), i(this, `_currentTransform`, null), i(this, `_groupSelector`, null), i(this, `contextTopDirty`, false);
    }
    static getDefaults() {
      return { ...super.getDefaults(), ...e12.ownDefaults };
    }
    get upperCanvasEl() {
      var e24;
      return (e24 = this.elements.upper) == null ? void 0 : e24.el;
    }
    get contextTop() {
      var e24;
      return (e24 = this.elements.upper) == null ? void 0 : e24.ctx;
    }
    get wrapperEl() {
      return this.elements.container;
    }
    initElements(e24) {
      this.elements = new qa(e24, { allowTouchScrolling: this.allowTouchScrolling, containerClass: this.containerClass }), this._createCacheCanvas();
    }
    _onObjectAdded(e24) {
      this._objectsToRender = void 0, super._onObjectAdded(e24);
    }
    _onObjectRemoved(e24) {
      this._objectsToRender = void 0, e24 === this._activeObject && (this.fire(`before:selection:cleared`, { deselected: [e24] }), this._discardActiveObject(), this.fire(`selection:cleared`, { deselected: [e24] }), e24.fire(`deselected`, { target: e24 })), e24 === this._hoveredTarget && (this._hoveredTarget = void 0, this._hoveredTargets = []), super._onObjectRemoved(e24);
    }
    _onStackOrderChanged() {
      this._objectsToRender = void 0, super._onStackOrderChanged();
    }
    _chooseObjectsToRender() {
      let e24 = this._activeObject;
      return !this.preserveObjectStacking && e24 ? this._objects.filter((t2) => !t2.group && t2 !== e24).concat(e24) : this._objects;
    }
    renderAll() {
      this.cancelRequestedRender(), this.destroyed || (!this.contextTopDirty || this._groupSelector || this.isDrawingMode || (this.clearContext(this.contextTop), this.contextTopDirty = false), this.hasLostContext && (this.renderTopLayer(this.contextTop), this.hasLostContext = false), !this._objectsToRender && (this._objectsToRender = this._chooseObjectsToRender()), this.renderCanvas(this.getContext(), this._objectsToRender));
    }
    renderTopLayer(e24) {
      e24.save(), this.isDrawingMode && this._isCurrentlyDrawing && (this.freeDrawingBrush && this.freeDrawingBrush._render(), this.contextTopDirty = true), this.selection && this._groupSelector && (this._drawSelection(e24), this.contextTopDirty = true), e24.restore();
    }
    renderTop() {
      let e24 = this.contextTop;
      this.clearContext(e24), this.renderTopLayer(e24), this.fire(`after:render`, { ctx: e24 });
    }
    setTargetFindTolerance(e24) {
      e24 = Math.round(e24), this.targetFindTolerance = e24;
      let t2 = this.getRetinaScaling(), n2 = Math.ceil((2 * e24 + 1) * t2);
      this.pixelFindCanvasEl.width = this.pixelFindCanvasEl.height = n2, this.pixelFindContext.scale(t2, t2);
    }
    isTargetTransparent(e24, t2, n2) {
      let r2 = this.targetFindTolerance, i2 = this.pixelFindContext;
      this.clearContext(i2), i2.save(), i2.translate(-t2 + r2, -n2 + r2), i2.transform(...this.viewportTransform);
      let a2 = e24.selectionBackgroundColor;
      e24.selectionBackgroundColor = ``, e24.render(i2), e24.selectionBackgroundColor = a2, i2.restore();
      let o2 = Math.round(r2 * this.getRetinaScaling());
      return yi(i2, o2, o2, o2);
    }
    _isSelectionKeyPressed(e24) {
      let t2 = this.selectionKey;
      return !!t2 && (Array.isArray(t2) ? !!t2.find((t3) => !!t3 && true === e24[t3]) : e24[t2]);
    }
    _shouldClearSelection(e24, t2) {
      let n2 = this.getActiveObjects(), r2 = this._activeObject;
      return !!(!t2 || t2 && r2 && n2.length > 1 && n2.indexOf(t2) === -1 && r2 !== t2 && !this._isSelectionKeyPressed(e24) || t2 && !t2.evented || t2 && !t2.selectable && r2 && r2 !== t2);
    }
    _shouldCenterTransform(e24, t2, n2) {
      if (!e24) return;
      let r2;
      return t2 === `scale` || t2 === `scaleX` || t2 === `scaleY` || t2 === `resizing` ? r2 = this.centeredScaling || e24.centeredScaling : t2 === `rotate` && (r2 = this.centeredRotation || e24.centeredRotation), r2 ? !n2 : n2;
    }
    _getOriginFromCorner(e24, t2) {
      let n2 = t2 ? e24.controls[t2].getTransformAnchorPoint() : { x: e24.originX, y: e24.originY };
      return t2 ? ([`ml`, `tl`, `bl`].includes(t2) ? n2.x = k : [`mr`, `tr`, `br`].includes(t2) && (n2.x = D), [`tl`, `mt`, `tr`].includes(t2) ? n2.y = O : [`bl`, `mb`, `br`].includes(t2) && (n2.y = `top`), n2) : n2;
    }
    _setupCurrentTransform(e24, t2, n2) {
      var r2;
      let i2 = t2.group ? Mt(this.getScenePoint(e24), void 0, t2.group.calcTransformMatrix()) : this.getScenePoint(e24), { key: a2 = ``, control: o2 } = t2.getActiveControl() || {}, s3 = n2 && o2 ? (r2 = o2.getActionHandler(e24, t2, o2)) == null ? void 0 : r2.bind(o2) : Ja, c2 = ((e25, t3, n3, r3) => {
        if (!t3 || !e25) return `drag`;
        let i3 = r3.controls[t3];
        return i3.getActionName(n3, i3, r3);
      })(n2, a2, e24, t2), l2 = e24[this.centeredKey], u2 = this._shouldCenterTransform(t2, c2, l2) ? { x: E, y: E } : this._getOriginFromCorner(t2, a2), { scaleX: d2, scaleY: f2, skewX: p2, skewY: m, left: h2, top: g2, angle: _2, width: v2, height: y2, cropX: b2, cropY: x2 } = t2, S2 = { target: t2, action: c2, actionHandler: s3, actionPerformed: false, corner: a2, scaleX: d2, scaleY: f2, skewX: p2, skewY: m, offsetX: i2.x - h2, offsetY: i2.y - g2, originX: u2.x, originY: u2.y, ex: i2.x, ey: i2.y, lastX: i2.x, lastY: i2.y, theta: I(_2), width: v2, height: y2, shiftKey: e24.shiftKey, altKey: l2, original: { ...kt(t2), originX: u2.x, originY: u2.y, cropX: b2, cropY: x2 } };
      this._currentTransform = S2, this.fire(`before:transform`, { e: e24, transform: S2 });
    }
    setCursor(e24) {
      this.upperCanvasEl.style.cursor = e24;
    }
    _drawSelection(e24) {
      let { x: t2, y: n2, deltaX: r2, deltaY: i2 } = this._groupSelector, a2 = new N(t2, n2).transform(this.viewportTransform), o2 = new N(t2 + r2, n2 + i2).transform(this.viewportTransform), s3 = this.selectionLineWidth / 2, c2 = Math.min(a2.x, o2.x), l2 = Math.min(a2.y, o2.y), u2 = Math.max(a2.x, o2.x), d2 = Math.max(a2.y, o2.y);
      this.selectionColor && (e24.fillStyle = this.selectionColor, e24.fillRect(c2, l2, u2 - c2, d2 - l2)), this.selectionLineWidth && this.selectionBorderColor && (e24.lineWidth = this.selectionLineWidth, e24.strokeStyle = this.selectionBorderColor, c2 += s3, l2 += s3, u2 -= s3, d2 -= s3, J.prototype._setLineDash.call(this, e24, this.selectionDashArray), e24.strokeRect(c2, l2, u2 - c2, d2 - l2));
    }
    findTarget(e24) {
      if (this._targetInfo) return this._targetInfo;
      if (this.skipTargetFind) return { subTargets: [], currentSubTargets: [] };
      let t2 = this.getScenePoint(e24), n2 = this._activeObject, r2 = this.getActiveObjects(), i2 = this.searchPossibleTargets(this._objects, t2), { subTargets: a2, container: o2, target: s3 } = i2, c2 = { ...i2, currentSubTargets: a2, currentContainer: o2, currentTarget: s3 };
      if (!n2) return c2;
      let l2 = { ...this.searchPossibleTargets([n2], t2), currentSubTargets: a2, currentContainer: o2, currentTarget: s3 };
      return n2.findControl(this.getViewportPoint(e24), St(e24)) ? { ...l2, target: n2 } : l2.target && (r2.length > 1 || !this.preserveObjectStacking || this.preserveObjectStacking && e24[this.altSelectionKey]) ? l2 : c2;
    }
    _pointIsInObjectSelectionArea(e24, t2) {
      let n2 = e24.getCoords(), r2 = this.getZoom(), i2 = e24.padding / r2;
      if (i2) {
        let [e25, t3, r3, a2] = n2, o2 = Math.atan2(t3.y - e25.y, t3.x - e25.x), s3 = Se(o2) * i2, c2 = Ce(o2) * i2, l2 = s3 + c2, u2 = s3 - c2;
        n2 = [new N(e25.x - u2, e25.y - l2), new N(t3.x + l2, t3.y - u2), new N(r3.x + u2, r3.y + l2), new N(a2.x - l2, a2.y + u2)];
      }
      return Pr.isPointInPolygon(t2, n2);
    }
    _checkTarget(e24, t2) {
      if (e24 && e24.visible && e24.evented && this._pointIsInObjectSelectionArea(e24, t2)) {
        if (!this.perPixelTargetFind && !e24.perPixelTargetFind || e24.isEditing) return true;
        {
          let n2 = t2.transform(this.viewportTransform);
          if (!this.isTargetTransparent(e24, n2.x, n2.y)) return true;
        }
      }
      return false;
    }
    _searchPossibleTargets(e24, t2, n2) {
      let r2 = e24.length;
      for (; r2--; ) {
        let i2 = e24[r2];
        if (this._checkTarget(i2, t2)) {
          if (Te(i2) && i2.subTargetCheck) {
            let { target: e25 } = this._searchPossibleTargets(i2._objects, t2, n2);
            e25 && n2.push(e25);
          }
          return { target: i2, subTargets: n2 };
        }
      }
      return { subTargets: [] };
    }
    searchPossibleTargets(e24, t2) {
      let n2 = this._searchPossibleTargets(e24, t2, []);
      n2.container = n2.target;
      let { container: r2, subTargets: i2 } = n2;
      if (r2 && Te(r2) && r2.interactive && i2[0]) {
        for (let e25 = i2.length - 1; e25 > 0; e25--) {
          let t3 = i2[e25];
          if (!Te(t3) || !t3.interactive) return n2.target = t3, n2;
        }
        return n2.target = i2[0], n2;
      }
      return n2;
    }
    getViewportPoint(e24) {
      return this._viewportPoint ? this._viewportPoint : this._getPointerImpl(e24, true);
    }
    getScenePoint(e24) {
      return this._scenePoint ? this._scenePoint : this._getPointerImpl(e24);
    }
    _getPointerImpl(e24, t2 = false) {
      let n2 = this.upperCanvasEl, r2 = n2.getBoundingClientRect(), i2 = xt(e24), a2 = r2.width || 0, o2 = r2.height || 0;
      a2 && o2 || (`top` in r2 && `bottom` in r2 && (o2 = Math.abs(r2.top - r2.bottom)), `right` in r2 && `left` in r2 && (a2 = Math.abs(r2.right - r2.left))), this.calcOffset(), i2.x -= this._offset.left, i2.y -= this._offset.top, t2 || (i2 = Mt(i2, void 0, this.viewportTransform));
      let s3 = this.getRetinaScaling();
      s3 !== 1 && (i2.x /= s3, i2.y /= s3);
      let c2 = a2 === 0 || o2 === 0 ? new N(1, 1) : new N(n2.width / a2, n2.height / o2);
      return i2.multiply(c2);
    }
    _setDimensionsImpl(e24, t2) {
      this._resetTransformEventData(), super._setDimensionsImpl(e24, t2), this._isCurrentlyDrawing && this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
    }
    _createCacheCanvas() {
      this.pixelFindCanvasEl = P(), this.pixelFindContext = this.pixelFindCanvasEl.getContext(`2d`, { willReadFrequently: true }), this.setTargetFindTolerance(this.targetFindTolerance);
    }
    getTopContext() {
      return this.elements.upper.ctx;
    }
    getSelectionContext() {
      return this.elements.upper.ctx;
    }
    getSelectionElement() {
      return this.elements.upper.el;
    }
    getActiveObject() {
      return this._activeObject;
    }
    getActiveObjects() {
      let e24 = this._activeObject;
      return at(e24) ? e24.getObjects() : e24 ? [e24] : [];
    }
    _fireSelectionEvents(e24, t2) {
      let n2 = false, r2 = false, i2 = this.getActiveObjects(), a2 = [], o2 = [];
      e24.forEach((e25) => {
        i2.includes(e25) || (n2 = true, e25.fire(`deselected`, { e: t2, target: e25 }), o2.push(e25));
      }), i2.forEach((r3) => {
        e24.includes(r3) || (n2 = true, r3.fire(`selected`, { e: t2, target: r3 }), a2.push(r3));
      }), e24.length > 0 && i2.length > 0 ? (r2 = true, n2 && this.fire(`selection:updated`, { e: t2, selected: a2, deselected: o2 })) : i2.length > 0 ? (r2 = true, this.fire(`selection:created`, { e: t2, selected: a2 })) : e24.length > 0 && (r2 = true, this.fire(`selection:cleared`, { e: t2, deselected: o2 })), r2 && (this._objectsToRender = void 0);
    }
    setActiveObject(e24, t2) {
      let n2 = this.getActiveObjects(), r2 = this._setActiveObject(e24, t2);
      return this._fireSelectionEvents(n2, t2), r2;
    }
    _setActiveObject(e24, t2) {
      let n2 = this._activeObject;
      return n2 !== e24 && !(!this._discardActiveObject(t2, e24) && this._activeObject) && !e24.onSelect({ e: t2 }) && (this._activeObject = e24, at(e24) && n2 !== e24 && e24.set(`canvas`, this), e24.setCoords(), true);
    }
    _discardActiveObject(e24, t2) {
      let n2 = this._activeObject;
      return !!n2 && !n2.onDeselect({ e: e24, object: t2 }) && (this._currentTransform && this._currentTransform.target === n2 && this.endCurrentTransform(e24), at(n2) && n2 === this._hoveredTarget && (this._hoveredTarget = void 0), this._activeObject = void 0, true);
    }
    discardActiveObject(e24) {
      let t2 = this.getActiveObjects(), n2 = this.getActiveObject();
      t2.length && this.fire(`before:selection:cleared`, { e: e24, deselected: [n2] });
      let r2 = this._discardActiveObject(e24);
      return this._fireSelectionEvents(t2, e24), r2;
    }
    endCurrentTransform(e24) {
      let t2 = this._currentTransform;
      this._finalizeCurrentTransform(e24), t2 && t2.target && (t2.target.isMoving = false), this._currentTransform = null;
    }
    _finalizeCurrentTransform(e24) {
      let t2 = this._currentTransform, n2 = t2.target, r2 = { e: e24, target: n2, transform: t2, action: t2.action };
      n2._scaling && (n2._scaling = false), n2.setCoords(), t2.actionPerformed && (this.fire(`object:modified`, r2), n2.fire(ge, r2));
    }
    setViewportTransform(e24) {
      super.setViewportTransform(e24);
      let t2 = this._activeObject;
      t2 && t2.setCoords();
    }
    destroy() {
      let e24 = this._activeObject;
      at(e24) && (e24.removeAll(), e24.dispose()), delete this._activeObject, super.destroy(), this.pixelFindContext = null, this.pixelFindCanvasEl = void 0;
    }
    clear() {
      this.discardActiveObject(), this._activeObject = void 0, this.clearContext(this.contextTop), super.clear();
    }
    drawControls(e24) {
      let t2 = this._activeObject;
      t2 && t2._renderControls(e24);
    }
    _toObject(e24, t2, n2) {
      let r2 = this._realizeGroupTransformOnObject(e24), i2 = super._toObject(e24, t2, n2);
      return e24.set(r2), i2;
    }
    _realizeGroupTransformOnObject(e24) {
      let { group: t2 } = e24;
      if (t2 && at(t2) && this._activeObject === t2) {
        let n2 = et(e24, [`angle`, `flipX`, `flipY`, D, de, fe, pe, me, `top`]);
        return Et(e24, t2.calcOwnMatrix()), n2;
      }
      return {};
    }
    _setSVGObject(e24, t2, n2) {
      let r2 = this._realizeGroupTransformOnObject(t2);
      super._setSVGObject(e24, t2, n2), t2.set(r2);
    }
  };
  i(lo, `ownDefaults`, { uniformScaling: true, uniScaleKey: `shiftKey`, centeredScaling: false, centeredRotation: false, centeredKey: `altKey`, altActionKey: `shiftKey`, selection: true, selectionKey: `shiftKey`, selectionColor: `rgba(100, 100, 255, 0.3)`, selectionDashArray: [], selectionBorderColor: `rgba(255, 255, 255, 0.3)`, selectionLineWidth: 1, selectionFullyContained: false, hoverCursor: `move`, moveCursor: `move`, defaultCursor: `default`, freeDrawingCursor: `crosshair`, notAllowedCursor: `not-allowed`, perPixelTargetFind: false, targetFindTolerance: 0, skipTargetFind: false, stopContextMenu: true, fireRightClick: true, fireMiddleClick: true, enablePointerEvents: false, containerClass: `canvas-container`, preserveObjectStacking: true });
  var uo = class {
    constructor(e24) {
      i(this, `targets`, []), i(this, `__disposer`, void 0);
      let t2 = () => {
        let { hiddenTextarea: t3 } = e24.getActiveObject() || {};
        t3 && t3.focus();
      }, n2 = e24.upperCanvasEl;
      n2.addEventListener(`click`, t2), this.__disposer = () => n2.removeEventListener(`click`, t2);
    }
    exitTextEditing() {
      this.target = void 0, this.targets.forEach((e24) => {
        e24.isEditing && e24.exitEditing();
      });
    }
    add(e24) {
      this.targets.push(e24);
    }
    remove(e24) {
      this.unregister(e24), xe(this.targets, e24);
    }
    register(e24) {
      this.target = e24;
    }
    unregister(e24) {
      e24 === this.target && (this.target = void 0);
    }
    onMouseMove(e24) {
      var t2;
      (t2 = this.target) != null && t2.isEditing && this.target.updateSelectionOnMouseMove(e24);
    }
    clear() {
      this.targets = [], this.target = void 0;
    }
    dispose() {
      this.clear(), this.__disposer(), delete this.__disposer;
    }
  };
  var X = { passive: false };
  var fo = (e24, t2) => ({ viewportPoint: e24.getViewportPoint(t2), scenePoint: e24.getScenePoint(t2) });
  var po = (e24, ...t2) => e24.addEventListener(...t2);
  var Z = (e24, ...t2) => e24.removeEventListener(...t2);
  var mo = { mouse: { in: `over`, out: `out`, targetIn: `mouseover`, targetOut: `mouseout`, canvasIn: `mouse:over`, canvasOut: `mouse:out` }, drag: { in: `enter`, out: `leave`, targetIn: `dragenter`, targetOut: `dragleave`, canvasIn: `drag:enter`, canvasOut: `drag:leave` } };
  var ho = class extends lo {
    constructor(e24, t2 = {}) {
      super(e24, t2), i(this, `_isClick`, void 0), i(this, `textEditingManager`, new uo(this)), [`_onMouseDown`, `_onTouchStart`, `_onMouseMove`, `_onMouseUp`, `_onTouchEnd`, `_onResize`, `_onMouseWheel`, `_onMouseOut`, `_onMouseEnter`, `_onContextMenu`, `_onClick`, `_onDragStart`, `_onDragEnd`, `_onDragProgress`, `_onDragOver`, `_onDragEnter`, `_onDragLeave`, `_onDrop`].forEach((e25) => {
        this[e25] = this[e25].bind(this);
      }), this.addOrRemove(po);
    }
    _getEventPrefix() {
      return this.enablePointerEvents ? `pointer` : `mouse`;
    }
    addOrRemove(e24, t2 = false) {
      let n2 = this.upperCanvasEl, r2 = this._getEventPrefix();
      e24(st(n2), `resize`, this._onResize), e24(n2, r2 + `down`, this._onMouseDown), e24(n2, `${r2}move`, this._onMouseMove, X), e24(n2, `${r2}out`, this._onMouseOut), e24(n2, `${r2}enter`, this._onMouseEnter), e24(n2, `wheel`, this._onMouseWheel, { passive: false }), e24(n2, `contextmenu`, this._onContextMenu), t2 || (e24(n2, `click`, this._onClick), e24(n2, `dblclick`, this._onClick)), e24(n2, `dragstart`, this._onDragStart), e24(n2, `dragend`, this._onDragEnd), e24(n2, `dragover`, this._onDragOver), e24(n2, `dragenter`, this._onDragEnter), e24(n2, `dragleave`, this._onDragLeave), e24(n2, `drop`, this._onDrop), this.enablePointerEvents || e24(n2, `touchstart`, this._onTouchStart, X);
    }
    removeListeners() {
      this.addOrRemove(Z);
      let e24 = this._getEventPrefix(), t2 = H(this.upperCanvasEl);
      Z(t2, `${e24}up`, this._onMouseUp), Z(t2, `touchend`, this._onTouchEnd, X), Z(t2, `${e24}move`, this._onMouseMove, X), Z(t2, `touchmove`, this._onMouseMove, X), clearTimeout(this._willAddMouseDown);
    }
    _onMouseWheel(e24) {
      this._cacheTransformEventData(e24), this._handleEvent(e24, `wheel`), this._resetTransformEventData();
    }
    _onMouseOut(e24) {
      let t2 = this._hoveredTarget, n2 = { e: e24, ...fo(this, e24) };
      this.fire(`mouse:out`, { ...n2, target: t2 }), this._hoveredTarget = void 0, t2 && t2.fire(`mouseout`, { ...n2 }), this._hoveredTargets.forEach((e25) => {
        this.fire(`mouse:out`, { ...n2, target: e25 }), e25 && e25.fire(`mouseout`, { ...n2 });
      }), this._hoveredTargets = [];
    }
    _onMouseEnter(e24) {
      let { target: t2 } = this.findTarget(e24);
      this._currentTransform || t2 || (this.fire(`mouse:over`, { e: e24, ...fo(this, e24) }), this._hoveredTarget = void 0, this._hoveredTargets = []);
    }
    _onDragStart(e24) {
      this._isClick = false;
      let t2 = this.getActiveObject();
      if (t2 && t2.onDragStart(e24)) {
        this._dragSource = t2;
        let n2 = { e: e24, target: t2 };
        this.fire(`dragstart`, n2), t2.fire(`dragstart`, n2), po(this.upperCanvasEl, `drag`, this._onDragProgress);
        return;
      }
      Ct(e24);
    }
    _renderDragEffects(e24, t2, n2) {
      let r2 = false, i2 = this._dropTarget;
      i2 && i2 !== t2 && i2 !== n2 && (i2.clearContextTop(), r2 = true), t2 == null || t2.clearContextTop(), n2 !== t2 && (n2 == null || n2.clearContextTop());
      let a2 = this.contextTop;
      a2.save(), a2.transform(...this.viewportTransform), t2 && (a2.save(), t2.transform(a2), t2.renderDragSourceEffect(e24), a2.restore(), r2 = true), n2 && (a2.save(), n2.transform(a2), n2.renderDropTargetEffect(e24), a2.restore(), r2 = true), a2.restore(), r2 && (this.contextTopDirty = true);
    }
    _onDragEnd(e24) {
      let { currentSubTargets: t2 } = this.findTarget(e24), n2 = !!e24.dataTransfer && e24.dataTransfer.dropEffect !== `none`, r2 = n2 ? this._activeObject : void 0, i2 = { e: e24, target: this._dragSource, subTargets: t2, dragSource: this._dragSource, didDrop: n2, dropTarget: r2 };
      Z(this.upperCanvasEl, `drag`, this._onDragProgress), this.fire(`dragend`, i2), this._dragSource && this._dragSource.fire(`dragend`, i2), delete this._dragSource, this._onMouseUp(e24);
    }
    _onDragProgress(e24) {
      let t2 = { e: e24, target: this._dragSource, dragSource: this._dragSource, dropTarget: this._draggedoverTarget };
      this.fire(`drag`, t2), this._dragSource && this._dragSource.fire(`drag`, t2);
    }
    _onDragOver(e24) {
      let t2 = `dragover`, { currentContainer: n2, currentSubTargets: r2 } = this.findTarget(e24), i2 = this._dragSource, a2 = { e: e24, target: n2, subTargets: r2, dragSource: i2, canDrop: false, dropTarget: void 0 }, o2;
      this.fire(t2, a2), this._fireEnterLeaveEvents(e24, n2, a2), n2 && (n2.canDrop(e24) && (o2 = n2), n2.fire(t2, a2));
      for (let n3 = 0; n3 < r2.length; n3++) {
        let i3 = r2[n3];
        i3.canDrop(e24) && (o2 = i3), i3.fire(t2, a2);
      }
      this._renderDragEffects(e24, i2, o2), this._dropTarget = o2;
    }
    _onDragEnter(e24) {
      let { currentContainer: t2, currentSubTargets: n2 } = this.findTarget(e24), r2 = { e: e24, target: t2, subTargets: n2, dragSource: this._dragSource };
      this.fire(`dragenter`, r2), this._fireEnterLeaveEvents(e24, t2, r2);
    }
    _onDragLeave(e24) {
      let { currentSubTargets: t2 } = this.findTarget(e24), n2 = { e: e24, target: this._draggedoverTarget, subTargets: t2, dragSource: this._dragSource };
      this.fire(`dragleave`, n2), this._fireEnterLeaveEvents(e24, void 0, n2), this._renderDragEffects(e24, this._dragSource), this._dropTarget = void 0, this._hoveredTargets = [];
    }
    _onDrop(e24) {
      let { currentContainer: t2, currentSubTargets: n2 } = this.findTarget(e24), r2 = this._basicEventHandler(`drop:before`, { e: e24, target: t2, subTargets: n2, dragSource: this._dragSource, ...fo(this, e24) });
      r2.didDrop = false, r2.dropTarget = void 0, this._basicEventHandler(`drop`, r2), this.fire(`drop:after`, r2);
    }
    _onContextMenu(e24) {
      let { target: t2, subTargets: n2 } = this.findTarget(e24), r2 = this._basicEventHandler(`contextmenu:before`, { e: e24, target: t2, subTargets: n2 });
      return this.stopContextMenu && Ct(e24), this._basicEventHandler(`contextmenu`, r2), false;
    }
    _onClick(e24) {
      let t2 = e24.detail;
      t2 > 3 || t2 < 2 || (this._cacheTransformEventData(e24), t2 == 2 && e24.type === `dblclick` && this._handleEvent(e24, `dblclick`), t2 == 3 && this._handleEvent(e24, `tripleclick`), this._resetTransformEventData());
    }
    fireEventFromPointerEvent(e24, t2, n2, r2 = {}) {
      this._cacheTransformEventData(e24);
      let { target: i2, subTargets: a2 } = this.findTarget(e24), o2 = { e: e24, target: i2, subTargets: a2, ...fo(this, e24), transform: this._currentTransform, ...r2 };
      this.fire(t2, o2), i2 && i2.fire(n2, o2);
      for (let e25 = 0; e25 < a2.length; e25++) a2[e25] !== i2 && a2[e25].fire(n2, o2);
      this._resetTransformEventData();
    }
    getPointerId(e24) {
      let t2 = e24.changedTouches;
      return t2 ? t2[0] && t2[0].identifier : this.enablePointerEvents ? e24.pointerId : -1;
    }
    _isMainEvent(e24) {
      return true === e24.isPrimary || false !== e24.isPrimary && (e24.type === `touchend` && e24.touches.length === 0 || !e24.changedTouches || e24.changedTouches[0].identifier === this.mainTouchId);
    }
    _onTouchStart(e24) {
      this._cacheTransformEventData(e24);
      let t2 = !this.allowTouchScrolling, n2 = this._activeObject;
      this.mainTouchId === void 0 && (this.mainTouchId = this.getPointerId(e24)), this.__onMouseDown(e24);
      let { target: r2 } = this.findTarget(e24);
      (this.isDrawingMode || n2 && r2 === n2) && (t2 = true), t2 && e24.preventDefault();
      let i2 = this.upperCanvasEl, a2 = this._getEventPrefix(), o2 = H(i2);
      po(o2, `touchend`, this._onTouchEnd, X), t2 && po(o2, `touchmove`, this._onMouseMove, X), Z(i2, `${a2}down`, this._onMouseDown), this._resetTransformEventData();
    }
    _onMouseDown(e24) {
      this._cacheTransformEventData(e24), this.__onMouseDown(e24);
      let t2 = this.upperCanvasEl, n2 = this._getEventPrefix();
      Z(t2, `${n2}move`, this._onMouseMove, X);
      let r2 = H(t2);
      po(r2, `${n2}up`, this._onMouseUp), po(r2, `${n2}move`, this._onMouseMove, X), this._resetTransformEventData();
    }
    _onTouchEnd(e24) {
      if (e24.touches.length > 0) return;
      this._cacheTransformEventData(e24), this.__onMouseUp(e24), this._resetTransformEventData(), delete this.mainTouchId;
      let t2 = this._getEventPrefix(), n2 = H(this.upperCanvasEl);
      Z(n2, `touchend`, this._onTouchEnd, X), Z(n2, `touchmove`, this._onMouseMove, X), this._willAddMouseDown && clearTimeout(this._willAddMouseDown), this._willAddMouseDown = setTimeout(() => {
        po(this.upperCanvasEl, `${t2}down`, this._onMouseDown), this._willAddMouseDown = 0;
      }, 400);
    }
    _onMouseUp(e24) {
      this._cacheTransformEventData(e24), this.__onMouseUp(e24);
      let t2 = this.upperCanvasEl, n2 = this._getEventPrefix();
      if (this._isMainEvent(e24)) {
        let e25 = H(this.upperCanvasEl);
        Z(e25, `${n2}up`, this._onMouseUp), Z(e25, `${n2}move`, this._onMouseMove, X), po(t2, `${n2}move`, this._onMouseMove, X);
      }
      this._resetTransformEventData();
    }
    _onMouseMove(e24) {
      this._cacheTransformEventData(e24);
      let t2 = this.getActiveObject();
      !this.allowTouchScrolling && (!t2 || !t2.shouldStartDragging(e24)) && e24.preventDefault && e24.preventDefault(), this.__onMouseMove(e24), this._resetTransformEventData();
    }
    _onResize() {
      this.calcOffset(), this._resetTransformEventData();
    }
    _shouldRender(e24) {
      let t2 = this.getActiveObject();
      return !!t2 != !!e24 || t2 && e24 && t2 !== e24;
    }
    __onMouseUp(e24) {
      var t2;
      this._handleEvent(e24, `up:before`);
      let n2 = this._currentTransform, r2 = this._isClick, { target: i2 } = this.findTarget(e24), { button: a2 } = e24;
      if (a2) return void ((this.fireMiddleClick && a2 === 1 || this.fireRightClick && a2 === 2) && this._handleEvent(e24, `up`));
      if (this.isDrawingMode && this._isCurrentlyDrawing) return void this._onMouseUpInDrawingMode(e24);
      if (!this._isMainEvent(e24)) return;
      let o2, s3, c2 = false;
      if (n2 && (this._finalizeCurrentTransform(e24), c2 = n2.actionPerformed), !r2) {
        let t3 = i2 === this._activeObject;
        this.handleSelection(e24), c2 || (c2 = this._shouldRender(i2) || !t3 && i2 === this._activeObject);
      }
      if (i2) {
        let { key: t3, control: r3 } = i2.findControl(this.getViewportPoint(e24), St(e24)) || {};
        if (s3 = t3, i2.selectable && i2 !== this._activeObject && i2.activeOn === `up`) this.setActiveObject(i2, e24), c2 = true;
        else if (r3) {
          let t4 = r3.getMouseUpHandler(e24, i2, r3);
          t4 && (o2 = this.getScenePoint(e24), t4.call(r3, e24, n2, o2.x, o2.y));
        }
        i2.isMoving = false;
      }
      if (n2 && (n2.target !== i2 || n2.corner !== s3)) {
        let t3 = n2.target && n2.target.controls[n2.corner], r3 = t3 && t3.getMouseUpHandler(e24, n2.target, t3);
        o2 = o2 || this.getScenePoint(e24), r3 && r3.call(t3, e24, n2, o2.x, o2.y);
      }
      this._setCursorFromEvent(e24, i2), this._handleEvent(e24, `up`), this._groupSelector = null, this._currentTransform = null, i2 && (i2.__corner = void 0), c2 ? this.requestRenderAll() : r2 || (t2 = this._activeObject) != null && t2.isEditing || this.renderTop();
    }
    _basicEventHandler(e24, t2) {
      let { target: n2, subTargets: r2 = [] } = t2;
      this.fire(e24, t2), n2 && n2.fire(e24, t2);
      for (let i2 = 0; i2 < r2.length; i2++) r2[i2] !== n2 && r2[i2].fire(e24, t2);
      return t2;
    }
    _handleEvent(e24, t2, n2) {
      let { target: r2, subTargets: i2 } = this.findTarget(e24), a2 = { e: e24, target: r2, subTargets: i2, ...fo(this, e24), transform: this._currentTransform, ...t2 === `down:before` || t2 === `down` ? n2 : {} };
      t2 !== `up:before` && t2 !== `up` || (a2.isClick = this._isClick), this.fire(`mouse:${t2}`, a2), r2 && r2.fire(`mouse${t2}`, a2);
      for (let e25 = 0; e25 < i2.length; e25++) i2[e25] !== r2 && i2[e25].fire(`mouse${t2}`, a2);
    }
    _onMouseDownInDrawingMode(e24) {
      this._isCurrentlyDrawing = true, this.getActiveObject() && (this.discardActiveObject(e24), this.requestRenderAll());
      let t2 = this.getScenePoint(e24);
      this.freeDrawingBrush && this.freeDrawingBrush.onMouseDown(t2, { e: e24, pointer: t2 }), this._handleEvent(e24, `down`, { alreadySelected: false });
    }
    _onMouseMoveInDrawingMode(e24) {
      if (this._isCurrentlyDrawing) {
        let t2 = this.getScenePoint(e24);
        this.freeDrawingBrush && this.freeDrawingBrush.onMouseMove(t2, { e: e24, pointer: t2 });
      }
      this.setCursor(this.freeDrawingCursor), this._handleEvent(e24, `move`);
    }
    _onMouseUpInDrawingMode(e24) {
      let t2 = this.getScenePoint(e24);
      this.freeDrawingBrush ? this._isCurrentlyDrawing = !!this.freeDrawingBrush.onMouseUp({ e: e24, pointer: t2 }) : this._isCurrentlyDrawing = false, this._handleEvent(e24, `up`);
    }
    __onMouseDown(e24) {
      this._isClick = true, this._handleEvent(e24, `down:before`);
      let { target: t2 } = this.findTarget(e24), n2 = !!t2 && t2 === this._activeObject, { button: r2 } = e24;
      if (r2) return void ((this.fireMiddleClick && r2 === 1 || this.fireRightClick && r2 === 2) && this._handleEvent(e24, `down`, { alreadySelected: n2 }));
      if (this.isDrawingMode) return void this._onMouseDownInDrawingMode(e24);
      if (!this._isMainEvent(e24) || this._currentTransform) return;
      let i2 = this._shouldRender(t2), a2 = false;
      if (this.handleMultiSelection(e24, t2) ? (t2 = this._activeObject, a2 = true, i2 = true) : this._shouldClearSelection(e24, t2) && this.discardActiveObject(e24), this.selection && (!t2 || !t2.selectable && !t2.isEditing && t2 !== this._activeObject)) {
        let t3 = this.getScenePoint(e24);
        this._groupSelector = { x: t3.x, y: t3.y, deltaY: 0, deltaX: 0 };
      }
      if (n2 = !!t2 && t2 === this._activeObject, t2) {
        t2.selectable && t2.activeOn === `down` && this.setActiveObject(t2, e24);
        let r3 = t2.findControl(this.getViewportPoint(e24), St(e24));
        if (t2 === this._activeObject && (r3 || !a2)) {
          this._setupCurrentTransform(e24, t2, n2);
          let i3 = r3 ? r3.control : void 0, a3 = this.getScenePoint(e24), o2 = i3 && i3.getMouseDownHandler(e24, t2, i3);
          o2 && o2.call(i3, e24, this._currentTransform, a3.x, a3.y);
        }
      }
      i2 && (this._objectsToRender = void 0), this._handleEvent(e24, `down`, { alreadySelected: n2 }), i2 && this.requestRenderAll();
    }
    _resetTransformEventData() {
      this._targetInfo = this._viewportPoint = this._scenePoint = void 0;
    }
    _cacheTransformEventData(e24) {
      this._resetTransformEventData(), this._viewportPoint = this.getViewportPoint(e24), this._scenePoint = Mt(this._viewportPoint, void 0, this.viewportTransform), this._targetInfo = this.findTarget(e24), this._currentTransform && (this._targetInfo.target = this._currentTransform.target);
    }
    __onMouseMove(e24) {
      if (this._isClick = false, this._handleEvent(e24, `move:before`), this.isDrawingMode) return void this._onMouseMoveInDrawingMode(e24);
      if (!this._isMainEvent(e24)) return;
      let t2 = this._groupSelector;
      if (t2) {
        let n2 = this.getScenePoint(e24);
        t2.deltaX = n2.x - t2.x, t2.deltaY = n2.y - t2.y, this.renderTop();
      } else if (this._currentTransform) this._transformObject(e24);
      else {
        let { target: t3 } = this.findTarget(e24);
        this._setCursorFromEvent(e24, t3), this._fireOverOutEvents(e24, t3);
      }
      this.textEditingManager.onMouseMove(e24), this._handleEvent(e24, `move`);
    }
    _fireOverOutEvents(e24, t2) {
      let { _hoveredTarget: n2, _hoveredTargets: r2 } = this, { subTargets: i2, currentTarget: a2 } = this.findTarget(e24), o2 = Math.max(r2.length, i2.length);
      this.fireSyntheticInOutEvents(`mouse`, { e: e24, target: t2, oldTarget: n2, actualTarget: a2, oldActualTarget: this._hoveredActualTarget, fireCanvas: true });
      for (let a3 = 0; a3 < o2; a3++) i2[a3] === t2 || r2[a3] && r2[a3] === n2 || this.fireSyntheticInOutEvents(`mouse`, { e: e24, target: i2[a3], oldTarget: r2[a3] });
      this._hoveredActualTarget = a2, this._hoveredTarget = t2, this._hoveredTargets = i2;
    }
    _fireEnterLeaveEvents(e24, t2, n2) {
      let r2 = this._draggedoverTarget, i2 = this._hoveredTargets, { subTargets: a2 } = this.findTarget(e24), o2 = Math.max(i2.length, a2.length);
      this.fireSyntheticInOutEvents(`drag`, { ...n2, target: t2, oldTarget: r2, fireCanvas: true });
      for (let e25 = 0; e25 < o2; e25++) this.fireSyntheticInOutEvents(`drag`, { ...n2, target: a2[e25], oldTarget: i2[e25] });
      this._draggedoverTarget = t2;
    }
    fireSyntheticInOutEvents(e24, { target: t2, oldTarget: n2, actualTarget: r2, oldActualTarget: i2, fireCanvas: a2, e: o2, ...s3 }) {
      let { targetIn: c2, targetOut: l2, canvasIn: u2, canvasOut: d2 } = mo[e24], f2 = n2 !== t2, p2 = i2 !== r2, m = t2 && f2, h2 = r2 && p2, g2 = n2 && f2, _2 = i2 && p2, v2 = { ...s3, e: o2, ...fo(this, o2) }, y2 = { ...v2, target: n2, nextTarget: t2, actualTarget: i2, nextActualTarget: r2 };
      (g2 || _2) && a2 && this.fire(d2, y2), g2 && n2.fire(l2, y2), _2 && n2 !== i2 && i2.fire(l2, y2);
      let b2 = { ...v2, target: t2, previousTarget: n2, actualTarget: r2, previousActualTarget: i2 };
      (m || h2) && a2 && this.fire(u2, b2), m && t2.fire(c2, b2), h2 && r2 !== t2 && r2.fire(c2, b2);
    }
    _transformObject(e24) {
      let t2 = this.getScenePoint(e24), n2 = this._currentTransform, r2 = n2.target, i2 = r2.group ? Mt(t2, void 0, r2.group.calcTransformMatrix()) : t2;
      n2.shiftKey = e24.shiftKey, n2.altKey = !!this.centeredKey && e24[this.centeredKey], this._performTransformAction(e24, n2, i2), n2.actionPerformed && this.requestRenderAll();
    }
    _performTransformAction(e24, t2, n2) {
      let { action: r2, actionHandler: i2, target: a2 } = t2, o2 = !!i2 && i2(e24, t2, n2.x, n2.y);
      o2 && a2.setCoords(), r2 === `drag` && o2 && (t2.target.isMoving = true, this.setCursor(t2.target.moveCursor || this.moveCursor)), t2.actionPerformed = t2.actionPerformed || o2;
    }
    _setCursorFromEvent(e24, t2) {
      if (!t2) return void this.setCursor(this.defaultCursor);
      let n2 = t2.hoverCursor || this.hoverCursor, r2 = at(this._activeObject) ? this._activeObject : null, i2 = (!r2 || t2.group !== r2) && t2.findControl(this.getViewportPoint(e24));
      if (i2) {
        let { control: n3, coord: r3 } = i2;
        this.setCursor(n3.cursorStyleHandler(e24, n3, t2, r3));
      } else {
        if (t2.subTargetCheck) {
          let { subTargets: t3 } = this.findTarget(e24);
          t3.concat().reverse().forEach((e25) => {
            n2 = e25.hoverCursor || n2;
          });
        }
        this.setCursor(n2);
      }
    }
    handleMultiSelection(e24, t2) {
      let n2 = this._activeObject, r2 = at(n2);
      if (n2 && this._isSelectionKeyPressed(e24) && this.selection && t2 && t2.selectable && (n2 !== t2 || r2) && (r2 || !t2.isDescendantOf(n2) && !n2.isDescendantOf(t2)) && !t2.onSelect({ e: e24 }) && !n2.getActiveControl()) {
        if (r2) {
          let r3 = n2.getObjects(), i2 = [];
          if (t2 === n2) {
            let n3 = this.getScenePoint(e24), a2 = this.searchPossibleTargets(r3, n3);
            if (a2.target ? (t2 = a2.target, i2 = a2.subTargets) : (a2 = this.searchPossibleTargets(this._objects, n3), t2 = a2.target, i2 = a2.subTargets), !t2 || !t2.selectable) return false;
          }
          t2.group === n2 ? (n2.remove(t2), this._hoveredTarget = t2, this._hoveredTargets = i2, n2.size() === 1 && this._setActiveObject(n2.item(0), e24)) : (n2.multiSelectAdd(t2), this._hoveredTarget = n2, this._hoveredTargets = i2), this._fireSelectionEvents(r3, e24);
        } else {
          n2.isEditing && n2.exitEditing();
          let r3 = new (M.getClass(`ActiveSelection`))([], { canvas: this });
          r3.multiSelectAdd(n2, t2), this._hoveredTarget = r3, this._setActiveObject(r3, e24), this._fireSelectionEvents([n2], e24);
        }
        return true;
      }
      return false;
    }
    handleSelection(e24) {
      if (!this.selection || !this._groupSelector) return false;
      let { x: t2, y: n2, deltaX: r2, deltaY: i2 } = this._groupSelector, a2 = new N(t2, n2), o2 = a2.add(new N(r2, i2)), s3 = a2.min(o2), c2 = a2.max(o2).subtract(s3), l2 = this.collectObjects({ left: s3.x, top: s3.y, width: c2.x, height: c2.y }, { includeIntersecting: !this.selectionFullyContained }), u2 = a2.eq(o2) ? l2[0] ? [l2[0]] : [] : l2.length > 1 ? l2.filter((t3) => !t3.onSelect({ e: e24 })).reverse() : l2;
      if (u2.length === 1) this.setActiveObject(u2[0], e24);
      else if (u2.length > 1) {
        let t3 = M.getClass(`ActiveSelection`);
        this.setActiveObject(new t3(u2, { canvas: this }), e24);
      }
      return this._groupSelector = null, true;
    }
    toCanvasElement(e24 = 1, t2) {
      let { upper: n2 } = this.elements;
      n2.ctx = void 0;
      let r2 = super.toCanvasElement(e24, t2);
      return n2.ctx = n2.el.getContext(`2d`), r2;
    }
    clear() {
      this.textEditingManager.clear(), super.clear();
    }
    destroy() {
      this.removeListeners(), this.textEditingManager.dispose(), super.destroy();
    }
  };
  var go = { x1: 0, y1: 0, x2: 0, y2: 0 };
  var _o = { ...go, r1: 0, r2: 0 };
  var vo = (e24, t2) => isNaN(e24) && typeof t2 == `number` ? t2 : e24;
  function yo(e24) {
    return e24 && /%$/.test(e24) && Number.isFinite(parseFloat(e24));
  }
  function bo(e24, t2) {
    return Vn(0, vo(typeof e24 == `number` ? e24 : typeof e24 == `string` ? parseFloat(e24) / (yo(e24) ? 100 : 1) : NaN, t2), 1);
  }
  var xo = /\s*;\s*/;
  var So = /\s*:\s*/;
  function Co(e24, t2) {
    let n2, r2, i2 = e24.getAttribute(`style`);
    if (i2) {
      let e25 = i2.split(xo);
      e25[e25.length - 1] === `` && e25.pop();
      for (let t3 = e25.length; t3--; ) {
        let [i3, a3] = e25[t3].split(So).map((e26) => e26.trim());
        i3 === `stop-color` ? n2 = a3 : i3 === `stop-opacity` && (r2 = a3);
      }
    }
    n2 = n2 || e24.getAttribute(`stop-color`) || `rgb(0,0,0)`, r2 = vo(parseFloat(r2 || e24.getAttribute(`stop-opacity`) || ``), 1);
    let a2 = new G(n2);
    return a2.setAlpha(a2.getAlpha() * r2 * t2), { offset: bo(e24.getAttribute(`offset`), 0), color: a2.toRgba() };
  }
  function wo(e24, t2) {
    let n2 = [], r2 = e24.getElementsByTagName(`stop`), i2 = bo(t2, 1);
    for (let e25 = r2.length; e25--; ) n2.push(Co(r2[e25], i2));
    return n2;
  }
  function To(e24) {
    return e24.nodeName === `linearGradient` || e24.nodeName === `LINEARGRADIENT` ? `linear` : `radial`;
  }
  function Eo(e24) {
    return e24.getAttribute(`gradientUnits`) === `userSpaceOnUse` ? `pixels` : `percentage`;
  }
  function Do(e24, t2) {
    return e24.getAttribute(t2);
  }
  function Oo(e24, t2) {
    return function(e25, { width: t3, height: n2, gradientUnits: r2 }) {
      let i2;
      return Object.entries(e25).reduce((e26, [a2, o2]) => {
        if (o2 === `Infinity`) i2 = 1;
        else if (o2 === `-Infinity`) i2 = 0;
        else {
          let e27 = typeof o2 == `string`;
          i2 = e27 ? parseFloat(o2) : o2, e27 && yo(o2) && (i2 *= 0.01, r2 === `pixels` && (a2 !== `x1` && a2 !== `x2` && a2 !== `r2` || (i2 *= t3), a2 !== `y1` && a2 !== `y2` || (i2 *= n2)));
        }
        return e26[a2] = i2, e26;
      }, {});
    }(To(e24) === `linear` ? function(e25) {
      return { x1: Do(e25, `x1`) || 0, y1: Do(e25, `y1`) || 0, x2: Do(e25, `x2`) || `100%`, y2: Do(e25, `y2`) || 0 };
    }(e24) : function(e25) {
      return { x1: Do(e25, `fx`) || Do(e25, `cx`) || `50%`, y1: Do(e25, `fy`) || Do(e25, `cy`) || `50%`, r1: 0, x2: Do(e25, `cx`) || `50%`, y2: Do(e25, `cy`) || `50%`, r2: Do(e25, `r`) || `50%` };
    }(e24), { ...t2, gradientUnits: Eo(e24) });
  }
  var ko = class {
    constructor(e24) {
      let { type: t2 = `linear`, gradientUnits: n2 = `pixels`, coords: r2 = {}, colorStops: i2 = [], offsetX: a2 = 0, offsetY: o2 = 0, gradientTransform: s3, id: c2 } = e24 || {};
      Object.assign(this, { type: t2, gradientUnits: n2, coords: { ...t2 === `radial` ? _o : go, ...r2 }, colorStops: i2, offsetX: a2, offsetY: o2, gradientTransform: s3, id: c2 ? `${c2}_${je()}` : je() });
    }
    addColorStop(e24) {
      for (let t2 in e24) this.colorStops.push({ offset: parseFloat(t2), color: e24[t2] });
      return this;
    }
    toObject(e24) {
      return { ...et(this, e24), type: this.type, coords: { ...this.coords }, colorStops: this.colorStops.map((e25) => ({ ...e25 })), offsetX: this.offsetX, offsetY: this.offsetY, gradientUnits: this.gradientUnits, gradientTransform: this.gradientTransform ? [...this.gradientTransform] : void 0 };
    }
    toSVG(e24, { additionalTransform: t2 } = {}) {
      let n2 = [], r2 = this.gradientTransform ? this.gradientTransform.concat() : T.concat(), i2 = this.gradientUnits === `pixels` ? `userSpaceOnUse` : `objectBoundingBox`, a2 = this.colorStops.map((e25) => ({ ...e25 })).sort((e25, t3) => e25.offset - t3.offset), o2 = -this.offsetX, s3 = -this.offsetY;
      var c2;
      i2 === `objectBoundingBox` ? (o2 /= e24.width, s3 /= e24.height) : (o2 += e24.width / 2, s3 += e24.height / 2), (c2 = e24) && typeof c2._renderPathCommands == `function` && this.gradientUnits !== `percentage` && (o2 -= e24.pathOffset.x, s3 -= e24.pathOffset.y), r2[4] -= o2, r2[5] -= s3;
      let l2 = [`id="SVGID_${U(String(this.id))}"`, `gradientUnits="${i2}"`, `gradientTransform="${t2 ? t2 + ` ` : ``}${nt(r2)}"`, ``].join(` `), u2 = (e25) => parseFloat(String(e25));
      if (this.type === `linear`) {
        let { x1: e25, y1: t3, x2: r3, y2: i3 } = this.coords, a3 = u2(e25), o3 = u2(t3), s4 = u2(r3), c3 = u2(i3);
        n2.push(`<linearGradient `, l2, ` x1="`, a3, `" y1="`, o3, `" x2="`, s4, `" y2="`, c3, `">
`);
      } else if (this.type === `radial`) {
        let { x1: e25, y1: t3, x2: r3, y2: i3, r1: o3, r2: s4 } = this.coords, c3 = u2(e25), d2 = u2(t3), f2 = u2(r3), p2 = u2(i3), m = u2(o3), h2 = u2(s4), g2 = m > h2;
        n2.push(`<radialGradient `, l2, ` cx="`, g2 ? c3 : f2, `" cy="`, g2 ? d2 : p2, `" r="`, g2 ? m : h2, `" fx="`, g2 ? f2 : c3, `" fy="`, g2 ? p2 : d2, `">
`), g2 && (a2.reverse(), a2.forEach((e26) => {
          e26.offset = 1 - e26.offset;
        }));
        let _2 = Math.min(m, h2);
        if (_2 > 0) {
          let e26 = _2 / Math.max(m, h2);
          a2.forEach((t4) => {
            t4.offset += e26 * (1 - t4.offset);
          });
        }
      }
      return a2.forEach(({ color: e25, offset: t3 }) => {
        let r3 = String(e25), i3 = nn(r3) ? r3 : new G(r3).toRgba();
        n2.push(`<stop offset="${100 * t3}%" style="stop-color:${U(i3)};"/>
`);
      }), n2.push(this.type === `linear` ? `</linearGradient>` : `</radialGradient>`, `
`), n2.join(``);
    }
    toLive(e24) {
      let { x1: t2, y1: n2, x2: r2, y2: i2, r1: a2, r2: o2 } = this.coords, s3 = this.type === `linear` ? e24.createLinearGradient(t2, n2, r2, i2) : e24.createRadialGradient(t2, n2, a2, r2, i2, o2);
      return this.colorStops.forEach(({ color: e25, offset: t3 }) => {
        s3.addColorStop(t3, e25);
      }), s3;
    }
    static async fromObject(e24) {
      let { colorStops: t2, gradientTransform: n2 } = e24;
      return new this({ ...e24, colorStops: t2 ? t2.map((e25) => ({ ...e25 })) : void 0, gradientTransform: n2 ? [...n2] : void 0 });
    }
    static fromElement(e24, t2, n2) {
      let r2 = Eo(e24), i2 = t2._findCenterFromElement();
      return new this({ id: e24.getAttribute(`id`) || void 0, type: To(e24), coords: Oo(e24, { width: n2.viewBoxWidth || n2.width, height: n2.viewBoxHeight || n2.height }), colorStops: wo(e24, n2.opacity), gradientUnits: r2, gradientTransform: Ki(e24.getAttribute(`gradientTransform`) || ``), ...r2 === `pixels` ? { offsetX: t2.width / 2 - i2.x, offsetY: t2.height / 2 - i2.y } : { offsetX: 0, offsetY: 0 } });
    }
  };
  i(ko, `type`, `Gradient`), M.setClass(ko, `gradient`), M.setClass(ko, `linear`), M.setClass(ko, `radial`);
  var Ao = class {
    get type() {
      return `pattern`;
    }
    set type(e24) {
      s(`warn`, `Setting type has no effect`, e24);
    }
    constructor(e24) {
      i(this, `repeat`, `repeat`), i(this, `offsetX`, 0), i(this, `offsetY`, 0), i(this, `crossOrigin`, ``), this.id = je(), Object.assign(this, e24);
    }
    isImageSource() {
      return !!this.source && typeof this.source.src == `string`;
    }
    isCanvasSource() {
      return !!this.source && !!this.source.toDataURL;
    }
    sourceToString() {
      return this.isImageSource() ? this.source.src : this.isCanvasSource() ? this.source.toDataURL() : ``;
    }
    toLive(e24) {
      return this.source && (!this.isImageSource() || this.source.complete && this.source.naturalWidth !== 0 && this.source.naturalHeight !== 0) ? e24.createPattern(this.source, this.repeat) : null;
    }
    toObject(e24 = []) {
      let { repeat: t2, crossOrigin: n2 } = this;
      return { ...et(this, e24), type: `pattern`, source: this.sourceToString(), repeat: t2, crossOrigin: n2, offsetX: B(this.offsetX, o.NUM_FRACTION_DIGITS), offsetY: B(this.offsetY, o.NUM_FRACTION_DIGITS), patternTransform: this.patternTransform ? [...this.patternTransform] : null };
    }
    toSVG({ width: e24, height: t2 }) {
      let { source: n2, repeat: r2, id: i2 } = this, a2 = vo(this.offsetX / e24, 0), o2 = vo(this.offsetY / t2, 0), s3 = r2 === `repeat-y` || r2 === `no-repeat` ? 1 + Math.abs(a2 || 0) : vo(n2.width / e24, 0), c2 = r2 === `repeat-x` || r2 === `no-repeat` ? 1 + Math.abs(o2 || 0) : vo(n2.height / t2, 0);
      return [`<pattern id="SVGID_${U(i2)}" x="${a2}" y="${o2}" width="${s3}" height="${c2}">`, `<image x="0" y="0" width="${n2.width}" height="${n2.height}" xlink:href="${U(this.sourceToString())}"></image>`, `</pattern>`, ``].join(`
`);
    }
    static async fromObject({ type: e24, source: t2, patternTransform: n2, ...r2 }, i2) {
      let a2 = await Ze(t2, { ...i2, crossOrigin: r2.crossOrigin });
      return new this({ ...r2, patternTransform: n2 && n2.slice(0), source: a2 });
    }
  };
  i(Ao, `type`, `Pattern`), M.setClass(Ao), M.setClass(Ao, `pattern`);
  var Mo = class e13 extends J {
    constructor(t2, { path: n2, left: r2, top: i2, ...a2 } = {}) {
      super(), Object.assign(this, e13.ownDefaults), this.setOptions(a2), this._setPath(t2 || [], true), typeof r2 == `number` && this.set(`left`, r2), typeof i2 == `number` && this.set(`top`, i2);
    }
    _setPath(e24, t2) {
      this.path = ba(Array.isArray(e24) ? e24 : La(e24)), this.setBoundingBox(t2);
    }
    _findCenterFromElement() {
      let e24 = this._calcBoundsFromPath();
      return new N(e24.left + e24.width / 2, e24.top + e24.height / 2);
    }
    _renderPathCommands(e24) {
      let t2 = -this.pathOffset.x, n2 = -this.pathOffset.y;
      e24.beginPath();
      for (let r2 of this.path) switch (r2[0]) {
        case `L`:
          e24.lineTo(r2[1] + t2, r2[2] + n2);
          break;
        case `M`:
          e24.moveTo(r2[1] + t2, r2[2] + n2);
          break;
        case `C`:
          e24.bezierCurveTo(r2[1] + t2, r2[2] + n2, r2[3] + t2, r2[4] + n2, r2[5] + t2, r2[6] + n2);
          break;
        case `Q`:
          e24.quadraticCurveTo(r2[1] + t2, r2[2] + n2, r2[3] + t2, r2[4] + n2);
          break;
        case `Z`:
          e24.closePath();
      }
    }
    _render(e24) {
      this._renderPathCommands(e24), this._renderPaintInOrder(e24);
    }
    toString() {
      return `#<Path (${this.complexity()}): { "top": ${this.top}, "left": ${this.left} }>`;
    }
    toObject(e24 = []) {
      return { ...super.toObject(e24), path: this.path.map((e25) => e25.slice()) };
    }
    toDatalessObject(e24 = []) {
      let t2 = this.toObject(e24);
      return this.sourcePath && (delete t2.path, t2.sourcePath = this.sourcePath), t2;
    }
    _toSVG() {
      return [`<path `, `COMMON_PARTS`, `d="${Va(this.path, o.NUM_FRACTION_DIGITS)}" stroke-linecap="round" />
`];
    }
    _getOffsetTransform() {
      let e24 = o.NUM_FRACTION_DIGITS;
      return ` translate(${B(-this.pathOffset.x, e24)}, ${B(-this.pathOffset.y, e24)})`;
    }
    toClipPathSVG(e24) {
      let t2 = this._getOffsetTransform();
      return `	` + this._createBaseClipPathSVGMarkup(this._toSVG(), { reviver: e24, additionalTransform: t2 });
    }
    toSVG(e24) {
      let t2 = this._getOffsetTransform();
      return this._createBaseSVGMarkup(this._toSVG(), { reviver: e24, additionalTransform: t2 });
    }
    complexity() {
      return this.path.length;
    }
    setDimensions() {
      this.setBoundingBox();
    }
    setBoundingBox(e24) {
      let { width: t2, height: n2, pathOffset: r2 } = this._calcDimensions();
      this.set({ width: t2, height: n2, pathOffset: r2 }), e24 && this.setPositionByOrigin(r2, `center`, `center`);
    }
    _calcBoundsFromPath() {
      let e24 = [], t2 = 0, n2 = 0, r2 = 0, i2 = 0;
      for (let a2 of this.path) switch (a2[0]) {
        case `L`:
          r2 = a2[1], i2 = a2[2], e24.push({ x: t2, y: n2 }, { x: r2, y: i2 });
          break;
        case `M`:
          r2 = a2[1], i2 = a2[2], t2 = r2, n2 = i2;
          break;
        case `C`:
          e24.push(...va(r2, i2, a2[1], a2[2], a2[3], a2[4], a2[5], a2[6])), r2 = a2[5], i2 = a2[6];
          break;
        case `Q`:
          e24.push(...va(r2, i2, a2[1], a2[2], a2[1], a2[2], a2[3], a2[4])), r2 = a2[3], i2 = a2[4];
          break;
        case `Z`:
          r2 = t2, i2 = n2;
      }
      return wt(e24);
    }
    _calcDimensions() {
      let e24 = this._calcBoundsFromPath();
      return { ...e24, pathOffset: new N(e24.left + e24.width / 2, e24.top + e24.height / 2) };
    }
    static fromObject(e24) {
      return this._fromObject(e24, { extraParam: `path` });
    }
    static async fromElement(e24, t2, n2) {
      let { d: r2, ...i2 } = Zi(e24, this.ATTRIBUTE_NAMES, n2);
      return new this(r2, { ...i2, ...t2, left: void 0, top: void 0 });
    }
  };
  i(Mo, `type`, `Path`), i(Mo, `cacheProperties`, [...Un, `path`, `fillRule`]), i(Mo, `ATTRIBUTE_NAMES`, [...ki, `d`]), M.setClass(Mo), M.setSVGClass(Mo);
  var Po = [`radius`, `startAngle`, `endAngle`, `counterClockwise`];
  var Fo = class e14 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e14.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, e14.ownDefaults), this.setOptions(t2);
    }
    _set(e24, t2) {
      return super._set(e24, t2), e24 === `radius` && this.setRadius(t2), this;
    }
    _render(e24) {
      e24.beginPath(), e24.arc(0, 0, this.radius, I(this.startAngle), I(this.endAngle), this.counterClockwise), this._renderPaintInOrder(e24);
    }
    getRadiusX() {
      return this.get(`radius`) * this.get(de);
    }
    getRadiusY() {
      return this.get(`radius`) * this.get(fe);
    }
    setRadius(e24) {
      this.radius = e24, this.set({ width: 2 * e24, height: 2 * e24 });
    }
    toObject(e24 = []) {
      return super.toObject([...Po, ...e24]);
    }
    _toSVG() {
      let { radius: e24, startAngle: t2, endAngle: n2 } = this, r2 = (n2 - t2) % 360;
      if (r2 === 0) return [`<circle `, `COMMON_PARTS`, `cx="0" cy="0" `, `r="`, `${U(e24)}`, `" />
`];
      {
        let i2 = I(t2), a2 = I(n2), o2 = Se(i2) * e24, s3 = Ce(i2) * e24, c2 = Se(a2) * e24, l2 = Ce(a2) * e24;
        return [`<path d="M ${o2} ${s3} A ${e24} ${e24} 0 ${+(r2 > 180)} ${+!this.counterClockwise} ${c2} ${l2}" `, `COMMON_PARTS`, ` />
`];
      }
    }
    static async fromElement(e24, t2, n2) {
      let { left: r2 = 0, top: i2 = 0, radius: a2 = 0, ...o2 } = Zi(e24, this.ATTRIBUTE_NAMES, n2);
      return new this({ ...o2, radius: a2, left: r2 - a2, top: i2 - a2 });
    }
    static fromObject(e24) {
      return super._fromObject(e24);
    }
  };
  i(Fo, `type`, `Circle`), i(Fo, `cacheProperties`, [...Un, ...Po]), i(Fo, `ownDefaults`, { radius: 0, startAngle: 0, endAngle: 360, counterClockwise: false }), i(Fo, `ATTRIBUTE_NAMES`, [`cx`, `cy`, `r`, ...ki]), M.setClass(Fo), M.setSVGClass(Fo);
  var zo = [`x1`, `x2`, `y1`, `y2`];
  var Bo = class e15 extends J {
    constructor([t2, n2, r2, i2] = [0, 0, 0, 0], a2 = {}) {
      super(), Object.assign(this, e15.ownDefaults), this.setOptions(a2), this.x1 = t2, this.x2 = r2, this.y1 = n2, this.y2 = i2, this._setWidthHeight();
      let { left: o2, top: s3 } = a2;
      typeof o2 == `number` && this.set(`left`, o2), typeof s3 == `number` && this.set(`top`, s3);
    }
    _setWidthHeight() {
      let { x1: e24, y1: t2, x2: n2, y2: r2 } = this;
      this.width = Math.abs(n2 - e24), this.height = Math.abs(r2 - t2);
      let { left: i2, top: a2, width: o2, height: s3 } = wt([{ x: e24, y: t2 }, { x: n2, y: r2 }]), c2 = new N(i2 + o2 / 2, a2 + s3 / 2);
      this.setPositionByOrigin(c2, E, E);
    }
    _set(e24, t2) {
      return super._set(e24, t2), zo.includes(e24) && this._setWidthHeight(), this;
    }
    _render(e24) {
      e24.beginPath();
      let t2 = this.calcLinePoints();
      e24.moveTo(t2.x1, t2.y1), e24.lineTo(t2.x2, t2.y2), e24.lineWidth = this.strokeWidth;
      let n2 = e24.strokeStyle;
      var r2;
      V(this.stroke) ? e24.strokeStyle = this.stroke.toLive(e24) : e24.strokeStyle = (r2 = this.stroke) == null ? e24.fillStyle : r2, this.stroke && this._renderStroke(e24), e24.strokeStyle = n2;
    }
    _findCenterFromElement() {
      return new N((this.x1 + this.x2) / 2, (this.y1 + this.y2) / 2);
    }
    toObject(e24 = []) {
      return { ...super.toObject(e24), ...this.calcLinePoints() };
    }
    _getNonTransformedDimensions() {
      let e24 = super._getNonTransformedDimensions();
      return this.strokeLineCap === `butt` && (this.width === 0 && (e24.y -= this.strokeWidth), this.height === 0 && (e24.x -= this.strokeWidth)), e24;
    }
    calcLinePoints() {
      let { x1: e24, x2: t2, y1: n2, y2: r2, width: i2, height: a2 } = this, o2 = e24 <= t2 ? -0.5 : 0.5, s3 = n2 <= r2 ? -0.5 : 0.5;
      return { x1: o2 * i2, x2: o2 * -i2, y1: s3 * a2, y2: s3 * -a2 };
    }
    _toSVG() {
      let { x1: e24, x2: t2, y1: n2, y2: r2 } = this.calcLinePoints();
      return [`<line `, `COMMON_PARTS`, `x1="${e24}" y1="${n2}" x2="${t2}" y2="${r2}" />
`];
    }
    static async fromElement(e24, t2, n2) {
      let { x1: r2 = 0, y1: i2 = 0, x2: a2 = 0, y2: o2 = 0, ...s3 } = Zi(e24, this.ATTRIBUTE_NAMES, n2);
      return new this([r2, i2, a2, o2], s3);
    }
    static fromObject({ x1: e24, y1: t2, x2: n2, y2: r2, ...i2 }) {
      return this._fromObject({ ...i2, points: [e24, t2, n2, r2] }, { extraParam: `points` });
    }
  };
  i(Bo, `type`, `Line`), i(Bo, `cacheProperties`, [...Un, ...zo]), i(Bo, `ATTRIBUTE_NAMES`, ki.concat(zo)), M.setClass(Bo), M.setSVGClass(Bo);
  var Vo = class e16 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e16.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, e16.ownDefaults), this.setOptions(t2);
    }
    _render(e24) {
      let t2 = this.width / 2, n2 = this.height / 2;
      e24.beginPath(), e24.moveTo(-t2, n2), e24.lineTo(0, -n2), e24.lineTo(t2, n2), e24.closePath(), this._renderPaintInOrder(e24);
    }
    _toSVG() {
      let e24 = this.width / 2, t2 = this.height / 2;
      return [`<polygon `, `COMMON_PARTS`, `points="`, `${-e24} ${t2},0 ${-t2},${e24} ${t2}`, `" />`];
    }
  };
  i(Vo, `type`, `Triangle`), i(Vo, `ownDefaults`, { width: 100, height: 100 }), M.setClass(Vo), M.setSVGClass(Vo);
  var Ho = [`rx`, `ry`];
  var Uo = class e17 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e17.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, e17.ownDefaults), this.setOptions(t2);
    }
    _set(e24, t2) {
      switch (super._set(e24, t2), e24) {
        case `rx`:
          this.rx = t2, this.set(`width`, 2 * t2);
          break;
        case `ry`:
          this.ry = t2, this.set(`height`, 2 * t2);
      }
      return this;
    }
    getRx() {
      return this.get(`rx`) * this.get(de);
    }
    getRy() {
      return this.get(`ry`) * this.get(fe);
    }
    toObject(e24 = []) {
      return super.toObject([...Ho, ...e24]);
    }
    _toSVG() {
      return [`<ellipse `, `COMMON_PARTS`, `cx="0" cy="0" rx="${U(this.rx)}" ry="${U(this.ry)}" />
`];
    }
    _render(e24) {
      e24.beginPath(), e24.save(), e24.transform(1, 0, 0, this.ry / this.rx, 0, 0), e24.arc(0, 0, this.rx, 0, w, false), e24.restore(), this._renderPaintInOrder(e24);
    }
    static async fromElement(e24, t2, n2) {
      let r2 = Zi(e24, this.ATTRIBUTE_NAMES, n2);
      return r2.left = (r2.left || 0) - r2.rx, r2.top = (r2.top || 0) - r2.ry, new this(r2);
    }
  };
  i(Uo, `type`, `Ellipse`), i(Uo, `cacheProperties`, [...Un, ...Ho]), i(Uo, `ownDefaults`, { rx: 0, ry: 0 }), i(Uo, `ATTRIBUTE_NAMES`, [...ki, `cx`, `cy`, `rx`, `ry`]), M.setClass(Uo), M.setSVGClass(Uo);
  var Wo = { exactBoundingBox: false };
  var Go = class e18 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e18.ownDefaults };
    }
    constructor(t2 = [], n2 = {}) {
      super(), i(this, `strokeDiff`, void 0), Object.assign(this, e18.ownDefaults), this.setOptions(n2), this.points = t2;
      let { left: r2, top: a2 } = n2;
      this.initialized = true, this.setBoundingBox(true), typeof r2 == `number` && this.set(`left`, r2), typeof a2 == `number` && this.set(`top`, a2);
    }
    isOpen() {
      return true;
    }
    _projectStrokeOnPoints(e24) {
      return wi(this.points, e24, this.isOpen());
    }
    _calcDimensions(e24) {
      e24 = { scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, strokeLineCap: this.strokeLineCap, strokeLineJoin: this.strokeLineJoin, strokeMiterLimit: this.strokeMiterLimit, strokeUniform: this.strokeUniform, strokeWidth: this.strokeWidth, ...e24 || {} };
      let t2 = this.exactBoundingBox ? this._projectStrokeOnPoints(e24).map((e25) => e25.projectedPoint) : this.points;
      if (t2.length === 0) return { left: 0, top: 0, width: 0, height: 0, pathOffset: new N(), strokeOffset: new N(), strokeDiff: new N() };
      let n2 = wt(t2), r2 = Ye({ ...e24, scaleX: 1, scaleY: 1 }), i2 = wt(this.points.map((e25) => L(e25, r2, true))), a2 = new N(this.scaleX, this.scaleY), o2 = n2.left + n2.width / 2, s3 = n2.top + n2.height / 2;
      return this.exactBoundingBox && (o2 -= s3 * Math.tan(I(this.skewX)), s3 -= o2 * Math.tan(I(this.skewY))), { ...n2, pathOffset: new N(o2, s3), strokeOffset: new N(i2.left, i2.top).subtract(new N(n2.left, n2.top)).multiply(a2), strokeDiff: new N(n2.width, n2.height).subtract(new N(i2.width, i2.height)).multiply(a2) };
    }
    _findCenterFromElement() {
      let e24 = wt(this.points);
      return new N(e24.left + e24.width / 2, e24.top + e24.height / 2);
    }
    setDimensions() {
      this.setBoundingBox();
    }
    setBoundingBox(e24) {
      let { left: t2, top: n2, width: r2, height: i2, pathOffset: a2, strokeOffset: o2, strokeDiff: s3 } = this._calcDimensions();
      this.set({ width: r2, height: i2, pathOffset: a2, strokeOffset: o2, strokeDiff: s3 }), e24 && this.setPositionByOrigin(new N(t2 + r2 / 2, n2 + i2 / 2), `center`, `center`);
    }
    isStrokeAccountedForInDimensions() {
      return this.exactBoundingBox;
    }
    _getNonTransformedDimensions() {
      return this.exactBoundingBox ? new N(this.width, this.height) : super._getNonTransformedDimensions();
    }
    _getTransformedDimensions(e24 = {}) {
      if (this.exactBoundingBox) {
        let a2;
        if (Object.keys(e24).some((e25) => this.strokeUniform || this.constructor.layoutProperties.includes(e25))) {
          var t2, n2;
          let { width: r3, height: i3 } = this._calcDimensions(e24);
          a2 = new N((t2 = e24.width) == null ? r3 : t2, (n2 = e24.height) == null ? i3 : n2);
        } else {
          var r2, i2;
          a2 = new N((r2 = e24.width) == null ? this.width : r2, (i2 = e24.height) == null ? this.height : i2);
        }
        return a2.multiply(new N(e24.scaleX || this.scaleX, e24.scaleY || this.scaleY));
      }
      return super._getTransformedDimensions(e24);
    }
    _set(e24, t2) {
      let n2 = this.initialized && this[e24] !== t2, r2 = super._set(e24, t2);
      return this.exactBoundingBox && n2 && ((e24 === `scaleX` || e24 === `scaleY`) && this.strokeUniform && this.constructor.layoutProperties.includes(`strokeUniform`) || this.constructor.layoutProperties.includes(e24)) && this.setDimensions(), r2;
    }
    toObject(e24 = []) {
      return { ...super.toObject(e24), points: this.points.map(({ x: e25, y: t2 }) => ({ x: e25, y: t2 })) };
    }
    _toSVG() {
      let e24 = this.pathOffset.x, t2 = this.pathOffset.y, n2 = o.NUM_FRACTION_DIGITS, r2 = this.points.map(({ x: r3, y: i2 }) => `${B(r3 - e24, n2)},${B(i2 - t2, n2)}`).join(` `);
      return [`<${U(this.constructor.type).toLowerCase()} `, `COMMON_PARTS`, `points="${r2}" />
`];
    }
    _render(e24) {
      let t2 = this.points.length, n2 = this.pathOffset.x, r2 = this.pathOffset.y;
      if (t2 && !isNaN(this.points[t2 - 1].y)) {
        e24.beginPath(), e24.moveTo(this.points[0].x - n2, this.points[0].y - r2);
        for (let i2 = 0; i2 < t2; i2++) {
          let t3 = this.points[i2];
          e24.lineTo(t3.x - n2, t3.y - r2);
        }
        !this.isOpen() && e24.closePath(), this._renderPaintInOrder(e24);
      }
    }
    complexity() {
      return this.points.length;
    }
    static async fromElement(e24, t2, n2) {
      let r2 = function(e25) {
        if (!e25) return [];
        let t3 = e25.replace(/,/g, ` `).trim().split(/\s+/), n3 = [];
        for (let e26 = 0; e26 < t3.length; e26 += 2) n3.push({ x: parseFloat(t3[e26]), y: parseFloat(t3[e26 + 1]) });
        return n3;
      }(e24.getAttribute(`points`)), { left: i2, top: a2, ...o2 } = Zi(e24, this.ATTRIBUTE_NAMES, n2);
      return new this(r2, { ...o2, ...t2 });
    }
    static fromObject(e24) {
      return this._fromObject(e24, { extraParam: `points` });
    }
  };
  i(Go, `ownDefaults`, Wo), i(Go, `type`, `Polyline`), i(Go, `layoutProperties`, [pe, me, `strokeLineCap`, `strokeLineJoin`, `strokeMiterLimit`, `strokeWidth`, `strokeUniform`, `points`]), i(Go, `cacheProperties`, [...Un, `points`]), i(Go, `ATTRIBUTE_NAMES`, [...ki]), M.setClass(Go), M.setSVGClass(Go);
  var Ko = class extends Go {
    isOpen() {
      return false;
    }
  };
  i(Ko, `ownDefaults`, Wo), i(Ko, `type`, `Polygon`), M.setClass(Ko), M.setSVGClass(Ko);
  var qo = class extends J {
    isEmptyStyles(e24) {
      if (!this.styles || e24 !== void 0 && !this.styles[e24]) return true;
      let t2 = e24 === void 0 ? this.styles : { line: this.styles[e24] };
      for (let e25 in t2) for (let n2 in t2[e25]) for (let r2 in t2[e25][n2]) return false;
      return true;
    }
    styleHas(e24, t2) {
      if (!this.styles || t2 !== void 0 && !this.styles[t2]) return false;
      let n2 = t2 === void 0 ? this.styles : { 0: this.styles[t2] };
      for (let t3 in n2) for (let r2 in n2[t3]) if (n2[t3][r2][e24] !== void 0) return true;
      return false;
    }
    cleanStyle(e24) {
      if (!this.styles) return false;
      let t2 = this.styles, n2, r2, i2 = 0, a2 = true, o2 = 0;
      for (let o3 in t2) {
        n2 = 0;
        for (let s3 in t2[o3]) {
          let c2 = t2[o3][s3] || {};
          i2++, c2[e24] === void 0 ? a2 = false : (r2 ? c2[e24] !== r2 && (a2 = false) : r2 = c2[e24], c2[e24] === this[e24] && delete c2[e24]), Object.keys(c2).length === 0 ? delete t2[o3][s3] : n2++;
        }
        n2 === 0 && delete t2[o3];
      }
      for (let e25 = 0; e25 < this._textLines.length; e25++) o2 += this._textLines[e25].length;
      a2 && i2 === o2 && (this[e24] = r2, this.removeStyle(e24));
    }
    removeStyle(e24) {
      if (!this.styles) return;
      let t2 = this.styles, n2, r2, i2;
      for (r2 in t2) {
        for (i2 in n2 = t2[r2], n2) delete n2[i2][e24], Object.keys(n2[i2]).length === 0 && delete n2[i2];
        Object.keys(n2).length === 0 && delete t2[r2];
      }
    }
    _extendStyles(e24, t2) {
      let { lineIndex: n2, charIndex: r2 } = this.get2DCursorLocation(e24);
      this._getLineStyle(n2) || this._setLineStyle(n2);
      let i2 = tt({ ...this._getStyleDeclaration(n2, r2), ...t2 }, (e25) => e25 !== void 0);
      this._setStyleDeclaration(n2, r2, i2);
    }
    getSelectionStyles(e24, t2, n2) {
      let r2 = [];
      for (let i2 = e24; i2 < (t2 || e24); i2++) r2.push(this.getStyleAtPosition(i2, n2));
      return r2;
    }
    getStyleAtPosition(e24, t2) {
      let { lineIndex: n2, charIndex: r2 } = this.get2DCursorLocation(e24);
      return t2 ? this.getCompleteStyleDeclaration(n2, r2) : this._getStyleDeclaration(n2, r2);
    }
    setSelectionStyles(e24, t2, n2) {
      for (let r2 = t2; r2 < (n2 || t2); r2++) this._extendStyles(r2, e24);
      this._forceClearCache = true;
    }
    _getStyleDeclaration(e24, t2) {
      var n2;
      let r2 = this.styles && this.styles[e24];
      return r2 && (n2 = r2[t2]) != null ? n2 : {};
    }
    getCompleteStyleDeclaration(e24, t2) {
      return { ...et(this, this.constructor._styleProperties), ...this._getStyleDeclaration(e24, t2) };
    }
    _setStyleDeclaration(e24, t2, n2) {
      this.styles[e24][t2] = n2;
    }
    _deleteStyleDeclaration(e24, t2) {
      delete this.styles[e24][t2];
    }
    _getLineStyle(e24) {
      return !!this.styles[e24];
    }
    _setLineStyle(e24) {
      this.styles[e24] = {};
    }
    _deleteLineStyle(e24) {
      delete this.styles[e24];
    }
  };
  i(qo, `_styleProperties`, wn);
  var Jo = /  +/g;
  var Yo = /"/g;
  function Xo(e24, t2, n2, r2, i2) {
    return `		${((e25, { left: t3, top: n3, width: r3, height: i3 }, a2 = o.NUM_FRACTION_DIGITS) => {
      let s3 = hn(j, e25, false), [c2, l2, u2, d2] = [t3, n3, r3, i3].map((e26) => B(e26, a2));
      return `<rect ${s3} x="${c2}" y="${l2}" width="${u2}" height="${d2}"></rect>`;
    })(e24, { left: t2, top: n2, width: r2, height: i2 })}
`;
  }
  var Zo;
  var Q = class e19 extends qo {
    static getDefaults() {
      return { ...super.getDefaults(), ...e19.ownDefaults };
    }
    constructor(t2, n2) {
      super(), i(this, `__charBounds`, []), Object.assign(this, e19.ownDefaults), this.setOptions(n2), this.styles || (this.styles = {}), this.text = t2, this.initialized = true, this.path && this.setPathInfo(), this.initDimensions(), this.setCoords();
    }
    setPathInfo() {
      let e24 = this.path;
      e24 && (e24.segmentsInfo = ja(e24.path));
    }
    _splitText() {
      let e24 = this._splitTextIntoLines(this.text);
      return this.textLines = e24.lines, this._textLines = e24.graphemeLines, this._unwrappedTextLines = e24._unwrappedLines, this._text = e24.graphemeText, e24;
    }
    initDimensions() {
      this._splitText(), this._clearCache(), this.dirty = true, this.path ? (this.width = this.path.width, this.height = this.path.height) : (this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH, this.height = this.calcTextHeight()), this.textAlign.includes(`justify`) && this.enlargeSpaces();
    }
    enlargeSpaces() {
      let e24, t2, n2, r2, i2, a2, o2;
      for (let s3 = 0, c2 = this._textLines.length; s3 < c2; s3++) if ((this.textAlign === `justify` || s3 !== c2 - 1 && !this.isEndOfWrapping(s3)) && (r2 = 0, i2 = this._textLines[s3], t2 = this.getLineWidth(s3), t2 < this.width && (o2 = this.textLines[s3].match(this._reSpacesAndTabs)))) {
        n2 = o2.length, e24 = (this.width - t2) / n2;
        for (let t3 = 0; t3 <= i2.length; t3++) a2 = this.__charBounds[s3][t3], this._reSpaceAndTab.test(i2[t3]) ? (a2.width += e24, a2.kernedWidth += e24, a2.left += r2, r2 += e24) : a2.left += r2;
      }
    }
    isEndOfWrapping(e24) {
      return e24 === this._textLines.length - 1;
    }
    missingNewlineOffset(e24) {
      return 1;
    }
    get2DCursorLocation(e24, t2) {
      let n2 = t2 ? this._unwrappedTextLines : this._textLines, r2;
      for (r2 = 0; r2 < n2.length; r2++) {
        if (e24 <= n2[r2].length) return { lineIndex: r2, charIndex: e24 };
        e24 -= n2[r2].length + this.missingNewlineOffset(r2, t2);
      }
      return { lineIndex: r2 - 1, charIndex: n2[r2 - 1].length < e24 ? n2[r2 - 1].length : e24 };
    }
    toString() {
      return `#<Text (${this.complexity()}): { "text": "${this.text}", "fontFamily": "${this.fontFamily}" }>`;
    }
    _getCacheCanvasDimensions() {
      let e24 = super._getCacheCanvasDimensions(), t2 = this.fontSize;
      return e24.width += t2 * e24.zoomX, e24.height += t2 * e24.zoomY, e24;
    }
    _render(e24) {
      let t2 = this.path;
      t2 && !t2.isNotVisible() && t2._render(e24), this._setTextStyles(e24), this._renderTextLinesBackground(e24), this._renderTextDecoration(e24, `underline`), this._renderText(e24), this._renderTextDecoration(e24, `overline`), this._renderTextDecoration(e24, `linethrough`);
    }
    _renderText(e24) {
      this.paintFirst === `stroke` ? (this._renderTextStroke(e24), this._renderTextFill(e24)) : (this._renderTextFill(e24), this._renderTextStroke(e24));
    }
    _setTextStyles(e24, t2, n2) {
      if (e24.textBaseline = `alphabetic`, this.path) switch (this.pathAlign) {
        case E:
          e24.textBaseline = `middle`;
          break;
        case `ascender`:
          e24.textBaseline = `top`;
          break;
        case `descender`:
          e24.textBaseline = O;
      }
      e24.font = this._getFontDeclaration(t2, n2);
    }
    calcTextWidth() {
      let e24 = this.getLineWidth(0);
      for (let t2 = 1, n2 = this._textLines.length; t2 < n2; t2++) {
        let n3 = this.getLineWidth(t2);
        n3 > e24 && (e24 = n3);
      }
      return e24;
    }
    _renderTextLine(e24, t2, n2, r2, i2, a2) {
      this._renderChars(e24, t2, n2, r2, i2, a2);
    }
    _renderTextLinesBackground(e24) {
      if (!this.textBackgroundColor && !this.styleHas(`textBackgroundColor`)) return;
      let t2 = e24.fillStyle, n2 = this._getLeftOffset(), r2 = this._getTopOffset();
      for (let t3 = 0, i2 = this._textLines.length; t3 < i2; t3++) {
        let i3 = this.getHeightOfLine(t3);
        if (!this.textBackgroundColor && !this.styleHas(`textBackgroundColor`, t3)) {
          r2 += i3;
          continue;
        }
        let a2 = this._textLines[t3].length, o2 = this._getLineLeftOffset(t3), s3, c2, l2 = 0, u2 = 0, d2 = this.getValueOfPropertyAt(t3, 0, `textBackgroundColor`), f2 = this.getHeightOfLineImpl(t3);
        for (let i4 = 0; i4 < a2; i4++) {
          let a3 = this.__charBounds[t3][i4];
          c2 = this.getValueOfPropertyAt(t3, i4, `textBackgroundColor`), this.path ? (e24.save(), e24.translate(a3.renderLeft, a3.renderTop), e24.rotate(a3.angle), e24.fillStyle = c2, c2 && e24.fillRect(-a3.width / 2, -f2 * (1 - this._fontSizeFraction), a3.width, f2), e24.restore()) : c2 === d2 ? l2 += a3.kernedWidth : (s3 = n2 + o2 + u2, this.direction === `rtl` && (s3 = this.width - s3 - l2), e24.fillStyle = d2, d2 && e24.fillRect(s3, r2, l2, f2), u2 = a3.left, l2 = a3.width, d2 = c2);
        }
        c2 && !this.path && (s3 = n2 + o2 + u2, this.direction === `rtl` && (s3 = this.width - s3 - l2), e24.fillStyle = c2, e24.fillRect(s3, r2, l2, f2)), r2 += i3;
      }
      e24.fillStyle = t2, this._removeShadow(e24);
    }
    _measureChar(e24, t2, n2, r2) {
      let i2 = y.getFontCache(t2), a2 = this._getFontDeclaration(t2), o2 = n2 ? n2 + e24 : e24, s3 = n2 && a2 === this._getFontDeclaration(r2), c2 = t2.fontSize / this.CACHE_FONT_SIZE, l2, u2, d2, f2;
      if (n2 && i2.has(n2) && (d2 = i2.get(n2)), i2.has(e24) && (f2 = l2 = i2.get(e24)), s3 && i2.has(o2) && (u2 = i2.get(o2), f2 = u2 - d2), l2 === void 0 || d2 === void 0 || u2 === void 0) {
        let r3 = (Zo || (Zo = F({ width: 0, height: 0 }).getContext(`2d`)), Zo);
        this._setTextStyles(r3, t2, true), l2 === void 0 && (f2 = l2 = r3.measureText(e24).width, i2.set(e24, l2)), d2 === void 0 && s3 && n2 && (d2 = r3.measureText(n2).width, i2.set(n2, d2)), s3 && u2 === void 0 && (u2 = r3.measureText(o2).width, i2.set(o2, u2), f2 = u2 - d2);
      }
      return { width: l2 * c2, kernedWidth: f2 * c2 };
    }
    getHeightOfChar(e24, t2) {
      return this.getValueOfPropertyAt(e24, t2, `fontSize`);
    }
    measureLine(e24) {
      let t2 = this._measureLine(e24);
      return this.charSpacing !== 0 && (t2.width -= this._getWidthOfCharSpacing()), t2.width < 0 && (t2.width = 0), t2;
    }
    _measureLine(e24) {
      let t2, n2, r2 = 0, i2 = this.pathSide === k, a2 = this.path, o2 = this._textLines[e24], s3 = o2.length, c2 = Array(s3);
      this.__charBounds[e24] = c2;
      for (let i3 = 0; i3 < s3; i3++) {
        let a3 = o2[i3];
        n2 = this._getGraphemeBox(a3, e24, i3, t2), c2[i3] = n2, r2 += n2.kernedWidth, t2 = a3;
      }
      if (c2[s3] = { left: n2 ? n2.left + n2.width : 0, width: 0, kernedWidth: 0, height: this.fontSize, deltaY: 0 }, a2 && a2.segmentsInfo) {
        let e25 = 0, t3 = a2.segmentsInfo[a2.segmentsInfo.length - 1].length;
        switch (this.textAlign) {
          case D:
            e25 = i2 ? t3 - r2 : 0;
            break;
          case E:
            e25 = (t3 - r2) / 2;
            break;
          case k:
            e25 = i2 ? 0 : t3 - r2;
        }
        e25 += this.pathStartOffset * (i2 ? -1 : 1);
        for (let r3 = i2 ? s3 - 1 : 0; i2 ? r3 >= 0 : r3 < s3; i2 ? r3-- : r3++) n2 = c2[r3], e25 > t3 ? e25 %= t3 : e25 < 0 && (e25 += t3), this._setGraphemeOnPath(e25, n2), e25 += n2.kernedWidth;
      }
      return { width: r2, numOfSpaces: 0 };
    }
    _setGraphemeOnPath(e24, t2) {
      let n2 = e24 + t2.kernedWidth / 2, r2 = this.path, i2 = Ma(r2.path, n2, r2.segmentsInfo);
      t2.renderLeft = i2.x - r2.pathOffset.x, t2.renderTop = i2.y - r2.pathOffset.y, t2.angle = i2.angle + (this.pathSide === `right` ? Math.PI : 0);
    }
    _getGraphemeBox(e24, t2, n2, r2, i2) {
      let a2 = this.getCompleteStyleDeclaration(t2, n2), o2 = r2 ? this.getCompleteStyleDeclaration(t2, n2 - 1) : {}, s3 = this._measureChar(e24, a2, r2, o2), c2, l2 = s3.kernedWidth, u2 = s3.width;
      this.charSpacing !== 0 && (c2 = this._getWidthOfCharSpacing(), u2 += c2, l2 += c2);
      let d2 = { width: u2, left: 0, height: a2.fontSize, kernedWidth: l2, deltaY: a2.deltaY };
      if (n2 > 0 && !i2) {
        let e25 = this.__charBounds[t2][n2 - 1];
        d2.left = e25.left + e25.width + s3.kernedWidth - s3.width;
      }
      return d2;
    }
    getHeightOfLineImpl(e24) {
      let t2 = this.__lineHeights;
      if (t2[e24]) return t2[e24];
      let n2 = this.getHeightOfChar(e24, 0);
      for (let t3 = 1, r2 = this._textLines[e24].length; t3 < r2; t3++) n2 = Math.max(this.getHeightOfChar(e24, t3), n2);
      return t2[e24] = n2 * this._fontSizeMult;
    }
    getHeightOfLine(e24) {
      return this.getHeightOfLineImpl(e24) * this.lineHeight;
    }
    calcTextHeight() {
      let e24 = 0;
      for (let t2 = 0, n2 = this._textLines.length; t2 < n2; t2++) e24 += t2 === n2 - 1 ? this.getHeightOfLineImpl(t2) : this.getHeightOfLine(t2);
      return e24;
    }
    _getLeftOffset() {
      return this.direction === `ltr` ? -this.width / 2 : this.width / 2;
    }
    _getTopOffset() {
      return -this.height / 2;
    }
    _renderTextCommon(e24, t2) {
      e24.save();
      let n2 = 0, r2 = this._getLeftOffset(), i2 = this._getTopOffset();
      for (let a2 = 0, o2 = this._textLines.length; a2 < o2; a2++) this._renderTextLine(t2, e24, this._textLines[a2], r2 + this._getLineLeftOffset(a2), i2 + n2 + this.getHeightOfLineImpl(a2), a2), n2 += this.getHeightOfLine(a2);
      e24.restore();
    }
    _renderTextFill(e24) {
      (this.fill || this.styleHas(`fill`)) && this._renderTextCommon(e24, `fillText`);
    }
    _renderTextStroke(e24) {
      (this.stroke && this.strokeWidth !== 0 || !this.isEmptyStyles()) && (this.shadow && !this.shadow.affectStroke && this._removeShadow(e24), e24.save(), this._setLineDash(e24, this.strokeDashArray), e24.beginPath(), this._renderTextCommon(e24, `strokeText`), e24.closePath(), e24.restore());
    }
    _renderChars(e24, t2, n2, r2, i2, a2) {
      let o2 = this.textAlign.includes(En), s3 = this.path, c2 = !o2 && this.charSpacing === 0 && this.isEmptyStyles(a2) && !s3, l2 = this.direction === `ltr`, u2 = this.direction === `ltr` ? 1 : -1, d2 = t2.direction, f2, p2, m, h2, g2, _2 = ``, v2 = 0;
      if (t2.save(), d2 !== this.direction && (t2.canvas.setAttribute(`dir`, l2 ? `ltr` : `rtl`), t2.direction = l2 ? `ltr` : `rtl`, t2.textAlign = l2 ? D : k), i2 -= this.getHeightOfLineImpl(a2) * this._fontSizeFraction, c2) return this._renderChar(e24, t2, a2, 0, n2.join(``), r2, i2), void t2.restore();
      for (let c3 = 0, l3 = n2.length - 1; c3 <= l3; c3++) h2 = c3 === l3 || this.charSpacing || s3, _2 += n2[c3], m = this.__charBounds[a2][c3], v2 === 0 ? (r2 += u2 * (m.kernedWidth - m.width), v2 += m.width) : v2 += m.kernedWidth, o2 && !h2 && this._reSpaceAndTab.test(n2[c3]) && (h2 = true), h2 || (f2 = f2 || this.getCompleteStyleDeclaration(a2, c3), p2 = this.getCompleteStyleDeclaration(a2, c3 + 1), h2 = Ei(f2, p2, false)), h2 && (s3 ? (t2.save(), t2.translate(m.renderLeft, m.renderTop), t2.rotate(m.angle), this._renderChar(e24, t2, a2, c3, _2, -v2 / 2, 0), t2.restore()) : (g2 = r2, this._renderChar(e24, t2, a2, c3, _2, g2, i2)), _2 = ``, f2 = p2, r2 += u2 * v2, v2 = 0);
      t2.restore();
    }
    _applyPatternGradientTransformText(e24) {
      let t2 = this.width + this.strokeWidth, n2 = this.height + this.strokeWidth, r2 = F({ width: t2, height: n2 }), i2 = r2.getContext(`2d`);
      return r2.width = t2, r2.height = n2, i2.beginPath(), i2.moveTo(0, 0), i2.lineTo(t2, 0), i2.lineTo(t2, n2), i2.lineTo(0, n2), i2.closePath(), i2.translate(t2 / 2, n2 / 2), i2.fillStyle = e24.toLive(i2), this._applyPatternGradientTransform(i2, e24), i2.fill(), i2.createPattern(r2, `no-repeat`);
    }
    handleFiller(e24, t2, n2) {
      let r2, i2;
      return V(n2) ? n2.gradientUnits === `percentage` || n2.gradientTransform || n2.patternTransform ? (r2 = -this.width / 2, i2 = -this.height / 2, e24.translate(r2, i2), e24[t2] = this._applyPatternGradientTransformText(n2), { offsetX: r2, offsetY: i2 }) : (e24[t2] = n2.toLive(e24), this._applyPatternGradientTransform(e24, n2)) : (e24[t2] = n2, { offsetX: 0, offsetY: 0 });
    }
    _setStrokeStyles(e24, { stroke: t2, strokeWidth: n2 }) {
      return e24.lineWidth = n2, e24.lineCap = this.strokeLineCap, e24.lineDashOffset = this.strokeDashOffset, e24.lineJoin = this.strokeLineJoin, e24.miterLimit = this.strokeMiterLimit, this.handleFiller(e24, `strokeStyle`, t2);
    }
    _setFillStyles(e24, { fill: t2 }) {
      return this.handleFiller(e24, `fillStyle`, t2);
    }
    _renderChar(e24, t2, n2, r2, i2, a2, o2) {
      let s3 = this._getStyleDeclaration(n2, r2), c2 = this.getCompleteStyleDeclaration(n2, r2), l2 = e24 === `fillText` && c2.fill, u2 = e24 === `strokeText` && c2.stroke && c2.strokeWidth;
      if (u2 || l2) {
        if (t2.save(), t2.font = this._getFontDeclaration(c2), s3.textBackgroundColor && this._removeShadow(t2), s3.deltaY && (o2 += s3.deltaY), l2) {
          let e25 = this._setFillStyles(t2, c2);
          t2.fillText(i2, a2 - e25.offsetX, o2 - e25.offsetY);
        }
        if (u2) {
          let e25 = this._setStrokeStyles(t2, c2);
          t2.strokeText(i2, a2 - e25.offsetX, o2 - e25.offsetY);
        }
        t2.restore();
      }
    }
    setSuperscript(e24, t2) {
      this._setScript(e24, t2, this.superscript);
    }
    setSubscript(e24, t2) {
      this._setScript(e24, t2, this.subscript);
    }
    _setScript(e24, t2, n2) {
      let r2 = this.get2DCursorLocation(e24, true), i2 = this.getValueOfPropertyAt(r2.lineIndex, r2.charIndex, `fontSize`), a2 = this.getValueOfPropertyAt(r2.lineIndex, r2.charIndex, `deltaY`), o2 = { fontSize: i2 * n2.size, deltaY: a2 + i2 * n2.baseline };
      this.setSelectionStyles(o2, e24, t2);
    }
    _getLineLeftOffset(e24) {
      let t2 = this.getLineWidth(e24), n2 = this.width - t2, r2 = this.textAlign, i2 = this.direction, a2 = this.isEndOfWrapping(e24), o2 = 0;
      return r2 === `justify` || r2 === `justify-center` && !a2 || r2 === `justify-right` && !a2 || r2 === `justify-left` && !a2 ? 0 : (r2 === `center` && (o2 = n2 / 2), r2 === `right` && (o2 = n2), r2 === `justify-center` && (o2 = n2 / 2), r2 === `justify-right` && (o2 = n2), i2 === `rtl` && (r2 === `right` || r2 === `justify-right` ? o2 = 0 : r2 === `left` || r2 === `justify-left` ? o2 = -n2 : r2 !== `center` && r2 !== `justify-center` || (o2 = -n2 / 2)), o2);
    }
    _clearCache() {
      this._forceClearCache = false, this.__lineWidths = [], this.__lineHeights = [], this.__charBounds = [];
    }
    getLineWidth(e24) {
      if (this.__lineWidths[e24] !== void 0) return this.__lineWidths[e24];
      let { width: t2 } = this.measureLine(e24);
      return this.__lineWidths[e24] = t2, t2;
    }
    _getWidthOfCharSpacing() {
      return this.charSpacing === 0 ? 0 : this.fontSize * this.charSpacing / 1e3;
    }
    getValueOfPropertyAt(e24, t2, n2) {
      var r2;
      return (r2 = this._getStyleDeclaration(e24, t2)[n2]) == null ? this[n2] : r2;
    }
    _renderTextDecoration(e24, t2) {
      if (!this[t2] && !this.styleHas(t2)) return;
      let n2 = this._getTopOffset(), r2 = this._getLeftOffset(), i2 = this.path, a2 = this._getWidthOfCharSpacing(), o2 = t2 === `linethrough` ? 0.5 : +(t2 === `overline`), s3 = this.offsets[t2];
      for (let c2 = 0, l2 = this._textLines.length; c2 < l2; c2++) {
        let l3 = this.getHeightOfLine(c2);
        if (!this[t2] && !this.styleHas(t2, c2)) {
          n2 += l3;
          continue;
        }
        let u2 = this._textLines[c2], d2 = l3 / this.lineHeight, f2 = this._getLineLeftOffset(c2), p2, m = 0, h2 = 0, g2 = this.getValueOfPropertyAt(c2, 0, t2), _2 = this.getValueOfPropertyAt(c2, 0, j), v2 = this.getValueOfPropertyAt(c2, 0, `textDecorationColor`) || _2, y2 = this.getValueOfPropertyAt(c2, 0, vn), b2 = g2, x2 = v2, S2 = y2, C2 = n2 + d2 * (1 - this._fontSizeFraction), w2 = this.getHeightOfChar(c2, 0), ee2 = this.getValueOfPropertyAt(c2, 0, `deltaY`);
        for (let n3 = 0, a3 = u2.length; n3 < a3; n3++) {
          let a4 = this.__charBounds[c2][n3];
          b2 = this.getValueOfPropertyAt(c2, n3, t2), p2 = this.getValueOfPropertyAt(c2, n3, j), x2 = this.getValueOfPropertyAt(c2, n3, `textDecorationColor`) || p2, S2 = this.getValueOfPropertyAt(c2, n3, vn);
          let l4 = this.getHeightOfChar(c2, n3), u3 = this.getValueOfPropertyAt(c2, n3, `deltaY`);
          if (i2 && b2 && p2) {
            let t3 = this.fontSize * S2 / 1e3;
            e24.save(), e24.fillStyle = x2, e24.translate(a4.renderLeft, a4.renderTop), e24.rotate(a4.angle), e24.fillRect(-a4.kernedWidth / 2, s3 * l4 + u3 - o2 * t3, a4.kernedWidth, t3), e24.restore();
          } else if ((b2 !== g2 || p2 !== _2 || x2 !== v2 || l4 !== w2 || S2 !== y2 || u3 !== ee2) && h2 > 0) {
            let t3 = this.fontSize * y2 / 1e3, n4 = r2 + f2 + m;
            this.direction === `rtl` && (n4 = this.width - n4 - h2), g2 && v2 && y2 && (e24.fillStyle = v2, e24.fillRect(n4, C2 + s3 * w2 + ee2 - o2 * t3, h2, t3)), m = a4.left, h2 = a4.width, g2 = b2, v2 = x2, y2 = S2, _2 = p2, w2 = l4, ee2 = u3;
          } else h2 += a4.kernedWidth;
        }
        let T2 = r2 + f2 + m;
        this.direction === `rtl` && (T2 = this.width - T2 - h2), e24.fillStyle = x2;
        let E2 = this.fontSize * S2 / 1e3;
        b2 && x2 && S2 && e24.fillRect(T2, C2 + s3 * w2 + ee2 - o2 * E2, h2 - a2, E2), n2 += l3;
      }
      this._removeShadow(e24);
    }
    _getFontDeclaration({ fontFamily: t2 = this.fontFamily, fontStyle: n2 = this.fontStyle, fontWeight: r2 = this.fontWeight, fontSize: i2 = this.fontSize } = {}, a2) {
      let o2 = t2.includes(`'`) || t2.includes(`"`) || t2.includes(`,`) || e19.genericFonts.includes(t2.toLowerCase()) ? t2 : `"${t2}"`;
      return [n2, r2, `${a2 ? this.CACHE_FONT_SIZE : i2}px`, o2].join(` `);
    }
    render(e24) {
      this.visible && (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (this._forceClearCache && this.initDimensions(), super.render(e24)));
    }
    graphemeSplit(e24) {
      return gt(e24);
    }
    _splitTextIntoLines(e24) {
      let t2 = e24.split(this._reNewline), n2 = Array(t2.length), r2 = [`
`], i2 = [];
      for (let e25 = 0; e25 < t2.length; e25++) n2[e25] = this.graphemeSplit(t2[e25]), i2 = i2.concat(n2[e25], r2);
      return i2.pop(), { _unwrappedLines: n2, lines: t2, graphemeText: i2, graphemeLines: n2 };
    }
    toObject(e24 = []) {
      return { ...super.toObject([...Cn, ...e24]), styles: Di(this.styles, this.text), ...this.path ? { path: this.path.toObject() } : {} };
    }
    set(e24, t2) {
      let { textLayoutProperties: n2 } = this.constructor;
      super.set(e24, t2);
      let r2 = false, i2 = false;
      if (typeof e24 == `object`) for (let t3 in e24) t3 === `path` && this.setPathInfo(), r2 = r2 || n2.includes(t3), i2 = i2 || t3 === `path`;
      else r2 = n2.includes(e24), i2 = e24 === `path`;
      return i2 && this.setPathInfo(), r2 && this.initialized && (this.initDimensions(), this.setCoords()), this;
    }
    complexity() {
      return 1;
    }
    static async fromElement(t2, n2, r2) {
      let i2 = Zi(t2, e19.ATTRIBUTE_NAMES, r2), { textAnchor: a2 = D, textDecoration: o2 = ``, dx: s3 = 0, dy: c2 = 0, top: l2 = 0, left: u2 = 0, fontSize: d2 = 16, strokeWidth: f2 = 1, ...p2 } = { ...n2, ...i2 }, m = new this(on(t2.textContent || ``).trim(), { left: u2 + s3, top: l2 + c2, underline: o2.includes(`underline`), overline: o2.includes(`overline`), linethrough: o2.includes(`line-through`), strokeWidth: 0, fontSize: d2, ...p2 }), h2 = m.getScaledHeight() / m.height, g2 = ((m.height + m.strokeWidth) * m.lineHeight - m.height) * h2, _2 = m.getScaledHeight() + g2, v2 = 0;
      return a2 === `center` && (v2 = m.getScaledWidth() / 2), a2 === `right` && (v2 = m.getScaledWidth()), m.set({ left: m.left - v2, top: m.top - (_2 - m.fontSize * (0.07 + m._fontSizeFraction)) / m.lineHeight, strokeWidth: f2 }), m;
    }
    static fromObject(e24) {
      return this._fromObject({ ...e24, styles: Oi(e24.styles || {}, e24.text) }, { extraParam: `text` });
    }
  };
  i(Q, `textLayoutProperties`, Sn), i(Q, `cacheProperties`, [...Un, ...Cn]), i(Q, `ownDefaults`, Tn), i(Q, `type`, `Text`), i(Q, `genericFonts`, [`serif`, `sans-serif`, `monospace`, `cursive`, `fantasy`, `system-ui`, `ui-serif`, `ui-sans-serif`, `ui-monospace`, `ui-rounded`, `math`, `emoji`, `fangsong`]), i(Q, `ATTRIBUTE_NAMES`, ki.concat(`x`, `y`, `dx`, `dy`, `font-family`, `font-style`, `font-weight`, `font-size`, `letter-spacing`, `text-decoration`, `text-decoration-thickness`, `text-decoration-color`, `text-anchor`)), vi(Q, [class extends gn {
    _toSVG() {
      let e24 = this._getSVGLeftTopOffsets(), t2 = this._getSVGTextAndBg(e24.textTop, e24.textLeft);
      return this._wrapSVGTextAndBg(t2);
    }
    toSVG(e24) {
      let t2 = this._createBaseSVGMarkup(this._toSVG(), { reviver: e24, noStyle: true, withShadow: true }), n2 = this.path;
      return n2 ? t2 + n2._createBaseSVGMarkup(n2._toSVG(), { reviver: e24, withShadow: true, additionalTransform: nt(this.calcOwnMatrix()) }) : t2;
    }
    _getSVGLeftTopOffsets() {
      return { textLeft: -this.width / 2, textTop: -this.height / 2, lineTop: this.getHeightOfLine(0) };
    }
    _wrapSVGTextAndBg({ textBgRects: e24, textSpans: t2 }) {
      let n2 = this.getSvgTextDecoration(this);
      return [e24.join(``), `		<text xml:space="preserve" `, `font-family="${U(this.fontFamily.replace(Yo, `'`))}" `, `font-size="${U(this.fontSize)}" `, this.fontStyle ? `font-style="${U(this.fontStyle)}" ` : ``, this.fontWeight ? `font-weight="${U(this.fontWeight)}" ` : ``, n2 ? `text-decoration="${n2}" ` : ``, this.direction === `rtl` ? `direction="rtl" ` : ``, `style="`, this.getSvgStyles(true), `"`, this.addPaintOrder(), ` >`, t2.join(``), `</text>
`];
    }
    _getSVGTextAndBg(e24, t2) {
      let n2 = [], r2 = [], i2, a2 = e24;
      this.backgroundColor && r2.push(Xo(this.backgroundColor, -this.width / 2, -this.height / 2, this.width, this.height));
      for (let e25 = 0, o2 = this._textLines.length; e25 < o2; e25++) i2 = this._getLineLeftOffset(e25), this.direction === `rtl` && (i2 += this.width), (this.textBackgroundColor || this.styleHas(`textBackgroundColor`, e25)) && this._setSVGTextLineBg(r2, e25, t2 + i2, a2), this._setSVGTextLineText(n2, e25, t2 + i2, a2), a2 += this.getHeightOfLine(e25);
      return { textSpans: n2, textBgRects: r2 };
    }
    _createTextCharSpan(e24, t2, n2, r2, i2) {
      let a2 = o.NUM_FRACTION_DIGITS, s3 = this.getSvgSpanStyles(t2, e24 !== e24.trim() || !!e24.match(Jo)), c2 = s3 ? `style="${s3}"` : ``, l2 = t2.deltaY, u2 = l2 ? ` dy="${B(l2, a2)}" ` : ``, { angle: d2, renderLeft: f2, renderTop: p2, width: m } = i2, h2 = ``;
      if (f2 !== void 0) {
        let e25 = m / 2;
        d2 && (h2 = ` rotate="${B(Ie(d2), a2)}"`);
        let t3 = We({ angle: Ie(d2) });
        t3[4] = f2, t3[5] = p2;
        let i3 = new N(-e25, 0).transform(t3);
        n2 = i3.x, r2 = i3.y;
      }
      return `<tspan x="${B(n2, a2)}" y="${B(r2, a2)}" ${u2}${h2}${c2}>${U(e24)}</tspan>`;
    }
    _setSVGTextLineText(e24, t2, n2, r2) {
      let i2 = this.getHeightOfLine(t2), a2 = this.textAlign.includes(En), o2 = this._textLines[t2], s3, c2, l2, u2, d2, f2 = ``, p2 = 0;
      r2 += i2 * (1 - this._fontSizeFraction) / this.lineHeight;
      for (let i3 = 0, m = o2.length - 1; i3 <= m; i3++) d2 = i3 === m || this.charSpacing || this.path, f2 += o2[i3], l2 = this.__charBounds[t2][i3], p2 === 0 ? (n2 += l2.kernedWidth - l2.width, p2 += l2.width) : p2 += l2.kernedWidth, a2 && !d2 && this._reSpaceAndTab.test(o2[i3]) && (d2 = true), d2 || (s3 = s3 || this.getCompleteStyleDeclaration(t2, i3), c2 = this.getCompleteStyleDeclaration(t2, i3 + 1), d2 = Ei(s3, c2, true)), d2 && (u2 = this._getStyleDeclaration(t2, i3), e24.push(this._createTextCharSpan(f2, u2, n2, r2, l2)), f2 = ``, s3 = c2, this.direction === `rtl` ? n2 -= p2 : n2 += p2, p2 = 0);
    }
    _setSVGTextLineBg(e24, t2, n2, r2) {
      let i2 = this._textLines[t2], a2 = this.getHeightOfLine(t2) / this.lineHeight, o2, s3 = 0, c2 = 0, l2 = this.getValueOfPropertyAt(t2, 0, `textBackgroundColor`);
      for (let u2 = 0; u2 < i2.length; u2++) {
        let { left: i3, width: d2, kernedWidth: f2 } = this.__charBounds[t2][u2];
        o2 = this.getValueOfPropertyAt(t2, u2, `textBackgroundColor`), o2 === l2 ? s3 += f2 : (l2 && e24.push(Xo(l2, n2 + c2, r2, s3, a2)), c2 = i3, s3 = d2, l2 = o2);
      }
      o2 && e24.push(Xo(l2, n2 + c2, r2, s3, a2));
    }
    getSvgStyles(e24) {
      let t2 = nn(this.textDecorationColor) ? ` text-decoration-color: ${U(this[yn])};` : ``;
      return `${super.getSvgStyles(e24)} text-decoration-thickness: ${B(this.textDecorationThickness * this.getObjectScaling().y / 10, o.NUM_FRACTION_DIGITS)}%;${t2} white-space: pre;`;
    }
    getSvgSpanStyles(e24, t2) {
      let { fontFamily: n2, strokeWidth: r2, stroke: i2, fill: a2, fontSize: s3, fontStyle: c2, fontWeight: l2, textDecorationThickness: u2, textDecorationColor: d2, linethrough: f2, overline: p2, underline: m } = e24, h2 = this.getSvgTextDecoration({ underline: m == null ? this.underline : m, overline: p2 == null ? this.overline : p2, linethrough: f2 == null ? this.linethrough : f2 }), g2 = u2 || this.textDecorationThickness, _2 = d2 || this.textDecorationColor, v2 = rn(r2), y2 = an(n2), b2 = rn(s3), x2 = an(c2), S2 = rn(l2) || an(l2), C2 = an(_2);
      return [i2 ? hn(he, i2) : ``, v2 ? `stroke-width: ${U(v2)}; ` : ``, y2 ? `font-family: ${y2.includes(`'`) || y2.includes(`"`) ? U(y2) : `'${U(y2)}'`}; ` : ``, b2 ? `font-size: ${U(b2)}px; ` : ``, x2 ? `font-style: ${U(x2)}; ` : ``, S2 ? `font-weight: ${U(S2)}; ` : ``, h2 ? `text-decoration: ${h2}; text-decoration-thickness: ${B(g2 * this.getObjectScaling().y / 10, o.NUM_FRACTION_DIGITS)}%;${C2 ? ` text-decoration-color: ${U(C2)};` : ``} ` : ``, a2 ? hn(j, a2) : ``, t2 ? `white-space: pre; ` : ``].join(``);
    }
    getSvgTextDecoration(e24) {
      return [`overline`, `underline`, `line-through`].filter((t2) => e24[t2.replace(`-`, ``)]).join(` `);
    }
  }]), M.setClass(Q), M.setSVGClass(Q);
  var Qo = class {
    constructor(e24) {
      i(this, `target`, void 0), i(this, `__mouseDownInPlace`, false), i(this, `__dragStartFired`, false), i(this, `__isDraggingOver`, false), i(this, `__dragStartSelection`, void 0), i(this, `__dragImageDisposer`, void 0), i(this, `_dispose`, void 0), this.target = e24;
      let t2 = [this.target.on(`dragenter`, this.dragEnterHandler.bind(this)), this.target.on(`dragover`, this.dragOverHandler.bind(this)), this.target.on(`dragleave`, this.dragLeaveHandler.bind(this)), this.target.on(`dragend`, this.dragEndHandler.bind(this)), this.target.on(`drop`, this.dropHandler.bind(this))];
      this._dispose = () => {
        t2.forEach((e25) => e25()), this._dispose = void 0;
      };
    }
    isPointerOverSelection(e24) {
      let t2 = this.target, n2 = t2.getSelectionStartFromPointer(e24);
      return t2.isEditing && n2 >= t2.selectionStart && n2 <= t2.selectionEnd && t2.selectionStart < t2.selectionEnd;
    }
    start(e24) {
      return this.__mouseDownInPlace = this.isPointerOverSelection(e24);
    }
    isActive() {
      return this.__mouseDownInPlace;
    }
    end(e24) {
      let t2 = this.isActive();
      return t2 && !this.__dragStartFired && (this.target.setCursorByClick(e24), this.target.initDelayedCursor(true)), this.__mouseDownInPlace = false, this.__dragStartFired = false, this.__isDraggingOver = false, t2;
    }
    getDragStartSelection() {
      return this.__dragStartSelection;
    }
    setDragImage(e24, { selectionStart: t2, selectionEnd: n2 }) {
      var r2;
      let i2 = this.target, a2 = i2.canvas, o2 = new N(i2.flipX ? -1 : 1, i2.flipY ? -1 : 1), s3 = i2._getCursorBoundaries(t2), c2 = new N(s3.left + s3.leftOffset, s3.top + s3.topOffset).multiply(o2).transform(i2.calcTransformMatrix()), l2 = a2.getScenePoint(e24).subtract(c2), u2 = i2.getCanvasRetinaScaling(), d2 = i2.getBoundingRect(), f2 = c2.subtract(new N(d2.left, d2.top)), p2 = a2.viewportTransform, m = f2.add(l2).transform(p2, true), h2 = i2.backgroundColor, g2 = Ti(i2.styles);
      i2.backgroundColor = ``;
      let _2 = { stroke: `transparent`, fill: `transparent`, textBackgroundColor: `transparent` };
      i2.setSelectionStyles(_2, 0, t2), i2.setSelectionStyles(_2, n2, i2.text.length), i2.dirty = true;
      let v2 = i2.toCanvasElement({ enableRetinaScaling: a2.enableRetinaScaling, viewportTransform: true });
      i2.backgroundColor = h2, i2.styles = g2, i2.dirty = true, Ka(v2, { position: `fixed`, left: -v2.width + `px`, border: te, width: v2.width / u2 + `px`, height: v2.height / u2 + `px` }), this.__dragImageDisposer && this.__dragImageDisposer(), this.__dragImageDisposer = () => {
        v2.remove();
      }, H(e24.target || this.target.hiddenTextarea).body.appendChild(v2), (r2 = e24.dataTransfer) == null || r2.setDragImage(v2, m.x, m.y);
    }
    onDragStart(e24) {
      this.__dragStartFired = true;
      let t2 = this.target, n2 = this.isActive();
      if (n2 && e24.dataTransfer) {
        let n3 = this.__dragStartSelection = { selectionStart: t2.selectionStart, selectionEnd: t2.selectionEnd }, r2 = t2._text.slice(n3.selectionStart, n3.selectionEnd).join(``), i2 = { text: t2.text, value: r2, ...n3 };
        e24.dataTransfer.setData(`text/plain`, r2), e24.dataTransfer.setData(`application/fabric`, JSON.stringify({ value: r2, styles: t2.getSelectionStyles(n3.selectionStart, n3.selectionEnd, true) })), e24.dataTransfer.effectAllowed = `copyMove`, this.setDragImage(e24, i2);
      }
      return t2.abortCursorAnimation(), n2;
    }
    canDrop(e24) {
      if (this.target.editable && !this.target.getActiveControl() && !e24.defaultPrevented) {
        if (this.isActive() && this.__dragStartSelection) {
          let t2 = this.target.getSelectionStartFromPointer(e24), n2 = this.__dragStartSelection;
          return t2 < n2.selectionStart || t2 > n2.selectionEnd;
        }
        return true;
      }
      return false;
    }
    targetCanDrop(e24) {
      return this.target.canDrop(e24);
    }
    dragEnterHandler({ e: e24 }) {
      let t2 = this.targetCanDrop(e24);
      !this.__isDraggingOver && t2 && (this.__isDraggingOver = true);
    }
    dragOverHandler(e24) {
      let { e: t2 } = e24, n2 = this.targetCanDrop(t2);
      !this.__isDraggingOver && n2 ? this.__isDraggingOver = true : this.__isDraggingOver && !n2 && (this.__isDraggingOver = false), this.__isDraggingOver && (t2.preventDefault(), e24.canDrop = true, e24.dropTarget = this.target);
    }
    dragLeaveHandler() {
      (this.__isDraggingOver || this.isActive()) && (this.__isDraggingOver = false);
    }
    dropHandler(e24) {
      var t2;
      let { e: n2 } = e24, r2 = n2.defaultPrevented;
      this.__isDraggingOver = false, n2.preventDefault();
      let i2 = (t2 = n2.dataTransfer) == null ? void 0 : t2.getData(`text/plain`);
      if (i2 && !r2) {
        let t3 = this.target, r3 = t3.canvas, a2 = t3.getSelectionStartFromPointer(n2), { styles: o2 } = n2.dataTransfer.types.includes(`application/fabric`) ? JSON.parse(n2.dataTransfer.getData(`application/fabric`)) : {}, s3 = i2[Math.max(0, i2.length - 1)];
        if (this.__dragStartSelection) {
          let e25 = this.__dragStartSelection.selectionStart, n3 = this.__dragStartSelection.selectionEnd;
          a2 > e25 && a2 <= n3 ? a2 = e25 : a2 > n3 && (a2 -= n3 - e25), t3.removeChars(e25, n3), delete this.__dragStartSelection;
        }
        t3._reNewline.test(s3) && (t3._reNewline.test(t3._text[a2]) || a2 === t3._text.length) && (i2 = i2.trimEnd()), e24.didDrop = true, e24.dropTarget = t3, t3.insertChars(i2, o2, a2), r3.setActiveObject(t3), t3.enterEditing(n2), t3.selectionStart = Math.min(a2 + 0, t3._text.length), t3.selectionEnd = Math.min(t3.selectionStart + i2.length, t3._text.length), t3.hiddenTextarea.value = t3.text, t3._updateTextarea(), t3.hiddenTextarea.focus(), t3.fire(le, { index: a2 + 0, action: `drop` }), r3.fire(`text:changed`, { target: t3 }), r3.contextTopDirty = true, r3.requestRenderAll();
      }
    }
    dragEndHandler({ e: e24 }) {
      if (this.isActive() && this.__dragStartFired && this.__dragStartSelection) {
        var t2;
        let n2 = this.target, r2 = this.target.canvas, { selectionStart: i2, selectionEnd: a2 } = this.__dragStartSelection, o2 = ((t2 = e24.dataTransfer) == null ? void 0 : t2.dropEffect) || `none`;
        o2 === `none` ? (n2.selectionStart = i2, n2.selectionEnd = a2, n2._updateTextarea(), n2.hiddenTextarea.focus()) : (n2.clearContextTop(), o2 === `move` && (n2.removeChars(i2, a2), n2.selectionStart = n2.selectionEnd = i2, n2.hiddenTextarea && (n2.hiddenTextarea.value = n2.text), n2._updateTextarea(), n2.fire(le, { index: i2, action: `dragend` }), r2.fire(`text:changed`, { target: n2 }), r2.requestRenderAll()), n2.exitEditing());
      }
      this.__dragImageDisposer && this.__dragImageDisposer(), delete this.__dragImageDisposer, delete this.__dragStartSelection, this.__isDraggingOver = false;
    }
    dispose() {
      this._dispose && this._dispose();
    }
  };
  var $o = /[ \n\.,;!\?\-]/;
  var es = class extends Q {
    constructor(...e24) {
      super(...e24), i(this, `_currentCursorOpacity`, 1);
    }
    initBehavior() {
      this._tick = this._tick.bind(this), this._onTickComplete = this._onTickComplete.bind(this), this.updateSelectionOnMouseMove = this.updateSelectionOnMouseMove.bind(this);
    }
    onDeselect(e24) {
      return this.isEditing && this.exitEditing(), this.selected = false, super.onDeselect(e24);
    }
    _animateCursor({ toValue: e24, duration: t2, delay: n2, onComplete: r2 }) {
      return Mr({ startValue: this._currentCursorOpacity, endValue: e24, duration: t2, delay: n2, onComplete: r2, abort: () => !this.canvas || this.selectionStart !== this.selectionEnd, onChange: (e25) => {
        this._currentCursorOpacity = e25, this.renderCursorOrSelection();
      } });
    }
    _tick(e24) {
      this._currentTickState = this._animateCursor({ toValue: 0, duration: this.cursorDuration / 2, delay: Math.max(e24 || 0, 100), onComplete: this._onTickComplete });
    }
    _onTickComplete() {
      var e24;
      (e24 = this._currentTickCompleteState) == null || e24.abort(), this._currentTickCompleteState = this._animateCursor({ toValue: 1, duration: this.cursorDuration, onComplete: this._tick });
    }
    initDelayedCursor(e24) {
      this.abortCursorAnimation(), this._tick(e24 ? 0 : this.cursorDelay);
    }
    abortCursorAnimation() {
      let e24 = false;
      [this._currentTickState, this._currentTickCompleteState].forEach((t2) => {
        t2 && !t2.isDone() && (e24 = true, t2.abort());
      }), this._currentCursorOpacity = 1, e24 && this.clearContextTop();
    }
    restartCursorIfNeeded() {
      [this._currentTickState, this._currentTickCompleteState].some((e24) => !e24 || e24.isDone()) && this.initDelayedCursor();
    }
    selectAll() {
      return this.selectionStart = 0, this.selectionEnd = this._text.length, this._fireSelectionChanged(), this._updateTextarea(), this;
    }
    cmdAll() {
      this.selectAll(), this.renderCursorOrSelection();
    }
    getSelectedText() {
      return this._text.slice(this.selectionStart, this.selectionEnd).join(``);
    }
    findWordBoundaryLeft(e24) {
      let t2 = 0, n2 = e24 - 1;
      if (this._reSpace.test(this._text[n2])) for (; this._reSpace.test(this._text[n2]); ) t2++, n2--;
      for (; /\S/.test(this._text[n2]) && n2 > -1; ) t2++, n2--;
      return e24 - t2;
    }
    findWordBoundaryRight(e24) {
      let t2 = 0, n2 = e24;
      if (this._reSpace.test(this._text[n2])) for (; this._reSpace.test(this._text[n2]); ) t2++, n2++;
      for (; /\S/.test(this._text[n2]) && n2 < this._text.length; ) t2++, n2++;
      return e24 + t2;
    }
    findLineBoundaryLeft(e24) {
      let t2 = 0, n2 = e24 - 1;
      for (; !/\n/.test(this._text[n2]) && n2 > -1; ) t2++, n2--;
      return e24 - t2;
    }
    findLineBoundaryRight(e24) {
      let t2 = 0, n2 = e24;
      for (; !/\n/.test(this._text[n2]) && n2 < this._text.length; ) t2++, n2++;
      return e24 + t2;
    }
    searchWordBoundary(e24, t2) {
      let n2 = this._text, r2 = e24 > 0 && this._reSpace.test(n2[e24]) && (t2 === -1 || !ne.test(n2[e24 - 1])) ? e24 - 1 : e24, i2 = n2[r2];
      for (; r2 > 0 && r2 < n2.length && !$o.test(i2); ) r2 += t2, i2 = n2[r2];
      return t2 === -1 && $o.test(i2) && r2++, r2;
    }
    selectWord(e24) {
      var t2;
      e24 = (t2 = e24) == null ? this.selectionStart : t2;
      let n2 = this.searchWordBoundary(e24, -1), r2 = Math.max(n2, this.searchWordBoundary(e24, 1));
      this.selectionStart = n2, this.selectionEnd = r2, this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection();
    }
    selectLine(e24) {
      var t2;
      e24 = (t2 = e24) == null ? this.selectionStart : t2;
      let n2 = this.findLineBoundaryLeft(e24), r2 = this.findLineBoundaryRight(e24);
      this.selectionStart = n2, this.selectionEnd = r2, this._fireSelectionChanged(), this._updateTextarea();
    }
    enterEditing(e24) {
      !this.isEditing && this.editable && (this.enterEditingImpl(), this.fire(`editing:entered`, e24 ? { e: e24 } : void 0), this._fireSelectionChanged(), this.canvas && (this.canvas.fire(`text:editing:entered`, { target: this, e: e24 }), this.canvas.requestRenderAll()));
    }
    enterEditingImpl() {
      this.canvas && (this.canvas.calcOffset(), this.canvas.textEditingManager.exitTextEditing()), this.isEditing = true, this.initHiddenTextarea(), this.hiddenTextarea.focus(), this.hiddenTextarea.value = this.text, this._updateTextarea(), this._saveEditingProps(), this._setEditingProps(), this._textBeforeEdit = this.text, this._tick();
    }
    updateSelectionOnMouseMove(e24) {
      if (this.getActiveControl()) return;
      let t2 = this.hiddenTextarea;
      H(t2).activeElement !== t2 && t2.focus();
      let n2 = this.getSelectionStartFromPointer(e24), r2 = this.selectionStart, i2 = this.selectionEnd;
      (n2 === this.__selectionStartOnMouseDown && r2 !== i2 || r2 !== n2 && i2 !== n2) && (n2 > this.__selectionStartOnMouseDown ? (this.selectionStart = this.__selectionStartOnMouseDown, this.selectionEnd = n2) : (this.selectionStart = n2, this.selectionEnd = this.__selectionStartOnMouseDown), this.selectionStart === r2 && this.selectionEnd === i2 || (this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection()));
    }
    _setEditingProps() {
      this.hoverCursor = `text`, this.canvas && (this.canvas.defaultCursor = this.canvas.moveCursor = `text`), this.borderColor = this.editingBorderColor, this.hasControls = this.selectable = false, this.lockMovementX = this.lockMovementY = true;
    }
    fromStringToGraphemeSelection(e24, t2, n2) {
      let r2 = n2.slice(0, e24), i2 = this.graphemeSplit(r2).length;
      if (e24 === t2) return { selectionStart: i2, selectionEnd: i2 };
      let a2 = n2.slice(e24, t2);
      return { selectionStart: i2, selectionEnd: i2 + this.graphemeSplit(a2).length };
    }
    fromGraphemeToStringSelection(e24, t2, n2) {
      let r2 = n2.slice(0, e24).join(``).length;
      return e24 === t2 ? { selectionStart: r2, selectionEnd: r2 } : { selectionStart: r2, selectionEnd: r2 + n2.slice(e24, t2).join(``).length };
    }
    _updateTextarea() {
      if (this.cursorOffsetCache = {}, this.hiddenTextarea) {
        if (!this.inCompositionMode) {
          let e24 = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
          this.hiddenTextarea.selectionStart = e24.selectionStart, this.hiddenTextarea.selectionEnd = e24.selectionEnd;
        }
        this.updateTextareaPosition();
      }
    }
    updateFromTextArea() {
      let { hiddenTextarea: e24, direction: t2, textAlign: n2, inCompositionMode: r2 } = this;
      if (!e24) return;
      let i2 = n2 === `justify` ? t2 === `ltr` ? D : k : n2.replace(`justify-`, ``), a2 = this.getPositionByOrigin(i2, `top`);
      this.cursorOffsetCache = {}, this.text = e24.value, this.set(`dirty`, true), this.initDimensions(), this.setPositionByOrigin(a2, i2, `top`), this.setCoords();
      let o2 = this.fromStringToGraphemeSelection(e24.selectionStart, e24.selectionEnd, e24.value);
      this.selectionEnd = this.selectionStart = o2.selectionEnd, r2 || (this.selectionStart = o2.selectionStart), this.updateTextareaPosition();
    }
    updateTextareaPosition() {
      if (this.selectionStart === this.selectionEnd) {
        let e24 = this._calcTextareaPosition();
        this.hiddenTextarea.style.left = e24.left, this.hiddenTextarea.style.top = e24.top;
      }
    }
    _calcTextareaPosition() {
      if (!this.canvas) return { left: `1px`, top: `1px` };
      let e24 = this.inCompositionMode ? this.compositionStart : this.selectionStart, t2 = this._getCursorBoundaries(e24), n2 = this.get2DCursorLocation(e24), r2 = n2.lineIndex, i2 = n2.charIndex, a2 = this.getValueOfPropertyAt(r2, i2, `fontSize`) * this.lineHeight, o2 = t2.leftOffset, s3 = this.getCanvasRetinaScaling(), c2 = this.canvas.upperCanvasEl, l2 = c2.width / s3, u2 = c2.height / s3, d2 = l2 - a2, f2 = u2 - a2, p2 = new N(t2.left + o2, t2.top + t2.topOffset + a2).transform(this.calcTransformMatrix()).transform(this.canvas.viewportTransform).multiply(new N(c2.clientWidth / l2, c2.clientHeight / u2));
      return p2.x < 0 && (p2.x = 0), p2.x > d2 && (p2.x = d2), p2.y < 0 && (p2.y = 0), p2.y > f2 && (p2.y = f2), p2.x += this.canvas._offset.left, p2.y += this.canvas._offset.top, { left: `${p2.x}px`, top: `${p2.y}px`, fontSize: `${a2}px`, charHeight: a2 };
    }
    _saveEditingProps() {
      this._savedProps = { hasControls: this.hasControls, borderColor: this.borderColor, lockMovementX: this.lockMovementX, lockMovementY: this.lockMovementY, hoverCursor: this.hoverCursor, selectable: this.selectable, defaultCursor: this.canvas && this.canvas.defaultCursor, moveCursor: this.canvas && this.canvas.moveCursor };
    }
    _restoreEditingProps() {
      this._savedProps && (this.hoverCursor = this._savedProps.hoverCursor, this.hasControls = this._savedProps.hasControls, this.borderColor = this._savedProps.borderColor, this.selectable = this._savedProps.selectable, this.lockMovementX = this._savedProps.lockMovementX, this.lockMovementY = this._savedProps.lockMovementY, this.canvas && (this.canvas.defaultCursor = this._savedProps.defaultCursor || this.canvas.defaultCursor, this.canvas.moveCursor = this._savedProps.moveCursor || this.canvas.moveCursor), delete this._savedProps);
    }
    exitEditingImpl() {
      let e24 = this.hiddenTextarea;
      this.selected = false, this.isEditing = false, e24 && (e24.blur && e24.blur(), e24.parentNode && e24.parentNode.removeChild(e24)), this.hiddenTextarea = null, this.abortCursorAnimation(), this.selectionStart !== this.selectionEnd && this.clearContextTop(), this.selectionEnd = this.selectionStart, this._restoreEditingProps(), this._forceClearCache && (this.initDimensions(), this.setCoords());
    }
    exitEditing() {
      let e24 = this._textBeforeEdit !== this.text;
      return this.exitEditingImpl(), this.fire(`editing:exited`), e24 && this.fire(`modified`), this.canvas && (this.canvas.fire(`text:editing:exited`, { target: this }), e24 && this.canvas.fire(`object:modified`, { target: this })), this;
    }
    _removeExtraneousStyles() {
      for (let e24 in this.styles) this._textLines[e24] || delete this.styles[e24];
    }
    removeStyleFromTo(e24, t2) {
      let { lineIndex: n2, charIndex: r2 } = this.get2DCursorLocation(e24, true), { lineIndex: i2, charIndex: a2 } = this.get2DCursorLocation(t2, true);
      if (n2 !== i2) {
        if (this.styles[n2]) for (let e25 = r2; e25 < this._unwrappedTextLines[n2].length; e25++) delete this.styles[n2][e25];
        if (this.styles[i2]) for (let e25 = a2; e25 < this._unwrappedTextLines[i2].length; e25++) {
          let t3 = this.styles[i2][e25];
          t3 && (this.styles[n2] || (this.styles[n2] = {}), this.styles[n2][r2 + e25 - a2] = t3);
        }
        for (let e25 = n2 + 1; e25 <= i2; e25++) delete this.styles[e25];
        this.shiftLineStyles(i2, n2 - i2);
      } else if (this.styles[n2]) {
        let e25 = this.styles[n2], t3 = a2 - r2;
        for (let t4 = r2; t4 < a2; t4++) delete e25[t4];
        for (let r3 in this.styles[n2]) {
          let n3 = parseInt(r3, 10);
          n3 >= a2 && (e25[n3 - t3] = e25[r3], delete e25[r3]);
        }
      }
    }
    shiftLineStyles(e24, t2) {
      let n2 = Object.assign({}, this.styles);
      for (let r2 in this.styles) {
        let i2 = parseInt(r2, 10);
        i2 > e24 && (this.styles[i2 + t2] = n2[i2], n2[i2 - t2] || delete this.styles[i2]);
      }
    }
    insertNewlineStyleObject(e24, t2, n2, r2) {
      let i2 = {}, a2 = this._unwrappedTextLines[e24].length, o2 = a2 === t2, s3 = false;
      n2 || (n2 = 1), this.shiftLineStyles(e24, n2);
      let c2 = this.styles[e24] ? this.styles[e24][t2 === 0 ? t2 : t2 - 1] : void 0;
      for (let n3 in this.styles[e24]) {
        let r3 = parseInt(n3, 10);
        r3 >= t2 && (s3 = true, i2[r3 - t2] = this.styles[e24][n3], o2 && t2 === 0 || delete this.styles[e24][n3]);
      }
      let l2 = false;
      for (s3 && !o2 && (this.styles[e24 + n2] = i2, l2 = true), (l2 || a2 > t2) && n2--; n2 > 0; ) r2 && r2[n2 - 1] ? this.styles[e24 + n2] = { 0: { ...r2[n2 - 1] } } : c2 ? this.styles[e24 + n2] = { 0: { ...c2 } } : delete this.styles[e24 + n2], n2--;
      this._forceClearCache = true;
    }
    insertCharStyleObject(e24, t2, n2, r2) {
      this.styles || (this.styles = {});
      let i2 = this.styles[e24], a2 = i2 ? { ...i2 } : {};
      n2 || (n2 = 1);
      for (let e25 in a2) {
        let r3 = parseInt(e25, 10);
        r3 >= t2 && (i2[r3 + n2] = a2[r3], a2[r3 - n2] || delete i2[r3]);
      }
      if (this._forceClearCache = true, r2) {
        for (; n2--; ) Object.keys(r2[n2]).length && (this.styles[e24] || (this.styles[e24] = {}), this.styles[e24][t2 + n2] = { ...r2[n2] });
        return;
      }
      if (!i2) return;
      let o2 = i2[t2 ? t2 - 1 : 1];
      for (; o2 && n2--; ) this.styles[e24][t2 + n2] = { ...o2 };
    }
    insertNewStyleBlock(e24, t2, n2) {
      let r2 = this.get2DCursorLocation(t2, true), i2 = [0], a2, o2 = 0;
      for (let t3 = 0; t3 < e24.length; t3++) e24[t3] === `
` ? (o2++, i2[o2] = 0) : i2[o2]++;
      for (i2[0] > 0 && (this.insertCharStyleObject(r2.lineIndex, r2.charIndex, i2[0], n2), n2 = n2 && n2.slice(i2[0] + 1)), o2 && this.insertNewlineStyleObject(r2.lineIndex, r2.charIndex + i2[0], o2), a2 = 1; a2 < o2; a2++) i2[a2] > 0 ? this.insertCharStyleObject(r2.lineIndex + a2, 0, i2[a2], n2) : n2 && this.styles[r2.lineIndex + a2] && n2[0] && (this.styles[r2.lineIndex + a2][0] = n2[0]), n2 = n2 && n2.slice(i2[a2] + 1);
      i2[a2] > 0 && this.insertCharStyleObject(r2.lineIndex + a2, 0, i2[a2], n2);
    }
    removeChars(e24, t2 = e24 + 1) {
      this.removeStyleFromTo(e24, t2), this._text.splice(e24, t2 - e24), this.text = this._text.join(``), this.set(`dirty`, true), this.initDimensions(), this.setCoords(), this._removeExtraneousStyles();
    }
    insertChars(e24, t2, n2, r2 = n2) {
      r2 > n2 && this.removeStyleFromTo(n2, r2);
      let i2 = this.graphemeSplit(e24);
      this.insertNewStyleBlock(i2, n2, t2), this._text = [...this._text.slice(0, n2), ...i2, ...this._text.slice(r2)], this.text = this._text.join(``), this.set(`dirty`, true), this.initDimensions(), this.setCoords(), this._removeExtraneousStyles();
    }
    setSelectionStartEndWithShift(e24, t2, n2) {
      n2 <= e24 ? (t2 === e24 ? this._selectionDirection = D : this._selectionDirection === `right` && (this._selectionDirection = D, this.selectionEnd = e24), this.selectionStart = n2) : n2 > e24 && n2 < t2 ? this._selectionDirection === `right` ? this.selectionEnd = n2 : this.selectionStart = n2 : (t2 === e24 ? this._selectionDirection = k : this._selectionDirection === `left` && (this._selectionDirection = k, this.selectionStart = t2), this.selectionEnd = n2);
    }
  };
  var ts = class extends es {
    initHiddenTextarea() {
      let e24 = this.canvas && H(this.canvas.getElement()) || g(), t2 = e24.createElement(`textarea`);
      Object.entries({ autocapitalize: `off`, autocorrect: `off`, autocomplete: `off`, spellcheck: `false`, "data-fabric": `textarea`, wrap: `off`, name: `fabricTextarea` }).map(([e25, n3]) => t2.setAttribute(e25, n3));
      let { top: n2, left: r2, fontSize: i2 } = this._calcTextareaPosition();
      t2.style.cssText = `position: absolute; top: ${n2}; left: ${r2}; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; padding-top: ${i2};`, (this.hiddenTextareaContainer || e24.body).appendChild(t2), Object.entries({ blur: `blur`, keydown: `onKeyDown`, keyup: `onKeyUp`, input: `onInput`, copy: `copy`, cut: `copy`, paste: `paste`, compositionstart: `onCompositionStart`, compositionupdate: `onCompositionUpdate`, compositionend: `onCompositionEnd` }).map(([e25, n3]) => t2.addEventListener(e25, this[n3].bind(this))), this.hiddenTextarea = t2;
    }
    blur() {
      this.abortCursorAnimation();
    }
    onKeyDown(e24) {
      if (!this.isEditing) return;
      let t2 = this.direction === `rtl` ? this.keysMapRtl : this.keysMap;
      if (e24.keyCode in t2) this[t2[e24.keyCode]](e24);
      else {
        if (!(e24.keyCode in this.ctrlKeysMapDown) || !e24.ctrlKey && !e24.metaKey) return;
        this[this.ctrlKeysMapDown[e24.keyCode]](e24);
      }
      e24.stopImmediatePropagation(), e24.preventDefault(), e24.keyCode >= 33 && e24.keyCode <= 40 ? (this.inCompositionMode = false, this.clearContextTop(), this.renderCursorOrSelection()) : this.canvas && this.canvas.requestRenderAll();
    }
    onKeyUp(e24) {
      !this.isEditing || this._copyDone || this.inCompositionMode ? this._copyDone = false : e24.keyCode in this.ctrlKeysMapUp && (e24.ctrlKey || e24.metaKey) && (this[this.ctrlKeysMapUp[e24.keyCode]](e24), e24.stopImmediatePropagation(), e24.preventDefault(), this.canvas && this.canvas.requestRenderAll());
    }
    onInput(e24) {
      let t2 = this.fromPaste, { value: n2, selectionStart: r2, selectionEnd: i2 } = this.hiddenTextarea;
      if (this.fromPaste = false, e24 && e24.stopPropagation(), !this.isEditing) return;
      let a2 = () => {
        this.updateFromTextArea(), this.fire(le), this.canvas && (this.canvas.fire(`text:changed`, { target: this }), this.canvas.requestRenderAll());
      };
      if (this.hiddenTextarea.value === ``) return this.styles = {}, void a2();
      let s3 = this._splitTextIntoLines(n2).graphemeText, c2 = this._text.length, l2 = s3.length, u2 = this.selectionStart, d2 = this.selectionEnd, f2 = u2 !== d2, p2, m, g2, _2, v2 = l2 - c2, y2 = this.fromStringToGraphemeSelection(r2, i2, n2), b2 = u2 > y2.selectionStart;
      f2 ? (m = this._text.slice(u2, d2), v2 += d2 - u2) : l2 < c2 && (m = b2 ? this._text.slice(d2 + v2, d2) : this._text.slice(u2, u2 - v2));
      let x2 = s3.slice(y2.selectionEnd - v2, y2.selectionEnd);
      if (m && m.length && (x2.length && (p2 = this.getSelectionStyles(u2, u2 + 1, false), p2 = x2.map(() => p2[0])), f2 ? (g2 = u2, _2 = d2) : b2 ? (g2 = d2 - m.length, _2 = d2) : (g2 = d2, _2 = d2 + m.length), this.removeStyleFromTo(g2, _2)), x2.length) {
        let { copyPasteData: e25 } = h();
        t2 && x2.join(``) === e25.copiedText && !o.disableStyleCopyPaste && (p2 = e25.copiedTextStyle), this.insertNewStyleBlock(x2, u2, p2);
      }
      a2();
    }
    onCompositionStart() {
      this.inCompositionMode = true;
    }
    onCompositionEnd() {
      this.inCompositionMode = false;
    }
    onCompositionUpdate({ target: e24 }) {
      let { selectionStart: t2, selectionEnd: n2 } = e24;
      this.compositionStart = t2, this.compositionEnd = n2, this.updateTextareaPosition();
    }
    copy() {
      if (this.selectionStart === this.selectionEnd) return;
      let { copyPasteData: e24 } = h();
      e24.copiedText = this.getSelectedText(), o.disableStyleCopyPaste ? e24.copiedTextStyle = void 0 : e24.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true), this._copyDone = true;
    }
    paste() {
      this.fromPaste = true;
    }
    _getWidthBeforeCursor(e24, t2) {
      let n2, r2 = this._getLineLeftOffset(e24);
      return t2 > 0 && (n2 = this.__charBounds[e24][t2 - 1], r2 += n2.left + n2.width), r2;
    }
    getDownCursorOffset(e24, t2) {
      let n2 = this._getSelectionForOffset(e24, t2), r2 = this.get2DCursorLocation(n2), i2 = r2.lineIndex;
      if (i2 === this._textLines.length - 1 || e24.metaKey || e24.keyCode === 34) return this._text.length - n2;
      let a2 = r2.charIndex, o2 = this._getWidthBeforeCursor(i2, a2), s3 = this._getIndexOnLine(i2 + 1, o2);
      return this._textLines[i2].slice(a2).length + s3 + 1 + this.missingNewlineOffset(i2);
    }
    _getSelectionForOffset(e24, t2) {
      return e24.shiftKey && this.selectionStart !== this.selectionEnd && t2 ? this.selectionEnd : this.selectionStart;
    }
    getUpCursorOffset(e24, t2) {
      let n2 = this._getSelectionForOffset(e24, t2), r2 = this.get2DCursorLocation(n2), i2 = r2.lineIndex;
      if (i2 === 0 || e24.metaKey || e24.keyCode === 33) return -n2;
      let a2 = r2.charIndex, o2 = this._getWidthBeforeCursor(i2, a2), s3 = this._getIndexOnLine(i2 - 1, o2), c2 = this._textLines[i2].slice(0, a2), l2 = this.missingNewlineOffset(i2 - 1);
      return -this._textLines[i2 - 1].length + s3 - c2.length + (1 - l2);
    }
    _getIndexOnLine(e24, t2) {
      let n2 = this._textLines[e24], r2, i2, a2 = this._getLineLeftOffset(e24), o2 = 0;
      for (let s3 = 0, c2 = n2.length; s3 < c2; s3++) if (r2 = this.__charBounds[e24][s3].width, a2 += r2, a2 > t2) {
        i2 = true;
        let e25 = a2 - r2, n3 = a2, c3 = Math.abs(e25 - t2);
        o2 = Math.abs(n3 - t2) < c3 ? s3 : s3 - 1;
        break;
      }
      return i2 || (o2 = n2.length - 1), o2;
    }
    moveCursorDown(e24) {
      this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorUpOrDown(`Down`, e24);
    }
    moveCursorUp(e24) {
      this.selectionStart === 0 && this.selectionEnd === 0 || this._moveCursorUpOrDown(`Up`, e24);
    }
    _moveCursorUpOrDown(e24, t2) {
      let n2 = this[`get${e24}CursorOffset`](t2, this._selectionDirection === k);
      if (t2.shiftKey ? this.moveCursorWithShift(n2) : this.moveCursorWithoutShift(n2), n2 !== 0) {
        let e25 = this.text.length;
        this.selectionStart = Vn(0, this.selectionStart, e25), this.selectionEnd = Vn(0, this.selectionEnd, e25), this.abortCursorAnimation(), this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea();
      }
    }
    moveCursorWithShift(e24) {
      let t2 = this._selectionDirection === `left` ? this.selectionStart + e24 : this.selectionEnd + e24;
      return this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, t2), e24 !== 0;
    }
    moveCursorWithoutShift(e24) {
      return e24 < 0 ? (this.selectionStart += e24, this.selectionEnd = this.selectionStart) : (this.selectionEnd += e24, this.selectionStart = this.selectionEnd), e24 !== 0;
    }
    moveCursorLeft(e24) {
      this.selectionStart === 0 && this.selectionEnd === 0 || this._moveCursorLeftOrRight(`Left`, e24);
    }
    _move(e24, t2, n2) {
      let r2;
      if (e24.altKey) r2 = this[`findWordBoundary${n2}`](this[t2]);
      else {
        if (!e24.metaKey && e24.keyCode !== 35 && e24.keyCode !== 36) return this[t2] += n2 === `Left` ? -1 : 1, true;
        r2 = this[`findLineBoundary${n2}`](this[t2]);
      }
      return r2 !== void 0 && this[t2] !== r2 && (this[t2] = r2, true);
    }
    _moveLeft(e24, t2) {
      return this._move(e24, t2, `Left`);
    }
    _moveRight(e24, t2) {
      return this._move(e24, t2, `Right`);
    }
    moveCursorLeftWithoutShift(e24) {
      let t2 = true;
      return this._selectionDirection = D, this.selectionEnd === this.selectionStart && this.selectionStart !== 0 && (t2 = this._moveLeft(e24, `selectionStart`)), this.selectionEnd = this.selectionStart, t2;
    }
    moveCursorLeftWithShift(e24) {
      return this._selectionDirection === `right` && this.selectionStart !== this.selectionEnd ? this._moveLeft(e24, `selectionEnd`) : this.selectionStart === 0 ? void 0 : (this._selectionDirection = D, this._moveLeft(e24, `selectionStart`));
    }
    moveCursorRight(e24) {
      this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorLeftOrRight(`Right`, e24);
    }
    _moveCursorLeftOrRight(e24, t2) {
      let n2 = `moveCursor${e24}${t2.shiftKey ? `WithShift` : `WithoutShift`}`;
      this._currentCursorOpacity = 1, this[n2](t2) && (this.abortCursorAnimation(), this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea());
    }
    moveCursorRightWithShift(e24) {
      return this._selectionDirection === `left` && this.selectionStart !== this.selectionEnd ? this._moveRight(e24, `selectionStart`) : this.selectionEnd === this._text.length ? void 0 : (this._selectionDirection = k, this._moveRight(e24, `selectionEnd`));
    }
    moveCursorRightWithoutShift(e24) {
      let t2 = true;
      return this._selectionDirection = k, this.selectionStart === this.selectionEnd ? (t2 = this._moveRight(e24, `selectionStart`), this.selectionEnd = this.selectionStart) : this.selectionStart = this.selectionEnd, t2;
    }
  };
  var ns = (e24) => !!e24.button;
  var rs = class extends ts {
    constructor(...e24) {
      super(...e24), i(this, `draggableTextDelegate`, void 0);
    }
    initBehavior() {
      this.on(`mousedown`, this._mouseDownHandler), this.on(`mouseup`, this.mouseUpHandler), this.on(`mousedblclick`, this.doubleClickHandler), this.on(`mousetripleclick`, this.tripleClickHandler), this.draggableTextDelegate = new Qo(this), super.initBehavior();
    }
    shouldStartDragging() {
      return this.draggableTextDelegate.isActive();
    }
    onDragStart(e24) {
      return this.draggableTextDelegate.onDragStart(e24);
    }
    canDrop(e24) {
      return this.draggableTextDelegate.canDrop(e24);
    }
    doubleClickHandler(e24) {
      this.isEditing && (this.selectWord(this.getSelectionStartFromPointer(e24.e)), this.renderCursorOrSelection());
    }
    tripleClickHandler(e24) {
      this.isEditing && (this.selectLine(this.getSelectionStartFromPointer(e24.e)), this.renderCursorOrSelection());
    }
    _mouseDownHandler({ e: e24, alreadySelected: t2 }) {
      this.canvas && this.editable && !ns(e24) && !this.getActiveControl() && (this.draggableTextDelegate.start(e24) || (this.canvas.textEditingManager.register(this), t2 && (this.inCompositionMode = false, this.setCursorByClick(e24)), this.isEditing && (this.__selectionStartOnMouseDown = this.selectionStart, this.selectionStart === this.selectionEnd && this.abortCursorAnimation(), this.renderCursorOrSelection()), this.selected || (this.selected = t2 || this.isEditing)));
    }
    mouseUpHandler({ e: e24, transform: t2 }) {
      let n2 = this.draggableTextDelegate.end(e24);
      if (this.canvas) {
        this.canvas.textEditingManager.unregister(this);
        let e25 = this.canvas._activeObject;
        if (e25 && e25 !== this) return;
      }
      !this.editable || this.group && !this.group.interactive || t2 && t2.actionPerformed || ns(e24) || n2 || this.selected && !this.getActiveControl() && (this.enterEditing(e24), this.selectionStart === this.selectionEnd ? this.initDelayedCursor(true) : this.renderCursorOrSelection());
    }
    setCursorByClick(e24) {
      let t2 = this.getSelectionStartFromPointer(e24), n2 = this.selectionStart, r2 = this.selectionEnd;
      e24.shiftKey ? this.setSelectionStartEndWithShift(n2, r2, t2) : (this.selectionStart = t2, this.selectionEnd = t2), this.isEditing && (this._fireSelectionChanged(), this._updateTextarea());
    }
    getSelectionStartFromPointer(e24) {
      let t2 = this.canvas.getScenePoint(e24).transform(R(this.calcTransformMatrix())).add(new N(-this._getLeftOffset(), -this._getTopOffset())), n2 = 0, r2 = 0, i2 = 0;
      for (let e25 = 0; e25 < this._textLines.length && n2 <= t2.y; e25++) n2 += this.getHeightOfLine(e25), i2 = e25, e25 > 0 && (r2 += this._textLines[e25 - 1].length + this.missingNewlineOffset(e25 - 1));
      let a2 = Math.abs(this._getLineLeftOffset(i2)), o2 = this._textLines[i2].length, s3 = this.__charBounds[i2];
      for (let e25 = 0; e25 < o2; e25++) {
        let n3 = a2 + s3[e25].kernedWidth;
        if (t2.x <= n3) {
          Math.abs(t2.x - n3) <= Math.abs(t2.x - a2) && r2++;
          break;
        }
        a2 = n3, r2++;
      }
      return Math.min(this.flipX ? o2 - r2 : r2, this._text.length);
    }
  };
  var is = `moveCursorUp`;
  var as = `moveCursorDown`;
  var os = `moveCursorLeft`;
  var ss = `moveCursorRight`;
  var cs = `exitEditing`;
  var ls = (e24, t2) => {
    let n2 = t2.getRetinaScaling();
    e24.setTransform(n2, 0, 0, n2, 0, 0);
    let r2 = t2.viewportTransform;
    e24.transform(r2[0], r2[1], r2[2], r2[3], r2[4], r2[5]);
  };
  var us = { selectionStart: 0, selectionEnd: 0, selectionColor: `rgba(17,119,255,0.3)`, isEditing: false, editable: true, editingBorderColor: `rgba(102,153,255,0.25)`, cursorWidth: 2, cursorColor: ``, cursorDelay: 1e3, cursorDuration: 600, caching: true, hiddenTextareaContainer: null, keysMap: { 9: cs, 27: cs, 33: is, 34: as, 35: ss, 36: os, 37: os, 38: is, 39: ss, 40: as }, keysMapRtl: { 9: cs, 27: cs, 33: is, 34: as, 35: os, 36: ss, 37: ss, 38: is, 39: os, 40: as }, ctrlKeysMapDown: { 65: `cmdAll` }, ctrlKeysMapUp: { 67: `copy`, 88: `cut` }, _selectionDirection: null, _reSpace: /\s|\r?\n/, inCompositionMode: false };
  var ds = class e20 extends rs {
    static getDefaults() {
      return { ...super.getDefaults(), ...e20.ownDefaults };
    }
    get type() {
      let e24 = super.type;
      return e24 === `itext` ? `i-text` : e24;
    }
    constructor(t2, n2) {
      super(t2, { ...e20.ownDefaults, ...n2 }), this.initBehavior();
    }
    _set(e24, t2) {
      return this.isEditing && this._savedProps && e24 in this._savedProps ? (this._savedProps[e24] = t2, this) : (e24 === `canvas` && (this.canvas instanceof ho && this.canvas.textEditingManager.remove(this), t2 instanceof ho && t2.textEditingManager.add(this)), super._set(e24, t2));
    }
    setSelectionStart(e24) {
      e24 = Math.max(e24, 0), this._updateAndFire(`selectionStart`, e24);
    }
    setSelectionEnd(e24) {
      e24 = Math.min(e24, this.text.length), this._updateAndFire(`selectionEnd`, e24);
    }
    _updateAndFire(e24, t2) {
      this[e24] !== t2 && (this._fireSelectionChanged(), this[e24] = t2), this._updateTextarea();
    }
    _fireSelectionChanged() {
      this.fire(`selection:changed`), this.canvas && this.canvas.fire(`text:selection:changed`, { target: this });
    }
    initDimensions() {
      this.isEditing && this.initDelayedCursor(), super.initDimensions();
    }
    getSelectionStyles(e24 = this.selectionStart || 0, t2 = this.selectionEnd, n2) {
      return super.getSelectionStyles(e24, t2, n2);
    }
    setSelectionStyles(e24, t2 = this.selectionStart || 0, n2 = this.selectionEnd) {
      return super.setSelectionStyles(e24, t2, n2);
    }
    get2DCursorLocation(e24 = this.selectionStart, t2) {
      return super.get2DCursorLocation(e24, t2);
    }
    render(e24) {
      super.render(e24), this.cursorOffsetCache = {}, this.renderCursorOrSelection();
    }
    toCanvasElement(e24) {
      let t2 = this.isEditing;
      this.isEditing = false;
      let n2 = super.toCanvasElement(e24);
      return this.isEditing = t2, n2;
    }
    renderCursorOrSelection() {
      if (!this.isEditing || !this.canvas) return;
      let e24 = this.clearContextTop(true);
      if (!e24) return;
      let t2 = this._getCursorBoundaries(), n2 = this.findAncestorsWithClipPath(), r2 = n2.length > 0, i2, a2 = e24;
      if (r2) {
        i2 = F(e24.canvas), a2 = i2.getContext(`2d`), ls(a2, this.canvas);
        let t3 = this.calcTransformMatrix();
        a2.transform(t3[0], t3[1], t3[2], t3[3], t3[4], t3[5]);
      }
      if (this.selectionStart !== this.selectionEnd || this.inCompositionMode ? this.renderSelection(a2, t2) : this.renderCursor(a2, t2), r2) for (let t3 of n2) {
        let n3 = t3.clipPath, r3 = F(e24.canvas), i3 = r3.getContext(`2d`);
        if (ls(i3, this.canvas), !n3.absolutePositioned) {
          let e25 = t3.calcTransformMatrix();
          i3.transform(e25[0], e25[1], e25[2], e25[3], e25[4], e25[5]);
        }
        n3.transform(i3), n3.drawObject(i3, true, {}), this.drawClipPathOnCache(a2, n3, r3);
      }
      r2 && (e24.setTransform(1, 0, 0, 1, 0, 0), e24.drawImage(i2, 0, 0)), this.canvas.contextTopDirty = true, e24.restore();
    }
    findAncestorsWithClipPath() {
      let e24 = [], t2 = this;
      for (; t2; ) t2.clipPath && e24.push(t2), t2 = t2.parent;
      return e24;
    }
    _getCursorBoundaries(e24 = this.selectionStart, t2) {
      let n2 = this._getLeftOffset(), r2 = this._getTopOffset(), i2 = this._getCursorBoundariesOffsets(e24, t2);
      return { left: n2, top: r2, leftOffset: i2.left, topOffset: i2.top };
    }
    _getCursorBoundariesOffsets(e24, t2) {
      return t2 ? this.__getCursorBoundariesOffsets(e24) : this.cursorOffsetCache && `top` in this.cursorOffsetCache ? this.cursorOffsetCache : this.cursorOffsetCache = this.__getCursorBoundariesOffsets(e24);
    }
    __getCursorBoundariesOffsets(e24) {
      let t2 = 0, n2 = 0, { charIndex: r2, lineIndex: i2 } = this.get2DCursorLocation(e24), { textAlign: a2, direction: o2 } = this;
      for (let e25 = 0; e25 < i2; e25++) t2 += this.getHeightOfLine(e25);
      let s3 = this._getLineLeftOffset(i2), c2 = this.__charBounds[i2][r2];
      c2 && (n2 = c2.left), this.charSpacing !== 0 && r2 === this._textLines[i2].length && (n2 -= this._getWidthOfCharSpacing());
      let l2 = s3 + (n2 > 0 ? n2 : 0);
      return o2 === `rtl` && (a2 === `right` || a2 === `justify` || a2 === `justify-right` ? l2 *= -1 : a2 === `left` || a2 === `justify-left` ? l2 = s3 - (n2 > 0 ? n2 : 0) : a2 !== `center` && a2 !== `justify-center` || (l2 = s3 - (n2 > 0 ? n2 : 0))), { top: t2, left: l2 };
    }
    renderCursorAt(e24) {
      this._renderCursor(this.canvas.contextTop, this._getCursorBoundaries(e24, true), e24);
    }
    renderCursor(e24, t2) {
      this._renderCursor(e24, t2, this.selectionStart);
    }
    getCursorRenderingData(e24 = this.selectionStart, t2 = this._getCursorBoundaries(e24)) {
      let n2 = this.get2DCursorLocation(e24), r2 = n2.lineIndex, i2 = n2.charIndex > 0 ? n2.charIndex - 1 : 0, a2 = this.getValueOfPropertyAt(r2, i2, `fontSize`), o2 = this.getObjectScaling().x * this.canvas.getZoom(), s3 = this.cursorWidth / o2, c2 = this.getValueOfPropertyAt(r2, i2, `deltaY`), l2 = t2.topOffset + (1 - this._fontSizeFraction) * this.getHeightOfLine(r2) / this.lineHeight - a2 * (1 - this._fontSizeFraction);
      return { color: this.cursorColor || this.getValueOfPropertyAt(r2, i2, `fill`), opacity: this._currentCursorOpacity, left: t2.left + t2.leftOffset - s3 / 2, top: l2 + t2.top + c2, width: s3, height: a2 };
    }
    _renderCursor(e24, t2, n2) {
      let { color: r2, opacity: i2, left: a2, top: o2, width: s3, height: c2 } = this.getCursorRenderingData(n2, t2);
      e24.fillStyle = r2, e24.globalAlpha = i2, e24.fillRect(a2, o2, s3, c2);
    }
    renderSelection(e24, t2) {
      let n2 = { selectionStart: this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart, selectionEnd: this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd };
      this._renderSelection(e24, n2, t2);
    }
    renderDragSourceEffect() {
      let e24 = this.draggableTextDelegate.getDragStartSelection();
      this._renderSelection(this.canvas.contextTop, e24, this._getCursorBoundaries(e24.selectionStart, true));
    }
    renderDropTargetEffect(e24) {
      let t2 = this.getSelectionStartFromPointer(e24);
      this.renderCursorAt(t2);
    }
    _renderSelection(e24, t2, n2) {
      let { textAlign: r2, direction: i2 } = this, a2 = t2.selectionStart, o2 = t2.selectionEnd, s3 = r2.includes(En), c2 = this.get2DCursorLocation(a2), l2 = this.get2DCursorLocation(o2), u2 = c2.lineIndex, d2 = l2.lineIndex, f2 = c2.charIndex < 0 ? 0 : c2.charIndex, p2 = l2.charIndex < 0 ? 0 : l2.charIndex;
      for (let t3 = u2; t3 <= d2; t3++) {
        let a3 = this._getLineLeftOffset(t3) || 0, o3 = this.getHeightOfLine(t3), c3 = 0, l3 = 0;
        if (t3 === u2 && (c3 = this.__charBounds[u2][f2].left), t3 >= u2 && t3 < d2) l3 = s3 && !this.isEndOfWrapping(t3) ? this.width : this.getLineWidth(t3) || 5;
        else if (t3 === d2) if (p2 === 0) l3 = this.__charBounds[d2][p2].left;
        else {
          let e25 = this._getWidthOfCharSpacing();
          l3 = this.__charBounds[d2][p2 - 1].left + this.__charBounds[d2][p2 - 1].width - e25;
        }
        let m = o3;
        (this.lineHeight < 1 || t3 === d2 && this.lineHeight > 1) && (o3 /= this.lineHeight);
        let h2 = n2.left + a3 + c3, g2 = o3, _2 = 0, v2 = l3 - c3;
        this.inCompositionMode ? (e24.fillStyle = this.compositionColor || `black`, g2 = 1, _2 = o3) : e24.fillStyle = this.selectionColor, i2 === `rtl` && (r2 === `right` || r2 === `justify` || r2 === `justify-right` ? h2 = this.width - h2 - v2 : r2 === `left` || r2 === `justify-left` ? h2 = n2.left + a3 - l3 : r2 !== `center` && r2 !== `justify-center` || (h2 = n2.left + a3 - l3)), e24.fillRect(h2, n2.top + n2.topOffset + _2, v2, g2), n2.topOffset += m;
      }
    }
    getCurrentCharFontSize() {
      let e24 = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(e24.l, e24.c, `fontSize`);
    }
    getCurrentCharColor() {
      let e24 = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(e24.l, e24.c, j);
    }
    _getCurrentCharIndex() {
      let e24 = this.get2DCursorLocation(this.selectionStart, true), t2 = e24.charIndex > 0 ? e24.charIndex - 1 : 0;
      return { l: e24.lineIndex, c: t2 };
    }
    dispose() {
      this.exitEditingImpl(), this.draggableTextDelegate.dispose(), super.dispose();
    }
  };
  i(ds, `ownDefaults`, us), i(ds, `type`, `IText`), M.setClass(ds), M.setClass(ds, `i-text`);
  var fs = class e21 extends ds {
    static getDefaults() {
      return { ...super.getDefaults(), ...e21.ownDefaults };
    }
    constructor(t2, n2) {
      super(t2, { ...e21.ownDefaults, ...n2 });
    }
    static createControls() {
      return { controls: gi() };
    }
    initDimensions() {
      this.initialized && (this.isEditing && this.initDelayedCursor(), this._clearCache(), this.dynamicMinWidth = 0, this._styleMap = this._generateStyleMap(this._splitText()), this.dynamicMinWidth > this.width && this._set(`width`, this.dynamicMinWidth), this.textAlign.includes(`justify`) && this.enlargeSpaces(), this.height = this.calcTextHeight());
    }
    _generateStyleMap(e24) {
      let t2 = 0, n2 = 0, r2 = 0, i2 = {};
      for (let a2 = 0; a2 < e24.graphemeLines.length; a2++) e24.graphemeText[r2] === `
` && a2 > 0 ? (n2 = 0, r2++, t2++) : !this.splitByGrapheme && this._reSpaceAndTab.test(e24.graphemeText[r2]) && a2 > 0 && (n2++, r2++), i2[a2] = { line: t2, offset: n2 }, r2 += e24.graphemeLines[a2].length, n2 += e24.graphemeLines[a2].length;
      return i2;
    }
    styleHas(e24, t2) {
      if (this._styleMap && !this.isWrapping) {
        let e25 = this._styleMap[t2];
        e25 && (t2 = e25.line);
      }
      return super.styleHas(e24, t2);
    }
    isEmptyStyles(e24) {
      if (!this.styles) return true;
      let t2, n2, r2 = 0, i2 = false, a2 = this._styleMap[e24], o2 = this._styleMap[e24 + 1];
      a2 && (e24 = a2.line, r2 = a2.offset), o2 && (t2 = o2.line, i2 = t2 === e24, n2 = o2.offset);
      let s3 = e24 === void 0 ? this.styles : { line: this.styles[e24] };
      for (let e25 in s3) for (let t3 in s3[e25]) {
        let a3 = parseInt(t3, 10);
        if (a3 >= r2 && (!i2 || a3 < n2)) for (let n3 in s3[e25][t3]) return false;
      }
      return true;
    }
    _getStyleDeclaration(e24, t2) {
      if (this._styleMap && !this.isWrapping) {
        let n2 = this._styleMap[e24];
        if (!n2) return {};
        e24 = n2.line, t2 = n2.offset + t2;
      }
      return super._getStyleDeclaration(e24, t2);
    }
    _setStyleDeclaration(e24, t2, n2) {
      let r2 = this._styleMap[e24];
      super._setStyleDeclaration(r2.line, r2.offset + t2, n2);
    }
    _deleteStyleDeclaration(e24, t2) {
      let n2 = this._styleMap[e24];
      super._deleteStyleDeclaration(n2.line, n2.offset + t2);
    }
    _getLineStyle(e24) {
      let t2 = this._styleMap[e24];
      return !!this.styles[t2.line];
    }
    _setLineStyle(e24) {
      let t2 = this._styleMap[e24];
      super._setLineStyle(t2.line);
    }
    _wrapText(e24, t2) {
      this.isWrapping = true;
      let n2 = this.getGraphemeDataForRender(e24), r2 = [];
      for (let e25 = 0; e25 < n2.wordsData.length; e25++) r2.push(...this._wrapLine(e25, t2, n2));
      return this.isWrapping = false, r2;
    }
    getGraphemeDataForRender(e24) {
      let t2 = this.splitByGrapheme, n2 = t2 ? `` : ` `, r2 = 0;
      return { wordsData: e24.map((e25, i2) => {
        let a2 = 0, o2 = t2 ? this.graphemeSplit(e25) : this.wordSplit(e25);
        return o2.length === 0 ? [{ word: [], width: 0 }] : o2.map((e26) => {
          let o3 = t2 ? [e26] : this.graphemeSplit(e26), s3 = this._measureWord(o3, i2, a2);
          return r2 = Math.max(s3, r2), a2 += o3.length + n2.length, { word: o3, width: s3 };
        });
      }), largestWordWidth: r2 };
    }
    _measureWord(e24, t2, n2 = 0) {
      let r2, i2 = 0;
      for (let a2 = 0, o2 = e24.length; a2 < o2; a2++) i2 += this._getGraphemeBox(e24[a2], t2, a2 + n2, r2, true).kernedWidth, r2 = e24[a2];
      return i2;
    }
    wordSplit(e24) {
      return e24.split(this._wordJoiners);
    }
    _wrapLine(e24, t2, { largestWordWidth: n2, wordsData: r2 }, i2 = 0) {
      let a2 = this._getWidthOfCharSpacing(), o2 = this.splitByGrapheme, s3 = [], c2 = o2 ? `` : ` `, l2 = 0, u2 = [], d2 = 0, f2 = 0, p2 = true;
      t2 -= i2;
      let m = Math.max(t2, n2, this.dynamicMinWidth), h2 = r2[e24], g2;
      for (g2 = 0; g2 < h2.length; g2++) {
        let { word: t3, width: n3 } = h2[g2];
        d2 += t3.length, l2 += f2 + n3 - a2, l2 > m && !p2 ? (s3.push(u2), u2 = [], l2 = n3, p2 = true) : l2 += a2, p2 || o2 || u2.push(c2), u2 = u2.concat(t3), f2 = o2 ? 0 : this._measureWord([c2], e24, d2), d2++, p2 = false;
      }
      return g2 && s3.push(u2), n2 + i2 > this.dynamicMinWidth && (this.dynamicMinWidth = n2 - a2 + i2), s3;
    }
    isEndOfWrapping(e24) {
      return !this._styleMap[e24 + 1] || this._styleMap[e24 + 1].line !== this._styleMap[e24].line;
    }
    missingNewlineOffset(e24, t2) {
      return this.splitByGrapheme && !t2 ? +!!this.isEndOfWrapping(e24) : 1;
    }
    _splitTextIntoLines(e24) {
      let t2 = super._splitTextIntoLines(e24), n2 = this._wrapText(t2.lines, this.width), r2 = Array(n2.length);
      for (let e25 = 0; e25 < n2.length; e25++) r2[e25] = n2[e25].join(``);
      return t2.lines = r2, t2.graphemeLines = n2, t2;
    }
    getMinWidth() {
      return Math.max(this.minWidth, this.dynamicMinWidth);
    }
    _removeExtraneousStyles() {
      let e24 = /* @__PURE__ */ new Map();
      for (let t2 in this._styleMap) {
        let n2 = parseInt(t2, 10);
        if (this._textLines[n2]) {
          let n3 = this._styleMap[t2].line;
          e24.set(`${n3}`, true);
        }
      }
      for (let t2 in this.styles) e24.has(t2) || delete this.styles[t2];
    }
    toObject(e24 = []) {
      return super.toObject([`minWidth`, `splitByGrapheme`, ...e24]);
    }
  };
  i(fs, `type`, `Textbox`), i(fs, `textLayoutProperties`, [...ds.textLayoutProperties, `width`]), i(fs, `ownDefaults`, { minWidth: 20, dynamicMinWidth: 2, lockScalingFlip: true, noScaleCache: false, _wordJoiners: /[ \t\r]/, splitByGrapheme: false }), M.setClass(fs);
  var ps = class extends ra {
    shouldPerformLayout(e24) {
      return !!e24.target.clipPath && super.shouldPerformLayout(e24);
    }
    shouldLayoutClipPath() {
      return false;
    }
    calcLayoutResult(e24, t2) {
      let { target: n2 } = e24, { clipPath: r2, group: i2 } = n2;
      if (!r2 || !this.shouldPerformLayout(e24)) return;
      let { width: a2, height: o2 } = wt(na(n2, r2)), s3 = new N(a2, o2);
      if (r2.absolutePositioned) return { center: Mt(r2.getRelativeCenterPoint(), void 0, i2 ? i2.calcTransformMatrix() : void 0), size: s3 };
      {
        let i3 = r2.getRelativeCenterPoint().transform(n2.calcOwnMatrix(), true);
        if (this.shouldPerformLayout(e24)) {
          let { center: n3 = new N(), correction: r3 = new N() } = this.calcBoundingBox(t2, e24) || {};
          return { center: n3.add(i3), correction: r3.subtract(i3), size: s3 };
        }
        return { center: n2.getRelativeCenterPoint().add(i3), size: s3 };
      }
    }
  };
  i(ps, `type`, `clip-path`), M.setClass(ps);
  var ms = class extends ra {
    getInitialSize({ target: e24 }, { size: t2 }) {
      return new N(e24.width || t2.x, e24.height || t2.y);
    }
  };
  i(ms, `type`, `fixed`), M.setClass(ms);
  var hs = class extends oa {
    subscribeTargets(e24) {
      let t2 = e24.target;
      e24.targets.reduce((e25, t3) => (t3.parent && e25.add(t3.parent), e25), /* @__PURE__ */ new Set()).forEach((e25) => {
        e25.layoutManager.subscribeTargets({ target: e25, targets: [t2] });
      });
    }
    unsubscribeTargets(e24) {
      let t2 = e24.target, n2 = t2.getObjects();
      e24.targets.reduce((e25, t3) => (t3.parent && e25.add(t3.parent), e25), /* @__PURE__ */ new Set()).forEach((e25) => {
        !n2.some((t3) => t3.parent === e25) && e25.layoutManager.unsubscribeTargets({ target: e25, targets: [t2] });
      });
    }
  };
  var gs = class e22 extends ca {
    static getDefaults() {
      return { ...super.getDefaults(), ...e22.ownDefaults };
    }
    constructor(t2 = [], n2 = {}) {
      super(), Object.assign(this, e22.ownDefaults), this.setOptions(n2);
      let { left: r2, top: i2, layoutManager: a2 } = n2;
      this.groupInit(t2, { left: r2, top: i2, layoutManager: a2 == null ? new hs() : a2 });
    }
    _shouldSetNestedCoords() {
      return true;
    }
    __objectSelectionMonitor() {
    }
    multiSelectAdd(...e24) {
      this.multiSelectionStacking === `selection-order` ? this.add(...e24) : e24.forEach((e25) => {
        let t2 = this._objects.findIndex((t3) => t3.isInFrontOf(e25)), n2 = t2 === -1 ? this.size() : t2;
        this.insertAt(n2, e25);
      });
    }
    canEnterGroup(e24) {
      return this.getObjects().some((t2) => t2.isDescendantOf(e24) || e24.isDescendantOf(t2)) ? (s(`error`, `ActiveSelection: circular object trees are not supported, this call has no effect`), false) : super.canEnterGroup(e24);
    }
    enterGroup(e24, t2) {
      e24.parent && e24.parent === e24.group ? e24.parent._exitGroup(e24) : e24.group && e24.parent !== e24.group && e24.group.remove(e24), this._enterGroup(e24, t2);
    }
    exitGroup(e24, t2) {
      this._exitGroup(e24, t2), e24.parent && e24.parent._enterGroup(e24, true);
    }
    _onAfterObjectsChange(e24, t2) {
      super._onAfterObjectsChange(e24, t2);
      let n2 = /* @__PURE__ */ new Set();
      t2.forEach((e25) => {
        let { parent: t3 } = e25;
        t3 && n2.add(t3);
      }), e24 === `removed` ? n2.forEach((e25) => {
        e25._onAfterObjectsChange(ta, t2);
      }) : n2.forEach((e25) => {
        e25._set(`dirty`, true);
      });
    }
    onDeselect() {
      return this.removeAll(), false;
    }
    toString() {
      return `#<ActiveSelection: (${this.complexity()})>`;
    }
    shouldCache() {
      return false;
    }
    isOnACache() {
      return false;
    }
    _renderControls(e24, t2, n2) {
      e24.save(), e24.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      let r2 = { hasControls: false, ...n2, forActiveSelection: true };
      for (let t3 = 0; t3 < this._objects.length; t3++) this._objects[t3]._renderControls(e24, r2);
      super._renderControls(e24, t2), e24.restore();
    }
  };
  i(gs, `type`, `ActiveSelection`), i(gs, `ownDefaults`, { multiSelectionStacking: `canvas-stacking` }), M.setClass(gs), M.setClass(gs, `activeSelection`);
  var _s = class {
    constructor() {
      i(this, `resources`, {});
    }
    applyFilters(e24, t2, n2, r2, i2) {
      let a2 = i2.getContext(`2d`, { willReadFrequently: true, desynchronized: true });
      if (!a2) return;
      a2.drawImage(t2, 0, 0, n2, r2);
      let o2 = { sourceWidth: n2, sourceHeight: r2, imageData: a2.getImageData(0, 0, n2, r2), originalEl: t2, originalImageData: a2.getImageData(0, 0, n2, r2), canvasEl: i2, ctx: a2, filterBackend: this };
      e24.forEach((e25) => {
        e25.applyTo(o2);
      });
      let { imageData: s3 } = o2;
      return s3.width === n2 && s3.height === r2 || (i2.width = s3.width, i2.height = s3.height), a2.putImageData(s3, 0, 0), o2;
    }
  };
  var vs = class {
    constructor({ tileSize: e24 = o.textureSize } = {}) {
      i(this, `aPosition`, new Float32Array([0, 0, 0, 1, 1, 0, 1, 1])), i(this, `resources`, {}), this.tileSize = e24, this.setupGLContext(e24, e24), this.captureGPUInfo();
    }
    setupGLContext(e24, t2) {
      this.dispose(), this.createWebGLCanvas(e24, t2);
    }
    createWebGLCanvas(e24, t2) {
      let n2 = F({ width: e24, height: t2 }), r2 = n2.getContext(`webgl`, { alpha: true, premultipliedAlpha: false, depth: false, stencil: false, antialias: false });
      r2 && (r2.clearColor(0, 0, 0, 0), this.canvas = n2, this.gl = r2);
    }
    applyFilters(e24, t2, n2, r2, i2, a2) {
      let o2 = this.gl, s3 = i2.getContext(`2d`);
      if (!o2 || !s3) return;
      let c2;
      a2 && (c2 = this.getCachedTexture(a2, t2));
      let l2 = { originalWidth: t2.width || t2.naturalWidth || 0, originalHeight: t2.height || t2.naturalHeight || 0, sourceWidth: n2, sourceHeight: r2, destinationWidth: n2, destinationHeight: r2, context: o2, sourceTexture: this.createTexture(o2, n2, r2, c2 ? void 0 : t2), targetTexture: this.createTexture(o2, n2, r2), originalTexture: c2 || this.createTexture(o2, n2, r2, c2 ? void 0 : t2), passes: e24.length, webgl: true, aPosition: this.aPosition, programCache: this.programCache, pass: 0, filterBackend: this, targetCanvas: i2 }, u2 = o2.createFramebuffer();
      return o2.bindFramebuffer(o2.FRAMEBUFFER, u2), e24.forEach((e25) => {
        e25 && e25.applyTo(l2);
      }), function(e25) {
        let t3 = e25.targetCanvas, n3 = t3.width, r3 = t3.height, i3 = e25.destinationWidth, a3 = e25.destinationHeight;
        n3 === i3 && r3 === a3 || (t3.width = i3, t3.height = a3);
      }(l2), this.copyGLTo2D(o2, l2), o2.bindTexture(o2.TEXTURE_2D, null), o2.deleteTexture(l2.sourceTexture), o2.deleteTexture(l2.targetTexture), o2.deleteFramebuffer(u2), s3.setTransform(1, 0, 0, 1, 0, 0), l2;
    }
    dispose() {
      this.canvas && (this.canvas = null, this.gl = null), this.clearWebGLCaches();
    }
    clearWebGLCaches() {
      this.programCache = {}, this.textureCache = {};
    }
    createTexture(e24, t2, n2, r2, i2) {
      let { NEAREST: a2, TEXTURE_2D: o2, RGBA: s3, UNSIGNED_BYTE: c2, CLAMP_TO_EDGE: l2, TEXTURE_MAG_FILTER: u2, TEXTURE_MIN_FILTER: d2, TEXTURE_WRAP_S: f2, TEXTURE_WRAP_T: p2 } = e24, m = e24.createTexture();
      return e24.bindTexture(o2, m), e24.texParameteri(o2, u2, i2 || a2), e24.texParameteri(o2, d2, i2 || a2), e24.texParameteri(o2, f2, l2), e24.texParameteri(o2, p2, l2), r2 ? e24.texImage2D(o2, 0, s3, s3, c2, r2) : e24.texImage2D(o2, 0, s3, t2, n2, 0, s3, c2, null), m;
    }
    getCachedTexture(e24, t2, n2) {
      let { textureCache: r2 } = this;
      if (r2[e24]) return r2[e24];
      {
        let i2 = this.createTexture(this.gl, t2.width, t2.height, t2, n2);
        return i2 && (r2[e24] = i2), i2;
      }
    }
    evictCachesForKey(e24) {
      this.textureCache[e24] && (this.gl.deleteTexture(this.textureCache[e24]), delete this.textureCache[e24]);
    }
    copyGLTo2D(e24, t2) {
      let n2 = e24.canvas, r2 = t2.targetCanvas, i2 = r2.getContext(`2d`);
      if (!i2) return;
      i2.translate(0, r2.height), i2.scale(1, -1);
      let a2 = n2.height - r2.height;
      i2.drawImage(n2, 0, a2, r2.width, r2.height, 0, 0, r2.width, r2.height);
    }
    copyGLTo2DPutImageData(e24, t2) {
      let n2 = t2.targetCanvas.getContext(`2d`), r2 = t2.destinationWidth, i2 = t2.destinationHeight, a2 = r2 * i2 * 4;
      if (!n2) return;
      let o2 = new Uint8Array(this.imageBuffer, 0, a2), s3 = new Uint8ClampedArray(this.imageBuffer, 0, a2);
      e24.readPixels(0, 0, r2, i2, e24.RGBA, e24.UNSIGNED_BYTE, o2);
      let c2 = new ImageData(s3, r2, i2);
      n2.putImageData(c2, 0, 0);
    }
    captureGPUInfo() {
      if (this.gpuInfo) return this.gpuInfo;
      let e24 = this.gl, t2 = { renderer: ``, vendor: `` };
      if (!e24) return t2;
      let n2 = e24.getExtension(`WEBGL_debug_renderer_info`);
      if (n2) {
        let r2 = e24.getParameter(n2.UNMASKED_RENDERER_WEBGL), i2 = e24.getParameter(n2.UNMASKED_VENDOR_WEBGL);
        r2 && (t2.renderer = r2.toLowerCase()), i2 && (t2.vendor = i2.toLowerCase());
      }
      return this.gpuInfo = t2, t2;
    }
  };
  var ys;
  function bs() {
    let { WebGLProbe: e24 } = h();
    return e24.queryWebGL(P()), o.enableGLFiltering && e24.isSupported(o.textureSize) ? new vs({ tileSize: o.textureSize }) : new _s();
  }
  function xs(e24 = true) {
    return !ys && e24 && (ys = bs()), ys;
  }
  function Ss(e24) {
    ys = e24;
  }
  var Cs = [`cropX`, `cropY`];
  var ws = class e23 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e23.ownDefaults };
    }
    constructor(t2, n2) {
      super(), i(this, `_lastScaleX`, 1), i(this, `_lastScaleY`, 1), i(this, `_filterScalingX`, 1), i(this, `_filterScalingY`, 1), this.filters = [], Object.assign(this, e23.ownDefaults), this.setOptions(n2), this.cacheKey = `texture${je()}`, this.setElement(typeof t2 == `string` ? (this.canvas && H(this.canvas.getElement()) || g()).getElementById(t2) : t2, n2);
    }
    getElement() {
      return this._element;
    }
    setElement(e24, t2 = {}) {
      this.removeTexture(this.cacheKey), this.removeTexture(`${this.cacheKey}_filtered`), this._element = e24, this._originalElement = e24, this._setWidthHeight(t2), this.filters.length !== 0 && this.applyFilters(), this.resizeFilter && this.applyResizeFilters();
    }
    removeTexture(e24) {
      let t2 = xs(false);
      t2 instanceof vs && t2.evictCachesForKey(e24);
    }
    dispose() {
      super.dispose(), this.removeTexture(this.cacheKey), this.removeTexture(`${this.cacheKey}_filtered`), this._cacheContext = null, [`_originalElement`, `_element`, `_filteredEl`, `_cacheCanvas`].forEach((e24) => {
        let t2 = this[e24];
        t2 && h().dispose(t2), this[e24] = void 0;
      });
    }
    getCrossOrigin() {
      return this._originalElement && (this._originalElement.crossOrigin || null);
    }
    getOriginalSize() {
      let e24 = this.getElement();
      return e24 ? { width: e24.naturalWidth || e24.width, height: e24.naturalHeight || e24.height } : { width: 0, height: 0 };
    }
    _stroke(e24) {
      if (!this.stroke || this.strokeWidth === 0) return;
      let t2 = this.width / 2, n2 = this.height / 2;
      e24.beginPath(), e24.moveTo(-t2, -n2), e24.lineTo(t2, -n2), e24.lineTo(t2, n2), e24.lineTo(-t2, n2), e24.lineTo(-t2, -n2), e24.closePath();
    }
    toObject(e24 = []) {
      let t2 = [];
      return this.filters.forEach((e25) => {
        e25 && t2.push(e25.toObject());
      }), { ...super.toObject([...Cs, ...e24]), src: this.getSrc(), crossOrigin: this.getCrossOrigin(), filters: t2, ...this.resizeFilter ? { resizeFilter: this.resizeFilter.toObject() } : {} };
    }
    hasCrop() {
      return !!this.cropX || !!this.cropY || this.width < this._element.width || this.height < this._element.height;
    }
    _toSVG() {
      let e24 = [], t2 = this._element, n2 = -this.width / 2, r2 = -this.height / 2, i2 = [], a2 = [], o2 = ``, s3 = ``;
      if (!t2) return [];
      if (this.hasCrop()) {
        let e25 = je();
        i2.push(`<clipPath id="imageCrop_` + e25 + `">
`, `	<rect x="` + n2 + `" y="` + r2 + `" width="` + U(this.width) + `" height="` + U(this.height) + `" />
`, `</clipPath>
`), o2 = ` clip-path="url(#imageCrop_` + e25 + `)" `;
      }
      if (this.imageSmoothing || (s3 = ` image-rendering="optimizeSpeed"`), e24.push(`	<image `, `COMMON_PARTS`, `xlink:href="${U(this.getSrc(true))}" x="${n2 - this.cropX}" y="${r2 - this.cropY}" width="${t2.width || t2.naturalWidth}" height="${t2.height || t2.naturalHeight}"${s3}${o2}></image>
`), this.stroke || this.strokeDashArray) {
        let e25 = this.fill;
        this.fill = null, a2 = [`	<rect x="${n2}" y="${r2}" width="${U(this.width)}" height="${U(this.height)}" style="${this.getSvgStyles()}" />
`], this.fill = e25;
      }
      return i2 = this.paintFirst === `fill` ? i2.concat(e24, a2) : i2.concat(a2, e24), i2;
    }
    getSrc(e24) {
      let t2 = e24 ? this._element : this._originalElement;
      return t2 ? t2.toDataURL ? t2.toDataURL() : this.srcFromAttribute ? t2.getAttribute(`src`) || `` : t2.src : this.src || ``;
    }
    getSvgSrc(e24) {
      return this.getSrc(e24);
    }
    setSrc(e24, { crossOrigin: t2, signal: n2 } = {}) {
      return Ze(e24, { crossOrigin: t2, signal: n2 }).then((e25) => {
        t2 !== void 0 && this.set({ crossOrigin: t2 }), this.setElement(e25);
      });
    }
    toString() {
      return `#<Image: { src: "${this.getSrc()}" }>`;
    }
    applyResizeFilters() {
      let e24 = this.resizeFilter, t2 = this.minimumScaleTrigger, n2 = this.getTotalObjectScaling(), r2 = n2.x, i2 = n2.y, a2 = this._filteredEl || this._originalElement;
      if (this.group && this.set(`dirty`, true), !e24 || r2 > t2 && i2 > t2) return this._element = a2, this._filterScalingX = 1, this._filterScalingY = 1, this._lastScaleX = r2, void (this._lastScaleY = i2);
      let o2 = F(a2), { width: s3, height: c2 } = a2;
      this._element = o2, this._lastScaleX = e24.scaleX = r2, this._lastScaleY = e24.scaleY = i2, xs().applyFilters([e24], a2, s3, c2, this._element), this._filterScalingX = o2.width / this._originalElement.width, this._filterScalingY = o2.height / this._originalElement.height;
    }
    applyFilters(e24 = this.filters || []) {
      if (e24 = e24.filter((e25) => e25 && !e25.isNeutralState()), this.set(`dirty`, true), this.removeTexture(`${this.cacheKey}_filtered`), e24.length === 0) return this._element = this._originalElement, this._filteredEl = void 0, this._filterScalingX = 1, void (this._filterScalingY = 1);
      let t2 = this._originalElement, n2 = t2.naturalWidth || t2.width, r2 = t2.naturalHeight || t2.height;
      if (this._element === this._originalElement) {
        let e25 = F({ width: n2, height: r2 });
        this._element = e25, this._filteredEl = e25;
      } else this._filteredEl && (this._element = this._filteredEl, this._filteredEl.getContext(`2d`).clearRect(0, 0, n2, r2), this._lastScaleX = 1, this._lastScaleY = 1);
      xs().applyFilters(e24, this._originalElement, n2, r2, this._element, this.cacheKey), this._originalElement.width === this._element.width && this._originalElement.height === this._element.height || (this._filterScalingX = this._element.width / this._originalElement.width, this._filterScalingY = this._element.height / this._originalElement.height);
    }
    _render(e24) {
      e24.imageSmoothingEnabled = this.imageSmoothing, true !== this.isMoving && this.resizeFilter && this._needsResize() && this.applyResizeFilters(), this._stroke(e24), this._renderPaintInOrder(e24);
    }
    drawCacheOnCanvas(e24) {
      e24.imageSmoothingEnabled = this.imageSmoothing, super.drawCacheOnCanvas(e24);
    }
    shouldCache() {
      return this.needsItsOwnCache();
    }
    _renderFill(e24) {
      let t2 = this._element;
      if (!t2) return;
      let n2 = this._filterScalingX, r2 = this._filterScalingY, i2 = this.width, a2 = this.height, o2 = Math.max(this.cropX, 0), s3 = Math.max(this.cropY, 0), c2 = t2.naturalWidth || t2.width, l2 = t2.naturalHeight || t2.height, u2 = o2 * n2, d2 = s3 * r2, f2 = Math.min(i2 * n2, c2 - u2), p2 = Math.min(a2 * r2, l2 - d2), m = -i2 / 2, h2 = -a2 / 2, g2 = Math.min(i2, c2 / n2 - o2), _2 = Math.min(a2, l2 / r2 - s3);
      t2 && e24.drawImage(t2, u2, d2, f2, p2, m, h2, g2, _2);
    }
    _needsResize() {
      let e24 = this.getTotalObjectScaling();
      return e24.x !== this._lastScaleX || e24.y !== this._lastScaleY;
    }
    _resetWidthHeight() {
      this.set(this.getOriginalSize());
    }
    _setWidthHeight({ width: e24, height: t2 } = {}) {
      let n2 = this.getOriginalSize();
      this.width = e24 || n2.width, this.height = t2 || n2.height;
    }
    parsePreserveAspectRatioAttribute() {
      let e24 = mn(this.preserveAspectRatio || ``), t2 = this.width, n2 = this.height, r2 = { width: t2, height: n2 }, i2, a2 = this._element.width, o2 = this._element.height, s3 = 1, c2 = 1, l2 = 0, u2 = 0, d2 = 0, f2 = 0;
      return !e24 || e24.alignX === `none` && e24.alignY === `none` ? (s3 = t2 / a2, c2 = n2 / o2) : (e24.meetOrSlice === `meet` && (s3 = c2 = ua(this._element, r2), i2 = (t2 - a2 * s3) / 2, e24.alignX === `Min` && (l2 = -i2), e24.alignX === `Max` && (l2 = i2), i2 = (n2 - o2 * c2) / 2, e24.alignY === `Min` && (u2 = -i2), e24.alignY === `Max` && (u2 = i2)), e24.meetOrSlice === `slice` && (s3 = c2 = da(this._element, r2), i2 = a2 - t2 / s3, e24.alignX === `Mid` && (d2 = i2 / 2), e24.alignX === `Max` && (d2 = i2), i2 = o2 - n2 / c2, e24.alignY === `Mid` && (f2 = i2 / 2), e24.alignY === `Max` && (f2 = i2), a2 = t2 / s3, o2 = n2 / c2)), { width: a2, height: o2, scaleX: s3, scaleY: c2, offsetLeft: l2, offsetTop: u2, cropX: d2, cropY: f2 };
    }
    static fromObject({ filters: e24, resizeFilter: t2, src: n2, crossOrigin: r2, type: i2, ...a2 }, o2) {
      return Promise.all([Ze(n2, { ...o2, crossOrigin: r2 }), e24 && Qe(e24, o2), t2 ? Qe([t2], o2) : [], $e(a2, o2)]).then(([e25, t3 = [], [r3], i3 = {}]) => new this(e25, { ...a2, src: n2, filters: t3, resizeFilter: r3, ...i3 }));
    }
    static fromURL(e24, { crossOrigin: t2 = null, signal: n2 } = {}, r2) {
      return Ze(e24, { crossOrigin: t2, signal: n2 }).then((e25) => new this(e25, r2));
    }
    static async fromElement(e24, t2 = {}, n2) {
      let r2 = Zi(e24, this.ATTRIBUTE_NAMES, n2);
      return this.fromURL(r2[`xlink:href`] || r2.href, t2, r2).catch((e25) => (s(`log`, `Unable to parse Image`, e25), null));
    }
  };
  i(ws, `type`, `Image`), i(ws, `cacheProperties`, [...Un, ...Cs]), i(ws, `ownDefaults`, { strokeWidth: 0, srcFromAttribute: false, minimumScaleTrigger: 0.5, cropX: 0, cropY: 0, imageSmoothing: true }), i(ws, `ATTRIBUTE_NAMES`, [...ki, `x`, `y`, `width`, `height`, `preserveAspectRatio`, `xlink:href`, `href`, `crossOrigin`, `image-rendering`]), M.setClass(ws), M.setSVGClass(ws);
  var Ds = _n([`pattern`, `defs`, `symbol`, `metadata`, `clipPath`, `mask`, `desc`]);
  var zs = (e24) => e24.webgl !== void 0;
  var Vs = `precision highp float`;
  var Hs = `
    ${Vs};
    varying vec2 vTexCoord;
    uniform sampler2D uTexture;
    void main() {
      gl_FragColor = texture2D(uTexture, vTexCoord);
    }`;
  var Us = new RegExp(Vs, `g`);
  var $ = class {
    get type() {
      return this.constructor.type;
    }
    constructor({ type: e24, ...t2 } = {}) {
      Object.assign(this, this.constructor.defaults, t2);
    }
    getFragmentSource() {
      return Hs;
    }
    getVertexSource() {
      return `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    void main() {
      vTexCoord = aPosition;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }`;
    }
    createProgram(e24, t2 = this.getFragmentSource(), n2 = this.getVertexSource()) {
      let { WebGLProbe: { GLPrecision: r2 = `highp` } } = h();
      r2 !== `highp` && (t2 = t2.replace(Us, Vs.replace(`highp`, r2)));
      let i2 = e24.createShader(e24.VERTEX_SHADER), a2 = e24.createShader(e24.FRAGMENT_SHADER), o2 = e24.createProgram();
      if (!i2 || !a2 || !o2) throw new c(`Vertex, fragment shader or program creation error`);
      if (e24.shaderSource(i2, n2), e24.compileShader(i2), !e24.getShaderParameter(i2, e24.COMPILE_STATUS)) throw new c(`Vertex shader compile error for ${this.type}: ${e24.getShaderInfoLog(i2)}`);
      if (e24.shaderSource(a2, t2), e24.compileShader(a2), !e24.getShaderParameter(a2, e24.COMPILE_STATUS)) throw new c(`Fragment shader compile error for ${this.type}: ${e24.getShaderInfoLog(a2)}`);
      if (e24.attachShader(o2, i2), e24.attachShader(o2, a2), e24.linkProgram(o2), !e24.getProgramParameter(o2, e24.LINK_STATUS)) throw new c(`Shader link error for "${this.type}" ${e24.getProgramInfoLog(o2)}`);
      let s3 = this.getUniformLocations(e24, o2) || {};
      return s3.uStepW = e24.getUniformLocation(o2, `uStepW`), s3.uStepH = e24.getUniformLocation(o2, `uStepH`), { program: o2, attributeLocations: this.getAttributeLocations(e24, o2), uniformLocations: s3 };
    }
    getAttributeLocations(e24, t2) {
      return { aPosition: e24.getAttribLocation(t2, `aPosition`) };
    }
    getUniformLocations(e24, t2) {
      let n2 = this.constructor.uniformLocations, r2 = {};
      for (let i2 = 0; i2 < n2.length; i2++) r2[n2[i2]] = e24.getUniformLocation(t2, n2[i2]);
      return r2;
    }
    sendAttributeData(e24, t2, n2) {
      let r2 = t2.aPosition, i2 = e24.createBuffer();
      e24.bindBuffer(e24.ARRAY_BUFFER, i2), e24.enableVertexAttribArray(r2), e24.vertexAttribPointer(r2, 2, e24.FLOAT, false, 0, 0), e24.bufferData(e24.ARRAY_BUFFER, n2, e24.STATIC_DRAW);
    }
    _setupFrameBuffer(e24) {
      let t2 = e24.context;
      if (e24.passes > 1) {
        let n2 = e24.destinationWidth, r2 = e24.destinationHeight;
        e24.sourceWidth === n2 && e24.sourceHeight === r2 || (t2.deleteTexture(e24.targetTexture), e24.targetTexture = e24.filterBackend.createTexture(t2, n2, r2)), t2.framebufferTexture2D(t2.FRAMEBUFFER, t2.COLOR_ATTACHMENT0, t2.TEXTURE_2D, e24.targetTexture, 0);
      } else t2.bindFramebuffer(t2.FRAMEBUFFER, null), t2.finish();
    }
    _swapTextures(e24) {
      e24.passes--, e24.pass++;
      let t2 = e24.targetTexture;
      e24.targetTexture = e24.sourceTexture, e24.sourceTexture = t2;
    }
    isNeutralState(e24) {
      return false;
    }
    applyTo(e24) {
      zs(e24) ? (this._setupFrameBuffer(e24), this.applyToWebGL(e24), this._swapTextures(e24)) : this.applyTo2d(e24);
    }
    applyTo2d(e24) {
    }
    getCacheKey() {
      return this.type;
    }
    retrieveShader(e24) {
      let t2 = this.getCacheKey();
      return e24.programCache[t2] || (e24.programCache[t2] = this.createProgram(e24.context)), e24.programCache[t2];
    }
    applyToWebGL(e24) {
      let t2 = e24.context, n2 = this.retrieveShader(e24);
      e24.pass === 0 && e24.originalTexture ? t2.bindTexture(t2.TEXTURE_2D, e24.originalTexture) : t2.bindTexture(t2.TEXTURE_2D, e24.sourceTexture), t2.useProgram(n2.program), this.sendAttributeData(t2, n2.attributeLocations, e24.aPosition), t2.uniform1f(n2.uniformLocations.uStepW, 1 / e24.sourceWidth), t2.uniform1f(n2.uniformLocations.uStepH, 1 / e24.sourceHeight), this.sendUniformData(t2, n2.uniformLocations), t2.viewport(0, 0, e24.destinationWidth, e24.destinationHeight), t2.drawArrays(t2.TRIANGLE_STRIP, 0, 4);
    }
    bindAdditionalTexture(e24, t2, n2) {
      e24.activeTexture(n2), e24.bindTexture(e24.TEXTURE_2D, t2), e24.activeTexture(e24.TEXTURE0);
    }
    unbindAdditionalTexture(e24, t2) {
      e24.activeTexture(t2), e24.bindTexture(e24.TEXTURE_2D, null), e24.activeTexture(e24.TEXTURE0);
    }
    sendUniformData(e24, t2) {
    }
    createHelpLayer(e24) {
      if (!e24.helpLayer) {
        let { sourceWidth: t2, sourceHeight: n2 } = e24;
        e24.helpLayer = F({ width: t2, height: n2 });
      }
    }
    toObject() {
      let e24 = Object.keys(this.constructor.defaults || {});
      return { type: this.type, ...e24.reduce((e25, t2) => (e25[t2] = this[t2], e25), {}) };
    }
    toJSON() {
      return this.toObject();
    }
    static async fromObject({ type: e24, ...t2 }, n2) {
      return new this(t2);
    }
  };
  i($, `type`, `BaseFilter`), i($, `uniformLocations`, []);
  var Ws = { multiply: `gl_FragColor.rgb *= uColor.rgb;
`, screen: `gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);
`, add: `gl_FragColor.rgb += uColor.rgb;
`, difference: `gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);
`, subtract: `gl_FragColor.rgb -= uColor.rgb;
`, lighten: `gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);
`, darken: `gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);
`, exclusion: `gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);
`, overlay: `
    if (uColor.r < 0.5) {
      gl_FragColor.r *= 2.0 * uColor.r;
    } else {
      gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);
    }
    if (uColor.g < 0.5) {
      gl_FragColor.g *= 2.0 * uColor.g;
    } else {
      gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);
    }
    if (uColor.b < 0.5) {
      gl_FragColor.b *= 2.0 * uColor.b;
    } else {
      gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);
    }
    `, tint: `
    gl_FragColor.rgb *= (1.0 - uColor.a);
    gl_FragColor.rgb += uColor.rgb;
    ` };
  var Gs = class extends $ {
    getCacheKey() {
      return `${this.type}_${this.mode}`;
    }
    getFragmentSource() {
      return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec4 uColor;
      varying vec2 vTexCoord;
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        gl_FragColor = color;
        if (color.a > 0.0) {
          ${Ws[this.mode]}
        }
      }
      `;
    }
    applyTo2d({ imageData: { data: e24 } }) {
      let t2 = new G(this.color).getSource(), n2 = this.alpha, r2 = t2[0] * n2, i2 = t2[1] * n2, a2 = t2[2] * n2, o2 = 1 - n2;
      for (let t3 = 0; t3 < e24.length; t3 += 4) {
        let n3 = e24[t3], s3 = e24[t3 + 1], c2 = e24[t3 + 2], l2, u2, d2;
        switch (this.mode) {
          case `multiply`:
            l2 = n3 * r2 / 255, u2 = s3 * i2 / 255, d2 = c2 * a2 / 255;
            break;
          case `screen`:
            l2 = 255 - (255 - n3) * (255 - r2) / 255, u2 = 255 - (255 - s3) * (255 - i2) / 255, d2 = 255 - (255 - c2) * (255 - a2) / 255;
            break;
          case `add`:
            l2 = n3 + r2, u2 = s3 + i2, d2 = c2 + a2;
            break;
          case `difference`:
            l2 = Math.abs(n3 - r2), u2 = Math.abs(s3 - i2), d2 = Math.abs(c2 - a2);
            break;
          case `subtract`:
            l2 = n3 - r2, u2 = s3 - i2, d2 = c2 - a2;
            break;
          case `darken`:
            l2 = Math.min(n3, r2), u2 = Math.min(s3, i2), d2 = Math.min(c2, a2);
            break;
          case `lighten`:
            l2 = Math.max(n3, r2), u2 = Math.max(s3, i2), d2 = Math.max(c2, a2);
            break;
          case `overlay`:
            l2 = r2 < 128 ? 2 * n3 * r2 / 255 : 255 - 2 * (255 - n3) * (255 - r2) / 255, u2 = i2 < 128 ? 2 * s3 * i2 / 255 : 255 - 2 * (255 - s3) * (255 - i2) / 255, d2 = a2 < 128 ? 2 * c2 * a2 / 255 : 255 - 2 * (255 - c2) * (255 - a2) / 255;
            break;
          case `exclusion`:
            l2 = r2 + n3 - 2 * r2 * n3 / 255, u2 = i2 + s3 - 2 * i2 * s3 / 255, d2 = a2 + c2 - 2 * a2 * c2 / 255;
            break;
          case `tint`:
            l2 = r2 + n3 * o2, u2 = i2 + s3 * o2, d2 = a2 + c2 * o2;
        }
        e24[t3] = l2, e24[t3 + 1] = u2, e24[t3 + 2] = d2;
      }
    }
    sendUniformData(e24, t2) {
      let n2 = new G(this.color).getSource();
      n2[0] = this.alpha * n2[0] / 255, n2[1] = this.alpha * n2[1] / 255, n2[2] = this.alpha * n2[2] / 255, n2[3] = this.alpha, e24.uniform4fv(t2.uColor, n2);
    }
  };
  i(Gs, `defaults`, { color: `#F95C63`, mode: `multiply`, alpha: 1 }), i(Gs, `type`, `BlendColor`), i(Gs, `uniformLocations`, [`uColor`]), M.setClass(Gs);
  var Ks = { multiply: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.rgba *= color2.rgba;
      gl_FragColor = color;
    }
    `, mask: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.a = color2.a;
      gl_FragColor = color;
    }
    ` };
  var qs = class extends $ {
    getCacheKey() {
      return `${this.type}_${this.mode}`;
    }
    getFragmentSource() {
      return Ks[this.mode];
    }
    getVertexSource() {
      return `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    uniform mat3 uTransformMatrix;
    void main() {
      vTexCoord = aPosition;
      vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }
    `;
    }
    applyToWebGL(e24) {
      let t2 = e24.context, n2 = this.createTexture(e24.filterBackend, this.image);
      this.bindAdditionalTexture(t2, n2, t2.TEXTURE1), super.applyToWebGL(e24), this.unbindAdditionalTexture(t2, t2.TEXTURE1);
    }
    createTexture(e24, t2) {
      return e24.getCachedTexture(t2.cacheKey, t2.getElement());
    }
    calculateMatrix() {
      let e24 = this.image, { width: t2, height: n2 } = e24.getElement();
      return [1 / e24.scaleX, 0, 0, 0, 1 / e24.scaleY, 0, -e24.left / t2, -e24.top / n2, 1];
    }
    applyTo2d({ imageData: { data: e24, width: t2, height: n2 }, filterBackend: { resources: r2 } }) {
      let i2 = this.image;
      r2.blendImage || (r2.blendImage = P());
      let a2 = r2.blendImage, o2 = a2.getContext(`2d`);
      a2.width !== t2 || a2.height !== n2 ? (a2.width = t2, a2.height = n2) : o2.clearRect(0, 0, t2, n2), o2.setTransform(i2.scaleX, 0, 0, i2.scaleY, i2.left, i2.top), o2.drawImage(i2.getElement(), 0, 0, t2, n2);
      let s3 = o2.getImageData(0, 0, t2, n2).data;
      for (let t3 = 0; t3 < e24.length; t3 += 4) {
        let n3 = e24[t3], r3 = e24[t3 + 1], i3 = e24[t3 + 2], a3 = e24[t3 + 3], o3 = s3[t3], c2 = s3[t3 + 1], l2 = s3[t3 + 2], u2 = s3[t3 + 3];
        switch (this.mode) {
          case `multiply`:
            e24[t3] = n3 * o3 / 255, e24[t3 + 1] = r3 * c2 / 255, e24[t3 + 2] = i3 * l2 / 255, e24[t3 + 3] = a3 * u2 / 255;
            break;
          case `mask`:
            e24[t3 + 3] = u2;
        }
      }
    }
    sendUniformData(e24, t2) {
      let n2 = this.calculateMatrix();
      e24.uniform1i(t2.uImage, 1), e24.uniformMatrix3fv(t2.uTransformMatrix, false, n2);
    }
    toObject() {
      return { ...super.toObject(), image: this.image && this.image.toObject() };
    }
    static async fromObject({ type: e24, image: t2, ...n2 }, r2) {
      return ws.fromObject(t2, r2).then((e25) => new this({ ...n2, image: e25 }));
    }
  };
  i(qs, `type`, `BlendImage`), i(qs, `defaults`, { mode: `multiply`, alpha: 1 }), i(qs, `uniformLocations`, [`uTransformMatrix`, `uImage`]), M.setClass(qs);
  var Js = class extends $ {
    getFragmentSource() {
      return `
    precision highp float;
    uniform sampler2D uTexture;
    uniform vec2 uDelta;
    varying vec2 vTexCoord;
    const float nSamples = 15.0;
    vec3 v3offset = vec3(12.9898, 78.233, 151.7182);
    float random(vec3 scale) {
      /* use the fragment position for a different seed per-pixel */
      return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);
    }
    void main() {
      vec4 color = vec4(0.0);
      float totalC = 0.0;
      float totalA = 0.0;
      float offset = random(v3offset);
      for (float t = -nSamples; t <= nSamples; t++) {
        float percent = (t + offset - 0.5) / nSamples;
        vec4 sample = texture2D(uTexture, vTexCoord + uDelta * percent);
        float weight = 1.0 - abs(percent);
        float alpha = weight * sample.a;
        color.rgb += sample.rgb * alpha;
        color.a += alpha;
        totalA += weight;
        totalC += alpha;
      }
      gl_FragColor.rgb = color.rgb / totalC;
      gl_FragColor.a = color.a / totalA;
    }
  `;
    }
    applyTo(e24) {
      zs(e24) ? (this.aspectRatio = e24.sourceWidth / e24.sourceHeight, e24.passes++, this._setupFrameBuffer(e24), this.horizontal = true, this.applyToWebGL(e24), this._swapTextures(e24), this._setupFrameBuffer(e24), this.horizontal = false, this.applyToWebGL(e24), this._swapTextures(e24)) : this.applyTo2d(e24);
    }
    applyTo2d({ imageData: { data: e24, width: t2, height: n2 } }) {
      this.aspectRatio = t2 / n2, this.horizontal = true;
      let r2 = this.getBlurValue() * t2, i2 = new Uint8ClampedArray(e24), a2 = 4 * t2;
      for (let t3 = 0; t3 < e24.length; t3 += 4) {
        let n3 = 0, o2 = 0, s3 = 0, c2 = 0, l2 = 0, u2 = t3 - t3 % a2, d2 = u2 + a2;
        for (let i3 = -14; i3 < 15; i3++) {
          let a3 = i3 / 15, f2 = 4 * Math.floor(r2 * a3), p2 = 1 - Math.abs(a3), m = t3 + f2;
          m < u2 ? m = u2 : m > d2 && (m = d2);
          let h2 = e24[m + 3] * p2;
          n3 += e24[m] * h2, o2 += e24[m + 1] * h2, s3 += e24[m + 2] * h2, c2 += h2, l2 += p2;
        }
        i2[t3] = n3 / c2, i2[t3 + 1] = o2 / c2, i2[t3 + 2] = s3 / c2, i2[t3 + 3] = c2 / l2;
      }
      this.horizontal = false, r2 = this.getBlurValue() * n2;
      for (let t3 = 0; t3 < i2.length; t3 += 4) {
        let n3 = 0, o2 = 0, s3 = 0, c2 = 0, l2 = 0, u2 = t3 % a2, d2 = i2.length - a2 + u2;
        for (let e25 = -14; e25 < 15; e25++) {
          let f2 = e25 / 15, p2 = Math.floor(r2 * f2) * a2, m = 1 - Math.abs(f2), h2 = t3 + p2;
          h2 < u2 ? h2 = u2 : h2 > d2 && (h2 = d2);
          let g2 = i2[h2 + 3] * m;
          n3 += i2[h2] * g2, o2 += i2[h2 + 1] * g2, s3 += i2[h2 + 2] * g2, c2 += g2, l2 += m;
        }
        e24[t3] = n3 / c2, e24[t3 + 1] = o2 / c2, e24[t3 + 2] = s3 / c2, e24[t3 + 3] = c2 / l2;
      }
    }
    sendUniformData(e24, t2) {
      let n2 = this.chooseRightDelta();
      e24.uniform2fv(t2.uDelta, n2);
    }
    isNeutralState() {
      return this.blur === 0;
    }
    getBlurValue() {
      let e24 = 1, { horizontal: t2, aspectRatio: n2 } = this;
      return t2 ? n2 > 1 && (e24 = 1 / n2) : n2 < 1 && (e24 = n2), e24 * this.blur * 0.12;
    }
    chooseRightDelta() {
      let e24 = this.getBlurValue();
      return this.horizontal ? [e24, 0] : [0, e24];
    }
  };
  i(Js, `type`, `Blur`), i(Js, `defaults`, { blur: 0 }), i(Js, `uniformLocations`, [`uDelta`]), M.setClass(Js);
  var Ys = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBrightness;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += uBrightness;
    gl_FragColor = color;
  }
`;
    }
    applyTo2d({ imageData: { data: e24 } }) {
      let t2 = Math.round(255 * this.brightness);
      for (let n2 = 0; n2 < e24.length; n2 += 4) e24[n2] += t2, e24[n2 + 1] += t2, e24[n2 + 2] += t2;
    }
    isNeutralState() {
      return this.brightness === 0;
    }
    sendUniformData(e24, t2) {
      e24.uniform1f(t2.uBrightness, this.brightness);
    }
  };
  i(Ys, `type`, `Brightness`), i(Ys, `defaults`, { brightness: 0 }), i(Ys, `uniformLocations`, [`uBrightness`]), M.setClass(Ys);
  var Xs = { matrix: [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0], colorsOnly: true };
  var Zs = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  varying vec2 vTexCoord;
  uniform mat4 uColorMatrix;
  uniform vec4 uConstants;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color *= uColorMatrix;
    color += uConstants;
    gl_FragColor = color;
  }`;
    }
    applyTo2d(e24) {
      let t2 = e24.imageData.data, n2 = this.matrix, r2 = this.colorsOnly;
      for (let e25 = 0; e25 < t2.length; e25 += 4) {
        let i2 = t2[e25], a2 = t2[e25 + 1], o2 = t2[e25 + 2];
        if (t2[e25] = i2 * n2[0] + a2 * n2[1] + o2 * n2[2] + 255 * n2[4], t2[e25 + 1] = i2 * n2[5] + a2 * n2[6] + o2 * n2[7] + 255 * n2[9], t2[e25 + 2] = i2 * n2[10] + a2 * n2[11] + o2 * n2[12] + 255 * n2[14], !r2) {
          let r3 = t2[e25 + 3];
          t2[e25] += r3 * n2[3], t2[e25 + 1] += r3 * n2[8], t2[e25 + 2] += r3 * n2[13], t2[e25 + 3] = i2 * n2[15] + a2 * n2[16] + o2 * n2[17] + r3 * n2[18] + 255 * n2[19];
        }
      }
    }
    sendUniformData(e24, t2) {
      let n2 = this.matrix, r2 = [n2[0], n2[1], n2[2], n2[3], n2[5], n2[6], n2[7], n2[8], n2[10], n2[11], n2[12], n2[13], n2[15], n2[16], n2[17], n2[18]], i2 = [n2[4], n2[9], n2[14], n2[19]];
      e24.uniformMatrix4fv(t2.uColorMatrix, false, r2), e24.uniform4fv(t2.uConstants, i2);
    }
    toObject() {
      return { ...super.toObject(), matrix: [...this.matrix] };
    }
  };
  function Qs(e24, t2) {
    var n2;
    let r2 = (i(n2 = class extends Zs {
      toObject() {
        return { type: this.type, colorsOnly: this.colorsOnly };
      }
    }, `type`, e24), i(n2, `defaults`, { colorsOnly: false, matrix: t2 }), n2);
    return M.setClass(r2, e24), r2;
  }
  i(Zs, `type`, `ColorMatrix`), i(Zs, `defaults`, Xs), i(Zs, `uniformLocations`, [`uColorMatrix`, `uConstants`]), M.setClass(Zs);
  var $s = Qs(`Brownie`, [0.5997, 0.34553, -0.27082, 0, 0.186, -0.0377, 0.86095, 0.15059, 0, -0.1449, 0.24113, -0.07441, 0.44972, 0, -0.02965, 0, 0, 0, 1, 0]);
  var ec = Qs(`Vintage`, [0.62793, 0.32021, -0.03965, 0, 0.03784, 0.02578, 0.64411, 0.03259, 0, 0.02926, 0.0466, -0.08512, 0.52416, 0, 0.02023, 0, 0, 0, 1, 0]);
  var tc = Qs(`Kodachrome`, [1.12855, -0.39673, -0.03992, 0, 0.24991, -0.16404, 1.08352, -0.05498, 0, 0.09698, -0.16786, -0.56034, 1.60148, 0, 0.13972, 0, 0, 0, 1, 0]);
  var nc = Qs(`Technicolor`, [1.91252, -0.85453, -0.09155, 0, 0.04624, -0.30878, 1.76589, -0.10601, 0, -0.27589, -0.2311, -0.75018, 1.84759, 0, 0.12137, 0, 0, 0, 1, 0]);
  var rc = Qs(`Polaroid`, [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0]);
  var ic = Qs(`Sepia`, [0.393, 0.769, 0.189, 0, 0, 0.349, 0.686, 0.168, 0, 0, 0.272, 0.534, 0.131, 0, 0, 0, 0, 0, 1, 0]);
  var ac = Qs(`BlackWhite`, [1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 0, 0, 0, 1, 0]);
  var oc = class extends $ {
    constructor(e24 = {}) {
      super(e24), this.subFilters = e24.subFilters || [];
    }
    applyTo(e24) {
      zs(e24) && (e24.passes += this.subFilters.length - 1), this.subFilters.forEach((t2) => {
        t2.applyTo(e24);
      });
    }
    toObject() {
      return { type: this.type, subFilters: this.subFilters.map((e24) => e24.toObject()) };
    }
    isNeutralState() {
      return !this.subFilters.some((e24) => !e24.isNeutralState());
    }
    static fromObject(e24, t2) {
      return Promise.all((e24.subFilters || []).map((e25) => M.getClass(e25.type).fromObject(e25, t2))).then((e25) => new this({ subFilters: e25 }));
    }
  };
  i(oc, `type`, `Composed`), M.setClass(oc);
  var sc = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uContrast;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));
    color.rgb = contrastF * (color.rgb - 0.5) + 0.5;
    gl_FragColor = color;
  }`;
    }
    isNeutralState() {
      return this.contrast === 0;
    }
    applyTo2d({ imageData: { data: e24 } }) {
      let t2 = Math.floor(255 * this.contrast), n2 = 259 * (t2 + 255) / (255 * (259 - t2));
      for (let t3 = 0; t3 < e24.length; t3 += 4) e24[t3] = n2 * (e24[t3] - 128) + 128, e24[t3 + 1] = n2 * (e24[t3 + 1] - 128) + 128, e24[t3 + 2] = n2 * (e24[t3 + 2] - 128) + 128;
    }
    sendUniformData(e24, t2) {
      e24.uniform1f(t2.uContrast, this.contrast);
    }
  };
  i(sc, `type`, `Contrast`), i(sc, `defaults`, { contrast: 0 }), i(sc, `uniformLocations`, [`uContrast`]), M.setClass(sc);
  var cc = { Convolute_3_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_3_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_5_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_5_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_7_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_7_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_9_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_9_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    ` };
  var lc = class extends $ {
    getCacheKey() {
      return `${this.type}_${Math.sqrt(this.matrix.length)}_${+!!this.opaque}`;
    }
    getFragmentSource() {
      return cc[this.getCacheKey()];
    }
    applyTo2d(e24) {
      let t2 = e24.imageData, n2 = t2.data, r2 = this.matrix, i2 = Math.round(Math.sqrt(r2.length)), a2 = Math.floor(i2 / 2), o2 = t2.width, s3 = t2.height, c2 = e24.ctx.createImageData(o2, s3), l2 = c2.data, u2 = +!!this.opaque, d2, f2, p2, m, h2, g2, _2, v2, y2, b2, x2, S2, C2;
      for (x2 = 0; x2 < s3; x2++) for (b2 = 0; b2 < o2; b2++) {
        for (h2 = 4 * (x2 * o2 + b2), d2 = 0, f2 = 0, p2 = 0, m = 0, C2 = 0; C2 < i2; C2++) for (S2 = 0; S2 < i2; S2++) _2 = x2 + C2 - a2, g2 = b2 + S2 - a2, _2 < 0 || _2 >= s3 || g2 < 0 || g2 >= o2 || (v2 = 4 * (_2 * o2 + g2), y2 = r2[C2 * i2 + S2], d2 += n2[v2] * y2, f2 += n2[v2 + 1] * y2, p2 += n2[v2 + 2] * y2, u2 || (m += n2[v2 + 3] * y2));
        l2[h2] = d2, l2[h2 + 1] = f2, l2[h2 + 2] = p2, l2[h2 + 3] = u2 ? n2[h2 + 3] : m;
      }
      e24.imageData = c2;
    }
    sendUniformData(e24, t2) {
      e24.uniform1fv(t2.uMatrix, this.matrix);
    }
    toObject() {
      return { ...super.toObject(), opaque: this.opaque, matrix: [...this.matrix] };
    }
  };
  i(lc, `type`, `Convolute`), i(lc, `defaults`, { opaque: false, matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0] }), i(lc, `uniformLocations`, [`uMatrix`, `uOpaque`, `uHalfSize`, `uSize`]), M.setClass(lc);
  var uc = `Gamma`;
  var dc = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform vec3 uGamma;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    vec3 correction = (1.0 / uGamma);
    color.r = pow(color.r, correction.r);
    color.g = pow(color.g, correction.g);
    color.b = pow(color.b, correction.b);
    gl_FragColor = color;
    gl_FragColor.rgb *= color.a;
  }
`;
    }
    constructor(e24 = {}) {
      super(e24), this.gamma = e24.gamma || this.constructor.defaults.gamma.concat();
    }
    applyTo2d({ imageData: { data: e24 } }) {
      let t2 = this.gamma, n2 = 1 / t2[0], r2 = 1 / t2[1], i2 = 1 / t2[2];
      this.rgbValues || (this.rgbValues = { r: new Uint8Array(256), g: new Uint8Array(256), b: new Uint8Array(256) });
      let a2 = this.rgbValues;
      for (let e25 = 0; e25 < 256; e25++) a2.r[e25] = 255 * (e25 / 255) ** n2, a2.g[e25] = 255 * (e25 / 255) ** r2, a2.b[e25] = 255 * (e25 / 255) ** i2;
      for (let t3 = 0; t3 < e24.length; t3 += 4) e24[t3] = a2.r[e24[t3]], e24[t3 + 1] = a2.g[e24[t3 + 1]], e24[t3 + 2] = a2.b[e24[t3 + 2]];
    }
    sendUniformData(e24, t2) {
      e24.uniform3fv(t2.uGamma, this.gamma);
    }
    isNeutralState() {
      let { gamma: e24 } = this;
      return e24[0] === 1 && e24[1] === 1 && e24[2] === 1;
    }
    toObject() {
      return { type: uc, gamma: this.gamma.concat() };
    }
  };
  i(dc, `type`, uc), i(dc, `defaults`, { gamma: [1, 1, 1] }), i(dc, `uniformLocations`, [`uGamma`]), M.setClass(dc);
  var fc = { average: `
    precision highp float;
    uniform sampler2D uTexture;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      float average = (color.r + color.b + color.g) / 3.0;
      gl_FragColor = vec4(average, average, average, color.a);
    }
    `, lightness: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    `, luminosity: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    ` };
  var pc = class extends $ {
    applyTo2d({ imageData: { data: e24 } }) {
      for (let t2, n2 = 0; n2 < e24.length; n2 += 4) {
        let r2 = e24[n2], i2 = e24[n2 + 1], a2 = e24[n2 + 2];
        switch (this.mode) {
          case `average`:
            t2 = (r2 + i2 + a2) / 3;
            break;
          case `lightness`:
            t2 = (Math.min(r2, i2, a2) + Math.max(r2, i2, a2)) / 2;
            break;
          case `luminosity`:
            t2 = 0.21 * r2 + 0.72 * i2 + 0.07 * a2;
        }
        e24[n2 + 2] = e24[n2 + 1] = e24[n2] = t2;
      }
    }
    getCacheKey() {
      return `${this.type}_${this.mode}`;
    }
    getFragmentSource() {
      return fc[this.mode];
    }
    sendUniformData(e24, t2) {
      e24.uniform1i(t2.uMode, 1);
    }
    isNeutralState() {
      return false;
    }
  };
  i(pc, `type`, `Grayscale`), i(pc, `defaults`, { mode: `average` }), i(pc, `uniformLocations`, [`uMode`]), M.setClass(pc);
  var mc = { ...Xs, rotation: 0 };
  var hc = class extends Zs {
    calculateMatrix() {
      let e24 = this.rotation * Math.PI, t2 = Se(e24), n2 = Ce(e24), r2 = 1 / 3, i2 = Math.sqrt(r2) * n2, a2 = 1 - t2;
      this.matrix = [t2 + a2 / 3, r2 * a2 - i2, r2 * a2 + i2, 0, 0, r2 * a2 + i2, t2 + r2 * a2, r2 * a2 - i2, 0, 0, r2 * a2 - i2, r2 * a2 + i2, t2 + r2 * a2, 0, 0, 0, 0, 0, 1, 0];
    }
    isNeutralState() {
      return this.rotation === 0;
    }
    applyTo(e24) {
      this.calculateMatrix(), super.applyTo(e24);
    }
    toObject() {
      return { type: this.type, rotation: this.rotation };
    }
  };
  i(hc, `type`, `HueRotation`), i(hc, `defaults`, mc), M.setClass(hc);
  var gc = class extends $ {
    applyTo2d({ imageData: { data: e24 } }) {
      for (let t2 = 0; t2 < e24.length; t2 += 4) e24[t2] = 255 - e24[t2], e24[t2 + 1] = 255 - e24[t2 + 1], e24[t2 + 2] = 255 - e24[t2 + 2], this.alpha && (e24[t2 + 3] = 255 - e24[t2 + 3]);
    }
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform int uInvert;
  uniform int uAlpha;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    if (uInvert == 1) {
      if (uAlpha == 1) {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,1.0 -color.a);
      } else {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);
      }
    } else {
      gl_FragColor = color;
    }
  }
`;
    }
    isNeutralState() {
      return !this.invert;
    }
    sendUniformData(e24, t2) {
      e24.uniform1i(t2.uInvert, Number(this.invert)), e24.uniform1i(t2.uAlpha, Number(this.alpha));
    }
  };
  i(gc, `type`, `Invert`), i(gc, `defaults`, { alpha: false, invert: true }), i(gc, `uniformLocations`, [`uInvert`, `uAlpha`]), M.setClass(gc);
  var _c = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uStepH;
  uniform float uNoise;
  uniform float uSeed;
  varying vec2 vTexCoord;
  float rand(vec2 co, float seed, float vScale) {
    return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);
  }
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;
    gl_FragColor = color;
  }
`;
    }
    applyTo2d({ imageData: { data: e24 } }) {
      let t2 = this.noise;
      for (let n2 = 0; n2 < e24.length; n2 += 4) {
        let r2 = (0.5 - Math.random()) * t2;
        e24[n2] += r2, e24[n2 + 1] += r2, e24[n2 + 2] += r2;
      }
    }
    sendUniformData(e24, t2) {
      e24.uniform1f(t2.uNoise, this.noise / 255), e24.uniform1f(t2.uSeed, Math.random());
    }
    isNeutralState() {
      return this.noise === 0;
    }
  };
  i(_c, `type`, `Noise`), i(_c, `defaults`, { noise: 0 }), i(_c, `uniformLocations`, [`uNoise`, `uSeed`]), M.setClass(_c);
  var vc = class extends $ {
    applyTo2d({ imageData: { data: e24, width: t2, height: n2 } }) {
      for (let r2 = 0; r2 < n2; r2 += this.blocksize) for (let i2 = 0; i2 < t2; i2 += this.blocksize) {
        let a2 = 4 * r2 * t2 + 4 * i2, o2 = e24[a2], s3 = e24[a2 + 1], c2 = e24[a2 + 2], l2 = e24[a2 + 3];
        for (let a3 = r2; a3 < Math.min(r2 + this.blocksize, n2); a3++) for (let n3 = i2; n3 < Math.min(i2 + this.blocksize, t2); n3++) {
          let r3 = 4 * a3 * t2 + 4 * n3;
          e24[r3] = o2, e24[r3 + 1] = s3, e24[r3 + 2] = c2, e24[r3 + 3] = l2;
        }
      }
    }
    isNeutralState() {
      return this.blocksize === 1;
    }
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBlocksize;
  uniform float uStepW;
  uniform float uStepH;
  varying vec2 vTexCoord;
  void main() {
    float blockW = uBlocksize * uStepW;
    float blockH = uBlocksize * uStepH;
    int posX = int(vTexCoord.x / blockW);
    int posY = int(vTexCoord.y / blockH);
    float fposX = float(posX);
    float fposY = float(posY);
    vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);
    vec4 color = texture2D(uTexture, squareCoords);
    gl_FragColor = color;
  }
`;
    }
    sendUniformData(e24, t2) {
      e24.uniform1f(t2.uBlocksize, this.blocksize);
    }
  };
  i(vc, `type`, `Pixelate`), i(vc, `defaults`, { blocksize: 4 }), i(vc, `uniformLocations`, [`uBlocksize`]), M.setClass(vc);
  var yc = class extends $ {
    getFragmentSource() {
      return `
precision highp float;
uniform sampler2D uTexture;
uniform vec4 uLow;
uniform vec4 uHigh;
varying vec2 vTexCoord;
void main() {
  gl_FragColor = texture2D(uTexture, vTexCoord);
  if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {
    gl_FragColor.a = 0.0;
  }
}
`;
    }
    applyTo2d({ imageData: { data: e24 } }) {
      let t2 = 255 * this.distance, n2 = new G(this.color).getSource(), r2 = [n2[0] - t2, n2[1] - t2, n2[2] - t2], i2 = [n2[0] + t2, n2[1] + t2, n2[2] + t2];
      for (let t3 = 0; t3 < e24.length; t3 += 4) {
        let n3 = e24[t3], a2 = e24[t3 + 1], o2 = e24[t3 + 2];
        n3 > r2[0] && a2 > r2[1] && o2 > r2[2] && n3 < i2[0] && a2 < i2[1] && o2 < i2[2] && (e24[t3 + 3] = 0);
      }
    }
    sendUniformData(e24, t2) {
      let n2 = new G(this.color).getSource(), r2 = this.distance, i2 = [0 + n2[0] / 255 - r2, 0 + n2[1] / 255 - r2, 0 + n2[2] / 255 - r2, 1], a2 = [n2[0] / 255 + r2, n2[1] / 255 + r2, n2[2] / 255 + r2, 1];
      e24.uniform4fv(t2.uLow, i2), e24.uniform4fv(t2.uHigh, a2);
    }
  };
  i(yc, `type`, `RemoveColor`), i(yc, `defaults`, { color: `#FFFFFF`, distance: 0.02, useAlpha: false }), i(yc, `uniformLocations`, [`uLow`, `uHigh`]), M.setClass(yc);
  var bc = class extends $ {
    sendUniformData(e24, t2) {
      e24.uniform2fv(t2.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]), e24.uniform1fv(t2.uTaps, this.taps);
    }
    getFilterWindow() {
      let e24 = this.tempScale;
      return Math.ceil(this.lanczosLobes / e24);
    }
    getCacheKey() {
      let e24 = this.getFilterWindow();
      return `${this.type}_${e24}`;
    }
    getFragmentSource() {
      let e24 = this.getFilterWindow();
      return this.generateShader(e24);
    }
    getTaps() {
      let e24 = this.lanczosCreate(this.lanczosLobes), t2 = this.tempScale, n2 = this.getFilterWindow(), r2 = Array(n2);
      for (let i2 = 1; i2 <= n2; i2++) r2[i2 - 1] = e24(i2 * t2);
      return r2;
    }
    generateShader(e24) {
      let t2 = Array(e24);
      for (let n2 = 1; n2 <= e24; n2++) t2[n2 - 1] = `${n2}.0 * uDelta`;
      return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec2 uDelta;
      varying vec2 vTexCoord;
      uniform float uTaps[${e24}];
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        float sum = 1.0;
        ${t2.map((e25, t3) => `
              color += texture2D(uTexture, vTexCoord + ${e25}) * uTaps[${t3}] + texture2D(uTexture, vTexCoord - ${e25}) * uTaps[${t3}];
              sum += 2.0 * uTaps[${t3}];
            `).join(`
`)}
        gl_FragColor = color / sum;
      }
    `;
    }
    applyToForWebgl(e24) {
      e24.passes++, this.width = e24.sourceWidth, this.horizontal = true, this.dW = Math.round(this.width * this.scaleX), this.dH = e24.sourceHeight, this.tempScale = this.dW / this.width, this.taps = this.getTaps(), e24.destinationWidth = this.dW, super.applyTo(e24), e24.sourceWidth = e24.destinationWidth, this.height = e24.sourceHeight, this.horizontal = false, this.dH = Math.round(this.height * this.scaleY), this.tempScale = this.dH / this.height, this.taps = this.getTaps(), e24.destinationHeight = this.dH, super.applyTo(e24), e24.sourceHeight = e24.destinationHeight;
    }
    applyTo(e24) {
      zs(e24) ? this.applyToForWebgl(e24) : this.applyTo2d(e24);
    }
    isNeutralState() {
      return this.scaleX === 1 && this.scaleY === 1;
    }
    lanczosCreate(e24) {
      return (t2) => {
        if (t2 >= e24 || t2 <= -e24) return 0;
        if (t2 < 11920929e-14 && t2 > -11920929e-14) return 1;
        let n2 = (t2 *= Math.PI) / e24;
        return Math.sin(t2) / t2 * Math.sin(n2) / n2;
      };
    }
    applyTo2d(e24) {
      let t2 = e24.imageData, n2 = this.scaleX, r2 = this.scaleY;
      this.rcpScaleX = 1 / n2, this.rcpScaleY = 1 / r2;
      let i2 = t2.width, a2 = t2.height, o2 = Math.round(i2 * n2), s3 = Math.round(a2 * r2), c2;
      c2 = this.resizeType === `sliceHack` ? this.sliceByTwo(e24, i2, a2, o2, s3) : this.resizeType === `hermite` ? this.hermiteFastResize(e24, i2, a2, o2, s3) : this.resizeType === `bilinear` ? this.bilinearFiltering(e24, i2, a2, o2, s3) : this.resizeType === `lanczos` ? this.lanczosResize(e24, i2, a2, o2, s3) : new ImageData(o2, s3), e24.imageData = c2;
    }
    sliceByTwo(e24, t2, n2, r2, i2) {
      let a2 = e24.imageData, o2 = 0.5, s3 = false, c2 = false, l2 = t2 * o2, u2 = n2 * o2, d2 = e24.filterBackend.resources, f2 = 0, p2 = 0, m = t2, h2 = 0;
      d2.sliceByTwo || (d2.sliceByTwo = P());
      let g2 = d2.sliceByTwo;
      (g2.width < 1.5 * t2 || g2.height < n2) && (g2.width = 1.5 * t2, g2.height = n2);
      let _2 = g2.getContext(`2d`);
      for (_2.clearRect(0, 0, 1.5 * t2, n2), _2.putImageData(a2, 0, 0), r2 = Math.floor(r2), i2 = Math.floor(i2); !s3 || !c2; ) t2 = l2, n2 = u2, r2 < Math.floor(l2 * o2) ? l2 = Math.floor(l2 * o2) : (l2 = r2, s3 = true), i2 < Math.floor(u2 * o2) ? u2 = Math.floor(u2 * o2) : (u2 = i2, c2 = true), _2.drawImage(g2, f2, p2, t2, n2, m, h2, l2, u2), f2 = m, p2 = h2, h2 += u2;
      return _2.getImageData(f2, p2, r2, i2);
    }
    lanczosResize(e24, t2, n2, r2, i2) {
      let a2 = e24.imageData.data, o2 = e24.ctx.createImageData(r2, i2), s3 = o2.data, c2 = this.lanczosCreate(this.lanczosLobes), l2 = this.rcpScaleX, u2 = this.rcpScaleY, d2 = 2 / this.rcpScaleX, f2 = 2 / this.rcpScaleY, p2 = Math.ceil(l2 * this.lanczosLobes / 2), m = Math.ceil(u2 * this.lanczosLobes / 2), h2 = {}, g2 = { x: 0, y: 0 }, _2 = { x: 0, y: 0 };
      return function e25(v2) {
        let y2, b2, x2, S2, C2, w2, ee2, T2, E2, D2, O2;
        for (g2.x = (v2 + 0.5) * l2, _2.x = Math.floor(g2.x), y2 = 0; y2 < i2; y2++) {
          for (g2.y = (y2 + 0.5) * u2, _2.y = Math.floor(g2.y), C2 = 0, w2 = 0, ee2 = 0, T2 = 0, E2 = 0, b2 = _2.x - p2; b2 <= _2.x + p2; b2++) if (!(b2 < 0 || b2 >= t2)) {
            D2 = Math.floor(1e3 * Math.abs(b2 - g2.x)), h2[D2] || (h2[D2] = {});
            for (let e26 = _2.y - m; e26 <= _2.y + m; e26++) e26 < 0 || e26 >= n2 || (O2 = Math.floor(1e3 * Math.abs(e26 - g2.y)), h2[D2][O2] || (h2[D2][O2] = c2(Math.sqrt((D2 * d2) ** 2 + (O2 * f2) ** 2) / 1e3)), x2 = h2[D2][O2], x2 > 0 && (S2 = 4 * (e26 * t2 + b2), C2 += x2, w2 += x2 * a2[S2], ee2 += x2 * a2[S2 + 1], T2 += x2 * a2[S2 + 2], E2 += x2 * a2[S2 + 3]));
          }
          S2 = 4 * (y2 * r2 + v2), s3[S2] = w2 / C2, s3[S2 + 1] = ee2 / C2, s3[S2 + 2] = T2 / C2, s3[S2 + 3] = E2 / C2;
        }
        return ++v2 < r2 ? e25(v2) : o2;
      }(0);
    }
    bilinearFiltering(e24, t2, n2, r2, i2) {
      let a2, o2, s3, c2, l2, u2, d2, f2, p2, m, h2, g2, _2, v2 = 0, y2 = this.rcpScaleX, b2 = this.rcpScaleY, x2 = 4 * (t2 - 1), S2 = e24.imageData.data, C2 = e24.ctx.createImageData(r2, i2), w2 = C2.data;
      for (d2 = 0; d2 < i2; d2++) for (f2 = 0; f2 < r2; f2++) for (l2 = Math.floor(y2 * f2), u2 = Math.floor(b2 * d2), p2 = y2 * f2 - l2, m = b2 * d2 - u2, _2 = 4 * (u2 * t2 + l2), h2 = 0; h2 < 4; h2++) a2 = S2[_2 + h2], o2 = S2[_2 + 4 + h2], s3 = S2[_2 + x2 + h2], c2 = S2[_2 + x2 + 4 + h2], g2 = a2 * (1 - p2) * (1 - m) + o2 * p2 * (1 - m) + s3 * m * (1 - p2) + c2 * p2 * m, w2[v2++] = g2;
      return C2;
    }
    hermiteFastResize(e24, t2, n2, r2, i2) {
      let a2 = this.rcpScaleX, o2 = this.rcpScaleY, s3 = Math.ceil(a2 / 2), c2 = Math.ceil(o2 / 2), l2 = e24.imageData.data, u2 = e24.ctx.createImageData(r2, i2), d2 = u2.data;
      for (let e25 = 0; e25 < i2; e25++) for (let n3 = 0; n3 < r2; n3++) {
        let i3 = 4 * (n3 + e25 * r2), u3, f2 = 0, p2 = 0, m = 0, h2 = 0, g2 = 0, _2 = 0, v2 = (e25 + 0.5) * o2;
        for (let r3 = Math.floor(e25 * o2); r3 < (e25 + 1) * o2; r3++) {
          let e26 = Math.abs(v2 - (r3 + 0.5)) / c2, i4 = (n3 + 0.5) * a2, o3 = e26 * e26;
          for (let e27 = Math.floor(n3 * a2); e27 < (n3 + 1) * a2; e27++) {
            let n4 = Math.abs(i4 - (e27 + 0.5)) / s3, a3 = Math.sqrt(o3 + n4 * n4);
            a3 > 1 && a3 < -1 || (u3 = 2 * a3 * a3 * a3 - 3 * a3 * a3 + 1, u3 > 0 && (n4 = 4 * (e27 + r3 * t2), _2 += u3 * l2[n4 + 3], p2 += u3, l2[n4 + 3] < 255 && (u3 = u3 * l2[n4 + 3] / 250), m += u3 * l2[n4], h2 += u3 * l2[n4 + 1], g2 += u3 * l2[n4 + 2], f2 += u3));
          }
        }
        d2[i3] = m / f2, d2[i3 + 1] = h2 / f2, d2[i3 + 2] = g2 / f2, d2[i3 + 3] = _2 / p2;
      }
      return u2;
    }
  };
  i(bc, `type`, `Resize`), i(bc, `defaults`, { resizeType: `hermite`, scaleX: 1, scaleY: 1, lanczosLobes: 3 }), i(bc, `uniformLocations`, [`uDelta`, `uTaps`]), M.setClass(bc);
  var xc = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uSaturation;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float rgMax = max(color.r, color.g);
    float rgbMax = max(rgMax, color.b);
    color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;
    color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;
    color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;
    gl_FragColor = color;
  }
`;
    }
    applyTo2d({ imageData: { data: e24 } }) {
      let t2 = -this.saturation;
      for (let n2 = 0; n2 < e24.length; n2 += 4) {
        let r2 = e24[n2], i2 = e24[n2 + 1], a2 = e24[n2 + 2], o2 = Math.max(r2, i2, a2);
        e24[n2] += o2 === r2 ? 0 : (o2 - r2) * t2, e24[n2 + 1] += o2 === i2 ? 0 : (o2 - i2) * t2, e24[n2 + 2] += o2 === a2 ? 0 : (o2 - a2) * t2;
      }
    }
    sendUniformData(e24, t2) {
      e24.uniform1f(t2.uSaturation, -this.saturation);
    }
    isNeutralState() {
      return this.saturation === 0;
    }
  };
  i(xc, `type`, `Saturation`), i(xc, `defaults`, { saturation: 0 }), i(xc, `uniformLocations`, [`uSaturation`]), M.setClass(xc);
  var Sc = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uVibrance;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float max = max(color.r, max(color.g, color.b));
    float avg = (color.r + color.g + color.b) / 3.0;
    float amt = (abs(max - avg) * 2.0) * uVibrance;
    color.r += max != color.r ? (max - color.r) * amt : 0.00;
    color.g += max != color.g ? (max - color.g) * amt : 0.00;
    color.b += max != color.b ? (max - color.b) * amt : 0.00;
    gl_FragColor = color;
  }
`;
    }
    applyTo2d({ imageData: { data: e24 } }) {
      let t2 = -this.vibrance;
      for (let n2 = 0; n2 < e24.length; n2 += 4) {
        let r2 = e24[n2], i2 = e24[n2 + 1], a2 = e24[n2 + 2], o2 = Math.max(r2, i2, a2), s3 = (r2 + i2 + a2) / 3, c2 = 2 * Math.abs(o2 - s3) / 255 * t2;
        e24[n2] += o2 === r2 ? 0 : (o2 - r2) * c2, e24[n2 + 1] += o2 === i2 ? 0 : (o2 - i2) * c2, e24[n2 + 2] += o2 === a2 ? 0 : (o2 - a2) * c2;
      }
    }
    sendUniformData(e24, t2) {
      e24.uniform1f(t2.uVibrance, -this.vibrance);
    }
    isNeutralState() {
      return this.vibrance === 0;
    }
  };
  i(Sc, `type`, `Vibrance`), i(Sc, `defaults`, { vibrance: 0 }), i(Sc, `uniformLocations`, [`uVibrance`]), M.setClass(Sc);
  var Cc = t({ BaseFilter: () => $, BlackWhite: () => ac, BlendColor: () => Gs, BlendImage: () => qs, Blur: () => Js, Brightness: () => Ys, Brownie: () => $s, ColorMatrix: () => Zs, Composed: () => oc, Contrast: () => sc, Convolute: () => lc, Gamma: () => dc, Grayscale: () => pc, HueRotation: () => hc, Invert: () => gc, Kodachrome: () => tc, Noise: () => _c, Pixelate: () => vc, Polaroid: () => rc, RemoveColor: () => yc, Resize: () => bc, Saturation: () => xc, Sepia: () => ic, Technicolor: () => nc, Vibrance: () => Sc, Vintage: () => ec });

  // src/fonts-catalog.js
  var FONT_CATALOG = [
    { c: "Popular", f: "Poppins", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Roboto", w: [100, 300, 400, 500, 700, 900] },
    { c: "Popular", f: "Open Sans", w: [300, 400, 500, 600, 700, 800] },
    { c: "Popular", f: "Lato", w: [100, 300, 400, 700, 900] },
    { c: "Popular", f: "Montserrat", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Oswald", w: [200, 300, 400, 500, 600, 700] },
    { c: "Popular", f: "Raleway", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Nunito", w: [200, 300, 400, 600, 700, 800, 900] },
    { c: "Popular", f: "Rubik", w: [300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Work Sans", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Inter", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Outfit", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Barlow", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Urbanist", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "DM Sans", w: [400, 500, 700] },
    { c: "Popular", f: "Manrope", w: [200, 300, 400, 500, 600, 700, 800] },
    { c: "Popular", f: "Playfair Display", w: [400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Merriweather", w: [300, 400, 700, 900] },
    { c: "Popular", f: "Noto Sans", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Ubuntu", w: [300, 400, 500, 700] },
    { c: "Popular", f: "Fira Sans", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "PT Sans", w: [400, 700] },
    { c: "Popular", f: "Exo 2", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Mulish", w: [200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Karla", w: [200, 300, 400, 500, 600, 700, 800] },
    { c: "Popular", f: "Hind", w: [300, 400, 500, 600, 700] },
    { c: "Popular", f: "Quicksand", w: [300, 400, 500, 600, 700] },
    { c: "Popular", f: "Source Sans 3", w: [200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Jost", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Arimo", w: [400, 500, 600, 700] },
    { c: "Popular", f: "Cabin", w: [400, 500, 600, 700] },
    { c: "Popular", f: "Titillium Web", w: [200, 300, 400, 600, 700, 900] },
    { c: "Popular", f: "Mukta", w: [200, 300, 400, 500, 600, 700, 800] },
    { c: "Popular", f: "Assistant", w: [200, 300, 400, 600, 700, 800] },
    { c: "Popular", f: "Varela Round", w: [400] },
    { c: "Popular", f: "Public Sans", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Signika", w: [300, 400, 500, 600, 700] },
    { c: "Popular", f: "Overpass", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Heebo", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "IBM Plex Sans", w: [100, 200, 300, 400, 500, 600, 700] },
    { c: "Popular", f: "Cairo", w: [200, 300, 400, 600, 700, 900] },
    { c: "Popular", f: "Red Hat Display", w: [400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Prompt", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Tajawal", w: [200, 300, 400, 500, 700, 800, 900] },
    { c: "Popular", f: "Noto Serif", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Barlow Condensed", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Lexend", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Hind Siliguri", w: [300, 400, 500, 600, 700] },
    { c: "Popular", f: "Be Vietnam Pro", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Popular", f: "Noto Sans Display", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Modern", f: "Sora", w: [100, 200, 300, 400, 500, 600, 700, 800] },
    { c: "Modern", f: "Plus Jakarta Sans", w: [200, 300, 400, 500, 600, 700, 800] },
    { c: "Modern", f: "Kumbh Sans", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Modern", f: "Figtree", w: [300, 400, 500, 600, 700, 800, 900] },
    { c: "Modern", f: "Teko", w: [300, 400, 500, 600, 700] },
    { c: "Modern", f: "Anton", w: [400] },
    { c: "Modern", f: "Orbitron", w: [400, 500, 600, 700, 800, 900] },
    { c: "Modern", f: "Rajdhani", w: [300, 400, 500, 600, 700] },
    { c: "Modern", f: "Space Grotesk", w: [300, 400, 500, 600, 700] },
    { c: "Modern", f: "Syne", w: [400, 500, 600, 700, 800] },
    { c: "Modern", f: "Quantico", w: [400, 700] },
    { c: "Modern", f: "Michroma", w: [400] },
    { c: "Modern", f: "Audiowide", w: [400] },
    { c: "Modern", f: "Jura", w: [300, 400, 500, 600, 700] },
    { c: "Modern", f: "Varta", w: [300, 400, 500, 600, 700] },
    { c: "Modern", f: "Questrial", w: [400] },
    { c: "Modern", f: "Chivo", w: [300, 400, 700, 900] },
    { c: "Modern", f: "Sarabun", w: [100, 200, 300, 400, 500, 600, 700, 800] },
    { c: "Modern", f: "Asap", w: [400, 500, 600, 700] },
    { c: "Modern", f: "Coda", w: [400, 800] },
    { c: "Modern", f: "Anek Latin", w: [100, 200, 300, 400, 500, 600, 700, 800] },
    { c: "Modern", f: "Hanken Grotesk", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Modern", f: "Livvic", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Modern", f: "Exo", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Modern", f: "Pathway Extreme", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Modern", f: "Atkinson Hyperlegible", w: [400, 700] },
    { c: "Modern", f: "Encode Sans", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Modern", f: "Bai Jamjuree", w: [200, 300, 400, 500, 600, 700] },
    { c: "Modern", f: "Sen", w: [400, 700, 800] },
    { c: "Modern", f: "Readex Pro", w: [200, 300, 400, 500, 600, 700] },
    { c: "Classic", f: "Times New Roman", w: [400, 700] },
    { c: "Classic", f: "Crimson Text", w: [400, 600, 700] },
    { c: "Classic", f: "Cormorant", w: [300, 400, 500, 600, 700] },
    { c: "Classic", f: "Libre Baskerville", w: [400, 700] },
    { c: "Classic", f: "Domine", w: [400, 500, 600, 700] },
    { c: "Classic", f: "Lora", w: [400, 500, 600, 700] },
    { c: "Classic", f: "EB Garamond", w: [400, 500, 600, 700, 800] },
    { c: "Classic", f: "Tinos", w: [400, 700] },
    { c: "Classic", f: "Spectral", w: [200, 300, 400, 500, 600, 700, 800] },
    { c: "Classic", f: "Vollkorn", w: [400, 500, 600, 700, 800, 900] },
    { c: "Classic", f: "Cardo", w: [400, 700] },
    { c: "Classic", f: "PT Serif", w: [400, 700] },
    { c: "Classic", f: "Old Standard TT", w: [400, 700] },
    { c: "Classic", f: "Cormorant Garamond", w: [300, 400, 500, 600, 700] },
    { c: "Classic", f: "Zilla Slab", w: [300, 400, 500, 600, 700] },
    { c: "Classic", f: "Bitter", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Classic", f: "Nanum Myeongjo", w: [400, 700, 800] },
    { c: "Classic", f: "Gentium Book Plus", w: [400, 700] },
    { c: "Classic", f: "Alegreya", w: [400, 500, 600, 700, 800, 900] },
    { c: "Classic", f: "Brawler", w: [400] },
    { c: "Classic", f: "Sorts Mill Goudy", w: [400] },
    { c: "Classic", f: "DM Serif Text", w: [400] },
    { c: "Classic", f: "Arapey", w: [400, 700] },
    { c: "Classic", f: "Taviraj", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Classic", f: "Rokkitt", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Classic", f: "Inknut Antiqua", w: [300, 400, 500, 600, 700, 800, 900] },
    { c: "Classic", f: "Ledger", w: [400] },
    { c: "Classic", f: "Trirong", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Classic", f: "Noticia Text", w: [400, 700] },
    { c: "Classic", f: "Alice", w: [400] },
    { c: "Classic", f: "Neuton", w: [200, 300, 400, 700, 800] },
    { c: "Classic", f: "Judson", w: [400, 700] },
    { c: "Classic", f: "Rasa", w: [300, 400, 500, 600, 700] },
    { c: "Classic", f: "Coustard", w: [400, 900] },
    { c: "Classic", f: "Lustria", w: [400] },
    { c: "Classic", f: "Suranna", w: [400] },
    { c: "Classic", f: "Rhodium Libre", w: [400] },
    { c: "Classic", f: "Mate", w: [400, 700] },
    { c: "Classic", f: "Noto Serif Display", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Classic", f: "Cormorant Infant", w: [300, 400, 500, 600, 700] },
    { c: "Classic", f: "Gloock", w: [400] },
    { c: "Classic", f: "Fraunces", w: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { c: "Classic", f: "IBM Plex Serif", w: [100, 200, 300, 400, 500, 600, 700] },
    { c: "Classic", f: "Prata", w: [400] },
    { c: "Classic", f: "Adamina", w: [400] },
    { c: "Classic", f: "Maitree", w: [200, 300, 400, 500, 600, 700] },
    { c: "Classic", f: "Rosarivo", w: [400] },
    { c: "Playful", f: "Fredoka", w: [300, 400, 500, 600, 700] },
    { c: "Playful", f: "Baloo 2", w: [400, 500, 600, 700, 800] },
    { c: "Playful", f: "Chewy", w: [400] },
    { c: "Playful", f: "Bungee", w: [400] },
    { c: "Playful", f: "Permanent Marker", w: [400] },
    { c: "Playful", f: "Luckiest Guy", w: [400] },
    { c: "Playful", f: "Shadows Into Light", w: [400] },
    { c: "Playful", f: "Comic Neue", w: [300, 400, 700] },
    { c: "Playful", f: "Handlee", w: [400] },
    { c: "Playful", f: "Patrick Hand", w: [400] },
    { c: "Playful", f: "Bubblegum Sans", w: [400] },
    { c: "Playful", f: "Carter One", w: [400] },
    { c: "Playful", f: "Sigmar", w: [400] },
    { c: "Playful", f: "Boogaloo", w: [400] },
    { c: "Playful", f: "Chicle", w: [400] },
    { c: "Playful", f: "Titan One", w: [400] },
    { c: "Playful", f: "Leckerli One", w: [400] },
    { c: "Playful", f: "Righteous", w: [400] },
    { c: "Playful", f: "Skranji", w: [400, 700] },
    { c: "Playful", f: "Acme", w: [400] },
    { c: "Playful", f: "Amaranth", w: [400, 700] },
    { c: "Playful", f: "Bangers", w: [400] },
    { c: "Playful", f: "Black Ops One", w: [400] },
    { c: "Playful", f: "Lalezar", w: [400] },
    { c: "Playful", f: "Paytone One", w: [400] },
    { c: "Playful", f: "Rock Salt", w: [400] },
    { c: "Playful", f: "Ravi Prakash", w: [400] },
    { c: "Playful", f: "Special Elite", w: [400] },
    { c: "Playful", f: "Knewave", w: [400] },
    { c: "Playful", f: "Kaushan Script", w: [400] },
    { c: "Playful", f: "Press Start 2P", w: [400] },
    { c: "Playful", f: "Rye", w: [400] },
    { c: "Playful", f: "Sniglet", w: [400, 800] },
    { c: "Playful", f: "Cabin Sketch", w: [400, 700] },
    { c: "Playful", f: "Creepster", w: [400] },
    { c: "Playful", f: "Coiny", w: [400] },
    { c: "Playful", f: "Caveat Brush", w: [400] },
    { c: "Playful", f: "Berkshire Swash", w: [400] },
    { c: "Playful", f: "Bungee Inline", w: [400] },
    { c: "Playful", f: "Bungee Shade", w: [400] },
    { c: "Playful", f: "Bungee Hairline", w: [400] },
    { c: "Playful", f: "Fugaz One", w: [400] },
    { c: "Playful", f: "Gochi Hand", w: [400] },
    { c: "Playful", f: "Modak", w: [400] },
    { c: "Playful", f: "Oleo Script", w: [400, 700] },
    { c: "Playful", f: "Nova Round", w: [400] },
    { c: "Playful", f: "Salsa", w: [400] },
    { c: "Playful", f: "Ranchers", w: [400] },
    { c: "Playful", f: "ZCOOL KuaiLe", w: [400] },
    { c: "Handwritten", f: "Dancing Script", w: [400, 500, 600, 700] },
    { c: "Handwritten", f: "Pacifico", w: [400] },
    { c: "Handwritten", f: "Satisfy", w: [400] },
    { c: "Handwritten", f: "Caveat", w: [400, 500, 600, 700] },
    { c: "Handwritten", f: "Amatic SC", w: [400, 700] },
    { c: "Handwritten", f: "Great Vibes", w: [400] },
    { c: "Handwritten", f: "Sacramento", w: [400] },
    { c: "Handwritten", f: "Gloria Hallelujah", w: [400] },
    { c: "Handwritten", f: "Cookie", w: [400] },
    { c: "Handwritten", f: "Alex Brush", w: [400] },
    { c: "Handwritten", f: "Parisienne", w: [400] },
    { c: "Handwritten", f: "Tangerine", w: [400, 700] },
    { c: "Handwritten", f: "Marck Script", w: [400] },
    { c: "Handwritten", f: "Allura", w: [400] },
    { c: "Handwritten", f: "Arizonia", w: [400] },
    { c: "Handwritten", f: "Merienda", w: [400, 700] },
    { c: "Handwritten", f: "Yesteryear", w: [400] },
    { c: "Handwritten", f: "Bad Script", w: [400] },
    { c: "Handwritten", f: "Nanum Pen Script", w: [400] },
    { c: "Handwritten", f: "Reenie Beanie", w: [400] },
    { c: "Handwritten", f: "La Belle Aurore", w: [400] },
    { c: "Handwritten", f: "Kalam", w: [300, 400, 700] },
    { c: "Handwritten", f: "Covered By Your Grace", w: [400] },
    { c: "Handwritten", f: "Calligraffitti", w: [400] },
    { c: "Handwritten", f: "Architects Daughter", w: [400] },
    { c: "Handwritten", f: "Nothing You Could Do", w: [400] },
    { c: "Handwritten", f: "Just Another Hand", w: [400] },
    { c: "Handwritten", f: "Beth Ellen", w: [400] },
    { c: "Handwritten", f: "Cedarville Cursive", w: [400] },
    { c: "Handwritten", f: "Clicker Script", w: [400] },
    { c: "Handwritten", f: "Dawning of a New Day", w: [400] },
    { c: "Handwritten", f: "Give You Glory", w: [400] },
    { c: "Handwritten", f: "Homemade Apple", w: [400] },
    { c: "Handwritten", f: "Italianno", w: [400] },
    { c: "Handwritten", f: "Mrs Saint Delafield", w: [400] },
    { c: "Handwritten", f: "Sofia", w: [400] },
    { c: "Handwritten", f: "Sriracha", w: [400] },
    { c: "Handwritten", f: "Qwigley", w: [400] },
    { c: "Handwritten", f: "Zeyada", w: [400] },
    { c: "Handwritten", f: "Norican", w: [400] },
    { c: "Handwritten", f: "Rouge Script", w: [400] },
    { c: "Handwritten", f: "Herr Von Muellerhoff", w: [400] },
    { c: "Handwritten", f: "Pinyon Script", w: [400] }
  ];

  // src/fonts.js
  var CATEGORIES = [...new Set(FONT_CATALOG.map((e24) => e24.c))];
  var WEIGHT_LABELS = {
    100: "Thin",
    200: "Extra Light",
    300: "Light",
    400: "Regular",
    500: "Medium",
    600: "Semi Bold",
    700: "Bold",
    800: "Extra Bold",
    900: "Black"
  };
  var byFamily = new Map(FONT_CATALOG.map((e24) => [e24.f, e24]));
  var SYSTEM = /* @__PURE__ */ new Set(["Times New Roman"]);
  function fontWeights(family) {
    const e24 = byFamily.get(family);
    return e24 ? e24.w : [400, 700];
  }
  function nearestWeight(family, target2) {
    let best = null;
    for (const w2 of fontWeights(family)) {
      if (best === null || Math.abs(w2 - target2) < Math.abs(best - target2)) best = w2;
    }
    return best === null ? target2 : best;
  }
  function addStylesheet(href) {
    return new Promise((resolve) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.onload = resolve;
      link.onerror = resolve;
      document.head.appendChild(link);
      setTimeout(resolve, 4e3);
    });
  }
  var famParam = (family, wghts) => "family=" + encodeURIComponent(family).replace(/%20/g, "+") + ":wght@" + wghts;
  var CHUNK = 25;
  var previewLoaded = /* @__PURE__ */ new Set();
  function ensurePreviewCss(category) {
    if (previewLoaded.has(category)) return;
    previewLoaded.add(category);
    const fams = FONT_CATALOG.filter((e24) => e24.c === category && !SYSTEM.has(e24.f));
    for (let i2 = 0; i2 < fams.length; i2 += CHUNK) {
      const chunk = fams.slice(i2, i2 + CHUNK);
      const text = [...new Set(chunk.map((e24) => e24.f).join(""))].join("");
      const params = chunk.map((e24) => famParam(e24.f, nearestWeight(e24.f, 400))).join("&");
      addStylesheet(
        "https://fonts.googleapis.com/css2?" + params + "&text=" + encodeURIComponent(text) + "&display=swap"
      );
    }
  }
  function ensureAllPreviewCss() {
    CATEGORIES.forEach(ensurePreviewCss);
  }
  var loadedFull = /* @__PURE__ */ new Map();
  function loadFont(family) {
    if (SYSTEM.has(family)) return Promise.resolve();
    let p2 = loadedFull.get(family);
    if (!p2) {
      p2 = loadFontNow(family);
      loadedFull.set(family, p2);
    }
    return p2;
  }
  async function loadFontNow(family) {
    await addStylesheet(
      "https://fonts.googleapis.com/css2?" + famParam(family, fontWeights(family).join(";")) + "&display=swap"
    );
    const reg = nearestWeight(family, 400);
    const bold = nearestWeight(family, 700);
    try {
      await Promise.all([
        document.fonts.load(reg + ' 32px "' + family + '"'),
        document.fonts.load(bold + ' 32px "' + family + '"')
      ]);
    } catch (e24) {
    }
    try {
      document.dispatchEvent(new CustomEvent("nsv2:fontloaded", { detail: { family } }));
    } catch (e24) {
    }
  }

  // src/glyphs.js
  var OWN_SRC = document.currentScript && document.currentScript.src || "";
  var otPromise = null;
  function loadOpentype() {
    if (window.NinjaStudioOpentype) return Promise.resolve(window.NinjaStudioOpentype);
    if (otPromise) return otPromise;
    otPromise = new Promise((resolve, reject) => {
      const own = OWN_SRC || (document.querySelector('script[src*="studio-v2.js"]') || {}).src || "";
      if (!own) return reject(new Error("studio script tag not found"));
      const sc2 = document.createElement("script");
      sc2.src = own.replace(/studio-v2\.js/, "studio-v2-opentype.js");
      sc2.async = true;
      sc2.onload = () => window.NinjaStudioOpentype ? resolve(window.NinjaStudioOpentype) : reject(new Error("opentype chunk loaded empty"));
      sc2.onerror = () => reject(new Error("opentype chunk failed"));
      document.head.appendChild(sc2);
    }).catch((e24) => {
      otPromise = null;
      throw e24;
    });
    return otPromise;
  }
  function prewarmGlyphEngine() {
    loadOpentype().catch(() => {
    });
  }
  var fontCache = /* @__PURE__ */ new Map();
  var inflight = /* @__PURE__ */ new Map();
  var fontsourceId = (family) => family.trim().toLowerCase().replace(/\s+/g, "-");
  function woffUrl(family, weight, italic) {
    return "https://cdn.jsdelivr.net/fontsource/fonts/" + fontsourceId(family) + "@latest/latin-" + weight + "-" + (italic ? "italic" : "normal") + ".woff";
  }
  async function fetchFont(family, weight, italic) {
    const [ot2, resp] = await Promise.all([
      loadOpentype(),
      fetch(woffUrl(family, weight, italic), { mode: "cors" })
    ]);
    if (!resp.ok) throw new Error("font HTTP " + resp.status);
    return ot2.parse(await resp.arrayBuffer());
  }
  function fontKey(family, weight, italic) {
    return family + "|" + (weight || 400) + "|" + (italic ? "i" : "n");
  }
  function getFontSync(family, weight, italic) {
    return fontCache.get(fontKey(family, weight, italic)) || null;
  }
  function ensureFontBinary(family, weight, italic) {
    const key = fontKey(family, weight, italic);
    if (fontCache.has(key)) return Promise.resolve(fontCache.get(key));
    if (inflight.has(key)) return inflight.get(key);
    const p2 = (async () => {
      try {
        const font = await fetchFont(family, weight, italic);
        const entry = { font, synthetic: false };
        fontCache.set(key, entry);
        return entry;
      } catch (e24) {
        if (italic) {
          try {
            const upEntry = await ensureFontBinary(family, weight, false);
            const entry = upEntry ? { font: upEntry.font, synthetic: true } : null;
            fontCache.set(key, entry);
            return entry;
          } catch (_2) {
          }
        }
        console.warn("studio-v2: font binary unavailable, canvas fallback stays", family, weight, e24);
        fontCache.set(key, null);
        return null;
      } finally {
        inflight.delete(key);
      }
    })();
    inflight.set(key, p2);
    return p2;
  }
  function layoutLine(entry, text, fontSize, charSpacingPx) {
    const { font, synthetic } = entry;
    const scale = fontSize / font.unitsPerEm;
    const skew = synthetic ? Math.tan(12 * Math.PI / 180) : 0;
    const chars = [...text];
    const glyphs = [];
    let pen = 0;
    let prev = null;
    chars.forEach((ch, i2) => {
      const glyph = font.charToGlyph(ch);
      if (prev) pen += font.getKerningValue(prev, glyph) * scale;
      const adv = glyph.advanceWidth * scale + (i2 < chars.length - 1 ? charSpacingPx : 0);
      const path = glyph.getPath(pen, 0, fontSize);
      const commands = skew ? path.commands.map((c2) => {
        const o2 = { ...c2 };
        if (o2.x != null) o2.x -= o2.y * skew;
        if (o2.x1 != null) o2.x1 -= o2.y1 * skew;
        if (o2.x2 != null) o2.x2 -= o2.y2 * skew;
        return o2;
      }) : path.commands;
      glyphs.push({ ch, adv, pen, commands });
      pen += adv;
      prev = glyph;
    });
    const ascent = font.ascender / font.unitsPerEm * fontSize;
    const descent = Math.abs(font.descender / font.unitsPerEm) * fontSize;
    return { glyphs, width: pen, ascent, descent };
  }

  // src/recolor.js
  var MAX_SWATCHES = 10;
  var MIN_COVERAGE = 1.5;
  var MERGE_DE = 5;
  var BIAS_LIMIT = 50;
  function hexToRgb(h2) {
    const n2 = parseInt(h2.replace("#", ""), 16);
    return [n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255];
  }
  function rgbToHex(r2, g2, b2) {
    return "#" + (1 << 24 | r2 << 16 | g2 << 8 | b2).toString(16).slice(1).toUpperCase();
  }
  function rgbToLab(r2, g2, b2) {
    let sr2 = r2 / 255, sg = g2 / 255, sb = b2 / 255;
    sr2 = sr2 > 0.04045 ? Math.pow((sr2 + 0.055) / 1.055, 2.4) : sr2 / 12.92;
    sg = sg > 0.04045 ? Math.pow((sg + 0.055) / 1.055, 2.4) : sg / 12.92;
    sb = sb > 0.04045 ? Math.pow((sb + 0.055) / 1.055, 2.4) : sb / 12.92;
    let x2 = (sr2 * 0.4124564 + sg * 0.3575761 + sb * 0.1804375) / 0.95047;
    let y2 = sr2 * 0.2126729 + sg * 0.7151522 + sb * 0.072175;
    let z2 = (sr2 * 0.0193339 + sg * 0.119192 + sb * 0.9503041) / 1.08883;
    x2 = x2 > 8856e-6 ? Math.cbrt(x2) : 7.787 * x2 + 16 / 116;
    y2 = y2 > 8856e-6 ? Math.cbrt(y2) : 7.787 * y2 + 16 / 116;
    z2 = z2 > 8856e-6 ? Math.cbrt(z2) : 7.787 * z2 + 16 / 116;
    return [116 * y2 - 16, 500 * (x2 - y2), 200 * (y2 - z2)];
  }
  function labToRgb(L2, a2, bb) {
    let y2 = (L2 + 16) / 116, x2 = a2 / 500 + y2, z2 = y2 - bb / 200;
    const x3 = x2 * x2 * x2, y3 = y2 * y2 * y2, z3 = z2 * z2 * z2;
    x2 = 0.95047 * (x3 > 8856e-6 ? x3 : (x2 - 16 / 116) / 7.787);
    y2 = y3 > 8856e-6 ? y3 : (y2 - 16 / 116) / 7.787;
    z2 = 1.08883 * (z3 > 8856e-6 ? z3 : (z2 - 16 / 116) / 7.787);
    const r2 = x2 * 3.2404542 + y2 * -1.5371385 + z2 * -0.4985314;
    const g2 = x2 * -0.966926 + y2 * 1.8760108 + z2 * 0.041556;
    const b2 = x2 * 0.0556434 + y2 * -0.2040259 + z2 * 1.0572252;
    const gam = (c2) => {
      c2 = c2 > 31308e-7 ? 1.055 * Math.pow(c2, 1 / 2.4) - 0.055 : 12.92 * c2;
      return Math.max(0, Math.min(255, Math.round(c2 * 255)));
    };
    return [gam(r2), gam(g2), gam(b2)];
  }
  function deltaE(l1, l2) {
    const dL = l1[0] - l2[0], da2 = l1[1] - l2[1], db = l1[2] - l2[2];
    return Math.sqrt(dL * dL + da2 * da2 + db * db);
  }
  var smoothstep = (t2) => {
    t2 = Math.max(0, Math.min(1, t2));
    return t2 * t2 * (3 - 2 * t2);
  };
  function labToRgbGamut(L2, a2, b2) {
    const inGamut = (l2, a22, b22) => {
      let y2 = (l2 + 16) / 116, x2 = a22 / 500 + y2, z2 = y2 - b22 / 200;
      const x3 = x2 * x2 * x2, y3 = y2 * y2 * y2, z3 = z2 * z2 * z2;
      x2 = 0.95047 * (x3 > 8856e-6 ? x3 : (x2 - 16 / 116) / 7.787);
      y2 = y3 > 8856e-6 ? y3 : (y2 - 16 / 116) / 7.787;
      z2 = 1.08883 * (z3 > 8856e-6 ? z3 : (z2 - 16 / 116) / 7.787);
      const r2 = x2 * 3.2404542 + y2 * -1.5371385 + z2 * -0.4985314;
      const g2 = x2 * -0.966926 + y2 * 1.8760108 + z2 * 0.041556;
      const b3 = x2 * 0.0556434 + y2 * -0.2040259 + z2 * 1.0572252;
      return r2 >= -1e-3 && r2 <= 1.001 && g2 >= -1e-3 && g2 <= 1.001 && b3 >= -1e-3 && b3 <= 1.001;
    };
    if (inGamut(L2, a2, b2)) return labToRgb(L2, a2, b2);
    let lo2 = 0, hi2 = 1;
    for (let i2 = 0; i2 < 7; i2++) {
      const mid = (lo2 + hi2) / 2;
      if (inGamut(L2, a2 * mid, b2 * mid)) lo2 = mid;
      else hi2 = mid;
    }
    return labToRgb(L2, a2 * lo2, b2 * lo2);
  }
  function rgbToOklab(r2, g2, b2) {
    let sr2 = r2 / 255, sg = g2 / 255, sb = b2 / 255;
    sr2 = sr2 > 0.04045 ? Math.pow((sr2 + 0.055) / 1.055, 2.4) : sr2 / 12.92;
    sg = sg > 0.04045 ? Math.pow((sg + 0.055) / 1.055, 2.4) : sg / 12.92;
    sb = sb > 0.04045 ? Math.pow((sb + 0.055) / 1.055, 2.4) : sb / 12.92;
    const l2 = Math.cbrt(0.4122214708 * sr2 + 0.5363325363 * sg + 0.0514459929 * sb);
    const m = Math.cbrt(0.2119034982 * sr2 + 0.6806995451 * sg + 0.1073969566 * sb);
    const s22 = Math.cbrt(0.0883024619 * sr2 + 0.2817188376 * sg + 0.6299787005 * sb);
    return [
      0.2104542553 * l2 + 0.793617785 * m - 0.0040720468 * s22,
      1.9779984951 * l2 - 2.428592205 * m + 0.4505937099 * s22,
      0.0259040371 * l2 + 0.7827717662 * m - 0.808675766 * s22
    ];
  }
  function oklabToRgb(L2, a2, b2) {
    const l2 = (L2 + 0.3963377774 * a2 + 0.2158037573 * b2) ** 3;
    const m = (L2 - 0.1055613458 * a2 - 0.0638541728 * b2) ** 3;
    const s22 = (L2 - 0.0894841775 * a2 - 1.291485548 * b2) ** 3;
    let r2 = 4.0767416621 * l2 - 3.3077115913 * m + 0.2309699292 * s22;
    let g2 = -1.2684380046 * l2 + 2.6097574011 * m - 0.3413193965 * s22;
    let b22 = -0.0041960863 * l2 - 0.7034186147 * m + 1.707614701 * s22;
    const gam = (c2) => {
      c2 = Math.max(0, Math.min(1, c2));
      c2 = c2 > 31308e-7 ? 1.055 * Math.pow(c2, 1 / 2.4) - 0.055 : 12.92 * c2;
      return Math.max(0, Math.min(255, Math.round(c2 * 255)));
    };
    return [gam(r2), gam(g2), gam(b22)];
  }
  function computeAnchorStats(data, palLab, palRgb, opts = {}) {
    const k2 = palLab.length;
    const HB = 160;
    const hist = Array.from({ length: k2 }, () => new Uint32Array(HB));
    const counts = new Uint32Array(k2);
    const wantMix = !!(opts.mixStats && palRgb);
    const histX = wantMix ? Array.from({ length: k2 }, () => new Uint32Array(HB)) : null;
    const countsX = wantMix ? new Uint32Array(k2) : null;
    const n2 = data.length;
    const stride = Math.max(1, Math.floor(n2 / 4 / 15e4)) * 4;
    const memo = /* @__PURE__ */ new Map();
    for (let p2 = 0; p2 < n2; p2 += stride) {
      if (data[p2 + 3] < 128) continue;
      const key = data[p2] << 16 | data[p2 + 1] << 8 | data[p2 + 2];
      let hit = memo.get(key);
      if (hit === void 0) {
        const lab = rgbToLab(data[p2], data[p2 + 1], data[p2 + 2]);
        let dmin = Infinity, imin = 0;
        for (let i3 = 0; i3 < k2; i3++) {
          const d2 = deltaE(lab, palLab[i3]);
          if (d2 < dmin) {
            dmin = d2;
            imin = i3;
          }
        }
        let isMix = 0;
        if (wantMix && dmin > 3) {
          const r2 = data[p2], g2 = data[p2 + 1], b3 = data[p2 + 2];
          const lim2 = 0.35 * dmin * 0.35 * dmin * 3;
          outer: for (let i3 = 0; i3 < k2 - 1; i3++) {
            const A2 = palRgb[i3];
            const ax = r2 - A2[0], ay = g2 - A2[1], az = b3 - A2[2];
            for (let j2 = i3 + 1; j2 < k2; j2++) {
              const B2 = palRgb[j2];
              const dx = B2[0] - A2[0], dy = B2[1] - A2[1], dz = B2[2] - A2[2];
              const gap2 = dx * dx + dy * dy + dz * dz;
              if (gap2 < 100) continue;
              const t2 = (ax * dx + ay * dy + az * dz) / gap2;
              if (t2 <= 0.15 || t2 >= 0.85) continue;
              const rx = ax - t2 * dx, ry = ay - t2 * dy, rz = az - t2 * dz;
              if (rx * rx + ry * ry + rz * rz < lim2) {
                isMix = 1;
                break outer;
              }
            }
          }
        }
        hit = isMix << 16 | imin << 8 | Math.min(HB - 1, Math.round(dmin * 2));
        memo.set(key, hit);
      }
      const i2 = hit >> 8 & 255, b2 = hit & 255;
      hist[i2][b2]++;
      counts[i2]++;
      if (wantMix && !(hit >> 16)) {
        histX[i2][b2]++;
        countsX[i2]++;
      }
    }
    const pct = (hh, c2, q2) => {
      let acc = 0;
      for (let b2 = 0; b2 < HB; b2++) {
        acc += hh[b2];
        if (acc >= q2 * c2) return b2 / 2;
      }
      return HB / 2;
    };
    return Array.from({ length: k2 }, (_2, i2) => {
      const c2 = counts[i2];
      if (!c2) return { n: 0, p50: 0, p90: 0 };
      const p50 = pct(hist[i2], c2, 0.5), p90 = pct(hist[i2], c2, 0.9);
      const st2 = { n: c2, p50, p90, p90raw: p90 };
      if (wantMix && countsX[i2] && p50 <= 3 && p90 > 3 * p50 + 2) {
        st2.p90 = pct(histX[i2], countsX[i2], 0.9);
      }
      return st2;
    });
  }
  var RECOLOR_V4 = true;
  function applyColorReplacements(data, replacements, palette, width, opts = {}) {
    if (RECOLOR_V4) opts = Object.assign({ noiseComp: true, familyPull: true, regionGuard: true, pairTiebreak: true, mixStats: true, rimInterloper: true }, opts);
    if (!replacements.length) return;
    const k2 = palette.length;
    if (!k2) return;
    const palRgb = palette.map((h2) => hexToRgb(h2));
    const palLab = palRgb.map((c2) => rgbToLab(c2[0], c2[1], c2[2]));
    const anchorStats = computeAnchorStats(data, palLab, palRgb, opts);
    const n0 = data.length;
    if (opts.debugStats) console.log("anchorStats", anchorStats.map((st2, i2) => `${palette[i2]} p50=${st2.p50.toFixed(1)} p90=${st2.p90.toFixed(1)} n=${st2.n}`).join("  "));
    const palRepl = palette.map((h2) => {
      const up = h2.toUpperCase();
      for (let i2 = 0; i2 < replacements.length; i2++) {
        if (replacements[i2].targetColor.toUpperCase() === up) return replacements[i2];
      }
      return null;
    });
    if (opts.familyPull) {
      for (let j2 = 0; j2 < k2; j2++) {
        if (palRepl[j2]) continue;
        const Lj = palLab[j2];
        const Cj = Math.hypot(Lj[1], Lj[2]);
        if (Cj < 8) continue;
        {
          const st2 = anchorStats[j2];
          let ng = Infinity;
          for (let q2 = 0; q2 < k2; q2++) if (q2 !== j2) {
            const d2 = deltaE(palLab[j2], palLab[q2]);
            if (d2 < ng) ng = d2;
          }
          if (!st2.n || !(st2.p90 > 0.35 * ng)) continue;
        }
        const hj = Math.atan2(Lj[2], Lj[1]);
        let best = -1, bestAng = Infinity;
        for (let i2 = 0; i2 < k2; i2++) {
          const rp = palRepl[i2];
          if (!rp || rp.mode !== "recolor" || rp.__synthetic) continue;
          const Li2 = palLab[i2];
          const Ci2 = Math.hypot(Li2[1], Li2[2]);
          if (Ci2 < 8) continue;
          if (Lj[0] > Li2[0] + 8) continue;
          let ang = Math.abs(hj - Math.atan2(Li2[2], Li2[1]));
          if (ang > Math.PI) ang = 2 * Math.PI - ang;
          if (ang < bestAng) {
            bestAng = ang;
            best = i2;
          }
        }
        if (best < 0 || bestAng > 0.44) continue;
        const src2 = hexToRgb(palRepl[best].targetColor);
        const nc2 = hexToRgb(palRepl[best].newColor);
        let rgbOut;
        if (opts.oklchTransport) {
          const oj = rgbToOklab(...palRgb[j2]);
          const os2 = rgbToOklab(...src2);
          const on2 = rgbToOklab(...nc2);
          const hj2 = Math.atan2(oj[2], oj[1]);
          const cj2 = Math.hypot(oj[1], oj[2]);
          const hs2 = Math.atan2(os2[2], os2[1]);
          const hn2 = Math.atan2(on2[2], on2[1]);
          const cs2 = Math.max(5e-3, Math.hypot(os2[1], os2[2]));
          const cn2 = Math.hypot(on2[1], on2[2]);
          const hOut = hj2 + (hn2 - hs2);
          const cOut = cj2 * Math.min(1.6, cn2 / cs2);
          const lOut = oj[0] + (on2[0] - os2[0]) * Math.min(1, cj2 / cs2) * 0.5;
          rgbOut = oklabToRgb(lOut, cOut * Math.cos(hOut), cOut * Math.sin(hOut));
        } else {
          const Lj2 = palLab[j2];
          const srcLab = rgbToLab(src2[0], src2[1], src2[2]);
          const nl2 = rgbToLab(nc2[0], nc2[1], nc2[2]);
          const hSrc = Math.atan2(srcLab[2], srcLab[1]);
          const hNew = Math.atan2(nl2[2], nl2[1]);
          const cSrc = Math.max(0.5, Math.hypot(srcLab[1], srcLab[2]));
          const cNew = Math.hypot(nl2[1], nl2[2]);
          const hOut = hj + (hNew - hSrc);
          const cOut = Cj * Math.min(1.6, cNew / cSrc);
          const lOut = Lj2[0] + (nl2[0] - srcLab[0]) * Math.min(1, Cj / cSrc) * 0.5;
          rgbOut = labToRgbGamut(lOut, cOut * Math.cos(hOut), cOut * Math.sin(hOut));
        }
        palRepl[j2] = { targetColor: palette[j2], mode: "recolor", newColor: rgbToHex(rgbOut[0], rgbOut[1], rgbOut[2]), __synthetic: true };
      }
    }
    const sigma = palLab.map((L2, i2) => {
      let nearest = Infinity;
      for (let j2 = 0; j2 < k2; j2++) {
        if (j2 === i2) continue;
        const d2 = deltaE(L2, palLab[j2]);
        if (d2 < nearest) nearest = d2;
      }
      let s3 = nearest === Infinity ? 20 : 0.45 * nearest;
      s3 = Math.max(7, Math.min(85, s3));
      const repl = palRepl[i2];
      if (repl && repl.boundaryBias) {
        const bias = Math.max(-BIAS_LIMIT, Math.min(BIAS_LIMIT, repl.boundaryBias));
        s3 *= Math.pow(2, bias / BIAS_LIMIT);
      }
      return s3;
    });
    if (opts.sigmaFloor) {
      for (let i2 = 0; i2 < k2; i2++) {
        const st2 = anchorStats[i2];
        let ng = Infinity;
        for (let j2 = 0; j2 < k2; j2++) if (j2 !== i2) {
          const d2 = deltaE(palLab[i2], palLab[j2]);
          if (d2 < ng) ng = d2;
        }
        if (st2.n && ng < Infinity && st2.p90 > 0.5 * ng) sigma[i2] = Math.max(sigma[i2], 0.9 * ng);
      }
    }
    const inv2s2 = sigma.map((s3) => 1 / (2 * s3 * s3 * 0.5));
    const nearestGap = palLab.map((L2, i2) => {
      let ng = Infinity;
      for (let j2 = 0; j2 < k2; j2++) {
        if (j2 !== i2) {
          const d2 = deltaE(L2, palLab[j2]);
          if (d2 < ng) ng = d2;
        }
      }
      return ng === Infinity ? 60 : ng;
    });
    const gapGate = nearestGap.map((g2) => smoothstep((g2 - 10) / 25));
    const exactCore = nearestGap.map((g2, i2) => Math.min(6, 0.12 * g2) * gapGate[i2]);
    const rampEnd = nearestGap.map((g2, i2) => Math.min(16, 0.32 * g2) * gapGate[i2]);
    const noiseFloor = palLab.map((L2, i2) => {
      var _a2;
      if (!opts.noiseComp) return 0;
      const st2 = anchorStats[i2];
      if (!st2.n) return 0;
      const tight = smoothstep((nearestGap[i2] / Math.max(1, st2.p90) - 2) / 2);
      return Math.min(((_a2 = st2.p90raw) != null ? _a2 : st2.p90) + 2, 0.3 * nearestGap[i2]) * tight * gapGate[i2];
    });
    const newLab = palRepl.map(
      (r2) => r2 && r2.mode === "recolor" ? (() => {
        const c2 = hexToRgb(r2.newColor);
        return rgbToLab(c2[0], c2[1], c2[2]);
      })() : null
    );
    const outRgb = palRgb.map((c2, i2) => {
      const rp = palRepl[i2];
      if (rp && rp.mode === "recolor") return hexToRgb(rp.newColor);
      return c2;
    });
    const eraseShare = palRepl.map((rp) => rp && rp.mode === "transparent" ? 1 : 0);
    const chromaScale = palLab.map((tl, i2) => {
      const nl = newLab[i2];
      if (!nl) return 1;
      const cT = Math.sqrt(tl[1] * tl[1] + tl[2] * tl[2]);
      const cN = Math.sqrt(nl[1] * nl[1] + nl[2] * nl[2]);
      return Math.min(1, cN / Math.max(cT, 0.5));
    });
    const looseAnchor = palLab.map((L2, i2) => {
      const st2 = anchorStats[i2];
      return st2.n ? st2.p90 > 0.35 * nearestGap[i2] : false;
    });
    const looseMask = opts.speckleGuard || opts.regionGuard ? new Uint8Array(n0 / 4) : null;
    let looseCount = 0;
    const memo = /* @__PURE__ */ new Map();
    const w2 = new Float64Array(k2);
    const n2 = data.length;
    const src = new Uint8ClampedArray(data);
    const rowStride = width ? width * 4 : 0;
    const rowW = width || n2 / 4;
    const spatialGate = (p2) => {
      const p4 = p2 >> 2;
      const col = p4 % rowW;
      let m = 0;
      const look = (q2) => {
        if (src[q2 + 3] < 128) {
          m = 999;
          return;
        }
        const d2 = Math.abs(src[q2] - src[p2]) + Math.abs(src[q2 + 1] - src[p2 + 1]) + Math.abs(src[q2 + 2] - src[p2 + 2]);
        if (d2 > m) m = d2;
      };
      if (col > 0) look(p2 - 4);
      if (col < rowW - 1) look(p2 + 4);
      if (rowStride) {
        if (p2 >= rowStride) look(p2 - rowStride);
        if (p2 + rowStride < n2) look(p2 + rowStride);
      }
      return smoothstep((m - 24) / 48);
    };
    for (let p2 = 0; p2 < n2; p2 += 4) {
      const alpha = data[p2 + 3];
      if (alpha < 2) continue;
      const r2 = data[p2], g2 = data[p2 + 1], b2 = data[p2 + 2];
      const key = r2 << 16 | g2 << 8 | b2;
      let dec = memo.get(key);
      if (dec === void 0) {
        const lab = rgbToLab(r2, g2, b2);
        let sum = 0;
        let touched = 0;
        let dmin = Infinity;
        let imin = -1;
        for (let i2 = 0; i2 < k2; i2++) {
          const d2 = deltaE(lab, palLab[i2]);
          if (d2 < dmin) {
            dmin = d2;
            imin = i2;
          }
          const wi2 = Math.exp(-d2 * d2 * inv2s2[i2]);
          w2[i2] = wi2;
          sum += wi2;
          if (palRepl[i2]) touched += wi2;
        }
        let bary = null;
        {
          let ba2 = -1, bj = -1, bt2 = 0, brx = 0, bry = 0, brz = 0, bResid2 = Infinity, bGap2 = 0;
          let ra2 = -1, rj = -1, rt2 = 0, rrx = 0, rry = 0, rrz = 0, rResid2 = Infinity, rGap2 = 0;
          const wantTb = !!opts.pairTiebreak;
          for (let i2 = 0; i2 < k2 - 1; i2++) {
            const A2 = palRgb[i2];
            const ax = r2 - A2[0], ay = g2 - A2[1], az = b2 - A2[2];
            for (let j2 = i2 + 1; j2 < k2; j2++) {
              const B2 = palRgb[j2];
              const dx = B2[0] - A2[0], dy = B2[1] - A2[1], dz = B2[2] - A2[2];
              const gap2 = dx * dx + dy * dy + dz * dz;
              if (gap2 < 1e-6) continue;
              const t2 = (ax * dx + ay * dy + az * dz) / gap2;
              if (t2 <= 0 || t2 >= 1) continue;
              const rx = ax - t2 * dx, ry = ay - t2 * dy, rz = az - t2 * dz;
              const resid2 = rx * rx + ry * ry + rz * rz;
              if (resid2 < bResid2) {
                bResid2 = resid2;
                ba2 = i2;
                bj = j2;
                bt2 = t2;
                brx = rx;
                bry = ry;
                brz = rz;
                bGap2 = gap2;
              }
              if (wantTb && resid2 < rResid2 && (palRepl[i2] || palRepl[j2])) {
                rResid2 = resid2;
                ra2 = i2;
                rj = j2;
                rt2 = t2;
                rrx = rx;
                rry = ry;
                rrz = rz;
                rGap2 = gap2;
              }
            }
          }
          if (wantTb && ba2 > -1 && ra2 > -1 && !palRepl[ba2] && !palRepl[bj]) {
            const pairF2 = Math.min(noiseFloor[ra2], noiseFloor[rj]);
            const tol = pairF2 > 0.5 ? Math.max(4, pairF2) : 0;
            if (tol > 0 && Math.sqrt(rResid2) <= Math.sqrt(bResid2) + tol) {
              ba2 = ra2;
              bj = rj;
              bt2 = rt2;
              brx = rrx;
              bry = rry;
              brz = rrz;
              bResid2 = rResid2;
              bGap2 = rGap2;
            }
          }
          if (ba2 > -1) {
            const pairGap = deltaE(palLab[ba2], palLab[bj]);
            let beta = (1 - smoothstep(Math.sqrt(bResid2 / bGap2) / 0.35)) * smoothstep((pairGap - 12) / 20) * smoothstep(bt2 / 0.22) * smoothstep((1 - bt2) / 0.22);
            if (imin !== ba2 && imin !== bj && beta > 1e-3) {
              const C2 = palRgb[imin];
              const dm = Math.sqrt((r2 - C2[0]) ** 2 + (g2 - C2[1]) ** 2 + (b2 - C2[2]) ** 2);
              const A2 = palRgb[ba2], B2 = palRgb[bj];
              const dA = Math.sqrt((r2 - A2[0]) ** 2 + (g2 - A2[1]) ** 2 + (b2 - A2[2]) ** 2);
              const dB = Math.sqrt((r2 - B2[0]) ** 2 + (g2 - B2[1]) ** 2 + (b2 - B2[2]) ** 2);
              const rho = dm / Math.max(1, Math.min(dA, dB));
              let keep = false;
              if (opts.rimInterloper && !palRepl[imin]) {
                const stI = anchorStats[imin];
                const tightI = stI.n ? smoothstep((nearestGap[imin] / Math.max(1, stI.p90) - 2) / 2) : 0;
                if (tightI > 0.5 && dm > Math.max(6, 3 * (stI.p90 + 1))) keep = true;
              }
              if (!keep) beta *= smoothstep((rho - 0.35) / 0.35);
            }
            if (beta > 1e-3) {
              const RA = outRgb[ba2], RB = outRgb[bj];
              bary = {
                r: RA[0] + bt2 * (RB[0] - RA[0]) + brx,
                g: RA[1] + bt2 * (RB[1] - RA[1]) + bry,
                b: RA[2] + bt2 * (RB[2] - RA[2]) + brz,
                e: (1 - bt2) * eraseShare[ba2] + bt2 * eraseShare[bj],
                beta,
                a: ba2,
                j: bj
              };
            }
          }
        }
        if (imin > -1 && dmin < rampEnd[imin] && sum > 1e-9) {
          const core = exactCore[imin];
          const t2 = dmin <= core ? 0 : smoothstep((dmin - core) / Math.max(0.5, rampEnd[imin] - core));
          touched = 0;
          let s22 = 0;
          for (let i2 = 0; i2 < k2; i2++) {
            w2[i2] = t2 * (w2[i2] / sum) + (1 - t2) * (i2 === imin ? 1 : 0);
            s22 += w2[i2];
            if (palRepl[i2]) touched += w2[i2];
          }
          sum = s22;
        }
        if (globalThis.__RCDBG && globalThis.__RCDBG.has(key)) {
          console.log(
            "DBG",
            [r2, g2, b2].join(","),
            "imin",
            imin,
            "dmin",
            dmin.toFixed(1),
            "bary",
            bary ? { j: bary.j, beta: +bary.beta.toFixed(3), out: [bary.r, bary.g, bary.b].map((v2) => Math.round(v2)).join(",") } : null
          );
        }
        const baryTouched = bary && (palRepl[bary.a] || palRepl[bary.j]) ? bary.beta : 0;
        if ((sum < 1e-9 || touched / sum < 4e-3) && baryTouched < 4e-3) {
          dec = false;
        } else {
          let oL = lab[0], oa2 = lab[1], ob = lab[2], erase = 0;
          if (sum > 1e-9) {
            oL = 0;
            oa2 = 0;
            ob = 0;
          }
          for (let i2 = 0; sum > 1e-9 && i2 < k2; i2++) {
            const wi2 = w2[i2] / sum;
            if (wi2 < 2e-3) continue;
            const repl = palRepl[i2];
            if (!repl) {
              oL += wi2 * lab[0];
              oa2 += wi2 * lab[1];
              ob += wi2 * lab[2];
            } else if (repl.mode === "transparent") {
              erase += wi2;
              oL += wi2 * lab[0];
              oa2 += wi2 * lab[1];
              ob += wi2 * lab[2];
            } else if (repl.flatFill === true) {
              const nl = newLab[i2];
              oL += wi2 * nl[0];
              oa2 += wi2 * nl[1];
              ob += wi2 * nl[2];
            } else {
              const nl = newLab[i2];
              const tl = palLab[i2];
              const cs2 = chromaScale[i2];
              let da2 = (lab[1] - tl[1]) * cs2, db2 = (lab[2] - tl[2]) * cs2;
              const F2 = noiseFloor[i2];
              if (F2 > 0.5) {
                const m2 = Math.hypot(da2, db2);
                let m3 = m2 * smoothstep((m2 - 0.8 * F2) / (1.6 * F2));
                if (m3 > F2) m3 = F2 + 0.25 * (m3 - F2);
                const f2 = m2 > 1e-6 ? m3 / m2 : 0;
                da2 *= f2;
                db2 *= f2;
              }
              oL += wi2 * (nl[0] + (lab[0] - tl[0]));
              oa2 += wi2 * (nl[1] + da2);
              ob += wi2 * (nl[2] + db2);
            }
          }
          let eSnap = 0;
          if (opts.noiseComp && imin > -1 && erase > 0) {
            const rp2 = palRepl[imin];
            const F2 = noiseFloor[imin];
            if (rp2 && rp2.mode === "transparent" && F2 > 0.5) {
              const g3 = nearestGap[imin];
              eSnap = 1 - smoothstep((dmin - 0.22 * g3) / (0.16 * g3));
              if (eSnap > erase) erase = eSnap;
            }
          }
          const out = labToRgbGamut(oL, oa2, ob);
          dec = { r: out[0], g: out[1], b: out[2], e: erase, eSnap, bary, loose: imin > -1 && looseAnchor[imin] };
        }
        memo.set(key, dec);
        if (dec === false) continue;
      } else if (dec === false) {
        continue;
      }
      let or2 = dec.r, og = dec.g, ob2 = dec.b, oe2 = dec.e;
      if (dec.bary) {
        const bt2 = dec.bary.beta * spatialGate(p2);
        if (bt2 > 1e-3) {
          or2 = Math.max(0, Math.min(255, Math.round(or2 + bt2 * (dec.bary.r - or2))));
          og = Math.max(0, Math.min(255, Math.round(og + bt2 * (dec.bary.g - og))));
          ob2 = Math.max(0, Math.min(255, Math.round(ob2 + bt2 * (dec.bary.b - ob2))));
          oe2 = oe2 + bt2 * (dec.bary.e - oe2);
          if (dec.eSnap > oe2) oe2 = dec.eSnap;
        }
      }
      data[p2] = or2;
      data[p2 + 1] = og;
      data[p2 + 2] = ob2;
      if (oe2 > 0) data[p2 + 3] = Math.round(alpha * (1 - oe2));
      if (looseMask && dec.loose) {
        looseMask[p2 >> 2] = 1;
        looseCount++;
      }
    }
    if (looseMask && looseCount > 0) {
      const rowW2 = width || n2 / 4;
      const rows = n2 / 4 / rowW2 | 0;
      const px = n2 / 4;
      const delta = new Float32Array(px);
      for (let i2 = 0, p2 = 0; i2 < px; i2++, p2 += 4) {
        delta[i2] = Math.abs(data[p2] - src[p2]) + Math.abs(data[p2 + 1] - src[p2 + 1]) + Math.abs(data[p2 + 2] - src[p2 + 2]);
      }
      for (let i2 = 0, p2 = 0; i2 < px; i2++, p2 += 4) {
        if (!looseMask[i2] || delta[i2] < 24) continue;
        const x2 = i2 % rowW2, y2 = i2 / rowW2 | 0;
        let sum2 = 0, cnt = 0;
        for (let dy = -2; dy <= 2; dy++) {
          const yy = y2 + dy;
          if (yy < 0 || yy >= rows) continue;
          for (let dx = -2; dx <= 2; dx++) {
            if (!dx && !dy) continue;
            const xx = x2 + dx;
            if (xx < 0 || xx >= rowW2) continue;
            sum2 += delta[yy * rowW2 + xx];
            cnt++;
          }
        }
        const bound = 2.5 * (sum2 / Math.max(1, cnt)) + 10;
        if (delta[i2] > bound) {
          const f2 = bound / delta[i2];
          data[p2] = Math.round(src[p2] + (data[p2] - src[p2]) * f2);
          data[p2 + 1] = Math.round(src[p2 + 1] + (data[p2 + 1] - src[p2 + 1]) * f2);
          data[p2 + 2] = Math.round(src[p2 + 2] + (data[p2 + 2] - src[p2 + 2]) * f2);
        }
      }
    }
    if (opts.regionGuard && looseMask && looseCount > 0) {
      const rowW2 = width || n2 / 4;
      const rows = n2 / 4 / rowW2 | 0;
      const px = n2 / 4;
      const chg = new Uint8Array(px);
      const delta2 = new Float32Array(px);
      for (let i2 = 0, p2 = 0; i2 < px; i2++, p2 += 4) {
        const d2 = Math.abs(data[p2] - src[p2]) + Math.abs(data[p2 + 1] - src[p2 + 1]) + Math.abs(data[p2 + 2] - src[p2 + 2]);
        delta2[i2] = d2;
        if (looseMask[i2] && d2 > 24) chg[i2] = 1;
      }
      const comp = new Int32Array(px).fill(-1);
      const sizes = [];
      const stack2 = [];
      for (let i2 = 0; i2 < px; i2++) {
        if (!chg[i2] || comp[i2] >= 0) continue;
        const id2 = sizes.length;
        let size2 = 0;
        stack2.push(i2);
        comp[i2] = id2;
        while (stack2.length) {
          const q2 = stack2.pop();
          size2++;
          const x2 = q2 % rowW2, y2 = q2 / rowW2 | 0;
          for (let dy = -1; dy <= 1; dy++) {
            const yy = y2 + dy;
            if (yy < 0 || yy >= rows) continue;
            for (let dx = -1; dx <= 1; dx++) {
              if (!dx && !dy) continue;
              const xx = x2 + dx;
              if (xx < 0 || xx >= rowW2) continue;
              const q22 = yy * rowW2 + xx;
              if (chg[q22] && comp[q22] < 0) {
                comp[q22] = id2;
                stack2.push(q22);
              }
            }
          }
        }
        sizes.push(size2);
      }
      let M3 = 0;
      for (const s22 of sizes) if (s22 > M3) M3 = s22;
      if (M3 > 400) {
        const thresh = 0.01 * M3;
        const factor = sizes.map((s22) => smoothstep(s22 / thresh));
        for (let i2 = 0, p2 = 0; i2 < px; i2++, p2 += 4) {
          if (!chg[i2]) continue;
          const f2 = factor[comp[i2]];
          if (f2 >= 0.999) continue;
          data[p2] = Math.round(src[p2] + (data[p2] - src[p2]) * f2);
          data[p2 + 1] = Math.round(src[p2 + 1] + (data[p2 + 1] - src[p2 + 1]) * f2);
          data[p2 + 2] = Math.round(src[p2 + 2] + (data[p2 + 2] - src[p2 + 2]) * f2);
        }
      }
    }
  }
  function extractSwatches(imageData) {
    const data = imageData.data;
    const px = [];
    const stride = Math.max(1, Math.floor(data.length / 4 / 22e4)) * 4;
    for (let p2 = 0; p2 < data.length; p2 += stride) {
      if (data[p2 + 3] < 128) continue;
      px.push([data[p2], data[p2 + 1], data[p2 + 2]]);
    }
    if (!px.length) return [];
    {
      const buckets = /* @__PURE__ */ new Map();
      for (let i2 = 0; i2 < px.length; i2++) {
        const [r2, g2, b2] = px[i2];
        const bk = r2 >> 4 << 8 | g2 >> 4 << 4 | b2 >> 4;
        let bkt = buckets.get(bk);
        if (!bkt) buckets.set(bk, bkt = { count: 0, modes: /* @__PURE__ */ new Map() });
        bkt.count++;
        const ek = r2 << 16 | g2 << 8 | b2;
        bkt.modes.set(ek, (bkt.modes.get(ek) || 0) + 1);
      }
      const sorted = [...buckets.values()].sort((a2, b2) => b2.count - a2.count);
      const significant = sorted.filter((b2) => b2.count / px.length >= 0.01);
      const covered = significant.reduce((s3, b2) => s3 + b2.count, 0) / px.length;
      if (significant.length <= 24 && covered >= 0.92) {
        const candidates = RECOLOR_V4 ? sorted.filter((b2) => b2.count / px.length >= 5e-4) : significant;
        const clusters2 = candidates.map((b2) => {
          let bestK = 0, bestN = -1;
          b2.modes.forEach((nn2, k2) => {
            if (nn2 > bestN) {
              bestN = nn2;
              bestK = k2;
            }
          });
          return {
            rgb: [bestK >> 16 & 255, bestK >> 8 & 255, bestK & 255],
            count: b2.count
          };
        });
        return mergeAndRank(clusters2, px.length, 0.5);
      }
    }
    const boxes = [px];
    const spread = (box) => {
      const mins = [255, 255, 255], maxs = [0, 0, 0];
      for (let i2 = 0; i2 < box.length; i2++)
        for (let c2 = 0; c2 < 3; c2++) {
          if (box[i2][c2] < mins[c2]) mins[c2] = box[i2][c2];
          if (box[i2][c2] > maxs[c2]) maxs[c2] = box[i2][c2];
        }
      return maxs[0] - mins[0] + (maxs[1] - mins[1]) + (maxs[2] - mins[2]);
    };
    const widestChannel = (box) => {
      const mins = [255, 255, 255], maxs = [0, 0, 0];
      for (let i2 = 0; i2 < box.length; i2++)
        for (let c2 = 0; c2 < 3; c2++) {
          if (box[i2][c2] < mins[c2]) mins[c2] = box[i2][c2];
          if (box[i2][c2] > maxs[c2]) maxs[c2] = box[i2][c2];
        }
      const dr2 = maxs[0] - mins[0], dg = maxs[1] - mins[1], db = maxs[2] - mins[2];
      return dg >= dr2 && dg >= db ? 1 : dr2 >= db ? 0 : 2;
    };
    while (boxes.length < 32) {
      boxes.sort((a2, b2) => spread(b2) - spread(a2));
      const box = boxes.shift();
      if (!box || box.length < 16 || spread(box) < 10) {
        if (box) boxes.push(box);
        break;
      }
      const ch = widestChannel(box);
      box.sort((a2, b2) => a2[ch] - b2[ch]);
      const mid = box.length >> 1;
      boxes.push(box.slice(0, mid), box.slice(mid));
    }
    const clusters = boxes.filter((b2) => b2.length).map((box) => {
      const counts = /* @__PURE__ */ new Map();
      for (let i2 = 0; i2 < box.length; i2++) {
        const k2 = box[i2][0] << 16 | box[i2][1] << 8 | box[i2][2];
        counts.set(k2, (counts.get(k2) || 0) + 1);
      }
      let bestK = 0, bestN = -1;
      counts.forEach((nn2, k2) => {
        if (nn2 > bestN) {
          bestN = nn2;
          bestK = k2;
        }
      });
      return { rgb: [bestK >> 16 & 255, bestK >> 8 & 255, bestK & 255], count: box.length };
    });
    return mergeAndRank(clusters, px.length, MIN_COVERAGE);
  }
  function mergeAndRank(clusters, total, minCoverage) {
    clusters.forEach((c2) => c2.lab = rgbToLab(c2.rgb[0], c2.rgb[1], c2.rgb[2]));
    clusters.sort((a2, b2) => b2.count - a2.count);
    const merged = [];
    clusters.forEach((c2) => {
      for (let i2 = 0; i2 < merged.length; i2++) {
        if (deltaE(c2.lab, merged[i2].lab) < MERGE_DE) {
          merged[i2].count += c2.count;
          return;
        }
      }
      merged.push(c2);
    });
    merged.sort((a2, b2) => b2.count - a2.count);
    for (let i2 = merged.length - 1; i2 > 0; i2--) {
      const c2 = merged[i2];
      if (c2.count / total >= 0.025) continue;
      for (let j2 = 0; j2 < i2; j2++) {
        const big = merged[j2];
        if (big.count >= 4 * c2.count && deltaE(c2.lab, big.lab) < 18) {
          big.count += c2.count;
          merged.splice(i2, 1);
          break;
        }
      }
    }
    for (let i2 = merged.length - 1; i2 >= 0; i2--) {
      const c2 = merged[i2];
      let dropped = false;
      for (let x2 = 0; x2 < merged.length && !dropped; x2++) {
        if (x2 === i2) continue;
        const A2 = merged[x2];
        if (c2.count > 0.35 * A2.count) continue;
        for (let y2 = x2 + 1; y2 < merged.length; y2++) {
          if (y2 === i2) continue;
          const B2 = merged[y2];
          if (c2.count > 0.35 * B2.count) continue;
          const dx = B2.rgb[0] - A2.rgb[0], dy = B2.rgb[1] - A2.rgb[1], dz = B2.rgb[2] - A2.rgb[2];
          const gap2 = dx * dx + dy * dy + dz * dz;
          if (gap2 < 900) continue;
          const px2 = c2.rgb[0] - A2.rgb[0], py = c2.rgb[1] - A2.rgb[1], pz = c2.rgb[2] - A2.rgb[2];
          const t2 = (px2 * dx + py * dy + pz * dz) / gap2;
          if (t2 < 0.12 || t2 > 0.88) continue;
          const rx = px2 - t2 * dx, ry = py - t2 * dy, rz = pz - t2 * dz;
          const resid2 = rx * rx + ry * ry + rz * rz;
          if (resid2 / gap2 > 0.0225 || resid2 > 196) continue;
          A2.count += Math.round(c2.count * (1 - t2));
          B2.count += Math.round(c2.count * t2);
          merged.splice(i2, 1);
          dropped = true;
          break;
        }
      }
    }
    let out = merged.map((c2) => ({
      hex: rgbToHex(c2.rgb[0], c2.rgb[1], c2.rgb[2]),
      coveragePercent: Math.round(c2.count / total * 1e3) / 10
    })).sort((a2, b2) => b2.coveragePercent - a2.coveragePercent);
    out = out.filter((s3, i2) => i2 === 0 || s3.coveragePercent >= minCoverage);
    return out.slice(0, MAX_SWATCHES);
  }
  function detectImageColors(el2) {
    const w2 = el2.naturalWidth || el2.width, h2 = el2.naturalHeight || el2.height;
    const scale = Math.min(1, 420 / Math.max(w2, h2));
    const c2 = document.createElement("canvas");
    c2.width = Math.max(1, Math.round(w2 * scale));
    c2.height = Math.max(1, Math.round(h2 * scale));
    const ctx = c2.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(el2, 0, 0, c2.width, c2.height);
    return extractSwatches(ctx.getImageData(0, 0, c2.width, c2.height));
  }
  function recolorElement(el2, replacements, palette) {
    const w2 = el2.naturalWidth || el2.width, h2 = el2.naturalHeight || el2.height;
    const c2 = document.createElement("canvas");
    c2.width = w2;
    c2.height = h2;
    const ctx = c2.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(el2, 0, 0);
    const id = ctx.getImageData(0, 0, w2, h2);
    applyColorReplacements(id.data, replacements, palette, id.width);
    ctx.putImageData(id, 0, 0);
    return c2;
  }

  // src/filters.js
  var R2 = (key, label, css, overlays, extra) => Object.assign({ key, label, params: Object.assign({ css: css || "", overlays: overlays || [] }, extra || {}) });
  var FILTERS = [
    { key: "original", label: "Original", params: null },
    // ── Instagram-style looks (CSSgram ports) ──
    R2("clarendon", "Clarendon", "contrast(1.2) saturate(1.35)", [["rgba(127,187,227,.2)", "overlay", 1]]),
    R2("juno", "Juno", "sepia(.35) contrast(1.15) brightness(1.15) saturate(1.8)", [["rgba(127,187,227,.2)", "overlay", 1]]),
    R2("lark", "Lark", "contrast(.9)", [["#22253f", "color-dodge", 1], ["rgba(242,242,242,.8)", "darken", 1]]),
    R2("gingham", "Gingham", "brightness(1.05) hue-rotate(-10deg)", [["rgb(230,230,250)", "soft-light", 1]]),
    R2("reyes", "Reyes", "sepia(.22) brightness(1.1) contrast(.85) saturate(.75)", [["#efcdad", "soft-light", 0.5]]),
    R2("moon", "Moon", "grayscale(1) contrast(1.1) brightness(1.1)", [["#a0a0a0", "soft-light", 1], ["#383838", "lighten", 1]]),
    R2("valencia", "Valencia", "contrast(1.08) brightness(1.08) sepia(.08)", [["rgba(58,3,57,.5)", "exclusion", 1]]),
    R2("nashville", "Nashville", "sepia(.2) contrast(1.2) brightness(1.05) saturate(1.2)", [["rgba(247,176,153,.56)", "darken", 1], ["rgba(0,70,150,.4)", "lighten", 1]]),
    R2("slumber", "Slumber", "saturate(.66) brightness(1.05)", [["rgba(69,41,12,.4)", "lighten", 1], ["rgba(125,105,24,.5)", "soft-light", 1]]),
    R2("crema", "Crema", "sepia(.5) contrast(1.25) brightness(1.15) saturate(.9) hue-rotate(-2deg)", [["rgba(125,105,24,.2)", "multiply", 1]]),
    R2("ludwig", "Ludwig", "sepia(.25) contrast(1.05) brightness(1.05) saturate(2)", [["rgba(125,105,24,.1)", "overlay", 1]]),
    R2("aden", "Aden", "hue-rotate(-20deg) contrast(.9) saturate(.85) brightness(1.2)", [["linear:rgba(66,10,14,.2)|rgba(66,10,14,0)", "darken", 1]]),
    R2("perpetua", "Perpetua", "", [["linearv:#005b9a|#e6c13d", "soft-light", 0.5]]),
    R2("mayfair", "Mayfair", "contrast(1.1) saturate(1.1)", [["radial:rgba(255,255,255,.8)|rgba(255,200,200,.6)|#111", "overlay", 0.4]]),
    R2("rise", "Rise", "brightness(1.05) sepia(.2) contrast(.9) saturate(.9)", [["radial:rgba(236,205,169,.15)|rgba(50,30,7,.4)", "multiply", 1], ["radial:rgba(232,180,130,.8)|rgba(232,180,130,0)", "overlay", 0.6]]),
    R2("hudson", "Hudson", "brightness(1.2) contrast(.9) saturate(1.1)", [["radial:#a6b1ff|#342134", "multiply", 0.5]]),
    R2("xpro2", "X-Pro II", "sepia(.3)", [["radial:#e6e7e0|rgba(43,42,161,.6)", "color-burn", 1]]),
    R2("sierra", "Sierra", "sepia(.25) contrast(1.5) brightness(.9) hue-rotate(-15deg)", [["radial:rgba(128,78,15,.5)|rgba(0,0,0,.65)", "screen", 1]]),
    R2("willow", "Willow", "grayscale(.5) contrast(.95) brightness(.9)", [["radial:#d4a9af|#000", "overlay", 1]]),
    R2("lofi", "Lo-Fi", "saturate(1.1) contrast(1.5)", [["radial:rgba(0,0,0,0)|#222", "multiply", 1]]),
    R2("inkwell", "Inkwell", "sepia(.3) contrast(1.1) brightness(1.1) grayscale(1)", []),
    R2("toaster", "Toaster", "contrast(1.5) brightness(.9)", [["radial:#804e0f|#3b003b", "screen", 1]]),
    R2("walden", "Walden", "brightness(1.1) hue-rotate(-10deg) sepia(.3) saturate(1.6)", [["#0044cc", "screen", 0.3]]),
    R2("y1977", "1977", "contrast(1.1) brightness(1.1) saturate(1.3)", [["rgba(243,106,188,.3)", "screen", 1]]),
    R2("kelvin", "Kelvin", "", [["#382c34", "color-dodge", 1], ["#b77d21", "overlay", 1]]),
    R2("brannan", "Brannan", "sepia(.5) contrast(1.4)", [["rgba(161,44,199,.31)", "lighten", 1]]),
    R2("earlybird", "Earlybird", "contrast(.9) sepia(.2)", [["radial:#d0ba8e|#360309|#1d0210", "overlay", 1]]),
    R2("stinson", "Stinson", "contrast(.75) saturate(.85) brightness(1.15)", [["rgba(240,149,128,.2)", "soft-light", 1]]),
    // ── Utilities (kept from the original set — same keys, so saved designs restore) ──
    R2("bw", "Black & White", "grayscale(1)", []),
    R2("sepia", "Sepia", "sepia(.8)", []),
    R2("fade", "Fade", "saturate(.65) contrast(.85) brightness(1.08)", []),
    R2("vivid", "Vivid", "saturate(1.4) contrast(1.12)", []),
    R2("cool", "Cool", "hue-rotate(15deg) saturate(1.1)", []),
    R2("warm", "Warm", "hue-rotate(-10deg) saturate(1.15) brightness(1.05)", []),
    R2("fuchsia", "Fuchsia", "", [], { mono: "C724B1" }),
    R2("duotone", "Duotone", "", [], { duo: ["003087", "00C5FF"], duoAlpha: 1 })
  ];
  function fromImgixParams(params) {
    if (!params) return null;
    const css = [];
    const r2 = { css: "", overlays: [] };
    for (const pair of String(params).split("&")) {
      const i2 = pair.indexOf("=");
      const k2 = pair.slice(0, i2);
      const v2 = pair.slice(i2 + 1);
      const n2 = Number(v2);
      if (k2 === "sat") css.push("saturate(" + Math.max(0, 1 + n2 / 100) + ")");
      else if (k2 === "con") css.push("contrast(" + Math.max(0, 1 + n2 / 100) + ")");
      else if (k2 === "bri" || k2 === "exp") css.push("brightness(" + Math.max(0, 1 + n2 / 100) + ")");
      else if (k2 === "sepia") css.push("sepia(" + Math.max(0, Math.min(1, n2 / 100)) + ")");
      else if (k2 === "hue") css.push("hue-rotate(" + n2 + "deg)");
      else if (k2 === "vib") css.push("saturate(" + Math.max(0, 1 + n2 / 150) + ")");
      else if (k2 === "monochrome") r2.mono = v2.length === 8 ? v2.slice(2) : v2;
      else if (k2 === "duotone") r2.duo = v2.split(",");
      else if (k2 === "duotone-alpha") r2.duoAlpha = Math.max(0, Math.min(1, n2 / 100));
    }
    r2.css = css.join(" ");
    return r2;
  }
  var I2 = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
  var mul = (a2, b2) => {
    const o2 = new Array(20).fill(0);
    for (let r2 = 0; r2 < 4; r2++) for (let c2 = 0; c2 < 5; c2++) {
      let s3 = 0;
      for (let k2 = 0; k2 < 4; k2++) s3 += a2[r2 * 5 + k2] * b2[k2 * 5 + c2];
      if (c2 === 4) s3 += a2[r2 * 5 + 4];
      o2[r2 * 5 + c2] = s3;
    }
    return o2;
  };
  var MAT = {
    saturate: (s3) => [0.213 + 0.787 * s3, 0.715 - 0.715 * s3, 0.072 - 0.072 * s3, 0, 0, 0.213 - 0.213 * s3, 0.715 + 0.285 * s3, 0.072 - 0.072 * s3, 0, 0, 0.213 - 0.213 * s3, 0.715 - 0.715 * s3, 0.072 + 0.928 * s3, 0, 0, 0, 0, 0, 1, 0],
    grayscale: (a2) => MAT.saturate(1 - a2),
    sepia: (a2) => {
      const t2 = 1 - a2;
      return [0.393 + 0.607 * t2, 0.769 - 0.769 * t2, 0.189 - 0.189 * t2, 0, 0, 0.349 - 0.349 * t2, 0.686 + 0.314 * t2, 0.168 - 0.168 * t2, 0, 0, 0.272 - 0.272 * t2, 0.534 - 0.534 * t2, 0.131 + 0.869 * t2, 0, 0, 0, 0, 0, 1, 0];
    },
    brightness: (b2) => [b2, 0, 0, 0, 0, 0, b2, 0, 0, 0, 0, 0, b2, 0, 0, 0, 0, 0, 1, 0],
    contrast: (c2) => {
      const o2 = (1 - c2) / 2;
      return [c2, 0, 0, 0, o2, 0, c2, 0, 0, o2, 0, 0, c2, 0, o2, 0, 0, 0, 1, 0];
    },
    hue: (deg) => {
      const a2 = deg * Math.PI / 180, c2 = Math.cos(a2), s3 = Math.sin(a2);
      return [0.213 + c2 * 0.787 - s3 * 0.213, 0.715 - c2 * 0.715 - s3 * 0.715, 0.072 - c2 * 0.072 + s3 * 0.928, 0, 0, 0.213 - c2 * 0.213 + s3 * 0.143, 0.715 + c2 * 0.285 + s3 * 0.14, 0.072 - c2 * 0.072 - s3 * 0.283, 0, 0, 0.213 - c2 * 0.213 - s3 * 0.787, 0.715 - c2 * 0.715 + s3 * 0.715, 0.072 + c2 * 0.928 + s3 * 0.072, 0, 0, 0, 0, 0, 1, 0];
    }
  };
  function chainMatrix(css, t2) {
    let m = I2, any = false;
    const re2 = /([a-z-]+)\(([^)]+)\)/g;
    let x2;
    while (x2 = re2.exec(css || "")) {
      const f2 = x2[1], v2 = parseFloat(x2[2]);
      let mm = null;
      if (f2 === "saturate") mm = MAT.saturate(1 + (v2 - 1) * t2);
      else if (f2 === "grayscale") mm = MAT.grayscale(v2 * t2);
      else if (f2 === "sepia") mm = MAT.sepia(v2 * t2);
      else if (f2 === "brightness") mm = MAT.brightness(1 + (v2 - 1) * t2);
      else if (f2 === "contrast") mm = MAT.contrast(1 + (v2 - 1) * t2);
      else if (f2 === "hue-rotate") mm = MAT.hue(v2 * t2);
      if (mm) {
        m = mul(mm, m);
        any = true;
      }
    }
    return any ? m : null;
  }
  function applyMatrix(d2, m) {
    const m0 = m[0], m1 = m[1], m2 = m[2], m4 = m[4] * 255, m5 = m[5], m6 = m[6], m7 = m[7], m9 = m[9] * 255, m10 = m[10], m11 = m[11], m12 = m[12], m14 = m[14] * 255;
    for (let i2 = 0; i2 < d2.length; i2 += 4) {
      if (!d2[i2 + 3]) continue;
      const r2 = d2[i2], g2 = d2[i2 + 1], b2 = d2[i2 + 2];
      d2[i2] = m0 * r2 + m1 * g2 + m2 * b2 + m4;
      d2[i2 + 1] = m5 * r2 + m6 * g2 + m7 * b2 + m9;
      d2[i2 + 2] = m10 * r2 + m11 * g2 + m12 * b2 + m14;
    }
  }
  var hex = (s3) => [parseInt(s3.slice(0, 2), 16), parseInt(s3.slice(2, 4), 16), parseInt(s3.slice(4, 6), 16)];
  function lumMap(d2, A2, B2, t2) {
    for (let i2 = 0; i2 < d2.length; i2 += 4) {
      if (!d2[i2 + 3]) continue;
      const lum = (d2[i2] * 0.299 + d2[i2 + 1] * 0.587 + d2[i2 + 2] * 0.114) / 255;
      d2[i2] += t2 * (A2[0] + lum * (B2[0] - A2[0]) - d2[i2]);
      d2[i2 + 1] += t2 * (A2[1] + lum * (B2[1] - A2[1]) - d2[i2 + 1]);
      d2[i2 + 2] += t2 * (A2[2] + lum * (B2[2] - A2[2]) - d2[i2 + 2]);
    }
  }
  function fillFor(ctx, w2, h2, spec) {
    const stops = (list, g2) => {
      const st2 = list.split("|");
      st2.forEach((c2, i2) => g2.addColorStop(st2.length === 1 ? 0 : i2 / (st2.length - 1), c2));
      return g2;
    };
    if (spec.startsWith("radial:")) return stops(spec.slice(7), ctx.createRadialGradient(w2 / 2, h2 / 2, 0, w2 / 2, h2 / 2, Math.hypot(w2, h2) / 2));
    if (spec.startsWith("linearv:")) return stops(spec.slice(8), ctx.createLinearGradient(0, 0, 0, h2));
    if (spec.startsWith("linear:")) return stops(spec.slice(7), ctx.createLinearGradient(0, 0, w2, 0));
    return spec;
  }
  function applyPresetToCanvas(el2, recipe, strength) {
    const r2 = typeof recipe === "string" ? fromImgixParams(recipe) : recipe;
    if (!r2) return el2;
    const t2 = Math.max(0, Math.min(100, strength == null ? 100 : strength)) / 100;
    if (t2 === 0) return el2;
    const w2 = el2.naturalWidth || el2.width;
    const h2 = el2.naturalHeight || el2.height;
    const out = document.createElement("canvas");
    out.width = w2;
    out.height = h2;
    const ctx = out.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(el2, 0, 0);
    const m = chainMatrix(r2.css, t2);
    const needPixels = m || r2.duo || r2.mono;
    if (needPixels) {
      const id = ctx.getImageData(0, 0, w2, h2);
      if (m) applyMatrix(id.data, m);
      if (r2.duo) lumMap(id.data, hex(r2.duo[0]), hex(r2.duo[1]), t2 * (r2.duoAlpha == null ? 1 : r2.duoAlpha));
      else if (r2.mono) lumMap(id.data, [0, 0, 0], hex(r2.mono), t2);
      ctx.putImageData(id, 0, 0);
    }
    const overlays = r2.overlays || [];
    for (const [spec, blend, opacity] of overlays) {
      ctx.save();
      ctx.globalCompositeOperation = blend || "source-over";
      ctx.globalAlpha = (opacity == null ? 1 : opacity) * t2;
      ctx.fillStyle = fillFor(ctx, w2, h2, spec);
      ctx.fillRect(0, 0, w2, h2);
      ctx.restore();
    }
    if (overlays.length) {
      ctx.save();
      ctx.globalCompositeOperation = "destination-in";
      ctx.drawImage(el2, 0, 0);
      ctx.restore();
    }
    return out;
  }

  // src/elements.js
  var fmt = (n2) => {
    const r2 = Math.round(n2 * 100) / 100;
    return Object.is(r2, -0) ? 0 : r2;
  };
  function regularPolygon(n2, rotDeg, w2, h2) {
    const raw = [];
    for (let i2 = 0; i2 < n2; i2++) {
      const a2 = (rotDeg + 360 / n2 * i2) * Math.PI / 180;
      raw.push({ x: Math.cos(a2), y: Math.sin(a2) });
    }
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const p2 of raw) {
      minX = Math.min(minX, p2.x);
      maxX = Math.max(maxX, p2.x);
      minY = Math.min(minY, p2.y);
      maxY = Math.max(maxY, p2.y);
    }
    const sx = w2 / (maxX - minX), sy = h2 / (maxY - minY);
    return raw.map((p2) => ({ x: (p2.x - minX) * sx, y: (p2.y - minY) * sy }));
  }
  function starPoints(spikes, inner, w2, h2) {
    const raw = [];
    for (let i2 = 0; i2 < spikes * 2; i2++) {
      const r2 = i2 % 2 === 0 ? 1 : inner;
      const a2 = Math.PI / spikes * i2 - Math.PI / 2;
      raw.push({ x: r2 * Math.cos(a2), y: r2 * Math.sin(a2) });
    }
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const p2 of raw) {
      minX = Math.min(minX, p2.x);
      maxX = Math.max(maxX, p2.x);
      minY = Math.min(minY, p2.y);
      maxY = Math.max(maxY, p2.y);
    }
    const sx = w2 / (maxX - minX), sy = h2 / (maxY - minY);
    return raw.map((p2) => ({ x: (p2.x - minX) * sx, y: (p2.y - minY) * sy }));
  }
  function roundedPolygonPath(pts, round) {
    const n2 = pts.length;
    if (!round || round <= 0) {
      let d3 = "";
      for (let i2 = 0; i2 < n2; i2++) d3 += (i2 ? "L" : "M") + fmt(pts[i2].x) + " " + fmt(pts[i2].y);
      return d3 + "Z";
    }
    const seg = [];
    for (let i2 = 0; i2 < n2; i2++) {
      const prev = pts[(i2 - 1 + n2) % n2], cur = pts[i2], next = pts[(i2 + 1) % n2];
      let ax = prev.x - cur.x, ay = prev.y - cur.y;
      let bx = next.x - cur.x, by = next.y - cur.y;
      const lenA = Math.hypot(ax, ay) || 1, lenB = Math.hypot(bx, by) || 1;
      ax /= lenA;
      ay /= lenA;
      bx /= lenB;
      by /= lenB;
      const trim = round / 100 * (Math.min(lenA, lenB) / 2);
      const cos = Math.max(-1, Math.min(1, ax * bx + ay * by));
      const theta = Math.acos(cos);
      if (theta > Math.PI - 0.01 || trim < 0.01) {
        seg.push({ pA: cur, pB: cur, r: 0 });
        continue;
      }
      const r2 = trim * Math.tan(theta / 2);
      const cross = (cur.x - prev.x) * (next.y - cur.y) - (cur.y - prev.y) * (next.x - cur.x);
      seg.push({
        pA: { x: cur.x + ax * trim, y: cur.y + ay * trim },
        // approach point (on edge to prev)
        pB: { x: cur.x + bx * trim, y: cur.y + by * trim },
        // exit point (on edge to next)
        r: r2,
        sweep: cross > 0 ? 1 : 0
      });
    }
    let d2 = "M" + fmt(seg[0].pB.x) + " " + fmt(seg[0].pB.y);
    for (let i2 = 1; i2 <= n2; i2++) {
      const s3 = seg[i2 % n2];
      d2 += "L" + fmt(s3.pA.x) + " " + fmt(s3.pA.y);
      if (s3.r > 0) d2 += "A" + fmt(s3.r) + " " + fmt(s3.r) + " 0 0 " + s3.sweep + " " + fmt(s3.pB.x) + " " + fmt(s3.pB.y);
    }
    return d2 + "Z";
  }
  function ellipsePath(w2, h2) {
    const rx = w2 / 2, ry = h2 / 2;
    return "M0 " + fmt(ry) + "A" + fmt(rx) + " " + fmt(ry) + " 0 1 1 " + fmt(w2) + " " + fmt(ry) + "A" + fmt(rx) + " " + fmt(ry) + " 0 1 1 0 " + fmt(ry) + "Z";
  }
  var HEART_ABS = [
    12,
    19.7,
    // M
    6.6,
    15.5,
    3.5,
    12.2,
    3.5,
    8.9,
    3.5,
    6.4,
    5.4,
    4.5,
    7.8,
    4.5,
    9.5,
    4.5,
    11.1,
    5.5,
    12,
    7.1,
    12.9,
    5.5,
    14.5,
    4.5,
    16.2,
    4.5,
    18.6,
    4.5,
    20.5,
    6.4,
    20.5,
    8.9,
    20.5,
    12.2,
    17.4,
    15.5,
    12,
    19.7
  ];
  function heartPath(w2, h2) {
    const x0 = 3.5, y0 = 4.5, sx = w2 / 17, sy = h2 / 15.2;
    const P2 = (i2) => fmt((HEART_ABS[i2] - x0) * sx) + " " + fmt((HEART_ABS[i2 + 1] - y0) * sy);
    let d2 = "M" + P2(0);
    for (let i2 = 2; i2 < HEART_ABS.length; i2 += 6) d2 += "C" + P2(i2) + " " + P2(i2 + 2) + " " + P2(i2 + 4);
    return d2 + "Z";
  }
  var ELEMENTS = {
    square: {
      label: "Square",
      group: "shapes",
      caps: { fill: true, border: true, corners: true, stretch: true },
      build: (p2) => roundedPolygonPath([{ x: 0, y: 0 }, { x: p2.w, y: 0 }, { x: p2.w, y: p2.h }, { x: 0, y: p2.h }], p2.round)
    },
    rounded: {
      label: "Rounded",
      group: "shapes",
      caps: { fill: true, border: true, corners: true, stretch: true },
      defaults: { round: 36 },
      // ≈ the old rx = 0.18·S on a square
      build: (p2) => roundedPolygonPath([{ x: 0, y: 0 }, { x: p2.w, y: 0 }, { x: p2.w, y: p2.h }, { x: 0, y: p2.h }], p2.round)
    },
    circle: {
      label: "Circle",
      group: "shapes",
      caps: { fill: true, border: true, stretch: true },
      build: (p2) => ellipsePath(p2.w, p2.h)
    },
    triangle: {
      label: "Triangle",
      group: "shapes",
      caps: { fill: true, border: true, corners: true, stretch: true },
      build: (p2) => roundedPolygonPath([{ x: p2.w / 2, y: 0 }, { x: p2.w, y: p2.h }, { x: 0, y: p2.h }], p2.round)
    },
    star: {
      label: "Star",
      group: "shapes",
      caps: { fill: true, border: true, corners: true, stretch: true },
      aspect: 0.951,
      // natural 5-point star h/w (1.809/1.902) — matches the old Polygon
      build: (p2) => roundedPolygonPath(starPoints(5, 0.42, p2.w, p2.h), p2.round)
    },
    heart: {
      label: "Heart",
      group: "shapes",
      caps: { fill: true, border: true, stretch: true },
      aspect: 0.894,
      // the 24-box glyph's natural h/w (15.2/17)
      build: (p2) => heartPath(p2.w, p2.h)
    },
    // P1 catalog wave (plan §1): the registry + options engine make each new
    // shape one entry — geometry, tile glyph and every edit option come free.
    diamond: {
      label: "Diamond",
      group: "shapes",
      caps: { fill: true, border: true, corners: true, stretch: true },
      build: (p2) => roundedPolygonPath([
        { x: p2.w / 2, y: 0 },
        { x: p2.w, y: p2.h / 2 },
        { x: p2.w / 2, y: p2.h },
        { x: 0, y: p2.h / 2 }
      ], p2.round)
    },
    pentagon: {
      label: "Pentagon",
      group: "shapes",
      caps: { fill: true, border: true, corners: true, stretch: true },
      build: (p2) => roundedPolygonPath(regularPolygon(5, -90, p2.w, p2.h), p2.round)
    },
    hexagon: {
      label: "Hexagon",
      group: "shapes",
      caps: { fill: true, border: true, corners: true, stretch: true },
      build: (p2) => roundedPolygonPath(regularPolygon(6, 0, p2.w, p2.h), p2.round)
      // flat-top
    },
    octagon: {
      label: "Octagon",
      group: "shapes",
      caps: { fill: true, border: true, corners: true, stretch: true },
      build: (p2) => roundedPolygonPath(regularPolygon(8, 22.5, p2.w, p2.h), p2.round)
      // stop-sign
    },
    semicircle: {
      label: "Half circle",
      group: "shapes",
      caps: { fill: true, border: true, stretch: true },
      aspect: 0.5,
      build: (p2) => "M0 " + fmt(p2.h) + "A" + fmt(p2.w / 2) + " " + fmt(p2.h) + " 0 0 1 " + fmt(p2.w) + " " + fmt(p2.h) + "Z"
    },
    quarter: {
      label: "Quarter",
      group: "shapes",
      caps: { fill: true, border: true, stretch: true },
      build: (p2) => "M0 " + fmt(p2.h) + "L0 0A" + fmt(p2.w) + " " + fmt(p2.h) + " 0 0 1 " + fmt(p2.w) + " " + fmt(p2.h) + "Z"
    },
    plus: {
      label: "Plus",
      group: "shapes",
      caps: { fill: true, border: true, corners: true, stretch: true },
      build: (p2) => {
        const a2 = 0.335, b2 = 0.665;
        const P2 = (fx, fy) => ({ x: fx * p2.w, y: fy * p2.h });
        return roundedPolygonPath([
          P2(a2, 0),
          P2(b2, 0),
          P2(b2, a2),
          P2(1, a2),
          P2(1, b2),
          P2(b2, b2),
          P2(b2, 1),
          P2(a2, 1),
          P2(a2, b2),
          P2(0, b2),
          P2(0, a2),
          P2(a2, a2)
        ], p2.round);
      }
    },
    // Lines (parametric assemblies — geometry built in editor.js from these
    // defaults; the registry rows drive the tiles + default caps). All ONE
    // element (kind stays what was placed; caps are per-end params).
    line: {
      label: "Line",
      group: "lines",
      isLine: true,
      caps: { ends: true, weight: true, dash: true },
      defaults: { weight: 9, dash: "solid", capStart: "none", capEnd: "none" }
    },
    arrow: {
      label: "Arrow",
      group: "lines",
      isLine: true,
      caps: { ends: true, weight: true, dash: true },
      defaults: { weight: 9, dash: "solid", capStart: "none", capEnd: "arrow" }
    },
    arrowBoth: {
      label: "Double arrow",
      group: "lines",
      isLine: true,
      caps: { ends: true, weight: true, dash: true },
      defaults: { weight: 9, dash: "solid", capStart: "arrow", capEnd: "arrow" }
    }
  };
  function lineCapPath(kind, endX, dir, w2) {
    if (kind === "arrow") {
      const L2 = 3.1 * w2, W2 = 1.85 * w2;
      return "M" + fmt(endX) + " 0L" + fmt(endX - dir * L2) + " " + fmt(-W2) + "L" + fmt(endX - dir * L2) + " " + fmt(W2) + "Z";
    }
    if (kind === "bar") {
      const t2 = 0.95 * w2, H2 = 1.8 * w2;
      return "M" + fmt(endX - t2 / 2) + " " + fmt(-H2) + "L" + fmt(endX + t2 / 2) + " " + fmt(-H2) + "L" + fmt(endX + t2 / 2) + " " + fmt(H2) + "L" + fmt(endX - t2 / 2) + " " + fmt(H2) + "Z";
    }
    if (kind === "dot") {
      const r2 = 1.5 * w2;
      return "M" + fmt(endX - r2) + " 0A" + fmt(r2) + " " + fmt(r2) + " 0 1 1 " + fmt(endX + r2) + " 0A" + fmt(r2) + " " + fmt(r2) + " 0 1 1 " + fmt(endX - r2) + " 0Z";
    }
    return null;
  }
  function lineCapInset(kind, w2) {
    if (kind === "arrow") return 2.4 * w2;
    if (kind === "bar") return 0.5 * w2;
    if (kind === "dot") return 1.2 * w2;
    return 0;
  }
  var DEFAULT_EL_PARAMS = (kind) => Object.assign({ round: 0 }, ELEMENTS[kind] && ELEMENTS[kind].defaults || {});
  function buildElementPath(kind, params) {
    const def = ELEMENTS[kind];
    if (!def || !def.build) return null;
    return def.build(Object.assign({ w: 100, h: 100, round: 0 }, params));
  }
  function elementGlyphSvg(kind) {
    const def = ELEMENTS[kind];
    if (!def) return "";
    if (def.isLine) {
      return '<svg width="26" height="26" viewBox="-10 -10 120 120" fill="none">' + lineGlyphInner(def.defaults || {}) + "</svg>";
    }
    const h2 = 100 * (def.aspect || 1);
    const d2 = buildElementPath(kind, Object.assign({ w: 100, h: h2 }, DEFAULT_EL_PARAMS(kind)));
    return '<svg width="26" height="26" viewBox="-10 -10 120 120" fill="none"><path d="' + d2 + '" transform="translate(0 ' + fmt((100 - h2) / 2) + ')" stroke="currentColor" stroke-width="8" stroke-linejoin="round" stroke-linecap="round"/></svg>';
  }
  function lineGlyphInner(defs) {
    const a2 = { x: 8, y: 92 }, b2 = { x: 92, y: 8 };
    let inner = '<path d="M' + a2.x + " " + a2.y + "L" + b2.x + " " + b2.y + '" stroke="currentColor" stroke-width="8" stroke-linecap="round"/>';
    const ang = Math.atan2(b2.y - a2.y, b2.x - a2.x);
    const cap = (p2, dir, kind) => {
      if (kind === "arrow") {
        const L2 = 26, Wd = 16;
        const bx = p2.x - Math.cos(dir) * L2, by = p2.y - Math.sin(dir) * L2;
        const px = -Math.sin(dir) * Wd, py = Math.cos(dir) * Wd;
        return '<path d="M' + fmt(p2.x) + " " + fmt(p2.y) + "L" + fmt(bx + px) + " " + fmt(by + py) + "L" + fmt(bx - px) + " " + fmt(by - py) + 'Z" fill="currentColor"/>';
      }
      if (kind === "bar") {
        const px = -Math.sin(dir) * 16, py = Math.cos(dir) * 16;
        return '<path d="M' + fmt(p2.x + px) + " " + fmt(p2.y + py) + "L" + fmt(p2.x - px) + " " + fmt(p2.y - py) + '" stroke="currentColor" stroke-width="8" stroke-linecap="round"/>';
      }
      if (kind === "dot") return '<circle cx="' + fmt(p2.x) + '" cy="' + fmt(p2.y) + '" r="12" fill="currentColor"/>';
      return "";
    };
    inner += cap(a2, ang + Math.PI, defs.capStart);
    inner += cap(b2, ang, defs.capEnd);
    return inner;
  }

  // src/adjust-filters.js
  var fragmentSource = `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uHi;
  uniform float uSh;
  uniform float uWh;
  uniform float uBl;
  uniform float uClar;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    vec3 c = color.rgb;
    float lum = dot(c, vec3(0.299, 0.587, 0.114));
    c += uSh * (1.0 - smoothstep(0.0, 0.55, lum)) * 0.35;
    c *= 1.0 + uHi * smoothstep(0.45, 1.0, lum) * 0.7;
    float bp = -0.25 * uBl;
    c = (c - bp) / max(0.05, 1.0 - bp);
    c /= max(0.05, 1.0 - 0.25 * uWh);
    float mid = 1.0 - abs(2.0 * lum - 1.0);
    c = mix(c, (c - 0.5) * (1.0 + uClar * 0.6) + 0.5, mid);
    gl_FragColor = vec4(clamp(c, 0.0, 1.0), color.a);
  }
`;
  var sstep = (a2, b2, x2) => {
    const t2 = Math.min(1, Math.max(0, (x2 - a2) / (b2 - a2)));
    return t2 * t2 * (3 - 2 * t2);
  };
  var NinjaTone = class extends Cc.BaseFilter {
    getFragmentSource() {
      return fragmentSource;
    }
    applyTo2d({ imageData: { data } }) {
      const { hi: hi2, sh, wh, bl, clar } = this;
      const bp = -0.25 * bl;
      const bpDiv = Math.max(0.05, 1 - bp);
      const wpDiv = Math.max(0.05, 1 - 0.25 * wh);
      for (let i2 = 0; i2 < data.length; i2 += 4) {
        let r2 = data[i2] / 255, g2 = data[i2 + 1] / 255, b2 = data[i2 + 2] / 255;
        const lum = r2 * 0.299 + g2 * 0.587 + b2 * 0.114;
        const lift = sh * (1 - sstep(0, 0.55, lum)) * 0.35;
        const gain = 1 + hi2 * sstep(0.45, 1, lum) * 0.7;
        const mid = 1 - Math.abs(2 * lum - 1);
        const tone = (v2) => {
          v2 = (v2 + lift) * gain;
          v2 = (v2 - bp) / bpDiv;
          v2 = v2 / wpDiv;
          v2 = v2 + ((v2 - 0.5) * (1 + clar * 0.6) + 0.5 - v2) * mid;
          return Math.min(255, Math.max(0, Math.round(v2 * 255)));
        };
        data[i2] = tone(r2);
        data[i2 + 1] = tone(g2);
        data[i2 + 2] = tone(b2);
      }
    }
    isNeutralState() {
      return !this.hi && !this.sh && !this.wh && !this.bl && !this.clar;
    }
    sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uHi, this.hi);
      gl.uniform1f(uniformLocations.uSh, this.sh);
      gl.uniform1f(uniformLocations.uWh, this.wh);
      gl.uniform1f(uniformLocations.uBl, this.bl);
      gl.uniform1f(uniformLocations.uClar, this.clar);
    }
  };
  __publicField(NinjaTone, "type", "NinjaTone");
  __publicField(NinjaTone, "defaults", { hi: 0, sh: 0, wh: 0, bl: 0, clar: 0 });
  __publicField(NinjaTone, "uniformLocations", ["uHi", "uSh", "uWh", "uBl", "uClar"]);
  M.setClass(NinjaTone);

  // src/editor.js
  var GESTURE_SETTLE = 160;
  function patchFilterBackend(be2) {
    if (!be2 || be2.__nsPatched || !be2.gl) return be2;
    be2.__nsPatched = true;
    const glMax = be2.gl.getParameter(be2.gl.MAX_TEXTURE_SIZE) || 4096;
    const orig = be2.applyFilters.bind(be2);
    let c2d = null;
    be2.applyFilters = (filters, source, w2, h2, target2, key) => {
      const dim = Math.max(w2 || 0, h2 || 0);
      if (dim > glMax) {
        c2d = c2d || new _s();
        return c2d.applyFilters(filters, source, w2, h2, target2, key);
      }
      if (dim > be2.tileSize) {
        be2.tileSize = Math.min(glMax, Math.max(dim, be2.tileSize * 2));
        be2.setupGLContext(be2.tileSize, be2.tileSize);
      }
      return orig(filters, source, w2, h2, target2, key);
    };
    return be2;
  }
  function warpPoint(kind, a2, W2, fontSize, x2, y2) {
    if (kind === "wave") {
      return [x2, y2 + waveOffset(a2, W2, fontSize, x2)];
    }
    if (kind === "angle") {
      return [x2, y2 + x2 * Math.tan(angleTheta(a2))];
    }
    if (kind === "bulge") {
      const f2 = Math.max(0.35, 1 + a2 * 0.65 * Math.cos(Math.PI * x2 / W2));
      return [x2, y2 * f2];
    }
    if (kind === "arcup" || kind === "arclo") {
      const f2 = Math.max(0.35, 1 + a2 * 0.65 * Math.cos(Math.PI * x2 / W2));
      if (kind === "arcup") return [x2, y2 * f2];
      const top = -fontSize * 0.72;
      return [x2, top + (y2 - top) * f2];
    }
    return [x2, y2];
  }
  function waveOffset(a2, W2, fontSize, x2) {
    const A2 = a2 * 0.7 * fontSize;
    const phi = 2 * Math.PI * x2 / (9.5 * fontSize) + 0.075 * Math.PI;
    return -A2 * Math.sin(phi);
  }
  function waveGlyph(a2, W2, fontSize, x2) {
    return { y: waveOffset(a2, W2, fontSize, x2), rot: 0 };
  }
  function angleTheta(a2) {
    return -a2 * Math.abs(a2) * (Math.PI / 4);
  }
  function curveRadius(a2, fontSize) {
    return fontSize * 1.7 / Math.max(0.01, Math.abs(a2));
  }
  function curveGlyph(a2, R3, x2) {
    const up = a2 > 0;
    const phi = x2 / R3;
    return {
      x: R3 * Math.sin(phi),
      y: (up ? 1 : -1) * R3 * (1 - Math.cos(phi)),
      rot: up ? phi : -phi
    };
  }
  var DESIGN_UNITS = 1100;
  var ROTATE_KNOB_R = 18;
  function renderRotateControl(ctx, left, top, styleOverride, obj) {
    const c2 = obj && obj.canvas;
    if (c2) c2.__mtrScreen = { left, top, hot: c2.__hoverControl === "mtr" };
  }
  function renderCornerControl(key) {
    return function(ctx, left, top, styleOverride, obj) {
      const hot = obj && obj.canvas && obj.canvas.__hoverControl === key;
      ctx.save();
      ctx.translate(left, top);
      ctx.shadowColor = "rgba(15,23,42,0.25)";
      ctx.shadowBlur = 4;
      ctx.shadowOffsetY = 1;
      ctx.beginPath();
      ctx.arc(0, 0, hot ? 7 : 5.5, 0, Math.PI * 2);
      ctx.fillStyle = hot ? "#019aff" : "#ffffff";
      ctx.fill();
      ctx.shadowColor = "transparent";
      ctx.strokeStyle = hot ? "#0284d8" : "#9db4c8";
      ctx.lineWidth = 1;
      ctx.stroke();
      ctx.restore();
    };
  }
  var CURSOR_CACHE = {};
  function resizeCursorUrl(deg) {
    const a2 = (Math.round(deg / 15) * 15 % 180 + 180) % 180;
    if (CURSOR_CACHE[a2]) return CURSOR_CACHE[a2];
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><g transform="rotate(' + a2 + ' 13 13)"><path d="M2.5 13 8.4 7.4v3.4h9.2V7.4l5.9 5.6-5.9 5.6v-3.4H8.4v3.4z" fill="#0f172a" stroke="#ffffff" stroke-width="1.6" stroke-linejoin="round"/></g></svg>';
    const fallback = a2 > 22 && a2 <= 67 ? "nwse-resize" : a2 > 67 && a2 <= 112 ? "ns-resize" : a2 > 112 && a2 <= 157 ? "nesw-resize" : "ew-resize";
    return CURSOR_CACHE[a2] = 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg) + '") 13 13, ' + fallback;
  }
  var CORNER_AXIS = { tl: 45, br: 45, tr: 135, bl: 135 };
  var cornerCursorHandler = (key) => (eventData, control, obj) => resizeCursorUrl(CORNER_AXIS[key] + (obj.angle || 0));
  var ROTATE_CURSOR = (() => {
    const head = "M0 -5 L4.2 3.2 L-4.2 3.2 Z";
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><path d="M6 10.5 A8.8 8.8 0 0 0 22 10.5" fill="none" stroke="#ffffff" stroke-width="6.2" stroke-linecap="round"/><path d="M6 10.5 A8.8 8.8 0 0 0 22 10.5" fill="none" stroke="#0f172a" stroke-width="3" stroke-linecap="round"/><path d="' + head + '" transform="translate(6 9.2) rotate(-34)" fill="#0f172a" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round"/><path d="' + head + '" transform="translate(22 9.2) rotate(34)" fill="#0f172a" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round"/></svg>';
    return 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg) + '") 14 14, crosshair';
  })();
  var EditorCloneProps = [
    "__bgr",
    "__effect",
    "__effectColor",
    "__effectSize",
    "__fxDirection",
    "__fxOffset",
    "__fxBlur",
    "__fxTransparency",
    "__fxRound",
    "__fxSpread",
    "__fxEcho2",
    "__shape",
    "__baseFill",
    "__gradFill",
    "__adjust",
    "__trimmed",
    "__filterStrength",
    "__superRes",
    "__sticker",
    "__stickerPad",
    "__stickerW",
    "__fxShift",
    "__originalSrc",
    "__fileName",
    "__manualWidth",
    "__caseOrig",
    "__bullets",
    "__filter",
    "__filterCS",
    "__filterColors",
    "__bake",
    "__shapeInkOffset",
    "__recolorRepl",
    "__recolorPal",
    "__aiCreated",
    "__aiEdit",
    "__autoWindow",
    // '__radius' (image corner rounding): the clipPath serializes natively so the
    // corners still SHOW, but without this the Radius slider reset to 0 and every
    // `if (img.__radius) setImageRadius(...)` re-fit guard (crop/BGR/enhance/AI/
    // filter) no-op'd, leaving a stale clipPath (agent 9-08). '__bgTextH' is the
    // flat-background plate height, re-derived on restore too — see _shapeReattach.
    "__radius",
    "__bgTextH",
    "__locked",
    "__base",
    // '__el': Elements v2 params (kind/w/h/round; lines add len/weight/dash/
    // caps). The LOOK rides on native fabric props (path/fill/stroke/…) — this
    // carries only what's needed to REBUILD geometry when a param changes.
    // Without it, rounding/caps silently reset on undo/save/clone while the art
    // still renders (the exact `__radius` failure mode above). '__elRole' tags a
    // line assembly's children (shaft/capStart/capEnd) for reattach.
    "__el",
    "__elRole"
  ];
  var Editor = class {
    constructor(canvasEl, areaEl, opts = {}) {
      this.outlineTracksScale = true;
      this.areaEl = areaEl;
      this.scrollEl = areaEl.querySelector(".nsv2-scroll") || areaEl;
      this.apronX = 0;
      this.apronY = 0;
      this.userZoom = 1;
      this.fitScale = 0.5;
      this._restoring = false;
      this._history = [];
      this._redo = [];
      this._listeners = {};
      this.designW = opts.designW > 0 ? Math.round(opts.designW) : DESIGN_UNITS;
      this.designH = opts.designH > 0 ? Math.round(opts.designH) : DESIGN_UNITS;
      this.canvas = new ho(canvasEl, {
        preserveObjectStacking: true,
        selection: true,
        backgroundColor: "",
        // Swipe-to-pan when zoomed (Owen 9-08): fabric swallows EVERY touch by
        // default, so once the canvas fills the viewport there is no pannable
        // surface. With this flag fabric only claims touches on the ACTIVE
        // object (drag still works); empty-canvas swipes fall through to the
        // .nsv2-scroll container's native scrolling — the Canva model.
        allowTouchScrolling: true
      });
      this.canvas.upperCanvasEl.style.touchAction = "pan-x pan-y";
      this.canvas.lowerCanvasEl.style.touchAction = "pan-x pan-y";
      this.boardApron = 60;
      this._boardBg = "";
      this._grid = { on: false, sizeIn: 0.25 };
      this._guides = { v: [], h: [] };
      this._guideDrag = null;
      this._pageEl = document.createElement("div");
      this._pageEl.className = "nsv2-page w3_bg";
      this.canvas.wrapperEl.insertBefore(this._pageEl, this.canvas.wrapperEl.firstChild);
      {
        const origRenderObjects = this.canvas._renderObjects.bind(this.canvas);
        const editor = this;
        this.canvas._renderObjects = function(ctx, objects) {
          ctx.save();
          ctx.beginPath();
          ctx.rect(0, 0, editor.designW, editor.designH);
          ctx.clip();
          origRenderObjects(ctx, objects);
          ctx.restore();
        };
      }
      this._strippingLocked = false;
      const stripLocked = () => {
        if (this._strippingLocked) return;
        const sel = this.canvas.getActiveObject();
        if (!sel || !(sel instanceof gs)) return;
        const members = sel.getObjects();
        const keep = members.filter((o2) => !o2.__locked);
        if (keep.length === members.length) return;
        this._strippingLocked = true;
        try {
          this.canvas.discardActiveObject();
          if (keep.length === 1) this.canvas.setActiveObject(keep[0]);
          else if (keep.length > 1) {
            const ns2 = new gs(keep, { canvas: this.canvas });
            this.canvas.setActiveObject(ns2);
            this._styleSelection(ns2);
          }
        } finally {
          this._strippingLocked = false;
        }
        this.canvas.requestRenderAll();
        this._emit("selection");
      };
      this.canvas.on("selection:created", stripLocked);
      this.canvas.on("selection:updated", stripLocked);
      this._ro = new ResizeObserver(() => this.fitToContainer());
      this._ro.observe(areaEl);
      this.fitToContainer();
      this.canvas.__hoverControl = null;
      const setHover = (key) => {
        if (this.canvas.__hoverControl === key) return;
        this.canvas.__hoverControl = key;
        this.canvas.requestRenderAll();
      };
      this.canvas.on("mouse:move", (e24) => {
        const tf = this.canvas._currentTransform;
        if (tf) return setHover(tf.corner || null);
        const t2 = this.canvas.getActiveObject();
        if (!t2 || !t2.findControl) return setHover(null);
        const ctl = t2.findControl(this.canvas.getViewportPoint(e24.e));
        setHover(ctl ? ctl.key : null);
      });
      this.canvas.on("mouse:out", () => setHover(null));
      this.canvas.on("selection:cleared", () => setHover(null));
      const styleMulti = () => {
        const a2 = this.canvas.getActiveObject();
        if (a2 instanceof gs) {
          this._styleSelection(a2);
          for (const o2 of a2.getObjects()) o2.borderColor = "rgba(102, 186, 255, 0.35)";
          this.canvas.requestRenderAll();
        }
      };
      this.canvas.on("selection:created", styleMulti);
      this.canvas.on("selection:updated", styleMulti);
      const restoreBorders = (e24) => {
        for (const o2 of e24 && e24.deselected || []) o2.borderColor = "#66baff";
        const a2 = this.canvas.getActiveObject();
        if (a2 && !(a2 instanceof gs)) a2.borderColor = "#66baff";
      };
      this.canvas.on("selection:updated", restoreBorders);
      this.canvas.on("selection:cleared", restoreBorders);
      const canvasBlank = (el2) => {
        try {
          const p2 = document.createElement("canvas");
          p2.width = 24;
          p2.height = 24;
          const cx = p2.getContext("2d");
          cx.drawImage(el2, 0, 0, 24, 24);
          const d2 = cx.getImageData(0, 0, 24, 24).data;
          for (let i2 = 3; i2 < d2.length; i2 += 4) if (d2[i2] > 0) return false;
          return true;
        } catch (e24) {
          return false;
        }
      };
      this._onVisibility = () => {
        const objs = this.canvas.getObjects();
        if (document.hidden) {
          for (const o2 of objs) {
            if (!o2.isType || !o2.isType("image")) continue;
            const src = o2._originalElement || o2._element;
            if (src && src.tagName === "CANVAS") {
              try {
                o2.__canvasBackup = src.toDataURL();
              } catch (e24) {
              }
            }
            if (o2.__stickerEl && o2.__stickerEl.canvas) {
              try {
                o2.__stickerBackup = o2.__stickerEl.canvas.toDataURL();
              } catch (e24) {
              }
            }
          }
          return;
        }
        try {
          const be2 = xs();
          if (be2 && be2.gl && be2.gl.isContextLost && be2.gl.isContextLost()) {
            Ss(patchFilterBackend(bs()));
          }
        } catch (e24) {
        }
        for (const o2 of objs) {
          o2.dirty = true;
          if (!o2.isType || !o2.isType("image")) continue;
          const st2 = o2.__stickerEl;
          if (st2 && st2.canvas && o2.__stickerBackup && canvasBlank(st2.canvas)) {
            const cimg = new Image();
            cimg.onload = () => {
              try {
                const cx = st2.canvas.getContext("2d");
                cx.clearRect(0, 0, st2.canvas.width, st2.canvas.height);
                cx.drawImage(cimg, 0, 0);
                o2.dirty = true;
                this.canvas.requestRenderAll();
              } catch (e24) {
              }
            };
            cimg.src = o2.__stickerBackup;
          }
          const src = o2._originalElement || o2._element;
          if (src && src.tagName === "CANVAS" && o2.__canvasBackup && canvasBlank(src)) {
            const img = new Image();
            img.onload = () => {
              try {
                const cx = src.getContext("2d");
                cx.clearRect(0, 0, src.width, src.height);
                cx.drawImage(img, 0, 0);
                if (o2.filters && o2.filters.length) o2.applyFilters();
                o2.dirty = true;
                this.canvas.requestRenderAll();
              } catch (e24) {
              }
            };
            img.src = o2.__canvasBackup;
          } else if (o2.filters && o2.filters.length) {
            try {
              o2.applyFilters();
              o2.dirty = true;
            } catch (e24) {
            }
          }
        }
        this.canvas.calcOffset();
        this.canvas.renderAll();
      };
      document.addEventListener("visibilitychange", this._onVisibility);
      try {
        patchFilterBackend(xs());
      } catch (e24) {
      }
      this._snapGuides = null;
      this._snapState = { v: null, h: null };
      this._snapTargets = null;
      this.canvas.on("object:moving", (e24) => {
        this._hideDragChrome(e24.target);
        this._snapMove(e24);
      });
      const clearSnap = () => {
        this._restoreDragChrome();
        this._snapTargets = null;
        this._snapState = { v: null, h: null };
        if (!this._snapGuides) return;
        this._snapGuides = null;
        this.canvas.requestRenderAll();
      };
      this.canvas.on("mouse:up", clearSnap);
      this.canvas.on("selection:cleared", clearSnap);
      this.canvas.on("selection:created", clearSnap);
      this.canvas.on("selection:updated", clearSnap);
      this.canvas.on("after:render", () => {
        this._drawUserGuides();
        this._drawSnapGuides();
      });
      this._snapshot = () => {
        const data = this.canvas.toDatalessJSON(EditorCloneProps);
        const lighten = (live, json) => {
          if (!live || !json) return;
          for (let i2 = 0; i2 < live.length && i2 < json.length; i2++) {
            const o2 = live[i2], j2 = json[i2];
            if (!o2 || !j2) continue;
            if (o2.isType && o2.isType("image") && o2.__preRecolorEl && j2.type && /image/i.test(j2.type)) {
              const base = o2.__preRecolorEl;
              const src = base && base.tagName === "IMG" ? base.currentSrc || base.src : "";
              if (src && !/^data:/i.test(src)) {
                j2.src = src;
                j2.crossOrigin = "anonymous";
                j2.__restage = true;
              }
            }
            if (o2.getObjects && j2.objects) lighten(o2.getObjects(), j2.objects);
          }
        };
        lighten(this.canvas.getObjects(), data.objects);
        data.__designW = this.designW;
        data.__designH = this.designH;
        data.__boardBg = this._boardBg || "";
        data.__guides = { v: this._guides.v.slice(), h: this._guides.h.slice() };
        return JSON.stringify(data);
      };
      this._recordTimer = null;
      this._flushRecord = () => {
        if (!this._recordTimer) return;
        clearTimeout(this._recordTimer);
        this._recordTimer = null;
        if (this._restoring) return;
        this._history.push(this._snapshot());
        if (this._history.length > 60) this._history.shift();
        this._redo.length = 0;
        this._emit("history");
      };
      const record = () => {
        if (this._restoring) return;
        clearTimeout(this._recordTimer);
        this._recordTimer = setTimeout(this._flushRecord, 300);
        this._recordTimer && this._emit("history");
      };
      this._record = record;
      this._history.push(this._snapshot());
      this.canvas.on("object:added", record);
      this.canvas.on("object:modified", record);
      this.canvas.on("object:removed", record);
      this.canvas.on("mouse:down", (opt) => {
        const pe2 = opt.e;
        this._touchHold = pe2 && pe2.pointerType === "touch" && opt.target ? { obj: opt.target, left: opt.target.left, top: opt.target.top, x: pe2.clientX, y: pe2.clientY, held: true } : null;
      });
      this.canvas.on("object:moving", (opt) => {
        const h2 = this._touchHold;
        if (!h2 || !h2.held || opt.target !== h2.obj) return;
        const pe2 = opt.e;
        if (pe2 && Math.hypot(pe2.clientX - h2.x, pe2.clientY - h2.y) < 6) {
          opt.target.set({ left: h2.left, top: h2.top });
        } else {
          h2.held = false;
        }
      });
      this.canvas.on("mouse:up", () => {
        this._touchHold = null;
      });
      this._onFontsArrived = (e24) => {
        const fams = new Set([...e24 && e24.fontfaces || []].map((f2) => String(f2.family || "").replace(/^['"]|['"]$/g, "")));
        if (!fams.size) return;
        for (const fam of fams) y.clearFontCache(fam);
        let touched = false;
        for (const o2 of this.canvas.getObjects()) {
          if (o2.isType && o2.isType("textbox") && fams.has(o2.fontFamily) && !o2.isEditing) {
            this._hugWidth(o2);
            o2.dirty = true;
            touched = true;
          }
        }
        if (touched) {
          this.canvas.requestRenderAll();
          this._emit("selection");
        }
      };
      try {
        document.fonts.addEventListener("loadingdone", this._onFontsArrived);
      } catch (e24) {
      }
      this._onStudioFontLoaded = (e24) => {
        const family = e24 && e24.detail && e24.detail.family;
        if (family) this._onFontsArrived({ fontfaces: [{ family }] });
      };
      try {
        document.addEventListener("nsv2:fontloaded", this._onStudioFontLoaded);
      } catch (e24) {
      }
      this._canvasFontWatch = /* @__PURE__ */ new Map();
      this._probeCtx = null;
      this._canvasFontUsable = (family) => {
        try {
          const ctx = this._probeCtx || (this._probeCtx = document.createElement("canvas").getContext("2d"));
          const txt = "Your text 0123 WMwm";
          ctx.font = '700 40px "' + family + '"';
          const a2 = ctx.measureText(txt).width;
          ctx.font = "700 40px serif";
          const b2 = ctx.measureText(txt).width;
          ctx.font = "700 40px sans-serif";
          const c2 = ctx.measureText(txt).width;
          return Math.abs(a2 - b2) > 0.5 && Math.abs(a2 - c2) > 0.5;
        } catch (e24) {
          return true;
        }
      };
      this._ensureCanvasFont = (family) => {
        if (!family || this._canvasFontWatch.get(family) === "done") return;
        if (this._canvasFontWatch.get(family)) return;
        if (this._canvasFontUsable(family)) {
          this._canvasFontWatch.set(family, "done");
          return;
        }
        let n2 = 0;
        const timer = setInterval(() => {
          n2++;
          if (this._canvasFontUsable(family)) {
            clearInterval(timer);
            this._canvasFontWatch.set(family, "done");
            this._onFontsArrived({ fontfaces: [{ family }] });
          } else if (n2 >= 40) {
            clearInterval(timer);
            this._canvasFontWatch.delete(family);
          }
        }, 250);
        this._canvasFontWatch.set(family, timer);
      };
      this.canvas.on("object:added", (e24) => {
        const o2 = e24 && e24.target;
        if (o2 && o2.isType && o2.isType("textbox") && o2.fontFamily) this._ensureCanvasFont(o2.fontFamily);
      });
      try {
        document.fonts.ready.then(() => {
          const fams = /* @__PURE__ */ new Set();
          for (const o2 of this.canvas.getObjects()) if (o2.isType && o2.isType("textbox") && o2.fontFamily) fams.add(o2.fontFamily);
          if (fams.size) this._onFontsArrived({ fontfaces: [...fams].map((family) => ({ family })) });
        });
      } catch (e24) {
      }
      this.canvas.on("object:modified", (e24) => {
        const t2 = e24 && e24.target;
        if (!t2) return;
        if (t2.__el) {
          if (t2.__el.isLine) this._lineNormalize(t2);
          else this._elAbsorbScale(t2);
        } else if (t2.isType && t2.isType("activeselection")) {
          for (const o2 of t2.getObjects()) {
            if (!o2.__el) {
              this._stickerWeightHold(o2);
              this._textOutlineHold(o2);
            }
          }
        } else {
          this._stickerWeightHold(t2);
          this._textOutlineHold(t2);
        }
      });
      this.canvas.on("object:scaling", (e24) => {
        const t2 = e24 && e24.target;
        if (!t2 || this.outlineTracksScale) return;
        const each = (o2) => {
          if (o2.isType && o2.isType("textbox") && o2.__effect === "outline") {
            const sc2 = this._effScale(o2);
            const want = Math.max(0.5, 2 * (o2.__effectSize != null ? o2.__effectSize : 12) / sc2);
            if (Math.abs((o2.strokeWidth || 0) - want) < 0.1) return;
            o2.set("strokeWidth", want);
            o2.dirty = true;
          } else if (o2.isType && o2.isType("image") && o2.__sticker && o2.__sticker.w) {
            this._stickerLive(o2);
          } else if (o2.__el && !o2.__el.isLine && o2.__el.bstyle && o2.__el.bstyle !== "none") {
            this._elStrokeSync(o2);
          } else if (o2.__el && o2.__el.isLine) {
            const parts = o2.__elParts || this._lineParts(o2);
            if (parts.shaft) {
              parts.shaft.set("strokeWidth", Math.max(0.5, (o2.__el.weight || 9) / this._effScale(o2)));
              parts.shaft.dirty = true;
              o2.dirty = true;
            }
          }
        };
        if (t2.isType && t2.isType("activeselection")) t2.getObjects().forEach(each);
        else each(t2);
      });
      const normDeselected = (e24) => {
        for (const o2 of e24 && e24.deselected || []) {
          if (o2.__el) {
            if (o2.__el.isLine) this._lineNormalize(o2);
            else this._elAbsorbScale(o2);
          } else {
            this._stickerWeightHold(o2);
            this._textOutlineHold(o2);
          }
        }
      };
      this.canvas.on("selection:cleared", normDeselected);
      this.canvas.on("selection:updated", normDeselected);
      this.canvas.on("text:changed", (e24) => {
        if (e24.target) {
          if (e24.target.__bullets) this._applyBullets(e24.target);
          this._hugWidth(e24.target);
          if (e24.target.isEditing && e24.target.__editCenter) {
            e24.target.setPositionByOrigin(e24.target.__editCenter, "center", "center");
            e24.target.setCoords();
          }
          this.canvas.requestRenderAll();
          this._emit("selection");
        }
      });
      this.canvas.on("object:resizing", (e24) => {
        if (e24.target) e24.target.__manualWidth = true;
      });
      this.canvas.on("after:render", () => {
        const o2 = this.canvas.getActiveObject();
        if (!o2 || !o2.__angleEnds || !this._shapeAdjusting || !o2.__shape || o2.__shape.kind !== "angle" || this._crop) return;
        const ctx = this.canvas.contextContainer;
        const vpt = this.canvas.viewportTransform;
        const c2 = o2.getCenterPoint();
        const rad = (o2.angle || 0) * Math.PI / 180;
        const pt2 = (p2) => {
          const ox = p2.x * o2.scaleX, oy = p2.y * o2.scaleY;
          const sx = c2.x + ox * Math.cos(rad) - oy * Math.sin(rad);
          const sy = c2.y + ox * Math.sin(rad) + oy * Math.cos(rad);
          return [sx * vpt[0] + vpt[4], sy * vpt[3] + vpt[5]];
        };
        const [x0, y0] = pt2(o2.__angleEnds[0]);
        const [x1, y1] = pt2(o2.__angleEnds[1]);
        const retina = this.canvas.getRetinaScaling ? this.canvas.getRetinaScaling() : 1;
        ctx.save();
        ctx.setTransform(retina, 0, 0, retina, 0, 0);
        ctx.strokeStyle = "rgba(102,186,255,0.9)";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(x0, y0);
        ctx.lineTo(x1, y1);
        ctx.stroke();
        for (const [hx, hy] of [[x0, y0], [x1, y1]]) {
          ctx.beginPath();
          ctx.arc(hx, hy, 4.5, 0, Math.PI * 2);
          ctx.fillStyle = "#ffffff";
          ctx.fill();
          ctx.strokeStyle = "#66baff";
          ctx.stroke();
        }
        ctx.restore();
      });
      this.canvas.on("after:render", () => {
        const o2 = this.canvas.getActiveObject();
        if (!o2 || !o2.__curveRing || !this._shapeAdjusting || !o2.__shape || o2.__shape.kind !== "curve" || this._crop) return;
        const ring2 = o2.__curveRing;
        const ctx = this.canvas.contextContainer;
        const vpt = this.canvas.viewportTransform;
        const c2 = o2.getCenterPoint();
        const rad = (o2.angle || 0) * Math.PI / 180;
        const ox = ring2.x * o2.scaleX, oy = ring2.y * o2.scaleY;
        const cx = c2.x + ox * Math.cos(rad) - oy * Math.sin(rad);
        const cy = c2.y + ox * Math.sin(rad) + oy * Math.cos(rad);
        const retina = this.canvas.getRetinaScaling ? this.canvas.getRetinaScaling() : 1;
        const scale = (o2.scaleX + o2.scaleY) / 2 * vpt[0];
        ctx.save();
        ctx.setTransform(retina, 0, 0, retina, 0, 0);
        ctx.strokeStyle = "rgba(102,186,255,0.9)";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(cx * vpt[0] + vpt[4], cy * vpt[3] + vpt[5], Math.max(1, ring2.r * scale), 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
      });
      const relay = (ev) => this.canvas.on(ev, () => this._emit("selection"));
      relay("selection:created");
      relay("selection:updated");
      relay("selection:cleared");
    }
    on(ev, fn2) {
      (this._listeners[ev] = this._listeners[ev] || []).push(fn2);
    }
    _emit(ev, payload) {
      (this._listeners[ev] || []).forEach((fn2) => fn2(payload));
    }
    // The board wrapper can carry padding (the 22px ruler-strip reserve) —
    // sizing against the raw scroll client ignores it and leaves a standing
    // 44px overflow whenever rulers are on (Owen 9-08 desktop wiggle).
    _boardPad() {
      const b2 = this.canvas && this.canvas.wrapperEl && this.canvas.wrapperEl.parentElement;
      if (!b2) return { x: 0, y: 0 };
      const cs2 = getComputedStyle(b2);
      return {
        x: (parseFloat(cs2.paddingLeft) || 0) + (parseFloat(cs2.paddingRight) || 0),
        y: (parseFloat(cs2.paddingTop) || 0) + (parseFloat(cs2.paddingBottom) || 0)
      };
    }
    fitToContainer() {
      const pad = this._boardPad();
      const rect = {
        width: (this.scrollEl.clientWidth || this.areaEl.getBoundingClientRect().width) - pad.x,
        height: (this.scrollEl.clientHeight || this.areaEl.getBoundingClientRect().height) - pad.y
      };
      if (!(rect.width > 0) || !(rect.height > 0)) return;
      this.boardApron = 20;
      const a2 = 2 * this.boardApron;
      this.fitScale = Math.max(
        0.01,
        Math.min((rect.width - a2) / this.designW, (rect.height - a2) / this.designH)
      );
      this._applyZoom();
    }
    _applyZoom() {
      const scale = this.fitScale * this.userZoom;
      const w2 = Math.max(1, Math.round(this.designW * scale));
      const h2 = Math.max(1, Math.round(this.designH * scale));
      const A2 = this.boardApron;
      const pad = this._boardPad();
      const cw = this.scrollEl ? this.scrollEl.clientWidth - pad.x : 0;
      const ch = this.scrollEl ? this.scrollEl.clientHeight - pad.y : 0;
      const apronX = cw && w2 <= cw ? Math.min(A2, Math.max(0, Math.floor((cw - w2) / 2))) : A2;
      const apronY = ch && h2 <= ch ? Math.min(A2, Math.max(0, Math.floor((ch - h2) / 2))) : A2;
      this.apronX = apronX;
      this.apronY = apronY;
      const newW = w2 + 2 * apronX;
      const newH = h2 + 2 * apronY;
      const resized = this.canvas.getWidth() !== newW || this.canvas.getHeight() !== newH;
      if (resized) this.canvas.setDimensions({ width: newW, height: newH });
      this.canvas.setViewportTransform([scale, 0, 0, scale, apronX, apronY]);
      if (this._pageEl) {
        this._pageEl.style.left = apronX + "px";
        this._pageEl.style.top = apronY + "px";
        this._pageEl.style.width = w2 + "px";
        this._pageEl.style.height = h2 + "px";
        this._paintPage();
      }
      if (resized) this.canvas.renderAll();
      else this.canvas.requestRenderAll();
      this._emit("zoom");
    }
    // Compose the page background: [grid lines] over [preview color | checker].
    // One inline style each time — the pieces coexist as background layers, so
    // the grid works over any board color (line shade adapts to bg luminance).
    _paintPage() {
      const p2 = this._pageEl;
      if (!p2) return;
      const layers = [];
      const sizes = [];
      if (this._grid.on) {
        const s3 = Math.max(4, this._grid.sizeIn * 50 * this.fitScale * this.userZoom);
        let line = "rgba(15,23,42,0.16)";
        if (this._boardBg) {
          const c2 = parseInt(this._boardBg.replace("#", ""), 16);
          const lum = 0.299 * (c2 >> 16 & 255) + 0.587 * (c2 >> 8 & 255) + 0.114 * (c2 & 255);
          if (lum < 128) line = "rgba(255,255,255,0.22)";
        }
        layers.push("repeating-linear-gradient(to right, " + line + " 0 1px, transparent 1px " + s3 + "px)");
        layers.push("repeating-linear-gradient(to bottom, " + line + " 0 1px, transparent 1px " + s3 + "px)");
        sizes.push("auto", "auto");
      }
      if (this._boardBg) {
        layers.push("linear-gradient(" + this._boardBg + ", " + this._boardBg + ")");
        sizes.push("auto");
      } else {
        layers.push("conic-gradient(#e9edf2 25%, #ffffff 0 50%, #e9edf2 0 75%, #ffffff 0)");
        sizes.push("18px 18px");
      }
      p2.style.background = layers.join(", ");
      p2.style.backgroundSize = sizes.join(", ");
    }
    setGrid(opts) {
      if (opts && typeof opts.on === "boolean") this._grid.on = opts.on;
      if (opts && opts.sizeIn) this._grid.sizeIn = Math.max(0.125, Math.min(4, opts.sizeIn));
      this._paintPage();
      this._emit("grid");
    }
    get grid() {
      return { on: this._grid.on, sizeIn: this._grid.sizeIn };
    }
    // While an object is being DRAGGED, its selection chrome (blue frame +
    // handles) disappears — only the art and the snap guides move (Canva
    // behavior, Owen 9-07). Restored on mouse:up and on any selection change.
    // Scale/rotate keep their handles: this fires only for pointer MOVE drags
    // (gated on fabric's live transform action), so a programmatic
    // object:moving can never strand an object with its chrome off.
    _hideDragChrome(o2) {
      if (!o2 || this._dragChrome && this._dragChrome.o === o2) return;
      const tr2 = this.canvas._currentTransform;
      if (!tr2 || tr2.action !== "drag") return;
      this._dragChrome = { o: o2, borders: !!o2.hasBorders, controls: !!o2.hasControls };
      o2.hasBorders = false;
      o2.hasControls = false;
    }
    // Viewport gesture chrome (Owen 9-18 "when zooming or panning hide element
    // controls"): every continuous VIEWPORT gesture — pinch, ctrl/⌘-wheel zoom,
    // Space-drag pan, the zoom glide, plain board scroll — calls beginGesture()
    // per event; the chrome returns GESTURE_SETTLE ms after the last one. While
    // active the active object's handles + borders are off (same save/restore
    // idea as the move-drag chrome, but NOT gated on fabric's transform — a
    // pinch has none) and index.js hides the pill / Edit chip / context menu
    // through the 'gesture' event. Object drags keep their own chrome path.
    beginGesture() {
      if (!this._gesture) {
        const o2 = this.canvas.getActiveObject() || null;
        this._gesture = { o: o2, borders: !!(o2 && o2.hasBorders), controls: !!(o2 && o2.hasControls) };
        if (o2) {
          o2.hasBorders = false;
          o2.hasControls = false;
        }
        this._emit("gesture", true);
        this.canvas.requestRenderAll();
      }
      clearTimeout(this._gestureT);
      this._gestureT = setTimeout(() => this.endGesture(), GESTURE_SETTLE);
    }
    endGesture() {
      clearTimeout(this._gestureT);
      this._gestureT = 0;
      const g2 = this._gesture;
      if (!g2) return;
      this._gesture = null;
      if (g2.o && (this.canvas.getObjects().includes(g2.o) || g2.o === this.canvas.getActiveObject())) {
        g2.o.hasBorders = g2.borders;
        g2.o.hasControls = g2.controls;
      }
      this._emit("gesture", false);
      this.canvas.requestRenderAll();
    }
    _restoreDragChrome() {
      const s3 = this._dragChrome;
      if (!s3) return;
      this._dragChrome = null;
      s3.o.hasBorders = s3.borders;
      s3.o.hasControls = s3.controls;
      this.canvas.requestRenderAll();
    }
    // INK rect (scene coords): the box around an object's actual PIXELS.
    // Frames carry hug margins, padding, and effect headroom — snapping frame
    // edges left visible gaps at guides and between elements (Owen 9-07:
    // "ideally the one closest to the pixels — universal"). Renders the object
    // small (≤200px) and alpha-scans; falls back to the frame on any failure.
    // opts.shadow = true keeps text shadows IN the measure (they print) — the
    // export gate wants that; snapping/alignment keep the shadow-less default.
    _inkRectFor(o2, opts = {}) {
      const br2 = o2.getBoundingRect();
      try {
        const mult = Math.min(1, 420 / Math.max(br2.width, br2.height, 1));
        const c2 = o2.toCanvasElement({
          multiplier: mult,
          withoutShadow: !opts.shadow && !!(o2.isType && o2.isType("textbox"))
        });
        const w2 = c2.width, h2 = c2.height;
        if (!w2 || !h2) return br2;
        const d2 = c2.getContext("2d").getImageData(0, 0, w2, h2).data;
        let mnx = w2, mny = h2, mxx = -1, mxy = -1;
        for (let y2 = 0; y2 < h2; y2++) {
          const row = y2 * w2 * 4;
          for (let x2 = 0; x2 < w2; x2++) {
            if (d2[row + x2 * 4 + 3] > 8) {
              if (x2 < mnx) mnx = x2;
              if (x2 > mxx) mxx = x2;
              if (y2 < mny) mny = y2;
              if (y2 > mxy) mxy = y2;
            }
          }
        }
        if (mxx < 0) return br2;
        const kx = opts.shadow ? 1 / mult : br2.width / w2;
        const ky = opts.shadow ? 1 / mult : br2.height / h2;
        const ox = opts.shadow ? br2.left + br2.width / 2 - w2 / (2 * mult) : br2.left;
        const oy = opts.shadow ? br2.top + br2.height / 2 - h2 / (2 * mult) : br2.top;
        return {
          left: ox + mnx * kx,
          top: oy + mny * ky,
          width: (mxx - mnx + 1) * kx,
          height: (mxy - mny + 1) * ky
        };
      } catch (err) {
        return br2;
      }
    }
    // Snap the dragged object's edges/centers to board center/edges and other
    // objects' edges/centers — engage 6px, release 14px (screen-constant), a
    // held snap wins over switching candidates. Drag only (never scale/rotate).
    // ALL lines (self + targets) come from INK rects, not frames.
    _snapMove(e24) {
      const o2 = e24.target;
      if (!o2 || this._crop) return;
      if (e24.transform && e24.transform.action && e24.transform.action !== "drag") return;
      const z2 = this.canvas.getZoom() || 1;
      const ENGAGE = 3 / z2;
      const RELEASE = 6 / z2;
      const TAKEOVER = 2 / z2;
      if (!this._snapTargets || this._snapTargets.for !== o2) {
        const tV = [{ t: this.designW / 2, board: true, centerOnly: true }];
        const tH = [{ t: this.designH / 2, board: true, centerOnly: true }];
        for (const t2 of this._guides.v) tV.push({ t: t2, board: true });
        for (const t2 of this._guides.h) tH.push({ t: t2, board: true });
        const members = o2.getObjects ? new Set(o2.getObjects()) : null;
        for (const other of this.canvas.getObjects()) {
          if (other === o2 || other.excludeFromExport || members && members.has(other)) continue;
          const r2 = this._inkRectFor(other);
          for (const t2 of [r2.left, r2.left + r2.width / 2, r2.left + r2.width]) tV.push({ t: t2, board: false, a: r2.top, b: r2.top + r2.height });
          for (const t2 of [r2.top, r2.top + r2.height / 2, r2.top + r2.height]) tH.push({ t: t2, board: false, a: r2.left, b: r2.left + r2.width });
        }
        const fr2 = o2.getBoundingRect();
        const ink = this._inkRectFor(o2);
        const selfIns = {
          l: ink.left - fr2.left,
          t: ink.top - fr2.top,
          w: ink.width,
          h: ink.height
        };
        this._snapTargets = { for: o2, v: tV, h: tH, selfIns };
        this._snapState = { v: null, h: null };
      }
      o2.setCoords();
      const br2 = o2.getBoundingRect();
      const ins = this._snapTargets.selfIns || { l: 0, t: 0, w: br2.width, h: br2.height };
      const iL = br2.left + ins.l, iT = br2.top + ins.t;
      const selfV = [iL, iL + ins.w / 2, iL + ins.w];
      const selfH = [iT, iT + ins.h / 2, iT + ins.h];
      const axis = (targets, selfs, held) => {
        let best = null;
        let bd = null;
        for (const entry of targets) {
          for (let si2 = 0; si2 < 3; si2++) {
            if (entry.centerOnly && si2 !== 1) continue;
            const d2 = entry.t - selfs[si2];
            if (Math.abs(d2) <= ENGAGE && (bd === null || Math.abs(d2) < Math.abs(bd))) {
              bd = d2;
              best = { t: entry.t, si: si2, entry };
            }
          }
        }
        if (held) {
          const d2 = held.t - selfs[held.si];
          if (Math.abs(d2) <= RELEASE && (!best || Math.abs(bd) >= Math.abs(d2) - TAKEOVER)) return { snap: held, d: d2 };
        }
        return best ? { snap: best, d: bd } : null;
      };
      const rv = axis(this._snapTargets.v, selfV, this._snapState.v);
      const rh = axis(this._snapTargets.h, selfH, this._snapState.h);
      this._snapState.v = rv ? rv.snap : null;
      this._snapState.h = rh ? rh.snap : null;
      if (rv) o2.set("left", o2.left + rv.d);
      if (rh) o2.set("top", o2.top + rh.d);
      if (this._grid.on) {
        const step = this._grid.sizeIn * 50;
        const GRID_R = Math.min(step * 0.4, 4 / z2);
        const gridAxis = (selfs) => {
          let best = null;
          for (let si2 = 0; si2 < 3; si2++) {
            const t2 = Math.round(selfs[si2] / step) * step;
            const d2 = t2 - selfs[si2];
            if (Math.abs(d2) <= GRID_R && (!best || Math.abs(d2) < Math.abs(best))) best = d2;
          }
          return best;
        };
        if (!rv) {
          const d2 = gridAxis(selfV);
          if (d2 !== null) o2.set("left", o2.left + d2);
        }
        if (!rh) {
          const d2 = gridAxis(selfH);
          if (d2 !== null) o2.set("top", o2.top + d2);
        }
      }
      if (rv || rh || this._grid.on) o2.setCoords();
      const OVER = 12 / z2;
      let nbr = null;
      if (rv || rh) {
        const b2 = o2.getBoundingRect();
        nbr = { left: b2.left + ins.l, top: b2.top + ins.t, width: ins.w, height: ins.h };
      }
      const seg = (snap, lo2, hi2) => {
        const e25 = snap.entry;
        if (!e25 || e25.board) return { t: snap.t, board: true };
        return { t: snap.t, board: false, a: Math.min(e25.a, lo2) - OVER, b: Math.max(e25.b, hi2) + OVER };
      };
      const next = rv || rh ? {
        v: rv ? seg(rv.snap, nbr.top, nbr.top + nbr.height) : null,
        h: rh ? seg(rh.snap, nbr.left, nbr.left + nbr.width) : null
      } : null;
      if (JSON.stringify(next) !== JSON.stringify(this._snapGuides)) {
        this._snapGuides = next;
        this.canvas.requestRenderAll();
      }
    }
    // ── User guides (ruler-dragged) ─────────────────────────────────────────
    addGuide(axis, t2) {
      if (this._guides[axis].some((g2) => Math.abs(g2 - t2) < 0.5)) return;
      this._guides[axis].push(t2);
      this._record();
      this.canvas.requestRenderAll();
    }
    moveGuide(axis, i2, t2) {
      if (this._guides[axis][i2] === void 0) return;
      this._guides[axis][i2] = t2;
      this.canvas.requestRenderAll();
    }
    removeGuide(axis, i2) {
      this._guides[axis].splice(i2, 1);
      this._record();
      this.canvas.requestRenderAll();
    }
    // Nearest guide within tol (scene units): {axis, i} | null. v = vertical
    // lines (match by x), h = horizontal (match by y).
    hitGuide(pt2, tol) {
      let best = null;
      this._guides.v.forEach((t2, i2) => {
        const d2 = Math.abs(pt2.x - t2);
        if (d2 <= tol && (!best || d2 < best.d)) best = { axis: "v", i: i2, d: d2 };
      });
      this._guides.h.forEach((t2, i2) => {
        const d2 = Math.abs(pt2.y - t2);
        if (d2 <= tol && (!best || d2 < best.d)) best = { axis: "h", i: i2, d: d2 };
      });
      return best;
    }
    setGuideDrag(axis, t2) {
      this._guideDrag = t2 === null || t2 === void 0 ? null : { axis, t: t2 };
      this.canvas.requestRenderAll();
    }
    _drawUserGuides() {
      const has = this._guides.v.length || this._guides.h.length || this._guideDrag;
      if (!has) return;
      const ctx = this.canvas.contextContainer;
      const z2 = this.canvas.getZoom();
      const vpt = this.canvas.viewportTransform;
      ctx.save();
      ctx.lineWidth = 1;
      const line = (axis, t2, live) => {
        ctx.strokeStyle = live ? "rgba(139,92,246,0.55)" : "#8b5cf6";
        ctx.beginPath();
        if (axis === "v") {
          const x2 = Math.round(t2 * z2 + vpt[4]) + 0.5;
          ctx.moveTo(x2, vpt[5]);
          ctx.lineTo(x2, this.designH * z2 + vpt[5]);
        } else {
          const y2 = Math.round(t2 * z2 + vpt[5]) + 0.5;
          ctx.moveTo(vpt[4], y2);
          ctx.lineTo(this.designW * z2 + vpt[4], y2);
        }
        ctx.stroke();
      };
      this._guides.v.forEach((t2) => line("v", t2, false));
      this._guides.h.forEach((t2) => line("h", t2, false));
      if (this._guideDrag) line(this._guideDrag.axis, this._guideDrag.t, true);
      ctx.restore();
    }
    _drawSnapGuides() {
      const g2 = this._snapGuides;
      if (!g2) return;
      const ctx = this.canvas.contextContainer;
      const z2 = this.canvas.getZoom();
      const vpt = this.canvas.viewportTransform;
      ctx.save();
      ctx.strokeStyle = "#f43f9d";
      ctx.lineWidth = 1;
      ctx.setLineDash([6, 4]);
      if (g2.v) {
        const x2 = Math.round(g2.v.t * z2 + vpt[4]) + 0.5;
        ctx.beginPath();
        ctx.moveTo(x2, g2.v.board ? 0 : g2.v.a * z2 + vpt[5]);
        ctx.lineTo(x2, g2.v.board ? this.canvas.getHeight() : g2.v.b * z2 + vpt[5]);
        ctx.stroke();
      }
      if (g2.h) {
        const y2 = Math.round(g2.h.t * z2 + vpt[5]) + 0.5;
        ctx.beginPath();
        ctx.moveTo(g2.h.board ? 0 : g2.h.a * z2 + vpt[4], y2);
        ctx.lineTo(g2.h.board ? this.canvas.getWidth() : g2.h.b * z2 + vpt[4], y2);
        ctx.stroke();
      }
      ctx.restore();
    }
    get designWIn() {
      return this.designW / 50;
    }
    get designHIn() {
      return this.designH / 50;
    }
    // Board size in inches. Never moves existing art.
    setCanvasSize(wIn, hIn) {
      const w2 = Math.round(wIn * 50);
      const h2 = Math.round(hIn * 50);
      if (w2 === this.designW && h2 === this.designH) return;
      const prevW = this.designW, prevH = this.designH;
      this.designW = w2;
      this.designH = h2;
      this.lastCanvasFit = this._fitContentToBoard(prevW, prevH);
      this._syncBoardClip();
      this.fitToContainer();
      this._record();
      this._emit("canvassize");
    }
    // Workspace PREVIEW color only — the color paints the PAGE element (never
    // the fabric canvas, whose element now includes the apron), so the print
    // output stays transparent no matter what is set here. The topbar warns the
    // user of exactly that. null/'' = back to the transparency grid.
    setCanvasBackground(color) {
      this._boardBg = color || "";
      this._paintPage();
      this._record();
      this._emit("canvasbg");
    }
    get boardBg() {
      return this._boardBg || "";
    }
    _syncBoardClip() {
      this.canvas.clipPath = void 0;
    }
    get zoomPercent() {
      return Math.round(this.fitScale * this.userZoom * 100);
    }
    zoomBy(step) {
      this._cancelZoomAnim();
      this.userZoom = Math.min(4, Math.max(0.25, this.userZoom * step));
      this._applyZoom();
    }
    zoomFit() {
      this._cancelZoomAnim();
      this.userZoom = 1;
      this._applyZoom();
    }
    // SMOOTH zoom (Owen 9-16 "make the canvas zoom smoother, not so abrupt"):
    // discrete changes (± steps, Fit, a typed value, double-tap) GLIDE to the
    // target instead of snapping — ~220 ms, ease-out, interpolated in LOG space
    // so each frame is the same perceptual step (Canva's feel). `pin` runs after
    // every frame so the caller's anchor (viewport center, the tap point) stays
    // put through the glide. A new zoom input cancels an in-flight glide; the
    // continuous inputs (slider drag, pinch, wheel) stay direct. Honors
    // prefers-reduced-motion (instant).
    animateZoom(targetUserZoom, pin, duration = 220) {
      this._cancelZoomAnim();
      const to2 = Math.min(4, Math.max(0.25, targetUserZoom));
      const from = this.userZoom;
      const reduced = typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduced || Math.abs(Math.log(to2 / from)) < 1e-4) {
        this.userZoom = to2;
        this._applyZoom();
        if (pin) pin();
        return;
      }
      const lf = Math.log(from), lt2 = Math.log(to2);
      const t0 = performance.now();
      const step = (now) => {
        this.beginGesture();
        const p2 = Math.min(1, (now - t0) / duration);
        const e24 = 1 - Math.pow(1 - p2, 3);
        this.userZoom = p2 < 1 ? Math.exp(lf + (lt2 - lf) * e24) : to2;
        this._applyZoom();
        if (pin) pin();
        this._zoomAnim = p2 < 1 ? requestAnimationFrame(step) : null;
      };
      this._zoomAnim = requestAnimationFrame(step);
    }
    _cancelZoomAnim() {
      if (this._zoomAnim) {
        cancelAnimationFrame(this._zoomAnim);
        this._zoomAnim = null;
      }
    }
    // Absolute display percent (the pill's number) → userZoom, clamped to the
    // same 25%–400%-of-fit range as zoomBy. Mobile zoom slider (Owen 9-09).
    setZoomPercent(p2) {
      this._cancelZoomAnim();
      this.userZoom = Math.min(4, Math.max(0.25, p2 / 100 / this.fitScale));
      this._applyZoom();
    }
    // Measured ink overhang beyond fabric's text box (design units, ≥0 per
    // side). fabric allots each line fontSize×_fontSizeMult with the baseline
    // at (1 − _fontSizeFraction) of it — script faces (Kaushan) overshoot that
    // box on every side. measureText's actualBoundingBox matches the fillText
    // raster exactly, so containment is MEASURED, never modeled; well-behaved
    // fonts come back all-zero. charSpacing never moves vertical extents;
    // horizontal overhang is the EDGE glyphs' side bearings (interior glyphs
    // paint inside their neighbors' advances). Stroke (outline effect) paints
    // half its width past the glyph edge vertically — the horizontal share is
    // already covered by _hugWidth's strokeWidth×2 term.
    _inkOverhang(t2) {
      const out = { l: 0, r: 0, t: 0, b: 0 };
      const lines = t2.textLines || [];
      if (!lines.length) return out;
      const ctx = this._measureCtx = this._measureCtx || document.createElement("canvas").getContext("2d");
      ctx.font = (t2.fontStyle === "italic" ? "italic " : "") + (t2.fontWeight || 400) + " " + t2.fontSize + 'px "' + t2.fontFamily + '"';
      const impl = t2.fontSize * (t2._fontSizeMult || 1.13);
      const frac = t2._fontSizeFraction != null ? t2._fontSizeFraction : 0.222;
      const sw = 0;
      for (let i2 = 0; i2 < lines.length; i2++) {
        const line = lines[i2];
        if (!line) continue;
        const m = ctx.measureText(line);
        if (m.actualBoundingBoxAscent == null) return out;
        if (i2 === 0) out.t = Math.max(out.t, m.actualBoundingBoxAscent + sw - impl * (1 - frac));
        if (i2 === lines.length - 1) out.b = Math.max(out.b, m.actualBoundingBoxDescent + sw - impl * frac);
        out.l = Math.max(out.l, m.actualBoundingBoxLeft || 0);
        const spacingW = (t2.charSpacing || 0) / 1e3 * t2.fontSize * Math.max(0, line.length - 1);
        const fw = (t2.getLineWidth ? t2.getLineWidth(i2) : m.width) - spacingW;
        out.r = Math.max(out.r, (m.actualBoundingBoxRight || 0) - Math.min(fw, m.width));
      }
      out.t = Math.max(0, out.t);
      out.b = Math.max(0, out.b);
      out.l = Math.max(0, out.l);
      out.r = Math.max(0, out.r);
      return out;
    }
    // Snap a textbox's width to its content (widest unwrapped line + stroke), unless the
    // user has taken manual control of the width.
    _hugWidth(t2) {
      if (!t2 || !t2.isType || !t2.isType("textbox") || t2.__manualWidth) return;
      const center = t2.getRelativeCenterPoint();
      const prevShift = t2.__fxShift || { x: 0, y: 0 };
      const glyphCenter = center.add(this._objVecToParent(t2, prevShift));
      t2.set("width", DESIGN_UNITS * 10);
      t2.initDimensions();
      let extra = 2;
      const ov = this._inkOverhang(t2);
      if (!t2.__shape) {
        const ext = this._effectExtents(t2);
        ov.l += ext.l;
        ov.r += ext.r;
        ov.t += ext.t;
        ov.b += ext.b;
      } else {
        if (t2.shadow) extra += 2 * (Math.abs(t2.shadow.offsetX || 0) + (t2.shadow.blur || 0));
        if (t2.__effect === "echo") extra += 4 * Math.abs(this._echoParams(t2).dx);
      }
      extra += Math.max(t2.fontStyle === "italic" ? t2.fontSize * 0.3 : 0, ov.l + ov.r);
      const w2 = t2.calcTextWidth() + extra;
      t2.set("width", Math.max(20, w2));
      t2.initDimensions();
      if ((t2.charSpacing || 0) < 0 && t2.width > Math.max(20, w2)) t2.width = Math.max(20, w2);
      if (!t2.isEditing && !t2.__shape && (ov.t > 0.5 || ov.b > 0.5)) {
        t2.height += ov.t + ov.b;
        t2.__inkDy = ov.t;
      } else {
        t2.__inkDy = 0;
      }
      if (!t2.isEditing && !t2.__shape && (ov.l > 0.5 || ov.r > 0.5)) {
        const a2 = t2.textAlign || "left";
        t2.__inkDx = a2 === "right" || a2 === "justify-right" ? -ov.r : a2 === "center" || a2 === "justify-center" ? (ov.l - ov.r) / 2 : ov.l;
      } else {
        t2.__inkDx = 0;
      }
      t2.padding = t2.__shape && t2.shadow ? 4 + Math.round(Math.abs(t2.shadow.offsetY || 0) + (t2.shadow.blur || 0)) : 4;
      this._bgInflate(t2);
      if (t2.__gradFill) {
        if (t2.fill && typeof t2.fill === "object") t2.fill = this._inkFill(t2);
        if (t2.stroke && typeof t2.stroke === "object") t2.stroke = this._inkFill(t2);
        t2.dirty = true;
      }
      this._syncFxRender(t2);
      const shift = { x: t2.__inkDx || 0, y: !t2.isEditing && !t2.__shape && (ov.t > 0.5 || ov.b > 0.5) ? (ov.t - ov.b) / 2 : 0 };
      t2.__fxShift = shift;
      t2.setPositionByOrigin(glyphCenter.subtract(this._objVecToParent(t2, shift)), "center", "center");
      t2.setCoords();
      if (t2.__shape) this._shapeApply(t2);
    }
    // Object-space vector (object units) → parent-frame vector: scaled, then
    // rotated by the object's angle. Used to pin the glyph anchor across hugs.
    _objVecToParent(t2, v2) {
      const p2 = new N((v2.x || 0) * (t2.scaleX || 1) * (t2.flipX ? -1 : 1), (v2.y || 0) * (t2.scaleY || 1) * (t2.flipY ? -1 : 1));
      return p2.rotate(Ga.degreesToRadians(t2.angle || 0));
    }
    // Per-side extent (object units) an effect paints BEYOND the glyph ink:
    // drop/splice = the shadow copy (offset + blur), echo = the 2× trail.
    _effectExtents(t2) {
      const e24 = { l: 0, r: 0, t: 0, b: 0 };
      if (t2.__effect === "echo") {
        const { dx, dy } = this._echoParams(t2);
        e24.r += Math.max(0, 2 * dx);
        e24.l += Math.max(0, -2 * dx);
        e24.b += Math.max(0, 2 * dy);
        e24.t += Math.max(0, -2 * dy);
      } else if (t2.shadow) {
        const ox = t2.shadow.offsetX || 0, oy = t2.shadow.offsetY || 0, bl = t2.shadow.blur || 0;
        e24.r += Math.max(0, ox + bl);
        e24.l += Math.max(0, -ox + bl);
        e24.b += Math.max(0, oy + bl);
        e24.t += Math.max(0, -oy + bl);
      }
      return e24;
    }
    // Placement defaults must CONTRAST the board (Owen 9-08 "when adding an
    // effect it contrasts what it's applied to" — extended to Add Text and
    // element placement): ink on light boards, white on dark, slate when the
    // board sits between. Board only — a fresh object has no element context.
    _autoInk() {
      const bg = this._boardBg || "#ffffff";
      const h2 = /^#[0-9a-f]{6}$/i.test(bg) ? bg : "#ffffff";
      const lum = (0.2126 * parseInt(h2.slice(1, 3), 16) + 0.7152 * parseInt(h2.slice(3, 5), 16) + 0.0722 * parseInt(h2.slice(5, 7), 16)) / 255;
      if (lum < 0.35) return "#ffffff";
      if (lum > 0.62) return "#0f172a";
      return lum < 0.5 ? "#f1f5f9" : "#0f172a";
    }
    async addText(family = "Poppins") {
      await loadFont(family);
      const land = this._landing();
      const box = new fs("Your text", {
        fontFamily: family,
        fontWeight: 700,
        fontSize: 120,
        fill: this._autoInk(),
        textAlign: "center",
        width: this.designW * 0.7,
        left: land.x,
        // shared add-landing cascade (_landing)
        top: land.y,
        originX: "center",
        originY: "center"
      });
      this._hugWidth(box);
      this._styleSelection(box);
      this._attachTextHooks([box]);
      this.canvas.add(box);
      this._clampOntoBoard([box]);
      this.canvas.setActiveObject(box);
      this.canvas.requestRenderAll();
      return box;
    }
    // ── Text treatments (registry: src/text-treatments.js) ──────────────────
    // Build a FULLY STYLED textbox from a treatment part spec WITHOUT adding it
    // to the canvas. One code path serves placement (addTreatedText below) and
    // the gallery's pixel-true thumbnails (a detached box rendered onto a
    // StaticCanvas) — all styling routes through the same *_To appliers the
    // toolbar uses, so a placed treatment is indistinguishable from hand-built
    // text: editable, effects adjustable, serializes/restores identically.
    async buildTreatedText(spec) {
      const family = spec.family || "Poppins";
      await loadFont(family);
      try {
        await document.fonts.load(
          (spec.italic ? "italic " : "") + (spec.weight || 400) + ' 32px "' + family + '"'
        );
      } catch (e24) {
      }
      const box = new fs(spec.text || "Your text", {
        fontFamily: family,
        fontWeight: spec.weight || 400,
        fontStyle: spec.italic ? "italic" : "normal",
        fontSize: spec.fontSize || 120,
        lineHeight: spec.lineHeight || 1.16,
        charSpacing: spec.charSpacing || 0,
        fill: spec.fill || this._autoInk(),
        textAlign: "center",
        width: this.designW * 0.7,
        left: 0,
        top: 0,
        originX: "center",
        originY: "center"
      });
      const fx = spec.fx || {};
      if (fx.direction != null) box.__fxDirection = fx.direction;
      if (fx.offset != null) box.__fxOffset = fx.offset;
      if (fx.echo2 != null) box.__fxEcho2 = fx.echo2;
      if (fx.round != null) box.__fxRound = fx.round;
      if (fx.spread != null) box.__fxSpread = fx.spread;
      if (spec.gradient) this._setGradientTo(box, spec.gradient);
      if (spec.effect) this._applyTextEffectTo(box, spec.effect.kind, spec.effect.color, spec.effect.size);
      else this._hugWidth(box);
      if (spec.shape) this._setShapeTo(box, spec.shape.kind, spec.shape.amount);
      return box;
    }
    // Place a treatment: the main part plus an optional stacked `sub` part
    // (Canva's "font combinations" pairs) lands with the same cascade as Add
    // Text, clamped onto the board AS A UNIT, and selected. Pairs stay two
    // independent editable textboxes selected together — NOT a Group: canvas
    // double-click text editing inside a Group needs subTargetCheck this
    // canvas doesn't run, so grouping would strand the pair uneditable.
    async addTreatedText(preset) {
      const dark = this._autoInk() === "#ffffff";
      const partSpec = (p2) => dark && p2.dark ? { ...p2, ...p2.dark } : p2;
      const land = this._landing();
      const cx = land.x;
      const cy = land.y;
      const parts = [preset, ...preset.sub ? [preset.sub] : []];
      const boxes = [];
      for (const p2 of parts) {
        const box = await this.buildTreatedText(partSpec(p2));
        box.setPositionByOrigin(new N(cx + (p2.dx || 0), cy + (p2.dy || 0)), "center", "center");
        box.setCoords();
        this._styleSelection(box);
        this._attachTextHooks([box]);
        this.canvas.add(box);
        if (box.__shape) this._shapeApply(box);
        boxes.push(box);
      }
      this._clampOntoBoard(boxes);
      this.canvas.discardActiveObject();
      if (boxes.length === 1) {
        this.canvas.setActiveObject(boxes[0]);
      } else {
        const sel = new gs(boxes, { canvas: this.canvas });
        this.canvas.setActiveObject(sel);
        this._styleSelection(sel);
      }
      this.canvas.requestRenderAll();
      this._emit("selection");
      return boxes;
    }
    // Landing spot for anything ADDED from a pane — text, text pairs, shapes,
    // images (uploads, AI results, Pre-Made, My Designs). Board center, stepping
    // 40 design px down-right while an existing board object already sits on
    // the spot (within 24 px), wrapping after 8 steps; callers clamp onto the
    // board. One rule for every add (Owen 9-17 "if an element is added twice,
    // it adds them on the same place" — only text cascaded, on a blind counter
    // from 9-08; shapes and images stacked dead-center). Occupancy-based like
    // Canva: move the first one away and the next add lands centered again.
    // Paste/duplicate keep _placeCascade — they offset from the SOURCE object.
    _landing() {
      const STEP = 40, NEAR = 24, MAX = 8;
      const cx = this.designW / 2;
      let cy = this.designH / 2;
      const base = this._boardObjects().find((o2) => o2.__base);
      if (base) cy = Math.min(this.designH - 60, base.getCenterPoint().y + base.getScaledHeight() / 2 + 70);
      const centers = this._boardObjects().filter((o2) => !o2.__base).map((o2) => o2.getCenterPoint());
      const taken = (x2, y2) => centers.some((c2) => Math.abs(c2.x - x2) < NEAR && Math.abs(c2.y - y2) < NEAR);
      for (let i2 = 0; i2 <= MAX; i2++) {
        if (!taken(cx + i2 * STEP, cy + i2 * STEP)) return new N(cx + i2 * STEP, cy + i2 * STEP);
      }
      const n2 = centers.length % (MAX + 1);
      return new N(cx + n2 * STEP, cy + n2 * STEP);
    }
    // Shaped text edits FLAT: fabric's native caret is exact on flat text and a
    // moving glyph under the cursor is not. The shape re-applies on exit.
    _attachTextHooks(objs) {
      for (const t2 of objs) {
        if (!t2.isType || !t2.isType("textbox") || t2.__editHooked) continue;
        t2.__editHooked = true;
        t2.on("editing:entered", () => {
          if (t2.__shape) this._shapeFlatten(t2);
          t2.__editCenter = t2.getRelativeCenterPoint().add(this._objVecToParent(t2, t2.__fxShift || { x: 0, y: 0 }));
          if (t2.__effect === "background" || t2.__inkDy || t2.__inkDx) {
            this._hugWidth(t2);
            this._syncFxRender(t2);
          }
        });
        t2.on("editing:exited", () => {
          if (t2.__editCenter) {
            t2.setPositionByOrigin(t2.__editCenter, "center", "center");
            t2.__fxShift = { x: 0, y: 0 };
            t2.setCoords();
            t2.__editCenter = null;
          }
          if (t2.__shape) {
            this._shapeApply(t2);
          } else {
            this._hugWidth(t2);
            this._syncFxRender(t2);
          }
          this.canvas.requestRenderAll();
        });
      }
    }
    // Ink bounding box of an element's alpha (2px sampling, widened back by the
    // step). null when fully opaque-ish, empty, or unreadable (tainted canvas).
    _inkBBox(el2) {
      const w2 = el2.naturalWidth || el2.width;
      const h2 = el2.naturalHeight || el2.height;
      if (!w2 || !h2) return null;
      const cv = document.createElement("canvas");
      cv.width = w2;
      cv.height = h2;
      const ctx = cv.getContext("2d", { willReadFrequently: true });
      ctx.drawImage(el2, 0, 0);
      let d2;
      try {
        d2 = ctx.getImageData(0, 0, w2, h2).data;
      } catch (e24) {
        return null;
      }
      let minX = w2, minY = h2, maxX = -1, maxY = -1;
      const step = 2;
      for (let y2 = 0; y2 < h2; y2 += step) {
        const row = y2 * w2 * 4;
        for (let x2 = 0; x2 < w2; x2 += step) {
          if (d2[row + x2 * 4 + 3] > 8) {
            if (x2 < minX) minX = x2;
            if (x2 > maxX) maxX = x2;
            if (y2 < minY) minY = y2;
            if (y2 > maxY) maxY = y2;
          }
        }
      }
      if (maxX < 0) return null;
      minX = Math.max(0, minX - step);
      minY = Math.max(0, minY - step);
      maxX = Math.min(w2 - 1, maxX + step);
      maxY = Math.min(h2 - 1, maxY + step);
      return { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1, gw: w2, gh: h2 };
    }
    // Hug the ink at placement: meaningful transparent padding becomes an
    // initial CROP WINDOW instead of a server-side trim (Owen 9-05). Every
    // render of the source (original, ix/pc bg-remove, filters) then shares ONE
    // pixel grid — bg-remove preserves dimensions — so model/filter swaps can
    // never re-map the window (the trim-mismatch bug class).
    _applyInkCrop(img) {
      const bb = this._inkBBox(img._originalElement || img._element);
      if (!bb) return;
      if (bb.w > bb.gw * 0.98 && bb.h > bb.gh * 0.98) return;
      img.set({ cropX: bb.x, cropY: bb.y, width: bb.w, height: bb.h });
      img.__autoWindow = { x: bb.x / bb.gw, y: bb.y / bb.gh, w: bb.w / bb.gw, h: bb.h / bb.gh };
    }
    async addImageFromFile(file) {
      const url = URL.createObjectURL(file);
      const img = await ws.fromURL(url, { crossOrigin: "anonymous" });
      this._applyInkCrop(img);
      const s3 = this._placementScale(img);
      const land = this._landing();
      img.set({
        scaleX: s3,
        scaleY: s3,
        left: land.x,
        top: land.y,
        originX: "center",
        originY: "center"
      });
      img.__originalSrc = url;
      img.__fileName = file.name || "";
      this._styleSelection(img);
      this.canvas.add(img);
      this._clampOntoBoard([img]);
      this.canvas.setActiveObject(img);
      this.canvas.requestRenderAll();
      return img;
    }
    // Place an already-hosted image (QR handoff, uploaded-files library, imgix
    // renders of print formats) — no local blob involved.
    _placementScale(img) {
      return Math.min(this.designW, this.designH) * 0.7 / Math.max(img.width, img.height);
    }
    // Shrink-wrap the crop window to the CURRENT element's ink (Owen 9-05: on a
    // bg-remove model swap the bounding box "never goes past the original's
    // height or width — it can shrink the lesser dimension"). The window only
    // ever INTERSECTS with the new ink box (never grows), and the object's
    // center shifts by the window-center delta in scene space so the remaining
    // pixels stay exactly where they were on the board.
    shrinkWrapWindow(img) {
      const baseEl = img.__preRecolorEl || img._originalElement || img._element;
      const bb = this._inkBBox(baseEl);
      if (!bb) return;
      const sp = img.__stickerPad || 0;
      if (sp) {
        bb.w = bb.w + 2 * sp;
        bb.h = bb.h + 2 * sp;
      }
      const ox0 = img.cropX || 0;
      const oy0 = img.cropY || 0;
      const ow0 = img.width;
      const oh0 = img.height;
      let x0 = ox0;
      let y0 = oy0;
      let w0 = ow0;
      let h0 = oh0;
      const coreW = Math.max(1, bb.gw);
      const coreH = Math.max(1, bb.gh);
      const auto = img.__autoWindow;
      const isAuto = auto && Math.abs(x0 / coreW - auto.x) < 0.01 && Math.abs(y0 / coreH - auto.y) < 0.01 && Math.abs(w0 / coreW - auto.w) < 0.01 && Math.abs(h0 / coreH - auto.h) < 0.01;
      if (isAuto) {
        x0 = bb.x;
        y0 = bb.y;
        w0 = bb.w;
        h0 = bb.h;
      }
      const nx = Math.max(x0, bb.x);
      const ny = Math.max(y0, bb.y);
      const nw = Math.max(1, Math.min(x0 + w0, bb.x + bb.w) - nx);
      const nh = Math.max(1, Math.min(y0 + h0, bb.y + bb.h) - ny);
      if (isAuto) img.__autoWindow = { x: nx / coreW, y: ny / coreH, w: nw / coreW, h: nh / coreH };
      if (nw >= ow0 - 2 && nh >= oh0 - 2 && Math.abs(nx - ox0) < 2 && Math.abs(ny - oy0) < 2) return;
      const dcx = (nx + nw / 2 - (ox0 + ow0 / 2)) * img.scaleX;
      const dcy = (ny + nh / 2 - (oy0 + oh0 / 2)) * img.scaleY;
      const rad = (img.angle || 0) * Math.PI / 180;
      const cur = img.getRelativeCenterPoint();
      img.set({ cropX: nx, cropY: ny, width: nw, height: nh });
      img.setPositionByOrigin(
        new N(
          cur.x + dcx * Math.cos(rad) - dcy * Math.sin(rad),
          cur.y + dcx * Math.sin(rad) + dcy * Math.cos(rad)
        ),
        "center",
        "center"
      );
      if (img.__radius) this.setImageRadius(img.__radius, img);
      img.setCoords();
      img.dirty = true;
    }
    async addImageFromUrl(url, name) {
      const img = await ws.fromURL(url, { crossOrigin: "anonymous" });
      this._applyInkCrop(img);
      const s3 = this._placementScale(img);
      const land = this._landing();
      img.set({
        scaleX: s3,
        scaleY: s3,
        left: land.x,
        top: land.y,
        originX: "center",
        originY: "center"
      });
      img.__originalSrc = url;
      img.__fileName = name || url.split("/").pop().split("?")[0];
      this._styleSelection(img);
      this.canvas.add(img);
      this._clampOntoBoard([img]);
      this.canvas.setActiveObject(img);
      this.canvas.requestRenderAll();
      return img;
    }
    // Basic shapes (Elements tool): plain fabric primitives placed at canvas
    // center at ~35% of the design space, brand-ink fill (the line paints via
    // stroke — a zero-area line has nothing to fill). They serialize natively
    // in toDatalessJSON, so undo/redo, clone and export need nothing extra.
    // Elements v2 (plan: .claude/rules/elements-v2-plan.md): every shape is a
    // parametric fabric.Path from the elements.js registry — one geometry source
    // shared with the pane tiles, and one `roundedPolygonPath` gives circular
    // corner rounding on ANY polygon at any aspect. `__el` carries the rebuild
    // params (kind/w/h/round; it rides EditorCloneProps through history/save/
    // clone); the LOOK stays on native fabric props so old code paths and
    // exports need nothing.
    addShape(kind) {
      const def = ELEMENTS[kind];
      if (!def) return null;
      const S2 = Math.min(this.designW, this.designH) * 0.35;
      const INK = this._autoInk();
      const land = this._landing();
      const at2 = { left: land.x, top: land.y, originX: "center", originY: "center" };
      let obj;
      if (def.isLine) {
        obj = this._buildLineAssembly(kind, S2, at2);
      } else {
        const params = Object.assign({ w: S2, h: S2 * (def.aspect || 1) }, DEFAULT_EL_PARAMS(kind));
        obj = new Mo(buildElementPath(kind, params), Object.assign({ fill: INK }, at2));
        obj.__el = Object.assign({ kind }, params);
      }
      if (!obj) return null;
      this._styleSelection(obj);
      this.canvas.add(obj);
      this._clampOntoBoard([obj]);
      this.canvas.setActiveObject(obj);
      this.canvas.requestRenderAll();
      return obj;
    }
    // ── Line assembly (plan §3b, option A — Owen-approved) ────────────────────
    // A fabric GROUP of shaft (stroked Line: carries dash) + two cap Paths
    // (an arrowhead is a FILLED triangle — one object can't stroke its shaft
    // and fill its head). Two custom endpoint controls re-point/re-length the
    // line; weight stays constant; caps scale with weight, never with length.
    // All scaling is locked — a multi-select scale is normalized back into
    // `len` on release (_lineNormalize).
    _buildLineAssembly(kind, S2, at2) {
      const def = ELEMENTS[kind];
      const p2 = Object.assign({ kind, isLine: true, len: S2, color: this._autoInk() }, def.defaults);
      const shaft = new Bo([-p2.len / 2, 0, p2.len / 2, 0], { stroke: p2.color, strokeWidth: p2.weight, strokeLineCap: "butt" });
      shaft.__elRole = "shaft";
      const capS = new Mo("M0 0L0.01 0", { fill: p2.color, stroke: null, visible: false });
      capS.__elRole = "capStart";
      const capE = new Mo("M0 0L0.01 0", { fill: p2.color, stroke: null, visible: false });
      capE.__elRole = "capEnd";
      const g2 = new ca([shaft, capS, capE]);
      g2.__el = p2;
      this._lineRig(g2);
      this._rebuildLine(g2);
      g2.set({ left: at2.left, top: at2.top, originX: "center", originY: "center" });
      g2.setCoords();
      return g2;
    }
    // Identify the assembly's children by their __elRole tags (survive
    // serialization via EditorCloneProps) — never by index.
    _lineParts(g2) {
      const parts = {};
      for (const c2 of g2.getObjects()) if (c2.__elRole) parts[c2.__elRole] = c2;
      g2.__elParts = parts;
      return parts;
    }
    // Controls, locks and hit affordances. Control instances here are PER
    // OBJECT (a fresh controls dict) — the shared-prototype controls stay
    // untouched. Does not survive deserialize: _shapeReattach re-rigs.
    _lineRig(g2) {
      this._lineParts(g2);
      g2.set({
        lockScalingX: true,
        lockScalingY: true,
        hasBorders: false,
        // Canva lines show endpoint knobs, no frame
        padding: 8,
        // thin lines are hard to grab
        subTargetCheck: false,
        interactive: false
      });
      const editor = this;
      const knob = (ctx, left, top) => {
        ctx.save();
        ctx.beginPath();
        ctx.arc(left, top, 7, 0, Math.PI * 2);
        ctx.fillStyle = "#ffffff";
        ctx.strokeStyle = "#019AFF";
        ctx.lineWidth = 1.5;
        ctx.shadowColor = "rgba(15, 23, 42, 0.25)";
        ctx.shadowBlur = 4;
        ctx.fill();
        ctx.shadowBlur = 0;
        ctx.stroke();
        ctx.restore();
      };
      const mk = (endKey, xRel) => new q({
        x: xRel,
        y: 0,
        sizeX: 16,
        sizeY: 16,
        touchSizeX: 32,
        touchSizeY: 32,
        actionName: "lineEnd",
        cursorStyleHandler: () => "crosshair",
        render: knob,
        actionHandler: (eventData, transform, x2, y2) => editor._lineEndDrag(endKey, transform, x2, y2)
      });
      g2.controls = { lineStart: mk("start", -0.5), lineEnd: mk("end", 0.5) };
    }
    // Rebuild the children from __el params IN PLACE (weight/dash/caps/len),
    // center pinned. Cheap: three tiny objects, mutation + one layout pass.
    _rebuildLine(g2) {
      const p2 = g2.__el;
      const parts = g2.__elParts || this._lineParts(g2);
      if (!parts.shaft) return;
      const center = g2.getRelativeCenterPoint();
      const w2 = p2.weight || 9;
      const half = (p2.len || 100) / 2;
      parts.shaft.set({
        x1: -half + lineCapInset(p2.capStart, w2),
        y1: 0,
        x2: half - lineCapInset(p2.capEnd, w2),
        y2: 0,
        stroke: p2.color || "#0f172a",
        strokeWidth: w2,
        strokeDashArray: this._elDash(p2.dash, w2),
        strokeLineCap: p2.dash === "dotted" ? "round" : "butt"
      });
      for (const [role, endX, dir] of [["capStart", -half, -1], ["capEnd", half, 1]]) {
        const cap = parts[role];
        if (!cap) continue;
        const kind = p2[role];
        const d2 = lineCapPath(kind, endX, dir, w2);
        if (d2) {
          cap._setPath(d2, true);
          cap.set({ fill: p2.color || "#0f172a", visible: true });
        } else {
          cap.set({ visible: false });
        }
        cap.dirty = true;
        cap.setCoords();
      }
      parts.shaft.dirty = true;
      parts.shaft.setCoords();
      g2.triggerLayout();
      g2.setPositionByOrigin(center, "center", "center");
      g2.dirty = true;
      g2.setCoords();
    }
    // Param changes from the toolbar (color / weight / dash / per-end caps).
    setLineProps(g2, patch) {
      const p2 = g2 && g2.__el;
      if (!p2 || !p2.isLine) return;
      Object.assign(p2, patch);
      this._rebuildLine(g2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: g2 });
    }
    // Endpoint drag: the OTHER endpoint stays fixed in scene coords; center,
    // angle and len re-derive from fixed→pointer; children rebuild so caps and
    // weight never distort (Canva's line behavior).
    _lineEndDrag(endKey, transform, x2, y2) {
      const g2 = transform.target;
      const p2 = g2 && g2.__el;
      if (!p2) return false;
      if (!transform.__elFixed) {
        const m = g2.calcTransformMatrix();
        const fixedLocal = endKey === "start" ? new N(p2.len / 2, 0) : new N(-p2.len / 2, 0);
        transform.__elFixed = fixedLocal.transform(m);
      }
      const fixed = transform.__elFixed;
      const dx = x2 - fixed.x, dy = y2 - fixed.y;
      p2.len = Math.max(10, Math.hypot(dx, dy));
      let angle = Math.atan2(dy, dx) * 180 / Math.PI;
      if (endKey === "start") angle += 180;
      g2.set({ angle: (angle % 360 + 360) % 360 });
      this._rebuildLine(g2);
      g2.setPositionByOrigin(new N((fixed.x + x2) / 2, (fixed.y + y2) / 2), "center", "center");
      g2.setCoords();
      this.canvas.requestRenderAll();
      return true;
    }
    // EVEN DASH FIT for shapes (parity with the image contours, Owen 9-08
    // "cleaner dashed lines"): rescale the pattern so an INTEGER number of
    // dash+gap units closes the path — no ragged partial dash at the seam.
    // Path objects only (legacy migrated primitives keep the nominal pattern).
    _elApplyDash(o2) {
      const p2 = o2 && o2.__el;
      if (!p2) return;
      const style = p2.bstyle || "none";
      if (style !== "dashed" && style !== "longdash" && style !== "dotted" || !o2.path) return;
      let dash = this._elDash(style, p2.bweight || 12);
      try {
        const info = Ga.getPathSegmentsInfo(o2.path);
        const L2 = info[info.length - 1].length;
        const unit = dash[0] + dash[1];
        if (L2 > unit * 2) {
          const n2 = Math.max(3, Math.round(L2 / unit));
          const sc2 = L2 / (n2 * unit);
          dash = [dash[0] * sc2, dash[1] * sc2];
        }
      } catch (e24) {
      }
      o2.set("strokeDashArray", dash);
    }
    // Dash arrays are WEIGHT-RELATIVE (plan §5.8) — recompute on every weight
    // change or dashes go visually wrong as the weight moves. With
    // strokeUniform the dashes also stay constant under scale.
    _elDash(style, w2) {
      if (style === "dashed") return [w2 * 2.2, w2 * 1.6];
      if (style === "longdash") return [w2 * 4.6, w2 * 2.2];
      if (style === "dotted") return [0.01, w2 * 2];
      return null;
    }
    // Shape border: style (none/solid/dashed/longdash) + weight + color. State
    // lives in __el (bstyle/bweight/bcolor — the rebuild params); the LOOK is
    // native stroke props so serialization/export need nothing. strokeUniform
    // keeps the border from fattening under resize (crop-rect precedent).
    setElBorder(o2, patch) {
      const p2 = o2 && o2.__el;
      if (!p2) return;
      if (patch.style != null) p2.bstyle = patch.style;
      if (patch.weight != null) p2.bweight = patch.weight;
      if (patch.color != null) p2.bcolor = patch.color;
      this._elStrokeSync(o2);
      o2.dirty = true;
      o2.setCoords();
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: o2 });
    }
    // OUTWARD outline for shapes — ALWAYS (Owen 9-08 "the object changes
    // considerably when you apply transparent"): stroke at DOUBLE width so the
    // visible ring sits entirely outside the geometry, with the inner half
    // hidden by whichever mechanism the fill state allows:
    //   fill on  → paintFirst 'stroke' (the fill paints over the inner half)
    //   no fill  → an INVERTED clipPath of the same geometry erases it —
    //              shapes are exact vectors, so unlike uploads there's no
    //              edge/halo ambiguity to fight. Native, serializes.
    // Legacy migrated primitives (no registry builder/path) keep a centered
    // ring — the only fallback left.
    // ⚠ A fill OR geometry change must re-run this: setElBorder (any patch,
    // {} included) and _elRebuild both do.
    _elStrokeSync(o2) {
      const p2 = o2.__el;
      const style = p2.bstyle || "none";
      if (style === "none") {
        o2.set({ stroke: null, strokeDashArray: null, paintFirst: "fill" });
        o2.clipPath = void 0;
        this._elDetachRing(o2);
        o2.dirty = true;
        return;
      }
      const w2 = p2.bweight || 12;
      const hasFill = typeof o2.fill === "string" && !!o2.fill;
      const def = ELEMENTS[p2.kind];
      const canOffset = !!(def && def.build && o2.path);
      const eff = this.outlineTracksScale ? 1 : this._effScale(o2);
      const wDraw = w2 / eff;
      o2.set({
        stroke: p2.bcolor || "#0f172a",
        strokeWidth: hasFill || canOffset ? wDraw * 2 : wDraw,
        // 2w also sizes the bbox/cache to the outward band
        paintFirst: hasFill ? "stroke" : "fill",
        strokeUniform: false,
        strokeDashArray: this._elDash(style, wDraw),
        strokeLineCap: style === "dotted" ? "round" : "butt",
        strokeLineJoin: "round"
      });
      if (style !== "solid" && canOffset) {
        o2.clipPath = void 0;
        this._elBuildRing(o2, wDraw, style);
        this._elAttachRing(o2);
      } else {
        this._elDetachRing(o2);
        if (!hasFill && canOffset) {
          o2.clipPath = new Mo(buildElementPath(p2.kind, p2), {
            inverted: true,
            originX: "center",
            originY: "center",
            left: 0,
            top: 0
          });
        } else {
          o2.clipPath = void 0;
        }
        this._elApplyDash(o2);
      }
      o2.dirty = true;
    }
    // Sample the shape's own path at even arc length and push each sample out
    // along its normal — a numeric outward offset that works for EVERY builder
    // (polygons, ellipse, heart) with no per-shape math. Cached on __elRing.
    _elBuildRing(o2, w2, style) {
      const infos = Ga.getPathSegmentsInfo(o2.path);
      const total = infos[infos.length - 1].length;
      if (!total || !isFinite(total)) return this._elDetachRing(o2);
      const n2 = Math.max(32, Math.min(480, Math.round(total / 4)));
      const base = [];
      for (let i2 = 0; i2 < n2; i2++) {
        const pt2 = Ga.getPointOnPath(o2.path, total * i2 / n2, infos);
        base.push({ x: pt2.x, y: pt2.y });
      }
      const d2 = w2 / 2;
      const offsetBy = (sgn) => base.map((pt2, i2) => {
        const prev = base[(i2 - 1 + n2) % n2], next = base[(i2 + 1) % n2];
        let tx = next.x - prev.x, ty = next.y - prev.y;
        const L2 = Math.hypot(tx, ty) || 1;
        tx /= L2;
        ty /= L2;
        return { x: pt2.x + -ty * d2 * sgn, y: pt2.y + tx * d2 * sgn };
      });
      const bbox = (pts) => {
        let minX = Infinity, maxX = -Infinity;
        for (const pt2 of pts) {
          minX = Math.min(minX, pt2.x);
          maxX = Math.max(maxX, pt2.x);
        }
        return maxX - minX;
      };
      let ring2 = offsetBy(1);
      if (bbox(ring2) < bbox(base)) ring2 = offsetBy(-1);
      let len = 0;
      for (let i2 = 0; i2 < n2; i2++) {
        const a2 = ring2[i2], b2 = ring2[(i2 + 1) % n2];
        len += Math.hypot(b2.x - a2.x, b2.y - a2.y);
      }
      const patt = this._elDash(style, w2) || [w2, w2];
      const unit = patt[0] + patt[1];
      const k2 = Math.max(3, Math.round(len / unit));
      const sc2 = len / (k2 * unit);
      o2.__elRing = {
        pts: ring2,
        w: w2,
        dash: [patt[0] * sc2, patt[1] * sc2],
        cap: style === "dotted" ? "round" : "butt"
      };
    }
    _elAttachRing(o2) {
      if (o2.__elRingRender) return;
      o2.__elRingRender = true;
      o2._render = function(ctx) {
        const s3 = this.stroke;
        this.stroke = null;
        Mo.prototype._render.call(this, ctx);
        this.stroke = s3;
        const ring2 = this.__elRing;
        if (!ring2 || ring2.pts.length < 3) return;
        ctx.save();
        ctx.beginPath();
        const ox = this.pathOffset.x, oy = this.pathOffset.y;
        ctx.moveTo(ring2.pts[0].x - ox, ring2.pts[0].y - oy);
        for (let i2 = 1; i2 < ring2.pts.length; i2++) ctx.lineTo(ring2.pts[i2].x - ox, ring2.pts[i2].y - oy);
        ctx.closePath();
        ctx.lineWidth = ring2.w;
        ctx.strokeStyle = s3 || "#0f172a";
        ctx.lineJoin = "round";
        ctx.lineCap = ring2.cap;
        ctx.setLineDash(ring2.dash);
        ctx.stroke();
        ctx.restore();
      };
    }
    _elDetachRing(o2) {
      o2.__elRing = null;
      if (o2.__elRingRender) {
        delete o2._render;
        o2.__elRingRender = false;
      }
    }
    // Element transparency (0..100 slider → opacity). Native prop, serializes.
    setElOpacity(o2, pct) {
      if (!o2) return;
      o2.set("opacity", Math.min(1, Math.max(0, 1 - pct / 100)));
      o2.dirty = true;
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: o2 });
    }
    // Rebuild a shape's path from its __el params IN PLACE, center pinned.
    // fabric v7 Path._setPath(d, false) recomputes path/pathOffset/width/height
    // without repositioning; the explicit center re-pin covers builds whose
    // bbox changed (absorb-scale). Fires NO events — callers decide.
    _elRebuild(o2) {
      const p2 = o2 && o2.__el;
      const def = p2 && ELEMENTS[p2.kind];
      if (!def || !def.build || p2.isLine) return;
      const center = o2.getRelativeCenterPoint();
      o2._setPath(buildElementPath(p2.kind, p2));
      o2.setPositionByOrigin(center, "center", "center");
      if (p2.bstyle && p2.bstyle !== "none") this._elStrokeSync(o2);
      o2.dirty = true;
      o2.setCoords();
    }
    // Corner rounding (0..100) — a PARAM rebuild via roundedPolygonPath, never
    // rx/ry (fabric's native rounding is Rect-only and goes elliptical under
    // stretch — plan §3a). Only caps.corners shapes get the control.
    setElRound(o2, round) {
      const p2 = o2 && o2.__el;
      if (!p2) return;
      p2.round = Math.min(100, Math.max(0, round));
      this._elRebuild(o2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: o2 });
    }
    // Multi-select gotcha (plan §3b): fabric applies an ActiveSelection's scale
    // to MEMBERS regardless of member locks, baking it at discard. Any line
    // assembly with non-unit scale absorbs it: local endpoints map through the
    // scaled matrix (exact under rotation + non-uniform scale), then center/
    // angle/len re-derive, scale resets to 1, weight stays constant.
    _lineNormalize(g2) {
      const p2 = g2 && g2.__el;
      if (!p2 || !p2.isLine) return;
      const sx = g2.scaleX || 1, sy = g2.scaleY || 1;
      if (Math.abs(Math.abs(sx) - 1) < 1e-6 && Math.abs(Math.abs(sy) - 1) < 1e-6) return;
      const m = g2.calcTransformMatrix();
      const a2 = new N(-p2.len / 2, 0).transform(m);
      const b2 = new N(p2.len / 2, 0).transform(m);
      p2.len = Math.max(10, Math.hypot(b2.x - a2.x, b2.y - a2.y));
      if (this.outlineTracksScale) p2.weight = Math.max(1, Math.round((p2.weight || 9) * ((Math.abs(sx) + Math.abs(sy)) / 2)));
      g2.set({ scaleX: 1, scaleY: 1, angle: Math.atan2(b2.y - a2.y, b2.x - a2.x) * 180 / Math.PI });
      this._rebuildLine(g2);
      g2.setPositionByOrigin(new N((a2.x + b2.x) / 2, (a2.y + b2.y) / 2), "center", "center");
      g2.setCoords();
      this.canvas.requestRenderAll();
    }
    // Absorb non-unit scale into the builder's w/h and rebuild — the rounding
    // radius stays CIRCULAR at any aspect (the rx·scaleX class of problem,
    // plan §5.9). Runs on object:modified and on multi-select release (an
    // ActiveSelection bakes its transform onto members at discard, plan §5.4 —
    // fabric applies selection scale to members regardless of member locks).
    _elAbsorbScale(t2) {
      const p2 = t2 && t2.__el;
      if (!p2 || p2.isLine) return;
      const def = ELEMENTS[p2.kind];
      if (!def) return;
      if (!this.outlineTracksScale && (!def.caps || !def.caps.corners)) {
        if (p2.bstyle && p2.bstyle !== "none") this._elStrokeSync(t2);
        return;
      }
      const sx = t2.scaleX || 1, sy = t2.scaleY || 1;
      if (Math.abs(Math.abs(sx) - 1) < 1e-6 && Math.abs(Math.abs(sy) - 1) < 1e-6) return;
      if (this.outlineTracksScale && p2.bweight) p2.bweight = Math.max(1, Math.round(p2.bweight * ((Math.abs(sx) + Math.abs(sy)) / 2)));
      p2.w = Math.max(2, p2.w * Math.abs(sx));
      p2.h = Math.max(2, p2.h * Math.abs(sy));
      t2.set({ scaleX: sx < 0 ? -1 : 1, scaleY: sy < 0 ? -1 : 1 });
      this._elRebuild(t2);
      this.canvas.requestRenderAll();
    }
    // Swap an image object's pixels while preserving its DISPLAYED size AND its
    // derived geometry. The new render's intrinsic size differs from the old
    // element's (local blob vs w=2000 imgix render, trim differences), so
    // everything expressed in element pixels must re-project onto the new one:
    //   - a rotated-crop bake (__bake) is REPLAYED against the new element
    //   - the cropX/cropY window is carried over as FRACTIONS of the element
    //   - the corner-radius clipPath is rebuilt for the new window size
    // Skipping any of these leaves the crop window pointing at a wrong tiny
    // region of the new element (the filter-on-cropped-image bug).
    async replaceImageSource(obj, url) {
      const displayedW = obj.getScaledWidth();
      const oldEl = obj._originalElement || obj._element;
      const pad = obj.__stickerPad || 0;
      const oldW = (oldEl && (oldEl.naturalWidth || oldEl.width) || obj.width) - 2 * pad || 1;
      const oldH = (oldEl && (oldEl.naturalHeight || oldEl.height) || obj.height) - 2 * pad || 1;
      const frac = {
        x: (obj.cropX || 0) / oldW,
        y: (obj.cropY || 0) / oldH,
        w: Math.max(1, obj.width - 2 * pad) / oldW,
        h: Math.max(1, obj.height - 2 * pad) / oldH
      };
      obj.__stickerPad = 0;
      const hadWindow = (obj.cropX || 0) > 0.5 || (obj.cropY || 0) > 0.5 || frac.w < 0.999 || frac.h < 0.999;
      await obj.setSrc(url, { crossOrigin: "anonymous" });
      if (obj.__bake) obj.setElement(this._replayBake(obj));
      if (hadWindow || obj.__bake) {
        const el2 = obj._element;
        const nw = el2.naturalWidth || el2.width;
        const nh = el2.naturalHeight || el2.height;
        obj.set({
          cropX: frac.x * nw,
          cropY: frac.y * nh,
          width: Math.max(1, frac.w * nw),
          height: Math.max(1, frac.h * nh)
        });
      }
      if (obj.__recolorRepl || obj.__adjust && obj.__adjust.blur || obj.__sticker && obj.__sticker.w || obj.__filterCS && obj.__filter) {
        obj.__preRecolorEl = null;
        this._applyRecolor(obj);
      }
      if (obj.__radius) this.setImageRadius(obj.__radius, obj);
      const s3 = displayedW / obj.width;
      obj.set({ scaleX: s3, scaleY: s3 });
      obj.dirty = true;
      obj.setCoords();
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: obj });
    }
    // Adopt an applied AI edit. gram-edit normally returns the INPUT's framing,
    // so when the new render's aspect matches the old grid the whole geometry
    // carries over exactly like a bg-remove swap — crop window, rotated-crop
    // bake, and every effect survive (Owen 9-07 "edit with ai should not
    // destroy effects like outline or crop"). Only when the model genuinely
    // re-framed the art (the 9-07 pirate: box didn't resize, art cut off) does
    // the old window mean nothing — then reset to the fresh grid and re-hug
    // the ink, keeping displayed width; effect props re-derive either way.
    async adoptNewSource(img, url) {
      const oldEl = img._originalElement || img._element;
      const pad = img.__stickerPad || 0;
      const oldW = (oldEl && (oldEl.naturalWidth || oldEl.width) || img.width) - 2 * pad || 1;
      const oldH = (oldEl && (oldEl.naturalHeight || oldEl.height) || img.height) - 2 * pad || 1;
      try {
        const probe = await new Promise((res, rej) => {
          const i2 = new Image();
          i2.crossOrigin = "anonymous";
          i2.onload = () => res(i2);
          i2.onerror = () => rej(new Error("probe failed"));
          i2.src = url;
        });
        const sameFraming = Math.abs(probe.naturalWidth / probe.naturalHeight / (oldW / oldH) - 1) < 0.02;
        if (sameFraming) return await this.replaceImageSource(img, url);
      } catch (e24) {
      }
      const displayedW = img.getScaledWidth();
      img.__bake = null;
      img.__stickerPad = 0;
      await img.setSrc(url, { crossOrigin: "anonymous" });
      const el2 = img._element;
      img.set({
        cropX: 0,
        cropY: 0,
        width: el2.naturalWidth || el2.width,
        height: el2.naturalHeight || el2.height
      });
      this._applyInkCrop(img);
      img.__preRecolorEl = null;
      if (img.__recolorRepl || img.__sticker && img.__sticker.w || img.__adjust && (img.__adjust.blur || img.__adjust.vig) || img.__filterCS && img.__filter) {
        this._applyRecolor(img);
      }
      if (img.__radius) this.setImageRadius(img.__radius, img);
      const s3 = displayedW / img.width;
      img.set({ scaleX: s3, scaleY: s3 });
      img.dirty = true;
      img.setCoords();
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: img });
    }
    // Re-run a stored rotated-crop bake (obj.__bake) against the image's CURRENT
    // element. The bake is one affine map (source px → baked-canvas px) recorded
    // relative to the source's natural width at bake time; a differently-sized
    // render of the same source just scales the whole map by k.
    _replayBake(obj) {
      const bake = obj.__bake;
      const el2 = obj._element;
      const k2 = (el2.naturalWidth || el2.width || bake.natW) / bake.natW;
      const cnv = document.createElement("canvas");
      cnv.width = Math.max(1, Math.round(bake.W * k2));
      cnv.height = Math.max(1, Math.round(bake.H * k2));
      const ctx = cnv.getContext("2d");
      const [a2, b2, c2, d2, e24, f2] = bake.m;
      ctx.setTransform(a2, b2, c2, d2, e24 * k2, f2 * k2);
      ctx.drawImage(el2, 0, 0);
      return cnv;
    }
    // Canva-style selection chrome: round white corner handles, brand border,
    // rotate handle floated below the box.
    _styleSelection(obj) {
      if (obj.isType && obj.isType("textbox", "i-text", "text")) obj.hiddenTextareaContainer = this.canvas.wrapperEl;
      obj.set({
        transparentCorners: false,
        cornerStyle: "circle",
        cornerColor: "#ffffff",
        cornerStrokeColor: "#9db4c8",
        cornerSize: 11,
        touchCornerSize: 32,
        // finger-sized handle hit areas (Owen 9-09 mobile sensitivity)
        borderColor: "#66baff",
        borderScaleFactor: 1.5,
        padding: 4,
        // Rotation snaps at the clock points — 0/45/90/… (12:00, 1:30, 3:00,
        // Owen 9-09). Native fabric snap: within 5° it locks to the point,
        // everywhere else rotation stays perfectly free.
        snapAngle: 45,
        snapThreshold: 5
      });
      const mtr = obj.controls && obj.controls.mtr;
      if (mtr) {
        mtr.y = 0.5;
        mtr.offsetY = ROTATE_KNOB_R + 16;
        mtr.withConnection = false;
        mtr.sizeX = ROTATE_KNOB_R * 2;
        mtr.sizeY = ROTATE_KNOB_R * 2;
        mtr.touchSizeX = 44;
        mtr.touchSizeY = 44;
        mtr.render = renderRotateControl;
        mtr.cursorStyleHandler = () => ROTATE_CURSOR;
      }
      for (const k2 of ["tl", "tr", "bl", "br"]) {
        const c2 = obj.controls && obj.controls[k2];
        if (!c2) continue;
        c2.render = renderCornerControl(k2);
        c2.cursorStyleHandler = cornerCursorHandler(k2);
      }
      obj.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false });
      if (obj.__el && !obj.__el.isLine) {
        const elDef = ELEMENTS[obj.__el.kind];
        if (elDef && elDef.caps && elDef.caps.stretch) {
          obj.setControlsVisibility({ mt: true, mb: true, ml: true, mr: true });
        }
      }
      obj.setCoords();
    }
    activeText() {
      const list = this.activeTexts();
      return list[0] || null;
    }
    // Multi-text selections (Owen 9-09): an ActiveSelection whose members are
    // ALL textboxes counts as a text selection — text tools show and every
    // applier below fans out over the members (Canva). Reads (font/size shown
    // in the toolbar) use the FIRST member.
    activeTexts() {
      const obj = this.canvas.getActiveObject();
      if (!obj) return [];
      if (obj.isType && obj.isType("textbox")) return [obj];
      if (obj instanceof gs) {
        const m = obj.getObjects().filter((x2) => x2.isType && x2.isType("textbox") && !x2.__locked);
        if (m.length) return m;
      }
      return [];
    }
    activeSelection() {
      const obj = this.canvas.getActiveObject();
      return obj instanceof gs ? obj : null;
    }
    // Select every object (Ctrl/Cmd+A).
    selectAll() {
      const objs = this.canvas.getObjects().filter((o2) => o2.selectable !== false && o2.evented !== false && !o2.__locked);
      if (!objs.length) return;
      this.canvas.discardActiveObject();
      if (objs.length === 1) {
        this.canvas.setActiveObject(objs[0]);
      } else {
        const sel = new gs(objs, { canvas: this.canvas });
        this.canvas.setActiveObject(sel);
        this._styleSelection(sel);
      }
      this.canvas.requestRenderAll();
      this._emit("selection");
    }
    // Group the current multi-selection into a real fabric Group (⌘G, Owen
    // 9-08 Canva parity). Members are removed from the canvas first — a Group
    // adopts objects at their scene transforms, and leaving the originals on
    // canvas would double-render them.
    groupSelection() {
      const sel = this.activeSelection();
      if (!sel) return null;
      const objs = sel.getObjects();
      if (objs.length < 2) return null;
      this.canvas.discardActiveObject();
      for (const o2 of objs) this.canvas.remove(o2);
      const g2 = new ca(objs);
      this.canvas.add(g2);
      this.canvas.setActiveObject(g2);
      this._styleSelection(g2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: g2 });
      this._emit("selection");
      return g2;
    }
    // Dissolve the active Group back into its members (⌘⇧G). Group.removeAll()
    // restores each child's scene transform; the members come back as a
    // multi-selection, ready to re-group or move together once more.
    // Dissolve a group INTO ITS PARENT — a nested group's parent group, or the
    // canvas at top level — never blindly to the canvas root. Blind
    // `canvas.remove(g)` no-ops for a nested group (it's not a canvas child), so
    // the empty group was orphaned inside its parent and the survivors ejected
    // to the top level (agent 9-08: silent layer-tree corruption on nested
    // delete/ungroup). fabric's remove/add convert coordinate spaces:
    // parent.remove(g) bakes g's scene transform onto it, g.removeAll() restores
    // its children to scene coords, parent.add() converts scene→parent-local
    // (verified: _enterGroup applies inv(parent)×child, so members stay put).
    _dissolveGroupIntoParent(g2) {
      const parent = g2.group && g2.group instanceof ca && !(g2.group instanceof gs) ? g2.group : this.canvas;
      parent.remove(g2);
      const members = g2.removeAll();
      for (const m of members) {
        parent.add(m);
        m.setCoords();
      }
      return { parent, members };
    }
    ungroupSelection() {
      const g2 = this.canvas.getActiveObject();
      if (!g2 || !(g2 instanceof ca) || g2 instanceof gs) return null;
      if (g2.__el) return null;
      const { parent, members } = this._dissolveGroupIntoParent(g2);
      if (parent === this.canvas) {
        const ns2 = new gs(members, { canvas: this.canvas });
        this.canvas.setActiveObject(ns2);
        this._styleSelection(ns2);
      } else {
        this.canvas.setActiveObject(parent);
        this._styleSelection(parent);
      }
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: this.canvas.getActiveObject() });
      this._emit("selection");
      return members;
    }
    // Align the members of a multi-selection to each other (Owen 9-05): edges or
    // centers meet the selection's own bounding box. Objects are temporarily
    // released to top level so the shifts happen in exact scene coordinates
    // (child coords are group-relative and skew once the group is transformed),
    // then re-selected.
    alignSelection(pos) {
      const sel = this.activeSelection();
      if (!sel) return;
      const objs = sel.getObjects();
      if (objs.length < 2) return;
      this.canvas.discardActiveObject();
      const rects = objs.map((o2) => (o2.setCoords(), { o: o2, r: this._inkRectFor(o2) }));
      const L2 = Math.min(...rects.map((x2) => x2.r.left));
      const T2 = Math.min(...rects.map((x2) => x2.r.top));
      const R3 = Math.max(...rects.map((x2) => x2.r.left + x2.r.width));
      const B2 = Math.max(...rects.map((x2) => x2.r.top + x2.r.height));
      for (const { o: o2, r: r2 } of rects) {
        let dx = 0;
        let dy = 0;
        if (pos === "left") dx = L2 - r2.left;
        else if (pos === "centerH") dx = (L2 + R3) / 2 - (r2.left + r2.width / 2);
        else if (pos === "right") dx = R3 - (r2.left + r2.width);
        else if (pos === "top") dy = T2 - r2.top;
        else if (pos === "middle") dy = (T2 + B2) / 2 - (r2.top + r2.height / 2);
        else if (pos === "bottom") dy = B2 - (r2.top + r2.height);
        if (dx || dy) {
          o2.set({ left: o2.left + dx, top: o2.top + dy });
          o2.setCoords();
        }
      }
      const ns2 = new gs(objs, { canvas: this.canvas });
      this.canvas.setActiveObject(ns2);
      this._styleSelection(ns2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: ns2 });
      this._emit("selection");
    }
    // Distribute the members of a multi-selection with EQUAL GAPS along one
    // axis (Owen 9-05). The outermost items stay put; everything between is
    // respaced. Needs 3+ members (2 have nothing to distribute). Same
    // release-to-scene-coords pattern as alignSelection.
    distributeSelection(axis) {
      const sel = this.activeSelection();
      if (!sel) return;
      const objs = sel.getObjects();
      if (objs.length < 3) return;
      this.canvas.discardActiveObject();
      const rects = objs.map((o2) => (o2.setCoords(), { o: o2, r: this._inkRectFor(o2) }));
      const horiz = axis === "h";
      const pos = horiz ? "left" : "top";
      const size = horiz ? "width" : "height";
      rects.sort((a2, b2) => a2.r[pos] - b2.r[pos]);
      const first = rects[0];
      const last = rects[rects.length - 1];
      const span = last.r[pos] + last.r[size] - first.r[pos];
      const total = rects.reduce((s3, x2) => s3 + x2.r[size], 0);
      const gap = (span - total) / (rects.length - 1);
      let cursor = first.r[pos];
      for (const x2 of rects) {
        const d2 = cursor - x2.r[pos];
        if (d2) {
          x2.o.set(pos, x2.o[pos] + d2);
          x2.o.setCoords();
        }
        cursor += x2.r[size] + gap;
      }
      const ns2 = new gs(objs, { canvas: this.canvas });
      this.canvas.setActiveObject(ns2);
      this._styleSelection(ns2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: ns2 });
      this._emit("selection");
    }
    // Prefix every line with "• ", preserving the caret (each insertion at or
    // before the caret shifts it by 2).
    _applyBullets(t2) {
      const lines = t2.text.split("\n");
      const editing = typeof t2.selectionStart === "number";
      const sel = editing ? t2.selectionStart : t2.text.length;
      let idx = 0;
      let shift = 0;
      let changed = false;
      const out = lines.map((l2) => {
        const lineStart = idx;
        idx += l2.length + 1;
        if (l2.startsWith("\u2022 ")) return l2;
        changed = true;
        if (sel >= lineStart) shift += 2;
        return "\u2022 " + l2;
      });
      if (!changed) return;
      t2.set("text", out.join("\n"));
      if (editing) {
        t2.selectionStart = t2.selectionEnd = Math.min(t2.text.length, sel + shift);
      }
    }
    // Bulleted-list MODE: while on, every line (and every new line typed) keeps
    // a "• " prefix; off strips the prefixes.
    setBullets(on2) {
      const t2 = this.activeText();
      if (!t2) return;
      t2.__bullets = !!on2;
      if (on2) {
        this._applyBullets(t2);
      } else {
        t2.set("text", t2.text.split("\n").map((l2) => l2.startsWith("\u2022 ") ? l2.slice(2) : l2).join("\n"));
      }
      this._hugWidth(t2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: t2 });
    }
    activeImage() {
      const obj = this.canvas.getActiveObject();
      return obj && obj.isType("image") ? obj : null;
    }
    setTextProp(props) {
      const list = this.activeTexts();
      if (!list.length) return;
      for (const obj of list) {
        obj.set(props);
        this._hugWidth(obj);
      }
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: list[0] });
    }
    // Family switches keep the RENDERED WIDTH constant: text that was 4in wide
    // in Inter stays 4in wide in a wider face — the font size rescales and the
    // height/box follow naturally.
    setFontKeepWidth(props) {
      const list = this.activeTexts();
      if (!list.length) return;
      for (const t2 of list) {
        const w0 = t2.calcTextWidth();
        t2.set(props);
        this._hugWidth(t2);
        const w1 = t2.calcTextWidth();
        if (w0 > 1 && w1 > 1 && Math.abs(w1 - w0) > 0.5) {
          t2.set("fontSize", Math.min(600, Math.max(8, t2.fontSize * (w0 / w1))));
          this._hugWidth(t2);
        }
      }
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: list[0] });
    }
    // ── Gradient fill (2-stop linear) ────────────────────────────────────────
    // Descriptor lives in __gradFill = { a, b, angle } (plain JSON — survives
    // snapshots; 0° = left→right, 90° = top→bottom). __baseFill stays a HEX (the
    // stop mix) so every luminance/contrast consumer keeps working; the real
    // fabric Gradient is derived at apply time via _inkFill. The shaped painter
    // substitutes its own CanvasGradient (fabric Gradients only paint through
    // fabric's native renderer).
    _inkFill(t2) {
      if (!t2.__gradFill) return t2.__baseFill;
      const g2 = t2.__gradFill;
      const rad = (g2.angle != null ? g2.angle : 90) * Math.PI / 180;
      const c2 = Math.cos(rad);
      const s3 = Math.sin(rad);
      const w2 = t2.width || 1;
      const h2 = t2.height || 1;
      const L2 = (Math.abs(c2) * w2 + Math.abs(s3) * h2) / 2;
      return new ko({
        type: "linear",
        gradientUnits: "pixels",
        coords: { x1: w2 / 2 - c2 * L2, y1: h2 / 2 - s3 * L2, x2: w2 / 2 + c2 * L2, y2: h2 / 2 + s3 * L2 },
        colorStops: [
          { offset: 0, color: g2.a },
          { offset: 1, color: g2.b }
        ]
      });
    }
    // Same gradient as a CanvasGradient for the shaped painter. ctx is in object
    // space (origin = center); the line spans the ink box along the angle.
    // ox/oy shift it for the per-glyph fillText fallback (each glyph translates
    // the ctx, which would otherwise restart the gradient per letter).
    _canvasGradient(t2, ctx, ox = 0, oy = 0) {
      const g2 = t2.__gradFill;
      const rad = (g2.angle != null ? g2.angle : 90) * Math.PI / 180;
      const c2 = Math.cos(rad);
      const s3 = Math.sin(rad);
      const L2 = (Math.abs(c2) * t2.width + Math.abs(s3) * t2.height) / 2;
      const grad = ctx.createLinearGradient(-c2 * L2 - ox, -s3 * L2 - oy, c2 * L2 - ox, s3 * L2 - oy);
      grad.addColorStop(0, g2.a);
      grad.addColorStop(1, g2.b);
      return grad;
    }
    // Set/clear the gradient, then reapply the current effect so fill/stroke
    // route consistently (hollow/splice carry the ink in the STROKE).
    // Gangs across an all-text multi-selection like every other text prop
    // (Owen 9-09 — parked until _setGradientTo landed with text-treatments).
    setTextGradient(desc) {
      const gang = this.activeTexts();
      if (!gang.length) return;
      for (const t2 of gang) this._setGradientTo(t2, desc);
    }
    // Target-explicit body (text treatments style DETACHED boxes through the
    // same path — no parallel effect logic anywhere).
    _setGradientTo(t2, desc) {
      t2.__gradFill = desc || null;
      if (desc) {
        const mix = (i2) => Math.round((parseInt(desc.a.slice(i2, i2 + 2), 16) + parseInt(desc.b.slice(i2, i2 + 2), 16)) / 2);
        t2.__baseFill = "#" + [1, 3, 5].map((i2) => mix(i2).toString(16).padStart(2, "0")).join("");
      }
      this._applyTextEffectTo(t2, t2.__effect || "none", t2.__effectColor, t2.__effectSize);
    }
    // ── Text effects ──────────────────────────────────────────────────────────
    // One-click effects built from stroke/shadow/fill combos, sized to the font.
    // The base fill is remembered so switching effects (or None) always restores
    // the text's own color. Multi-object effects (Echo, Background) are out of
    // scope for this layer.
    applyTextEffect(key, color, size) {
      const list = this.activeTexts();
      for (const t2 of list) this._applyTextEffectTo(t2, key, color, size);
    }
    // Target-explicit body — ONE code path for the gang loop above AND the
    // text treatments styling DETACHED boxes (thumbnails): render/history
    // fires are gated on t.canvas.
    _applyTextEffectTo(t2, key, color, size) {
      if (!t2) return;
      if (t2.__baseFill == null) t2.__baseFill = t2.fill;
      const em = t2.fontSize;
      const reset = {
        stroke: null,
        strokeWidth: 0,
        shadow: null,
        fill: this._inkFill(t2),
        // gradient-aware: __baseFill, or the derived Gradient
        paintFirst: "fill"
      };
      const effSize = Math.max(0, Math.min(100, size != null ? size : t2.__effectSize != null ? t2.__effectSize : 12));
      const s3 = effSize / 100;
      const oSc = this._effScale(t2);
      const keepStroke = this.outlineTracksScale && key === "outline" && t2.__effect === "outline" && t2.__effectSize != null && effSize === t2.__effectSize && t2.strokeWidth > 0;
      const outlineW = keepStroke ? t2.strokeWidth : Math.max(0.5, 2 * effSize / oSc);
      const hollowW = Math.max(1, em * (0.01 + 0.07 * s3));
      const EFFECTS = {
        none: reset,
        outline: {
          ...reset,
          stroke: color || "#ffffff",
          strokeWidth: outlineW,
          paintFirst: "stroke",
          strokeLineJoin: "round"
        },
        hollow: {
          ...reset,
          fill: "rgba(0,0,0,0)",
          stroke: color || this._inkFill(t2),
          strokeWidth: hollowW,
          strokeLineJoin: "round"
        },
        drop: {
          ...reset,
          // Canva's Drop control set (Owen 9-05): Direction (degrees, 0 = right,
          // 90 = down), Offset (0-100 distance), Blur (0-100), Transparency
          // (0-100 shadow opacity) — per-object settings. Defaults 45/50/0/100
          // (Owen 9-05): crisp full-opacity shadow, the retro merch look.
          shadow: (() => {
            const dir = (t2.__fxDirection != null ? t2.__fxDirection : 45) * Math.PI / 180;
            const dist = em * 0.2 * ((t2.__fxOffset != null ? t2.__fxOffset : 50) / 100);
            return new Bn({
              color: color || "#0f172a",
              blur: 0,
              offsetX: dist * Math.cos(dir),
              offsetY: dist * Math.sin(dir)
            });
          })()
        },
        // 'glow' REMOVED (Owen 9-08) — a blur-only effect can't print. Legacy
        // glow objects keep their serialized shadow until any effect reapplies.
        splice: {
          ...reset,
          fill: "rgba(0,0,0,0)",
          stroke: this._inkFill(t2),
          // the hollow letter keeps the TEXT's color (gradient included)
          strokeWidth: hollowW,
          strokeLineJoin: "round",
          // Effect color paints the OFFSET COPY (the new element), not the
          // outline (Owen 9-05). Direction + Offset shared with Drop/Echo.
          shadow: (() => {
            const dir = (t2.__fxDirection != null ? t2.__fxDirection : 45) * Math.PI / 180;
            const dist = em * 0.2 * ((t2.__fxOffset != null ? t2.__fxOffset : 50) / 100);
            return new Bn({
              color: color || "#94a3b8",
              blur: 0,
              offsetX: dist * Math.cos(dir),
              offsetY: dist * Math.sin(dir)
            });
          })()
        }
      };
      t2.__effect = key === "none" ? null : key;
      if (key === "echo" && t2.__fxEcho2 == null) t2.__fxEcho2 = this._echoDerive(color || t2.__baseFill || "#0f172a");
      t2.__effectColor = color || null;
      t2.__effectSize = Math.round(effSize);
      t2.set(EFFECTS[key] || reset);
      this._hugWidth(t2);
      if (t2.canvas) {
        this.canvas.requestRenderAll();
        this.canvas.fire("object:modified", { target: t2 });
      }
      this._syncFxRender(t2);
    }
    // ── Echo (Canva reference, Owen 9-05): two trailing copies of the text at
    // 1x and 2x the offset. Each copy carries its OWN SOLID color (Owen 9-05) —
    // copy 1 (nearest) = __effectColor, copy 2 = __fxEcho2 — no alpha fade, so
    // an assigned color prints exactly as picked. Needs multiple paint passes
    // (fabric shadow can't repeat), so flat text gets an instance _render
    // override and the shaped renderer runs echo passes itself.
    _echoColors(t2) {
      const c1 = t2.__effectColor || "#0f172a";
      return [c1, t2.__fxEcho2 || this._echoDerive(c1)];
    }
    // Copy-2 seed: copy 1 pulled halfway toward white (dark ink) or slate (light
    // ink), so a fresh echo still reads as a receding trail before any assigning.
    _echoDerive(hex3) {
      const p2 = (i2) => parseInt(hex3.slice(i2, i2 + 2), 16) || 0;
      const [r2, g2, b2] = [p2(1), p2(3), p2(5)];
      const light = (r2 * 299 + g2 * 587 + b2 * 114) / 1e3 > 145;
      const to2 = light ? [71, 85, 105] : [255, 255, 255];
      const mix = (v2, tv) => Math.round(v2 + (tv - v2) * 0.5).toString(16).padStart(2, "0");
      return "#" + mix(r2, to2[0]) + mix(g2, to2[1]) + mix(b2, to2[2]);
    }
    _echoParams(t2) {
      const dir = (t2.__fxDirection != null ? t2.__fxDirection : 45) * Math.PI / 180;
      const dist = t2.fontSize * 0.2 * ((t2.__fxOffset != null ? t2.__fxOffset : 50) / 100);
      return { dx: dist * Math.cos(dir), dy: dist * Math.sin(dir) };
    }
    // Background plate geometry: padding from Spread, radius from Roundness.
    _bgParams(t2) {
      const em = t2.fontSize;
      const pad = em * (0.08 + 0.4 * ((t2.__fxSpread != null ? t2.__fxSpread : 50) / 100));
      const round = (t2.__fxRound != null ? t2.__fxRound : 22) / 100;
      const alpha = 1;
      return { pad, round, alpha, color: t2.__effectColor || "#0f172a" };
    }
    // Inflate a FLAT textbox so the background plate fits inside the cached
    // object box; the renderer recenters the text within it. Skipped while
    // editing (the caret math assumes uninflated dims — bg returns on exit).
    _bgInflate(t2) {
      if (t2.__effect !== "background" || t2.__shape || t2.isEditing) {
        t2.__bgTextH = null;
        return;
      }
      const { pad } = this._bgParams(t2);
      t2.__bgTextH = t2.height;
      t2.width += pad * 2;
      t2.height += pad * 2;
      t2.setCoords();
    }
    _syncFxRender(t2) {
      if (!t2 || !t2.isType || !t2.isType("textbox")) return;
      const wantsFlat = (t2.__effect === "echo" || t2.__effect === "background" && !t2.isEditing || (t2.__inkDy || 0) > 0 || (t2.__inkDx || 0) !== 0) && !t2.__shapeRender;
      if (wantsFlat && !t2.__fxRender) {
        const editor = this;
        t2.__fxRender = true;
        t2._render = function(ctx) {
          editor._renderFxFlat(this, ctx);
        };
      } else if (!wantsFlat && t2.__fxRender) {
        t2.__fxRender = false;
        if (!t2.__shapeRender) delete t2._render;
      }
      t2.dirty = true;
    }
    _drawBgPlate(t2, ctx, w2, h2) {
      const { round, alpha, color } = this._bgParams(t2);
      const r2 = Math.min(w2, h2) / 2 * round;
      ctx.save();
      ctx.globalAlpha *= alpha;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.roundRect(-w2 / 2, -h2 / 2, w2, h2, r2);
      ctx.fill();
      ctx.restore();
    }
    _renderFxFlat(t2, ctx) {
      const proto = fs.prototype._render;
      const ink = t2.__inkDy || 0;
      const inkX = t2.__inkDx || 0;
      if (t2.__effect === "background") {
        this._drawBgPlate(t2, ctx, t2.width, t2.height);
        const dy = ink + (t2.__bgTextH != null ? (t2.height - t2.__bgTextH) / 2 : 0);
        ctx.save();
        ctx.translate(inkX, dy);
        proto.call(t2, ctx);
        ctx.restore();
        return;
      }
      if (t2.__effect === "echo") {
        const { dx, dy } = this._echoParams(t2);
        const [echo1, echo2] = this._echoColors(t2);
        const origFill = t2.fill;
        for (const [mult, color] of [[2, echo2], [1, echo1]]) {
          ctx.save();
          ctx.translate(dx * mult + inkX, dy * mult + ink);
          t2.fill = color;
          proto.call(t2, ctx);
          ctx.restore();
        }
        t2.fill = origFill;
        ctx.save();
        ctx.translate(inkX, ink);
        proto.call(t2, ctx);
        ctx.restore();
        return;
      }
      ctx.save();
      ctx.translate(inkX, ink);
      proto.call(t2, ctx);
      ctx.restore();
    }
    // ── Text shapes: Curve / Wave / Bulge — OWN glyph engine ─────────────────
    // fabric's text-on-path scrambled glyphs (its path-length estimate drifts at
    // low curvature and Textbox.initDimensions fights the path — the 9-05 "curve
    // breaks easily" report). Shapes are now rendered by US: per-glyph placement
    // is computed analytically from measured advances and drawn in an
    // instance-level _render override; the bounding box is derived FROM the
    // placements, so it is exact by construction — no ink scans, no path
    // plumbing, no drift at any amount.
    // While the user edits (editing:entered) the text renders FLAT with fabric's
    // native caret; the shape re-applies on exit. Effects (stroke/shadow/fill)
    // are plain object props and compose with every shape.
    // Gangs across an all-text multi-selection like font/color/effects/gradient
    // (Owen 9-09 — shapes were the last non-ganged text prop).
    setShape(kind, amount, preview) {
      const gang = this.activeTexts();
      if (!gang.length) return;
      this._shapeAdjusting = !!preview;
      for (const t2 of gang) {
        this._setShapeTo(t2, kind, amount);
        this.canvas.fire("object:modified", { target: t2 });
      }
      this.canvas.requestRenderAll();
    }
    // Target-explicit body (treatments shape detached boxes through it too).
    _setShapeTo(t2, kind, amount) {
      const a2 = Math.max(-100, Math.min(100, Math.round(amount) || 0));
      t2.__shape = !kind || kind === "none" || !a2 ? null : { kind, amount: a2 };
      if (t2.__shape) this._shapeApply(t2);
      else this._shapeFlatten(t2);
    }
    // The ANCHOR is the layout ORIGIN — the mid-line baseline, where the curve
    // ring is tangent — not the frame: Canva pins the base of the circle, so the
    // middle of the text never moves while the arch/ring grows around it (Owen
    // 9-07 video "notice the base remains pinned"). __shapeInkOffset = origin −
    // frame center in object coords (serialized — restore needs it to anchor).
    // Offsets carry o:1 for the origin semantics; a stored offset WITHOUT the
    // flag is a legacy frame-center pin from before 9-07 — _shapeApply converts
    // it in place, jump-free, on the first re-apply.
    // ⚠ FRAME: both _inkScenePoint and _anchorInk work in PARENT space (the
    // group's local frame when t.group is set, scene otherwise). fabric 7's
    // getCenterPoint() is SCENE-space but setPositionByOrigin() writes PARENT
    // coords — mixing them displaced a grouped shaped text by exactly the
    // group's center vector on every restore, compounding until it left the
    // board (breaker 9-08). Parent space is also what t.angle/t.scaleX are
    // relative to, so the offset rotation math is only correct here.
    _inkScenePoint(t2) {
      const off = t2.__shapeInkOffset || { x: 0, y: 0 };
      const rad = (t2.angle || 0) * Math.PI / 180;
      const ox = off.x * t2.scaleX, oy = off.y * t2.scaleY;
      const c2 = t2.getRelativeCenterPoint();
      return {
        x: c2.x + ox * Math.cos(rad) - oy * Math.sin(rad),
        y: c2.y + ox * Math.sin(rad) + oy * Math.cos(rad)
      };
    }
    _anchorInk(t2, inkScene, newOff) {
      const rad = (t2.angle || 0) * Math.PI / 180;
      const ox = newOff.x * t2.scaleX, oy = newOff.y * t2.scaleY;
      const target2 = {
        x: inkScene.x - (ox * Math.cos(rad) - oy * Math.sin(rad)),
        y: inkScene.y - (ox * Math.sin(rad) + oy * Math.cos(rad))
      };
      t2.setPositionByOrigin(target2, "center", "center");
      t2.__shapeInkOffset = newOff;
      t2.setCoords();
    }
    // Ascent/descent of the current font — locates the FLAT text's mid-line
    // baseline (the shape anchor) relative to its frame center.
    _flatProbe(t2) {
      const ctx = this._measureCtx = this._measureCtx || document.createElement("canvas").getContext("2d");
      ctx.font = (t2.fontStyle === "italic" ? "italic " : "") + (t2.fontWeight || 400) + " " + t2.fontSize + 'px "' + t2.fontFamily + '"';
      const probe = ctx.measureText("Mgj");
      return {
        asc: probe.actualBoundingBoxAscent || t2.fontSize * 0.88,
        desc: probe.actualBoundingBoxDescent || t2.fontSize * 0.26
      };
    }
    // Measure one line's glyphs (advances include charSpacing; the trailing
    // glyph drops the spacing so the line hugs like flat text).
    _shapeMeasure(t2, ctx) {
      ctx.font = (t2.fontStyle === "italic" ? "italic " : "") + (t2.fontWeight || 400) + " " + t2.fontSize + 'px "' + t2.fontFamily + '"';
      const spacing = (t2.charSpacing || 0) / 1e3 * t2.fontSize;
      const probe = ctx.measureText("Mgj");
      const asc = probe.actualBoundingBoxAscent || t2.fontSize * 0.88;
      const desc = probe.actualBoundingBoxDescent || t2.fontSize * 0.26;
      const lines = t2.textLines.map((line) => {
        const glyphs = [];
        let w2 = 0, wb = 0;
        const chars = [...line];
        chars.forEach((ch, i2) => {
          const raw = ctx.measureText(ch).width;
          const adv = raw + (i2 < chars.length - 1 ? spacing : 0);
          glyphs.push({ ch, adv });
          w2 += adv;
          wb += raw;
        });
        return { glyphs, w: w2, wb };
      });
      return { lines, asc, desc };
    }
    // Per-glyph placements + exact ink bbox for the current shape. Coordinates
    // are baseline-centered per line; the caller recenters on the union bbox.
    _shapeLayout(t2) {
      const { kind, amount } = t2.__shape;
      const a2 = amount / 100;
      const ctx = this._measureCtx = this._measureCtx || document.createElement("canvas").getContext("2d");
      const { lines, asc, desc } = this._shapeMeasure(t2, ctx);
      const lineH = t2.fontSize * (t2.lineHeight || 1.16);
      const n2 = lines.length;
      const placed = [];
      let mnx = Infinity, mny = Infinity, mxx = -Infinity, mxy = -Infinity;
      const pad = (t2.strokeWidth || 0) + (t2.fontStyle === "italic" ? t2.fontSize * 0.12 : 0);
      lines.forEach((line, li2) => {
        const W2 = Math.max(1, line.w);
        const baseY = (li2 - (n2 - 1) / 2) * lineH;
        let scales = null, scaledW = W2;
        if (kind === "bulge" || kind === "arcup" || kind === "arclo") {
          let s0 = 0;
          scales = line.glyphs.map((g2) => {
            const u2 = (s0 + g2.adv / 2) / W2 - 0.5;
            s0 += g2.adv;
            return Math.max(0.35, 1 + a2 * 0.65 * Math.cos(Math.PI * u2));
          });
          scaledW = line.glyphs.reduce((sum, g2, i2) => sum + g2.adv * scales[i2], 0);
        }
        let s3 = 0, sScaled = 0;
        line.glyphs.forEach((g2, gi2) => {
          const mid = s3 + g2.adv / 2;
          const u2 = mid / W2 - 0.5;
          let x2 = mid - W2 / 2, y2 = 0, rot = 0, sc2 = 1;
          if (kind === "curve") {
            const cg = curveGlyph(a2, curveRadius(a2, t2.fontSize), mid - W2 / 2);
            const midLine = (asc - desc) / 2;
            x2 = cg.x - midLine * Math.sin(cg.rot);
            y2 = cg.y + midLine * Math.cos(cg.rot) - midLine;
            rot = cg.rot;
          } else if (kind === "wave") {
            x2 = mid - W2 / 2;
            const wg = waveGlyph(a2, W2, t2.fontSize, x2);
            y2 = wg.y;
            rot = wg.rot;
          } else if (kind === "angle") {
            x2 = mid - W2 / 2;
            y2 = x2 * Math.tan(angleTheta(a2));
          } else if (kind === "bulge") {
            sc2 = scales[gi2];
            x2 = sScaled + g2.adv * sc2 / 2 - scaledW / 2;
          } else if (kind === "arcup" || kind === "arclo") {
            sc2 = scales[gi2];
            x2 = sScaled + g2.adv * sc2 / 2 - scaledW / 2;
            if (kind === "arclo") y2 = (sc2 - 1) * asc;
          }
          placed.push({ ch: g2.ch, adv: g2.adv, x: x2, y: y2 + baseY, rot, sc: sc2 });
          const hw = (g2.adv / 2 + pad) * sc2;
          const top = (asc + pad) * sc2, bot = (desc + pad) * sc2;
          const cos = Math.cos(rot), sin = Math.sin(rot);
          for (const [gx, gy] of [[-hw, -top], [hw, -top], [-hw, bot], [hw, bot]]) {
            const px = x2 + gx * cos - gy * sin;
            const py = y2 + baseY + gx * sin + gy * cos;
            if (px < mnx) mnx = px;
            if (px > mxx) mxx = px;
            if (py < mny) mny = py;
            if (py > mxy) mxy = py;
          }
          s3 += g2.adv;
          if (scales) sScaled += g2.adv * scales[gi2];
        });
      });
      if (!placed.length) {
        mnx = mny = -1;
        mxx = mxy = 1;
      }
      let circle = null;
      if (kind === "curve" && lines.length) {
        circle = { R: curveRadius(amount / 100, t2.fontSize), up: amount > 0, asc };
      }
      const line0W = lines.length ? Math.max(1, lines[0].w) : 1;
      return { placed, circle, line0W, bbox: { l: mnx, t: mny, r: mxx, b: mxy }, asc, desc };
    }
    _shapeApply(t2) {
      if (!t2 || !t2.isType || !t2.isType("textbox") || !t2.__shape) return;
      if (t2.isEditing) return;
      const editor = this;
      if (t2.width < DESIGN_UNITS * 10) {
        t2.set("width", DESIGN_UNITS * 10);
        t2.initDimensions();
      }
      if (t2.__shapeInkOffset == null) {
        const { asc, desc } = this._flatProbe(t2);
        t2.__shapeInkOffset = { x: 0, y: (asc - desc) / 2, o: 1 };
      }
      const legacy = !t2.__shapeInkOffset.o;
      const inkScene = this._inkScenePoint(t2);
      const italic = t2.fontStyle === "italic";
      const weight = parseInt(t2.fontWeight, 10) || (t2.fontWeight === "bold" ? 700 : 400);
      const entry = getFontSync(t2.fontFamily, weight, italic);
      if (!entry) {
        ensureFontBinary(t2.fontFamily, weight, italic).then((e24) => {
          if (e24 && t2.__shape && !t2.isEditing && this.canvas.getObjects().includes(t2)) {
            this._shapeApply(t2);
            this.canvas.requestRenderAll();
          }
        });
      }
      const layout = entry ? this._shapeLayoutOutline(t2, entry) : this._shapeLayout(t2);
      const { bbox } = layout;
      if (t2.__effect === "echo") {
        const { dx, dy } = this._echoParams(t2);
        bbox.l += Math.min(0, dx * 2);
        bbox.r += Math.max(0, dx * 2);
        bbox.t += Math.min(0, dy * 2);
        bbox.b += Math.max(0, dy * 2);
      }
      if (t2.__effect === "background") {
        const { pad } = this._bgParams(t2);
        bbox.l -= pad;
        bbox.r += pad;
        bbox.t -= pad;
        bbox.b += pad;
      }
      t2.__curveRing = null;
      const m = t2.fontSize * 0.04;
      t2.width = bbox.r - bbox.l + 2 * m;
      t2.height = bbox.b - bbox.t + 2 * m;
      const cx = (bbox.l + bbox.r) / 2;
      const cy = (bbox.t + bbox.b) / 2;
      if (layout.rawPaths) {
        const m2 = new DOMMatrix().translate(-cx, -cy);
        t2.__shapePath = layout.rawPaths.map((p2) => {
          const q2 = new Path2D();
          q2.addPath(p2, m2);
          return q2;
        });
        t2.__shapeLayout = null;
      } else {
        t2.__shapeLayout = layout.placed.map((g2) => ({ ...g2, x: g2.x - cx, y: g2.y - cy }));
        t2.__shapePath = null;
      }
      if (!t2.__shapeRender) {
        t2.__shapeRender = true;
        t2.__fxRender = false;
        t2._render = function(ctx) {
          editor._renderShaped(this, ctx);
        };
      }
      t2.padding = t2.shadow ? 4 + Math.round(Math.abs(t2.shadow.offsetY || 0) + (t2.shadow.blur || 0)) : 4;
      if (layout.circle) {
        const { R: R3, up } = layout.circle;
        t2.__curveRing = { r: R3, x: -cx, y: (up ? R3 : -R3) - cy };
      }
      t2.__angleEnds = null;
      if (t2.__shape.kind === "angle" && layout.line0W) {
        const slope = Math.tan(angleTheta(t2.__shape.amount / 100));
        const hw = layout.line0W / 2;
        t2.__angleEnds = [
          { x: -hw - cx, y: -hw * slope - cy },
          { x: hw - cx, y: hw * slope - cy }
        ];
      }
      this._anchorInk(t2, inkScene, legacy ? { x: 0, y: 0 } : { x: -cx, y: -cy, o: 1 });
      if (legacy) t2.__shapeInkOffset = { x: -cx, y: -cy, o: 1 };
      t2.dirty = true;
    }
    _shapeFlatten(t2) {
      if (!t2) return;
      const hadAnchor = t2.__shapeInkOffset != null;
      const originPin = hadAnchor && !!t2.__shapeInkOffset.o;
      const inkScene = this._inkScenePoint(t2);
      if (t2.__shapeRender) {
        delete t2._render;
        t2.__shapeRender = false;
      }
      t2.__shapeLayout = null;
      t2.__shapePath = null;
      t2.dirty = true;
      this._syncFxRender(t2);
      this._hugWidth(t2);
      if (originPin) {
        const { asc, desc } = this._flatProbe(t2);
        this._anchorInk(t2, inkScene, { x: 0, y: (asc - desc) / 2 });
      } else {
        t2.setPositionByOrigin(inkScene, "center", "center");
      }
      t2.__shapeInkOffset = null;
      t2.setCoords();
    }
    // Outline layout: real glyph béziers from the font binary, every point
    // pushed through the envelope warp. Exact kerning from the font tables;
    // the bbox comes from the warped points themselves. Underline/linethrough
    // become warped quads in the same path.
    _shapeLayoutOutline(t2, entry) {
      const { kind, amount } = t2.__shape;
      const a2 = amount / 100;
      const fontSize = t2.fontSize;
      const spacing = (t2.charSpacing || 0) / 1e3 * fontSize;
      const lineH = fontSize * (t2.lineHeight || 1.16);
      const lines = t2.textLines.map((line) => layoutLine(entry, line, fontSize, spacing));
      lines.forEach((line) => {
        line.baseW = line.width - spacing * Math.max(0, line.glyphs.length - 1);
      });
      const n2 = lines.length;
      const rawPaths = [];
      let rawPath = null;
      const pad = (t2.strokeWidth || 0) + 1;
      let mnx = Infinity, mny = Infinity, mxx = -Infinity, mxy = -Infinity;
      const track2 = (x2, y2) => {
        if (x2 - pad < mnx) mnx = x2 - pad;
        if (x2 + pad > mxx) mxx = x2 + pad;
        if (y2 - pad < mny) mny = y2 - pad;
        if (y2 + pad > mxy) mxy = y2 + pad;
      };
      lines.forEach((line, li2) => {
        const W2 = Math.max(1, line.width);
        const baseY = (li2 - (n2 - 1) / 2) * lineH;
        const wp = (x2, y2) => {
          const [wx, wy] = warpPoint(kind, a2, W2, fontSize, x2 - W2 / 2, y2);
          track2(wx, wy + baseY);
          return [wx, wy + baseY];
        };
        const glyphMapper = (g2) => {
          if (kind !== "curve") return wp;
          const midLine = (line.ascent - line.descent) / 2;
          const ax = g2.pen + g2.adv / 2 - W2 / 2;
          const { x: x0, y: y0, rot } = curveGlyph(a2, curveRadius(a2, fontSize), ax);
          const cos = Math.cos(rot), sin = Math.sin(rot);
          return (x2, y2) => {
            const dx = x2 - W2 / 2 - ax;
            const dy = y2 + midLine;
            const wx = x0 + dx * cos - dy * sin;
            const wy = y0 + dx * sin + dy * cos;
            track2(wx, wy + baseY);
            return [wx, wy + baseY];
          };
        };
        for (const g2 of line.glyphs) {
          const wpg = glyphMapper(g2);
          rawPath = new Path2D();
          rawPaths.push(rawPath);
          const subs = [];
          let sub = null;
          for (const c2 of g2.commands) {
            if (c2.type === "M") {
              sub = { m: c2, segs: [] };
              subs.push(sub);
            } else if (c2.type === "Z") {
              if (sub) sub.z = true;
            } else if (sub) {
              sub.segs.push(c2);
            }
          }
          const eps = 0.01;
          for (const sp of subs) {
            if (!sp.segs.length) continue;
            const last = sp.segs[sp.segs.length - 1];
            if (last.type === "L" && Math.abs(last.x - sp.m.x) < eps && Math.abs(last.y - sp.m.y) < eps) {
              sp.segs.pop();
            }
            const [mx, my] = wpg(sp.m.x, sp.m.y);
            rawPath.moveTo(mx, my);
            for (const c2 of sp.segs) {
              if (c2.type === "L") {
                const [x2, y2] = wpg(c2.x, c2.y);
                rawPath.lineTo(x2, y2);
              } else if (c2.type === "C") {
                const [x1, y1] = wpg(c2.x1, c2.y1);
                const [x2, y2] = wpg(c2.x2, c2.y2);
                const [x3, y3] = wpg(c2.x, c2.y);
                rawPath.bezierCurveTo(x1, y1, x2, y2, x3, y3);
              } else if (c2.type === "Q") {
                const [x1, y1] = wpg(c2.x1, c2.y1);
                const [x2, y2] = wpg(c2.x, c2.y);
                rawPath.quadraticCurveTo(x1, y1, x2, y2);
              }
            }
            rawPath.closePath();
          }
          const deco = (yEm, hEm) => {
            const y0 = fontSize * yEm;
            const y1 = y0 + Math.max(1, fontSize * hEm);
            const x0 = g2.pen, x1 = g2.pen + g2.adv;
            const p0 = wpg(x0, y0), p1 = wpg(x1, y0), p2 = wpg(x1, y1), p3 = wpg(x0, y1);
            rawPath.moveTo(p0[0], p0[1]);
            rawPath.lineTo(p1[0], p1[1]);
            rawPath.lineTo(p2[0], p2[1]);
            rawPath.lineTo(p3[0], p3[1]);
            rawPath.closePath();
          };
          if (t2.underline) deco(0.1, 0.065);
          if (t2.linethrough) deco(-0.31, 0.065);
        }
      });
      if (mnx === Infinity) {
        mnx = mny = -1;
        mxx = mxy = 1;
      }
      let circle = null;
      if (kind === "curve" && lines.length) {
        circle = { R: curveRadius(a2, fontSize), up: a2 > 0, asc: lines[0].ascent };
      }
      const line0W = lines.length ? Math.max(1, lines[0].width) : 1;
      return { rawPaths, circle, line0W, bbox: { l: mnx, t: mny, r: mxx, b: mxy } };
    }
    // Draws the shaped text. ctx arrives in object space (origin = center).
    // Fill/stroke/shadow/paintFirst come from the object, so every effect
    // composes. Outline engine: one warped Path2D. Fallback engine: per-glyph
    // fillText placements.
    _renderShaped(t2, ctx) {
      if (t2.__shapePath) {
        ctx.save();
        if (t2.__effect === "background") this._drawBgPlate(t2, ctx, t2.width, t2.height);
        if (t2.__effect === "echo") {
          const { dx, dy } = this._echoParams(t2);
          const [echo1, echo2] = this._echoColors(t2);
          for (const [mult, color] of [[2, echo2], [1, echo1]]) {
            ctx.save();
            ctx.translate(dx * mult, dy * mult);
            ctx.fillStyle = color;
            for (const gp of t2.__shapePath) ctx.fill(gp);
            ctx.restore();
          }
        }
        ctx.lineJoin = t2.strokeLineJoin || "miter";
        let fill2 = t2.fill && t2.fill !== "rgba(0,0,0,0)" ? t2.fill : null;
        const strokeW2 = t2.strokeWidth || 0;
        let stroke2 = t2.stroke && strokeW2 ? t2.stroke : null;
        if (t2.__gradFill) {
          const grad = this._canvasGradient(t2, ctx);
          if (fill2 && typeof fill2 !== "string") fill2 = grad;
          if (stroke2 && typeof stroke2 !== "string") stroke2 = grad;
        }
        if (fill2) ctx.fillStyle = fill2;
        if (stroke2) {
          ctx.strokeStyle = stroke2;
          ctx.lineWidth = strokeW2;
        }
        if (stroke2 && t2.paintFirst === "stroke") for (const gp of t2.__shapePath) ctx.stroke(gp);
        if (fill2) for (const gp of t2.__shapePath) ctx.fill(gp);
        if (stroke2 && t2.paintFirst !== "stroke") for (const gp of t2.__shapePath) ctx.stroke(gp);
        ctx.restore();
        return;
      }
      const placed = t2.__shapeLayout;
      if (!placed) return;
      ctx.save();
      ctx.font = (t2.fontStyle === "italic" ? "italic " : "") + (t2.fontWeight || 400) + " " + t2.fontSize + 'px "' + t2.fontFamily + '"';
      ctx.textAlign = "center";
      ctx.textBaseline = "alphabetic";
      ctx.lineJoin = t2.strokeLineJoin || "miter";
      const fill = t2.fill && t2.fill !== "rgba(0,0,0,0)" ? t2.fill : null;
      const strokeW = t2.strokeWidth || 0;
      const stroke = t2.stroke && strokeW ? t2.stroke : null;
      const gradAt = (ox, oy) => t2.__gradFill ? this._canvasGradient(t2, ctx, ox, oy) : null;
      if (fill) ctx.fillStyle = typeof fill === "string" ? fill : gradAt(0, 0) || "#0f172a";
      if (stroke) {
        ctx.strokeStyle = typeof stroke === "string" ? stroke : gradAt(0, 0) || "#0f172a";
        ctx.lineWidth = strokeW;
      }
      const deco = (g2, yEm, hEm) => {
        const y2 = t2.fontSize * yEm;
        ctx.fillRect(-g2.adv / 2, y2, g2.adv, Math.max(1, t2.fontSize * hEm));
      };
      const glyphPass = (mode) => {
        for (const g2 of placed) {
          if (g2.ch === " " && !t2.underline && !t2.linethrough) continue;
          ctx.save();
          ctx.translate(g2.x, g2.y);
          if (g2.rot) ctx.rotate(g2.rot);
          if (g2.sc !== 1) ctx.scale(g2.sc, g2.sc);
          if (t2.__gradFill) {
            const lg = gradAt(g2.x, g2.y);
            if (fill && typeof fill !== "string") ctx.fillStyle = lg;
            if (stroke && typeof stroke !== "string") ctx.strokeStyle = lg;
          }
          if (mode === "stroke") {
            ctx.strokeText(g2.ch, 0, 0);
          } else {
            if (fill) ctx.fillText(g2.ch, 0, 0);
            if (fill || stroke) {
              if (!fill) ctx.fillStyle = stroke;
              if (t2.underline) deco(g2, 0.1, 0.065);
              if (t2.linethrough) deco(g2, -0.31, 0.065);
            }
          }
          ctx.restore();
        }
      };
      if (stroke && t2.paintFirst === "stroke") glyphPass("stroke");
      glyphPass("fill");
      if (stroke && t2.paintFirst !== "stroke") glyphPass("stroke");
      ctx.restore();
    }
    // Re-attach shape rendering after any deserialize (undo/redo, paste) — the
    // JSON carries __shape, but instance _render overrides don't survive it.
    _shapeReattach(objs) {
      for (const o2 of objs) {
        if (o2.__locked) this._applyLockState(o2);
        if (o2.__base) this._applyBaseState(o2);
        if (o2.__el && !o2.__el.isLine && o2.path) {
          this._elStrokeSync(o2);
          continue;
        }
        if (o2.__el && o2.__el.isLine && o2 instanceof ca) {
          this._lineRig(o2);
          this._rebuildLine(o2);
          continue;
        }
        if (!o2.__el && !o2.__elRole && !this._crop && o2.selectable !== false && o2.evented !== false && !o2.excludeFromExport && o2.isType && o2.isType("rect", "circle", "triangle", "polygon", "path")) {
          o2.__el = { kind: "legacy", w: o2.width, h: o2.height, round: 0 };
          if (typeof o2.stroke === "string" && o2.stroke && o2.strokeWidth) {
            o2.__el.bstyle = o2.strokeDashArray ? "dashed" : "solid";
            o2.__el.bweight = o2.strokeWidth;
            o2.__el.bcolor = o2.stroke;
          }
          continue;
        }
        if (!o2.__el && !o2.__elRole && o2.isType && o2.isType("line") && !o2.group && !this._crop) {
          const m = o2.calcTransformMatrix();
          const a2 = new N(o2.x1 - (o2.x1 + o2.x2) / 2, o2.y1 - (o2.y1 + o2.y2) / 2).transform(m);
          const b2 = new N(o2.x2 - (o2.x1 + o2.x2) / 2, o2.y2 - (o2.y1 + o2.y2) / 2).transform(m);
          const idx = this.canvas.getObjects().indexOf(o2);
          if (idx !== -1) {
            const S2 = Math.max(10, Math.hypot(b2.x - a2.x, b2.y - a2.y));
            const g2 = this._buildLineAssembly("line", S2, { left: (a2.x + b2.x) / 2, top: (a2.y + b2.y) / 2, originX: "center", originY: "center" });
            g2.__el.weight = Math.max(1, (o2.strokeWidth || 9) * ((Math.abs(o2.scaleX || 1) + Math.abs(o2.scaleY || 1)) / 2));
            g2.__el.color = typeof o2.stroke === "string" && o2.stroke ? o2.stroke : "#0f172a";
            g2.set({ angle: Math.atan2(b2.y - a2.y, b2.x - a2.x) * 180 / Math.PI, opacity: o2.opacity == null ? 1 : o2.opacity });
            this._rebuildLine(g2);
            this.canvas.remove(o2);
            this.canvas.insertAt(idx, g2);
            this._styleSelection(g2);
            g2.setCoords();
          }
          continue;
        }
        if (o2.isType && o2.isType("image")) {
          o2.__stickerRender = false;
          if (o2.__sticker && o2.__sticker.w && o2.__stickerPad) {
            const el2 = o2._originalElement || o2._element;
            if (el2 && !this._ringHasInk(el2, o2.__stickerPad)) {
              o2.__stickerEl = this._contourFor(el2, o2.__stickerPad, o2.__sticker.color || "#000000", true);
              this._attachStickerRender(o2);
            }
          }
          continue;
        }
        if (!o2.isType || !o2.isType("textbox")) continue;
        if (o2.__gradFill) {
          if (o2.fill && typeof o2.fill === "object") o2.fill = this._inkFill(o2);
          if (o2.stroke && typeof o2.stroke === "object") o2.stroke = this._inkFill(o2);
          o2.dirty = true;
        }
        if (o2.__shape) {
          o2.__shapeRender = false;
          this._shapeApply(o2);
        } else {
          this._hugWidth(o2);
        }
        o2.__fxRender = false;
        this._syncFxRender(o2);
      }
    }
    // ── Lock (Owen 9-08, Canva semantics): a locked element still SELECTS
    // (that's the unlock affordance) but can't move/scale/rotate/edit/delete
    // and drops out of multi-selections. __locked rides EditorCloneProps;
    // _shapeReattach re-applies the lock after restore/undo/clone.
    _applyLockState(o2) {
      const on2 = !!o2.__locked;
      o2.lockMovementX = o2.lockMovementY = o2.lockScalingX = o2.lockScalingY = o2.lockRotation = on2;
      o2.hoverCursor = on2 ? "default" : null;
      if (on2) o2.hasControls = false;
      if (o2.isType && o2.isType("textbox")) o2.editable = !on2;
    }
    // Host-supplied BASE art (studio modes — the by-size Add Text takeover).
    // Owen 9-20 "a layer you can put text behind", then 9-21 "make the image
    // moveable and scalable on the text stand alone": the base is a REAL layer
    // — selectable, movable, UNIFORMLY scalable (corner handles only), NOT
    // rotatable — but never deleted or duplicated (deleteActive /
    // _cloneActiveMembers skip it: the upload is why the session exists, and a
    // copy would smuggle an image into a text-only studio) and never restyled
    // (syncSelection hides the image tools for it). The Use Design export scale
    // reads its LIVE scaled width, so the art still lands at by-size's pxW.
    // __base rides EditorCloneProps; _shapeReattach re-applies this (fabric does
    // not serialize selectable/evented/controls). Drafts saved while the base
    // was inert carry __locked:true — on a base that flag can only be the old
    // inert state (it had no lock affordance), so it is cleared here.
    _applyBaseState(o2) {
      o2.__locked = false;
      this._applyLockState(o2);
      o2.selectable = true;
      o2.evented = true;
      o2.hasBorders = true;
      o2.hasControls = true;
      o2.lockRotation = true;
      o2.lockUniScaling = true;
      o2.lockSkewingX = o2.lockSkewingY = true;
      o2.setControlsVisibility({ mtr: false, mt: false, mb: false, ml: false, mr: false });
    }
    setBase(obj) {
      if (!obj) return;
      obj.__base = true;
      this._applyBaseState(obj);
      obj.setCoords();
      this.canvas.requestRenderAll();
    }
    // Fresh history line from the CURRENT canvas: a host-placed base is the
    // floor — undo must never walk back to an empty board.
    resetHistory() {
      clearTimeout(this._recordTimer);
      this._recordTimer = null;
      this._history = [this._snapshot()];
      this._redo.length = 0;
      this._emit("history");
    }
    setLocked(obj, on2) {
      if (!obj) return;
      obj.__locked = !!on2;
      this._applyLockState(obj);
      if (!on2) {
        obj.hasControls = true;
        this._styleSelection(obj);
        this._shapeReattach([obj]);
      }
      obj.setCoords();
      this.canvas.fire("object:modified", { target: obj });
      this.canvas.requestRenderAll();
      this._emit("selection");
    }
    deleteActive() {
      const active = this.canvas.getActiveObject();
      const all = this.canvas.getActiveObjects();
      const objs = all.filter((o2) => !o2.__locked && !o2.__base);
      if (!objs.length) {
        if (all.some((o2) => o2.__base)) this._emit("refuse", "baseDelete");
        return;
      }
      this.canvas.discardActiveObject();
      const touchedGroups = /* @__PURE__ */ new Set();
      objs.forEach((o2) => {
        if (o2.group && o2.group !== active && o2.group instanceof ca && !(o2.group instanceof gs)) {
          touchedGroups.add(o2.group);
          o2.group.remove(o2);
        } else this.canvas.remove(o2);
      });
      for (const g2 of touchedGroups) {
        if (g2.getObjects().length > 1) continue;
        this._dissolveGroupIntoParent(g2);
      }
      if (active && this.canvas.getObjects().indexOf(active) !== -1) this.canvas.remove(active);
      this.canvas.requestRenderAll();
      this._emit("deleted", { count: objs.length });
    }
    // ── Selection actions (quick-action pill / context menu / keyboard) ───────
    layerUp() {
      const o2 = this.canvas.getActiveObject();
      if (!o2) return;
      this.canvas.bringObjectForward(o2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: o2 });
    }
    layerDown() {
      const o2 = this.canvas.getActiveObject();
      if (!o2) return;
      this.canvas.sendObjectBackwards(o2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: o2 });
    }
    layerToFront() {
      const o2 = this.canvas.getActiveObject();
      if (!o2) return;
      this.canvas.bringObjectToFront(o2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: o2 });
    }
    layerToBack() {
      const o2 = this.canvas.getActiveObject();
      if (!o2) return;
      this.canvas.sendObjectToBack(o2);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: o2 });
    }
    flip(axis) {
      const o2 = this.canvas.getActiveObject();
      if (!o2) return;
      const prop = axis === "h" ? "flipX" : "flipY";
      o2.set(prop, !o2[prop]);
      o2.setCoords();
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: o2 });
    }
    async _cloneWithMeta(obj) {
      const clone = await obj.clone(EditorCloneProps);
      this._styleSelection(clone);
      this._shapeReattach([clone]);
      return clone;
    }
    // ⚠ ActiveSelection is EPHEMERAL — cloning it and adding the clone puts a
    // wrapper "object" on the canvas that renders blank and barely hit-tests
    // (Owen 9-06 "duplicated four layers, produced one blank layer I can't
    // delete"). Multi-selections always dup/copy/paste by their MEMBERS: the
    // selection is discarded first so member coords read absolute (inside a
    // selection they're group-relative), members clone individually, and the
    // clones re-select as a fresh ActiveSelection.
    async _cloneActiveMembers() {
      const obj = this.canvas.getActiveObject();
      if (!obj) return null;
      if (obj.__base) {
        this._emit("refuse", "baseCopy");
        return null;
      }
      if (obj instanceof gs) {
        const members = obj.getObjects();
        this.canvas.discardActiveObject();
        const clones = [];
        for (const m of members) if (!m.__base) clones.push(await this._cloneWithMeta(m));
        if (members.some((m) => m.__base) && !clones.length) this._emit("refuse", "baseCopy");
        const sel = new gs(members, { canvas: this.canvas });
        this.canvas.setActiveObject(sel);
        this._styleSelection(sel);
        return clones.length ? clones : null;
      }
      const clone = await this._cloneWithMeta(obj);
      const g2 = obj.group;
      if (g2 && g2 instanceof ca && !(g2 instanceof gs)) {
        clone.set({
          angle: (obj.angle || 0) + (g2.angle || 0),
          scaleX: (obj.scaleX || 1) * (g2.scaleX || 1),
          scaleY: (obj.scaleY || 1) * (g2.scaleY || 1)
        });
        clone.setPositionByOrigin(obj.getCenterPoint(), "center", "center");
        clone.setCoords();
        if (clone.__shape) this._shapeApply(clone);
      }
      return [clone];
    }
    // Diagonal step (30, 60, … wrapping) for paste/duplicate so a copy NEVER
    // lands directly on its original and repeated pastes cascade (Owen 9-08).
    _placeCascade() {
      this._placeSeq = (this._placeSeq || 0) % 8 + 1;
      return this._placeSeq * 30;
    }
    // Nudge a set of objects so their combined bounding box stays ON the board
    // (Owen 9-08 "any copied or pasted element lands on canvas"). Objects bigger
    // than the board are centered instead of pinned.
    _clampOntoBoard(objs) {
      let minL = Infinity, minT = Infinity, maxR = -Infinity, maxB = -Infinity;
      for (const o2 of objs) {
        o2.setCoords();
        const r2 = o2.getBoundingRect();
        minL = Math.min(minL, r2.left);
        minT = Math.min(minT, r2.top);
        maxR = Math.max(maxR, r2.left + r2.width);
        maxB = Math.max(maxB, r2.top + r2.height);
      }
      const W2 = this.designW, H2 = this.designH;
      const bw = maxR - minL, bh = maxB - minT;
      let dx = 0, dy = 0;
      if (bw <= W2) {
        if (minL < 0) dx = -minL;
        else if (maxR > W2) dx = W2 - maxR;
      } else dx = W2 / 2 - (minL + bw / 2);
      if (bh <= H2) {
        if (minT < 0) dy = -minT;
        else if (maxB > H2) dy = H2 - maxB;
      } else dy = H2 / 2 - (minT + bh / 2);
      if (dx || dy) for (const o2 of objs) {
        o2.set({ left: o2.left + dx, top: o2.top + dy });
        o2.setCoords();
      }
    }
    // Real design objects (what prints) — excludes render helpers.
    _boardObjects() {
      return this.canvas.getObjects().filter((o2) => !o2.excludeFromExport);
    }
    // Union bounding box of `objs` in design units.
    _contentBounds(objs) {
      let minL = Infinity, minT = Infinity, maxR = -Infinity, maxB = -Infinity;
      for (const o2 of objs) {
        o2.setCoords();
        const r2 = o2.getBoundingRect();
        minL = Math.min(minL, r2.left);
        minT = Math.min(minT, r2.top);
        maxR = Math.max(maxR, r2.left + r2.width);
        maxB = Math.max(maxB, r2.top + r2.height);
      }
      return { left: minL, top: minT, width: maxR - minL, height: maxB - minT };
    }
    // Union of the objects' INK rects (shadows included — they print).
    _inkBounds(objs) {
      let minL = Infinity, minT = Infinity, maxR = -Infinity, maxB = -Infinity;
      for (const o2 of objs) {
        o2.setCoords();
        const r2 = this._inkRectFor(o2, { shadow: true });
        minL = Math.min(minL, r2.left);
        minT = Math.min(minT, r2.top);
        maxR = Math.max(maxR, r2.left + r2.width);
        maxB = Math.max(maxB, r2.top + r2.height);
      }
      return { left: minL, top: minT, width: maxR - minL, height: maxB - minT };
    }
    // True when any real PIXEL pokes past the board edge (what the export
    // crops). INK, not frames (Owen 9-20 "I'm getting a warning because my
    // bounding box is outside of the canvas, not any design pixels"): frames
    // carry hug margins, padding and effect headroom; only pixels print. Same
    // ink rule as snapping and alignment, plus shadows.
    contentOverhang() {
      const objs = this._boardObjects();
      if (!objs.length) return false;
      const b2 = this._inkBounds(objs);
      return b2.left < -0.5 || b2.top < -0.5 || b2.left + b2.width > this.designW + 0.5 || b2.top + b2.height > this.designH + 0.5;
    }
    // Board-change safety (Owen 9-14): shift the content so it stays centered
    // on the new board (physical sizes unchanged), then — only if it still
    // doesn't fit — scale the WHOLE design down about the board center, 2%
    // margin. Never scales UP (print pixels must not inflate). Outlines
    // re-hold their weight at the new scale; a final clamp catches rounding.
    _fitContentToBoard(prevW, prevH) {
      const objs = this._boardObjects();
      if (!objs.length) return { scaled: false, s: 1 };
      const wasRestoring = this._restoring;
      this._restoring = true;
      try {
        this.canvas.discardActiveObject();
        const dx = (this.designW - prevW) / 2, dy = (this.designH - prevH) / 2;
        if (dx || dy) for (const o2 of objs) {
          o2.set({ left: o2.left + dx, top: o2.top + dy });
          o2.setCoords();
        }
        const margin = Math.round(Math.min(this.designW, this.designH) * 0.02);
        const b2 = this._contentBounds(objs);
        const s3 = Math.min(1, (this.designW - 2 * margin) / Math.max(1, b2.width), (this.designH - 2 * margin) / Math.max(1, b2.height));
        if (s3 < 1) {
          const cx = this.designW / 2, cy = this.designH / 2;
          for (const o2 of objs) {
            const c2 = o2.getCenterPoint();
            o2.set({ scaleX: o2.scaleX * s3, scaleY: o2.scaleY * s3 });
            o2.setPositionByOrigin(new N(cx + (c2.x - cx) * s3, cy + (c2.y - cy) * s3), "center", "center");
            o2.setCoords();
            if (o2.__sticker && o2.__sticker.w) {
              o2.__stickerFastDirty = true;
              this._stickerWeightHold(o2);
            }
          }
        }
        this._clampOntoBoard(objs);
        this.canvas.requestRenderAll();
        return { scaled: s3 < 1, s: s3 };
      } finally {
        this._restoring = wasRestoring;
      }
    }
    // "Fit to canvas" action (overhang toast / export gate): scale + clamp the
    // design onto the CURRENT board as one undo step.
    fitContentToBoard() {
      const r2 = this._fitContentToBoard(this.designW, this.designH);
      this._record();
      this._emit("canvasfit");
      return r2;
    }
    _placeClones(clones, atPoint) {
      if (atPoint) {
        let minL = Infinity, minT = Infinity, maxR = -Infinity, maxB = -Infinity;
        for (const c2 of clones) {
          c2.setCoords();
          const r2 = c2.getBoundingRect();
          minL = Math.min(minL, r2.left);
          minT = Math.min(minT, r2.top);
          maxR = Math.max(maxR, r2.left + r2.width);
          maxB = Math.max(maxB, r2.top + r2.height);
        }
        const dx = atPoint.x - (minL + maxR) / 2, dy = atPoint.y - (minT + maxB) / 2;
        for (const c2 of clones) {
          c2.set({ left: c2.left + dx, top: c2.top + dy });
          c2.setCoords();
          this.canvas.add(c2);
        }
      } else {
        const d2 = this._placeCascade();
        for (const c2 of clones) {
          c2.set({ left: c2.left + d2, top: c2.top + d2 });
          c2.setCoords();
          this.canvas.add(c2);
        }
      }
      this._clampOntoBoard(clones);
      this.canvas.discardActiveObject();
      if (clones.length === 1) {
        this.canvas.setActiveObject(clones[0]);
      } else {
        const sel = new gs(clones, { canvas: this.canvas });
        this.canvas.setActiveObject(sel);
        this._styleSelection(sel);
      }
      this.canvas.requestRenderAll();
    }
    async duplicateActive() {
      const clones = await this._cloneActiveMembers();
      if (!clones) return null;
      this._placeClones(clones);
      return clones.length === 1 ? clones[0] : this.canvas.getActiveObject();
    }
    async copyActive() {
      const clones = await this._cloneActiveMembers();
      if (!clones) return false;
      this._clipboard = clones;
      return true;
    }
    hasClipboard() {
      return !!(this._clipboard && this._clipboard.length);
    }
    async paste(atPoint) {
      if (!this.hasClipboard()) return null;
      const clones = [];
      for (const c2 of this._clipboard) clones.push(await this._cloneWithMeta(c2));
      this._placeClones(clones, atPoint);
      return this.canvas.getActiveObject();
    }
    // ── Image tools: crop / corner radius / revert ────────────────────────────
    // Crop mode: a draggable/resizable frame over the image; Apply computes the
    // fabric cropX/cropY/width/height in image-source pixels. The frame shares
    // the image's angle so the math stays in image-local space.
    startCrop() {
      const img = this.activeImage();
      if (!img || img.__el || this._crop) return false;
      const rect = new $i({
        left: img.left,
        top: img.top,
        originX: "center",
        originY: "center",
        angle: img.angle || 0,
        width: img.getScaledWidth(),
        height: img.getScaledHeight(),
        fill: "rgba(0,0,0,0)",
        stroke: "#019AFF",
        strokeWidth: 1.5,
        strokeUniform: true,
        lockRotation: true,
        transparentCorners: false,
        cornerStyle: "circle",
        cornerColor: "#ffffff",
        cornerStrokeColor: "#019AFF",
        cornerSize: 11,
        touchCornerSize: 32,
        // finger-sized handle hit areas (Owen 9-09 mobile sensitivity)
        borderColor: "#019AFF"
      });
      rect.setControlsVisibility({ mtr: false, mt: false, mb: false, ml: false, mr: false });
      for (const k2 of ["tl", "tr", "bl", "br"]) {
        const c2 = rect.controls && rect.controls[k2];
        if (c2) {
          c2.render = renderCornerControl(k2);
          c2.cursorStyleHandler = cornerCursorHandler(k2);
        }
      }
      rect.lockMovementX = rect.lockMovementY = true;
      this._crop = {
        img,
        rect,
        prevSelectable: img.selectable,
        baseAngle: img.angle || 0,
        prevOpacity: img.opacity == null ? 1 : img.opacity,
        baseScaleX: img.scaleX,
        baseScaleY: img.scaleY,
        baseLeft: img.left,
        baseTop: img.top,
        ratioLocked: false
        // set true by the aspect-ratio tiles
      };
      const scrim = new $i({
        fill: "rgba(100,116,139,0.55)",
        selectable: false,
        evented: false,
        excludeFromExport: true,
        originX: "center",
        originY: "center",
        left: this.designW / 2,
        top: this.designH / 2,
        width: Math.max(this.designW, this.designH) * 1.4,
        height: Math.max(this.designW, this.designH) * 1.4
      });
      this._crop.scrim = scrim;
      this.canvas.add(scrim);
      this.canvas.add(rect);
      this.canvas.setActiveObject(rect);
      img.clone().then((bright) => {
        if (!this._crop || this._crop.img !== img) return;
        bright.set({
          selectable: false,
          evented: false,
          opacity: this._crop.prevOpacity,
          excludeFromExport: true
        });
        this._crop.bright = bright;
        this.canvas.add(bright);
        this.canvas.bringObjectToFront(rect);
        this._syncCropClip();
      });
      this._syncCropClip();
      this._cropSync = (e24) => {
        if (this._crop && (e24.target === this._crop.rect || e24.target === this._crop.img)) this._syncCropClip();
      };
      this.canvas.on("object:moving", this._cropSync);
      this.canvas.on("object:scaling", this._cropSync);
      this.canvas.on("object:rotating", this._cropSync);
      this.canvas.on("object:modified", this._cropSync);
      this._cropDown = (opt) => {
        const c2 = this._crop;
        if (!c2) return;
        if (opt.target === c2.rect && !c2.rect.__corner) {
          const p2 = this.canvas.getScenePoint(opt.e);
          c2.drag = { x: p2.x, y: p2.y, left: c2.img.left, top: c2.img.top };
        }
      };
      this._cropMove = (opt) => {
        const c2 = this._crop;
        if (!c2 || !c2.drag) return;
        const p2 = this.canvas.getScenePoint(opt.e);
        c2.img.set({ left: c2.drag.left + (p2.x - c2.drag.x), top: c2.drag.top + (p2.y - c2.drag.y) });
        c2.img.setCoords();
        this._syncCropClip();
      };
      this._cropUp = () => {
        if (this._crop) this._crop.drag = null;
      };
      this._cropResel = () => {
        if (!this._crop) return;
        setTimeout(() => {
          if (this._crop && !this.canvas.getActiveObject()) {
            this.canvas.setActiveObject(this._crop.rect);
            this.canvas.requestRenderAll();
          }
        }, 0);
      };
      this._cropBeforeTransform = (opt) => {
        const c2 = this._crop;
        this.canvas.uniformScaling = !(c2 && opt.transform && opt.transform.target === c2.rect && !c2.ratioLocked);
      };
      this.canvas.on("before:transform", this._cropBeforeTransform);
      this.canvas.on("mouse:down", this._cropDown);
      this.canvas.on("mouse:move", this._cropMove);
      this.canvas.on("mouse:up", this._cropUp);
      this.canvas.on("selection:cleared", this._cropResel);
      this.canvas.requestRenderAll();
      return true;
    }
    _syncCropClip() {
      const c2 = this._crop;
      if (!c2) return;
      const { img, rect, bright } = c2;
      if (!bright) {
        this.canvas.requestRenderAll();
        return;
      }
      bright.set({
        left: img.left,
        top: img.top,
        angle: img.angle,
        scaleX: img.scaleX,
        scaleY: img.scaleY,
        flipX: img.flipX,
        flipY: img.flipY
      });
      bright.clipPath = new $i({
        absolutePositioned: true,
        originX: "center",
        originY: "center",
        left: rect.left,
        top: rect.top,
        width: rect.getScaledWidth(),
        height: rect.getScaledHeight(),
        angle: rect.angle || 0
      });
      bright.dirty = true;
      this.canvas.requestRenderAll();
    }
    _teardownCrop(crop) {
      this.canvas.off("object:moving", this._cropSync);
      this.canvas.off("object:scaling", this._cropSync);
      this.canvas.off("object:rotating", this._cropSync);
      this.canvas.off("object:modified", this._cropSync);
      this.canvas.off("before:transform", this._cropBeforeTransform);
      this.canvas.uniformScaling = true;
      this.canvas.off("mouse:down", this._cropDown);
      this.canvas.off("mouse:move", this._cropMove);
      this.canvas.off("mouse:up", this._cropUp);
      this.canvas.off("selection:cleared", this._cropResel);
      if (crop.bright) this.canvas.remove(crop.bright);
      if (crop.scrim) this.canvas.remove(crop.scrim);
      crop.img.set("opacity", crop.prevOpacity);
    }
    // Smart Crop: snap the frame to the subject. Local-first — scans the pixels
    // already on canvas (blob or the imgix render the file arrived as; no new
    // imgix calls). Opaque photos find their subject via the SITE-STANDARD imgix
    // bg-remove recipe (bare url + bg-remove=true, no trim so coordinates stay
    // in the source frame) — the one capability we deliberately share so studio
    // behavior never drifts from the rest of the site.
    async smartCrop(ratio) {
      if (!this._crop) return false;
      const { img, rect } = this._crop;
      const scan = (el2, sx, sy, sw, sh) => {
        const k2 = Math.min(1, 420 / Math.max(sw, sh));
        const W2 = Math.max(1, Math.round(sw * k2));
        const H2 = Math.max(1, Math.round(sh * k2));
        const c2 = document.createElement("canvas");
        c2.width = W2;
        c2.height = H2;
        const g2 = c2.getContext("2d");
        try {
          g2.drawImage(el2, sx, sy, sw, sh, 0, 0, W2, H2);
          const d2 = g2.getImageData(0, 0, W2, H2).data;
          let minX = Infinity, minY = Infinity, maxX = -1, maxY = -1, opaque = 0;
          for (let y2 = 0; y2 < H2; y2++) {
            for (let x2 = 0; x2 < W2; x2++) {
              if (d2[(y2 * W2 + x2) * 4 + 3] > 16) {
                opaque++;
                if (x2 < minX) minX = x2;
                if (x2 > maxX) maxX = x2;
                if (y2 < minY) minY = y2;
                if (y2 > maxY) maxY = y2;
              }
            }
          }
          if (maxX < 0) return null;
          return {
            x: minX / k2,
            y: minY / k2,
            w: (maxX - minX + 1) / k2,
            h: (maxY - minY + 1) / k2,
            coverage: opaque / (W2 * H2)
          };
        } catch (e24) {
          return null;
        }
      };
      const cropX = img.cropX || 0, cropY = img.cropY || 0;
      let box = scan(img._element, cropX, cropY, img.width, img.height);
      if ((!box || box.coverage > 0.98) && img.__bgr && img.__bgr.imgixUrl) {
        try {
          const url = img.__bgr.imgixUrl.split("?")[0] + "?fm=png&w=800&bg-remove=true";
          const rEl = await new Promise((res, rej) => {
            const i2 = new Image();
            i2.crossOrigin = "anonymous";
            i2.onload = () => res(i2);
            i2.onerror = rej;
            i2.src = url;
          });
          const el0 = img._originalElement || img._element;
          const k2 = rEl.naturalWidth / (el0.naturalWidth || el0.width);
          const b2 = scan(rEl, cropX * k2, cropY * k2, img.width * k2, img.height * k2);
          if (b2) box = { x: b2.x / k2, y: b2.y / k2, w: b2.w / k2, h: b2.h / k2, coverage: b2.coverage };
        } catch (e24) {
        }
      }
      if (!box || box.coverage > 0.995) return false;
      const m = Math.max(4, Math.max(box.w, box.h) * 0.04);
      let bx = Math.max(0, box.x - m);
      let by = Math.max(0, box.y - m);
      let bw = Math.min(img.width - bx, box.w + 2 * m);
      let bh = Math.min(img.height - by, box.h + 2 * m);
      if (ratio) {
        const cx0 = bx + bw / 2, cy0 = by + bh / 2;
        if (bw / bh < ratio) bw = bh * ratio;
        else bh = bw / ratio;
        bw = Math.min(bw, img.width);
        bh = Math.min(bh, img.height);
        if (bw / bh > ratio) bw = bh * ratio;
        else bh = bw / ratio;
        bx = Math.min(Math.max(0, cx0 - bw / 2), img.width - bw);
        by = Math.min(Math.max(0, cy0 - bh / 2), img.height - bh);
      }
      const rad = (img.angle || 0) * Math.PI / 180;
      const lx = (bx + bw / 2 - img.width / 2) * img.scaleX;
      const ly = (by + bh / 2 - img.height / 2) * img.scaleY;
      rect.set({
        left: img.left + lx * Math.cos(rad) - ly * Math.sin(rad),
        top: img.top + lx * Math.sin(rad) + ly * Math.cos(rad),
        width: bw * img.scaleX,
        height: bh * img.scaleY,
        scaleX: 1,
        scaleY: 1,
        angle: img.angle || 0
      });
      rect.setCoords();
      this._syncCropClip();
      this.canvas.setActiveObject(rect);
      this.canvas.requestRenderAll();
      return true;
    }
    // Scale the image INSIDE the crop frame around its center (Canva behavior).
    setCropScale(pct) {
      if (!this._crop) return;
      const c2 = this._crop;
      const k2 = Math.min(3, Math.max(0.1, (parseFloat(pct) || 100) / 100));
      c2.img.set({ scaleX: c2.baseScaleX * k2, scaleY: c2.baseScaleY * k2 });
      c2.img.setCoords();
      this._syncCropClip();
      this.canvas.requestRenderAll();
    }
    // Rotate the image INSIDE the crop frame (Canva's crop-rotate). Baked on apply.
    setCropRotation(deg) {
      if (!this._crop) return;
      const { img, baseAngle } = this._crop;
      img.set("angle", baseAngle + (parseFloat(deg) || 0));
      img.setCoords();
      this._syncCropClip();
      this.canvas.requestRenderAll();
    }
    cancelCrop() {
      if (!this._crop) return;
      const crop = this._crop;
      const { img, rect, prevSelectable, baseAngle } = crop;
      this._crop = null;
      this._teardownCrop(crop);
      img.set({
        angle: baseAngle,
        left: crop.baseLeft,
        top: crop.baseTop,
        scaleX: crop.baseScaleX,
        scaleY: crop.baseScaleY
      });
      img.setCoords();
      this.canvas.remove(rect);
      img.selectable = prevSelectable;
      this.canvas.setActiveObject(img);
      this.canvas.requestRenderAll();
    }
    applyCrop() {
      if (!this._crop) return;
      const crop = this._crop;
      const { img, rect, prevSelectable } = crop;
      const phi = ((img.angle || 0) - (rect.angle || 0)) * Math.PI / 180;
      if (Math.abs(phi) > 5e-4) {
        this._crop = null;
        this._teardownCrop(crop);
        const keepSticker = img.__sticker && img.__sticker.w ? img.__sticker : null;
        if (keepSticker && img.__stickerPad) {
          img.__sticker = null;
          this._applyRecolor(img);
        }
        const el3 = img._originalElement || img._element;
        const sx = img.scaleX, sy = img.scaleY;
        const W2 = Math.max(1, Math.round(rect.getScaledWidth() / sx));
        const H2 = Math.max(1, Math.round(rect.getScaledHeight() / sy));
        const rad2 = (rect.angle || 0) * Math.PI / 180;
        const dx2 = img.left - rect.left;
        const dy2 = img.top - rect.top;
        const ox = (dx2 * Math.cos(-rad2) - dy2 * Math.sin(-rad2)) / sx;
        const oy = (dx2 * Math.sin(-rad2) + dy2 * Math.cos(-rad2)) / sy;
        const cnv = document.createElement("canvas");
        cnv.width = W2;
        cnv.height = H2;
        const ctx = cnv.getContext("2d");
        ctx.translate(W2 / 2 + ox, H2 / 2 + oy);
        ctx.rotate(phi);
        ctx.drawImage(el3, -((img.cropX || 0) + img.width / 2), -((img.cropY || 0) + img.height / 2));
        {
          const cos = Math.cos(phi), sin = Math.sin(phi);
          const tx1 = -((img.cropX || 0) + img.width / 2);
          const ty1 = -((img.cropY || 0) + img.height / 2);
          const tx2 = W2 / 2 + ox, ty2 = H2 / 2 + oy;
          const m1 = [cos, sin, -sin, cos, cos * tx1 - sin * ty1 + tx2, sin * tx1 + cos * ty1 + ty2];
          const prev = img.__bake;
          const m = prev ? [
            // compose: this bake applied AFTER the stored one (m1 ∘ m0)
            m1[0] * prev.m[0] + m1[2] * prev.m[1],
            m1[1] * prev.m[0] + m1[3] * prev.m[1],
            m1[0] * prev.m[2] + m1[2] * prev.m[3],
            m1[1] * prev.m[2] + m1[3] * prev.m[3],
            m1[0] * prev.m[4] + m1[2] * prev.m[5] + m1[4],
            m1[1] * prev.m[4] + m1[3] * prev.m[5] + m1[5]
          ] : m1;
          const natW2 = prev ? prev.natW : el3.naturalWidth || el3.width;
          img.__bake = { m, W: W2, H: H2, natW: natW2 };
        }
        img.__recolorRepl = null;
        img.__recolorPal = null;
        img.__filter = null;
        img.__filterStrength = null;
        img.__filterColors = null;
        if (img.__adjust) img.__adjust.blur = 0;
        img.__stickerPad = 0;
        img.__preRecolorEl = null;
        img.setElement(cnv);
        img.set({
          cropX: 0,
          cropY: 0,
          width: W2,
          height: H2,
          left: rect.left,
          top: rect.top,
          angle: rect.angle || 0
        });
        this.canvas.remove(rect);
        img.selectable = prevSelectable;
        img.__autoWindow = null;
        if (keepSticker) {
          img.__sticker = keepSticker;
          this._applyRecolor(img);
        }
        if (img.__radius) this.setImageRadius(img.__radius, img);
        img.dirty = true;
        img.setCoords();
        this.canvas.setActiveObject(img);
        this.canvas.requestRenderAll();
        this.canvas.fire("object:modified", { target: img });
        return;
      }
      this._crop = null;
      this._teardownCrop(crop);
      const rad = (img.angle || 0) * Math.PI / 180;
      const dx = rect.left - img.left;
      const dy = rect.top - img.top;
      const localX = (dx * Math.cos(-rad) - dy * Math.sin(-rad)) / img.scaleX;
      const localY = (dx * Math.sin(-rad) + dy * Math.cos(-rad)) / img.scaleY;
      const wLocal = rect.getScaledWidth() / img.scaleX;
      const hLocal = rect.getScaledHeight() / img.scaleY;
      const el2 = img._originalElement || img._element;
      const natW = el2 && (el2.naturalWidth || el2.width) || img.width;
      const natH = el2 && (el2.naturalHeight || el2.height) || img.height;
      let cropX = (img.cropX || 0) + img.width / 2 + (localX - wLocal / 2);
      let cropY = (img.cropY || 0) + img.height / 2 + (localY - hLocal / 2);
      cropX = Math.max(0, Math.min(natW - 1, cropX));
      cropY = Math.max(0, Math.min(natH - 1, cropY));
      const w2 = Math.max(1, Math.min(wLocal, natW - cropX));
      const h2 = Math.max(1, Math.min(hLocal, natH - cropY));
      img.set({ cropX, cropY, width: w2, height: h2, left: rect.left, top: rect.top });
      img.__autoWindow = null;
      this.canvas.remove(rect);
      img.selectable = prevSelectable;
      if (img.__sticker && img.__sticker.w) {
        const p2 = img.__stickerPad || 0;
        this._applyRecolor(img, { clipCore: { x: cropX - p2, y: cropY - p2, w: w2, h: h2 } });
      }
      if (img.__radius) this.setImageRadius(img.__radius, img);
      img.setCoords();
      this.canvas.setActiveObject(img);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: img });
    }
    // Corner rounding: pct 0–100 of the shorter side's half → rounded-rect clipPath.
    setImageRadius(pct, target2) {
      const img = target2 || this.activeImage();
      if (!img) return;
      img.__radius = Math.max(0, Math.min(100, Math.round(pct) || 0));
      if (img.__sticker && img.__sticker.w && img.__stickerPad) {
        img.clipPath = void 0;
        this._applyRecolor(img);
      } else if (!img.__radius) {
        img.clipPath = void 0;
      } else {
        const r2 = Math.min(img.width, img.height) * (img.__radius / 100) / 2;
        img.clipPath = new $i({
          width: img.width,
          height: img.height,
          rx: r2,
          ry: r2,
          originX: "center",
          originY: "center"
        });
      }
      img.dirty = true;
      this.canvas.requestRenderAll();
      if (!target2) this.canvas.fire("object:modified", { target: img });
    }
    // ── Recolor (ported from the PDP's studio-recolor) ────────────────────────
    // replacements live on the object (__recolorRepl + __recolorPal, serialized)
    // and re-apply after any source swap, so they compose with BGR/filters.
    // ── Adjustments (Owen 9-05): client-side fabric filters — instant sliders,
    // no network render, no source swap (so crop/bake geometry is untouched by
    // construction). Values are UI-range (-100..100, blur 0..100); mapped here
    // onto fabric's ranges, tempered where fabric's ±1 is far past useful.
    // fabric serializes the `filters` array natively and setElement/setSrc
    // re-apply it, so adjustments survive undo/redo, saves, BGR/filter swaps,
    // and recolor without any replay code. __adjust mirrors the values for the
    // pane's sliders (serialized via EditorCloneProps).
    setImageAdjust(im, adjust) {
      if (!im) return;
      const a2 = Object.assign(
        { temp: 0, tint: 0, bri: 0, con: 0, hi: 0, sh: 0, wh: 0, bl: 0, invert: false, vib: 0, sat: 0, hue: 0, sharp: 0, clar: 0, vig: 0, blur: 0, noise: 0, pix: 0 },
        adjust || {}
      );
      const any = a2.temp || a2.tint || a2.bri || a2.con || a2.hi || a2.sh || a2.wh || a2.bl || a2.invert || a2.vib || a2.sat || a2.hue || a2.sharp || a2.clar || a2.vig || a2.blur || a2.noise || a2.pix;
      const prevBlur = im.__adjust && im.__adjust.blur || 0;
      const prevVig = im.__adjust && im.__adjust.vig || 0;
      im.__adjust = any ? a2 : null;
      const list = [];
      if (a2.temp || a2.tint) {
        list.push(new Cc.ColorMatrix({
          matrix: [
            1,
            0,
            0,
            0,
            a2.temp / 100 * 0.16,
            0,
            1,
            0,
            0,
            -(a2.tint / 100) * 0.12,
            0,
            0,
            1,
            0,
            -(a2.temp / 100) * 0.16,
            0,
            0,
            0,
            1,
            0
          ]
        }));
      }
      if (a2.bri) list.push(new Cc.Brightness({ brightness: a2.bri / 100 * 0.5 }));
      if (a2.con) list.push(new Cc.Contrast({ contrast: a2.con / 100 * 0.5 }));
      if (a2.hi || a2.sh || a2.wh || a2.bl || a2.clar) {
        list.push(new NinjaTone({ hi: a2.hi / 100, sh: a2.sh / 100, wh: a2.wh / 100, bl: a2.bl / 100, clar: a2.clar / 100 }));
      }
      if (a2.vib) list.push(new Cc.Vibrance({ vibrance: a2.vib / 100 }));
      if (a2.sat) list.push(new Cc.Saturation({ saturation: a2.sat / 100 }));
      if (a2.hue) list.push(new Cc.HueRotation({ rotation: a2.hue / 100 }));
      if (a2.invert) list.push(new Cc.Invert());
      if (a2.sharp) {
        const k2 = a2.sharp / 100 * 0.6;
        const m = -a2.sharp / 100 * 0.08;
        list.push(new Cc.Convolute({
          matrix: a2.sharp > 0 ? [0, -k2, 0, -k2, 1 + 4 * k2, -k2, 0, -k2, 0] : [m, m, m, m, 1 - 8 * m, m, m, m, m]
        }));
      }
      if (a2.noise) list.push(new Cc.Noise({ noise: Math.round(a2.noise / 100 * 200) }));
      if (a2.pix) {
        const el2 = im._originalElement || im._element;
        const minDim = Math.min(el2.naturalWidth || el2.width || 100, el2.naturalHeight || el2.height || 100);
        list.push(new Cc.Pixelate({ blocksize: Math.max(2, Math.round(minDim * 0.04 * (a2.pix / 100))) }));
      }
      im.filters = list;
      if ((a2.blur || 0) !== prevBlur || (a2.vig || 0) !== prevVig) this._applyRecolor(im);
      else im.applyFilters();
      im.dirty = true;
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: im });
    }
    setImageRecolor(im, replacements, palette) {
      if (!im) return;
      im.__recolorRepl = replacements && replacements.length ? replacements : null;
      im.__recolorPal = im.__recolorRepl ? palette : null;
      this._applyRecolor(im);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: im });
    }
    // INTERIOR blur (Owen 9-05): UNIFORM blur with a crisp silhouette — the
    // whole image blurs equally (edge to core), but the alpha channel is the
    // ORIGINAL's, so there is never an outside halo (which prints as fuzz on a
    // DTF cut edge). getImageData returns STRAIGHT (non-premultiplied) RGBA, so
    // the blurred rgb near the edge is already the normalized neighborhood
    // color — stamping the original alpha over it gives full-strength blur
    // right up to a hard edge, no darkened or faded rim. (Earlier 3-draw
    // composite kept a sharp rim of original pixels — Owen asked for uniform.)
    _interiorBlur(el2, amount) {
      const w2 = el2.naturalWidth || el2.width;
      const h2 = el2.naturalHeight || el2.height;
      const t2 = Math.max(0, Math.min(100, amount)) / 100;
      const r2 = Math.max(1, Math.round(Math.min(w2, h2) * 0.03 * t2));
      const out = document.createElement("canvas");
      out.width = w2;
      out.height = h2;
      const ctx = out.getContext("2d");
      ctx.filter = "blur(" + r2 + "px)";
      ctx.drawImage(el2, 0, 0);
      ctx.filter = "none";
      const bd = ctx.getImageData(0, 0, w2, h2);
      const oc2 = document.createElement("canvas");
      oc2.width = w2;
      oc2.height = h2;
      const octx = oc2.getContext("2d");
      octx.drawImage(el2, 0, 0);
      const od = octx.getImageData(0, 0, w2, h2).data;
      const d2 = bd.data;
      for (let i2 = 3; i2 < d2.length; i2 += 4) d2[i2] = od[i2];
      ctx.putImageData(bd, 0, 0);
      return out;
    }
    // Sticker outline (Owen 9-06): a solid contour dilated around the art's
    // silhouette — the die-cut sticker look. Dilation = the colored silhouette
    // stamped in two rings of offsets (16 at full radius, 8 at half) with the
    // art drawn back on top. Same grid as the input; the crop window is grown
    // separately so the contour isn't clipped (see _applyRecolor).
    // Output grid = input + 2·pad with the art at (+pad, +pad): the contour has
    // guaranteed room on every side, so it can NEVER clip at the grid edge
    // (Owen 9-06: the outline was cut flat where art touched the file edge).
    // The outline is a SEPARATE LAYER now (Owen 9-07): the element holds only
    // the padded ART, and the contour lives on im.__stickerEl, drawn UNDER the
    // art by a _render override. Two wins: fabric adjustment filters (invert,
    // brightness, …) apply to the art only — the contour keeps its exact color —
    // and the contour is generated SUPERSAMPLED (up to 4×, targeting ~1800px)
    // so it stays crisp regardless of the source's resolution.
    // Art centered on the grown grid with a transparent pad ring — the element
    // the window math expects (same grid the baked version used).
    _padArt(el2, pad) {
      const w2 = el2.naturalWidth || el2.width;
      const h2 = el2.naturalHeight || el2.height;
      const out = document.createElement("canvas");
      out.width = w2 + 2 * pad;
      out.height = h2 + 2 * pad;
      out.getContext("2d").drawImage(el2, pad, pad);
      return out;
    }
    // Smooth contour of `el`'s VISIBLE silhouette at supersample k.
    // 1. Threshold the art's alpha near-hard first (Owen 9-07: art edges can be
    //    feathered/semi-transparent — the contour must hug the VISIBLE edge, not
    //    the faint haze; the haze itself blends over the contour ink underneath,
    //    so no transparent gap can appear between art and outline).
    // 2. Exact disc dilation of that silhouette through a Euclidean distance
    //    transform (9-18): true circles at corners, hairlines preserved, and a
    //    1px alpha ramp at the exact boundary — no stamp facets, no blur pass.
    // prePadded: el is already on the grown grid (restore path).
    _contourFor(el2, pad, color, prePadded) {
      const w2 = el2.naturalWidth || el2.width;
      const h2 = el2.naturalHeight || el2.height;
      const gw = prePadded ? w2 : w2 + 2 * pad;
      const gh = prePadded ? h2 : h2 + 2 * pad;
      const target2 = this._stickerFastMode ? 700 : 1800;
      const k2 = Math.max(gw, gh) <= target2 ? Math.min(4, Math.max(1, Math.round(target2 / Math.max(gw, gh)))) : Math.max(0.15, target2 / Math.max(gw, gh));
      const r2 = pad * k2;
      const off = prePadded ? 0 : r2;
      const hard = document.createElement("canvas");
      hard.width = w2 * k2;
      hard.height = h2 * k2;
      const hctx = hard.getContext("2d");
      hctx.drawImage(el2, 0, 0, w2, h2, 0, 0, w2 * k2, h2 * k2);
      const hid = hctx.getImageData(0, 0, hard.width, hard.height);
      const hd = hid.data;
      for (let i2 = 3; i2 < hd.length; i2 += 4) {
        hd[i2] = hd[i2] < 128 ? 0 : 255;
      }
      hctx.putImageData(hid, 0, 0);
      const W2 = Math.max(1, Math.round(gw * k2));
      const H2 = Math.max(1, Math.round(gh * k2));
      const sil = document.createElement("canvas");
      sil.width = W2;
      sil.height = H2;
      const sctx = sil.getContext("2d");
      sctx.drawImage(hard, off, off);
      const sd = sctx.getImageData(0, 0, W2, H2).data;
      const INF = 1e20;
      const f2 = new Float32Array(W2 * H2);
      for (let i2 = 0, j2 = 3; i2 < f2.length; i2++, j2 += 4) f2[i2] = sd[j2] >= 128 ? 0 : INF;
      const n2 = Math.max(W2, H2);
      const v2 = new Int32Array(n2), z2 = new Float64Array(n2 + 1), g2 = new Float32Array(n2), out = new Float32Array(n2);
      const edt1d = (len, read, write) => {
        let kk = 0;
        v2[0] = 0;
        z2[0] = -INF;
        z2[1] = INF;
        for (let q2 = 0; q2 < len; q2++) g2[q2] = read(q2);
        for (let q2 = 1; q2 < len; q2++) {
          if (g2[q2] >= INF) continue;
          let sInt;
          for (; ; ) {
            const vk = v2[kk];
            sInt = (g2[q2] + q2 * q2 - (g2[vk] + vk * vk)) / (2 * q2 - 2 * vk);
            if (sInt <= z2[kk] && kk > 0) {
              kk--;
              continue;
            }
            break;
          }
          if (g2[v2[kk]] >= INF) {
            v2[kk] = q2;
            z2[kk] = -INF;
            z2[kk + 1] = INF;
            continue;
          }
          kk++;
          v2[kk] = q2;
          z2[kk] = sInt;
          z2[kk + 1] = INF;
        }
        kk = 0;
        for (let q2 = 0; q2 < len; q2++) {
          while (z2[kk + 1] < q2) kk++;
          const vk = v2[kk];
          const dq = q2 - vk;
          out[q2] = g2[vk] + dq * dq;
        }
        for (let q2 = 0; q2 < len; q2++) write(q2, out[q2]);
      };
      for (let x2 = 0; x2 < W2; x2++) edt1d(H2, (y2) => f2[y2 * W2 + x2], (y2, val) => {
        f2[y2 * W2 + x2] = val;
      });
      for (let y2 = 0; y2 < H2; y2++) {
        const row = y2 * W2;
        edt1d(W2, (x2) => f2[row + x2], (x2, val) => {
          f2[row + x2] = val;
        });
      }
      const sm = document.createElement("canvas");
      sm.width = W2;
      sm.height = H2;
      const mctx = sm.getContext("2d");
      const id = mctx.createImageData(W2, H2);
      const d2 = id.data;
      const co2 = [parseInt(color.slice(1, 3), 16) || 0, parseInt(color.slice(3, 5), 16) || 0, parseInt(color.slice(5, 7), 16) || 0];
      const edge = r2 + 0.5;
      for (let i2 = 0, j2 = 0; i2 < f2.length; i2++, j2 += 4) {
        const dist = Math.sqrt(f2[i2]);
        let t2 = edge - dist;
        t2 = t2 < 0 ? 0 : t2 > 1 ? 1 : t2;
        d2[j2] = co2[0];
        d2[j2 + 1] = co2[1];
        d2[j2 + 2] = co2[2];
        d2[j2 + 3] = Math.round(t2 * 255);
      }
      mctx.putImageData(id, 0, 0);
      return { canvas: sm, k: k2 };
    }
    // Draw the contour under the art, mapped through the SAME crop window the
    // element uses (contour grid = element grid × k, so window coords scale by k).
    _renderSticker(im, ctx) {
      const st2 = im.__stickerEl;
      if (st2 && st2.canvas && st2.canvas.width) {
        const k2 = st2.k;
        ctx.drawImage(
          st2.canvas,
          (im.cropX || 0) * k2,
          (im.cropY || 0) * k2,
          im.width * k2,
          im.height * k2,
          -im.width / 2,
          -im.height / 2,
          im.width,
          im.height
        );
      }
      ws.prototype._render.call(im, ctx);
    }
    _attachStickerRender(im) {
      if (im.__stickerRender) return;
      im.__stickerRender = true;
      const editor = this;
      im._render = function(ctx) {
        editor._renderSticker(this, ctx);
      };
    }
    _detachStickerRender(im) {
      im.__stickerEl = null;
      if (im.__stickerRender) {
        delete im._render;
        im.__stickerRender = false;
      }
    }
    // Legacy detection: pre-9-07 saves BAKED the contour into the element, so
    // their pad ring carries ink; the layered format's ring is transparent.
    _ringHasInk(el2, pad) {
      const w2 = el2.naturalWidth || el2.width;
      const h2 = el2.naturalHeight || el2.height;
      try {
        const c2 = document.createElement("canvas");
        c2.width = w2;
        c2.height = Math.max(1, Math.min(pad, 4));
        const ctx = c2.getContext("2d");
        ctx.drawImage(el2, 0, 0);
        const d2 = ctx.getImageData(0, 0, c2.width, c2.height).data;
        for (let i2 = 3; i2 < d2.length; i2 += 16) if (d2[i2] > 12) return true;
      } catch (e24) {
        return true;
      }
      return false;
    }
    // Outline weight is in CANVAS units — same meaning as element outlines
    // (Owen 9-08 video: element stroke stays visually constant as the object
    // scales, the image outline used to be a fraction of the SOURCE resolution
    // so its visual weight rode the display scale). pad converts design units
    // → source px through the image's live scale; a resize re-derives it (the
    // object:modified hook), so the visible weight holds.
    _stickerPadFor(im, el2) {
      const w2 = im.__sticker && im.__sticker.w || 0;
      if (!w2) return 0;
      const scale = this._effScale(im);
      const minDim = Math.min(el2.naturalWidth || el2.width || 100, el2.naturalHeight || el2.height || 100);
      return Math.max(1, Math.min(Math.round(minDim * 0.5), 600, Math.round(w2 / scale)));
    }
    // Image outline weight is CANVAS-absolute: after a resize the stored pad
    // (source px) no longer matches the design-unit weight — re-stage so the
    // ring re-derives at the new scale (runs at gesture end, not per-frame).
    // LIVE image outline during a scale gesture (Owen 9-09 "that scale
    // transition on all outlines"): a full re-stage per frame is too heavy, so
    // it throttles to one pass every ~300ms and never overlaps itself; the ring
    // steps back to constant thickness as you drag, and the release hold lands
    // the exact value.
    _stickerLive(im) {
      const now = performance.now();
      if (this._stickerLiveBusy || now - (this._stickerLiveAt || 0) < 120) return;
      this._stickerLiveAt = now;
      this._stickerLiveBusy = true;
      this._stickerFastMode = true;
      im.__stickerFastDirty = true;
      try {
        const st2 = im.__sticker;
        const el2 = im._originalElement || im._element;
        if (st2 && st2.w && im.__stickerPad && el2) {
          const pad = Math.max(1, Math.min(this._stickerPadFor(im, el2), im.__stickerPad));
          im.__stickerEl = this._contourFor(el2, pad, st2.color, true);
          im.dirty = true;
        } else {
          this._applyRecolor(im);
        }
      } finally {
        this._stickerFastMode = false;
        this._stickerLiveBusy = false;
      }
      clearTimeout(im.__stickerQT);
      im.__stickerQT = setTimeout(() => {
        if (im.__stickerFastDirty) this._stickerWeightHold(im);
      }, 450);
    }
    _stickerWeightHold(im) {
      if (this.outlineTracksScale) return;
      if (!im || !im.isType || !im.isType("image")) return;
      const st2 = im.__sticker;
      if (!st2 || !st2.w || !im.__stickerPad) return;
      const visual = im.__stickerPad * this._effScale(im);
      if (!im.__stickerFastDirty && Math.abs(visual - st2.w) <= Math.max(0.75, st2.w * 0.08)) return;
      im.__stickerFastDirty = false;
      this._applyRecolor(im);
      this.canvas.requestRenderAll();
    }
    // ═══ THE OUTLINE SCALE SWITCH (Owen 9-09) ═══
    // ONE flag governs every outline surface — text stroke, image sticker,
    // element border, line weight — so they always act the same:
    //   false = CANVAS-ABSOLUTE: the value keeps meaning the same visible band
    //     through resizes (the gesture-end holds re-derive).
    //   true (DEFAULT since 9-18, Owen) = outlines RIDE the object scale: holds
    //     no-op, and the element/line scale-absorb multiplies the weight instead
    //     of preserving it.
    // Toggled from File → "Outline scales with object" (persisted per browser).
    setOutlineTracksScale(v2) {
      this.outlineTracksScale = !!v2;
      for (const o2 of this.canvas.getObjects()) {
        if (!o2.__el) continue;
        if (!o2.__el.isLine && o2.__el.bstyle && o2.__el.bstyle !== "none") this._elStrokeSync(o2);
        o2.dirty = true;
      }
      this.canvas.requestRenderAll();
    }
    // Total effective scale of an object, THROUGH any group / active-selection
    // chain — mid-gesture a member's own scaleX doesn't include the selection's
    // transform, which is exactly when the outline holds need the real number.
    _effScale(o2) {
      let sx = Math.abs(o2.scaleX || 1);
      let sy = Math.abs(o2.scaleY || 1);
      let g2 = o2.group;
      while (g2) {
        sx *= Math.abs(g2.scaleX || 1);
        sy *= Math.abs(g2.scaleY || 1);
        g2 = g2.group;
      }
      return (sx + sy) / 2 || 1;
    }
    // Text outline weight is canvas-absolute (see _applyTextEffectTo): after a
    // resize the stored strokeWidth no longer matches the design-unit value —
    // re-apply so the visible weight holds (gesture end, like images).
    _textOutlineHold(t2) {
      if (this.outlineTracksScale) return;
      if (!t2 || !t2.isType || !t2.isType("textbox")) return;
      if (t2.__effect !== "outline") return;
      const sc2 = this._effScale(t2);
      const want = Math.max(0.5, 2 * (t2.__effectSize != null ? t2.__effectSize : 12) / sc2);
      if (Math.abs((t2.strokeWidth || 0) - want) <= Math.max(0.5, want * 0.08)) return;
      this._applyTextEffectTo(t2, "outline", t2.__effectColor, t2.__effectSize);
    }
    // Slider-scrub variant of the gesture fast path (Owen 9-09 lighten-up):
    // the outline weight slider re-derived the FULL-quality contour on every
    // input tick (~52ms even on a fast machine — a frozen slider on slow
    // ones). Stage at preview quality (700px trace); a 450ms trailer lands the
    // full-quality ring — mode-agnostic, so it also covers outlineTracksScale.
    setImageStickerLive(im, sticker) {
      if (!im) return;
      im.__sticker = sticker && sticker.w ? { w: sticker.w, color: sticker.color || "#ffffff" } : null;
      im.__stickerFastDirty = true;
      const now = performance.now();
      if (!this._stickerLiveBusy && now - (this._stickerLiveAt || 0) >= 120) {
        this._stickerLiveAt = now;
        this._stickerLiveBusy = true;
        this._stickerFastMode = true;
        try {
          this._applyRecolor(im);
        } finally {
          this._stickerFastMode = false;
          this._stickerLiveBusy = false;
        }
        this.canvas.requestRenderAll();
      }
      clearTimeout(im.__stickerQT);
      im.__stickerQT = setTimeout(() => {
        if (!im.__stickerFastDirty) return;
        im.__stickerFastDirty = false;
        this._applyRecolor(im);
        this.canvas.requestRenderAll();
      }, 450);
    }
    setImageSticker(im, sticker) {
      if (!im) return;
      im.__sticker = sticker && sticker.w ? { w: sticker.w, color: sticker.color || "#ffffff" } : null;
      this._applyRecolor(im);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: im });
    }
    // Element-stage pipeline: base → recolor → preset filter → interior blur →
    // sticker outline → (fabric adjustment filters apply on top via setElement).
    // One captured base serves all. The preset stage runs CLIENT-SIDE and after
    // recolor, so filters see the recolored pixels (Owen 9-07 #2) — no imgix
    // round-trip, and intensity scrubs are instant like the adjustments.
    //
    // WINDOW MODEL: all window math runs through the CORE window — the visible
    // rect in base-grid coords. With an outline pad p, the object's fabric
    // window is (coreX, coreY, coreW + 2p, coreH + 2p) on the padded grid (art
    // at +p, so the same x/y numerically): content stays centered (origin is
    // center), the p-ring around the art is where the contour paints, and
    // repeated re-applies never ratchet. opts.clipCore passes an explicit core
    // window (a fresh user crop, already mapped to core coords).
    _applyRecolor(im, opts) {
      if (!im.__preRecolorEl) im.__preRecolorEl = im._originalElement || im._element;
      const base = im.__preRecolorEl;
      const baseW = base.naturalWidth || base.width;
      const baseH = base.naturalHeight || base.height;
      const oldPad = im.__stickerPad || 0;
      let core = opts && opts.clipCore ? opts.clipCore : { x: im.cropX || 0, y: im.cropY || 0, w: Math.max(1, im.width - 2 * oldPad), h: Math.max(1, im.height - 2 * oldPad) };
      const cx = Math.max(0, Math.min(baseW - 1, core.x));
      const cy = Math.max(0, Math.min(baseH - 1, core.y));
      core = { x: cx, y: cy, w: Math.max(1, Math.min(core.w, baseW - cx)), h: Math.max(1, Math.min(core.h, baseH - cy)) };
      const windowed = core.x > 0.5 || core.y > 0.5 || core.w < baseW - 1 || core.h < baseH - 1;
      let el2 = base;
      if (im.__recolorRepl) el2 = recolorElement(el2, im.__recolorRepl, im.__recolorPal || []);
      if (im.__filterCS && im.__filter) {
        const f2 = FILTERS.find((x2) => x2.key === im.__filter);
        let params = f2 && f2.params;
        if (params && im.__filter === "duotone" && im.__filterColors) {
          params = Object.assign({}, params, { duo: [im.__filterColors.a.replace("#", ""), im.__filterColors.b.replace("#", "")], duoAlpha: 1 });
        }
        if (params) el2 = applyPresetToCanvas(el2, params, im.__filterStrength);
      }
      const blur = im.__adjust && im.__adjust.blur;
      if (blur) el2 = this._interiorBlur(el2, blur);
      const vig = im.__adjust && im.__adjust.vig;
      if (vig) el2 = this._vignette(el2, core, vig);
      const wantW = im.__sticker && im.__sticker.w ? im.__sticker.w : 0;
      let newPad = 0;
      if (wantW) {
        const sameW = im.__stickerW == null ? !!oldPad : im.__stickerW === wantW;
        newPad = this.outlineTracksScale && oldPad && sameW ? oldPad : this._stickerPadFor(im, el2);
        im.__stickerW = wantW;
      } else {
        im.__stickerW = null;
      }
      if (newPad) {
        if (windowed) el2 = this._clipToWindow(el2, core);
        if (im.__radius) el2 = this._roundWindowMask(el2, core, im.__radius);
        im.__stickerEl = this._contourFor(el2, newPad, im.__sticker.color);
        el2 = this._padArt(el2, newPad);
        this._attachStickerRender(im);
      } else {
        this._detachStickerRender(im);
      }
      im.setElement(el2);
      im.set({
        cropX: core.x,
        cropY: core.y,
        width: core.w + 2 * newPad,
        height: core.h + 2 * newPad
      });
      if (im.__radius) {
        if (newPad) im.clipPath = void 0;
        else this.setImageRadius(im.__radius, im);
      }
      if (newPad !== oldPad || opts && opts.clipCore) im.setCoords();
      im.__stickerPad = newPad;
      if (el2 === base) im.__preRecolorEl = null;
      im.dirty = true;
    }
    // Vignette (Owen 9-07, Canva parity): radial darkening (amt>0) or lightening
    // (amt<0) centered on the VISIBLE window — source-atop, so only existing
    // pixels are touched and the silhouette/alpha never changes.
    _vignette(el2, core, amt) {
      const w2 = el2.naturalWidth || el2.width;
      const h2 = el2.naturalHeight || el2.height;
      const out = document.createElement("canvas");
      out.width = w2;
      out.height = h2;
      const ctx = out.getContext("2d");
      ctx.drawImage(el2, 0, 0);
      const cx = core.x + core.w / 2;
      const cy = core.y + core.h / 2;
      const outer = Math.sqrt(core.w * core.w + core.h * core.h) / 2;
      const a2 = Math.min(1, Math.abs(amt) / 100);
      const tone = amt > 0 ? "0,0,0" : "255,255,255";
      const g2 = ctx.createRadialGradient(cx, cy, outer * (0.75 - 0.35 * a2), cx, cy, outer);
      g2.addColorStop(0, "rgba(" + tone + ",0)");
      g2.addColorStop(1, "rgba(" + tone + "," + (0.85 * a2).toFixed(3) + ")");
      ctx.globalCompositeOperation = "source-atop";
      ctx.fillStyle = g2;
      ctx.fillRect(0, 0, w2, h2);
      return out;
    }
    // Copy of the element with everything OUTSIDE the core window cleared —
    // same grid, art clipped in place (the outline stage's input).
    _clipToWindow(el2, core) {
      const w2 = el2.naturalWidth || el2.width;
      const h2 = el2.naturalHeight || el2.height;
      const out = document.createElement("canvas");
      out.width = w2;
      out.height = h2;
      out.getContext("2d").drawImage(el2, core.x, core.y, core.w, core.h, core.x, core.y, core.w, core.h);
      return out;
    }
    // Bake the corner-radius rounding into the ART PIXELS at the window rect
    // (full-grid coords, like _clipToWindow). Used when an OUTLINE is active
    // (Owen 9-08 screenshot): the contour must trace the ROUNDED silhouette,
    // and the fabric clipPath can't be used — the sticker underlay escapes it
    // (square ring behind a circled image) and clipping it would chop the ring.
    _roundWindowMask(el2, core, pct) {
      const w2 = el2.naturalWidth || el2.width;
      const h2 = el2.naturalHeight || el2.height;
      const out = document.createElement("canvas");
      out.width = w2;
      out.height = h2;
      const x2 = out.getContext("2d");
      x2.drawImage(el2, 0, 0);
      const r2 = Math.min(core.w, core.h) * (pct / 100) / 2;
      x2.globalCompositeOperation = "destination-in";
      x2.beginPath();
      x2.roundRect(core.x, core.y, core.w, core.h, r2);
      x2.fill();
      return out;
    }
    // Re-run the element stages with the current props (public: preset filter
    // picks/intensity re-stage without any source swap — Owen 9-07 #2).
    restageImage(im) {
      if (!im) return;
      this._applyRecolor(im);
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: im });
    }
    // Pixels the recolor pane should DETECT on (the clean pre-recolor base,
    // unfiltered — see _applyRecolor).
    recolorBaseElement(im) {
      return im.__preRecolorEl || im._originalElement || im._element;
    }
    // Small canvas of the image's PRE-FILTER look — base + recolor — for the
    // filter tiles: presets preview on top of the user's recolor (Owen 9-07 #2).
    // Recolor runs on the downscaled copy, so tiles stay cheap at any source size.
    filterThumbCanvas(im, size = 320) {
      const base = this.recolorBaseElement(im);
      const iw = base.naturalWidth || base.width;
      const ih = base.naturalHeight || base.height;
      const k2 = Math.min(1, size / Math.max(1, Math.max(iw, ih)));
      const c2 = document.createElement("canvas");
      c2.width = Math.max(1, Math.round(iw * k2));
      c2.height = Math.max(1, Math.round(ih * k2));
      c2.getContext("2d").drawImage(base, 0, 0, c2.width, c2.height);
      return im.__recolorRepl ? recolorElement(c2, im.__recolorRepl, im.__recolorPal || []) : c2;
    }
    // Revert: back to the original upload — crop, rounding, and BGR pick cleared;
    // displayed width preserved.
    async revertImage() {
      const img = this.activeImage();
      if (!img || !img.__originalSrc) return;
      const displayedW = img.getScaledWidth();
      await img.setSrc(img.__originalSrc, { crossOrigin: "anonymous" });
      {
        const el2 = img._element;
        img.set({ cropX: 0, cropY: 0, width: el2.naturalWidth || el2.width, height: el2.naturalHeight || el2.height });
      }
      img.clipPath = void 0;
      img.__radius = 0;
      img.__filter = null;
      img.__filterCS = false;
      img.__filterStrength = null;
      img.__filterColors = null;
      img.__bake = null;
      img.__recolorRepl = null;
      img.__recolorPal = null;
      img.__preRecolorEl = null;
      img.__sticker = null;
      img.__stickerPad = 0;
      img.__superRes = false;
      img.__adjust = null;
      img.filters = [];
      img.applyFilters();
      if (img.__bgr) img.__bgr.model = null;
      this._applyInkCrop(img);
      const s3 = displayedW / img.width;
      img.set({ scaleX: s3, scaleY: s3 });
      img.dirty = true;
      img.setCoords();
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: img });
    }
    // Align the selection to the page (the current design space). Uses the INK
    // rect, not the frame — alignment works on pixels, exactly like snapping
    // (Owen 9-08 "that goes for all alignment").
    alignToPage(pos) {
      const o2 = this.canvas.getActiveObject();
      if (!o2) return;
      o2.setCoords();
      const br2 = this._inkRectFor(o2);
      const W2 = this.designW;
      const H2 = this.designH;
      if (pos === "left") o2.set("left", o2.left - br2.left);
      else if (pos === "centerH") o2.set("left", o2.left + (W2 / 2 - (br2.left + br2.width / 2)));
      else if (pos === "right") o2.set("left", o2.left + (W2 - (br2.left + br2.width)));
      else if (pos === "top") o2.set("top", o2.top - br2.top);
      else if (pos === "middle") o2.set("top", o2.top + (H2 / 2 - (br2.top + br2.height / 2)));
      else if (pos === "bottom") o2.set("top", o2.top + (H2 - (br2.top + br2.height)));
      o2.setCoords();
      this.canvas.requestRenderAll();
      this.canvas.fire("object:modified", { target: o2 });
      this._emit("selection");
    }
    async _restore(json) {
      this._restoring = true;
      try {
        performance.mark("nsv2:restore:start");
      } catch (e24) {
      }
      try {
        const data = typeof json === "string" ? JSON.parse(json) : json;
        {
          const fams = /* @__PURE__ */ new Set();
          const raw = typeof json === "string" ? json : JSON.stringify(data);
          for (const m of raw.matchAll(/"fontFamily"\s*:\s*"([^"]+)"/g)) fams.add(m[1]);
          const fontsReady = Promise.all([...fams].map((f2) => loadFont(f2).catch(() => {
          })));
          await Promise.race([fontsReady, new Promise((r2) => setTimeout(r2, 200))]);
          const token = this._restoreToken = (this._restoreToken || 0) + 1;
          this._restoreSettled = fontsReady.then(() => {
            if (this._restoreToken !== token) return;
            this._refitTextMetrics();
          });
        }
        if (data.__designW && (data.__designW !== this.designW || data.__designH !== this.designH)) {
          this.designW = data.__designW;
          this.designH = data.__designH || data.__designW;
          this.fitToContainer();
          this._emit("canvassize");
        }
        await this.canvas.loadFromJSON(data);
        this._syncBoardClip();
        {
          const bg = data.__boardBg != null ? data.__boardBg : this.canvas.backgroundColor || "";
          this.canvas.backgroundColor = "";
          this._boardBg = bg;
          this._paintPage();
        }
        this._guides = data.__guides && data.__guides.v ? { v: data.__guides.v.slice(), h: data.__guides.h.slice() } : { v: [], h: [] };
        for (const o2 of [...this.canvas.getObjects()]) {
          if (o2 instanceof gs || o2.type === "activeselection" || o2.type === "activeSelection") {
            this.canvas.remove(o2);
          }
        }
        const objs = [];
        const walk = (list) => {
          for (const o2 of list) {
            objs.push(o2);
            if (o2 instanceof ca && !(o2 instanceof gs) && o2.getObjects) walk(o2.getObjects());
          }
        };
        walk(this.canvas.getObjects());
        objs.forEach((o2) => this._styleSelection(o2));
        for (const o2 of objs) {
          if (o2.__restage && o2.isType && o2.isType("image")) {
            delete o2.__restage;
            o2.__preRecolorEl = null;
            try {
              this._applyRecolor(o2);
            } catch (e24) {
              console.warn("studio-v2: restage on restore failed", e24);
            }
          }
        }
        this._shapeReattach(objs);
        this._emit("canvasbg");
        this._attachTextHooks(objs);
        this.canvas.requestRenderAll();
      } finally {
        this._restoring = false;
        try {
          performance.mark("nsv2:restore:end");
          performance.measure("nsv2:restore", "nsv2:restore:start", "nsv2:restore:end");
        } catch (e24) {
        }
      }
      this._emit("selection");
      this._emit("history");
    }
    // Resolves when the latest restore has fully settled (fonts landed + text
    // refit) — after this, nothing on the canvas will shift. Resolved promise
    // when no restore ran.
    whenRestoreSettled() {
      return this._restoreSettled || Promise.resolve();
    }
    // Re-derive text geometry after the real fonts land: boot restores paint
    // with fallback faces first (see _restore's fast-paint race), so hug/wrap/
    // shape need one pass with true metrics. Idempotent when fonts were already
    // warm. Fires no object:modified → no history records.
    _refitTextMetrics() {
      const walk = (list, parent) => {
        for (const o2 of list) {
          if (o2 instanceof ca && !(o2 instanceof gs) && o2.getObjects) {
            walk(o2.getObjects(), o2);
            if (o2.triggerLayout) o2.triggerLayout();
            continue;
          }
          if (!o2.isType || !o2.isType("textbox") || o2.isEditing) continue;
          if (o2.__shape) this._shapeApply(o2);
          else if (o2.__manualWidth) o2.initDimensions();
          else this._hugWidth(o2);
          o2.setCoords();
        }
      };
      walk(this.canvas.getObjects(), null);
      this.canvas.requestRenderAll();
    }
    // The full design state as a JSON string — same shape history snapshots use
    // (toDatalessJSON + EditorCloneProps + __designW/__designH), so anything
    // undo/redo can restore, a saved design can too.
    designJSON() {
      this._flushRecord();
      return this._snapshot();
    }
    // Load a SAVED design (My Designs → continue editing). Same revive path as
    // undo/redo, but the loaded design starts a FRESH history line — undo must
    // never walk back into whatever was on the canvas before the load.
    async loadDesign(json) {
      await this._restore(json);
      clearTimeout(this._recordTimer);
      this._recordTimer = null;
      this._history = [this._snapshot()];
      this._redo.length = 0;
      this._emit("history");
    }
    get canUndo() {
      return this._history.length > 1 || !!this._recordTimer;
    }
    get canRedo() {
      return this._redo.length > 0;
    }
    async undo() {
      this._flushRecord();
      if (this._history.length <= 1) return;
      this._redo.push(this._history.pop());
      await this._restore(this._history[this._history.length - 1]);
    }
    async redo() {
      this._flushRecord();
      if (!this.canRedo) return;
      const state = this._redo.pop();
      this._history.push(state);
      await this._restore(state);
    }
    // Full design space → transparent PNG blob at targetPx square (the output contract's step 1).
    async exportPng(targetPx, opts = {}) {
      const active = this.canvas.getActiveObject();
      this.canvas.discardActiveObject();
      const prevBg = this.canvas.backgroundColor;
      this.canvas.backgroundColor = "";
      this.canvas.renderAll();
      const swaps = [];
      const wantPrint = opts.print !== false && targetPx > 2e3 && typeof this.printSourceFor === "function";
      const wasRestoring = this._restoring;
      if (wantPrint) {
        this._restoring = true;
        for (const o2 of this.canvas.getObjects()) {
          if (!o2.isType || !o2.isType("image") || o2.__el) continue;
          let pair = null;
          try {
            pair = this.printSourceFor(o2);
          } catch (e24) {
            pair = null;
          }
          if (!pair) continue;
          try {
            const snap = { scaleX: o2.scaleX, scaleY: o2.scaleY, left: o2.left, top: o2.top, cropX: o2.cropX, cropY: o2.cropY, width: o2.width, height: o2.height, pad: o2.__stickerPad || 0 };
            const center = o2.getCenterPoint();
            const coreDisp = (snap.width - 2 * snap.pad) * snap.scaleX;
            await this.replaceImageSource(o2, pair.print);
            for (let i2 = 0; i2 < 2; i2++) {
              const core = Math.max(1, o2.width - 2 * (o2.__stickerPad || 0));
              const sc2 = coreDisp / core;
              o2.set({ scaleX: sc2, scaleY: sc2 });
              if (o2.__sticker && o2.__sticker.w) {
                o2.__stickerFastDirty = true;
                this._stickerWeightHold(o2);
              } else break;
            }
            o2.setPositionByOrigin(center, "center", "center");
            o2.setCoords();
            swaps.push({ o: o2, back: pair.display, snap });
          } catch (err) {
            console.warn("studio-v2: print-res swap failed, exporting display res", err);
          }
        }
        this.canvas.renderAll();
      }
      const shaped = this.canvas.getObjects().filter((o2) => o2.isType && o2.isType("textbox") && o2.__shape);
      if (shaped.some((t2) => !t2.__shapePath)) {
        await Promise.all(
          shaped.map((t2) => {
            const italic = t2.fontStyle === "italic";
            const weight = parseInt(t2.fontWeight, 10) || (t2.fontWeight === "bold" ? 700 : 400);
            return Promise.race([
              ensureFontBinary(t2.fontFamily, weight, italic),
              new Promise((r2) => setTimeout(r2, 6e3))
            ]);
          })
        );
        for (const t2 of shaped) {
          if (!t2.__shapePath) this._shapeApply(t2);
        }
        this.canvas.renderAll();
      }
      try {
        const z2 = this.canvas.getZoom();
        const w2 = this.designW * z2;
        const dataUrl = this.canvas.toDataURL({
          format: "png",
          quality: 1,
          // Board top-left sits `apron` px into the canvas element (see
          // _applyZoom's viewportTransform) — crop exactly the board.
          left: this.apronX,
          top: this.apronY,
          width: w2,
          height: this.designH * z2,
          multiplier: targetPx / w2
        });
        return await (await fetch(dataUrl)).blob();
      } finally {
        for (const s3 of swaps) {
          try {
            await this.replaceImageSource(s3.o, s3.back);
            const o2 = s3.o;
            o2.set({ scaleX: s3.snap.scaleX, scaleY: s3.snap.scaleY, left: s3.snap.left, top: s3.snap.top });
            if (o2.__sticker && o2.__sticker.w) {
              o2.__stickerFastDirty = true;
              this._stickerWeightHold(o2);
            }
            if ((o2.__stickerPad || 0) === s3.snap.pad) o2.set({ cropX: s3.snap.cropX, cropY: s3.snap.cropY, width: s3.snap.width, height: s3.snap.height });
            o2.set({ scaleX: s3.snap.scaleX, scaleY: s3.snap.scaleY, left: s3.snap.left, top: s3.snap.top });
            o2.dirty = true;
            o2.setCoords();
          } catch (e24) {
          }
        }
        if (wantPrint) this._restoring = wasRestoring;
        this.canvas.backgroundColor = prevBg;
        if (active) this.canvas.setActiveObject(active);
        this.canvas.renderAll();
      }
    }
    destroy() {
      this._ro.disconnect();
      document.removeEventListener("visibilitychange", this._onVisibility);
      try {
        document.fonts.removeEventListener("loadingdone", this._onFontsArrived);
      } catch (e24) {
      }
      try {
        document.removeEventListener("nsv2:fontloaded", this._onStudioFontLoaded);
      } catch (e24) {
      }
      if (this._canvasFontWatch) {
        for (const t2 of this._canvasFontWatch.values()) if (t2 !== "done") clearInterval(t2);
        this._canvasFontWatch.clear();
      }
      this.canvas.dispose();
    }
  };

  // src/config.js
  var cfg = {
    // uploads API: /uploads/getPresignedUploadUrl, saveData, fetchDataNew, archiveData
    apiUrl: "https://hpz51rjda5.execute-api.us-east-1.amazonaws.com/production",
    // public image door for the uploads bucket (tiles, previews, derivatives)
    imgixHost: "ninjauploads-production.imgix.net",
    // the uploads bucket itself: presigned PUTs, and plain GETs of save-state JSON
    s3Host: "ninja-services-production-ninjauploadss3bucket-zks2mguobhe4.s3.amazonaws.com",
    // CORS-safe imgix copy of the premade "Ready to Press" feed; '' = no mirror
    rtpMirror: "https://ninjauploads-production.imgix.net/rtp-mirror/",
    // background-removal + AI-edit proxy
    proxyUrl: "https://ruhg140mmf.execute-api.us-east-1.amazonaws.com/",
    // Ninja Labs usage beacons; '' = off
    evtUrl: "https://uszaouez69.execute-api.us-east-1.amazonaws.com/evt",
    // store tag the proxy expects in its request bodies (UK by-size contract sends 'uk'); '' = omit the key
    store: "",
    // brandingName the AI create backend receives
    brandingName: "ninjatransfers.com",
    // 'api' = retire the previous save's row via /uploads/archiveData on overwrite; 'none' = skip (no route)
    archive: "api",
    // 'in' | 'cm' — the DISPLAY unit at the UI boundary (canvas presets + custom
    // inputs, grid-size slider, ruler ticks — src/units.js). The engine stays
    // inches: 50 units/in, 300 dpi exports, `wIn x hIn` registrations, and the
    // Use Design handoff is a FILE the PDP measures itself.
    units: "in",
    // Canvas-size contract in the unit of `units`: { presets: [[w, h, label]…],
    // min, max, step, defaultW, defaultH }. null = the US board (src/units.js
    // boardCfg: the Popular Sizes list + the 22 in max board, converted for cm).
    board: null
  };
  var ROUTE_KEYS = ["apiUrl", "imgixHost", "s3Host", "rtpMirror", "proxyUrl", "evtUrl", "store", "brandingName"];
  function configure(storage, units, board) {
    if (storage && typeof storage === "object") {
      for (const k2 of ROUTE_KEYS) if (typeof storage[k2] === "string") cfg[k2] = storage[k2].trim();
      if (storage.archive === "api" || storage.archive === "none") cfg.archive = storage.archive;
      cfg.apiUrl = cfg.apiUrl.replace(/\/+$/, "");
      if (cfg.rtpMirror && !/\/$/.test(cfg.rtpMirror)) cfg.rtpMirror += "/";
      if (cfg.proxyUrl && !/\/$/.test(cfg.proxyUrl)) cfg.proxyUrl += "/";
    }
    if (units === "in" || units === "cm") cfg.units = units;
    cfg.board = normalizeBoard(board);
    return cfg;
  }
  function normalizeBoard(b2) {
    if (!b2 || typeof b2 !== "object") return null;
    const num = (v2) => typeof v2 === "number" && isFinite(v2) && v2 > 0 ? v2 : null;
    const min = num(b2.min), max = num(b2.max), step = num(b2.step), dw = num(b2.defaultW), dh = num(b2.defaultH);
    if (min == null || max == null || step == null || dw == null || dh == null) return null;
    if (!(min < max) || dw < min || dw > max || dh < min || dh > max) return null;
    const presets = Array.isArray(b2.presets) ? b2.presets.map((p2) => Array.isArray(p2) ? [num(p2[0]), num(p2[1]), typeof p2[2] === "string" ? p2[2] : ""] : null).filter((p2) => p2 && p2[0] != null && p2[1] != null && p2[0] >= min && p2[0] <= max && p2[1] >= min && p2[1] <= max) : [];
    if (!presets.length) return null;
    return { presets, min, max, step, defaultW: dw, defaultH: dh };
  }
  function isBucketHost(host) {
    if (!host || !cfg.s3Host) return false;
    const bucket = cfg.s3Host.split(".s3.")[0];
    return host.split(".s3.")[0] === bucket && /\.s3(\.[a-z0-9-]+)?\.amazonaws\.com$/.test(host);
  }

  // src/eyedropper.js
  var target = null;
  function setEyeDropperTarget(t2) {
    target = t2;
  }
  function hasNativeEyeDropper() {
    return typeof window !== "undefined" && "EyeDropper" in window;
  }
  function openEyeDropper() {
    if (hasNativeEyeDropper()) return new window.EyeDropper().open();
    return sampleFromBoard();
  }
  var hex2 = (v2) => v2.toString(16).padStart(2, "0");
  function sampleFromBoard() {
    return new Promise((resolve, reject) => {
      const cv = target && target.canvasEl();
      const host = target && target.hostEl() || document.body;
      if (!cv) return reject(new Error("eyedropper: no board"));
      const coarse = !!(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
      const layer = document.createElement("div");
      layer.className = "nsv2-eyedrop-layer";
      const hint = document.createElement("div");
      hint.className = "nsv2-eyedrop-hint";
      hint.textContent = coarse ? "Tap a color on your design" : "Click a color on your design \xB7 Esc to cancel";
      const swatch = document.createElement("div");
      swatch.className = "nsv2-eyedrop-swatch";
      swatch.hidden = true;
      layer.append(hint, swatch);
      const phone = host.clientWidth < 768;
      if (phone) host.classList.add("is-eyedropping");
      host.appendChild(layer);
      const lr2 = () => layer.getBoundingClientRect();
      const fc2 = target.canvas && target.canvas();
      const act = fc2 && fc2.getActiveObject && fc2.getActiveObject();
      const savedChrome = act ? { b: act.hasBorders, c: act.hasControls } : null;
      if (act) {
        act.hasBorders = false;
        act.hasControls = false;
        try {
          fc2.renderAll();
        } catch (e24) {
        }
      }
      let ctx = null;
      try {
        ctx = cv.getContext("2d");
      } catch (e24) {
      }
      const sample = (clientX, clientY) => {
        const r2 = cv.getBoundingClientRect();
        if (!r2.width || !r2.height || clientX < r2.left || clientY < r2.top || clientX >= r2.right || clientY >= r2.bottom) return { off: true };
        const x2 = Math.floor((clientX - r2.left) * cv.width / r2.width);
        const y2 = Math.floor((clientY - r2.top) * cv.height / r2.height);
        const d2 = ctx.getImageData(x2, y2, 1, 1).data;
        if (d2[3] === 0) return { empty: true };
        return { sRGBHex: "#" + hex2(d2[0]) + hex2(d2[1]) + hex2(d2[2]) };
      };
      const done = (fn2) => {
        window.removeEventListener("keydown", onKey, true);
        if (phone) host.classList.remove("is-eyedropping");
        if (act && savedChrome) {
          act.hasBorders = savedChrome.b;
          act.hasControls = savedChrome.c;
          try {
            fc2.requestRenderAll();
          } catch (e24) {
          }
        }
        layer.remove();
        fn2();
      };
      const onKey = (e24) => {
        if (e24.key === "Escape") {
          e24.preventDefault();
          e24.stopPropagation();
          done(() => reject(new Error("cancelled")));
        }
      };
      const onMove = (e24) => {
        let s3;
        try {
          s3 = sample(e24.clientX, e24.clientY);
        } catch (err) {
          return;
        }
        swatch.hidden = !!s3.off;
        swatch.classList.toggle("is-empty", !!s3.empty);
        swatch.style.background = s3.sRGBHex || "";
        const b2 = lr2();
        swatch.style.left = e24.clientX - b2.left + "px";
        swatch.style.top = e24.clientY - b2.top + "px";
      };
      const onDown = (e24) => {
        e24.preventDefault();
        e24.stopPropagation();
        let s3;
        try {
          s3 = sample(e24.clientX, e24.clientY);
        } catch (err) {
          hint.textContent = "This image can\u2019t be sampled";
          setTimeout(() => done(() => reject(new Error("tainted"))), 1400);
          return;
        }
        if (s3.off) return done(() => reject(new Error("cancelled")));
        done(() => resolve(s3.empty ? null : { sRGBHex: s3.sRGBHex }));
      };
      layer.addEventListener("pointermove", onMove);
      layer.addEventListener("pointerdown", onDown);
      window.addEventListener("keydown", onKey, true);
    });
  }

  // src/units.js
  var IN2CM = 2.54;
  var isCm = () => cfg.units === "cm";
  var unitLabel = () => isCm() ? "cm" : "in";
  var unitWord = () => isCm() ? "centimetres" : "inches";
  var toIn = (v2) => isCm() ? v2 / IN2CM : v2;
  var fromIn = (v2) => isCm() ? v2 * IN2CM : v2;
  var roundStep = (v2, step) => Math.round(v2 / step) * step;
  var fmtNum = (v2) => {
    const dp = isCm() ? 10 : 100;
    return String(Math.round(v2 * dp) / dp);
  };
  var US_PRESETS_IN = [
    [2, 2, "Tag Print / Neck Label"],
    [3, 3, "Small Tag / Sleeve Icon"],
    [4, 2, "Name Label / Small Chest Text"],
    [4, 4, "Left-Chest Logo"],
    [5, 3, "Small Badge Logo"],
    [5, 5, "Small Chest / Youth Print"],
    [6, 6, "Std Left-Chest / Youth"],
    [7, 7, "Small Front (Adult)"],
    [8, 8, "Medium Front Print"],
    [9, 9, "Large Chest / Med Front"],
    [9, 11, "Vertical Front / Youth"],
    [10, 10, "Standard Adult Front"],
    [11, 5, "Chest Banner / Sleeve"],
    [11, 11, "Adult Full Front"],
    [11, 14, "Tall Front / Jersey"],
    [12, 17, "Oversized Front / Hoodie"],
    [22, 22, "Max board"]
  ];
  var US_BOARD_IN = { presets: US_PRESETS_IN, min: 1, max: 22, step: 0.5, defaultW: 22, defaultH: 22 };
  function boardCfg() {
    if (cfg.board) return cfg.board;
    if (!isCm()) return US_BOARD_IN;
    const cm = (v2) => roundStep(v2 * IN2CM, 0.5);
    return {
      presets: US_PRESETS_IN.map(([w2, h2, use]) => [cm(w2), cm(h2), use]),
      min: cm(US_BOARD_IN.min),
      max: cm(US_BOARD_IN.max),
      step: 0.5,
      defaultW: cm(US_BOARD_IN.defaultW),
      defaultH: cm(US_BOARD_IN.defaultH)
    };
  }
  var gridRange = () => isCm() ? { min: 0.5, max: 5, step: 0.5, def: 1 } : { min: 0.125, max: 2, step: 0.125, def: 0.25 };
  var rulerSteps = () => isCm() ? [1, 2, 5, 10, 20, 50] : [1, 2, 5, 10, 20];

  // src/icons.js
  var s2 = (inner, vb = "0 0 21 21", w2 = 19) => '<svg width="' + w2 + '" height="' + w2 + '" viewBox="' + vb + '" fill="none">' + inner + "</svg>";
  var icons = {
    // Rail (sidebar) glyph set — Owen's 9-21 filled 72×72 SVGs ("can we try these icons for the side bar"), fill:
    // currentColor so the rail's color/active state applies; used ONLY by the rail tool list in ui.js — the same tools'
    // other surfaces (Add text button, upload CTA, Effects/Smart Crop) keep the stroke icons below.
    rail: {
      text: '<svg width="22" height="22" viewBox="0 0 72 72" fill="currentColor" aria-hidden="true"><path d="M61.06,5.84H10.94c-1.53,0-2.76,1.24-2.76,2.76v9.87c0,1.53,1.24,2.76,2.76,2.76h2.71c1.53,0,2.76-1.24,2.76-2.76v-2.82c0-.51.41-.92.92-.92h13.3c.51,0,.92.41.92.92v42.2c0,.51-.41.92-.92.92h-2.45c-1.53,0-2.76,1.24-2.76,2.76v1.85c0,1.53,1.24,2.76,2.76,2.76h15.64c1.53,0,2.76-1.24,2.76-2.76v-1.85c0-1.53-1.24-2.76-2.76-2.76h-2.45c-.51,0-.92-.41-.92-.92V15.66c0-.51.41-.92.92-.92h13.3c.51,0,.92.41.92.92v2.82c0,1.53,1.24,2.76,2.76,2.76h2.71c1.53,0,2.76-1.24,2.76-2.76v-9.87c0-1.53-1.24-2.76-2.76-2.76Z"/></svg>',
      uploads: '<svg width="22" height="22" viewBox="0 0 72 72" fill="currentColor" aria-hidden="true"><path d="M45.59,13.45l3.8-3.8v21.03c0,1.48,1.2,2.68,2.68,2.68s2.68-1.2,2.68-2.68V9.66l3.8,3.8c.44.44,1.02.66,1.6.66s1.16-.22,1.6-.66c.88-.88.88-2.31,0-3.19l-8.07-8.07c-.88-.88-2.31-.88-3.19,0l-8.07,8.07c-.88.88-.88,2.31,0,3.19.88.88,2.31.88,3.19,0Z"/><path d="M59.73,39.26h-14.53c-2.13,0-3.86-1.73-3.86-3.86v-10.62c0-1.28-1.04-2.31-2.31-2.31h-21.71c-4.26,0-7.71,3.45-7.71,7.71v32.57c0,4.26,3.45,7.71,7.71,7.71h37.01c4.26,0,7.71-3.45,7.71-7.71v-21.18c0-1.28-1.04-2.31-2.31-2.31ZM53.93,63.81H17.73c-.64,0-1-.74-.61-1.25l12.03-15.31c.31-.39.9-.39,1.21,0l9.21,11.73c.31.39.9.39,1.21,0l4.86-6.18c.31-.39.9-.39,1.21,0l7.67,9.77c.4.51.04,1.25-.61,1.25Z"/></svg>',
      ai: '<svg width="22" height="22" viewBox="0 0 72 72" fill="currentColor" aria-hidden="true"><path d="M58.19,40.33l-18.67-6.91c-.32-.12-.61-.31-.85-.55-.24-.24-.43-.53-.55-.85l-6.91-18.67c-.13-.34-.43-.52-.74-.52s-.61.17-.74.52l-6.91,18.67c-.12.32-.31.61-.55.85-.24.24-.53.43-.85.55l-18.67,6.91c-.17.06-.3.17-.39.3s-.13.28-.13.44c0,.31.17.61.52.74l18.67,6.91c.65.24,1.16.75,1.4,1.4l6.91,18.67c.13.34.43.52.74.52s.61-.17.74-.52l6.91-18.67c.24-.65.75-1.16,1.4-1.4l18.67-6.91c.34-.13.52-.43.52-.74,0-.15-.04-.31-.13-.44s-.21-.24-.39-.3Z"/><path d="M69.5,15.62l-8.77-3.25c-.3-.11-.54-.35-.66-.66l-3.25-8.77c-.06-.16-.2-.24-.35-.24s-.29.08-.35.24l-3.25,8.77c-.11.3-.35.54-.66.66l-8.77,3.25c-.16.06-.24.2-.24.35,0,.14.08.29.24.35l8.77,3.25c.15.06.29.14.4.26.11.11.2.25.26.4l3.25,8.77c.06.16.2.24.35.24s.29-.08.35-.24l3.25-8.77c.06-.15.14-.29.26-.4s.25-.2.4-.26l8.77-3.25c.16-.06.24-.2.24-.35,0-.14-.08-.29-.24-.35Z"/></svg>',
      elements: '<svg width="22" height="22" viewBox="0 0 72 72" fill="currentColor" aria-hidden="true"><path d="M37.64,42.13c-.84-1.45-2.94-1.45-3.78,0l-13.13,22.75c-.84,1.45.21,3.27,1.89,3.27h26.27c1.68,0,2.73-1.82,1.89-3.27l-13.13-22.75Z"/><rect x="42.83" y="4.65" width="25.47" height="25.47" rx="2.18" ry="2.18"/><circle cx="16.73" cy="17.38" r="13.53"/></svg>',
      layers: '<svg width="22" height="22" viewBox="0 0 72 72" fill="currentColor" aria-hidden="true"><path d="M7.06,27.15l26.83,14.29h0c.66.35,1.39.53,2.12.53s1.45-.18,2.12-.53l26.83-14.29c1.02-.54,1.65-1.6,1.65-2.75s-.63-2.2-1.65-2.75l-26.82-14.29c-1.33-.71-2.91-.71-4.24,0L7.06,21.66c-1.02.54-1.65,1.6-1.65,2.75s.63,2.2,1.65,2.75Z"/><path d="M63.01,33.83l-26.01,14.29c-.63.34-1.38.34-2.01,0l-26.01-14.29c-1.61-.89-3.58.28-3.58,2.12h0c0,.88.48,1.69,1.25,2.12l27.17,14.93c.68.37,1.42.56,2.17.56s1.49-.19,2.17-.56l27.17-14.93c.77-.42,1.25-1.24,1.25-2.12,0-1.84-1.97-3-3.58-2.12Z"/><path d="M63.01,45.43l-26.01,14.29c-.63.34-1.38.34-2.01,0l-26.01-14.29c-1.61-.89-3.58.28-3.58,2.12h0c0,.88.48,1.69,1.25,2.12l27.17,14.93c.68.37,1.42.56,2.17.56s1.49-.19,2.17-.56l27.17-14.93c.77-.42,1.25-1.24,1.25-2.12,0-1.84-1.97-3-3.58-2.12Z"/></svg>',
      designs: '<svg width="22" height="22" viewBox="0 0 72 72" fill="currentColor" aria-hidden="true"><path d="M65.14,17.4h-29.3l-7.43-8.24c-.41-.46-1-.72-1.62-.72H6.86c-1.2,0-2.18.98-2.18,2.18v50.75c0,1.2.98,2.18,2.18,2.18h58.29c1.2,0,2.18-.98,2.18-2.18V19.58c0-1.2-.98-2.18-2.18-2.18ZM47.68,39.02c-1.84,5.36-11.59,13.35-11.68,13.43h0s0,0,0,0c0,0,0,0,0,0h0c-.09-.08-9.84-8.08-11.68-13.43h0c-.34-.82-.54-1.71-.54-2.66,0-3.71,2.93-6.71,6.55-6.71,2.44,0,4.54,1.38,5.67,3.4,1.13-2.02,3.23-3.4,5.67-3.4,3.62,0,6.55,3,6.55,6.71,0,.95-.19,1.84-.54,2.66h0Z"/></svg>',
      premade: '<svg width="22" height="22" viewBox="0 0 72 72" fill="currentColor" aria-hidden="true"><rect x="7.51" y="9.12" width="24.26" height="24.26" rx="2.32" ry="2.32"/><rect x="39.73" y="9.12" width="24.26" height="24.26" rx="2.32" ry="2.32"/><rect x="7.51" y="41.35" width="24.26" height="24.26" rx="2.32" ry="2.32"/><rect x="39.73" y="41.35" width="24.26" height="24.26" rx="2.32" ry="2.32"/></svg>'
    },
    lock: s2('<rect x="5" y="9.5" width="11" height="8" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="M7.5 9.5V7a3 3 0 0 1 6 0v2.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>'),
    unlock: s2('<rect x="5" y="9.5" width="11" height="8" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="M7.5 9.5V7a3 3 0 0 1 5.7-1.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>'),
    // Group-align set: a fixed edge/center line + two bars snapping to it
    alignL: s2('<path d="M4 3.5v14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="6.5" y="5.5" width="8" height="3.6" rx="1.1" fill="currentColor"/><rect x="6.5" y="12" width="11" height="3.6" rx="1.1" fill="currentColor"/>'),
    alignCH: s2('<path d="M10.5 3.5v14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="6" y="5.5" width="9" height="3.6" rx="1.1" fill="currentColor"/><rect x="4.5" y="12" width="12" height="3.6" rx="1.1" fill="currentColor"/>'),
    alignR: s2('<path d="M17 3.5v14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="6.5" y="5.5" width="8" height="3.6" rx="1.1" fill="currentColor"/><rect x="3.5" y="12" width="11" height="3.6" rx="1.1" fill="currentColor"/>'),
    alignT: s2('<path d="M3.5 4h14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="5.5" y="6.5" width="3.6" height="8" rx="1.1" fill="currentColor"/><rect x="12" y="6.5" width="3.6" height="11" rx="1.1" fill="currentColor"/>'),
    alignM: s2('<path d="M3.5 10.5h14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="5.5" y="6" width="3.6" height="9" rx="1.1" fill="currentColor"/><rect x="12" y="4.5" width="3.6" height="12" rx="1.1" fill="currentColor"/>'),
    alignB: s2('<path d="M3.5 17h14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="5.5" y="6.5" width="3.6" height="8" rx="1.1" fill="currentColor"/><rect x="12" y="3.5" width="3.6" height="11" rx="1.1" fill="currentColor"/>'),
    distH: s2('<rect x="3" y="5" width="3.4" height="11" rx="1.1" fill="currentColor"/><rect x="8.8" y="5" width="3.4" height="11" rx="1.1" fill="currentColor"/><rect x="14.6" y="5" width="3.4" height="11" rx="1.1" fill="currentColor"/>'),
    distV: s2('<rect x="5" y="3" width="11" height="3.4" rx="1.1" fill="currentColor"/><rect x="5" y="8.8" width="11" height="3.4" rx="1.1" fill="currentColor"/><rect x="5" y="14.6" width="11" height="3.4" rx="1.1" fill="currentColor"/>'),
    layers: s2('<path d="M10.5 3 17.5 7l-7 4-7-4 7-4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M3.5 10.8l7 4 7-4M3.5 14.4l7 4 7-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>'),
    grip: s2('<g fill="currentColor"><circle cx="7.5" cy="5" r="1.5"/><circle cx="13.5" cy="5" r="1.5"/><circle cx="7.5" cy="10.5" r="1.5"/><circle cx="13.5" cy="10.5" r="1.5"/><circle cx="7.5" cy="16" r="1.5"/><circle cx="13.5" cy="16" r="1.5"/></g>'),
    home: s2('<path d="M3.5 9.6 10.5 3.5l7 6.1M5.5 8.5v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8M8.5 17.5v-4.5h4v4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>'),
    // Selection rotate knob (DOM glass button under the box — Owen 9-21); geometry mirrors the old canvas glyph
    rotate: s2('<path d="M3.05 7.47A7.4 7.4 0 0 1 16.06 5.76 M16.95 12.53A7.4 7.4 0 0 1 3.94 14.24" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/><path d="M19.04 10.02L18.85 3.81L13.28 7.71Z M0.96 9.98L1.15 16.19L6.72 12.29Z" fill="currentColor"/>', "0 0 20 20", 18),
    // Grid / rulers (canvas view options)
    grid: s2('<path d="M4 4h13v13H4z M8.3 4v13 M12.7 4v13 M4 8.3h13 M4 12.7h13" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'),
    ruler: s2('<rect x="3" y="8" width="15" height="5.5" rx="1.2" transform="rotate(-25 10.5 10.75)" stroke="currentColor" stroke-width="1.5"/><path d="M7 11.9l1-2.1M10 10.5l1-2.1M13 9.1l1-2.1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" transform="rotate(0)"/>'),
    // Floppy (quick save)
    save: s2('<path d="M5 3.5h8.2L16.5 6.8V16a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 16V5A1.5 1.5 0 0 1 5 3.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M7 3.8v3.4h5.4V3.8" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><rect x="6.6" y="10.6" width="6.8" height="6.6" rx="0.8" fill="currentColor"/>'),
    // Adjustments: three slider tracks with staggered knobs (Owen 9-07 screenshot)
    sliders: s2('<path d="M3.5 5.5h6.5M14.6 5.5h2.9M3.5 10.5h1.9M9.6 10.5h7.9M3.5 15.5h5.2M13.3 15.5h4.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="10.6" y="3.7" width="3.4" height="3.6" rx="1" fill="currentColor"/><rect x="5.9" y="8.7" width="3.4" height="3.6" rx="1" fill="currentColor"/><rect x="9.3" y="13.7" width="3.4" height="3.6" rx="1" fill="currentColor"/>'),
    text: s2('<path d="M4 6V4h13v2M10.5 4v13M8 17h5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>'),
    uploads: s2('<path d="M10.5 13V3.5M6.8 7.2l3.7-3.7 3.7 3.7M4 14.5v2a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5v-2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>'),
    ai: s2('<path d="M10.5 3l1.7 4.6L17 9.5l-4.8 1.9-1.7 4.6-1.7-4.6L4 9.5l4.8-1.9L10.5 3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>'),
    elements: s2('<rect x="3.5" y="3.5" width="9" height="9" rx="1.5" stroke="currentColor" stroke-width="1.6"/><circle cx="13.5" cy="13.5" r="4" stroke="currentColor" stroke-width="1.6"/>'),
    designs: s2('<circle cx="10.5" cy="10.5" r="7" stroke="currentColor" stroke-width="1.6"/><path d="M10.5 6.5v4l2.8 1.7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>'),
    // Pre-Made Designs: library spines + tilted book (same motif as the PDP's ndl tab)
    premade: s2('<rect x="3.2" y="3.2" width="3.7" height="14.6" rx="1" stroke="currentColor" stroke-width="1.5"/><rect x="8.5" y="3.2" width="3.7" height="14.6" rx="1" stroke="currentColor" stroke-width="1.5"/><path d="M13.9 4.5l3.4.9-3.5 12.8-3.4-.9z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'),
    layers: s2('<path d="M8 2l6 3.2L8 8.4 2 5.2 8 2z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M2 8.2l6 3.2 6-3.2M2 11.2l6 3.2 6-3.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 16 16", 16),
    undo: s2('<path d="M6.5 4L3 7.5 6.5 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 7.5h7.5a4 4 0 0 1 0 8H8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', "0 0 18 18", 17),
    redo: s2('<path d="M11.5 4L15 7.5 11.5 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 7.5H7.5a4 4 0 0 0 0 8H10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', "0 0 18 18", 17),
    arrow: s2('<path d="M3 7.5h9M8.5 4l3.5 3.5L8.5 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 15 15", 14),
    chevronDown: s2('<path d="M2.5 4l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 11 11", 11),
    alignLeft: s2('<path d="M2.5 4h12M2.5 8.5h8M2.5 13h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', "0 0 17 17", 16),
    alignCenter: s2('<path d="M2.5 4h12M4.5 8.5h8M2.5 13h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', "0 0 17 17", 16),
    alignRight: s2('<path d="M2.5 4h12M6.5 8.5h8M2.5 13h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', "0 0 17 17", 16),
    trash: s2('<path d="M3 4.5h11M6 4.5V3h5v1.5M4.5 4.5l.7 9a1.5 1.5 0 0 0 1.5 1.4h3.6a1.5 1.5 0 0 0 1.5-1.4l.7-9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 17 17", 16),
    expand: s2('<path d="M9 2h4v4M13 2L8.5 6.5M6 13H2V9M2 13l4.5-4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 15 15", 14),
    search: s2('<circle cx="6" cy="6" r="4.2" stroke="currentColor" stroke-width="1.5"/><path d="M9.2 9.2L12.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>', "0 0 14 14", 13),
    check: s2('<path d="M3 8.5l3.4 3.4L13 5.3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 16 16", 15),
    close: s2('<path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', "0 0 16 16", 15),
    phone: s2('<rect x="5.5" y="2" width="10" height="17" rx="2.2" stroke="currentColor" stroke-width="1.6"/><path d="M9 16.2h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', "0 0 21 21", 18),
    arrowLeft: s2('<path d="M13.5 8H2.5M7 3.5L2.5 8 7 12.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 16 16", 16),
    arrowDown: s2('<path d="M8 2.5v11M3.8 9.3L8 13.5l4.2-4.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 16 16", 16),
    arrowUp: s2('<path d="M8 13.5v-11M3.8 6.7L8 2.5l4.2 4.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 16 16", 16),
    dots: s2('<circle cx="3.5" cy="8" r="1.4" fill="currentColor"/><circle cx="8" cy="8" r="1.4" fill="currentColor"/><circle cx="12.5" cy="8" r="1.4" fill="currentColor"/>', "0 0 16 16", 16),
    copy: s2('<rect x="5.5" y="5.5" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.5"/><path d="M3 10.5V3.9C3 3.4 3.4 3 3.9 3h6.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>', "0 0 16 16", 16),
    duplicate: s2('<rect x="5.5" y="5.5" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.5"/><path d="M3 10.5V3.9C3 3.4 3.4 3 3.9 3h6.6M9.5 8v3M8 9.5h3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>', "0 0 16 16", 16),
    clipboard: s2('<rect x="3.5" y="3" width="9" height="11" rx="1.5" stroke="currentColor" stroke-width="1.5"/><path d="M6 3.2V2h4v1.2M6 7h4M6 10h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>', "0 0 16 16", 16),
    chevronRight: s2('<path d="M4 2.5l3 3-3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 11 11", 11),
    alignPage: s2('<path d="M3 2.5v11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><rect x="5.5" y="4" width="7.5" height="2.6" rx="1" fill="currentColor"/><rect x="5.5" y="9" width="4.5" height="2.6" rx="1" fill="currentColor"/>', "0 0 16 16", 16),
    // Material Symbols "colorize" (Owen-supplied), recolored via currentColor.
    dropper: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 -960 960 960" fill="currentColor"><path d="M120-120v-190l358-358-58-56 58-56 76 76 124-124q5-5 12.5-8t15.5-3q8 0 15 3t13 8l94 94q5 6 8 13t3 15q0 8-3 15.5t-8 12.5L705-555l76 78-57 57-56-58-358 358H120Zm80-80h78l332-334-76-76-334 332v78Z"/></svg>',
    dotsV: s2('<circle cx="8" cy="3" r="1.4" fill="currentColor"/><circle cx="8" cy="8" r="1.4" fill="currentColor"/><circle cx="8" cy="13" r="1.4" fill="currentColor"/>', "0 0 16 16", 16),
    // Group: two overlapping frames; ungroup: the frames pulled apart
    group: s2('<rect x="2.5" y="2.5" width="10.5" height="10.5" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M15 8h1.5A2 2 0 0 1 18.5 10v6.5a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', "0 0 21 21", 16),
    ungroup: s2('<rect x="2.5" y="2.5" width="7.5" height="7.5" rx="1.8" stroke="currentColor" stroke-width="1.6"/><rect x="11" y="11" width="7.5" height="7.5" rx="1.8" stroke="currentColor" stroke-width="1.6"/>', "0 0 21 21", 16),
    // Flip: solid shape + dashed mirror axis + outlined mirror image
    flipH: s2('<path d="M10.5 2.5v16" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-dasharray="0.2 3" /><path d="M7.5 6L3 10.5L7.5 15z" fill="currentColor"/><path d="M13.5 6L18 10.5L13.5 15z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" fill="none"/>', "0 0 21 21", 16),
    flipV: s2('<path d="M2.5 10.5h16" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-dasharray="0.2 3"/><path d="M6 7.5L10.5 3L15 7.5z" fill="currentColor"/><path d="M6 13.5L10.5 18L15 13.5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" fill="none"/>', "0 0 21 21", 16),
    plus: s2('<path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>', "0 0 16 16", 14),
    bullets: s2('<circle cx="2.4" cy="3.7" r="1.2" fill="currentColor"/><circle cx="2.4" cy="8.5" r="1.2" fill="currentColor"/><circle cx="2.4" cy="13.3" r="1.2" fill="currentColor"/><path d="M6 3.7h8.5M6 8.5h8.5M6 13.3h8.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', "0 0 17 17", 16),
    spacing: s2('<path d="M4.5 3h8M8.5 3v6.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M2.5 13.5h12M4.6 11.4l-2.1 2.1 2.1 2.1M12.4 11.4l2.1 2.1-2.1 2.1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>', "0 0 17 17", 17),
    // Google Drive triangle — brand-colored fills (approximation of the official mark)
    drive: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M8.7 2.5L0.9 16l3.9 6.8L12.6 9.3 8.7 2.5z" fill="#0F9D58"/><path d="M8.7 2.5h7.8L24.3 16h-7.8L8.7 2.5z" fill="#4285F4"/><path d="M4.8 22.8h15.6l3.9-6.8H8.7l-3.9 6.8z" fill="#FBBC04"/></svg>'
  };

  // src/micons.js
  var M2 = (path, size = 22) => '<svg width="' + size + '" height="' + size + '" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true"><path d="' + path + '"/></svg>';
  var micons = {
    layers: M2("M480-160 200-380l66-50 214 168 214-168 66 50-280 220Zm0-206L200-586l280-220 280 220-280 220Z"),
    more: M2("M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z"),
    close: M2("m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"),
    check: M2("M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"),
    canvas: M2("M600-320h140q17 0 28.5-11.5T780-360v-100h-60v100H600v60ZM220-520h60v-100h140v-60H240q-17 0-28.5 11.5T200-640v120ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Z"),
    add: M2("M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"),
    expand: M2("M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z"),
    // extras the mobile trays/stripe may want, kept here so all new icons match:
    // opacity (water-drop half-fill) — shape/line transparency chips
    opacity: M2("M480-120q-133 0-226.5-92T160-436q0-66 25-122t69-100l226-222 226 222q44 44 69 100t25 122q0 132-93.5 224T480-120Zm0-80q100 0 170-68.5T720-436q0-27-6-52t-18-47L480-360 264-535q-12 22-18 47t-6 52q0 99 70 167.5T480-200Z"),
    // horizontal rule — border style chips
    hrule: M2("M160-440v-80h640v80H160Z"),
    // pen-size-ish diagonal — line style chip
    lineStyle: M2("m216-160-56-56 464-464-88-88 56-56 88 88 56-56 56 56-56 56 88 88-56 56-88-88-464 464Z"),
    // arrow range — line end-caps chip
    arrowRange: M2("M280-280 80-480l200-200 56 57-103 103h494L624-623l56-57 200 200-200 200-56-57 103-103H233l103 103-56 57Z"),
    crop: M2("M680-40v-160H280q-33 0-56.5-23.5T200-280v-400H40v-80h160v-160h80v640h640v80H760v160h-80Zm0-320v-320H360v-80h320q33 0 56.5 23.5T760-680v320h-80Z"),
    tune: M2("M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z"),
    eraser: M2("M690-240h190v80H610l80-80Zm-500 80-85-85q-23-23-23.5-57t22.5-58l440-456q23-24 56.5-24t56.5 23l199 199q23 23 23 57t-23 57L520-160H190Zm296-80 314-322-198-198-442 456 64 64h262Z"),
    corner: M2("M120-120v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80h80v80h-80ZM120-280v-80h80v80h-80Zm640 0v-160q0-50-35-85t-85-35H480v-80h160q83 0 141.5 58.5T840-440v160h-80ZM120-440v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80h80v80h-80Z"),
    restore: M2("M480-120q-138 0-240.5-91.5T122-440h82q14 104 92.5 172T480-200q117 0 198.5-81.5T760-480q0-117-81.5-198.5T480-760q-69 0-129 32t-101 88h110v80H120v-240h80v94q51-64 124.5-99T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Zm112-192L440-464v-216h80v184l128 128-56 56Z"),
    star: M2("m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z"),
    ring: M2("M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Z"),
    filterIc: M2("M480-120q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-480q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840v80q-117 0-198.5 81.5T200-480q0 117 81.5 198.5T480-200q117 0 198.5-81.5T760-480h80q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Zm320-560-40-88-88-40 88-40 40-88 40 88 88 40-88 40-40 88Z"),
    pencil: M2("M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"),
    zoom: M2("M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"),
    colorize: M2("M619-527 421-725l43-43q34-34 81.5-34t81.5 34l14 14 43-43q11-11 28-11t28 11q11 11 11 28t-11 28l-43 43 14 14q34 34 34 81.5T765-539l-43 43-103-31ZM234-80q-11 0-21-4t-18-12l-19-19q-8-8-12-18t-4-21q0-11 4-21t12-18l278-278-42-42q-11-11-11-28t11-28q11-11 28-11t28 11l248 248q11 11 11 28t-11 28q-11 11-28 11t-28-11l-42-42-278 278q-8 8-18 12t-21 4Z"),
    palette: M2("M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 32.5-156.5t88-128Q256-818 330-849t156-31q80 0 151 27.5t124.5 76q53.5 48.5 85 115T878-518q0 115-70 176.5T640-280h-74q-9 0-12.5 5t-3.5 11q0 12 15 34.5t15 51.5q0 50-27.5 78.5T480-80ZM240-440q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm120-160q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm240 0q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm120 160q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Z")
  };

  // src/text-treatments.js
  var TEXT_TREATMENTS = [
    {
      key: "varsity",
      label: "Varsity",
      text: "CHAMPS",
      family: "Anton",
      weight: 400,
      fontSize: 130,
      charSpacing: 40,
      fill: "#1e40af",
      effect: { kind: "outline", color: "#fbbf24", size: 6 },
      shape: { kind: "arcup", amount: 55 }
    },
    {
      key: "game-day",
      label: "Game Day",
      text: "GAME",
      family: "Anton",
      weight: 400,
      fontSize: 150,
      fill: "#0f172a",
      dark: { fill: "#ffffff" },
      sub: {
        text: "day",
        family: "Pacifico",
        weight: 400,
        fontSize: 115,
        fill: "#ef4444",
        dy: 60,
        effect: { kind: "outline", color: "#ffffff", size: 4 }
      }
    },
    {
      key: "retro-drop",
      label: "Retro Drop",
      text: "RETRO",
      family: "Bungee",
      weight: 400,
      fontSize: 115,
      fill: "#f97316",
      effect: { kind: "drop", color: "#7c2d12" },
      fx: { direction: 135, offset: 60 }
    },
    {
      key: "sticker-pop",
      label: "Sticker Pop",
      text: "POP!",
      family: "Baloo 2",
      weight: 800,
      fontSize: 140,
      fill: "#ec4899",
      effect: { kind: "outline", color: "#ffffff", size: 8 },
      tileBg: "#dbeafe"
    },
    {
      key: "sunset-script",
      label: "Sunset Script",
      text: "Sunset",
      family: "Kaushan Script",
      weight: 400,
      fontSize: 135,
      gradient: { a: "#f59e0b", b: "#ef4444", angle: 0 }
    },
    {
      key: "hollow",
      label: "Hollow",
      text: "HOLLOW",
      family: "Anton",
      weight: 400,
      fontSize: 120,
      charSpacing: 30,
      fill: "#0f172a",
      effect: { kind: "hollow", color: "#0f172a", size: 45 },
      dark: { effect: { kind: "hollow", color: "#ffffff", size: 45 } }
    },
    {
      key: "echo",
      label: "Echo",
      text: "ECHO",
      family: "Poppins",
      weight: 900,
      fontSize: 125,
      fill: "#0ea5e9",
      effect: { kind: "echo", color: "#94a3b8" },
      fx: { direction: 0, offset: 60, echo2: "#cbd5e1" }
    },
    {
      key: "badge-plate",
      label: "Badge Plate",
      text: "EST \u2022 2026",
      family: "Oswald",
      weight: 600,
      fontSize: 95,
      charSpacing: 150,
      fill: "#ffffff",
      effect: { kind: "background", color: "#0f172a" },
      fx: { round: 70, spread: 55 },
      dark: { fill: "#0f172a", effect: { kind: "background", color: "#ffffff" } }
    },
    {
      key: "wave",
      label: "Wave",
      text: "make waves",
      family: "Fredoka",
      weight: 600,
      fontSize: 105,
      fill: "#06b6d4",
      shape: { kind: "wave", amount: 65 }
    },
    {
      key: "signature",
      label: "Signature",
      text: "Forever yours",
      family: "Great Vibes",
      weight: 400,
      fontSize: 145,
      fill: "#111827",
      dark: { fill: "#ffffff" }
    },
    {
      key: "splice",
      label: "Splice",
      text: "SLICE",
      family: "Anton",
      weight: 400,
      fontSize: 130,
      fill: "#0f172a",
      effect: { kind: "splice", color: "#f43f5e" },
      fx: { direction: 45, offset: 55 },
      dark: { fill: "#ffffff" }
    },
    {
      key: "steel",
      label: "Steel",
      text: "TITAN",
      family: "Orbitron",
      weight: 800,
      fontSize: 110,
      charSpacing: 60,
      gradient: { a: "#94a3b8", b: "#e2e8f0", angle: 90 },
      effect: { kind: "drop", color: "#0f172a" },
      fx: { direction: 90, offset: 30 }
    },
    {
      key: "comic-blast",
      label: "Comic Blast",
      text: "BAM!",
      family: "Bangers",
      weight: 400,
      fontSize: 145,
      charSpacing: 60,
      fill: "#facc15",
      effect: { kind: "outline", color: "#0f172a", size: 6 },
      shape: { kind: "bulge", amount: 45 }
    },
    {
      key: "stamp",
      label: "Stamp",
      text: "AUTHENTIC",
      family: "Special Elite",
      weight: 400,
      fontSize: 90,
      charSpacing: 180,
      fill: "#7c2d12"
    },
    {
      key: "tall-stack",
      label: "Tall Stack",
      text: "STAY\nHUNGRY",
      family: "Barlow Condensed",
      weight: 800,
      fontSize: 120,
      lineHeight: 0.92,
      charSpacing: 60,
      fill: "#0f172a",
      dark: { fill: "#ffffff" }
    },
    {
      key: "western",
      label: "Western",
      text: "RODEO",
      family: "Rye",
      weight: 400,
      fontSize: 110,
      fill: "#92400e",
      effect: { kind: "drop", color: "#fbbf24" },
      fx: { direction: 90, offset: 45 }
    },
    {
      key: "arcade",
      label: "Arcade",
      text: "PLAYER 1",
      family: "Press Start 2P",
      weight: 400,
      fontSize: 75,
      fill: "#22c55e",
      effect: { kind: "drop", color: "#0f172a" },
      fx: { direction: 90, offset: 40 }
    },
    {
      key: "kawaii",
      label: "Kawaii",
      text: "cutie",
      family: "Chewy",
      weight: 400,
      fontSize: 140,
      fill: "#f472b6",
      effect: { kind: "outline", color: "#ffffff", size: 7 },
      tileBg: "#fce7f3"
    },
    {
      key: "speed",
      label: "Speed",
      text: "FAST",
      italic: true,
      family: "Exo 2",
      weight: 900,
      fontSize: 130,
      fill: "#0f172a",
      effect: { kind: "echo", color: "#94a3b8" },
      fx: { direction: 180, offset: 55, echo2: "#cbd5e1" },
      dark: { fill: "#ffffff" }
    },
    {
      key: "groovy",
      label: "Groovy",
      text: "groovy",
      family: "Boogaloo",
      weight: 400,
      fontSize: 135,
      fill: "#a855f7",
      shape: { kind: "arclo", amount: 55 }
    },
    {
      key: "slant",
      label: "Slant",
      text: "VICTORY",
      family: "Teko",
      weight: 600,
      fontSize: 130,
      charSpacing: 80,
      fill: "#dc2626",
      shape: { kind: "angle", amount: 35 }
    },
    {
      key: "ring-badge",
      label: "Badge Arc",
      text: "ORIGINAL",
      family: "Oswald",
      weight: 600,
      fontSize: 105,
      charSpacing: 250,
      fill: "#0f766e",
      shape: { kind: "curve", amount: 55 }
    },
    {
      key: "athletic-club",
      label: "Athletic Club",
      text: "NINJA",
      family: "Anton",
      weight: 400,
      fontSize: 135,
      charSpacing: 60,
      fill: "#0f172a",
      shape: { kind: "arcup", amount: 45 },
      dark: { fill: "#ffffff" },
      sub: {
        text: "ATHLETIC DEPT",
        family: "Oswald",
        weight: 500,
        fontSize: 42,
        charSpacing: 320,
        fill: "#dc2626",
        dy: 110
      }
    }
  ];
  function applyTreatment(editor, preset) {
    return editor.addTreatedText(preset);
  }
  var thumbCache = /* @__PURE__ */ new Map();
  function treatmentThumb(editor, preset, px = 300) {
    let p2 = thumbCache.get(preset.key);
    if (!p2) {
      p2 = renderThumb(editor, preset, px);
      thumbCache.set(preset.key, p2);
    }
    return p2;
  }
  async function renderThumb(editor, preset, px) {
    const parts = [preset, ...preset.sub ? [preset.sub] : []];
    for (const part of parts) {
      await loadFont(part.family);
      if (part.shape) {
        try {
          await ensureFontBinary(part.family, part.weight || 400, !!part.italic);
        } catch (e24) {
        }
      }
    }
    const boxes = [];
    for (const part of parts) {
      const b2 = await editor.buildTreatedText(part);
      b2.left = part.dx || 0;
      b2.top = part.dy || 0;
      b2.setCoords();
      boxes.push(b2);
    }
    let l2 = Infinity, t2 = Infinity, r2 = -Infinity, btm = -Infinity;
    for (const b2 of boxes) {
      const bb = b2.getBoundingRect();
      l2 = Math.min(l2, bb.left);
      t2 = Math.min(t2, bb.top);
      r2 = Math.max(r2, bb.left + bb.width);
      btm = Math.max(btm, bb.top + bb.height);
    }
    const k2 = Math.min(px * 0.84 / Math.max(1, r2 - l2), px * 0.66 / Math.max(1, btm - t2));
    const sc2 = new yt(void 0, {
      width: px,
      height: px,
      backgroundColor: preset.tileBg || "",
      renderOnAddRemove: false
    });
    const ucx = (l2 + r2) / 2, ucy = (t2 + btm) / 2;
    for (const b2 of boxes) {
      b2.scaleX = b2.scaleY = k2;
      b2.left = px / 2 + (b2.left - ucx) * k2;
      b2.top = px / 2 + (b2.top - ucy) * k2;
      b2.setCoords();
      sc2.add(b2);
    }
    sc2.renderAll();
    const url = sc2.toDataURL({ format: "png" });
    sc2.dispose();
    return url;
  }

  // src/ui.js
  var el = (tag, cls, html) => {
    const n2 = document.createElement(tag);
    if (cls) n2.className = tag === "div" ? cls + " w3_bg" : cls;
    else if (tag === "div") n2.className = "w3_bg";
    if (html != null) n2.innerHTML = html;
    return n2;
  };
  function buildUI(host, opts) {
    host.classList.add("nsv2-host");
    const root = el("div", "nsv2");
    const topbar = el("div", "nsv2-topbar");
    const topLeft = el("div", "nsv2-top-left");
    const homeBtn = el(
      "button",
      "nsv2-home-btn",
      '<svg width="14" height="14" viewBox="0 0 15 15" fill="none"><path d="M9.5 2.5 4.5 7.5l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="nsv2-home-lab">Exit</span>'
    );
    homeBtn.type = "button";
    homeBtn.title = "Exit the studio (back to where you came from)";
    const canvasSizeWrap = el("div", "nsv2-canvas-size");
    const boardC = boardCfg();
    const unit = unitLabel();
    const mkSizeInput = (label) => {
      const i2 = document.createElement("input");
      i2.type = "number";
      i2.className = "nsv2-size-in";
      i2.min = String(boardC.min);
      i2.max = String(boardC.max);
      i2.step = String(boardC.step);
      i2.setAttribute("aria-label", "Canvas " + label + " (" + unitWord() + ")");
      return i2;
    };
    const sizeW = mkSizeInput("width");
    const sizeH = mkSizeInput("height");
    const sizeSel = document.createElement("select");
    sizeSel.className = "nsv2-select nsv2-canvas-sel";
    sizeSel.setAttribute("aria-label", "Canvas size");
    for (const [w2, h2, use] of boardC.presets) {
      const o2 = document.createElement("option");
      o2.value = w2 + "x" + h2;
      o2.textContent = w2 + " " + unit + " x " + h2 + " " + unit;
      o2.title = use;
      sizeSel.appendChild(o2);
    }
    const sizeCustomOpt = document.createElement("option");
    sizeCustomOpt.value = "custom";
    sizeCustomOpt.textContent = "Custom size\u2026";
    sizeSel.appendChild(sizeCustomOpt);
    const sizeCustom = el("div", "nsv2-canvas-custom");
    sizeCustom.hidden = true;
    sizeCustom.append(sizeW, el("span", "nsv2-size-x", "\xD7"), sizeH, el("span", "nsv2-size-unit", unit));
    canvasSizeWrap.append(sizeSel, sizeCustom);
    const bgBtn = el("button", "nsv2-ctx-color nsv2-canvas-bg", '<span class="nsv2-color-disc nsv2-canvas-bg-swatch"></span>');
    bgBtn.type = "button";
    bgBtn.title = "Canvas color \u2014 preview only, will not print";
    const bgSwatch = bgBtn.firstChild;
    const bgColorInput = document.createElement("input");
    bgColorInput.type = "color";
    bgColorInput.className = "nsv2-bg-color-input";
    bgColorInput.value = "#ffffff";
    bgBtn.appendChild(bgColorInput);
    const bgClear = el("button", "nsv2-bg-clear", icons.close);
    bgClear.type = "button";
    bgClear.title = "Remove canvas color";
    bgClear.hidden = true;
    const bgWarn = el("span", "nsv2-canvas-warn", "Preview only \u2014 won\u2019t print");
    bgWarn.hidden = true;
    const bgAlert = el(
      "div",
      "nsv2-bg-alert",
      '<span class="nsv2-bg-alert-ic" aria-hidden="true">!</span><span class="nsv2-bg-alert-msg">Background color is for preview only and will not be printed.</span><button type="button" class="nsv2-bg-alert-x" title="Dismiss">' + icons.close + "</button>"
    );
    bgAlert.hidden = true;
    const fitAlert = el(
      "div",
      "nsv2-bg-alert nsv2-fit-alert",
      '<span class="nsv2-bg-alert-ic" aria-hidden="true">!</span><span class="nsv2-bg-alert-msg">Part of your design is off the canvas and won\u2019t print.</span><button type="button" class="nsv2-bg-alert-act">Fit to canvas</button><button type="button" class="nsv2-bg-alert-x" title="Dismiss">' + icons.close + "</button>"
    );
    fitAlert.hidden = true;
    const fitAlertMsg = fitAlert.querySelector(".nsv2-bg-alert-msg");
    const toast = el(
      "div",
      "nsv2-bg-alert nsv2-toast",
      '<span class="nsv2-bg-alert-msg"></span><button type="button" class="nsv2-bg-alert-act"></button><button type="button" class="nsv2-bg-alert-x" title="Dismiss">' + icons.close + "</button>"
    );
    toast.hidden = true;
    const toastMsg = toast.querySelector(".nsv2-bg-alert-msg");
    const toastAct = toast.querySelector(".nsv2-bg-alert-act");
    const toastX = toast.querySelector(".nsv2-bg-alert-x");
    const fitAlertAct = fitAlert.querySelector(".nsv2-bg-alert-act");
    const fitAlertX = fitAlert.querySelector(".nsv2-bg-alert-x");
    const fileBtn = el("button", "nsv2-file-btn", "File");
    fileBtn.type = "button";
    const fileMenu = el("div", "nsv2-file-menu");
    fileMenu.hidden = true;
    const fileItem = (label) => {
      const b2 = el("button", "nsv2-file-item", label);
      b2.type = "button";
      fileMenu.appendChild(b2);
      return b2;
    };
    const fileNew = fileItem("New Design");
    const fileOpen = fileItem("Open");
    const fileSave = fileItem("Save");
    const fileSaveAs = fileItem("Save as");
    const fileDup = fileItem("Duplicate Design");
    const fileOutlineMode = fileItem("Outline scales with object");
    fileOutlineMode.classList.add("nsv2-file-check");
    const fileSignIn = fileItem("Sign in");
    fileSignIn.hidden = true;
    const fileBuild = el("div", "nsv2-file-build", "");
    fileMenu.appendChild(fileBuild);
    const fileWrap = el("div", "nsv2-file-wrap");
    fileWrap.append(fileBtn, fileMenu);
    const undoBtn = el("button", "nsv2-icon-btn", icons.undo);
    const redoBtn = el("button", "nsv2-icon-btn", icons.redo);
    undoBtn.type = redoBtn.type = "button";
    undoBtn.title = "Undo";
    redoBtn.title = "Redo";
    topLeft.append(homeBtn, fileWrap, undoBtn, redoBtn);
    const topRight = el("div", "nsv2-top-right");
    const useBtn = el("button", "nsv2-cta", "<span>Use Design</span>" + icons.arrow);
    useBtn.type = "button";
    const saveBtn = el("button", "nsv2-icon-btn nsv2-save-btn", icons.save + '<span class="nsv2-visually-hidden">Save</span>');
    saveBtn.type = "button";
    saveBtn.title = "Save to your account";
    const designNameInput = el("input", "nsv2-design-name");
    designNameInput.type = "text";
    designNameInput.placeholder = "Untitled design";
    designNameInput.maxLength = 60;
    designNameInput.setAttribute("aria-label", "Design name");
    const savePop = el("div", "nsv2-save-pop");
    savePop.hidden = true;
    const saveUpdateBtn = el("button", "nsv2-save-pop-btn nsv2-save-pop-btn--primary");
    saveUpdateBtn.type = "button";
    const saveNewBtn = el("button", "nsv2-save-pop-btn", "Save as new design");
    saveNewBtn.type = "button";
    savePop.append(saveUpdateBtn, saveNewBtn);
    const saveWrap = el("div", "nsv2-save-wrap");
    saveWrap.append(saveBtn, savePop);
    const topVdiv = el("div", "nsv2-vdiv");
    topRight.append(saveWrap, topVdiv, useBtn);
    topbar.append(topLeft, designNameInput, topRight);
    const useModal = el("div", "nsv2-use-modal");
    useModal.hidden = true;
    const useCard = el("div", "nsv2-use-card");
    const useClose = el("button", "nsv2-icon-btn nsv2-use-close", icons.close);
    useClose.type = "button";
    useClose.title = "Cancel";
    const useTitle = el("div", "nsv2-use-title", "Use this design on\u2026");
    const useSub = el("div", "nsv2-use-sub", "Pick a product \u2014 your design comes with you.");
    const useGrid = el("div", "nsv2-use-grid");
    const useBusy = el("div", "nsv2-use-busy", "Preparing your design\u2026");
    useBusy.hidden = true;
    useCard.append(useClose, useTitle, useSub, useGrid, useBusy);
    useModal.appendChild(useCard);
    root.appendChild(useModal);
    const rail = el("div", "nsv2-rail");
    const tools = [
      // Rail glyphs = icons.rail (Owen's filled set, 9-21); fall back to the stroke icon if a tool has none.
      { id: "text", label: "Text", icon: icons.rail.text || icons.text },
      { id: "uploads", label: "Uploads", icon: icons.rail.uploads || icons.uploads },
      { id: "ai", label: "Create AI", icon: icons.rail.ai || icons.ai },
      { id: "elements", label: "Elements", icon: icons.rail.elements || icons.elements },
      { id: "layers", label: "Layers", icon: icons.rail.layers || icons.layers },
      { id: "designs", label: "My Designs", icon: icons.rail.designs || icons.designs },
      { id: "premade", label: "Pre-Made Designs", icon: icons.rail.premade || icons.premade }
    ];
    const toolBtns = {};
    tools.forEach((t2) => {
      const b2 = el("button", "nsv2-tool" + (t2.soon ? " is-soon" : ""), t2.icon + '<span class="nsv2-tool-label">' + t2.label + "</span>");
      b2.type = "button";
      b2.dataset.tool = t2.id;
      if (t2.soon) b2.title = "Coming soon";
      rail.appendChild(b2);
      toolBtns[t2.id] = b2;
    });
    const panel = el("div", "nsv2-panel");
    const panelClose = el("button", "nsv2-icon-btn nsv2-panel-close", icons.close);
    panelClose.title = "Close";
    panelClose.type = "button";
    const textPane = el("div", "nsv2-pane");
    textPane.dataset.pane = "text";
    const addTextBtn = el("button", "nsv2-add-text", icons.text + "<span>Add text</span>");
    addTextBtn.type = "button";
    const treatmentTiles = el("div", "nsv2-tt-tiles");
    for (const p2 of TEXT_TREATMENTS) {
      const tile = el(
        "button",
        "nsv2-fx-tile nsv2-tt-tile",
        '<span class="nsv2-fx-box"><img class="nsv2-tt-thumb" alt="" draggable="false" hidden></span><span class="nsv2-fx-label">' + p2.label + "</span>"
      );
      tile.type = "button";
      tile.dataset.tt = p2.key;
      if (p2.tileBg) tile.querySelector(".nsv2-fx-box").style.background = p2.tileBg;
      treatmentTiles.appendChild(tile);
    }
    textPane.append(
      el("div", "nsv2-pane-title", "Text"),
      addTextBtn,
      el("div", "nsv2-pane-label", "Text styles"),
      treatmentTiles
    );
    const fontsPane = el("div", "nsv2-pane");
    fontsPane.dataset.pane = "fonts";
    const fontsBackBtn = el("button", "nsv2-icon-btn nsv2-pane-back", icons.arrowLeft);
    fontsBackBtn.type = "button";
    fontsBackBtn.title = "Back";
    const fontsHead = el("div", "nsv2-pane-head");
    fontsHead.append(fontsBackBtn, el("div", "nsv2-pane-title", "Fonts"));
    const fontSearch = el("input", "nsv2-font-search");
    fontSearch.type = "text";
    fontSearch.placeholder = "Search fonts\u2026";
    const fontCats = el("div", "nsv2-font-cats");
    const fontList = el("div", "nsv2-font-list");
    fontsPane.append(fontsHead, fontSearch, fontCats, fontList);
    const colorPane = el("div", "nsv2-pane");
    colorPane.dataset.pane = "color";
    const colorBackBtn = el("button", "nsv2-icon-btn nsv2-pane-back", icons.arrowLeft);
    colorBackBtn.type = "button";
    colorBackBtn.title = "Back";
    const colorTitle = el("div", "nsv2-pane-title", "Text color");
    const colorHead = el("div", "nsv2-pane-head");
    colorHead.append(colorBackBtn, colorTitle);
    const colorSearch = el("input", "nsv2-font-search");
    colorSearch.type = "text";
    colorSearch.placeholder = 'Try "blue" or "#00c4cc"';
    const colorMain = el("div", "nsv2-color-main");
    const customColorInput = el("input");
    customColorInput.type = "color";
    customColorInput.className = "nsv2-color-native";
    customColorInput.dataset.spectrumDirect = "1";
    const customColorBtn = el("button", "nsv2-swatch nsv2-swatch--custom", icons.plus);
    customColorBtn.type = "button";
    customColorBtn.title = "Custom color";
    const dropperBtn = el("button", "nsv2-swatch nsv2-swatch--tool", icons.dropper);
    dropperBtn.type = "button";
    dropperBtn.title = "Pick from screen";
    const currentSwatch = el("button", "nsv2-swatch is-active");
    currentSwatch.type = "button";
    currentSwatch.title = "Current color";
    const colorToolsRow = el("div", "nsv2-color-row");
    const colorNoFill = el("button", "nsv2-swatch nsv2-swatch--transparent");
    colorNoFill.type = "button";
    colorNoFill.title = "Transparent";
    colorNoFill.hidden = true;
    colorToolsRow.append(customColorBtn, dropperBtn, colorNoFill, currentSwatch, customColorInput);
    const designLabel = el("div", "nsv2-pane-label", "Colors in this design");
    const designGrid = el("div", "nsv2-color-grid");
    const defaultsHead = el("div", "nsv2-color-defaults-head");
    const seeAllBtn = el("button", "nsv2-see-all", "See all");
    seeAllBtn.type = "button";
    defaultsHead.append(el("div", "nsv2-pane-label", "Default solid colors"), seeAllBtn);
    const defaultGrid = el("div", "nsv2-color-grid");
    const DEFAULT_COLORS = [
      "#000000",
      "#545454",
      "#737373",
      "#a6a6a6",
      "#d9d9d9",
      "#f2f2f2",
      "#ffffff",
      "#ff0000",
      "#ff3131",
      "#ff5757",
      "#ff66c4",
      "#cb6ce6",
      "#8c52ff",
      "#5e17eb",
      "#00c2cb",
      "#0cc0df",
      "#5ce1e6",
      "#38b6ff",
      "#5271ff",
      "#004aad",
      "#0a1172",
      "#00bf63",
      "#7ed957",
      "#c1ff72",
      "#ffde59",
      "#ffbd59",
      "#ff914d",
      "#ff751f"
    ];
    for (const c2 of DEFAULT_COLORS) {
      const sw = el("button", "nsv2-swatch");
      sw.type = "button";
      sw.dataset.c = c2;
      sw.style.background = c2;
      sw.title = c2;
      defaultGrid.appendChild(sw);
    }
    const colorToolsLabel = el("div", "nsv2-pane-label", "Text colors");
    colorMain.append(
      colorToolsLabel,
      colorToolsRow,
      designLabel,
      designGrid,
      defaultsHead,
      defaultGrid
    );
    const allGrid = el("div", "nsv2-color-grid");
    allGrid.hidden = true;
    const colorMsg = el("div", "nsv2-color-msg");
    colorMsg.hidden = true;
    colorPane.append(colorHead, colorSearch, colorMsg, colorMain, allGrid);
    const effectsPane = el("div", "nsv2-pane nsv2-fx-pane");
    effectsPane.dataset.pane = "effects";
    const fxBackBtn = el("button", "nsv2-icon-btn nsv2-pane-back", icons.arrowLeft);
    fxBackBtn.type = "button";
    fxBackBtn.title = "Back";
    const fxHead = el("div", "nsv2-pane-head");
    const fxTitle = el("div", "nsv2-pane-title", "Effects");
    fxHead.append(fxBackBtn, fxTitle);
    const FX_TILES = [
      ["none", "None"],
      ["outline", "Outline"],
      ["hollow", "Hollow"],
      ["drop", "Drop"],
      ["splice", "Splice"],
      ["echo", "Echo"],
      ["background", "Background"]
    ];
    const fxTiles = el("div", "nsv2-fx-tiles");
    for (const [key, label] of FX_TILES) {
      const badge = key === "none" ? "" : '<span class="nsv2-fx-adjust">' + icons.sliders + "</span>";
      const tile = el(
        "button",
        "nsv2-fx-tile",
        '<span class="nsv2-fx-box"><span class="nsv2-fx-ag nsv2-fx-ag--' + key + '">Ag</span>' + badge + '</span><span class="nsv2-fx-label">' + label + "</span>"
      );
      tile.type = "button";
      tile.dataset.fx = key;
      fxTiles.appendChild(tile);
    }
    const fxColorRow = el("div", "nsv2-fx-color-row");
    const fxColorInput = el("input");
    fxColorInput.type = "color";
    fxColorInput.value = "#ffffff";
    fxColorInput.className = "nsv2-color-native";
    const fxColorChip = el("button", "nsv2-swatch nsv2-fx-color-chip");
    fxColorChip.type = "button";
    fxColorChip.title = "Effect color";
    const fxColorChip2 = el("button", "nsv2-swatch nsv2-fx-color-chip");
    fxColorChip2.type = "button";
    fxColorChip2.title = "Second copy color";
    fxColorChip2.hidden = true;
    const fxColorLabel = el("span", "nsv2-fx-color-label", "Color");
    const fxChips = el("span", "nsv2-fx-chips");
    fxChips.append(fxColorChip, fxColorChip2);
    fxColorRow.append(fxColorLabel, fxChips, fxColorInput);
    const fxColorPop = el("div", "nsv2-fx-colorpop");
    fxColorPop.hidden = true;
    const fxPopCustom = el("button", "nsv2-swatch nsv2-swatch--custom", icons.plus);
    fxPopCustom.type = "button";
    fxPopCustom.title = "Custom color";
    const fxPopDropper = el("button", "nsv2-swatch nsv2-swatch--tool", icons.dropper);
    fxPopDropper.type = "button";
    fxPopDropper.title = "Pick from screen";
    const fxPopCurrent = el("button", "nsv2-swatch is-active");
    fxPopCurrent.type = "button";
    fxPopCurrent.title = "Current color";
    const fxPopTools = el("div", "nsv2-color-row");
    fxPopTools.append(fxPopCustom, fxPopDropper, fxPopCurrent);
    const fxDesignLabel = el("div", "nsv2-pane-label", "Colors in this design");
    const fxDesignGrid = el("div", "nsv2-color-grid");
    const fxDefaultGrid = el("div", "nsv2-color-grid");
    for (const c2 of DEFAULT_COLORS) {
      const sw = el("button", "nsv2-swatch");
      sw.type = "button";
      sw.dataset.c = c2;
      sw.style.background = c2;
      sw.title = c2;
      fxDefaultGrid.appendChild(sw);
    }
    fxColorPop.append(
      fxPopTools,
      fxDesignLabel,
      fxDesignGrid,
      el("div", "nsv2-pane-label", "Default solid colors"),
      fxDefaultGrid
    );
    root.appendChild(fxColorPop);
    const fxControls = el("div", "nsv2-fx-controls");
    fxControls.hidden = true;
    fxControls.append(fxColorRow);
    const nativeValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
    const makeRange = (min, max, step, val) => {
      const range = el("input");
      range.type = "range";
      range.min = String(min);
      range.max = String(max);
      range.step = String(step);
      const fill = (r2) => {
        const lo2 = parseFloat(r2.min) || 0;
        const hi2 = parseFloat(r2.max) || 100;
        r2.style.setProperty("--fill", String((r2.valueAsNumber - lo2) / (hi2 - lo2) * 100));
      };
      Object.defineProperty(range, "value", {
        get() {
          return nativeValue.get.call(this);
        },
        set(v2) {
          nativeValue.set.call(this, v2);
          fill(this);
        }
      });
      range.addEventListener("input", () => fill(range));
      range.value = String(val);
      return range;
    };
    const GRADIENT_PRESETS = [
      ["#0f172a", "#64748b"],
      ["#8e9eab", "#eef2f3"],
      ["#b88746", "#fdf5a6"],
      ["#ff3131", "#ffde59"],
      ["#ff66c4", "#ffde59"],
      ["#ff5757", "#8c52ff"],
      ["#8c52ff", "#ff914d"],
      ["#5271ff", "#ff66c4"],
      ["#cb6ce6", "#004aad"],
      ["#5ce1e6", "#8c52ff"],
      ["#0cc0df", "#7ed957"],
      ["#004aad", "#0cc0df"],
      ["#00bf63", "#c1ff72"],
      ["#ffde59", "#ff751f"]
    ];
    const gradsLabel = el("div", "nsv2-pane-label", "Gradients");
    const gradGrid = el("div", "nsv2-color-grid");
    for (const [a2, b2] of GRADIENT_PRESETS) {
      const sw = el("button", "nsv2-swatch");
      sw.type = "button";
      sw.dataset.ga = a2;
      sw.dataset.gb = b2;
      sw.style.background = "linear-gradient(180deg, " + a2 + ", " + b2 + ")";
      sw.title = a2 + " \u2192 " + b2;
      gradGrid.appendChild(sw);
    }
    const gradEdit = el("div", "nsv2-grad-edit");
    gradEdit.hidden = true;
    const mkStop = (label) => {
      const btn = el("button", "nsv2-swatch nsv2-grad-stop");
      btn.type = "button";
      btn.title = label;
      const input = el("input");
      input.type = "color";
      input.className = "nsv2-color-native";
      return [btn, input];
    };
    const [gradStopA, gradInputA] = mkStop("Start color");
    const [gradStopB, gradInputB] = mkStop("End color");
    const gradStopsRow = el("div", "nsv2-color-row nsv2-grad-stops");
    gradStopsRow.append(gradStopA, gradInputA, gradStopB, gradInputB);
    const gradAngle = makeRange(0, 360, 1, 90);
    const gradAngleVal = el("span", "nsv2-fx-curve-val", "90\xB0");
    const gradAngleRow = el("div", "nsv2-fx-curve");
    gradAngleRow.append(el("span", "nsv2-fx-curve-name", "Angle"), gradAngle, gradAngleVal);
    gradEdit.append(gradStopsRow, gradAngleRow);
    colorMain.append(gradsLabel, gradGrid, gradEdit);
    const fxCurveLabel = el("div", "nsv2-pane-label nsv2-shape-label", "Shape");
    const shapeSvg = (d2) => '<svg width="26" height="16" viewBox="0 0 26 16" fill="none"><path d="' + d2 + '" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    const SHAPE_TILES = [
      ["none", "None", shapeSvg("M3 8h20")],
      ["curve", "Curve", shapeSvg("M3 12 Q13 1 23 12")],
      ["wave", "Wave", shapeSvg("M3 8 C7 2 10 2 13 8 S19 14 23 8")],
      ["arcup", "Arc Upper", shapeSvg("M3 12 Q13 3 23 12")],
      ["arclo", "Arc Lower", shapeSvg("M3 4 Q13 13 23 4")],
      ["angle", "Angle", shapeSvg("M3 13 L23 3")]
    ];
    const shapeTiles = el("div", "nsv2-fx-tiles nsv2-shape-tiles");
    for (const [key, label, icon] of SHAPE_TILES) {
      const tile = el(
        "button",
        "nsv2-fx-tile",
        '<span class="nsv2-fx-box"><span class="nsv2-fx-ag nsv2-fx-shape">' + icon + '</span></span><span class="nsv2-fx-label">' + label + "</span>"
      );
      tile.type = "button";
      tile.dataset.shape = key;
      shapeTiles.appendChild(tile);
    }
    const fxCurveRow = el("div", "nsv2-fx-curve");
    const fxCurveRange = makeRange(-100, 100, 1, 0);
    const fxCurveVal = el("input", "nsv2-fx-curve-val");
    fxCurveVal.type = "text";
    fxCurveVal.inputMode = "numeric";
    fxCurveVal.value = "0";
    fxCurveRow.append(el("span", "nsv2-fx-curve-name", "Amount"), fxCurveRange, fxCurveVal);
    fxTiles.appendChild(fxControls);
    shapeTiles.appendChild(fxCurveRow);
    effectsPane.append(fxHead, fxTiles, fxCurveLabel, shapeTiles);
    const bgrPane = el("div", "nsv2-pane");
    bgrPane.dataset.pane = "bgr";
    const bgrBackBtn = el("button", "nsv2-icon-btn nsv2-pane-back", icons.arrowLeft);
    bgrBackBtn.type = "button";
    bgrBackBtn.title = "Back";
    const bgrHead = el("div", "nsv2-pane-head");
    bgrHead.append(bgrBackBtn, el("div", "nsv2-pane-title", "Remove background"));
    const bgrTiles = el("div", "nsv2-bgr-tiles");
    bgrPane.append(bgrHead, bgrTiles);
    const recolorPane = el("div", "nsv2-pane");
    recolorPane.dataset.pane = "recolor";
    const recolorBackBtn = el("button", "nsv2-icon-btn nsv2-pane-back", icons.arrowLeft);
    recolorBackBtn.type = "button";
    recolorBackBtn.title = "Back";
    const recolorHead = el("div", "nsv2-pane-head");
    recolorHead.append(recolorBackBtn, el("div", "nsv2-pane-title", "Recolor"));
    const recolorSrcLabel = el("div", "nsv2-pane-label", "Colors in this image");
    const recolorSrcRow = el("div", "nsv2-color-grid");
    const recolorToLabel = el("div", "nsv2-pane-label", "Change to");
    const recolorCustomInput = el("input");
    recolorCustomInput.type = "color";
    recolorCustomInput.dataset.spectrumDirect = "1";
    recolorCustomInput.className = "nsv2-color-native";
    const recolorCustomBtn = el("button", "nsv2-swatch nsv2-swatch--custom", icons.plus);
    recolorCustomBtn.type = "button";
    recolorCustomBtn.title = "Custom color";
    const recolorDropperBtn = el("button", "nsv2-swatch nsv2-swatch--tool", icons.dropper);
    recolorDropperBtn.type = "button";
    recolorDropperBtn.title = "Pick from screen";
    const recolorTransparent = el("button", "nsv2-swatch nsv2-swatch--transparent");
    recolorTransparent.type = "button";
    recolorTransparent.title = "Transparent (erase)";
    recolorTransparent.dataset.mode = "transparent";
    const recolorCurrent = el("button", "nsv2-swatch");
    recolorCurrent.type = "button";
    recolorCurrent.title = "Current replacement";
    const recolorToolsRow = el("div", "nsv2-color-row");
    recolorToolsRow.append(recolorCustomBtn, recolorDropperBtn, recolorTransparent, recolorCurrent, recolorCustomInput);
    const recolorDesignLabel = el("div", "nsv2-pane-label", "Colors in this design");
    const recolorDesignGrid = el("div", "nsv2-color-grid");
    const recolorDefaultsHead = el("div", "nsv2-color-defaults-head");
    const recolorSeeAll = el("button", "nsv2-see-all", "See all");
    recolorSeeAll.type = "button";
    recolorDefaultsHead.append(el("div", "nsv2-pane-label", "Default solid colors"), recolorSeeAll);
    const recolorGrid = el("div", "nsv2-color-grid");
    const recolorAllGrid = el("div", "nsv2-color-grid");
    recolorAllGrid.hidden = true;
    const recolorResetBtn = el("button", "nsv2-recolor-reset", "Reset colors");
    recolorResetBtn.type = "button";
    recolorPane.append(
      recolorHead,
      recolorSrcLabel,
      recolorSrcRow,
      recolorToLabel,
      recolorToolsRow,
      recolorDesignLabel,
      recolorDesignGrid,
      recolorDefaultsHead,
      recolorGrid,
      recolorAllGrid,
      recolorResetBtn
    );
    const filtersPane = el("div", "nsv2-pane");
    filtersPane.dataset.pane = "filters";
    const filtersBackBtn = el("button", "nsv2-icon-btn nsv2-pane-back", icons.arrowLeft);
    filtersBackBtn.type = "button";
    filtersBackBtn.title = "Back";
    const filtersHead = el("div", "nsv2-pane-head");
    const filtersTitle = el("div", "nsv2-pane-title", "Filters");
    filtersHead.append(filtersBackBtn, filtersTitle);
    const filterTiles = el("div", "nsv2-bgr-tiles nsv2-filter-tiles");
    filtersPane.append(filtersHead, filterTiles);
    const dlgModal = el("div", "nsv2-use-modal nsv2-dlg");
    dlgModal.hidden = true;
    const dlgCard = el("div", "nsv2-use-card nsv2-dlg-card");
    const dlgMsg = el("div", "nsv2-dlg-msg");
    const dlgInput = el("input", "nsv2-dlg-input");
    dlgInput.type = "text";
    dlgInput.maxLength = 80;
    dlgInput.autocomplete = "off";
    dlgInput.hidden = true;
    const dlgRow = el("div", "nsv2-aied-row");
    const dlgCancel = el("button", "nsv2-cropbar-cancel nsv2-dlg-cancel", "Cancel");
    const dlgAlt = el("button", "nsv2-cropbar-cancel nsv2-dlg-alt", "Discard");
    dlgAlt.hidden = true;
    const dlgOk = el("button", "nsv2-cta nsv2-dlg-ok", "<span>OK</span>");
    dlgCancel.type = dlgAlt.type = dlgOk.type = "button";
    dlgRow.append(dlgCancel, dlgAlt, dlgOk);
    dlgCard.append(dlgMsg, dlgInput, dlgRow);
    dlgModal.appendChild(dlgCard);
    root.appendChild(dlgModal);
    const adjustPane = el("div", "nsv2-pane");
    adjustPane.dataset.pane = "adjust";
    const adjustBackBtn = el("button", "nsv2-icon-btn nsv2-pane-back", icons.arrowLeft);
    adjustBackBtn.type = "button";
    adjustBackBtn.title = "Back";
    const adjustHead = el("div", "nsv2-pane-head");
    adjustHead.append(adjustBackBtn, el("div", "nsv2-pane-title", "Adjust"));
    adjustPane.append(adjustHead);
    const uploadsPane = el("div", "nsv2-pane");
    uploadsPane.dataset.pane = "uploads";
    const fileInput = el("input");
    fileInput.type = "file";
    fileInput.multiple = true;
    fileInput.accept = ".png,.jpg,.jpeg,.gif,.webp,.svg,.pdf,.ai,.eps,.psd,.tif,.tiff";
    fileInput.hidden = true;
    const dropzone = el("button", "nsv2-upload-cta", icons.uploads + "<span>Upload files</span>");
    dropzone.type = "button";
    const uploadFormats = el(
      "div",
      "nsv2-up-formats",
      "PNG, JPG, SVG, PDF, AI, EPS, PSD & more \xB7 or drag & drop anywhere"
    );
    const uploadBusy = el("div", "nsv2-up-busy", '<span class="nsv2-bgr-spin"></span><span>Uploading\u2026</span>');
    uploadBusy.hidden = true;
    const driveBtn = el("button", "nsv2-src-btn", icons.drive + "<span>Drive</span>");
    const phoneBtn = el("button", "nsv2-src-btn nsv2-src-btn--phone", icons.phone + "<span>Phone</span>");
    driveBtn.type = phoneBtn.type = "button";
    driveBtn.title = "Upload from Google Drive";
    phoneBtn.title = "Upload from your phone";
    const srcRow = el("div", "nsv2-src-row");
    srcRow.append(driveBtn, phoneBtn);
    const myFilesLabel = el("div", "nsv2-pane-label", "My uploaded files");
    const myFilesGrid = el("div", "nsv2-myfiles");
    myFilesLabel.hidden = myFilesGrid.hidden = true;
    const uploadsSignin = el("div", "nsv2-designs-empty nsv2-uploads-signin", "Sign in to see your uploaded files");
    const uploadsSigninBtn = el("button", "nsv2-signin-btn", "Sign In");
    uploadsSigninBtn.type = "button";
    uploadsSignin.appendChild(uploadsSigninBtn);
    uploadsSignin.hidden = true;
    uploadsPane.append(
      el("div", "nsv2-pane-title", "Uploads"),
      dropzone,
      srcRow,
      uploadFormats,
      uploadBusy,
      myFilesLabel,
      myFilesGrid,
      uploadsSignin,
      fileInput
    );
    const layersPane = el("div", "nsv2-pane");
    layersPane.dataset.pane = "layers";
    const layersList = el("div", "nsv2-layers-list");
    const layersEmpty = el("div", "nsv2-designs-empty", "Nothing on your canvas yet");
    layersEmpty.hidden = true;
    layersPane.append(el("div", "nsv2-pane-title", "Layers"), layersEmpty, layersList);
    const elementsPane = el("div", "nsv2-pane");
    elementsPane.dataset.pane = "elements";
    const elTile = (key) => {
      const tile = el(
        "button",
        "nsv2-fx-tile",
        '<span class="nsv2-fx-box"><span class="nsv2-fx-ag nsv2-fx-shape">' + elementGlyphSvg(key) + '</span></span><span class="nsv2-fx-label">' + ELEMENTS[key].label + "</span>"
      );
      tile.type = "button";
      tile.dataset.el = key;
      return tile;
    };
    const elementTiles = el("div", "nsv2-fx-tiles");
    const elementLineTiles = el("div", "nsv2-fx-tiles");
    const elementLinesLabel = el("div", "nsv2-pane-label", "Lines");
    for (const key of Object.keys(ELEMENTS)) {
      (ELEMENTS[key].isLine ? elementLineTiles : elementTiles).appendChild(elTile(key));
    }
    elementsPane.append(
      el("div", "nsv2-pane-title", "Elements"),
      el("div", "nsv2-pane-label", "Shapes"),
      elementTiles,
      elementLinesLabel,
      elementLineTiles
    );
    const designsPane = el("div", "nsv2-pane");
    designsPane.dataset.pane = "designs";
    const designsEmpty = el("div", "nsv2-designs-empty");
    const designsTabs = el("div", "nsv2-tabs");
    const designsTabSaved = el("button", "nsv2-tab is-on", "Saved");
    designsTabSaved.type = "button";
    const designsTabExports = el("button", "nsv2-tab", "Exported");
    designsTabExports.type = "button";
    designsTabs.append(designsTabSaved, designsTabExports);
    const designsSavedGrid = el("div", "nsv2-designs nsv2-designs--saved");
    const designsGrid = el("div", "nsv2-designs");
    designsEmpty.hidden = designsGrid.hidden = true;
    designsTabs.hidden = designsSavedGrid.hidden = true;
    designsPane.append(
      el("div", "nsv2-pane-title", "My Designs"),
      designsTabs,
      designsEmpty,
      designsSavedGrid,
      designsGrid
    );
    const premadePane = el("div", "nsv2-pane");
    premadePane.dataset.pane = "premade";
    const premadeBody = el("div", "nsv2-premade-body");
    premadePane.append(el("div", "nsv2-pane-title", "Pre-Made Designs"), premadeBody);
    premadePane.hidden = true;
    const canvasPane = el("div", "nsv2-pane nsv2-canvas-pane");
    canvasPane.append(el("div", "nsv2-pane-title", "Canvas"));
    canvasPane.hidden = true;
    const formatPane = el("div", "nsv2-pane nsv2-format-pane");
    formatPane.append(el("div", "nsv2-pane-title", "Format"));
    formatPane.hidden = true;
    const spacingPane = el("div", "nsv2-pane nsv2-spacing-pane");
    spacingPane.append(el("div", "nsv2-pane-title", "Spacing"));
    spacingPane.hidden = true;
    const nudgeIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v18M3 12h18"/><path d="M9 6l3-3 3 3M9 18l3 3 3-3M6 9l-3 3 3 3M18 9l3 3-3 3"/></svg>';
    const nudgePane = el("div", "nsv2-pane nsv2-nudge-pane");
    nudgePane.append(el("div", "nsv2-pane-title", "Nudge"));
    nudgePane.hidden = true;
    const nudgePad = el("div", "nsv2-nudge-pad");
    const nudgeBtns = {};
    for (const [dir, icon, tip] of [["left", icons.arrowLeft, "Move left"], ["up", icons.arrowUp, "Move up"], ["down", icons.arrowDown, "Move down"], ["right", icons.arrow, "Move right"]]) {
      const b2 = el("button", "nsv2-nudge-btn nsv2-nudge-" + dir, icon);
      b2.type = "button";
      b2.setAttribute("aria-label", tip);
      b2.dataset.dir = dir;
      nudgePad.appendChild(b2);
      nudgeBtns[dir] = b2;
    }
    nudgePane.append(nudgePad);
    const shapePane = el("div", "nsv2-pane nsv2-shape-pane");
    shapePane.append(el("div", "nsv2-pane-title", "Shape"));
    shapePane.hidden = true;
    panel.append(panelClose, textPane, fontsPane, uploadsPane, elementsPane, layersPane, designsPane, premadePane, colorPane, effectsPane, bgrPane, filtersPane, recolorPane, adjustPane, canvasPane, formatPane, spacingPane, nudgePane, shapePane);
    const area = el("div", "nsv2-area");
    const ctxbar = el("div", "nsv2-ctxbar");
    const fontBtn = el("button", "nsv2-ctx-font", '<span data-ref="family">Poppins</span>');
    fontBtn.title = "Font";
    fontBtn.type = "button";
    const sizeWrap = el("div", "nsv2-ctx-size");
    const sizeDown = el("button", "nsv2-ctx-size-btn", "\u2212");
    sizeDown.title = "Decrease size";
    const sizeVal = el("input", "nsv2-ctx-size-val");
    sizeVal.type = "text";
    sizeVal.inputMode = "numeric";
    const sizeUp = el("button", "nsv2-ctx-size-btn", "+");
    sizeUp.title = "Increase size";
    sizeDown.type = sizeUp.type = "button";
    sizeWrap.append(sizeDown, sizeVal, sizeUp);
    const colorBtn = el("button", "nsv2-ctx-color", '<span class="nsv2-color-disc" data-ref="disc"></span>');
    colorBtn.type = "button";
    colorBtn.title = "Text color";
    const boldBtn = el("button", "nsv2-ctx-toggle nsv2-ctx-b", "B");
    boldBtn.title = "Bold";
    const italicBtn = el("button", "nsv2-ctx-toggle nsv2-ctx-i", "I");
    italicBtn.title = "Italic";
    const underlineBtn = el("button", "nsv2-ctx-toggle nsv2-ctx-u", "U");
    underlineBtn.title = "Underline";
    const strikeBtn = el("button", "nsv2-ctx-toggle nsv2-ctx-s", "S");
    strikeBtn.title = "Strikethrough";
    const caseBtn = el("button", "nsv2-ctx-toggle nsv2-ctx-aa", "aA");
    caseBtn.title = "Uppercase";
    const bulletsBtn = el("button", "nsv2-ctx-toggle", icons.bullets);
    bulletsBtn.title = "Bulleted list";
    const alignBtn = el("button", "nsv2-ctx-toggle", icons.alignCenter);
    alignBtn.title = "Alignment";
    const spacingBtn = el("button", "nsv2-ctx-toggle nsv2-sp-btn", icons.spacing);
    spacingBtn.title = "Spacing";
    const effectsBtn = el("button", "nsv2-ctx-word", '<span class="nsv2-cw-ic">' + icons.ai + '</span><span class="nsv2-cw-lab">Effects</span>');
    const deleteBtn = el("button", "nsv2-ctx-toggle nsv2-ctx-del", icons.trash + '<span class="nsv2-cw-lab">Delete</span>');
    deleteBtn.title = "Delete";
    const word = (label, icon, soon) => {
      const b2 = el(
        "button",
        "nsv2-ctx-word" + (soon ? " is-soon" : ""),
        (icon ? '<span class="nsv2-cw-ic">' + icon + "</span>" : "") + '<span class="nsv2-cw-lab">' + label + "</span>"
      );
      b2.type = "button";
      if (soon) b2.title = "Coming soon";
      return b2;
    };
    const aiEditBtn = word("Edit with AI", micons.star);
    const removeBgBtn = word("BG Remove", micons.eraser);
    removeBgBtn.classList.add("nsv2-ctx-removebg");
    const cropBtn = word("Crop", micons.crop);
    cropBtn.classList.add("nsv2-cw-iconic");
    cropBtn.title = "Crop";
    const radiusBtn = word("Radius", micons.corner);
    radiusBtn.classList.add("nsv2-cw-iconic");
    radiusBtn.title = "Radius";
    const colorReplaceBtn = word("Recolor", micons.palette);
    const filtersBtn = word("Filters", micons.filterIc);
    const revertBtn = word("Revert", micons.restore);
    [boldBtn, italicBtn, underlineBtn, strikeBtn, caseBtn, bulletsBtn, alignBtn, spacingBtn, effectsBtn, deleteBtn].forEach((b2) => b2.type = "button");
    const fmtCluster = el("div", "nsv2-fmt-cluster");
    fmtCluster.append(boldBtn, italicBtn, underlineBtn, strikeBtn, caseBtn, alignBtn, bulletsBtn, spacingBtn);
    const fmtChip = el("button", "nsv2-mchip nsv2-fmt-chip", '<span class="nsv2-fmt-chip-glyph">B</span><span class="nsv2-mchip-lab">Format</span>');
    fmtChip.type = "button";
    const spacingChip = el("button", "nsv2-mchip nsv2-sp-chip", icons.spacing + '<span class="nsv2-mchip-lab">Spacing</span>');
    spacingChip.type = "button";
    const shapeChip = el(
      "button",
      "nsv2-mchip nsv2-shape-chip",
      '<svg width="26" height="16" viewBox="0 0 26 16" fill="none"><path d="M3 12 Q13 1 23 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><span class="nsv2-mchip-lab">Shape</span>'
    );
    shapeChip.type = "button";
    const editTextChip = word("Edit", micons.pencil);
    editTextChip.classList.add("nsv2-edit-chip");
    const ctxTextGroup = el("div", "nsv2-ctx-group");
    ctxTextGroup.append(editTextChip, fontBtn, sizeWrap, colorBtn, el("div", "nsv2-vdiv"), fmtCluster, fmtChip, spacingChip, el("div", "nsv2-vdiv"), effectsBtn, shapeChip);
    const imgOutlineColorBtn = el("button", "nsv2-ctx-color nsv2-elc-chip", '<span class="nsv2-color-disc nsv2-ring-disc" data-ref="disc"></span>');
    imgOutlineColorBtn.type = "button";
    imgOutlineColorBtn.title = "Outline color";
    const stickerBtn = word("Outline", micons.ring);
    stickerBtn.classList.add("nsv2-cw-iconic");
    stickerBtn.title = "Outline";
    const adjustBtn = el("button", "nsv2-icon-btn nsv2-ctx-toggle", icons.sliders + '<span class="nsv2-cw-lab nsv2-adjust-lab">Adjust</span>');
    adjustBtn.type = "button";
    adjustBtn.title = "Adjust";
    const upscaleBtn = word("Upscale", micons.expand);
    const ctxImageGroup = el("div", "nsv2-ctx-group");
    ctxImageGroup.append(
      removeBgBtn,
      el("div", "nsv2-vdiv"),
      colorReplaceBtn,
      filtersBtn,
      upscaleBtn,
      el("div", "nsv2-vdiv"),
      cropBtn,
      radiusBtn,
      imgOutlineColorBtn,
      stickerBtn,
      adjustBtn,
      el("div", "nsv2-vdiv"),
      revertBtn
    );
    const elFillBtn = el("button", "nsv2-ctx-color nsv2-el-fill", '<span class="nsv2-color-disc" data-ref="disc"></span>');
    elFillBtn.type = "button";
    elFillBtn.title = "Fill color";
    const elBorderColorBtn = el("button", "nsv2-ctx-color nsv2-elc-chip", '<span class="nsv2-color-disc nsv2-ring-disc" data-ref="disc"></span>');
    elBorderColorBtn.type = "button";
    elBorderColorBtn.title = "Outline color";
    const elBorderBtn = word("Outline", micons.ring);
    const elRoundBtn = word("Radius", micons.corner);
    elRoundBtn.hidden = true;
    const elFlipHBtn = word("Flip H", icons.flipH);
    const elFlipVBtn = word("Flip V", icons.flipV);
    const ctxShapeGroup = el("div", "nsv2-ctx-group");
    ctxShapeGroup.append(elFillBtn, elBorderColorBtn, elBorderBtn, elRoundBtn, el("div", "nsv2-vdiv"), elFlipHBtn, elFlipVBtn);
    ctxShapeGroup.hidden = true;
    const lnColorBtn = el("button", "nsv2-ctx-color nsv2-ln-color", '<span class="nsv2-color-disc" data-ref="disc"></span>');
    lnColorBtn.type = "button";
    lnColorBtn.title = "Line color";
    const lnStyleBtn = word("Style", micons.lineStyle);
    const lnEndsBtn = word("Ends", micons.arrowRange);
    const ctxLineGroup = el("div", "nsv2-ctx-group");
    ctxLineGroup.append(lnColorBtn, lnStyleBtn, lnEndsBtn);
    ctxLineGroup.hidden = true;
    const borderPop = el("div", "nsv2-spop nsv2-border-pop");
    borderPop.hidden = true;
    const lnStylePop = el("div", "nsv2-spop nsv2-border-pop");
    lnStylePop.hidden = true;
    const lnEndsPop = el("div", "nsv2-spop nsv2-ends-pop");
    lnEndsPop.hidden = true;
    const borderPane = el("div", "nsv2-pane nsv2-border-pane");
    borderPane.append(el("div", "nsv2-pane-title", "Outline"));
    borderPane.hidden = true;
    const endsPane = el("div", "nsv2-pane nsv2-ends-pane");
    endsPane.append(el("div", "nsv2-pane-title", "Line ends"));
    endsPane.hidden = true;
    const lnStylePane = el("div", "nsv2-pane nsv2-lnstyle-pane");
    lnStylePane.append(el("div", "nsv2-pane-title", "Line style"));
    lnStylePane.hidden = true;
    const gridBtn = el("button", "nsv2-icon-btn nsv2-ctx-toggle", icons.grid);
    gridBtn.type = "button";
    gridBtn.title = "Grid";
    const rulerBtn = el("button", "nsv2-icon-btn nsv2-ctx-toggle nsv2-ruler-btn", icons.ruler);
    rulerBtn.type = "button";
    rulerBtn.title = "Rulers";
    const ctxCanvasGroup = el("div", "nsv2-ctx-group");
    const canvasSizeLabel = el("span", "nsv2-fx-color-label", "Canvas");
    const canvasSizeVdiv = el("div", "nsv2-vdiv");
    ctxCanvasGroup.append(
      canvasSizeLabel,
      canvasSizeWrap,
      canvasSizeVdiv,
      bgBtn,
      el("div", "nsv2-vdiv"),
      gridBtn,
      rulerBtn
    );
    ctxCanvasGroup.hidden = true;
    const gridPop = el("div", "nsv2-spop nsv2-grid-pop");
    gridPop.hidden = true;
    const gridToggle = el("button", "nsv2-enhance-toggle");
    gridToggle.type = "button";
    gridToggle.setAttribute("aria-pressed", "false");
    const gridToggleRow = el("div", "nsv2-fx-color-row");
    gridToggleRow.append(el("span", "nsv2-fx-color-label", "Grid"), gridToggle);
    const cropBar = el("div", "nsv2-cropbar");
    cropBar.hidden = true;
    const cropApplyBtn = el("button", "nsv2-cta nsv2-cropbar-apply", "<span>Apply</span>");
    const cropCancelBtn = el("button", "nsv2-cropbar-cancel", "Cancel");
    cropApplyBtn.type = cropCancelBtn.type = "button";
    cropBar.append(cropApplyBtn, cropCancelBtn);
    const rpop = el("div", "nsv2-spop");
    rpop.hidden = true;
    const ctxMoreBtn = el("button", "nsv2-ctx-toggle nsv2-ctx-more", icons.dots);
    ctxMoreBtn.type = "button";
    ctxMoreBtn.title = "More";
    ctxMoreBtn.hidden = true;
    const ctxMorePanel = el("div", "nsv2-ctx-more-panel");
    ctxMorePanel.hidden = true;
    const ctxSelGroup = el("div", "nsv2-ctx-group");
    const alignBtns = {};
    for (const [pos, icon, tip] of [
      ["left", icons.alignL, "Align left"],
      ["centerH", icons.alignCH, "Align center"],
      ["right", icons.alignR, "Align right"],
      ["top", icons.alignT, "Align top"],
      ["middle", icons.alignM, "Align middle"],
      ["bottom", icons.alignB, "Align bottom"]
    ]) {
      const b2 = el("button", "nsv2-icon-btn nsv2-ctx-toggle");
      b2.type = "button";
      b2.innerHTML = icon;
      b2.dataset.tip = tip;
      b2.dataset.alignPos = pos;
      ctxSelGroup.appendChild(b2);
      alignBtns[pos] = b2;
    }
    ctxSelGroup.appendChild(el("div", "nsv2-vdiv"));
    const distBtns = {};
    for (const [axis, icon, tip] of [
      ["h", icons.distH, "Distribute horizontally"],
      ["v", icons.distV, "Distribute vertically"]
    ]) {
      const b2 = el("button", "nsv2-icon-btn nsv2-ctx-toggle");
      b2.type = "button";
      b2.innerHTML = icon;
      b2.dataset.tip = tip;
      b2.dataset.distAxis = axis;
      ctxSelGroup.appendChild(b2);
      distBtns[axis] = b2;
    }
    ctxSelGroup.hidden = true;
    const nudgeChip = word("Nudge", nudgeIcon);
    nudgeChip.classList.add("nsv2-nudge-chip");
    const ctxNudgeGroup = el("div", "nsv2-ctx-group nsv2-nudge-group");
    ctxNudgeGroup.append(nudgeChip);
    ctxNudgeGroup.hidden = true;
    const ctxTail = el("div", "nsv2-ctx-group");
    ctxTail.append(el("div", "nsv2-vdiv"), deleteBtn);
    ctxbar.append(ctxTextGroup, ctxImageGroup, ctxShapeGroup, ctxLineGroup, ctxSelGroup, ctxNudgeGroup, ctxCanvasGroup, ctxMoreBtn, ctxTail);
    const board = el("div", "nsv2-board");
    const canvasEl = el("canvas");
    board.appendChild(canvasEl);
    const qa2 = el("div", "nsv2-qa");
    qa2.hidden = true;
    const qaBtn = (cls, icon, title) => {
      const b2 = el("button", "nsv2-qa-btn" + (cls ? " " + cls : ""), icon);
      b2.type = "button";
      b2.title = title;
      return b2;
    };
    const qaAi = el("button", "nsv2-qa-ai", "Edit with AI");
    qaAi.type = "button";
    qaAi.hidden = true;
    const qaDown = qaBtn("", icons.arrowDown, "Send backward");
    const qaUp = qaBtn("", icons.arrowUp, "Bring forward");
    const qaDup = qaBtn("nsv2-qa-dup", icons.duplicate, "Duplicate");
    const qaDel = qaBtn("nsv2-qa-del", icons.trash, "Delete");
    const qaMore = qaBtn("", icons.dots, "More");
    const qaLock = qaBtn("nsv2-qa-lock", icons.unlock, "Unlock");
    const rotKnob = el("div", "nsv2-qa nsv2-rotate-knob", icons.rotate);
    rotKnob.hidden = true;
    rotKnob.setAttribute("aria-hidden", "true");
    qa2.append(qaAi, qaDown, qaUp, qaDup, qaDel, qaMore, qaLock);
    const spop = el("div", "nsv2-spop");
    spop.hidden = true;
    const sliderRow = (label, min, max, step, val) => {
      const wrap = el("div", "nsv2-spop-row");
      const lab = el("div", "nsv2-spop-label", label);
      const row = el("div", "nsv2-fx-curve");
      const range = makeRange(min, max, step, val);
      const num = el("input", "nsv2-fx-curve-val");
      num.type = "text";
      num.inputMode = "decimal";
      num.value = String(val);
      row.append(range, num);
      wrap.append(lab, row);
      return { wrap, range, num };
    };
    const filterStrength = sliderRow("Intensity", 0, 100, 1, 100);
    const filterDuoRow = el("div", "nsv2-fx-color-row nsv2-duo-row");
    const duoChip = (title, c2) => {
      const b2 = el("button", "nsv2-swatch nsv2-fx-color-chip");
      b2.type = "button";
      b2.title = title;
      b2.dataset.c = c2;
      b2.style.background = c2;
      return b2;
    };
    const duoShadow = duoChip("Shadows", "#003087");
    const duoHighlight = duoChip("Highlights", "#00c5ff");
    const duoChips = el("span", "nsv2-fx-chips");
    duoChips.append(duoShadow, duoHighlight);
    filterDuoRow.append(el("span", "nsv2-fx-color-label", "Colors"), duoChips);
    filterDuoRow.hidden = true;
    const filterCtrls = el("div", "nsv2-filter-ctrls");
    filterCtrls.append(filterStrength.wrap, filterDuoRow);
    filterCtrls.hidden = true;
    filtersPane.append(filterCtrls);
    const adjTemp = sliderRow("Temperature", -100, 100, 1, 0);
    const adjTint = sliderRow("Tint", -100, 100, 1, 0);
    const adjBri = sliderRow("Brightness", -100, 100, 1, 0);
    const adjCon = sliderRow("Contrast", -100, 100, 1, 0);
    const adjHi = sliderRow("Highlights", -100, 100, 1, 0);
    const adjSh = sliderRow("Shadows", -100, 100, 1, 0);
    const adjWh = sliderRow("Whites", -100, 100, 1, 0);
    const adjBl = sliderRow("Blacks", -100, 100, 1, 0);
    const adjVib = sliderRow("Vibrance", -100, 100, 1, 0);
    const adjSat = sliderRow("Saturation", -100, 100, 1, 0);
    const adjHue = sliderRow("Hue", -100, 100, 1, 0);
    const adjSharp = sliderRow("Sharpness", -100, 100, 1, 0);
    const adjClar = sliderRow("Clarity", -100, 100, 1, 0);
    const adjVig = sliderRow("Vignette", -100, 100, 1, 0);
    const adjBlur = sliderRow("Blur", 0, 100, 1, 0);
    const adjNoise = sliderRow("Noise", 0, 100, 1, 0);
    const adjPix = sliderRow("Pixelate", 0, 100, 1, 0);
    const adjInvertRow = el("div", "nsv2-fx-color-row nsv2-adj-invert");
    const adjInvert = el("button", "nsv2-enhance-toggle");
    adjInvert.type = "button";
    adjInvert.setAttribute("aria-pressed", "false");
    adjInvertRow.append(el("span", "nsv2-fx-color-label", "Invert"), adjInvert);
    const adjReset = el("button", "nsv2-recolor-reset", "Reset adjustments");
    adjReset.type = "button";
    adjustPane.append(
      el("div", "nsv2-pane-label", "White balance"),
      adjTemp.wrap,
      adjTint.wrap,
      el("div", "nsv2-pane-label", "Light"),
      adjBri.wrap,
      adjCon.wrap,
      adjHi.wrap,
      adjSh.wrap,
      adjWh.wrap,
      adjBl.wrap,
      el("div", "nsv2-pane-label", "Color"),
      adjInvertRow,
      adjVib.wrap,
      adjSat.wrap,
      adjHue.wrap,
      el("div", "nsv2-pane-label", "Texture"),
      adjSharp.wrap,
      adjClar.wrap,
      adjVig.wrap,
      adjBlur.wrap,
      adjNoise.wrap,
      adjPix.wrap,
      adjReset
    );
    const gr2 = gridRange();
    const gridSize = sliderRow("Grid size (" + unit + ")", gr2.min, gr2.max, gr2.step, gr2.def);
    gridSize.wrap.classList.add("nsv2-grid-size-row");
    gridPop.append(gridToggleRow, gridSize.wrap);
    const letterSp = sliderRow("Letter spacing", -200, 800, 5, 0);
    const lineSp = sliderRow("Line spacing", 0.75, 2.5, 0.01, 1.16);
    spop.append(letterSp.wrap, lineSp.wrap);
    const radiusSp = sliderRow("Corner radius", 0, 100, 1, 0);
    rpop.append(radiusSp.wrap);
    const lineSample = (dash, cap) => '<svg width="34" height="12" viewBox="0 0 34 12" fill="none"><path d="M3 6H31" stroke="currentColor" stroke-width="3"' + (dash ? ' stroke-dasharray="' + dash + '"' : "") + (cap ? ' stroke-linecap="round"' : "") + "/></svg>";
    const noneSample = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.6"/><path d="M4 14L14 4" stroke="currentColor" stroke-width="1.6"/></svg>';
    const miniTile = (ds2, label, inner) => {
      const t2 = el(
        "button",
        "nsv2-fx-tile nsv2-bstyle-tile",
        '<span class="nsv2-fx-box">' + inner + '</span><span class="nsv2-fx-label">' + label + "</span>"
      );
      t2.type = "button";
      Object.assign(t2.dataset, ds2);
      return t2;
    };
    const BSTYLES = [
      ["none", "None", noneSample],
      ["solid", "Solid", lineSample("", false)],
      ["dashed", "Dashed", lineSample("7 5", false)],
      ["longdash", "Long dash", lineSample("13 5", false)],
      ["dotted", "Dotted", lineSample("0.1 6", true)]
    ];
    const borderStyleRow = el("div", "nsv2-bstyle-row");
    for (const [key, label, inner] of BSTYLES) borderStyleRow.appendChild(miniTile({ bstyle: key }, label, inner));
    const borderWeight = sliderRow("Stroke weight", 1, 100, 1, 12);
    const borderCtrls = el("div", "nsv2-el-ctrls");
    borderCtrls.append(borderStyleRow, borderWeight.wrap);
    borderPop.appendChild(borderCtrls);
    const lnStyleRow = el("div", "nsv2-bstyle-row nsv2-bstyle-row--3");
    for (const [key, label, inner] of BSTYLES.slice(1)) lnStyleRow.appendChild(miniTile({ lnstyle: key }, label, inner));
    const lnWeight = sliderRow("Weight", 2, 30, 1, 9);
    const lnStyleCtrls = el("div", "nsv2-el-ctrls");
    lnStyleCtrls.append(lnStyleRow, lnWeight.wrap);
    lnStylePop.appendChild(lnStyleCtrls);
    const capSample = (kind) => {
      if (kind === "none") return lineSample("", false);
      let capSvg = "";
      if (kind === "arrow") capSvg = '<path d="M31 6L21 1V11Z" fill="currentColor"/>';
      if (kind === "bar") capSvg = '<path d="M30 1V11" stroke="currentColor" stroke-width="3"/>';
      if (kind === "dot") capSvg = '<circle cx="29" cy="6" r="4.5" fill="currentColor"/>';
      return '<svg width="34" height="12" viewBox="0 0 34 12" fill="none"><path d="M3 6H' + (kind === "none" ? 31 : 24) + '" stroke="currentColor" stroke-width="3"/>' + capSvg + "</svg>";
    };
    const CAPS = [["none", "None"], ["arrow", "Arrow"], ["bar", "Bar"], ["dot", "Dot"]];
    const capRow = (end) => {
      const row = el("div", "nsv2-bstyle-row");
      for (const [key, label] of CAPS) row.appendChild(miniTile({ end, cap: key }, label, capSample(key)));
      return row;
    };
    const lnCapStartRow = capRow("start");
    const lnCapEndRow = capRow("end");
    const lnEndsCtrls = el("div", "nsv2-el-ctrls");
    lnEndsCtrls.append(
      el("div", "nsv2-pane-label", "Line start"),
      lnCapStartRow,
      el("div", "nsv2-pane-label", "Line end"),
      lnCapEndRow
    );
    lnEndsPop.appendChild(lnEndsCtrls);
    const outlinePane = el("div", "nsv2-pane");
    outlinePane.dataset.pane = "outline";
    const outlineBackBtn = el("button", "nsv2-icon-btn nsv2-pane-back", icons.arrowLeft);
    outlineBackBtn.type = "button";
    outlineBackBtn.title = "Back";
    const outlineHead = el("div", "nsv2-pane-head");
    outlineHead.append(outlineBackBtn, el("div", "nsv2-pane-title", "Outline"));
    outlinePane.append(outlineHead);
    panel.appendChild(outlinePane);
    const fxSize = sliderRow("Thickness", 0, 100, 1, 50);
    fxSize.wrap.hidden = true;
    const fxDir = sliderRow("Direction", -180, 180, 1, 45);
    fxDir.wrap.hidden = true;
    const fxOff = sliderRow("Offset", 0, 100, 1, 50);
    fxOff.wrap.hidden = true;
    const fxBlur = sliderRow("Blur", 0, 100, 1, 0);
    fxBlur.wrap.hidden = true;
    const fxRound = sliderRow("Roundness", 0, 100, 1, 22);
    fxRound.wrap.hidden = true;
    const fxSpread = sliderRow("Spread", 0, 100, 1, 50);
    fxSpread.wrap.hidden = true;
    const fxTransp = sliderRow("Transparency", 0, 100, 1, 100);
    fxTransp.wrap.hidden = true;
    fxControls.insertBefore(fxSize.wrap, fxColorRow);
    fxControls.insertBefore(fxDir.wrap, fxColorRow);
    fxControls.insertBefore(fxOff.wrap, fxColorRow);
    fxControls.insertBefore(fxBlur.wrap, fxColorRow);
    fxControls.insertBefore(fxRound.wrap, fxColorRow);
    fxControls.insertBefore(fxSpread.wrap, fxColorRow);
    fxControls.insertBefore(fxTransp.wrap, fxColorRow);
    const cropPane = el("div", "nsv2-pane");
    cropPane.dataset.pane = "crop";
    const cropBackBtn = el("button", "nsv2-icon-btn nsv2-pane-back", icons.arrowLeft);
    cropBackBtn.type = "button";
    cropBackBtn.title = "Cancel crop";
    const cropHead = el("div", "nsv2-pane-head");
    cropHead.append(cropBackBtn, el("div", "nsv2-pane-title", "Crop"));
    const smartCropBtn = el("button", "nsv2-add-text nsv2-smartcrop", icons.ai + "<span>Smart Crop</span>");
    smartCropBtn.type = "button";
    smartCropBtn.title = "Crop to the subject";
    const CROP_RATIOS = [
      ["free", "Freeform", 0],
      ["orig", "Original", 0],
      ["1:1", "1:1", 1],
      ["4:3", "4:3", 4 / 3],
      ["3:4", "3:4", 3 / 4],
      ["16:9", "16:9", 16 / 9],
      ["9:16", "9:16", 9 / 16]
    ];
    const cropRatios = el("div", "nsv2-crop-ratios nsv2-fx-tiles");
    for (const [key, label, ratio] of CROP_RATIOS) {
      const w2 = ratio ? ratio >= 1 ? 24 : Math.round(24 * ratio) : 20;
      const h2 = ratio ? ratio >= 1 ? Math.round(24 / ratio) : 24 : 20;
      const tile = el(
        "button",
        "nsv2-fx-tile nsv2-crop-tile" + (key === "free" ? " is-active" : ""),
        '<span class="nsv2-fx-box"><span class="nsv2-crop-shape' + (key === "free" ? " nsv2-crop-shape--free" : "") + '" style="width:' + w2 + "px;height:" + h2 + 'px"></span></span><span class="nsv2-fx-label">' + label + "</span>"
      );
      tile.type = "button";
      tile.dataset.ratio = key;
      cropRatios.appendChild(tile);
    }
    const cropScale = sliderRow("Scale", 10, 300, 1, 100);
    const cropRotate = sliderRow("Rotate", -180, 180, 0.5, 0);
    const cropRotateReset = el("button", "nsv2-crop-reset", "Reset");
    cropRotateReset.type = "button";
    cropRotate.wrap.querySelector(".nsv2-fx-curve").appendChild(cropRotateReset);
    cropPane.append(cropHead, smartCropBtn, el("div", "nsv2-pane-label", "Aspect ratio"), cropRatios, cropScale.wrap, cropRotate.wrap);
    panel.appendChild(cropPane);
    panel.append(borderPane, endsPane, lnStylePane);
    const menu = el("div", "nsv2-menu");
    menu.hidden = true;
    const menuItem = (act, icon, label, kbd) => {
      const b2 = el(
        "button",
        "nsv2-menu-item",
        '<span class="nsv2-menu-lab">' + icon + "<span>" + label + "</span></span>" + (kbd ? "<kbd>" + kbd + "</kbd>" : "")
      );
      b2.type = "button";
      b2.dataset.act = act;
      return b2;
    };
    const menuCopy = menuItem("copy", icons.copy, "Copy", "\u2318C");
    const menuPaste = menuItem("paste", icons.clipboard, "Paste", "\u2318V");
    const menuDup = menuItem("duplicate", icons.duplicate, "Duplicate", "\u2318D");
    const menuGroup = menuItem("group", icons.group, "Group", "\u2318G");
    const menuUngroup = menuItem("ungroup", icons.ungroup, "Ungroup", "\u2318\u21E7G");
    const menuDel = menuItem("delete", icons.trash, "Delete", "DELETE");
    const alignWrap = el("div", "nsv2-menu-sub");
    const alignBtnRow = el(
      "button",
      "nsv2-menu-item",
      '<span class="nsv2-menu-lab">' + icons.alignPage + "<span>Align to page</span></span>" + icons.chevronRight
    );
    alignBtnRow.type = "button";
    const alignMenu = el("div", "nsv2-menu nsv2-menu--sub");
    alignMenu.append(
      menuItem("align:left", icons.alignLeft, "Left"),
      menuItem("align:centerH", icons.alignCenter, "Center"),
      menuItem("align:right", icons.alignRight, "Right"),
      el("div", "nsv2-menu-div"),
      menuItem("align:top", icons.arrowUp, "Top"),
      menuItem("align:middle", icons.alignCenter, "Middle"),
      menuItem("align:bottom", icons.arrowDown, "Bottom")
    );
    alignWrap.append(alignBtnRow, alignMenu);
    const menuLock = menuItem("lock", icons.lock, "Lock");
    menu.append(
      menuCopy,
      menuPaste,
      menuDup,
      menuGroup,
      menuUngroup,
      menuLock,
      menuDel,
      el("div", "nsv2-menu-div"),
      menuItem("layer:front", icons.arrowUp, "Bring to Front", "\u21E7]"),
      menuItem("layer:up", icons.arrowUp, "Bring Forward", "]"),
      menuItem("layer:down", icons.arrowDown, "Send Backward", "["),
      menuItem("layer:back", icons.arrowDown, "Send to Back", "\u21E7["),
      el("div", "nsv2-menu-div"),
      menuItem("flip:h", icons.flipH, "Flip Horizontal", "\u21E7H"),
      menuItem("flip:v", icons.flipV, "Flip Vertical", "\u21E7V"),
      el("div", "nsv2-menu-div"),
      alignWrap
    );
    const zoom = el("div", "nsv2-zoom");
    const boardScroll = el("div", "nsv2-scroll");
    boardScroll.appendChild(board);
    const rulerX = el("canvas", "nsv2-ruler nsv2-ruler-x");
    const rulerY = el("canvas", "nsv2-ruler nsv2-ruler-y");
    const rulerCorner = el("div", "nsv2-ruler nsv2-ruler-corner");
    rulerX.hidden = rulerY.hidden = rulerCorner.hidden = true;
    const aiDrawer = el("aside", "nsv2-ai-drawer");
    aiDrawer.hidden = true;
    aiDrawer.setAttribute("aria-label", "AI assistant");
    aiDrawer.tabIndex = -1;
    const aiHead = el("div", "nsv2-ai-head");
    const aiTitle = el("div", "nsv2-pane-title nsv2-ai-title", "Edit with AI");
    const aiClose = el("button", "nsv2-icon-btn nsv2-ai-close", icons.close);
    aiClose.type = "button";
    aiClose.title = "Close";
    aiHead.append(aiTitle, aiClose);
    const aiThread = el("div", "nsv2-ai-thread");
    const aiFoot = el("div", "nsv2-ai-foot");
    const aiBasis = el("div", "nsv2-ai-basis");
    aiBasis.hidden = true;
    const aiFootErr = el("div", "nsv2-ai-foot-err");
    aiFootErr.hidden = true;
    const aiComposer = el("div", "nsv2-ai-composer");
    const aiInput = el("textarea", "nsv2-ai-input");
    aiInput.placeholder = "Describe what you want to change";
    aiInput.rows = 2;
    const aiSend = el("button", "nsv2-ai-send", icons.arrowUp);
    aiSend.type = "button";
    aiSend.title = "Send";
    aiSend.setAttribute("aria-label", "Send");
    const aiStop = el("button", "nsv2-ai-send nsv2-ai-stop", '<span class="nsv2-ai-stop-sq"></span>');
    aiStop.type = "button";
    aiStop.title = "Stop";
    aiStop.hidden = true;
    aiComposer.append(aiInput, aiSend, aiStop);
    aiFoot.append(aiBasis, aiFootErr, aiComposer);
    aiDrawer.append(aiHead, aiThread, aiFoot);
    area.append(ctxbar, bgAlert, fitAlert, toast, ctxMorePanel, boardScroll, rulerX, rulerY, rulerCorner, qa2, rotKnob, menu, spop, rpop, gridPop, borderPop, lnStylePop, lnEndsPop, cropBar, zoom);
    const body = el("div", "nsv2-body");
    body.append(rail, panel, aiDrawer, area);
    root.append(topbar, body);
    host.appendChild(root);
    return {
      root,
      topbar,
      undoBtn,
      redoBtn,
      useBtn,
      useModal,
      useCard,
      useClose,
      useGrid,
      useBusy,
      designNameInput,
      savePop,
      saveUpdateBtn,
      saveNewBtn,
      saveWrap,
      saveBtn,
      topVdiv,
      homeBtn,
      sizeW,
      sizeH,
      sizeSel,
      sizeCustom,
      canvasSizeWrap,
      canvasSizeLabel,
      canvasSizeVdiv,
      bgBtn,
      bgSwatch,
      bgColorInput,
      bgClear,
      bgWarn,
      bgAlert,
      fitAlert,
      toast,
      toastMsg,
      toastAct,
      toastX,
      fitAlertMsg,
      fitAlertAct,
      fitAlertX,
      fileBtn,
      fileMenu,
      fileWrap,
      fileNew,
      fileOpen,
      fileSave,
      fileSaveAs,
      fileDup,
      fileOutlineMode,
      fileSignIn,
      fileBuild,
      rail,
      toolBtns,
      panel,
      panelClose,
      textPane,
      addTextBtn,
      treatmentTiles,
      fontsPane,
      fontsBackBtn,
      fontSearch,
      fontCats,
      fontList,
      uploadsPane,
      dropzone,
      fileInput,
      uploadBusy,
      driveBtn,
      phoneBtn,
      myFilesLabel,
      myFilesGrid,
      uploadsSignin,
      uploadsSigninBtn,
      designsPane,
      designsEmpty,
      designsGrid,
      designsTabs,
      designsTabSaved,
      designsTabExports,
      designsSavedGrid,
      premadePane,
      premadeBody,
      elementsPane,
      elementTiles,
      elementLineTiles,
      elementLinesLabel,
      layersPane,
      layersList,
      layersEmpty,
      effectsPane,
      fxBackBtn,
      fxTitle,
      fxTiles,
      shapeTiles,
      fxControls,
      fxColorRow,
      fxColorInput,
      fxSize,
      fxDir,
      fxOff,
      fxBlur,
      fxRound,
      fxSpread,
      fxTransp,
      fxCurveRow,
      fxCurveRange,
      fxCurveVal,
      fxColorChip,
      fxColorChip2,
      fxColorLabel,
      fxColorPop,
      fxPopCustom,
      fxPopDropper,
      fxPopCurrent,
      fxDesignLabel,
      fxDesignGrid,
      fxDefaultGrid,
      bgrPane,
      bgrBackBtn,
      bgrTiles,
      filtersPane,
      filtersBackBtn,
      filtersTitle,
      filterTiles,
      filterStrength,
      filterCtrls,
      filterDuoRow,
      duoShadow,
      duoHighlight,
      adjustPane,
      adjustBackBtn,
      adjTemp,
      adjTint,
      adjBri,
      adjCon,
      adjHi,
      adjSh,
      adjWh,
      adjBl,
      adjVib,
      adjSat,
      adjHue,
      adjSharp,
      adjClar,
      adjVig,
      adjBlur,
      adjNoise,
      adjPix,
      adjInvert,
      adjReset,
      upscaleBtn,
      aiDrawer,
      aiTitle,
      aiClose,
      aiThread,
      aiBasis,
      aiFootErr,
      aiComposer,
      aiInput,
      aiSend,
      aiStop,
      canvasPane,
      formatPane,
      spacingPane,
      spacingChip,
      nudgePane,
      nudgeChip,
      ctxNudgeGroup,
      nudgeBtns,
      shapePane,
      shapeChip,
      fmtCluster,
      fmtChip,
      makeRange,
      sliderRow,
      dlgModal,
      dlgMsg,
      dlgInput,
      dlgCancel,
      dlgAlt,
      dlgOk,
      recolorPane,
      recolorBackBtn,
      recolorSrcRow,
      recolorToLabel,
      recolorToolsRow,
      recolorGrid,
      recolorAllGrid,
      recolorSeeAll,
      recolorDesignLabel,
      recolorDesignGrid,
      recolorTransparent,
      recolorCurrent,
      recolorDropperBtn,
      recolorCustomBtn,
      recolorCustomInput,
      recolorResetBtn,
      colorPane,
      colorBackBtn,
      colorTitle,
      colorSearch,
      colorMsg,
      colorMain,
      customColorBtn,
      customColorInput,
      dropperBtn,
      currentSwatch,
      colorNoFill,
      colorToolsLabel,
      designLabel,
      designGrid,
      seeAllBtn,
      allGrid,
      gradGrid,
      gradEdit,
      gradsLabel,
      gradStopA,
      gradInputA,
      gradStopB,
      gradInputB,
      gradAngle,
      gradAngleVal,
      area,
      ctxbar,
      ctxTextGroup,
      ctxImageGroup,
      ctxSelGroup,
      ctxCanvasGroup,
      ctxTail,
      alignBtns,
      distBtns,
      fontBtn,
      sizeDown,
      sizeVal,
      sizeUp,
      colorBtn,
      ctxShapeGroup,
      ctxLineGroup,
      elFillBtn,
      elBorderBtn,
      elBorderColorBtn,
      imgOutlineColorBtn,
      elRoundBtn,
      elFlipHBtn,
      elFlipVBtn,
      lnColorBtn,
      lnStyleBtn,
      lnEndsBtn,
      borderPop,
      lnStylePop,
      lnEndsPop,
      borderPane,
      endsPane,
      lnStylePane,
      borderCtrls,
      borderStyleRow,
      borderWeight,
      lnStyleCtrls,
      lnStyleRow,
      lnWeight,
      lnEndsCtrls,
      lnCapStartRow,
      lnCapEndRow,
      boldBtn,
      italicBtn,
      underlineBtn,
      strikeBtn,
      caseBtn,
      bulletsBtn,
      alignBtn,
      spacingBtn,
      effectsBtn,
      removeBgBtn,
      deleteBtn,
      editTextChip,
      menuLock,
      qaLock,
      sizeWrap,
      spop,
      letterSp,
      lineSp,
      rpop,
      radiusSp,
      stickerBtn,
      adjustBtn,
      outlinePane,
      outlineBackBtn,
      gridBtn,
      rulerBtn,
      gridPop,
      gridToggle,
      gridSize,
      rulerX,
      rulerY,
      rulerCorner,
      rotKnob,
      cropPane,
      cropBackBtn,
      smartCropBtn,
      cropRatios,
      cropScale,
      cropRotate,
      cropRotateReset,
      aiEditBtn,
      cropBtn,
      radiusBtn,
      colorReplaceBtn,
      filtersBtn,
      revertBtn,
      cropBar,
      cropApplyBtn,
      cropCancelBtn,
      ctxMoreBtn,
      ctxMorePanel,
      board,
      boardScroll,
      canvasEl,
      zoom,
      qa: qa2,
      qaAi,
      qaDown,
      qaUp,
      qaDup,
      qaDel,
      qaMore,
      menu,
      menuCopy,
      menuPaste,
      menuDup,
      menuDel,
      menuGroup,
      menuUngroup,
      alignWrap
    };
  }

  // src/output.js
  var EXPORT_PX = 22 * 300;
  var RENDER_W = 4e3;
  var DISPLAY_W = 2e3;
  function printVariant(url) {
    const u2 = String(url || "");
    if (!/^https?:/.test(u2) || u2.indexOf(cfg.imgixHost) === -1) return u2;
    return u2.replace(/([?&]w=)2000(?=&|$)/, "$1" + RENDER_W);
  }
  function hostedDisplayUrl(url) {
    const bare = url.split("?")[0].split(cfg.s3Host).join(cfg.imgixHost);
    return bare + "?fm=png&fit=max&w=" + DISPLAY_W;
  }
  var CRC_TABLE = null;
  function crcTable() {
    if (CRC_TABLE) return CRC_TABLE;
    CRC_TABLE = new Int32Array(256);
    for (let n2 = 0; n2 < 256; n2++) {
      let c2 = n2;
      for (let k2 = 0; k2 < 8; k2++) c2 = c2 & 1 ? 3988292384 ^ c2 >>> 1 : c2 >>> 1;
      CRC_TABLE[n2] = c2;
    }
    return CRC_TABLE;
  }
  async function crc32Blob(blob) {
    const table = crcTable();
    const bytes = new Uint8Array(await blob.arrayBuffer());
    let c2 = -1;
    for (let i2 = 0; i2 < bytes.length; i2++) c2 = c2 >>> 8 ^ table[(c2 ^ bytes[i2]) & 255];
    return (c2 ^ -1) >>> 0;
  }
  async function getPresignedUploadUrl(fileName, fileType) {
    const res = await fetch(
      cfg.apiUrl + "/uploads/getPresignedUploadUrl?file_name=" + encodeURIComponent(fileName) + "&file_type=" + encodeURIComponent(fileType)
    );
    if (!res.ok) throw new Error("presign request failed: " + res.status);
    return res.json();
  }
  async function uploadBlobAs(fileName, blob, fileType) {
    const presign = await getPresignedUploadUrl(fileName, fileType);
    if (!presign || !presign.url || !presign.sourceUrl) throw new Error("Invalid presigned URL response");
    const put = await fetch(presign.url, { method: "PUT", headers: { "Content-Type": fileType }, body: blob });
    if (!put.ok) throw new Error("Upload failed");
    return {
      fileName,
      s3Url: presign.sourceUrl,
      imgixUrl: presign.sourceUrl.split(cfg.s3Host).join(cfg.imgixHost)
    };
  }
  async function uploadFileToS3(file) {
    const safe = (file.name || "upload.png").replace(/[^A-Za-z0-9._-]+/g, "_").slice(-60);
    const fileName = "studio-upload-" + Date.now() + "-" + Math.floor(Math.random() * 1e4) + "-" + safe;
    return uploadBlobAs(fileName, file, file.type || "image/png");
  }
  async function registerUpload(customerId, { url, fileName, crc, variantTitle, gangsheet = false }) {
    const res = await fetch(cfg.apiUrl + "/uploads/saveData", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify([
        {
          variant_title: variantTitle || "",
          file: url,
          customer_id: String(customerId),
          file_name: fileName,
          file_crc: String(crc || 0),
          product_id: "",
          gangsheet
        }
      ])
    });
    if (!res.ok) throw new Error("saveData failed: " + res.status + " " + (await res.text()).slice(0, 120));
  }
  async function fetchUploadedFiles(customerId) {
    const res = await fetch(
      cfg.apiUrl + "/uploads/fetchDataNew?customer_id=" + encodeURIComponent(customerId) + "&archived=true&gangsheet=false"
    );
    if (!res.ok) throw new Error("fetchDataNew failed: " + res.status);
    const json = await res.json();
    const rows = Array.isArray(json) ? json : json && json.data || [];
    return rows.filter((it2) => it2 && it2.file && !(it2.archived === true || it2.archived === "true")).map((it2) => ({
      url: it2.file,
      name: it2.file_name || "",
      gangsheet: it2.gangsheet === true || it2.gangsheet === "true",
      photoId: it2.photo_id != null ? it2.photo_id : null
      // archiveData needs it (overwrite flow)
    }));
  }
  async function archiveUpload(customerId, photoId) {
    if (cfg.archive === "none") return null;
    const res = await fetch(
      cfg.apiUrl + "/uploads/archiveData?customer_id=" + encodeURIComponent(customerId) + "&photo_id=" + encodeURIComponent(photoId)
    );
    if (!res.ok) throw new Error("archiveData failed: " + res.status);
  }
  var PRINT_DPI_LADDER = [300, 200];
  async function exportPrintBlob(editor, targetPx) {
    const wIn = editor.designWIn || 22;
    const hIn = editor.designHIn || 22;
    let lastErr = null;
    const widths = (targetPx > 0 ? [Math.round(targetPx)] : []).concat(PRINT_DPI_LADDER.map((dpi) => Math.round(wIn * dpi)));
    for (const px of widths) {
      const dpi = Math.round(px / wIn);
      try {
        const blob = await editor.exportPng(px);
        if (blob && blob.size > 0) return { blob, dpi, px, wIn, hIn };
        lastErr = new Error("empty export at " + dpi + " dpi");
      } catch (err) {
        lastErr = err;
      }
      console.warn("studio-v2: print export failed at " + dpi + " dpi", lastErr && lastErr.message);
    }
    throw lastErr || new Error("print export failed");
  }
  async function exportAndUpload(editor, opts = {}) {
    const { blob, px, wIn, hIn } = await exportPrintBlob(editor, opts.targetPx);
    const fileName = "design-studio-" + Date.now() + "-" + Math.floor(Math.random() * 1e4) + ".png";
    const fileType = "image/png";
    const presign = await getPresignedUploadUrl(fileName, fileType);
    if (!presign || !presign.url || !presign.sourceUrl) throw new Error("Invalid presigned URL response");
    const put = await fetch(presign.url, { method: "PUT", headers: { "Content-Type": fileType }, body: blob });
    if (!put.ok) throw new Error("Upload failed");
    const crc = await crc32Blob(blob);
    if (opts.customerId) {
      try {
        await registerUpload(opts.customerId, {
          url: presign.sourceUrl,
          fileName,
          crc,
          // the board's inches; customer sizes the print later
          variantTitle: wIn + "x" + hIn
        });
      } catch (err) {
        console.error("studio-v2: saveData failed", err);
      }
    }
    const objs = editor.canvas && editor.canvas.getObjects() || [];
    const aiFlags = (objs.some((o2) => o2.__aiEdit) ? "&ai_edit=Y" : "") + (objs.some((o2) => o2.__aiCreated) ? "&ai_created=Y" : "");
    return {
      url: presign.sourceUrl,
      imgixUrl: presign.sourceUrl.split("?")[0].split(cfg.s3Host).join(cfg.imgixHost),
      // the hosted twin (by-size file records carry both)
      fileName,
      crc,
      exportPx: px,
      // the board width actually rendered (targetPx, or a dpi-ladder fallback)
      handoffQuery: "?file=" + encodeURIComponent(presign.sourceUrl) + "&_design_studio=Yes" + aiFlags
    };
  }

  // src/persistence.js
  var SAVE_MARKER = "design-studio-save-";
  var SAVE_NAME_RE = /^design-studio-save-(\d+)-/;
  var STATE_MARKER = "design-studio-state-";
  var STATE_NAME_RE = /^design-studio-state-(\d+)-/;
  var EXPORT_NAME_RE = /^design-studio-(\d+)-/;
  function isStudioSave(nameOrUrl) {
    const base = String(nameOrUrl || "").split("?")[0].split("/").pop();
    return base.indexOf(SAVE_MARKER) === 0 || base.indexOf(STATE_MARKER) === 0;
  }
  function savedNameRe(fileName) {
    const n2 = String(fileName || "");
    return SAVE_NAME_RE.test(n2) ? SAVE_NAME_RE : STATE_NAME_RE.test(n2) ? STATE_NAME_RE : null;
  }
  function stateUrlFor(previewUrl) {
    return previewUrl.split("?")[0].split(cfg.imgixHost).join(cfg.s3Host).replace(/\.png$/i, ".json");
  }
  function accountRegistry(customerId) {
    if (!customerId) return null;
    return {
      register: (info) => registerUpload(customerId, {
        url: info.url,
        fileName: info.fileName,
        crc: info.crc,
        variantTitle: info.variantTitle
      }),
      list: () => fetchUploadedFiles(customerId),
      // Retire one save's row by file name (overwrite flow). photo_id comes off
      // a fresh list — rows in hand may predate this row's registration.
      archive: async (fileName) => {
        const row = (await fetchUploadedFiles(customerId)).find((r2) => r2.name === fileName);
        if (row && row.photoId != null) await archiveUpload(customerId, row.photoId);
      }
    };
  }
  var NAME_SLUG_RE = /--([a-z0-9-]+)\.(?:png|json)$/i;
  function nameSlug(name) {
    return String(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40);
  }
  function nameFromFileName(fileName) {
    const m = NAME_SLUG_RE.exec(String(fileName || "").split("?")[0]);
    if (!m) return "";
    return m[1].replace(/-/g, " ").replace(/\b\w/g, (c2) => c2.toUpperCase());
  }
  async function migrateBlobImages(editor) {
    for (const o2 of editor.canvas.getObjects()) {
      if (!o2.isType || !o2.isType("image")) continue;
      const orig = o2.__originalSrc || "";
      if (!orig.startsWith("blob:")) continue;
      let bare;
      if (o2.__bgr && o2.__bgr.status === "ready" && o2.__bgr.imgixUrl) {
        bare = o2.__bgr.imgixUrl;
      } else {
        const blob = await (await fetch(orig)).blob();
        const up = await uploadFileToS3(
          new File([blob], o2.__fileName || "image.png", { type: blob.type || "image/png" })
        );
        if (o2.__bgr) {
          o2.__bgr.status = "ready";
          o2.__bgr.imgixUrl = up.imgixUrl;
          o2.__bgr.fileName = up.fileName;
        }
        bare = up.imgixUrl;
      }
      const display = hostedDisplayUrl(bare);
      const el2 = o2._element;
      const canvasBacked = el2 && el2.tagName === "CANVAS";
      if (!canvasBacked) await editor.replaceImageSource(o2, display);
      o2.__originalSrc = display;
    }
  }
  async function uploadDesignArtifacts(editor, { name, onState }) {
    await migrateBlobImages(editor);
    const data = JSON.parse(editor.designJSON());
    data.__studio = { v: 1, savedAt: Date.now(), name: name || "" };
    const slug = nameSlug(name);
    const base = SAVE_MARKER + Date.now() + "-" + Math.floor(Math.random() * 1e4) + (slug ? "--" + slug : "");
    const stateBlob = new Blob([JSON.stringify(data)], { type: "application/json" });
    const st2 = await uploadBlobAs(base + ".json", stateBlob, "application/json");
    if (typeof onState === "function") {
      try {
        onState({ fileName: base + ".png", stateUrl: st2.s3Url });
      } catch (e24) {
      }
    }
    const { blob: printBlob } = await exportPrintBlob(editor);
    const pv = await uploadBlobAs(base + ".png", printBlob, "image/png");
    return {
      fileName: base + ".png",
      stateUrl: st2.s3Url,
      previewUrl: pv.s3Url,
      crc: await crc32Blob(printBlob),
      variantTitle: editor.designWIn + "x" + editor.designHIn,
      name: name || ""
    };
  }
  async function registerParked(registry, parked) {
    if (!registry) throw new Error("no design registry (signed out?)");
    await registry.register({
      url: parked.previewUrl,
      fileName: parked.fileName,
      crc: parked.crc,
      variantTitle: parked.variantTitle || ""
    });
  }
  async function saveDesign(editor, { registry, name, prevFileName, onState }) {
    if (!registry) throw new Error("no design registry (signed out?)");
    const art = await uploadDesignArtifacts(editor, { name, onState });
    const base = art.fileName.replace(/\.png$/, "");
    const st2 = { s3Url: art.stateUrl };
    const pv = { s3Url: art.previewUrl };
    await registry.register({
      url: pv.s3Url,
      fileName: base + ".png",
      crc: art.crc,
      variantTitle: art.variantTitle
    });
    if (prevFileName && prevFileName !== base + ".png" && registry.archive) {
      try {
        await registry.archive(prevFileName);
      } catch (err) {
        console.warn("studio-v2: previous save not archived (duplicate tile may remain)", err);
      }
    }
    return { fileName: base + ".png", stateUrl: st2.s3Url, previewUrl: pv.s3Url };
  }
  async function duplicateDesign(registry, previewUrl) {
    if (!registry) throw new Error("no design registry (signed out?)");
    const bare = previewUrl.split("?")[0];
    const data = await (await fetch(stateUrlFor(bare))).json();
    const name = ((data.__studio && data.__studio.name || "Untitled Design") + " Copy").slice(0, 60);
    data.__studio = Object.assign({ v: 1 }, data.__studio, { savedAt: Date.now(), name });
    const slug = nameSlug(name);
    const legacy = STATE_NAME_RE.test(bare.split("/").pop());
    const base = (legacy ? STATE_MARKER : SAVE_MARKER) + Date.now() + "-" + Math.floor(Math.random() * 1e4) + (slug ? "--" + slug : "");
    const stateBlob = new Blob([JSON.stringify(data)], { type: "application/json" });
    const previewBlob = await (await fetch(bare.split(cfg.imgixHost).join(cfg.s3Host))).blob();
    const st2 = await uploadBlobAs(base + ".json", stateBlob, "application/json");
    const pv = await uploadBlobAs(base + ".png", previewBlob, "image/png");
    await registry.register({
      url: pv.s3Url,
      fileName: base + ".png",
      crc: await crc32Blob(previewBlob),
      variantTitle: ""
    });
    return { fileName: base + ".png", stateUrl: st2.s3Url, previewUrl: pv.s3Url, name };
  }
  function fontFamiliesIn(data) {
    const fams = /* @__PURE__ */ new Set();
    const re2 = /"fontFamily"\s*:\s*"([^"]+)"/g;
    const raw = JSON.stringify(data);
    let m;
    while (m = re2.exec(raw)) fams.add(m[1]);
    return [...fams];
  }
  async function loadDesignData(editor, data) {
    await Promise.all(fontFamiliesIn(data).map((f2) => loadFont(f2).catch(() => {
    })));
    await editor.loadDesign(data);
  }
  async function loadDesignFromUrl(editor, stateUrl, prepare) {
    const res = await fetch(stateUrl);
    if (!res.ok) throw new Error("design state fetch failed: " + res.status);
    const data = await res.json();
    await loadDesignData(editor, prepare ? prepare(data) : data);
    const meta = data.__studio || {};
    const fileName = stateUrl.split("?")[0].split("/").pop().replace(/\.json$/i, ".png");
    return { name: meta.name || nameFromFileName(fileName), savedAt: meta.savedAt || null, fileName };
  }

  // src/ndl-data.js
  var NDL_CATS = [{ "name": "Trending", "page": "/pages/trending-ready-to-press-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/Trending.png?auto=format,compress&w=480", "subs": [{ "t": "Football", "h": "football-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/football-mama-watercolor-artninja-transfers-644668.jpg?auto=format,compress&w=400", "n": 47 }, { "t": "Viral", "h": "viral-designs-for-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/NT.RTPTemplate_Busy_LockedIn.jpg?auto=format,compress&w=400", "n": 5 }, { "t": "Baseball", "h": "baseball-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/no-place-like-homeninja-transfers-174500.jpg?auto=format,compress&w=400", "n": 43 }, { "t": "Cat", "h": "cat-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/cat-lady-for-lifeninja-transfers-229839.jpg?auto=format,compress&w=400", "n": 51 }, { "t": "Military & Veteran", "h": "military-veteran-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/proud-veteran-us-mapninja-transfers-710919.jpg?auto=format,compress&w=400", "n": 29 }, { "t": "Dog", "h": "dog-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/if-my-dogs-cant-come-im-not-goingninja-transfers-964808.jpg?auto=format,compress&w=400", "n": 99 }] }, { "name": "Sports", "page": "/pages/sports-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/Sports.png?auto=format,compress&w=480", "subs": [{ "t": "Football", "h": "football-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/football-mama-watercolor-artninja-transfers-644668.jpg?auto=format,compress&w=400", "n": 47 }, { "t": "Basketball", "h": "basketball-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/BasketballMamaWatercolor.jpg?auto=format,compress&w=400", "n": 72 }, { "t": "Soccer", "h": "soccer-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/soccer-mom-galaxyninja-transfers-264109.jpg?auto=format,compress&w=400", "n": 66 }, { "t": "Baseball", "h": "baseball-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/no-place-like-homeninja-transfers-174500.jpg?auto=format,compress&w=400", "n": 43 }, { "t": "Hockey", "h": "hockey-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/goal-getterninja-transfers-117709.jpg?auto=format,compress&w=400", "n": 20 }, { "t": "Tennis", "h": "tennis-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/live-love-tennisninja-transfers-689118.jpg?auto=format,compress&w=400", "n": 39 }, { "t": "Volleyball", "h": "volleyball-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/in-my-volleyball-era-graffitininja-transfers-951746.jpg?auto=format,compress&w=400", "n": 39 }, { "t": "Cheerleading", "h": "cheerleading-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/cheerninja-transfers-875169.jpg?auto=format,compress&w=400", "n": 17 }, { "t": "Softball", "h": "softball-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/dripping-softballninja-transfers-207902.jpg?auto=format,compress&w=400", "n": 33 }, { "t": "Field Hockey", "h": "field-hockey-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/field-hockeyninja-transfers-277467.jpg?auto=format,compress&w=400", "n": 19 }, { "t": "Golf", "h": "golf-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/golfninja-transfers-533058.jpg?auto=format,compress&w=400", "n": 21 }, { "t": "Boxing", "h": "boxing-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/boxing-blueninja-transfers-882417.jpg?auto=format,compress&w=400", "n": 11 }, { "t": "Swimming", "h": "swimming-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/swimming-is-lifeninja-transfers-156104.jpg?auto=format,compress&w=400", "n": 9 }, { "t": "Bowling", "h": "bowling-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/id-hit-thatninja-transfers-799611.jpg?auto=format,compress&w=400", "n": 21 }, { "t": "Wrestling", "h": "wrestling-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/loud-and-proud-wrestling-momninja-transfers-605544.jpg?auto=format,compress&w=400", "n": 21 }, { "t": "Lacrosse", "h": "lacrosse-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/lacrosse-momninja-transfers-584122.jpg?auto=format,compress&w=400", "n": 18 }, { "t": "Surf", "h": "surf-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/life-is-swell-when-you-surfninja-transfers-253868.jpg?auto=format,compress&w=400", "n": 22 }, { "t": "Skiing", "h": "skiing-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/ski-legendninja-transfers-689703.jpg?auto=format,compress&w=400", "n": 16 }, { "t": "Cycling", "h": "cycling-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/just-enjoy-the-rideninja-transfers-553877.jpg?auto=format,compress&w=400", "n": 11 }, { "t": "Disc Golf", "h": "disc-golf-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/disc-golf-evolutionninja-transfers-356425.jpg?auto=format,compress&w=400", "n": 12 }, { "t": "Archery", "h": "archery-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/Archerymom.jpg?auto=format,compress&w=400", "n": 10 }, { "t": "Pickleball", "h": "pickleball-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/pickleball-legendninja-transfers-388924.jpg?auto=format,compress&w=400", "n": 19 }] }, { "name": "Holidays & Seasons", "page": "/pages/holiday-seasons-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/Holidays_Seasons_2.png?auto=format,compress&w=480", "subs": [{ "t": "Valentine's Day", "h": "valentines-day-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/all-you-need-is-love-transferninja-transfers-759649.jpg?auto=format,compress&w=400", "n": 44 }, { "t": "Mardi Gras", "h": "mardi-gras-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/louisiana-silhouetteninja-transfers-150542.jpg?auto=format,compress&w=400", "n": 22 }, { "t": "Easter", "h": "easter-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/silly-rabbit-easter-is-for-jesusninja-transfers-161894.jpg?auto=format,compress&w=400", "n": 38 }, { "t": "Mother's Day", "h": "mothers-day-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/NT.RTP_MamaRainbowCheckered.jpg?auto=format,compress&w=400", "n": 73 }, { "t": "Cinco de Mayo", "h": "cinco-de-mayo-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/todays-forecastninja-transfers-993603.jpg?auto=format,compress&w=400", "n": 46 }, { "t": "Father's Day", "h": "fathers-day-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/beer-dad-transferninja-transfers-478407.jpg?auto=format,compress&w=400", "n": 37 }, { "t": "Juneteenth", "h": "juneteenth-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/juneteenth-free-ish-since-1865ninja-transfers-168032.jpg?auto=format,compress&w=400", "n": 23 }, { "t": "Oktoberfest", "h": "oktoberfest-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/hello-beer-goodbye-problemsninja-transfers-448697.jpg?auto=format,compress&w=400", "n": 48 }, { "t": "Halloween", "h": "halloween-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/kitchen-witchninja-transfers-136910.jpg?auto=format,compress&w=400", "n": 77 }, { "t": "Thanksgiving", "h": "thanksgiving-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/these-rolls-are-homemadeninja-transfers-949179.jpg?auto=format,compress&w=400", "n": 31 }, { "t": "Day of the Dead", "h": "day-of-the-dead-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/black-sugar-skullninja-transfers-795777.jpg?auto=format,compress&w=400", "n": 28 }, { "t": "Christmas", "h": "christmas-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/NaughtyList_e00de3e6-1c4b-43a0-9490-7385470300b1.jpg?auto=format,compress&w=400", "n": 88 }, { "t": "Hanukkah", "h": "hanukkah-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/100-kosher-transferninja-transfers-258205.jpg?auto=format,compress&w=400", "n": 18 }, { "t": "New Year's Eve", "h": "new-years-eve-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/happy-new-year-yallninja-transfers-228666.jpg?auto=format,compress&w=400", "n": 4 }, { "t": "Winter", "h": "winter-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/official-cookie-testerninja-transfers-882812.jpg?auto=format,compress&w=400", "n": 21 }, { "t": "Spring", "h": "spring-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/i-choose-to-shineninja-transfers-284485.jpg?auto=format,compress&w=400", "n": 50 }, { "t": "Autumn", "h": "autumn-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/its-fall-yallninja-transfers-965476.jpg?auto=format,compress&w=400", "n": 76 }, { "t": "Summer", "h": "summer-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/bring-on-the-sunshineninja-transfers-127721.jpg?auto=format,compress&w=400", "n": 30 }] }, { "name": "Charities & Causes", "page": "/pages/charities-causes-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/Charities_Causes_4735c03d-5064-4c57-9e5d-5e5e5c7ffec9.png?auto=format,compress&w=480", "subs": [{ "t": "Environmental", "h": "environmental-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/peace-love-recycleninja-transfers-227380.jpg?auto=format,compress&w=400", "n": 33 }, { "t": "Mental Health", "h": "mental-health-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/continueninja-transfers-617325.jpg?auto=format,compress&w=400", "n": 53 }, { "t": "Diabetes Awareness", "h": "diabetes-awareness-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/peace-love-cureninja-transfers-352989.jpg?auto=format,compress&w=400", "n": 14 }, { "t": "Leukemia", "h": "leukemia-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/proud-brother-of-a-leukemia-warriorninja-transfers-571231.jpg?auto=format,compress&w=400", "n": 54 }, { "t": "Lymphoma", "h": "lymphoma-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/support-squadninja-transfers-750418.jpg?auto=format,compress&w=400", "n": 50 }, { "t": "Inspirational", "h": "inspirational-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/sometimes-its-better-to-let-the-silence-do-the-talkingninja-transfers-222766.jpg?auto=format,compress&w=400", "n": 50 }] }, { "name": "Military & First Responders", "page": "/pages/military-first-responders-ready-to-press-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/Military_First_Responders.png?auto=format,compress&w=480", "subs": [{ "t": "Military & Veteran", "h": "military-veteran-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/proud-veteran-us-mapninja-transfers-710919.jpg?auto=format,compress&w=400", "n": 29 }, { "t": "Police", "h": "police-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/AmericanBackTheBlueBlackWhiteBlue_1.jpg?auto=format,compress&w=400", "n": 23 }, { "t": "Firefighter", "h": "firefighter-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/FirefighterMom.jpg?auto=format,compress&w=400", "n": 24 }, { "t": "Nurse", "h": "nurse-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/will-trade-medical-advice-for-wineninja-transfers-724869.jpg?auto=format,compress&w=400", "n": 26 }, { "t": "EMT", "h": "emt-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/star-of-life-flagninja-transfers-753673.jpg?auto=format,compress&w=400", "n": 25 }] }, { "name": "Animals", "page": "/pages/animal-ready-to-press-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/Animals_2.png?auto=format,compress&w=480", "subs": [{ "t": "Cat", "h": "cat-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/cat-lady-for-lifeninja-transfers-229839.jpg?auto=format,compress&w=400", "n": 51 }, { "t": "Sloth", "h": "sloth-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/if-you-love-me-let-me-sleepninja-transfers-173431.jpg?auto=format,compress&w=400", "n": 35 }, { "t": "Dog", "h": "dog-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/BarkLessWagMorePastel_1.jpg?auto=format,compress&w=400", "n": 99 }, { "t": "Horses", "h": "horses-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/horse-riding-is-my-cardioninja-transfers-274650.jpg?auto=format,compress&w=400", "n": 35 }, { "t": "Animal", "h": "animal-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/cute-slothninja-transfers-259869.jpg?auto=format,compress&w=400", "n": 34 }, { "t": "Bigfoot", "h": "bigfoot-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/bigfoot-american-flagninja-transfers-145070.jpg?auto=format,compress&w=400", "n": 40 }] }, { "name": "Fitness", "page": "/pages/fitness-ready-to-press-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/Fitness_aceae4a0-d63a-49b0-8fa8-7eb4069d185b.png?auto=format,compress&w=480", "subs": [{ "t": "Gym", "h": "gym-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/be-a-badass-with-a-good-ass-transferninja-transfers-950832.jpg?auto=format,compress&w=400", "n": 30 }, { "t": "Yoga", "h": "yoga-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/quiet-your-mind-listen-to-your-soulninja-transfers-631733.jpg?auto=format,compress&w=400", "n": 27 }, { "t": "Gymnastics", "h": "gymnastics-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/warning-i-may-flip-at-any-timeninja-transfers-468346.jpg?auto=format,compress&w=400", "n": 20 }, { "t": "Running", "h": "running-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/running-momninja-transfers-193285.jpg?auto=format,compress&w=400", "n": 20 }, { "t": "Meditation", "h": "meditation-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/you-cannot-travel-on-the-pathninja-transfers-850472.jpg?auto=format,compress&w=400", "n": 25 }, { "t": "Vegan", "h": "vegan-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/milk-coconuts-not-cowsninja-transfers-909807.jpg?auto=format,compress&w=400", "n": 40 }, { "t": "Muay Thai", "h": "muay-thai-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/tiger-muay-thaininja-transfers-716315.jpg?auto=format,compress&w=400", "n": 21 }] }, { "name": "Outdoors", "page": "/pages/outdoors-ready-to-press-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/Outdoors.png?auto=format,compress&w=480", "subs": [{ "t": "Camping", "h": "camping-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/LifeIsBetterAroundBonfire.jpg?auto=format,compress&w=400", "n": 45 }, { "t": "Beach", "h": "beach-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/beach-please-transferninja-transfers-317931.jpg?auto=format,compress&w=400", "n": 24 }, { "t": "Boating", "h": "boating-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/i-like-my-boat-my-dog-and-maybe-three-peopleninja-transfers-622435.jpg?auto=format,compress&w=400", "n": 22 }, { "t": "Fishing", "h": "fishing-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/a-bad-day-fishing-is-better-than-a-good-day-at-work-transferninja-transfers-459092.jpg?auto=format,compress&w=400", "n": 38 }, { "t": "Hunting", "h": "hunting-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/hunting-toolsninja-transfers-690991.jpg?auto=format,compress&w=400", "n": 109 }, { "t": "Hiking", "h": "hiking-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/id-rather-be-hikingninja-transfers-771715.jpg?auto=format,compress&w=400", "n": 39 }, { "t": "Western", "h": "western-stickers-dtf-transfers", "img": "https://ninja-transfers-cdn.imgix.net/cowboy-up-or-go-wait-in-the-truckninja-transfers-964896.jpg?auto=format,compress&w=400", "n": 42 }] }];

  // src/diag.js
  var FEATURE = "design-studio";
  var RING_KEY = "nsv2Diag";
  function track(e24, v2) {
    try {
      const body = { f: FEATURE, e: e24 };
      if (typeof v2 === "number" && isFinite(v2) && v2 >= 0) body.v = v2;
      const ver = window.NinjaStudio && window.NinjaStudio.version;
      if (ver) body.ver = String(ver).slice(0, 16);
      body.env = window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "main" ? "production" : "staging";
      const json = JSON.stringify(body);
      if (!cfg.evtUrl) return;
      if (navigator.sendBeacon) navigator.sendBeacon(cfg.evtUrl, json);
      else fetch(cfg.evtUrl, { method: "POST", body: json, keepalive: true }).catch(() => {
      });
    } catch (err) {
    }
  }
  var sentErr = /* @__PURE__ */ new Set();
  function errBeacon(kind) {
    if (sentErr.has(kind) || sentErr.size >= 3) return;
    sentErr.add(kind);
    track(kind);
  }
  function ring(msg) {
    try {
      const rows = JSON.parse(localStorage.getItem(RING_KEY) || "[]");
      rows.push({ t: Date.now(), m: String(msg).slice(0, 300) });
      localStorage.setItem(RING_KEY, JSON.stringify(rows.slice(-20)));
    } catch (e24) {
    }
  }
  function diagCount() {
    try {
      return JSON.parse(localStorage.getItem(RING_KEY) || "[]").length;
    } catch (e24) {
      return 0;
    }
  }
  function diagFail(kind, err) {
    ring(kind + ": " + (err && err.message ? err.message : err));
    errBeacon(kind === "export_fail" ? "export_fail" : "save_fail");
  }
  function installDiagnostics() {
    const fromStudio = (s3) => typeof s3 === "string" && s3.indexOf("studio-v2") !== -1;
    window.addEventListener("error", (e24) => {
      if (fromStudio(e24.filename) || fromStudio(e24.error && e24.error.stack)) {
        ring(e24.message);
        errBeacon("error");
      }
    });
    window.addEventListener("unhandledrejection", (e24) => {
      const r2 = e24.reason;
      if (r2 && fromStudio(r2.stack)) {
        ring(r2.message || String(r2));
        errBeacon("error");
      }
    });
  }

  // src/drive.js
  var DEFAULT_CLIENT_ID = "333432217986-p85aqpdu0cmh9l0ehn44sg31r1k4nlsl.apps.googleusercontent.com";
  var DEFAULT_API_KEY = "AIzaSyDv6DTri7BJaSHwA9s1LxAJ8qiLBqswwh8";
  var MIME_TYPES = "image/jpeg,image/png,image/gif,image/webp,image/svg+xml,image/tiff,application/pdf";
  var scriptPromises = /* @__PURE__ */ new Map();
  function loadScript(src) {
    if (scriptPromises.has(src)) return scriptPromises.get(src);
    const p2 = new Promise((resolve, reject) => {
      const s3 = document.createElement("script");
      s3.src = src;
      s3.async = true;
      s3.onload = resolve;
      s3.onerror = () => {
        scriptPromises.delete(src);
        reject(new Error("Failed to load " + src));
      };
      document.head.appendChild(s3);
    });
    scriptPromises.set(src, p2);
    return p2;
  }
  async function ensurePicker() {
    if (!(window.google && window.google.accounts && window.google.accounts.oauth2)) {
      await loadScript("https://accounts.google.com/gsi/client");
    }
    if (!(window.gapi && window.google && window.google.picker)) {
      await loadScript("https://apis.google.com/js/api.js");
      await new Promise(
        (resolve, reject) => window.gapi.load("picker", { callback: resolve, onerror: () => reject(new Error("Picker API failed")) })
      );
    }
  }
  async function fetchDriveFile(fileId, fileName, mimeType, accessToken) {
    const res = await fetch(
      "https://www.googleapis.com/drive/v3/files/" + encodeURIComponent(fileId) + "?alt=media&supportsAllDrives=true",
      { headers: { Authorization: "Bearer " + accessToken } }
    );
    if (!res.ok) throw new Error("Drive download failed: " + res.status);
    const ab = await res.arrayBuffer();
    const type = mimeType || "application/octet-stream";
    return new File([new Blob([ab], { type })], fileName, { type });
  }
  function openDrivePicker(cfg2 = {}, onFile) {
    const clientId = cfg2.clientId || DEFAULT_CLIENT_ID;
    const apiKey = cfg2.apiKey || DEFAULT_API_KEY;
    ensurePicker().then(() => {
      const tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: clientId,
        scope: "https://www.googleapis.com/auth/drive.file",
        login_hint: cfg2.loginHint || "",
        callback: (tok) => {
          if (!tok || !tok.access_token) return;
          const docsView = new window.google.picker.DocsView(window.google.picker.ViewId.DOCS).setMimeTypes(MIME_TYPES).setIncludeFolders(true).setSelectFolderEnabled(false);
          const uploadView = new window.google.picker.DocsUploadView();
          const picker = new window.google.picker.PickerBuilder().enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED).enableFeature(window.google.picker.Feature.SUPPORT_DRIVES).setAppId((clientId || "").split("-")[0]).setOAuthToken(tok.access_token).setDeveloperKey(apiKey).addView(docsView).addView(uploadView).setCallback((data) => {
            if (data.action !== window.google.picker.Action.PICKED) return;
            (data.docs || []).forEach((doc) => {
              fetchDriveFile(doc.id, doc.name, doc.mimeType, tok.access_token).then(onFile).catch((err) => console.error("studio-v2: Drive import failed", doc.name, err));
            });
          }).build();
          picker.setVisible(true);
        }
      });
      tokenClient.requestAccessToken({ prompt: "" });
    }).catch((err) => console.error("studio-v2: Drive picker unavailable", err));
  }

  // src/bgr.js
  var BGR_MODELS = [
    { key: "ix", label: "Option 1", modelParam: null },
    { key: "pc", label: "Option 2", modelParam: 4 },
    { key: "gram", label: "Option 3", lambda: true }
  ];
  var FAL_TIMEOUT_MS = 25e3;
  var isVectorName = (name) => /\.(?:svg|eps|pdf|ai)(?:[?#]|$)/i.test(name || "");
  function candidateUrl(imgixUrl, model, w2 = 2e3, trimmed = false) {
    const base = imgixUrl.split("?")[0] + "?" + (trimmed ? "trim=colorUnlessAlpha&" : "") + "fm=png&fit=max&w=" + w2 + "&bg-remove=true";
    return model.modelParam ? base + "&bg-remove-model=" + model.modelParam : base;
  }
  async function gramPreview(imgixUrl) {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), FAL_TIMEOUT_MS);
    try {
      const previewInput = imgixUrl + (imgixUrl.includes("?") ? "&" : "?") + "w=2000&fit=max";
      const resp = await fetch(cfg.proxyUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Object.assign({ model: "gram", imageUrl: previewInput }, cfg.store ? { store: cfg.store } : {})),
        signal: ctrl.signal
      });
      if (!resp.ok) throw new Error("gram HTTP " + resp.status);
      const data = await resp.json();
      if (!data || !data.url) throw new Error("gram response missing url");
      return data.url;
    } finally {
      clearTimeout(timer);
    }
  }
  var RETRY_DELAYS = [2e3, 5e3, 1e4];
  function loadImageWithRetry(url, attempt = 0) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(url);
      img.onerror = () => {
        if (attempt >= RETRY_DELAYS.length) return reject(new Error("failed: " + url.slice(0, 80)));
        setTimeout(() => loadImageWithRetry(url, attempt + 1).then(resolve, reject), RETRY_DELAYS[attempt]);
      };
      img.src = url;
    });
  }

  // src/ai.js
  var ROT_HOST = "https://www.rushordertees.com/design";
  var AI_TIMEOUT_MS = 6e4;
  var EDIT_TIMEOUT_MS = 6e4;
  var AI_BATCH = 3;
  function composeEditPrompt(prompt, lineage) {
    const chain = (lineage || []).slice(-4);
    if (!chain.length) return prompt;
    return "Earlier edits already applied to this image, in order:\n" + chain.map((p2, i2) => i2 + 1 + ". " + p2).join("\n") + "\n\nNow apply only this change: " + prompt + `

Vague references like "it" or "that" in the new change mean the thing added or changed by the most recent edit above, NOT the whole image. Do not re-apply earlier edits or alter the image's size, crop, or composition unless explicitly asked.`;
  }
  async function aiEdit(imageUrl, prompt, lineage, signal) {
    const input = imageUrl + (imageUrl.indexOf("?") > -1 ? "&" : "?") + "w=2000&fit=max";
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), EDIT_TIMEOUT_MS);
    if (signal) signal.addEventListener("abort", () => ctrl.abort(), { once: true });
    try {
      const resp = await fetch(cfg.proxyUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "gram-edit-45g",
          imageUrl: input,
          prompt: composeEditPrompt(prompt, lineage),
          transparency: "AUTO",
          ...cfg.store ? { store: cfg.store } : {}
        }),
        signal: ctrl.signal
      });
      if (!resp.ok) {
        const err = new Error("ai-edit HTTP " + resp.status + " " + (await resp.text()).slice(0, 120));
        err.aiRefused = true;
        throw err;
      }
      const data = await resp.json();
      if (!data || !data.url) {
        const err = new Error("ai-edit response missing url");
        err.aiRefused = true;
        throw err;
      }
      return data.url + (data.url.indexOf("?") > -1 ? "&" : "?") + "cs=strip";
    } finally {
      clearTimeout(timer);
    }
  }
  function waitForRender(url, totalMs = 6e4) {
    const deadline = Date.now() + totalMs;
    return new Promise((resolve, reject) => {
      const attempt = () => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(url);
        img.onerror = () => {
          if (Date.now() > deadline) return reject(new Error("render not servable: " + url.slice(0, 80)));
          setTimeout(attempt, 3e3);
        };
        img.src = url;
      };
      attempt();
    });
  }
  var hiRes = (url) => url.replace("/unsafe/", "/unsafe/3000x0/");
  function normalize(items) {
    return (Array.isArray(items) ? items : []).filter((it2) => it2 && it2.url).slice(0, AI_BATCH).map((it2) => ({ url: hiRes(it2.url), thumbnailUrl: it2.thumbnailUrl || it2.url, fileName: it2.fileName || "ai-image.png" }));
  }
  async function aiCreate(prompt, opts = {}) {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), AI_TIMEOUT_MS);
    if (opts.signal) opts.signal.addEventListener("abort", () => ctrl.abort(), { once: true });
    try {
      if (!opts.fresh) try {
        const cached = await fetch(
          ROT_HOST + "/studio/getGenerativeAiUploads.php?prompt=" + encodeURIComponent(prompt),
          { credentials: "include", signal: ctrl.signal }
        );
        if (cached.ok) {
          const rows = normalize(await cached.json());
          if (rows.length) return rows;
        }
      } catch (e24) {
      }
      const resp = await fetch(ROT_HOST + "/studio/postBatchGenerativeAiUpload.php", {
        method: "POST",
        body: JSON.stringify({ prompt, batchSize: AI_BATCH, brandingName: cfg.brandingName }),
        signal: ctrl.signal
      });
      if (!resp.ok) throw new Error("ai-create HTTP " + resp.status);
      return normalize(await resp.json());
    } finally {
      clearTimeout(timer);
    }
  }
  var AI_CREATE_STARTERS = [
    "A fierce ninja mascot holding a katana",
    "Retro sunset with palm trees and bold stripes",
    "A cute cartoon dog wearing sunglasses"
  ];
  var AI_EDIT_CHIPS = [
    "Turn it into a cartoon",
    "Black and white line art",
    "Vintage, distressed look",
    "Make the colors pop",
    "Add a sunset background",
    "Add a thick white outline"
  ];
  var HISTORY_KEY = "ninjaAiHistory";
  var HISTORY_TTL = 30 * 24 * 3600 * 1e3;
  var HISTORY_MAX = 30;
  function aiHistory() {
    try {
      const rows = JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]");
      const now = Date.now();
      return rows.filter((r2) => r2 && r2.url && now - (r2.savedAt || 0) < HISTORY_TTL);
    } catch (e24) {
      return [];
    }
  }
  function aiHistoryAdd(items, prompt) {
    try {
      const now = Date.now();
      const cur = aiHistory();
      for (const it2 of items) {
        if (cur.some((r2) => r2.url === it2.url)) continue;
        cur.unshift({ url: it2.url, thumbnailUrl: it2.thumbnailUrl, fileName: it2.fileName, prompt, savedAt: now });
      }
      localStorage.setItem(HISTORY_KEY, JSON.stringify(cur.slice(0, HISTORY_MAX)));
      document.dispatchEvent(new CustomEvent("ninjaAiHistory:changed"));
    } catch (e24) {
    }
  }
  var USAGE_KEY = "nanoBananaUsage";
  var DAILY_LIMIT = 50;
  function usageDay() {
    const d2 = /* @__PURE__ */ new Date();
    return d2.getFullYear() + "-" + String(d2.getMonth() + 1).padStart(2, "0") + "-" + String(d2.getDate()).padStart(2, "0");
  }
  function canUseAi() {
    try {
      const u2 = JSON.parse(localStorage.getItem(USAGE_KEY) || "null");
      return !u2 || u2.day !== usageDay() || (u2.count || 0) < DAILY_LIMIT;
    } catch (e24) {
      return true;
    }
  }
  function consumeAi() {
    try {
      const day = usageDay();
      let u2 = JSON.parse(localStorage.getItem(USAGE_KEY) || "null");
      if (!u2 || u2.day !== day) u2 = { day, count: 0 };
      u2.count = (u2.count || 0) + 1;
      localStorage.setItem(USAGE_KEY, JSON.stringify(u2));
    } catch (e24) {
    }
  }

  // src/color-names.js
  var _ctx;
  function cssToSolidHex(c2) {
    if (typeof c2 !== "string" || !c2) return null;
    if (!(window.CSS && CSS.supports("color", c2))) return null;
    _ctx = _ctx || document.createElement("canvas").getContext("2d");
    _ctx.fillStyle = "#000000";
    _ctx.fillStyle = c2;
    const v2 = _ctx.fillStyle;
    if (v2.startsWith("#")) return v2.length === 7 ? v2 : "#" + v2.slice(1, 7);
    const m = v2.match(/rgba?\((\d+), ?(\d+), ?(\d+)/);
    if (!m) return null;
    return "#" + [m[1], m[2], m[3]].map((n2) => (+n2).toString(16).padStart(2, "0")).join("");
  }
  function hexToHsl(hex3) {
    const r2 = parseInt(hex3.slice(1, 3), 16) / 255;
    const g2 = parseInt(hex3.slice(3, 5), 16) / 255;
    const b2 = parseInt(hex3.slice(5, 7), 16) / 255;
    const max = Math.max(r2, g2, b2), min = Math.min(r2, g2, b2);
    const l2 = (max + min) / 2;
    if (max === min) return { h: 0, s: 0, l: l2 * 100 };
    const d2 = max - min;
    const s3 = l2 > 0.5 ? d2 / (2 - max - min) : d2 / (max + min);
    let h2;
    if (max === r2) h2 = ((g2 - b2) / d2 + (g2 < b2 ? 6 : 0)) * 60;
    else if (max === g2) h2 = ((b2 - r2) / d2 + 2) * 60;
    else h2 = ((r2 - g2) / d2 + 4) * 60;
    return { h: h2, s: s3 * 100, l: l2 * 100 };
  }
  function hslToHex(h2, s3, l2) {
    return cssToSolidHex("hsl(" + h2 + ", " + s3 + "%, " + l2 + "%)");
  }
  var EXTRA_NAMES = {
    mint: "#98e8c1",
    "mint green": "#98e8c1",
    sage: "#9caf88",
    emerald: "#2ecc71",
    mustard: "#e1ad01",
    peach: "#ffcba4",
    apricot: "#fbceb1",
    cream: "#fffdd0",
    blush: "#f4c2c2",
    rust: "#b7410e",
    burgundy: "#800020",
    wine: "#722f37",
    charcoal: "#36454f",
    slate: "#64748b",
    denim: "#1560bd",
    cobalt: "#0047ab",
    sapphire: "#0f52ba",
    ruby: "#e0115f",
    rose: "#ff007f",
    "rose gold": "#b76e79",
    terracotta: "#e2725b",
    sand: "#e3c9a3",
    taupe: "#8b8589",
    mauve: "#e0b0ff",
    lilac: "#c8a2c8",
    periwinkle: "#ccccff",
    blueberry: "#4f86f7",
    grape: "#6f2da8",
    eggplant: "#614051",
    pumpkin: "#ff7518",
    tangerine: "#f28500",
    lemon: "#fff44f",
    banana: "#ffe135",
    avocado: "#568203",
    pine: "#01796f",
    seafoam: "#93e9be",
    aqua: "#00ffff",
    ocean: "#016fb9",
    midnight: "#191970",
    ink: "#0f172a",
    offwhite: "#faf7f2",
    "off white": "#faf7f2",
    bone: "#e3dac9",
    mocha: "#967259",
    espresso: "#4e342e",
    caramel: "#af6f09",
    honey: "#eb9605",
    bronze: "#cd7f32",
    copper: "#b87333",
    "gun metal": "#2a3439",
    gunmetal: "#2a3439",
    scarlet: "#ff2400",
    // Art / design vocabulary CSS doesn't know (Owen 9-04: "vermilion" missed).
    vermilion: "#e34234",
    vermillion: "#e34234",
    cerulean: "#2a52be",
    ochre: "#cc7722",
    ocher: "#cc7722",
    umber: "#635147",
    "burnt umber": "#8a3324",
    "burnt sienna": "#e97451",
    "burnt orange": "#cc5500",
    carmine: "#960018",
    cardinal: "#c41e3a",
    brick: "#cb4154",
    "brick red": "#cb4154",
    mahogany: "#c04000",
    chestnut: "#954535",
    auburn: "#a52a2a",
    amber: "#ffbf00",
    saffron: "#f4c430",
    marigold: "#eaa221",
    canary: "#ffef00",
    butterscotch: "#e09540",
    flax: "#eedc82",
    moss: "#8a9a5b",
    fern: "#71bc78",
    forest: "#228b22",
    "kelly green": "#4cbb17",
    "hunter green": "#355e3b",
    jade: "#00a86b",
    viridian: "#40826d",
    spruce: "#2c5545",
    juniper: "#3d5d42",
    celadon: "#ace1af",
    pistachio: "#93c572",
    shamrock: "#009e60",
    "sea green": "#2e8b57",
    peacock: "#33a1c9",
    ultramarine: "#3f00ff",
    "prussian blue": "#003153",
    iris: "#5a4fcf",
    amethyst: "#9966cc",
    heliotrope: "#df73ff",
    cerise: "#de3163",
    raspberry: "#e30b5d",
    strawberry: "#fc5a8d",
    watermelon: "#fc6c85",
    flamingo: "#fc8eac",
    bubblegum: "#ffc1cc",
    melon: "#fdbcb4",
    cantaloupe: "#ffa62f",
    papaya: "#ffefd5",
    persimmon: "#ec5800",
    carrot: "#ed9121",
    cinnamon: "#d2691e",
    ginger: "#b06500",
    walnut: "#773f1a",
    coffee: "#6f4e37",
    cocoa: "#875f42",
    camel: "#c19a6b",
    fawn: "#e5aa70",
    buff: "#dab87f",
    ecru: "#c2b280",
    eggshell: "#f0ead6",
    alabaster: "#edeae0",
    pearl: "#eae0c8",
    porcelain: "#f0f2f5",
    pewter: "#8e9294",
    ash: "#b2beb5",
    smoke: "#738276",
    graphite: "#41424c",
    onyx: "#353839",
    jet: "#343434",
    obsidian: "#3a3c42",
    ebony: "#555d50",
    aubergine: "#472c4c",
    mulberry: "#c54b8c",
    oxblood: "#4a0000",
    garnet: "#733635",
    cherry: "#de3163",
    flame: "#e25822",
    brass: "#b5a642",
    champagne: "#f7e7ce",
    vanilla: "#f3e5ab",
    oatmeal: "#d9c7a7",
    latte: "#c8a27a",
    spearmint: "#45b08c",
    evergreen: "#05472a",
    "royal purple": "#7851a9",
    "royal blue": "#4169e1",
    "steel blue": "#4682b4",
    steel: "#71797e",
    "sky blue": "#87ceeb",
    sky: "#87ceeb",
    cornflower: "#6495ed",
    "ice blue": "#d6ecef",
    "forest green": "#228b22",
    "olive green": "#708238",
    "army green": "#4b5320",
    "navy blue": "#000080",
    "blood red": "#660000",
    "fire engine red": "#ce2029",
    "sunflower yellow": "#ffda03",
    sunflower: "#ffda03",
    "bubblegum pink": "#ffc1cc"
  };
  var MOD_BASES = {
    purple: "#8b5cf6",
    violet: "#7c3aed",
    blue: "#3b82f6",
    red: "#ef4444",
    green: "#22c55e",
    pink: "#ec4899",
    orange: "#f97316",
    yellow: "#eab308",
    teal: "#14b8a6",
    cyan: "#06b6d4",
    magenta: "#d946ef",
    indigo: "#6366f1",
    brown: "#92693e",
    gray: "#6b7280",
    grey: "#6b7280",
    lime: "#84cc16",
    turquoise: "#2dd4bf",
    navy: "#1e3a8a",
    maroon: "#7f1d1d"
  };
  var MODIFIERS = {
    light: (c2) => ({ h: c2.h, s: c2.s * 0.9, l: Math.min(84, c2.l + 18) }),
    lighter: (c2) => ({ h: c2.h, s: c2.s * 0.85, l: Math.min(88, c2.l + 26) }),
    pale: (c2) => ({ h: c2.h, s: Math.max(25, c2.s * 0.45), l: Math.min(90, c2.l + 30) }),
    pastel: (c2) => ({ h: c2.h, s: Math.max(30, c2.s * 0.5), l: Math.min(88, c2.l + 28) }),
    baby: (c2) => ({ h: c2.h, s: Math.max(30, c2.s * 0.5), l: Math.min(90, c2.l + 32) }),
    soft: (c2) => ({ h: c2.h, s: Math.max(30, c2.s * 0.6), l: Math.min(85, c2.l + 18) }),
    dark: (c2) => ({ h: c2.h, s: c2.s, l: Math.max(12, c2.l - 20) }),
    darker: (c2) => ({ h: c2.h, s: c2.s, l: Math.max(10, c2.l - 28) }),
    deep: (c2) => ({ h: c2.h, s: Math.min(100, c2.s + 8), l: Math.max(15, c2.l - 24) }),
    bright: (c2) => ({ h: c2.h, s: 100, l: Math.min(60, Math.max(48, c2.l)) }),
    vivid: (c2) => ({ h: c2.h, s: 100, l: Math.min(58, Math.max(46, c2.l)) }),
    neon: (c2) => ({ h: c2.h, s: 100, l: 55 }),
    electric: (c2) => ({ h: c2.h, s: 100, l: 52 }),
    hot: (c2) => ({ h: c2.h, s: 100, l: 50 }),
    muted: (c2) => ({ h: c2.h, s: Math.max(15, c2.s * 0.5), l: c2.l }),
    dusty: (c2) => ({ h: c2.h, s: Math.max(15, c2.s * 0.45), l: Math.min(75, c2.l + 6) }),
    medium: (c2) => c2
  };
  function resolveBase(s3) {
    const hexMatch = s3.match(/^#?([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i);
    if (hexMatch) {
      let h2 = hexMatch[1];
      if (h2.length === 4 || h2.length === 8) h2 = h2.slice(0, h2.length === 4 ? 3 : 6);
      if (h2.length === 3) h2 = h2.split("").map((ch) => ch + ch).join("");
      return "#" + h2.toLowerCase();
    }
    return cssToSolidHex(s3) || cssToSolidHex(s3.replace(/ /g, "")) || EXTRA_NAMES[s3] || null;
  }
  function resolveColorName(input) {
    if (typeof input !== "string") return null;
    const s3 = input.trim().toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ");
    if (!s3) return null;
    const direct = resolveBase(s3);
    if (direct) return direct;
    const words = s3.split(" ");
    const mods = [];
    while (words.length > 1 && MODIFIERS[words[0]]) mods.push(MODIFIERS[words.shift()]);
    if (!mods.length) return null;
    const rest = words.join(" ");
    const base = MOD_BASES[rest] || resolveBase(rest);
    if (!base) return null;
    let hsl = hexToHsl(base);
    for (const m of mods) hsl = m(hsl);
    return hslToHex(hsl.h, hsl.s, hsl.l);
  }
  var COMMON_NAMES = [
    "red",
    "orange",
    "yellow",
    "green",
    "blue",
    "purple",
    "pink",
    "brown",
    "black",
    "white",
    "gray",
    "grey",
    "cyan",
    "magenta",
    "teal",
    "navy",
    "maroon",
    "olive",
    "lime",
    "aqua",
    "silver",
    "gold",
    "beige",
    "coral",
    "crimson",
    "fuchsia",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "orchid",
    "plum",
    "salmon",
    "sienna",
    "tan",
    "tomato",
    "turquoise",
    "violet",
    "azure",
    "chocolate",
    "scarlet"
  ];
  var FUZZ_BASES = [.../* @__PURE__ */ new Set([...COMMON_NAMES, ...Object.keys(EXTRA_NAMES), ...Object.keys(MOD_BASES)])];
  var FUZZ_MODS = Object.keys(MODIFIERS);
  function editDistance(a2, b2, cap) {
    if (Math.abs(a2.length - b2.length) > cap) return cap + 1;
    let prev = Array.from({ length: b2.length + 1 }, (_2, i2) => i2);
    for (let i2 = 1; i2 <= a2.length; i2++) {
      const cur = [i2];
      let rowMin = i2;
      for (let j2 = 1; j2 <= b2.length; j2++) {
        cur[j2] = Math.min(prev[j2] + 1, cur[j2 - 1] + 1, prev[j2 - 1] + (a2[i2 - 1] === b2[j2 - 1] ? 0 : 1));
        if (cur[j2] < rowMin) rowMin = cur[j2];
      }
      if (rowMin > cap) return cap + 1;
      prev = cur;
    }
    return prev[b2.length];
  }
  function nearestWord(w2, dict) {
    if (w2.length < 3) return null;
    const cap = w2.length <= 5 ? 1 : 2;
    let best = null, bestD = cap + 1;
    for (const cand of dict) {
      const d2 = editDistance(w2, cand, cap);
      if (d2 < bestD) {
        bestD = d2;
        best = cand;
        if (d2 === 0) break;
      }
    }
    return best;
  }
  function resolveColorSmart(input) {
    const strict = resolveColorName(input);
    if (strict) return { hex: strict, corrected: null };
    if (typeof input !== "string") return { hex: null, corrected: null };
    const s3 = input.trim().toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ");
    if (!s3 || s3.startsWith("#")) return { hex: null, corrected: null };
    const whole = nearestWord(s3, FUZZ_BASES);
    if (whole) {
      const hex3 = resolveColorName(whole);
      if (hex3) return { hex: hex3, corrected: whole };
    }
    const words = s3.split(" ");
    const fixed = words.map((w2, i2) => {
      if (i2 < words.length - 1 && (MODIFIERS[w2] || nearestWord(w2, FUZZ_MODS))) {
        return MODIFIERS[w2] ? w2 : nearestWord(w2, FUZZ_MODS);
      }
      return resolveBase(w2) || MOD_BASES[w2] ? w2 : nearestWord(w2, FUZZ_BASES) || w2;
    });
    const phrase = fixed.join(" ");
    if (phrase !== s3) {
      const hex3 = resolveColorName(phrase);
      if (hex3) return { hex: hex3, corrected: phrase };
    }
    return { hex: null, corrected: null };
  }
  var NAME_POOL = (() => {
    const pool = [];
    const push = (name, hex3) => {
      const c2 = hexToRgbLocal(hex3);
      if (c2) pool.push({ name, c: c2 });
    };
    function hexToRgbLocal(h2) {
      const m = /^#([0-9a-f]{6})$/i.exec(h2 || "");
      if (!m) return null;
      const n2 = parseInt(m[1], 16);
      return [n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255];
    }
    for (const [k2, v2] of Object.entries(EXTRA_NAMES)) push(k2, v2);
    for (const [k2, v2] of Object.entries(MOD_BASES)) push(k2, v2);
    for (const k2 of ["black|#000000", "white|#ffffff", "silver|#c0c0c0", "beige|#f5f5dc", "cream|#fffdd0", "tan|#d2b48c", "gold|#ffd700", "olive|#808000", "coral|#ff7f50", "crimson|#dc143c", "salmon|#fa8072", "khaki|#f0e68c", "lavender|#e6e6fa", "plum|#dda0dd", "orchid|#da70d6"]) {
      const [n2, h2] = k2.split("|");
      push(n2, h2);
    }
    return pool;
  })();
  function nearestColorName(hex3) {
    const m = /^#([0-9a-f]{6})$/i.exec(hex3 || "");
    if (!m) return hex3;
    const n2 = parseInt(m[1], 16);
    const r2 = n2 >> 16 & 255, g2 = n2 >> 8 & 255, b2 = n2 & 255;
    let best = null, bestD = Infinity;
    for (const p2 of NAME_POOL) {
      const d2 = (p2.c[0] - r2) ** 2 + (p2.c[1] - g2) ** 2 + (p2.c[2] - b2) ** 2;
      if (d2 < bestD) {
        bestD = d2;
        best = p2.name;
      }
    }
    return bestD < 3600 ? best : hex3;
  }

  // src/colorpicker.js
  var clamp01 = (v2) => v2 < 0 ? 0 : v2 > 1 ? 1 : v2;
  function hexToHsv(hex3) {
    const m = /^#?([0-9a-f]{6})$/i.exec(String(hex3 || "").trim());
    const n2 = m ? parseInt(m[1], 16) : 0;
    const r2 = (n2 >> 16 & 255) / 255, g2 = (n2 >> 8 & 255) / 255, b2 = (n2 & 255) / 255;
    const mx = Math.max(r2, g2, b2), mn2 = Math.min(r2, g2, b2), d2 = mx - mn2;
    let h2 = 0;
    if (d2) {
      if (mx === r2) h2 = (g2 - b2) / d2 % 6;
      else if (mx === g2) h2 = (b2 - r2) / d2 + 2;
      else h2 = (r2 - g2) / d2 + 4;
      h2 = (h2 * 60 + 360) % 360;
    }
    return { h: h2, s: mx ? d2 / mx : 0, v: mx };
  }
  function hsvToHex({ h: h2, s: s3, v: v2 }) {
    const f2 = (n2) => {
      const k2 = (n2 + h2 / 60) % 6;
      const c2 = v2 - v2 * s3 * Math.max(0, Math.min(k2, 4 - k2, 1));
      return Math.round(c2 * 255).toString(16).padStart(2, "0");
    };
    return "#" + f2(5) + f2(3) + f2(1);
  }
  function buildColorPicker(rootEl) {
    const el2 = (cls, html) => {
      const d2 = document.createElement("div");
      d2.className = cls;
      if (html) d2.innerHTML = html;
      return d2;
    };
    const pop = el2("nsv2-cpick");
    pop.hidden = true;
    const sv = el2("nsv2-cpick-sv");
    const svKnob = el2("nsv2-cpick-knob");
    sv.appendChild(svKnob);
    const hueRow = el2("nsv2-cpick-hue");
    const hueKnob = el2("nsv2-cpick-knob nsv2-cpick-hue-knob");
    hueRow.appendChild(hueKnob);
    const row = el2("nsv2-cpick-row");
    const chip = el2("nsv2-cpick-chip");
    const hexWrap = el2("nsv2-cpick-hexwrap");
    const hexIn = document.createElement("input");
    hexIn.className = "nsv2-cpick-hex";
    hexIn.type = "text";
    hexIn.spellcheck = false;
    hexIn.maxLength = 7;
    hexWrap.appendChild(hexIn);
    const dropBtn = document.createElement("button");
    dropBtn.type = "button";
    dropBtn.className = "nsv2-icon-btn nsv2-cpick-drop";
    dropBtn.title = "Pick from screen";
    dropBtn.innerHTML = '<svg width="17" height="17" viewBox="0 0 20 20" fill="none"><path d="M13.2 2.8a2.3 2.3 0 0 1 3.9 1.7c0 .6-.2 1.2-.7 1.6l-1.5 1.5.6.6a.9.9 0 0 1-1.3 1.3l-.4-.4-6.8 6.8c-.3.3-.7.5-1.1.6l-2.3.5a.7.7 0 0 1-.8-.8l.5-2.3c.1-.4.3-.8.6-1.1l6.8-6.8-.4-.4A.9.9 0 0 1 11.6 4l.6.6 1-1zM6 14.9l6.4-6.4-1-1L5 13.9l-.3 1.3 1.3-.3z" fill="currentColor"/></svg>';
    row.append(chip, hexWrap, dropBtn);
    const designLabel = el2("nsv2-cpick-label");
    designLabel.textContent = "Design colors";
    const designRow = el2("nsv2-cpick-design");
    const paletteLabel = el2("nsv2-cpick-label");
    paletteLabel.textContent = "Default colors";
    const paletteRow = el2("nsv2-cpick-design nsv2-cpick-palette");
    designLabel.textContent = "Colors in this design";
    paletteLabel.textContent = "Default solid colors";
    const customBtn = document.createElement("button");
    customBtn.type = "button";
    customBtn.className = "nsv2-swatch nsv2-swatch--custom";
    customBtn.title = "Custom color";
    customBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>';
    const dropBtn2 = document.createElement("button");
    dropBtn2.type = "button";
    dropBtn2.className = "nsv2-swatch nsv2-swatch--tool";
    dropBtn2.title = "Pick from screen";
    dropBtn2.innerHTML = dropBtn.innerHTML;
    const swView = el2("nsv2-cpick-swview");
    swView.append(designLabel, designRow, paletteLabel, paletteRow);
    const handle = el2("nsv2-cpick-handle");
    const head = el2("nsv2-cpick-head");
    const headTitle = el2("nsv2-cpick-title");
    const headDone = document.createElement("button");
    headDone.type = "button";
    headDone.className = "nsv2-cpick-done";
    headDone.innerHTML = '<svg width="20" height="20" viewBox="0 -960 960 960" fill="currentColor"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>';
    const headX = document.createElement("button");
    headX.type = "button";
    headX.className = "nsv2-cpick-x";
    headX.title = "Close";
    headX.setAttribute("aria-label", "Close");
    headX.innerHTML = '<svg width="20" height="20" viewBox="0 -960 960 960" fill="currentColor"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>';
    head.append(headX, headTitle, headDone);
    const tabs = el2("nsv2-cpick-tabs");
    const tabColor = document.createElement("button");
    tabColor.type = "button";
    tabColor.className = "nsv2-cpick-tab is-on";
    tabColor.textContent = "Color";
    const tabGrad = document.createElement("button");
    tabGrad.type = "button";
    tabGrad.className = "nsv2-cpick-tab";
    tabGrad.textContent = "Gradient";
    tabs.append(tabColor, tabGrad);
    tabs.hidden = true;
    const gradHost = el2("nsv2-cpick-gradhost");
    gradHost.hidden = true;
    let gradDock = null;
    const backBtn = document.createElement("button");
    backBtn.type = "button";
    backBtn.className = "nsv2-cpick-back";
    backBtn.title = "Back to colors";
    backBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M14.5 5.5 8 12l6.5 6.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    head.insertBefore(backBtn, headTitle);
    const specView = el2("nsv2-cpick-specview");
    specView.append(sv, hueRow, row);
    pop.append(handle, head, swView, specView, gradHost, tabs);
    rootEl.appendChild(pop);
    const isMobile = () => rootEl.clientWidth < 768;
    const returnGradNodes = () => {
      if (!gradDock) return;
      for (let i2 = gradDock.nodes.length - 1; i2 >= 0; i2--) {
        const h2 = gradDock.home[i2];
        const next = h2.next && h2.next.parentElement === h2.parent ? h2.next : null;
        h2.parent.insertBefore(gradDock.nodes[i2], next);
      }
      gradDock = null;
    };
    const showTab = (which) => {
      tabColor.classList.toggle("is-on", which === "color");
      tabGrad.classList.toggle("is-on", which === "grad");
      gradHost.hidden = which !== "grad";
      specView.style.display = "";
      swView.style.display = "";
      pop.classList.toggle("is-grad", which === "grad");
    };
    tabColor.addEventListener("click", () => showTab("color"));
    tabGrad.addEventListener("click", () => showTab("grad"));
    headDone.addEventListener("click", () => close());
    const setView = (v2) => {
      pop.classList.toggle("is-spectrum", v2 === "spectrum");
      place();
    };
    customBtn.addEventListener("click", () => setView("spectrum"));
    backBtn.addEventListener("click", () => setView("swatches"));
    dropBtn2.addEventListener("click", async () => {
      try {
        const res = await openEyeDropper();
        if (res && res.sRGBHex) {
          hsv = hexToHsv(res.sRGBHex);
          emit();
        }
      } catch (e24) {
      }
    });
    let hsv = { h: 0, s: 1, v: 1 };
    let cb = null;
    let closeCb = null;
    let anchorEl = null;
    const paint = () => {
      try {
        const nm = nearestColorName(hsvToHex(hsv));
        headTitle.textContent = nm ? nm.charAt(0).toUpperCase() + nm.slice(1) : hsvToHex(hsv).toUpperCase();
      } catch (e24) {
        headTitle.textContent = hsvToHex(hsv).toUpperCase();
      }
      sv.style.backgroundColor = "hsl(" + hsv.h + ", 100%, 50%)";
      svKnob.style.left = hsv.s * 100 + "%";
      svKnob.style.top = (1 - hsv.v) * 100 + "%";
      hueKnob.style.left = hsv.h / 360 * 100 + "%";
      const hex3 = hsvToHex(hsv);
      chip.style.background = hex3;
      if (document.activeElement !== hexIn) hexIn.value = hex3.toUpperCase();
      return hex3;
    };
    const emit = () => {
      const hex3 = paint();
      if (cb) cb(hex3);
    };
    const drag = (surface, apply) => {
      const move = (e24) => {
        const r2 = surface.getBoundingClientRect();
        apply(clamp01((e24.clientX - r2.left) / r2.width), clamp01((e24.clientY - r2.top) / r2.height));
        emit();
      };
      surface.addEventListener("pointerdown", (e24) => {
        e24.preventDefault();
        surface.setPointerCapture(e24.pointerId);
        move(e24);
        const up = () => {
          surface.removeEventListener("pointermove", move);
          surface.removeEventListener("pointerup", up);
        };
        surface.addEventListener("pointermove", move);
        surface.addEventListener("pointerup", up);
      });
    };
    drag(sv, (x2, y2) => {
      hsv.s = x2;
      hsv.v = 1 - y2;
    });
    drag(hueRow, (x2) => {
      hsv.h = Math.min(359.9, x2 * 360);
    });
    hexIn.addEventListener("input", () => {
      const v2 = hexIn.value.trim();
      if (/^#?[0-9a-f]{6}$/i.test(v2)) {
        hsv = hexToHsv(v2.startsWith("#") ? v2 : "#" + v2);
        emit();
      }
    });
    dropBtn.addEventListener("click", async () => {
      try {
        const res = await openEyeDropper();
        if (res && res.sRGBHex) {
          hsv = hexToHsv(res.sRGBHex);
          emit();
        }
      } catch (e24) {
      }
    });
    const swatchClick = (e24) => {
      const sw = e24.target.closest(".nsv2-swatch");
      if (!sw || !sw.dataset.c) return;
      hsv = hexToHsv(sw.dataset.c);
      emit();
    };
    designRow.addEventListener("click", swatchClick);
    paletteRow.addEventListener("click", swatchClick);
    let closeT = 0;
    const close = () => {
      if (pop.hidden || pop.classList.contains("is-closing")) return;
      returnGradNodes();
      if (pop.classList.contains("nsv2-cpick--sheet") && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        pop.classList.add("is-closing");
        const done = () => {
          clearTimeout(closeT);
          pop.removeEventListener("animationend", done);
          pop.classList.remove("is-closing");
          pop.hidden = true;
        };
        pop.addEventListener("animationend", done);
        closeT = setTimeout(done, 400);
      } else pop.hidden = true;
      if (closeCb) closeCb();
      cb = null;
      closeCb = null;
      anchorEl = null;
    };
    document.addEventListener("pointerdown", (e24) => {
      if (!pop.hidden && !pop.contains(e24.target) && !(anchorEl && anchorEl.contains(e24.target))) close();
    });
    const fillRow = (rowEl, labelEl, colors, lead) => {
      rowEl.innerHTML = "";
      if (lead) for (const n2 of lead) rowEl.appendChild(n2);
      labelEl.hidden = rowEl.hidden = !colors.length && !lead;
      const cur = hsvToHex(hsv).toLowerCase();
      for (const c2 of colors) {
        const sw = document.createElement("button");
        sw.type = "button";
        sw.className = "nsv2-swatch" + (String(c2).toLowerCase() === cur ? " is-active" : "");
        sw.dataset.c = c2;
        sw.style.background = c2;
        rowEl.appendChild(sw);
      }
    };
    const place = () => {
      let anchor = anchorEl || rootEl;
      if (anchor.offsetWidth < 4 && anchor.parentElement) anchor = anchor.parentElement;
      const ar2 = rootEl.getBoundingClientRect();
      const br2 = anchor.getBoundingClientRect();
      const w2 = pop.offsetWidth || 268;
      const hgt = pop.offsetHeight || 320;
      let x2 = br2.left - ar2.left - w2 / 2 + br2.width / 2;
      x2 = Math.min(Math.max(8, x2), rootEl.clientWidth - w2 - 8);
      let y2 = br2.bottom - ar2.top + 8;
      if (y2 + hgt > rootEl.clientHeight - 8) y2 = Math.max(8, br2.top - ar2.top - hgt - 8);
      pop.style.transform = "translate(" + x2 + "px, " + y2 + "px)";
    };
    const open = (opts) => {
      cb = opts.onChange || null;
      closeCb = opts.onClose || null;
      anchorEl = opts.anchor || null;
      hsv = hexToHsv(opts.value || "#000000");
      fillRow(designRow, designLabel, (opts.designColors || []).slice(0, 14), [customBtn, dropBtn2]);
      fillRow(paletteRow, paletteLabel, opts.palette || []);
      paint();
      pop.classList.toggle("is-spectrum", opts.view === "spectrum");
      const sheet = isMobile();
      pop.classList.toggle("nsv2-cpick--sheet", sheet);
      returnGradNodes();
      if (opts.gradient && opts.gradient.nodes && opts.gradient.nodes.length) {
        gradDock = {
          nodes: opts.gradient.nodes,
          home: opts.gradient.nodes.map((n2) => ({ parent: n2.parentElement, next: n2.nextSibling }))
        };
        gradDock.nodes.forEach((n2) => {
          gradHost.appendChild(n2);
          n2.hidden = false;
        });
        tabs.hidden = false;
      } else {
        tabs.hidden = true;
      }
      showTab("color");
      clearTimeout(closeT);
      pop.classList.remove("is-closing");
      pop.hidden = false;
      if (sheet) pop.style.transform = "";
      else place();
    };
    headX.addEventListener("click", () => close());
    return { open, close, element: pop };
  }

  // src/shell.js
  function installShell({ root, ui: ui2, editor, api }) {
    const { openPane, closePanel, getActivePane, discardSelection } = api;
    const backdrop = document.createElement("div");
    backdrop.className = "nsv2-sheet-backdrop";
    backdrop.addEventListener("click", () => closePanel());
    root.appendChild(backdrop);
    const head = makeSheetHead({
      onClose: () => {
        if (typeof ui2.beforeSheetClose === "function" && ui2.beforeSheetClose() === false) return;
        closePanel();
      },
      onDone: () => {
        if (typeof ui2.beforeSheetDone === "function" && ui2.beforeSheetDone() === false) return;
        closePanel();
      },
      onBack: () => {
        const b2 = ui2.panel.querySelector(".nsv2-pane:not([hidden]) .nsv2-pane-back");
        if (b2) b2.click();
      }
    });
    ui2.panel.insertBefore(head.el, ui2.panel.firstChild);
    ui2.sheetHead = head;
    ui2.sheetDone = head.done;
    const detachSwipe = attachSwipeDismiss(head.handle, ui2.panel, () => closePanel());
    const updateSel = () => {
      root.classList.toggle("nsv2-has-sel", !!(editor.canvas && editor.canvas.getActiveObject()));
    };
    editor.on && editor.on("selection", updateSel);
    editor.canvas.on("selection:created", updateSel);
    editor.canvas.on("selection:updated", updateSel);
    editor.canvas.on("selection:cleared", updateSel);
    updateSel();
    const chip = (label, iconHtml, onClick, cls) => {
      const b2 = document.createElement("button");
      b2.type = "button";
      b2.className = "nsv2-mchip" + (cls ? " " + cls : "");
      b2.innerHTML = iconHtml + '<span class="nsv2-mchip-lab">' + label + "</span>";
      b2.addEventListener("click", onClick);
      return b2;
    };
    const layersChip = chip("Layers", micons.layers, () => openPane(getActivePane() === "layers" ? null : "layers"));
    layersChip.hidden = !!(api.toolAllowed && !api.toolAllowed("layers"));
    ui2.ctxbar.append(
      chip("Zoom", micons.zoom, () => api.openZoomTray && api.openZoomTray()),
      layersChip,
      chip("More", micons.more, (e24) => api.openMoreMenu && api.openMoreMenu(e24))
    );
    const doneBtn = document.createElement("button");
    doneBtn.type = "button";
    doneBtn.className = "nsv2-round-btn nsv2-mstripe-done";
    doneBtn.title = "Done";
    doneBtn.innerHTML = micons.check;
    doneBtn.addEventListener("click", () => discardSelection());
    ui2.ctxbar.appendChild(doneBtn);
    const canvasTool = document.createElement("button");
    canvasTool.type = "button";
    canvasTool.className = "nsv2-tool nsv2-tool--canvas";
    canvasTool.innerHTML = micons.canvas + '<span class="nsv2-tool-label">Canvas</span>';
    canvasTool.addEventListener("click", () => openPane(getActivePane() === "canvas" ? null : "canvas"));
    ui2.rail.appendChild(canvasTool);
    const zoomTool = document.createElement("button");
    zoomTool.type = "button";
    zoomTool.className = "nsv2-tool nsv2-tool--zoom";
    zoomTool.innerHTML = micons.zoom + '<span class="nsv2-tool-label">Zoom</span>';
    zoomTool.addEventListener("click", () => api.openZoomTray && api.openZoomTray());
    ui2.rail.appendChild(zoomTool);
    return {
      destroy() {
        detachSwipe();
      }
    };
  }
  function makeSheetHead({ title = "", onClose, onDone, onBack, done = true } = {}) {
    const btn = (cls, label, html) => {
      const b2 = document.createElement("button");
      b2.type = "button";
      b2.className = "nsv2-icon-btn " + cls;
      b2.title = label;
      b2.setAttribute("aria-label", label);
      b2.innerHTML = html;
      return b2;
    };
    const el2 = document.createElement("div");
    el2.className = "nsv2-sheet-head w3_bg";
    const handle = document.createElement("div");
    handle.className = "nsv2-sheet-handle";
    handle.innerHTML = '<span class="nsv2-sheet-grip"></span>';
    const row = document.createElement("div");
    row.className = "nsv2-sheet-row";
    const x2 = btn("nsv2-sheet-x", "Close", micons.close);
    x2.addEventListener("click", () => onClose && onClose());
    const back = btn("nsv2-sheet-back", "Back", "");
    back.hidden = true;
    back.addEventListener("click", () => onBack && onBack());
    const ttl = document.createElement("div");
    ttl.className = "nsv2-sheet-title";
    ttl.textContent = title;
    const extra = document.createElement("div");
    extra.className = "nsv2-sheet-extra";
    const doneBtn = btn("nsv2-sheet-done", "Done", micons.check);
    doneBtn.hidden = !done;
    doneBtn.addEventListener("click", () => onDone && onDone());
    row.append(x2, back, ttl, extra, doneBtn);
    el2.append(handle, row);
    return {
      el: el2,
      handle,
      x: x2,
      back,
      title: ttl,
      extra,
      done: doneBtn,
      set({ title: t2, back: hasBack } = {}) {
        if (t2 != null) ttl.textContent = t2;
        if (hasBack != null) back.hidden = !hasBack;
      }
    };
  }
  function attachSwipeDismiss(handle, surface, onDismiss, prop = "transform") {
    let y0 = null;
    const val = (dy) => prop === "translate" ? "0 " + dy + "px" : "translateY(" + dy + "px)";
    const onGrab = (e24) => {
      if (!handle.offsetParent) return;
      y0 = (e24.touches ? e24.touches[0] : e24).clientY;
      surface.style.transition = "none";
    };
    const onMove = (e24) => {
      if (y0 == null) return;
      const y2 = (e24.touches ? e24.touches[0] : e24).clientY;
      surface.style[prop] = val(Math.max(0, y2 - y0));
    };
    const onDrop = (e24) => {
      if (y0 == null) return;
      const y2 = (e24.changedTouches ? e24.changedTouches[0] : e24).clientY;
      const dy = y2 - y0;
      y0 = null;
      surface.style.transition = "";
      surface.style[prop] = "";
      if (dy > 70) onDismiss();
    };
    handle.addEventListener("touchstart", onGrab, { passive: true });
    handle.addEventListener("touchmove", onMove, { passive: true });
    handle.addEventListener("touchend", onDrop);
    handle.addEventListener("pointerdown", onGrab);
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onDrop);
    return () => {
      handle.removeEventListener("touchstart", onGrab);
      handle.removeEventListener("touchmove", onMove);
      handle.removeEventListener("touchend", onDrop);
      handle.removeEventListener("pointerdown", onGrab);
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onDrop);
    };
  }

  // src/modes.js
  var RAIL_TOOLS = ["text", "uploads", "ai", "elements", "layers", "designs", "premade"];
  var TOOL_KIND = {
    text: "text",
    uploads: "image",
    ai: "image",
    designs: "image",
    // Exported tab places flat PNGs; Saved tab loads whole designs (sanitized)
    premade: "image",
    elements: "element"
  };
  var KIND_LABEL = { text: "Text", image: "Images", element: "Shapes" };
  var MODES = {
    // Text-only studio (the by-size "Add Text" successor): Text pane (add +
    // text styles), the full text toolbar, and Layers for stacking lines.
    // Owen 9-20 "for this let's get rid of save and file … also the canvas size
    // as this will be a fixed canvas size" — a one-off for THIS preset; the
    // full studio keeps all three. The size itself comes from the host/board
    // config (config.js `board`), not from here.
    // Board 22 × 22 in (Owen 9-21 "make the canvas 22x22 on the text only" —
    // the same square as the full studio's default board; it replaced the
    // 22 × 16 Add Text-stage proportions of 9-20). Still FIXED: the size
    // control is hidden and the board is pinned at construction + on restore.
    text: { label: "text only", tools: ["text", "layers"], hide: ["save", "file", "canvasSize", "name"], canvas: { w: 22, h: 22 } }
  };
  function resolveMode(opts) {
    let tools = null;
    let key = null;
    let label = "limited";
    let hide = [];
    let canvas = null;
    const preset = opts.mode ? MODES[opts.mode] : null;
    if (opts.mode && !preset) console.warn("studio-v2: unknown mode ignored (full studio)", opts.mode);
    if (preset) {
      tools = preset.tools;
      if (Array.isArray(opts.tools)) {
        const both = preset.tools.filter((t2) => opts.tools.includes(t2));
        if (both.length) tools = both;
        else console.warn("studio-v2: host tools exclude every tool of mode " + opts.mode + " \u2014 using the mode's own tools", opts.tools);
      }
      key = String(opts.mode);
      label = preset.label;
      hide = preset.hide || [];
      canvas = preset.canvas || null;
    } else if (Array.isArray(opts.tools)) {
      tools = opts.tools;
      key = "tools:" + tools.slice().sort().join("+");
    }
    if (!tools) return null;
    if (Array.isArray(opts.hide)) hide = opts.hide;
    const c2 = opts.canvas || canvas;
    canvas = c2 && c2.w > 0 && c2.h > 0 ? { w: +c2.w, h: +c2.h } : null;
    const set = new Set(tools.filter((t2) => RAIL_TOOLS.includes(t2)));
    const kinds = new Set([...set].map((t2) => TOOL_KIND[t2]).filter(Boolean));
    return { key, label, tools: set, kinds, hide: new Set(hide), canvas };
  }
  function snapshotObjectAllowed(o2, kinds) {
    if (!o2) return true;
    if (o2.__base) return true;
    if (o2.__el) return kinds.has("element");
    const t2 = String(o2.type || "").toLowerCase();
    if (t2 === "textbox" || t2 === "text" || t2 === "i-text" || t2 === "itext") return kinds.has("text");
    if (t2 === "image") return kinds.has("image");
    if (t2 === "group" || t2 === "activeselection") return (o2.objects || []).every((c2) => snapshotObjectAllowed(c2, kinds));
    return kinds.has("element");
  }
  function sanitizeSnapshot(data, kinds) {
    if (!data || !Array.isArray(data.objects)) return { data, removed: 0 };
    const kept = data.objects.filter((o2) => snapshotObjectAllowed(o2, kinds));
    const removed = data.objects.length - kept.length;
    if (!removed) return { data, removed: 0 };
    return { data: Object.assign({}, data, { objects: kept }), removed };
  }

  // src/index.js
  function mount(host, opts = {}) {
    configure(opts.storage, opts.units, opts.board);
    const ui2 = buildUI(host, opts);
    const tracked = [];
    const cleanups = [];
    const listen = (target2, type, fn2, o2) => {
      target2.addEventListener(type, fn2, o2);
      tracked.push([target2, type, fn2, o2]);
      return fn2;
    };
    const board = boardCfg();
    const mode = resolveMode(opts);
    const editor = new Editor(ui2.canvasEl, ui2.area, mode && mode.canvas ? { designW: mode.canvas.w * 50, designH: mode.canvas.h * 50 } : { designW: toIn(board.defaultW) * 50, designH: toIn(board.defaultH) * 50 });
    setEyeDropperTarget({ canvasEl: () => editor.canvas.lowerCanvasEl, hostEl: () => ui2.root, canvas: () => editor.canvas });
    const toolAllowed = (t2) => !mode || mode.tools.has(t2);
    const kindAllowed = (k2) => !mode || mode.kinds.has(k2);
    if (mode) ui2.root.dataset.mode = mode.key;
    Object.entries(ui2.toolBtns).forEach(([tid, b2]) => {
      b2.hidden = !toolAllowed(tid);
    });
    ui2.fileOpen.hidden = !toolAllowed("designs");
    const chromeHidden = (k2) => !!(mode && mode.hide.has(k2));
    ui2.saveWrap.hidden = ui2.topVdiv.hidden = chromeHidden("save");
    ui2.fileWrap.hidden = chromeHidden("file");
    ui2.canvasSizeLabel.hidden = ui2.canvasSizeWrap.hidden = ui2.canvasSizeVdiv.hidden = chromeHidden("canvasSize");
    ui2.designNameInput.hidden = chromeHidden("name");
    let refusePill = null;
    const BASE_NOTE = { baseDelete: "Your upload stays in this design.", baseCopy: "Your upload can\u2019t be copied here." };
    function refuse(kind) {
      if (refusePill) refusePill.remove();
      const p2 = placingPill(BASE_NOTE[kind] || (KIND_LABEL[kind] || "That") + " can\u2019t be added here. This studio is " + (mode ? mode.label : "limited") + ".");
      p2.classList.add("is-note");
      refusePill = p2;
      setTimeout(() => {
        if (refusePill === p2) refusePill = null;
        p2.remove();
      }, 2600);
      return null;
    }
    editor.on("refuse", refuse);
    let lastStripped = 0;
    function modeSanitize(data) {
      lastStripped = 0;
      if (!mode) return data;
      const r2 = sanitizeSnapshot(data, mode.kinds);
      lastStripped = r2.removed;
      if (mode.canvas) {
        const w2 = Math.round(mode.canvas.w * 50), h2 = Math.round(mode.canvas.h * 50);
        if (r2.data.__designW !== w2 || r2.data.__designH !== h2) r2.data = Object.assign({}, r2.data, { __designW: w2, __designH: h2 });
      }
      if (r2.removed) {
        const p2 = placingPill(r2.removed + (r2.removed === 1 ? " item was" : " items were") + " left out. This studio is " + mode.label + ".");
        p2.classList.add("is-note");
        setTimeout(() => p2.remove(), 3600);
      }
      return r2.data;
    }
    const baseImg = opts.baseImage && opts.baseImage.url ? opts.baseImage : null;
    const strHash = (s3) => {
      let h2 = 5381;
      for (let i2 = 0; i2 < s3.length; i2++) h2 = (h2 << 5) + h2 + s3.charCodeAt(i2) | 0;
      return (h2 >>> 0).toString(36);
    };
    const DRAFT_KEY = "nsv2Draft" + (mode ? ":" + mode.key : "") + (baseImg ? ":" + strHash(baseImg.url.split("?")[0]) : "");
    const SAVE_KEY = DRAFT_KEY + ":save";
    const SURFACES = ["page", "popup", "embed"];
    const surface = SURFACES.includes(opts.surface) ? opts.surface : opts.onUseDesign && opts.onHome ? "popup" : host.closest && host.closest("[data-nsv3-embed]") ? "embed" : "page";
    let firstAddSent = false;
    function trackAdd(e24) {
      track(e24);
      if (firstAddSent) return;
      firstAddSent = true;
      track("first_add");
    }
    let firstSaveSent = false;
    let openedSaved = false;
    let useSavedSent = false;
    function trackOpenSaved() {
      if (openedSaved) return;
      openedSaved = true;
      track("open_saved");
    }
    function trackUse() {
      track("use_design", editor.canvas.getObjects().length);
      if (!openedSaved || useSavedSent) return;
      useSavedSent = true;
      track("use_saved");
    }
    ui2.root.querySelectorAll("[title]").forEach((b2) => {
      b2.dataset.tip = b2.title;
      b2.removeAttribute("title");
    });
    const tipEl = document.createElement("div");
    tipEl.className = "nsv2-tip";
    ui2.root.appendChild(tipEl);
    let tipTimer = 0;
    function hideTip() {
      clearTimeout(tipTimer);
      tipEl.classList.remove("is-show");
    }
    function showTip(el2) {
      const label = el2.dataset.tip;
      if (!label || !el2.isConnected) return;
      tipEl.textContent = label;
      tipEl.classList.add("is-show");
      const r2 = el2.getBoundingClientRect();
      const a2 = ui2.root.getBoundingClientRect();
      const w2 = tipEl.offsetWidth, h2 = tipEl.offsetHeight;
      const x2 = Math.min(Math.max(6, r2.left - a2.left + r2.width / 2 - w2 / 2), a2.width - w2 - 6);
      let y2 = r2.bottom - a2.top + 9;
      let above = false;
      if (y2 + h2 > a2.height - 6) {
        y2 = r2.top - a2.top - h2 - 9;
        above = true;
      }
      tipEl.classList.toggle("is-above", above);
      tipEl.style.transform = "translate(" + x2 + "px, " + y2 + "px)";
      tipEl.style.setProperty("--tip-caret", Math.round(r2.left - a2.left + r2.width / 2 - x2) + "px");
    }
    ui2.root.addEventListener("pointerover", (e24) => {
      const el2 = e24.target.closest("[data-tip]");
      clearTimeout(tipTimer);
      if (!el2 || !ui2.root.contains(el2)) return hideTip();
      tipTimer = setTimeout(() => showTip(el2), 150);
    });
    ui2.root.addEventListener("pointerout", (e24) => {
      if (e24.target.closest("[data-tip]")) hideTip();
    });
    ui2.root.addEventListener("pointerdown", hideTip, true);
    const busySpin = document.createElement("div");
    busySpin.className = "nsv2-obj-busy";
    busySpin.innerHTML = '<span class="nsv2-bgr-spin"></span>';
    busySpin.hidden = true;
    ui2.area.appendChild(busySpin);
    let busyCount = 0;
    function askDialog(message, opts2 = {}) {
      return new Promise((resolve) => {
        ui2.dlgInput.hidden = true;
        ui2.dlgMsg.textContent = message;
        ui2.dlgOk.querySelector("span").textContent = opts2.ok || "OK";
        ui2.dlgCancel.textContent = opts2.cancel || "Cancel";
        ui2.dlgCancel.hidden = opts2.cancel === null;
        ui2.dlgAlt.textContent = opts2.alt || "";
        ui2.dlgAlt.hidden = !opts2.alt;
        ui2.dlgModal.hidden = false;
        const done = (val) => {
          ui2.dlgModal.hidden = true;
          ui2.dlgOk.onclick = ui2.dlgCancel.onclick = ui2.dlgAlt.onclick = null;
          resolve(val);
        };
        ui2.dlgOk.onclick = () => done(true);
        ui2.dlgCancel.onclick = () => done(false);
        ui2.dlgAlt.onclick = () => done("alt");
      });
    }
    function askName(message, opts2 = {}) {
      return new Promise((resolve) => {
        const fallback = opts2.placeholder || "Untitled design";
        ui2.dlgMsg.textContent = message;
        ui2.dlgInput.hidden = false;
        ui2.dlgInput.value = opts2.value || "";
        ui2.dlgInput.placeholder = fallback;
        ui2.dlgOk.querySelector("span").textContent = opts2.ok || "Save";
        ui2.dlgCancel.textContent = "Cancel";
        ui2.dlgCancel.hidden = false;
        ui2.dlgAlt.hidden = true;
        ui2.dlgModal.hidden = false;
        const done = (val) => {
          ui2.dlgModal.hidden = true;
          ui2.dlgInput.hidden = true;
          ui2.dlgOk.onclick = ui2.dlgCancel.onclick = ui2.dlgAlt.onclick = null;
          ui2.dlgInput.onkeydown = null;
          resolve(val);
        };
        ui2.dlgOk.onclick = () => done(ui2.dlgInput.value.trim() || fallback);
        ui2.dlgCancel.onclick = () => done(null);
        ui2.dlgInput.onkeydown = (e24) => {
          if (e24.key === "Enter") {
            e24.preventDefault();
            ui2.dlgOk.click();
          } else if (e24.key === "Escape") {
            e24.preventDefault();
            done(null);
          }
        };
        requestAnimationFrame(() => {
          ui2.dlgInput.focus();
          ui2.dlgInput.select();
        });
      });
    }
    async function withObjBusy(obj, fn2) {
      busyCount++;
      const timer = setTimeout(() => {
        if (!busyCount) return;
        const c2 = obj.getCenterPoint();
        const vpt = editor.canvas.viewportTransform;
        const cvR = editor.canvas.upperCanvasEl.getBoundingClientRect();
        const aR = ui2.area.getBoundingClientRect();
        busySpin.style.left = cvR.left - aR.left + c2.x * vpt[0] + vpt[4] + "px";
        busySpin.style.top = cvR.top - aR.top + c2.y * vpt[3] + vpt[5] + "px";
        busySpin.hidden = false;
      }, 150);
      try {
        return await fn2();
      } finally {
        clearTimeout(timer);
        if (--busyCount === 0) busySpin.hidden = true;
      }
    }
    let activePane = null;
    let lastTrayObj = null;
    let paneBeforeFonts = null;
    let currentFamily = "Poppins";
    let movedReset = null;
    let mtrayKind = null;
    const isMobileView = () => ui2.root.clientWidth < 768;
    const railIdFor = (id) => id === "fonts" || id === "effects" || id === "color" || id === "format" || id === "spacing" || id === "shape" ? "text" : id === "bgr" || id === "crop" || id === "filters" || id === "recolor" || id === "adjust" ? "uploads" : id === "border" || id === "ends" || id === "lnstyle" ? "elements" : id;
    const paneAllowed = (id) => !id || !(railIdFor(id) in ui2.toolBtns) || toolAllowed(railIdFor(id));
    const TEXT_OPTION_PANES = ["fonts", "color", "format", "spacing", "effects", "shape", "nudge"];
    function exitTextEditingForOptions() {
      if (!isMobileView()) return;
      const t2 = editor.activeText && editor.activeText();
      if (t2 && t2.isEditing) {
        try {
          t2.exitEditing();
        } catch (e24) {
        }
        editor.canvas.requestRenderAll();
      }
    }
    let heldPane = null;
    let holdTimer = 0;
    const paneEl = (id) => id ? ui2[id + "Pane"] || (id === "lnstyle" ? ui2.lnStylePane : null) : null;
    const isSheetLayout = () => ui2.root.getBoundingClientRect().width < 768 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function holdPaneForSlide(prev, id) {
      if (heldPane) {
        clearTimeout(holdTimer);
        if (heldPane !== paneEl(id)) heldPane.hidden = true;
        heldPane = null;
      }
      const pane = !id && prev ? paneEl(prev) : null;
      if (!pane || !isSheetLayout()) return;
      pane.hidden = false;
      heldPane = pane;
      holdTimer = setTimeout(() => {
        if (heldPane !== pane) return;
        heldPane = null;
        if (activePane !== prev) pane.hidden = true;
      }, 360);
    }
    function openPane(id) {
      if (!paneAllowed(id)) return;
      if (id && chat) {
        if (!chat.busy && (chat.mode === "create" || !chat.versions.length || chat.applied)) closeChat(true);
        else parkChat();
      }
      const prev = activePane;
      activePane = id;
      if (id) closeMtray();
      if (id && TEXT_OPTION_PANES.includes(id)) exitTextEditingForOptions();
      if (id === "layers") renderLayers();
      if (id === "text") ensureTreatmentThumbs();
      if (id !== "effects") closeFxColorPop();
      const railId = railIdFor(id);
      Object.entries(ui2.toolBtns).forEach(([tid, b2]) => b2.classList.toggle("is-active", !!id && tid === railId));
      ui2.root.classList.toggle("nsv2-panel-open", !!id);
      ui2.textPane.hidden = id !== "text";
      ui2.fontsPane.hidden = id !== "fonts";
      ui2.uploadsPane.hidden = id !== "uploads";
      ui2.elementsPane.hidden = id !== "elements";
      ui2.layersPane.hidden = id !== "layers";
      ui2.designsPane.hidden = id !== "designs";
      ui2.premadePane.hidden = id !== "premade";
      ui2.colorPane.hidden = id !== "color";
      ui2.effectsPane.hidden = id !== "effects";
      ui2.cropPane.hidden = id !== "crop";
      ui2.bgrPane.hidden = id !== "bgr";
      ui2.filtersPane.hidden = id !== "filters";
      ui2.recolorPane.hidden = id !== "recolor";
      ui2.adjustPane.hidden = id !== "adjust";
      ui2.canvasPane.hidden = id !== "canvas";
      if (id === "canvas" && ui2.ctxCanvasGroup.parentElement !== ui2.canvasPane) {
        ui2.canvasPane.appendChild(ui2.ctxCanvasGroup);
        ui2.ctxCanvasGroup.hidden = false;
        editor._emit("canvaspane");
      } else if (id !== "canvas" && ui2.ctxCanvasGroup.parentElement === ui2.canvasPane) {
        ui2.ctxbar.insertBefore(ui2.ctxCanvasGroup, ui2.ctxMoreBtn);
        editor._emit("canvaspane");
      }
      ui2.formatPane.hidden = id !== "format";
      if (id === "format" && ui2.fmtCluster.parentElement !== ui2.formatPane) {
        ui2.formatPane.appendChild(ui2.fmtCluster);
      } else if (id !== "format" && ui2.fmtCluster.parentElement === ui2.formatPane) {
        ui2.fmtChip.parentElement.insertBefore(ui2.fmtCluster, ui2.fmtChip);
      }
      ui2.fmtChip.classList.toggle("is-active", id === "format");
      ui2.spacingPane.hidden = id !== "spacing";
      if (id === "spacing" && ui2.letterSp.wrap.parentElement !== ui2.spacingPane) {
        hideSpop();
        ui2.spacingPane.append(ui2.letterSp.wrap, ui2.lineSp.wrap);
        if (editor.activeText()) syncSpop();
      } else if (id !== "spacing" && ui2.letterSp.wrap.parentElement === ui2.spacingPane) {
        ui2.spop.append(ui2.letterSp.wrap, ui2.lineSp.wrap);
      }
      ui2.spacingChip.classList.toggle("is-active", id === "spacing");
      ui2.nudgePane.hidden = id !== "nudge";
      ui2.nudgeChip.classList.toggle("is-on", id === "nudge");
      ui2.shapePane.hidden = id !== "shape";
      if (id === "shape" && ui2.shapeTiles.parentElement !== ui2.shapePane) {
        ui2.shapePane.appendChild(ui2.shapeTiles);
        ui2.shapeTiles.after(ui2.fxCurveRow);
      } else if (id !== "shape" && ui2.shapeTiles.parentElement === ui2.shapePane) {
        ui2.shapeTiles.appendChild(ui2.fxCurveRow);
        ui2.effectsPane.appendChild(ui2.shapeTiles);
      }
      ui2.shapeChip.classList.toggle("is-active", id === "shape");
      ui2.borderPane.hidden = id !== "border";
      const outlineHost = id === "border" ? ui2.borderPane : id === "outline" ? ui2.outlinePane : ui2.borderPop;
      if (ui2.borderCtrls.parentElement !== outlineHost) outlineHost.appendChild(ui2.borderCtrls);
      ui2.endsPane.hidden = id !== "ends";
      if (id === "ends" && ui2.lnEndsCtrls.parentElement !== ui2.endsPane) {
        ui2.endsPane.appendChild(ui2.lnEndsCtrls);
      } else if (id !== "ends" && ui2.lnEndsCtrls.parentElement === ui2.endsPane) {
        ui2.lnEndsPop.appendChild(ui2.lnEndsCtrls);
      }
      ui2.lnStylePane.hidden = id !== "lnstyle";
      if (id === "lnstyle" && ui2.lnStyleCtrls.parentElement !== ui2.lnStylePane) {
        ui2.lnStylePane.appendChild(ui2.lnStyleCtrls);
      } else if (id !== "lnstyle" && ui2.lnStyleCtrls.parentElement === ui2.lnStylePane) {
        ui2.lnStylePop.appendChild(ui2.lnStyleCtrls);
      }
      ui2.outlinePane.hidden = id !== "outline";
      ui2.root.classList.toggle(
        "nsv2-compact-sheet",
        id === "effects" || id === "format" || id === "spacing" || id === "nudge" || id === "canvas" || id === "filters" || id === "bgr" || id === "crop" || id === "adjust" || id === "shape" || id === "outline" || id === "border" || id === "ends" || id === "lnstyle"
      );
      if (ui2.sheetHead) {
        const pane = id ? ui2.panel.querySelector(".nsv2-pane:not([hidden])") : null;
        const t2 = pane && (pane.querySelector(".nsv2-pane-head .nsv2-pane-title") || pane.querySelector(":scope > .nsv2-pane-title") || pane.querySelector(".nsv2-pane-title"));
        ui2.sheetHead.set({ title: t2 ? t2.textContent.trim() : "", back: !!(pane && pane.querySelector(".nsv2-pane-back")) });
      }
      if (movedReset) {
        movedReset.el.classList.remove("nsv2-head-reset");
        movedReset.el.textContent = movedReset.label;
        movedReset.parent.insertBefore(movedReset.el, movedReset.next);
        movedReset = null;
      }
      if (id && isMobileView()) {
        const pane = ui2.panel.querySelector(".nsv2-pane:not([hidden])");
        const reset = pane && pane.querySelector(".nsv2-recolor-reset");
        const slot = ui2.sheetHead ? ui2.sheetHead.extra : pane && pane.querySelector(".nsv2-pane-head");
        if (reset && slot) {
          movedReset = { el: reset, parent: reset.parentElement, next: reset.nextSibling, label: reset.textContent };
          reset.textContent = "Reset";
          reset.classList.add("nsv2-head-reset");
          slot.appendChild(reset);
        }
      }
      ui2.fontBtn.classList.toggle("is-open", id === "fonts");
      ui2.colorBtn.classList.toggle("is-open", id === "color");
      ui2.effectsBtn.classList.toggle("is-on", id === "effects");
      ui2.removeBgBtn.classList.toggle("is-open", id === "bgr");
      ui2.stickerBtn.classList.toggle("is-open", id === "outline");
      ui2.filtersBtn.classList.toggle("is-open", id === "filters");
      ui2.colorReplaceBtn.classList.toggle("is-open", id === "recolor");
      if (id === "uploads") loadMyFiles();
      if (id === "designs") loadMyDesigns();
      if (id === "premade") initPremade();
      holdPaneForSlide(prev, id);
    }
    const closePanel = () => openPane(null);
    function openFonts() {
      if (activePane !== "fonts") paneBeforeFonts = activePane;
      openPane("fonts");
      renderFontCats();
      renderFontList();
      ui2.fontSearch.focus();
    }
    const closeFonts = () => openPane(isMobileView() ? null : paneBeforeFonts || "text");
    ui2.toolBtns.text.addEventListener(
      "click",
      () => activePane === "text" || activePane === "fonts" ? closePanel() : openPane("text")
    );
    ui2.toolBtns.uploads.addEventListener("click", () => activePane === "uploads" ? closePanel() : openPane("uploads"));
    ui2.toolBtns.elements.addEventListener("click", () => activePane === "elements" ? closePanel() : openPane("elements"));
    ui2.toolBtns.layers.addEventListener("click", () => {
      if (activePane === "layers") return closePanel();
      openPane("layers");
      renderLayers();
    });
    ui2.toolBtns.designs.addEventListener("click", () => activePane === "designs" ? closePanel() : openPane("designs"));
    ui2.toolBtns.premade.addEventListener("click", () => activePane === "premade" ? closePanel() : openPane("premade"));
    ui2.panelClose.addEventListener("click", closePanel);
    ui2.fontsBackBtn.addEventListener("click", closeFonts);
    openPane(null);
    queueMicrotask(() => syncSelection());
    ui2.addTextBtn.addEventListener("click", () => {
      if (!kindAllowed("text")) return refuse("text");
      editor.addText(currentFamily);
      trackAdd("text_add");
      if (isMobileView()) openPane(null);
    });
    let ttThumbsStarted = false;
    function ensureTreatmentThumbs() {
      if (ttThumbsStarted) return;
      ttThumbsStarted = true;
      for (const p2 of TEXT_TREATMENTS) {
        treatmentThumb(editor, p2).then((url) => {
          const img = ui2.treatmentTiles.querySelector('[data-tt="' + p2.key + '"] .nsv2-tt-thumb');
          if (img) {
            img.src = url;
            img.hidden = false;
          }
        }).catch((e24) => console.warn("studio-v2: treatment thumb failed", p2.key, e24));
      }
    }
    ui2.treatmentTiles.addEventListener("click", async (e24) => {
      const tile = e24.target.closest("[data-tt]");
      if (!tile) return;
      const preset = TEXT_TREATMENTS.find((x2) => x2.key === tile.dataset.tt);
      if (!preset) return;
      if (!kindAllowed("text")) return refuse("text");
      await applyTreatment(editor, preset);
      trackAdd("text_add");
      closePanelAfterPlace();
    });
    let fontCategory = CATEGORIES[0];
    let currentWeight = 400;
    let expandedFamily = null;
    function markFontRows() {
      ui2.fontList.querySelectorAll(".nsv2-font-item").forEach((item) => {
        const fam = item.dataset.family;
        const isCurrent = fam === currentFamily;
        const isOpen = item.classList.contains("is-open");
        item.querySelector(".nsv2-font-name").classList.toggle("is-active", isCurrent && !isOpen);
        item.querySelectorAll(".nsv2-font-wrow").forEach((wrow) => {
          wrow.classList.toggle("is-active", isCurrent && Number(wrow.dataset.w) === currentWeight);
        });
      });
      ui2.fontBtn.querySelector('[data-ref="family"]').textContent = currentFamily;
    }
    function buildWeightRows(entry) {
      const wrap = document.createElement("div");
      wrap.className = "nsv2-font-weights";
      for (const w2 of entry.w) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "nsv2-font-wrow";
        btn.dataset.family = entry.f;
        btn.dataset.w = String(w2);
        const span = document.createElement("span");
        span.style.fontFamily = "'" + entry.f + "', sans-serif";
        span.style.fontWeight = String(w2);
        span.textContent = WEIGHT_LABELS[w2] || String(w2);
        const check = document.createElement("span");
        check.className = "nsv2-font-check";
        check.innerHTML = icons.check;
        btn.append(span, check);
        wrap.appendChild(btn);
      }
      return wrap;
    }
    function toggleExpand(item) {
      const fam = item.dataset.family;
      if (expandedFamily === fam) {
        expandedFamily = null;
        item.classList.remove("is-open");
        const w2 = item.querySelector(".nsv2-font-weights");
        if (w2) w2.hidden = true;
        markFontRows();
        return;
      }
      const prev = ui2.fontList.querySelector(".nsv2-font-item.is-open");
      if (prev) {
        prev.classList.remove("is-open");
        const pw = prev.querySelector(".nsv2-font-weights");
        if (pw) pw.hidden = true;
      }
      expandedFamily = fam;
      let weights = item.querySelector(".nsv2-font-weights");
      if (!weights) {
        const entry = FONT_CATALOG.find((x2) => x2.f === fam);
        weights = buildWeightRows(entry);
        item.appendChild(weights);
      }
      weights.hidden = false;
      item.classList.add("is-open");
      loadFont(fam);
      markFontRows();
    }
    function renderFontCats() {
      ui2.fontCats.innerHTML = "";
      for (const c2 of CATEGORIES) {
        const chip = document.createElement("button");
        chip.type = "button";
        chip.className = "nsv2-font-cat" + (c2 === fontCategory ? " is-active" : "");
        chip.dataset.cat = c2;
        chip.textContent = c2;
        ui2.fontCats.appendChild(chip);
      }
    }
    function renderFontList() {
      const q2 = ui2.fontSearch.value.trim().toLowerCase();
      let rows;
      if (q2) {
        ensureAllPreviewCss();
        rows = FONT_CATALOG.filter((e24) => e24.f.toLowerCase().includes(q2));
      } else {
        ensurePreviewCss(fontCategory);
        rows = FONT_CATALOG.filter((e24) => e24.c === fontCategory);
      }
      expandedFamily = null;
      const frag = document.createDocumentFragment();
      for (const e24 of rows) {
        const item = document.createElement("div");
        item.className = "nsv2-font-item";
        item.dataset.family = e24.f;
        const row = document.createElement("div");
        row.className = "nsv2-font-row";
        const nameBtn = document.createElement("button");
        nameBtn.type = "button";
        nameBtn.className = "nsv2-font-name";
        const name = document.createElement("span");
        name.style.fontFamily = "'" + e24.f + "', sans-serif";
        name.style.fontWeight = String(nearestWeight(e24.f, 400));
        name.textContent = e24.f;
        const check = document.createElement("span");
        check.className = "nsv2-font-check";
        check.innerHTML = icons.check;
        nameBtn.append(name, check);
        row.appendChild(nameBtn);
        if (e24.w.length > 1) {
          const exp = document.createElement("button");
          exp.type = "button";
          exp.className = "nsv2-font-exp";
          exp.dataset.tip = "Styles";
          exp.innerHTML = icons.chevronDown;
          row.appendChild(exp);
        }
        item.appendChild(row);
        frag.appendChild(item);
      }
      ui2.fontList.replaceChildren(frag);
      markFontRows();
    }
    ui2.fontCats.addEventListener("click", (e24) => {
      const chip = e24.target.closest(".nsv2-font-cat");
      if (!chip) return;
      fontCategory = chip.dataset.cat;
      ui2.fontSearch.value = "";
      renderFontCats();
      renderFontList();
    });
    ui2.fontList.addEventListener("click", async (e24) => {
      const wrow = e24.target.closest(".nsv2-font-wrow");
      if (wrow) {
        const t0 = editor.activeText();
        const familyChanging = !t0 || t0.fontFamily !== wrow.dataset.family;
        currentFamily = wrow.dataset.family;
        currentWeight = Number(wrow.dataset.w);
        markFontRows();
        if (t0) await withObjBusy(t0, () => loadFont(currentFamily));
        else await loadFont(currentFamily);
        const props = { fontFamily: currentFamily, fontWeight: currentWeight };
        familyChanging ? editor.setFontKeepWidth(props) : editor.setTextProp(props);
        syncSelection();
        return;
      }
      const exp = e24.target.closest(".nsv2-font-exp");
      if (exp) {
        toggleExpand(exp.closest(".nsv2-font-item"));
        return;
      }
      const nameBtn = e24.target.closest(".nsv2-font-name");
      if (!nameBtn) return;
      currentFamily = nameBtn.closest(".nsv2-font-item").dataset.family;
      currentWeight = nearestWeight(currentFamily, 400);
      markFontRows();
      const tf = editor.activeText();
      if (tf) await withObjBusy(tf, () => loadFont(currentFamily));
      else await loadFont(currentFamily);
      editor.setFontKeepWidth({ fontFamily: currentFamily, fontWeight: currentWeight });
      syncSelection();
    });
    ui2.fontSearch.addEventListener("input", renderFontList);
    let paneBeforeColor = null;
    let colorAllMode = false;
    function currentTextColor(t2) {
      if (!t2) return "#0f172a";
      if (t2.__effect === "hollow" || t2.__effect === "splice") {
        return typeof t2.stroke === "string" ? t2.stroke : "#0f172a";
      }
      return typeof t2.fill === "string" ? t2.fill : "#0f172a";
    }
    function syncColorUI() {
      if (colorTarget !== "text") {
        const o2 = colorTargetObj();
        const c3 = colorTarget === "canvasBg" ? editor._boardBg || "transparent" : !o2 ? "#0f172a" : colorTarget === "shapeBorder" ? typeof o2.stroke === "string" && o2.stroke || "#0f172a" : colorTarget === "imageOutline" ? o2.__sticker && o2.__sticker.color || "#000000" : colorTarget === "line" ? o2.__el && o2.__el.color || "#0f172a" : typeof o2.fill === "string" && o2.fill || "transparent";
        ui2.currentSwatch.style.background = c3;
        syncNoFill();
        if (activePane === "color") renderDesignColors();
        return;
      }
      const t2 = editor.activeText();
      if (!t2) return;
      const g2 = t2 && t2.__gradFill;
      let c2 = g2 ? "linear-gradient(" + ((g2.angle != null ? g2.angle : 90) + 90) % 360 + "deg, " + g2.a + ", " + g2.b + ")" : currentTextColor(t2);
      const gang2 = editor.activeTexts();
      if (gang2.length > 1) {
        const cols = [...new Set(gang2.map((x2) => String(currentTextColor(x2) || "").toLowerCase()))];
        if (cols.length > 1) c2 = "linear-gradient(135deg, " + cols[0] + " 0 50%, " + cols[1] + " 50% 100%)";
      }
      ui2.colorBtn.querySelector('[data-ref="disc"]').style.background = c2;
      ui2.currentSwatch.style.background = c2;
      if (activePane === "color") renderDesignColors();
      syncGradUI();
    }
    function syncGradUI() {
      const t2 = editor.activeText();
      const g2 = t2 && t2.__gradFill;
      ui2.gradEdit.hidden = !g2;
      if (g2) {
        ui2.gradInputA.value = g2.a;
        ui2.gradInputB.value = g2.b;
        ui2.gradStopA.style.background = g2.a;
        ui2.gradStopB.style.background = g2.b;
        const ang = Math.round(g2.angle != null ? g2.angle : 90);
        ui2.gradAngle.value = ang;
        ui2.gradAngleVal.textContent = ang + "\xB0";
      }
      for (const sw of ui2.gradGrid.children) {
        sw.classList.toggle("is-active", !!g2 && sw.dataset.ga === g2.a && sw.dataset.gb === g2.b);
      }
    }
    function applyGradient(desc) {
      if (!editor.activeText()) return;
      editor.setTextGradient(desc);
      syncColorUI();
    }
    function activeGrad() {
      const t2 = editor.activeText();
      return t2 && t2.__gradFill || { a: "#8c52ff", b: "#ff914d", angle: 90 };
    }
    function renderDesignColors() {
      const colors = collectDesignColors();
      const frag = document.createDocumentFragment();
      for (const c2 of colors.slice(0, 14)) {
        const sw = document.createElement("button");
        sw.type = "button";
        sw.className = "nsv2-swatch";
        sw.dataset.c = c2;
        sw.style.background = c2;
        frag.appendChild(sw);
      }
      ui2.designGrid.replaceChildren(frag);
      ui2.designLabel.hidden = ui2.designGrid.hidden = colors.length === 0;
    }
    function setColorMode(all) {
      colorAllMode = all;
      ui2.colorMain.hidden = all;
      ui2.colorSearch.hidden = all;
      ui2.allGrid.hidden = !all;
      ui2.colorTitle.textContent = all ? "Default solid colors" : colorTitleFor();
      if (all && !ui2.allGrid.childElementCount) fillGradedPalette(ui2.allGrid);
    }
    function fillGradedPalette(grid) {
      const frag = document.createDocumentFragment();
      const HUES = [215, 235, 258, 280, 305, 330, 352, 15, 30, 45, 60, 90, 120, 150, 170, 190, 205];
      for (const h2 of HUES) {
        for (const l2 of [22, 32, 42, 52, 64, 76, 88]) {
          const sw = document.createElement("button");
          sw.type = "button";
          sw.className = "nsv2-swatch";
          const c2 = "hsl(" + h2 + ", 82%, " + l2 + "%)";
          sw.dataset.c = c2;
          sw.style.background = c2;
          frag.appendChild(sw);
        }
      }
      grid.appendChild(frag);
    }
    function collectDesignColors() {
      const seen = /* @__PURE__ */ new Set();
      const colors = [];
      editor.canvas.getObjects().forEach((o2) => {
        for (const c2 of [o2.fill, o2.stroke, o2.shadow && o2.shadow.color, o2.__el && o2.__el.color]) {
          if (typeof c2 === "string" && c2 && c2 !== "transparent" && !/^rgba\(0, ?0, ?0, ?0\)$/.test(c2) && !seen.has(c2.toLowerCase())) {
            seen.add(c2.toLowerCase());
            colors.push(c2);
          }
        }
      });
      return colors;
    }
    let colorTarget = "text";
    function colorTargetObj() {
      if (colorTarget === "text") return editor.activeText();
      if (colorTarget === "imageOutline") return editor.activeImage();
      if (colorTarget === "canvasBg") return editor.canvas;
      const o2 = editor.canvas.getActiveObject();
      return o2 && o2.__el ? o2 : null;
    }
    const colorTitleFor = () => colorTarget === "shapeFill" ? "Fill color" : colorTarget === "shapeBorder" || colorTarget === "imageOutline" ? "Outline color" : colorTarget === "line" ? "Line color" : colorTarget === "canvasBg" ? "Background color" : "Text color";
    function openColors() {
      if (!colorTargetObj()) return;
      if (activePane !== "color") paneBeforeColor = activePane;
      setColorMode(false);
      const shapeMode = colorTarget !== "text";
      ui2.gradsLabel.hidden = ui2.gradGrid.hidden = shapeMode;
      if (shapeMode) ui2.gradEdit.hidden = true;
      ui2.colorToolsLabel.textContent = colorTitleFor() + "s";
      syncNoFill();
      openPane("color");
      syncColorUI();
      renderDesignColors();
    }
    function closeColors() {
      if (colorAllMode) return setColorMode(false);
      if (isMobileView()) return openPane(null);
      const fallback = colorTarget === "canvasBg" ? null : "text";
      openPane(paneBeforeColor === "color" ? fallback : paneBeforeColor || fallback);
    }
    function syncNoFill() {
      const o2 = colorTargetObj();
      ui2.colorNoFill.hidden = !(colorTarget === "shapeFill" && o2 && o2.__el || colorTarget === "canvasBg");
    }
    function applyColor(c2) {
      c2 = cssToSolidHex(c2) || c2;
      if (colorTarget !== "text") {
        if (colorTarget === "canvasBg") {
          editor.setCanvasBackground(c2);
          syncCanvasBg();
          syncColorUI();
          return;
        }
        const o2 = colorTargetObj();
        if (!o2) return;
        if (colorTarget === "shapeBorder") {
          editor.setElBorder(o2, { color: c2 });
        } else if (colorTarget === "imageOutline") {
          const st2 = o2.__sticker || {};
          editor.setImageSticker(o2, { w: st2.w || 12, color: c2 });
          syncImgOutlineChip(o2);
        } else if (colorTarget === "line") {
          editor.setLineProps(o2, { color: c2 });
        } else {
          o2.set("fill", c2);
          editor.setElBorder(o2, {});
          o2.dirty = true;
          editor.canvas.requestRenderAll();
          editor.canvas.fire("object:modified", { target: o2 });
        }
        syncElUI();
        syncColorUI();
        return;
      }
      const texts = editor.activeTexts();
      if (!texts.length) return;
      for (const t2 of texts) {
        t2.__gradFill = null;
        if (t2.__effect === "hollow" || t2.__effect === "splice") {
          editor._applyTextEffectTo(t2, t2.__effect, c2);
        } else {
          t2.set({ fill: c2 });
          t2.__baseFill = c2;
          editor._hugWidth(t2);
        }
      }
      editor.canvas.requestRenderAll();
      editor.canvas.fire("object:modified", { target: texts[0] });
      syncColorUI();
    }
    const mtray = document.createElement("div");
    mtray.className = "nsv2-mtray";
    mtray.hidden = true;
    ui2.area.appendChild(mtray);
    let zoomCtlHome = null;
    let mtrayOutT = 0;
    function closeMtray() {
      if (!mtrayKind) return;
      if (isMobileView() && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        const ghost = mtray.cloneNode(true);
        ghost.classList.add("is-closing");
        ghost.removeAttribute("hidden");
        mtray.parentElement.insertBefore(ghost, mtray);
        clearTimeout(mtrayOutT);
        mtrayOutT = setTimeout(() => ghost.remove(), 240);
      }
      if (mtrayKind === "zoom" && zoomCtlHome) zoomCtlHome();
      mtray.hidden = true;
      mtray.replaceChildren();
      mtrayKind = null;
      ui2.root.classList.remove("nsv2-mtray-open");
    }
    function openMtray(kind, fillScroll, onExpand) {
      mtrayKind = kind;
      exitTextEditingForOptions();
      const scroll = document.createElement("div");
      scroll.className = "nsv2-mtray-scroll";
      fillScroll(scroll);
      const kids = [scroll];
      if (onExpand) {
        const expand = document.createElement("button");
        expand.type = "button";
        expand.className = "nsv2-round-btn nsv2-mtray-expand";
        expand.title = "More";
        expand.innerHTML = micons.expand;
        expand.addEventListener("click", () => {
          closeMtray();
          onExpand();
        });
        kids.push(expand);
      }
      mtray.replaceChildren(...kids);
      mtray.hidden = false;
      ui2.root.classList.add("nsv2-mtray-open");
    }
    editor.canvas.on("selection:cleared", closeMtray);
    function fillColorTray(scroll) {
      if (colorTarget === "shapeFill" && colorTargetObj()) {
        const none = document.createElement("button");
        none.type = "button";
        none.className = "nsv2-swatch nsv2-swatch--transparent";
        none.title = "Transparent";
        none.addEventListener("click", applyNoFill);
        scroll.appendChild(none);
      }
      const custom = document.createElement("button");
      custom.type = "button";
      custom.className = "nsv2-swatch nsv2-swatch--custom";
      custom.title = "Custom color";
      custom.innerHTML = micons.add;
      custom.addEventListener("click", () => ui2.customColorInput.click());
      scroll.appendChild(custom);
      const curColor = (() => {
        if (colorTarget === "text") {
          const t2 = editor.activeText();
          return t2 ? currentTextColor(t2) : null;
        }
        const o2 = colorTargetObj();
        if (!o2) return null;
        if (colorTarget === "shapeBorder") return typeof o2.stroke === "string" ? o2.stroke : null;
        if (colorTarget === "imageOutline") return o2.__sticker && o2.__sticker.color || null;
        if (colorTarget === "line") return o2.__el && o2.__el.color || null;
        return typeof o2.fill === "string" ? o2.fill : null;
      })();
      const curLc = curColor ? String(curColor).toLowerCase() : null;
      const seen = /* @__PURE__ */ new Set();
      for (const c2 of [...collectDesignColors(), ...DEFAULT_PALETTE]) {
        const lc2 = String(c2).toLowerCase();
        if (seen.has(lc2)) continue;
        seen.add(lc2);
        const sw = document.createElement("button");
        sw.type = "button";
        sw.className = "nsv2-swatch" + (curLc && lc2 === curLc ? " is-active" : "");
        sw.dataset.c = c2;
        sw.style.background = c2;
        sw.addEventListener("click", () => {
          applyColor(c2);
          scroll.querySelectorAll(".nsv2-swatch.is-active").forEach((x2) => x2.classList.remove("is-active"));
          sw.classList.add("is-active");
        });
        scroll.appendChild(sw);
      }
    }
    function applyNoFill() {
      if (colorTarget === "canvasBg") {
        editor.setCanvasBackground(null);
        syncCanvasBg();
        syncColorUI();
        return;
      }
      const o2 = colorTargetObj();
      if (!o2 || colorTarget !== "shapeFill") return;
      o2.set("fill", "");
      editor.setElBorder(o2, {});
      o2.dirty = true;
      editor.canvas.requestRenderAll();
      editor.canvas.fire("object:modified", { target: o2 });
      syncElUI();
      syncColorUI();
    }
    ui2.colorNoFill.addEventListener("click", applyNoFill);
    ui2.colorBtn.addEventListener("click", () => {
      colorTarget = "text";
      if (isMobileView()) {
        if (mtrayKind === "color") return closeMtray();
        if (!editor.activeText()) return;
        openMtray("color", fillColorTray, () => openColors());
        return;
      }
      activePane === "color" ? closeColors() : openColors();
    });
    ui2.colorBackBtn.addEventListener("click", closeColors);
    ui2.seeAllBtn.addEventListener("click", () => setColorMode(true));
    ui2.colorPane.addEventListener("click", (e24) => {
      const sw = e24.target.closest(".nsv2-swatch[data-c]");
      if (sw) applyColor(sw.dataset.c);
    });
    ui2.customColorBtn.addEventListener("click", () => ui2.customColorInput.click());
    ui2.customColorInput.addEventListener("input", () => applyColor(ui2.customColorInput.value));
    ui2.gradGrid.addEventListener("click", (e24) => {
      const sw = e24.target.closest("[data-ga]");
      if (sw) applyGradient({ a: sw.dataset.ga, b: sw.dataset.gb, angle: activeGrad().angle });
    });
    ui2.gradStopA.addEventListener("click", () => ui2.gradInputA.click());
    ui2.gradStopB.addEventListener("click", () => ui2.gradInputB.click());
    ui2.gradInputA.addEventListener("input", () => applyGradient({ ...activeGrad(), a: ui2.gradInputA.value }));
    ui2.gradInputB.addEventListener("input", () => applyGradient({ ...activeGrad(), b: ui2.gradInputB.value }));
    ui2.gradAngle.addEventListener("input", () => {
      applyGradient({ ...activeGrad(), angle: ui2.gradAngle.valueAsNumber });
    });
    ui2.dropperBtn.addEventListener("click", async () => {
      try {
        const r2 = await openEyeDropper();
        if (r2 && r2.sRGBHex) applyColor(r2.sRGBHex);
      } catch (e24) {
      }
    });
    function colorSearchMsg(kind, text) {
      ui2.colorMsg.hidden = false;
      ui2.colorMsg.classList.toggle("is-error", kind === "error");
      ui2.colorMsg.textContent = text;
    }
    function clearColorSearchState() {
      ui2.colorMsg.hidden = true;
      ui2.colorSearch.classList.remove("is-invalid");
    }
    ui2.colorSearch.addEventListener("keydown", (e24) => {
      if (e24.key !== "Enter") return;
      const typed = ui2.colorSearch.value.trim();
      const { hex: hex3, corrected } = resolveColorSmart(typed);
      if (hex3) {
        applyColor(hex3);
        ui2.colorSearch.value = "";
        clearColorSearchState();
        if (corrected) colorSearchMsg("hint", "Using \u201C" + corrected + "\u201D");
      } else {
        ui2.colorSearch.classList.remove("is-invalid");
        void ui2.colorSearch.offsetWidth;
        ui2.colorSearch.classList.add("is-invalid");
        colorSearchMsg("error", "No color called \u201C" + typed + "\u201D \u2014 try \u201Cblue\u201D, \u201Clight purple\u201D, or a hex like #00c4cc");
      }
    });
    ui2.colorSearch.addEventListener("input", clearColorSearchState);
    function applyFontFamily(family) {
      currentFamily = family;
      currentWeight = nearestWeight(family, 400);
      markFontRows();
      const go2 = () => editor.setFontKeepWidth({ fontFamily: family, fontWeight: currentWeight });
      go2();
      loadFont(family).then(() => {
        go2();
        syncSelection();
      });
    }
    const FONT_TRAY = ["Anton", "Montserrat", "Bebas Neue", "Pacifico", "Oswald", "Poppins", "Playfair Display", "Roboto", "Lobster", "Dancing Script", "Archivo Black", "Caveat"];
    function fillFontTray(scroll) {
      ensureAllPreviewCss();
      const cur = editor.activeText() && editor.activeText().fontFamily || currentFamily;
      for (const fam of [cur, ...FONT_TRAY.filter((f2) => f2 !== cur)]) {
        const pill = document.createElement("button");
        pill.type = "button";
        pill.className = "nsv2-fpill" + (fam === cur ? " is-active" : "");
        pill.textContent = fam;
        pill.style.fontFamily = "'" + fam + "', sans-serif";
        pill.addEventListener("click", () => applyFontFamily(fam));
        scroll.appendChild(pill);
      }
    }
    ui2.editTextChip.addEventListener("click", () => {
      if (editor.activeSelection()) return;
      const t2 = editor.activeText();
      if (!t2) return;
      closeMtray();
      if (isMobileView()) openPane(null);
      if (t2.isEditing) {
        try {
          t2.exitEditing();
        } catch (e24) {
        }
        editor.canvas.requestRenderAll();
        return;
      }
      t2.enterEditing();
      t2.selectAll();
      editor.canvas.requestRenderAll();
    });
    const editChipLab = ui2.editTextChip.querySelector(".nsv2-cw-lab");
    const editChipIc = ui2.editTextChip.querySelector(".nsv2-cw-ic");
    const syncEditChip = (editing) => {
      ui2.editTextChip.classList.toggle("is-done", !!editing);
      if (editChipLab) editChipLab.textContent = editing ? "Done" : "Edit";
      if (editChipIc) editChipIc.innerHTML = editing ? micons.check : micons.pencil;
    };
    editor.canvas.on("text:editing:entered", () => syncEditChip(true));
    editor.canvas.on("text:editing:exited", () => syncEditChip(false));
    ui2.root.addEventListener("pointerdown", (e24) => {
      if (!isMobileView()) return;
      const t2 = editor.activeText && editor.activeText();
      if (!t2 || !t2.isEditing) return;
      if (e24.target && e24.target.closest && e24.target.closest("canvas, textarea, .nsv2-edit-chip")) return;
      try {
        t2.exitEditing();
      } catch (err) {
      }
      editor.canvas.requestRenderAll();
    }, true);
    ui2.fontBtn.addEventListener("click", () => {
      if (isMobileView()) {
        if (mtrayKind === "font") return closeMtray();
        if (!editor.activeText()) return;
        openMtray("font", fillFontTray, () => openFonts());
        return;
      }
      activePane === "fonts" ? closeFonts() : openFonts();
    });
    async function addUpload(file) {
      const img = await editor.addImageFromFile(file);
      img.__bgr = { status: "uploading", isVector: isVectorName(file.name), versions: {}, model: null };
      trackAdd("image_upload");
      uploadFileToS3(file).then((up) => {
        img.__bgr.status = "ready";
        img.__bgr.imgixUrl = up.imgixUrl;
        img.__bgr.fileName = up.fileName;
        addRecentUpload(up.imgixUrl, file.name);
        syncSelection();
      }).catch((err) => {
        console.error("studio-v2: background upload failed", err);
        img.__bgr.status = "failed";
        syncSelection();
      });
      return img;
    }
    const BROWSER_TYPES = ["image/png", "image/jpeg", "image/gif", "image/webp", "image/svg+xml"];
    const ACCEPT_RE = /\.(png|jpe?g|gif|webp|svg|pdf|ai|eps|psd|tiff?)$/i;
    function closePanelAfterPlace() {
      if (isMobileView()) openPane(null);
    }
    async function intake(file) {
      if (!kindAllowed("image")) return refuse("image");
      if (BROWSER_TYPES.includes(file.type)) {
        const img = await addUpload(file);
        closePanelAfterPlace();
        return img;
      }
      if (!ACCEPT_RE.test(file.name || "")) {
        console.warn("studio-v2: unsupported file skipped", file.name, file.type);
        return;
      }
      ui2.uploadBusy.hidden = false;
      try {
        const up = await uploadFileToS3(file);
        const img = await editor.addImageFromUrl(hostedDisplayUrl(up.imgixUrl), file.name);
        img.__bgr = {
          status: "ready",
          imgixUrl: up.imgixUrl,
          fileName: up.fileName,
          isVector: isVectorName(file.name),
          versions: {},
          model: null
        };
        addRecentUpload(up.imgixUrl, file.name);
        trackAdd("image_upload");
        syncSelection();
        closePanelAfterPlace();
      } catch (err) {
        console.error("studio-v2: upload failed", file.name, err);
      } finally {
        ui2.uploadBusy.hidden = true;
      }
    }
    async function intakeHosted(url, name, addToList = true, bgrMeta) {
      if (!kindAllowed("image")) return refuse("image");
      try {
        const bare = url.split("?")[0].split(cfg.s3Host).join(cfg.imgixHost);
        const q2 = url.split("?")[1] || "";
        const hadBgr = /(?:^|&)bg-remove=true/.test(q2);
        const rowModel = hadBgr ? (q2.match(/bg-remove-model=(\d+)/) || [])[1] === "4" ? "pc" : "ix" : null;
        const versions = {};
        if (rowModel) versions[rowModel] = candidateUrl(bare, BGR_MODELS.find((m) => m.key === rowModel));
        if (bgrMeta && bgrMeta.model && bgrMeta.url) versions[bgrMeta.model] = bgrMeta.url;
        const img = await editor.addImageFromUrl(hostedDisplayUrl(bare), name);
        img.__bgr = {
          status: "ready",
          imgixUrl: bare,
          fileName: name || bare.split("/").pop(),
          isVector: isVectorName(bare),
          versions,
          model: null
        };
        if (addToList) {
          addRecentUpload(bare, name);
          trackAdd("image_upload");
        }
        syncSelection();
        closePanelAfterPlace();
      } catch (err) {
        console.error("studio-v2: hosted intake failed", url, err);
      }
    }
    ui2.dropzone.addEventListener("click", () => ui2.fileInput.click());
    ui2.fileInput.addEventListener("change", () => {
      Array.from(ui2.fileInput.files || []).forEach(intake);
      ui2.fileInput.value = "";
    });
    if (opts.drive === false) ui2.driveBtn.hidden = true;
    ui2.driveBtn.addEventListener(
      "click",
      () => openDrivePicker(Object.assign({ loginHint: opts.customerEmail || "" }, opts.drive || {}), intake)
    );
    function ensureQrModule(src) {
      return new Promise((resolve, reject) => {
        if (window.NinjaQrUpload) return resolve();
        if (!src) return reject(new Error("qr module url missing"));
        let s3 = document.querySelector("script[data-njqr-mod]");
        if (!s3) {
          s3 = document.createElement("script");
          s3.setAttribute("data-njqr-mod", "");
          s3.src = src;
          document.head.appendChild(s3);
        }
        s3.addEventListener("load", () => window.NinjaQrUpload ? resolve() : reject(new Error("njqr load failed")));
        s3.addEventListener("error", () => reject(new Error("njqr load failed")));
      });
    }
    const qrCfg = opts.qr || {};
    if (!qrCfg.moduleUrl) ui2.phoneBtn.hidden = true;
    ui2.phoneBtn.addEventListener("click", () => {
      ensureQrModule(qrCfg.moduleUrl).then(() => {
        window.NinjaQrUpload.open({
          engine: "studio",
          pageUrl: qrCfg.pageUrl || "/pages/phone-upload",
          exts: ["png", "jpg", "jpeg", "gif", "webp", "svg", "pdf", "ai", "eps", "psd"],
          max: 10,
          qrLibUrl: qrCfg.libUrl || "",
          onDesigns: (items) => items.forEach((i2) => intakeHosted(i2.url, i2.fileName))
        });
      }).catch((err) => console.error("studio-v2: phone upload unavailable", err));
    });
    let sessionFiles = [];
    let libraryFiles = [];
    let myFilesLoaded = false;
    function previewImg(f2) {
      const img = document.createElement("img");
      img.loading = "lazy";
      img.alt = f2.name || "";
      const src = f2.bare + "?trim=colorUnlessAlpha&fm=png&w=200&auto=compress&q=60";
      let attempt = 0;
      img.onerror = () => {
        if (attempt >= 3) return;
        const delay = [2e3, 5e3, 1e4][attempt++];
        setTimeout(() => {
          img.removeAttribute("src");
          img.src = src;
        }, delay);
      };
      img.src = src;
      return img;
    }
    function fileTile(f2, onClick, extraClass) {
      const tile = document.createElement("button");
      tile.type = "button";
      tile.className = "nsv2-myfile" + (extraClass ? " " + extraClass : "");
      tile.appendChild(previewImg(f2));
      tile.addEventListener("click", () => onClick ? onClick(tile) : intakeHosted(f2.url || f2.bare, f2.name, false, f2.bgr));
      return tile;
    }
    function renderMyFiles() {
      const seen = /* @__PURE__ */ new Set();
      const rows = [];
      for (const f2 of sessionFiles) {
        if (seen.has(f2.bare)) continue;
        seen.add(f2.bare);
        rows.push(f2);
      }
      for (const f2 of libraryFiles) {
        if (seen.has(f2.bare)) continue;
        seen.add(f2.bare);
        rows.push(f2);
      }
      if (!rows.length) {
        ui2.myFilesLabel.hidden = ui2.myFilesGrid.hidden = true;
        return;
      }
      const frag = document.createDocumentFragment();
      for (const f2 of rows) frag.appendChild(fileTile(f2));
      ui2.myFilesGrid.replaceChildren(frag);
      ui2.myFilesLabel.hidden = ui2.myFilesGrid.hidden = false;
    }
    function addRecentUpload(url, name, bgrMeta) {
      const bare = url.split("?")[0].split(cfg.s3Host).join(cfg.imgixHost);
      const prev = sessionFiles.find((f2) => f2.bare === bare);
      sessionFiles = sessionFiles.filter((f2) => f2.bare !== bare);
      sessionFiles.unshift({ bare, url, name: name || bare.split("/").pop(), bgr: bgrMeta || prev && prev.bgr || null });
      renderMyFiles();
    }
    async function loadMyFiles() {
      if (myFilesLoaded) return;
      myFilesLoaded = true;
      if (!opts.customerId) {
        renderMyFiles();
        return;
      }
      if (!sessionFiles.length) {
        const frag = document.createDocumentFragment();
        for (let i2 = 0; i2 < 4; i2++) {
          const t2 = document.createElement("div");
          t2.className = "nsv2-myfile nsv2-skel";
          frag.appendChild(t2);
        }
        ui2.myFilesGrid.replaceChildren(frag);
        ui2.myFilesLabel.hidden = ui2.myFilesGrid.hidden = false;
      }
      try {
        const files = await fetchUploadedFiles(opts.customerId);
        libraryFiles = files.filter((f2) => !f2.gangsheet && !EXPORT_NAME_RE.test(f2.name) && !isStudioSave(f2.name)).map((f2) => ({
          bare: f2.url.split("?")[0].split(cfg.s3Host).join(cfg.imgixHost),
          // FULL url kept: newer rows carry the applied bg-removal in the
          // query (?bg-remove=true…) — intakeHosted reads it to seed BGR.
          url: f2.url,
          name: f2.name
        }));
      } catch (err) {
        console.warn("studio-v2: uploaded-files library unavailable", err);
      }
      renderMyFiles();
    }
    ui2.elementsPane.addEventListener("click", (e24) => {
      const tile = e24.target.closest(".nsv2-fx-tile");
      if (tile && tile.dataset.el) {
        if (!kindAllowed("element")) return refuse("element");
        editor.addShape(tile.dataset.el);
        closePanelAfterPlace();
      }
    });
    const activeElAny = () => {
      const o2 = editor.canvas.getActiveObject();
      return o2 && o2.__el && !editor.activeSelection() ? o2 : null;
    };
    const activeElShape = () => {
      const o2 = activeElAny();
      return o2 && !o2.__el.isLine ? o2 : null;
    };
    const activeElLine = () => {
      const o2 = activeElAny();
      return o2 && o2.__el.isLine ? o2 : null;
    };
    function placeSpop(pop, btn) {
      const br2 = btn.getBoundingClientRect();
      const ar2 = ui2.area.getBoundingClientRect();
      const w2 = pop.offsetWidth;
      const x2 = Math.min(Math.max(8, br2.left - ar2.left - w2 / 2 + br2.width / 2), ui2.area.clientWidth - w2 - 8);
      pop.style.transform = "translate(" + x2 + "px, " + (br2.bottom - ar2.top + 8) + "px)";
    }
    const EL_POPS = () => [ui2.borderPop, ui2.lnStylePop, ui2.lnEndsPop];
    function hideElPops() {
      for (const p2 of EL_POPS()) p2.hidden = true;
    }
    const outlineTarget = () => {
      const sh = activeElShape();
      if (sh) return { type: "shape", obj: sh };
      const im = editor.activeImage();
      if (im) return { type: "image", obj: im };
      return null;
    };
    function syncOutlineCtrls() {
      const t2 = outlineTarget();
      if (!t2) return;
      const isShape = t2.type === "shape";
      const st2 = isShape ? { style: t2.obj.__el.bstyle || "none", w: t2.obj.__el.bweight || 12, color: t2.obj.__el.bcolor || "#0f172a" } : t2.obj.__sticker && t2.obj.__sticker.w ? { style: "solid", w: t2.obj.__sticker.w, color: t2.obj.__sticker.color || "#000000" } : { style: "none", w: 12, color: "#000000" };
      ui2.borderStyleRow.querySelectorAll("[data-bstyle]").forEach((tl) => {
        tl.classList.toggle("is-active", tl.dataset.bstyle === st2.style);
        tl.hidden = !isShape && tl.dataset.bstyle !== "none" && tl.dataset.bstyle !== "solid";
      });
      ui2.borderWeight.range.value = String(st2.w);
      ui2.borderWeight.num.value = String(st2.w);
    }
    function syncShapeUI(o2) {
      o2 = o2 || activeElShape();
      if (!o2) return;
      const p2 = o2.__el;
      ui2.elFillBtn.querySelector('[data-ref="disc"]').style.background = typeof o2.fill === "string" && o2.fill || "transparent";
      const st2 = p2.bstyle || "none";
      syncOutlineCtrls();
      ui2.elBorderBtn.classList.toggle("is-on", st2 !== "none");
      ui2.elBorderColorBtn.hidden = st2 === "none";
      ui2.elBorderColorBtn.querySelector('[data-ref="disc"]').style.borderColor = p2.bcolor || "#0f172a";
      const def = ELEMENTS[p2.kind];
      ui2.elRoundBtn.hidden = !(def && def.caps && def.caps.corners);
      const rv = Math.round(p2.round || 0);
      ui2.radiusSp.range.value = String(rv);
      ui2.radiusSp.num.value = String(rv);
    }
    function syncLineUI(o2) {
      o2 = o2 || activeElLine();
      if (!o2) return;
      const p2 = o2.__el;
      ui2.lnColorBtn.querySelector('[data-ref="disc"]').style.background = p2.color || "#0f172a";
      ui2.lnStyleRow.querySelectorAll("[data-lnstyle]").forEach((tl) => {
        tl.classList.toggle("is-active", tl.dataset.lnstyle === (p2.dash || "solid"));
      });
      const w2 = p2.weight || 9;
      ui2.lnWeight.range.value = String(w2);
      ui2.lnWeight.num.value = String(w2);
      for (const [row, key] of [[ui2.lnCapStartRow, "capStart"], [ui2.lnCapEndRow, "capEnd"]]) {
        row.querySelectorAll("[data-cap]").forEach((tl) => {
          tl.classList.toggle("is-active", tl.dataset.cap === (p2[key] || "none"));
        });
      }
    }
    function syncElUI() {
      syncShapeUI();
      syncLineUI();
    }
    ui2.elFillBtn.addEventListener("click", () => {
      if (!activeElShape()) return;
      colorTarget = "shapeFill";
      if (isMobileView()) {
        if (mtrayKind === "color") return closeMtray();
        openMtray("color", fillColorTray, () => openColors());
        return;
      }
      activePane === "color" ? closeColors() : openColors();
    });
    const hexLum = (hex3) => {
      const h2 = cssToSolidHex(hex3) || "#ffffff";
      const r2 = parseInt(h2.slice(1, 3), 16) / 255, g2 = parseInt(h2.slice(3, 5), 16) / 255, b2 = parseInt(h2.slice(5, 7), 16) / 255;
      return 0.2126 * r2 + 0.7152 * g2 + 0.0722 * b2;
    };
    function imageAvgLum(im) {
      try {
        const el2 = im._element;
        const c2 = document.createElement("canvas");
        c2.width = 24;
        c2.height = 24;
        const cx = c2.getContext("2d");
        cx.drawImage(el2, 0, 0, 24, 24);
        const d2 = cx.getImageData(0, 0, 24, 24).data;
        let sum = 0, n2 = 0;
        for (let i2 = 0; i2 < d2.length; i2 += 4) {
          if (d2[i2 + 3] < 60) continue;
          sum += (0.2126 * d2[i2] + 0.7152 * d2[i2 + 1] + 0.0722 * d2[i2 + 2]) / 255;
          n2++;
        }
        return n2 ? sum / n2 : null;
      } catch (e24) {
        return null;
      }
    }
    function autoOutlineColor(o2) {
      const boardLum = hexLum(editor._boardBg || "#ffffff");
      let elLum = null;
      if (o2.__el) elLum = typeof o2.fill === "string" && o2.fill ? hexLum(o2.fill) : null;
      else elLum = imageAvgLum(o2);
      const targets = elLum == null ? [boardLum] : [elLum, boardLum];
      let best = "#0f172a", bestScore = -1;
      for (const c2 of ["#0f172a", "#ffffff", "#8b98ab"]) {
        const cl = hexLum(c2);
        const score = Math.min.apply(null, targets.map((t2) => Math.abs(cl - t2)));
        if (score > bestScore) {
          bestScore = score;
          best = c2;
        }
      }
      return best;
    }
    function syncImgOutlineChip(im) {
      im = im || editor.activeImage();
      const on2 = !!(im && im.__sticker && im.__sticker.w);
      ui2.imgOutlineColorBtn.hidden = !on2;
      if (on2) ui2.imgOutlineColorBtn.querySelector('[data-ref="disc"]').style.borderColor = im.__sticker.color || "#0f172a";
    }
    ui2.elBorderColorBtn.addEventListener("click", () => {
      const o2 = activeElShape();
      if (!o2) return;
      if (!o2.__el.bstyle || o2.__el.bstyle === "none") editor.setElBorder(o2, { style: "solid", color: o2.__el.bcolor || autoOutlineColor(o2) });
      syncShapeUI(o2);
      colorTarget = "shapeBorder";
      if (isMobileView()) {
        if (mtrayKind === "color") return closeMtray();
        openMtray("color", fillColorTray, () => openColors());
        return;
      }
      activePane === "color" ? closeColors() : openColors();
    });
    ui2.imgOutlineColorBtn.addEventListener("click", () => {
      const im = editor.activeImage();
      if (!im) return;
      if (!im.__sticker || !im.__sticker.w) editor.setImageSticker(im, { w: 12, color: autoOutlineColor(im) });
      syncImgOutlineChip(im);
      colorTarget = "imageOutline";
      if (isMobileView()) {
        if (mtrayKind === "color") return closeMtray();
        openMtray("color", fillColorTray, () => openColors());
        return;
      }
      activePane === "color" ? closeColors() : openColors();
    });
    ui2.elBorderBtn.addEventListener("click", () => {
      const o2 = activeElShape();
      if (!o2) return;
      if (isMobileView()) return openPane(activePane === "border" ? null : "border");
      if (!ui2.borderPop.hidden) return hideElPops();
      hideElPops();
      syncShapeUI(o2);
      ui2.borderPop.hidden = false;
      placeSpop(ui2.borderPop, ui2.elBorderBtn);
    });
    ui2.stickerBtn.addEventListener("click", () => {
      const im = editor.activeImage();
      if (!im) return;
      if (!im.__sticker || !im.__sticker.w) editor.setImageSticker(im, { w: 12, color: autoOutlineColor(im) });
      syncImgOutlineChip(im);
      syncOutlineCtrls();
      if (isMobileView()) return openPane(activePane === "outline" ? null : "outline");
      if (activePane === "outline") openPane(null);
      if (!ui2.borderPop.hidden) return hideElPops();
      hideElPops();
      ui2.borderPop.hidden = false;
      placeSpop(ui2.borderPop, ui2.stickerBtn);
    });
    ui2.borderStyleRow.addEventListener("click", (e24) => {
      const tile = e24.target.closest("[data-bstyle]");
      const t2 = outlineTarget();
      if (!tile || !t2) return;
      const key = tile.dataset.bstyle;
      if (t2.type === "shape") {
        const patch = { style: key };
        if (key !== "none" && !t2.obj.__el.bcolor) patch.color = autoOutlineColor(t2.obj);
        if (key !== "none" && !t2.obj.__el.bweight) patch.weight = 12;
        editor.setElBorder(t2.obj, patch);
        syncShapeUI(t2.obj);
        return;
      }
      if (key === "none") editor.setImageSticker(t2.obj, null);
      else if (key === "solid") {
        const st2 = t2.obj.__sticker || {};
        editor.setImageSticker(t2.obj, { w: st2.w || 12, color: st2.color || autoOutlineColor(t2.obj) });
      }
      syncImgOutlineChip(t2.obj);
      syncOutlineCtrls();
    });
    let outlineRaf = null;
    const applyBorderWeight = (v2, live) => {
      const t2 = outlineTarget();
      if (!t2) return;
      if (t2.type === "shape") {
        const n3 = Math.min(100, Math.max(1, Math.round(parseFloat(v2)) || 12));
        editor.setElBorder(t2.obj, { weight: n3 });
        syncShapeUI(t2.obj);
        return;
      }
      const n2 = Math.min(100, Math.max(1, Math.round(parseFloat(v2)) || 12));
      ui2.borderWeight.range.value = String(n2);
      ui2.borderWeight.num.value = String(n2);
      if (outlineRaf) cancelAnimationFrame(outlineRaf);
      outlineRaf = requestAnimationFrame(() => {
        outlineRaf = null;
        const st2 = t2.obj.__sticker || {};
        const sticker = { w: n2, color: st2.color || autoOutlineColor(t2.obj) };
        if (live) editor.setImageStickerLive(t2.obj, sticker);
        else editor.setImageSticker(t2.obj, sticker);
        syncImgOutlineChip(t2.obj);
      });
    };
    ui2.borderWeight.range.addEventListener("input", () => applyBorderWeight(ui2.borderWeight.range.value, true));
    ui2.borderWeight.range.addEventListener("change", () => applyBorderWeight(ui2.borderWeight.range.value));
    ui2.borderWeight.num.addEventListener("change", () => applyBorderWeight(ui2.borderWeight.num.value));
    ui2.elRoundBtn.addEventListener("click", () => openRadiusUI(ui2.elRoundBtn));
    ui2.elFlipHBtn.addEventListener("click", () => editor.flip("h"));
    ui2.elFlipVBtn.addEventListener("click", () => editor.flip("v"));
    ui2.lnColorBtn.addEventListener("click", () => {
      if (!activeElLine()) return;
      colorTarget = "line";
      if (isMobileView()) {
        if (mtrayKind === "color") return closeMtray();
        openMtray("color", fillColorTray, () => openColors());
        return;
      }
      activePane === "color" ? closeColors() : openColors();
    });
    ui2.lnStyleBtn.addEventListener("click", () => {
      const o2 = activeElLine();
      if (!o2) return;
      if (isMobileView()) return openPane(activePane === "lnstyle" ? null : "lnstyle");
      if (!ui2.lnStylePop.hidden) return hideElPops();
      hideElPops();
      syncLineUI(o2);
      ui2.lnStylePop.hidden = false;
      placeSpop(ui2.lnStylePop, ui2.lnStyleBtn);
    });
    ui2.lnEndsBtn.addEventListener("click", () => {
      const o2 = activeElLine();
      if (!o2) return;
      if (isMobileView()) return openPane(activePane === "ends" ? null : "ends");
      if (!ui2.lnEndsPop.hidden) return hideElPops();
      hideElPops();
      syncLineUI(o2);
      ui2.lnEndsPop.hidden = false;
      placeSpop(ui2.lnEndsPop, ui2.lnEndsBtn);
    });
    ui2.lnStyleRow.addEventListener("click", (e24) => {
      const tile = e24.target.closest("[data-lnstyle]");
      const o2 = activeElLine();
      if (!tile || !o2) return;
      editor.setLineProps(o2, { dash: tile.dataset.lnstyle });
      syncLineUI(o2);
    });
    const applyLnWeight = (v2) => {
      const o2 = activeElLine();
      if (!o2) return;
      const n2 = Math.min(30, Math.max(2, Math.round(parseFloat(v2)) || 9));
      editor.setLineProps(o2, { weight: n2 });
      syncLineUI(o2);
    };
    ui2.lnWeight.range.addEventListener("input", () => applyLnWeight(ui2.lnWeight.range.value));
    ui2.lnWeight.num.addEventListener("change", () => applyLnWeight(ui2.lnWeight.num.value));
    const onCapRow = (row, key) => {
      row.addEventListener("click", (e24) => {
        const tile = e24.target.closest("[data-cap]");
        const o2 = activeElLine();
        if (!tile || !o2) return;
        editor.setLineProps(o2, { [key]: tile.dataset.cap });
        syncLineUI(o2);
      });
    };
    onCapRow(ui2.lnCapStartRow, "capStart");
    onCapRow(ui2.lnCapEndRow, "capEnd");
    listen(document, "pointerdown", (e24) => {
      const anchors = [ui2.elBorderBtn, ui2.stickerBtn, ui2.lnStyleBtn, ui2.lnEndsBtn];
      for (const pop of EL_POPS()) {
        if (pop.hidden) continue;
        if (pop.contains(e24.target) || anchors.some((b2) => b2.contains(e24.target))) continue;
        pop.hidden = true;
      }
    });
    const registry = opts.persistRegistry || accountRegistry(opts.customerId);
    function loginUrl() {
      let path = window.location.pathname;
      try {
        const qs2 = new URLSearchParams(window.location.search);
        const keep = new URLSearchParams();
        for (const k2 of ["view", "preview_theme_id", "mode"]) if (qs2.get(k2)) keep.set(k2, qs2.get(k2));
        if (keep.toString()) path += "?" + keep.toString();
      } catch (e24) {
      }
      return "/customer_authentication/login?return_to=" + encodeURIComponent(path);
    }
    const RETURN_PANE_KEY = "nsv2ReturnPane";
    const gotoLogin = (pane) => {
      try {
        if (pane) sessionStorage.setItem(RETURN_PANE_KEY, pane);
      } catch (e24) {
      }
      window.location.href = loginUrl();
    };
    try {
      const qs2 = new URLSearchParams(window.location.search);
      if (qs2.has("shop_sign_in") || qs2.has("shop_consented_scopes")) {
        qs2.delete("shop_sign_in");
        qs2.delete("shop_consented_scopes");
        const clean = window.location.pathname + (qs2.toString() ? "?" + qs2.toString() : "");
        window.history.replaceState(null, "", clean);
      }
    } catch (e24) {
    }
    let designsLoaded = false;
    let designsTab = "saved";
    let designCounts = null;
    function designsEmptyState(msg2, withSignIn) {
      designCounts = null;
      ui2.designsTabs.hidden = true;
      ui2.designsSavedGrid.hidden = ui2.designsGrid.hidden = true;
      ui2.designsEmpty.textContent = msg2;
      if (withSignIn) {
        const b2 = document.createElement("button");
        b2.type = "button";
        b2.className = "nsv2-signin-btn";
        b2.textContent = "Sign In";
        b2.addEventListener("click", () => gotoLogin("designs"));
        ui2.designsEmpty.appendChild(b2);
      }
      ui2.designsEmpty.hidden = false;
    }
    function syncDesignsTab() {
      if (!designCounts) return;
      ui2.designsTabs.hidden = false;
      ui2.designsTabSaved.classList.toggle("is-on", designsTab === "saved");
      ui2.designsTabExports.classList.toggle("is-on", designsTab === "exports");
      const saved = designsTab === "saved";
      ui2.designsSavedGrid.hidden = !saved || !designCounts.saved;
      ui2.designsGrid.hidden = saved || !designCounts.exports;
      const empty = saved ? !designCounts.saved : !designCounts.exports;
      ui2.designsEmpty.textContent = saved ? "No saved designs yet \u2014 hit Save and they\u2019ll show up here" : "No exported designs yet \u2014 hit Use Design and they\u2019ll show up here";
      ui2.designsEmpty.hidden = !empty;
    }
    ui2.designsTabSaved.addEventListener("click", () => {
      designsTab = "saved";
      syncDesignsTab();
    });
    ui2.designsTabExports.addEventListener("click", () => {
      designsTab = "exports";
      syncDesignsTab();
    });
    function editedAgo(ts2) {
      if (!ts2) return "";
      const m = Math.floor((Date.now() - ts2) / 6e4);
      if (m < 1) return "Edited just now";
      if (m < 60) return "Edited " + m + (m === 1 ? " minute ago" : " minutes ago");
      const h2 = Math.floor(m / 60);
      if (h2 < 24) return "Edited " + h2 + (h2 === 1 ? " hour ago" : " hours ago");
      const d2 = Math.floor(h2 / 24);
      if (d2 < 30) return "Edited " + d2 + (d2 === 1 ? " day ago" : " days ago");
      return "Edited " + new Date(ts2).toLocaleDateString();
    }
    const dcardMenu = document.createElement("div");
    dcardMenu.className = "nsv2-menu nsv2-dcard-menu";
    dcardMenu.hidden = true;
    const dcardItem = (label, danger) => {
      const b2 = document.createElement("button");
      b2.type = "button";
      b2.className = "nsv2-menu-item" + (danger ? " nsv2-menu-item--danger" : "");
      b2.innerHTML = '<span class="nsv2-menu-lab"><span>' + label + "</span></span>";
      dcardMenu.appendChild(b2);
      return b2;
    };
    const dcardOpen = dcardItem("Open");
    const dcardDup = dcardItem("Duplicate");
    const dcardDel = dcardItem("Delete", true);
    ui2.root.appendChild(dcardMenu);
    let dcardCtx = null;
    function closeDcardMenu() {
      dcardMenu.hidden = true;
      if (dcardCtx) dcardCtx.dots.classList.remove("is-open");
      dcardCtx = null;
    }
    listen(document, "pointerdown", (e24) => {
      if (dcardCtx && !dcardMenu.contains(e24.target) && !dcardCtx.dots.contains(e24.target)) closeDcardMenu();
    }, true);
    listen(document, "scroll", () => {
      if (dcardCtx) closeDcardMenu();
    }, true);
    dcardOpen.addEventListener("click", () => {
      const c2 = dcardCtx;
      closeDcardMenu();
      if (c2) openSavedDesign(c2.f, c2.card);
    });
    dcardDup.addEventListener("click", async () => {
      const c2 = dcardCtx;
      closeDcardMenu();
      if (!c2) return;
      c2.card.classList.add("is-loading");
      try {
        const result = await duplicateDesign(registry, c2.f.url || c2.f.bare);
        noteSessionSave(result);
      } catch (err) {
        console.error("studio-v2: duplicate failed", err);
        askDialog("Couldn\u2019t duplicate this design \u2014 please try again.", { cancel: null });
      } finally {
        c2.card.classList.remove("is-loading");
      }
    });
    dcardDel.addEventListener("click", async () => {
      const c2 = dcardCtx;
      closeDcardMenu();
      if (!c2) return;
      if (!await askDialog("Delete this design? This can\u2019t be undone.", { ok: "Delete" })) return;
      c2.card.classList.add("is-loading");
      try {
        await registry.archive(c2.f.name);
        sessionArchived.add(c2.f.name);
        sessionSaves = sessionSaves.filter((sv) => sv.name !== c2.f.name);
        designsLoaded = false;
        loadMyDesigns();
      } catch (err) {
        console.error("studio-v2: delete failed", err);
        c2.card.classList.remove("is-loading");
        askDialog("Couldn\u2019t delete this design \u2014 please try again.", { cancel: null });
      }
    });
    function designCard(f2) {
      const card = document.createElement("div");
      card.className = "nsv2-dcard" + (f2.pending ? " is-loading" : "");
      const thumb = document.createElement("button");
      thumb.type = "button";
      thumb.className = "nsv2-dcard-thumb";
      if (f2.pending) {
        const im = document.createElement("img");
        im.alt = f2.name || "";
        if (f2.thumb) im.src = f2.thumb;
        thumb.appendChild(im);
      } else {
        thumb.appendChild(previewImg(f2));
      }
      thumb.addEventListener("click", () => {
        if (!f2.pending) openSavedDesign(f2, card);
      });
      const dots = document.createElement("button");
      dots.type = "button";
      dots.className = "nsv2-dcard-dots";
      dots.setAttribute("aria-label", "Design options");
      dots.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><circle cx="3" cy="8" r="1.6"/><circle cx="8" cy="8" r="1.6"/><circle cx="13" cy="8" r="1.6"/></svg>';
      dots.addEventListener("click", (e24) => {
        e24.stopPropagation();
        if (dcardCtx && dcardCtx.dots === dots) return closeDcardMenu();
        if (dcardCtx) closeDcardMenu();
        dcardCtx = { f: f2, card, dots };
        dots.classList.add("is-open");
        dcardMenu.hidden = false;
        const rr2 = ui2.root.getBoundingClientRect();
        const dr2 = dots.getBoundingClientRect();
        const mw = dcardMenu.offsetWidth, mh = dcardMenu.offsetHeight;
        const px = Math.max(8, Math.min(dr2.right - rr2.left - mw, rr2.width - mw - 8));
        const py = Math.max(8, Math.min(dr2.bottom - rr2.top + 4, rr2.height - mh - 8));
        dcardMenu.style.transform = "translate(" + px + "px, " + py + "px)";
      });
      const name = document.createElement("div");
      name.className = "nsv2-dcard-name";
      name.textContent = nameFromFileName(f2.name) || "Untitled Design";
      const meta = document.createElement("div");
      meta.className = "nsv2-dcard-meta";
      meta.textContent = editedAgo(f2.ts);
      card.append(thumb, dots, name, meta);
      return card;
    }
    function designRow(f2, re2) {
      return {
        bare: f2.url.split("?")[0].split(cfg.s3Host).join(cfg.imgixHost),
        url: f2.url,
        name: f2.name,
        ts: Number(f2.name.match(re2)[1]) || 0
      };
    }
    async function openSavedDesign(f2, tile) {
      if (editor.canvas.getObjects().length && !await askDialog("Open this design? Your current canvas will be replaced.", { ok: "Open" }))
        return;
      tile.classList.add("is-loading");
      try {
        const meta = await loadDesignFromUrl(editor, stateUrlFor(f2.url), modeSanitize);
        if (!lastStripped) adoptSave(meta);
        trackOpenSaved();
      } catch (err) {
        console.error("studio-v2: design load failed", err);
        askDialog("Couldn\u2019t open this design \u2014 please try again.", { cancel: null });
      } finally {
        tile.classList.remove("is-loading");
      }
    }
    let sessionSaves = [];
    const sessionArchived = /* @__PURE__ */ new Set();
    function noteSessionSave(result, replacedFileName) {
      track("save");
      if (!firstSaveSent) {
        firstSaveSent = true;
        track("first_save");
      }
      sessionSaves = sessionSaves.filter((s3) => s3.name !== result.fileName);
      sessionSaves.unshift(designRow({ url: result.previewUrl, name: result.fileName }, savedNameRe(result.fileName)));
      if (replacedFileName) sessionArchived.add(replacedFileName);
      designsLoaded = false;
      if (activePane === "designs") loadMyDesigns();
    }
    async function notePendingSave(fileName) {
      let thumb = "";
      try {
        thumb = URL.createObjectURL(await editor.exportPng(300, { print: false }));
      } catch (e24) {
      }
      const re2 = savedNameRe(fileName);
      sessionSaves = sessionSaves.filter((s3) => s3.name !== fileName);
      sessionSaves.unshift({ bare: "", url: "", name: fileName, ts: re2 ? Number(fileName.match(re2)[1]) || Date.now() : Date.now(), thumb, pending: true });
      designsLoaded = false;
      if (activePane === "designs") loadMyDesigns();
    }
    function dropPendingSave(fileName) {
      const row = sessionSaves.find((s3) => s3.name === fileName && s3.pending);
      if (!row) return;
      if (row.thumb) {
        try {
          URL.revokeObjectURL(row.thumb);
        } catch (e24) {
        }
      }
      sessionSaves = sessionSaves.filter((s3) => s3 !== row);
      designsLoaded = false;
      if (activePane === "designs") loadMyDesigns();
    }
    async function loadMyDesigns() {
      if (designsLoaded) return;
      designsLoaded = true;
      if (!registry) {
        designsEmptyState("Sign in to see your saved designs, exports, and uploads", true);
        return;
      }
      let files;
      try {
        files = await registry.list();
      } catch (err) {
        console.warn("studio-v2: designs library unavailable", err);
        designsLoaded = false;
        designsEmptyState("Couldn\u2019t load your designs \u2014 try again in a moment");
        return;
      }
      const fetched = files.filter((f2) => savedNameRe(f2.name)).map((f2) => designRow(f2, savedNameRe(f2.name)));
      const seen = new Set(sessionSaves.map((s3) => s3.name));
      const saved = sessionSaves.concat(fetched.filter((f2) => !seen.has(f2.name))).filter((f2) => !sessionArchived.has(f2.name)).sort((a2, b2) => b2.ts - a2.ts);
      const exports_ = files.filter((f2) => EXPORT_NAME_RE.test(f2.name) && !savedNameRe(f2.name)).map((f2) => designRow(f2, EXPORT_NAME_RE)).sort((a2, b2) => b2.ts - a2.ts);
      const savedFrag = document.createDocumentFragment();
      for (const f2 of saved) savedFrag.appendChild(designCard(f2));
      ui2.designsSavedGrid.replaceChildren(savedFrag);
      const expFrag = document.createDocumentFragment();
      for (const f2 of exports_) expFrag.appendChild(fileTile(f2));
      ui2.designsGrid.replaceChildren(expFrag);
      designCounts = { saved: saved.length, exports: exports_.length };
      syncDesignsTab();
    }
    let premadeInit = false;
    function initPremade() {
      if (premadeInit) return;
      premadeInit = true;
      const body = ui2.premadeBody;
      const topbar = document.createElement("div");
      topbar.className = "nsv2-ndl-top";
      const backBtn = document.createElement("button");
      backBtn.type = "button";
      backBtn.className = "nsv2-ndl-back";
      backBtn.innerHTML = icons.chevronRight + "<span>Back</span>";
      const titleEl = document.createElement("span");
      titleEl.className = "nsv2-ndl-title";
      topbar.append(backBtn, titleEl);
      const home = document.createElement("div");
      home.className = "nsv2-designs nsv2-designs--saved";
      const subs = document.createElement("div");
      subs.className = "nsv2-designs nsv2-designs--saved";
      const grid = document.createElement("div");
      grid.className = "nsv2-designs nsv2-designs--saved";
      const pager = document.createElement("div");
      pager.className = "nsv2-ndl-pager";
      const status = document.createElement("div");
      status.className = "nsv2-designs-empty";
      body.append(topbar, home, subs, grid, pager, status);
      let onBack = null;
      backBtn.addEventListener("click", () => {
        if (onBack) onBack();
      });
      let curHandle = null, page = 1, pages = 1, reqSeq = 0;
      const cache = {};
      const views = [topbar, home, subs, grid, pager, status];
      function show(...els) {
        for (const v2 of views) v2.hidden = !els.includes(v2);
      }
      function card(name, img, meta, onClick) {
        const c2 = document.createElement("div");
        c2.className = "nsv2-dcard";
        const thumb = document.createElement("button");
        thumb.type = "button";
        thumb.className = "nsv2-dcard-thumb";
        if (img) {
          const im = document.createElement("img");
          im.loading = "lazy";
          im.decoding = "async";
          im.alt = name;
          im.src = img;
          im.onerror = () => {
            im.remove();
            thumb.classList.add("nsv2-ndl-textile");
            thumb.textContent = name;
          };
          thumb.appendChild(im);
        } else {
          thumb.classList.add("nsv2-ndl-textile");
          thumb.textContent = name;
        }
        thumb.addEventListener("click", () => onClick(c2));
        const nm = document.createElement("div");
        nm.className = "nsv2-dcard-name";
        nm.textContent = name;
        c2.append(thumb, nm);
        if (meta) {
          const mt2 = document.createElement("div");
          mt2.className = "nsv2-dcard-meta";
          mt2.textContent = meta;
          c2.append(mt2);
        }
        return c2;
      }
      for (const c2 of NDL_CATS)
        home.appendChild(card(c2.name, c2.img, c2.subs.length + " categories", () => openCat(c2)));
      function showCats() {
        reqSeq++;
        show(home);
      }
      function openCat(c2) {
        reqSeq++;
        titleEl.textContent = c2.name;
        onBack = showCats;
        subs.replaceChildren();
        for (const s22 of c2.subs)
          subs.appendChild(card(s22.t, s22.img, s22.n ? s22.n + " designs" : "", () => openSub(c2, s22)));
        show(topbar, subs);
      }
      function openSub(c2, s22) {
        titleEl.textContent = c2.name + " \u203A " + s22.t;
        onBack = () => openCat(c2);
        load(s22.h, 1);
      }
      function urlFor(handle, n2) {
        let url = "/collections/" + handle + "?view=rtp-json&page=" + n2;
        const pv = new URLSearchParams(location.search).get("preview_theme_id");
        if (pv) url += "&preview_theme_id=" + encodeURIComponent(pv);
        return url;
      }
      function load(handle, n2) {
        curHandle = handle;
        page = n2;
        status.textContent = "Loading designs\u2026";
        show(topbar, status);
        const key = handle + ":" + n2;
        const seq = ++reqSeq;
        if (cache[key]) return renderDesigns(cache[key], seq);
        fetch(urlFor(handle, n2)).then((r2) => r2.json()).then((d2) => {
          cache[key] = d2;
          renderDesigns(d2, seq);
        }).catch(() => {
          if (seq !== reqSeq) return;
          status.textContent = "Couldn\u2019t load designs \u2014 please try again.";
        });
      }
      function renderDesigns(d2, seq) {
        if (seq !== reqSeq) return;
        pages = d2.pages || 1;
        grid.replaceChildren();
        for (const it2 of d2.items || []) {
          const clean = String(it2.title || "").replace(/\s*[-|,]?\s*Ready[\s-]?to[\s-]?Press(\s*DTF)?(\s*Transfers?)?\s*$/i, "").replace(/\s*[-|,]\s*$/, "").trim() || it2.title || "";
          grid.appendChild(card(clean, thumbUrl(it2), "", (tile) => placePremade(it2, clean, tile)));
        }
        renderPager();
        show(topbar, grid, ...pages > 1 ? [pager] : []);
      }
      function renderPager() {
        pager.replaceChildren();
        if (pages <= 1) return;
        const mk = (label) => {
          const b2 = document.createElement("button");
          b2.type = "button";
          b2.className = "nsv2-ndl-pgbtn";
          b2.textContent = label;
          return b2;
        };
        const prev = mk("Prev"), next = mk("Next");
        const info = document.createElement("span");
        info.className = "nsv2-ndl-pginfo";
        info.textContent = "Page " + page + " of " + pages;
        prev.disabled = page <= 1;
        next.disabled = page >= pages;
        prev.onclick = () => {
          if (page > 1) load(curHandle, page - 1);
        };
        next.onclick = () => {
          if (page < pages) load(curHandle, page + 1);
        };
        pager.append(prev, info, next);
      }
      showCats();
    }
    function thumbUrl(it2) {
      return String(it2.img || "").replace(/^\/\//, "https://");
    }
    async function placePremade(it2, name, tile) {
      if (!kindAllowed("image")) return refuse("image");
      const file = String(it2.file || "");
      const bare = file.split("?")[0];
      const cands = [];
      if (/\.amazonaws\.com\//.test(bare) && bare.indexOf(cfg.s3Host) === -1) {
        let base = bare.split("/").pop();
        try {
          base = decodeURIComponent(base);
        } catch (e24) {
        }
        if (cfg.rtpMirror) cands.push(cfg.rtpMirror + encodeURIComponent(base.replace(/\+/g, " ")));
      } else if (bare.indexOf("imgix.net") > -1 || bare.indexOf(cfg.s3Host) > -1) {
        cands.push(bare);
      }
      tile.classList.add("is-loading");
      try {
        let placed = null, lastErr = null;
        for (const u2 of cands) {
          try {
            placed = await editor.addImageFromUrl(hostedDisplayUrl(u2), name);
            placed.__bgr = {
              status: "ready",
              imgixUrl: u2.split("?")[0],
              fileName: name + ".png",
              isVector: false,
              versions: {},
              model: null
            };
            break;
          } catch (err) {
            lastErr = err;
          }
        }
        if (!placed) throw lastErr || new Error("no loadable part file");
        trackAdd("premade_place");
        syncSelection();
        closePanelAfterPlace();
      } catch (err) {
        console.error("studio-v2: premade part file failed", file, err);
        askDialog("Couldn\u2019t load this design \u2014 please try again.", { cancel: null });
      } finally {
        tile.classList.remove("is-loading");
      }
    }
    function syncSelection() {
      if (editor._crop) return;
      const t2 = editor.activeText();
      const im = editor.activeImage();
      const sel = editor.activeSelection();
      const none = !editor.canvas.getActiveObject();
      ui2.ctxbar.classList.add("is-visible");
      const activeNow = editor.canvas.getActiveObject() || null;
      if (activeNow !== lastTrayObj) {
        lastTrayObj = activeNow;
        if (isMobileView()) ui2.ctxbar.scrollLeft = 0;
      }
      const elSh = activeElShape();
      const elLn = activeElLine();
      const lockedSel = (() => {
        const a2 = editor.canvas.getActiveObject();
        return !!(a2 && a2.__locked);
      })();
      const baseSel = (() => {
        const a2 = editor.canvas.getActiveObject();
        return !!(a2 && a2.__base);
      })();
      ui2.ctxTextGroup.hidden = !t2 || lockedSel;
      ui2.editTextChip.hidden = !!sel;
      ui2.ctxImageGroup.hidden = !im || lockedSel || !!im.__base;
      ui2.cropBtn.hidden = !!(im && im.__el);
      ui2.ctxShapeGroup.hidden = !elSh || lockedSel;
      ui2.ctxLineGroup.hidden = !elLn || lockedSel;
      ui2.ctxSelGroup.hidden = !sel || lockedSel;
      ui2.ctxCanvasGroup.hidden = !none;
      ui2.ctxNudgeGroup.hidden = none || lockedSel;
      if (none && activePane === "nudge") openPane(null);
      ui2.ctxTail.hidden = none || lockedSel || baseSel;
      if (elSh) syncShapeUI(elSh);
      if (elLn) syncLineUI(elLn);
      if (t2) colorTarget = "text";
      if (!elSh && !elLn) {
        hideElPops();
        if (activePane === "border" || activePane === "ends" || activePane === "lnstyle") openPane(null);
      }
      if (im) {
        const st2 = im.__bgr && im.__bgr.status || "none";
        ui2.removeBgBtn.disabled = st2 !== "ready";
        ui2.removeBgBtn.dataset.tip = st2 === "uploading" ? "Preparing upload\u2026" : st2 === "failed" ? "Upload failed" : "Remove background";
        ui2.filtersBtn.disabled = st2 !== "ready";
        ui2.filtersBtn.dataset.tip = st2 === "uploading" ? "Preparing upload\u2026" : st2 === "failed" ? "Upload failed" : "Filters";
        ui2.upscaleBtn.disabled = st2 !== "ready";
        ui2.upscaleBtn.dataset.tip = st2 === "uploading" ? "Preparing upload\u2026" : st2 === "failed" ? "Upload failed" : "AI upscale for sharper large prints";
        syncUpscaleUI(im);
        if (activePane === "bgr" && liveBgrObject() !== im) closeBgr();
        if (activePane === "filters" && filterObject !== im) closeFilters();
        ui2.colorReplaceBtn.disabled = false;
        if (activePane === "recolor" && liveRecolorObject() !== im) closeRecolor();
        syncImgOutlineChip(im);
      }
      if (!t2) {
        const mob = isMobileView();
        if (activePane === "color") setColorMode(false);
        const textExp = activePane === "fonts" || activePane === "effects" || activePane === "color" || activePane === "format" || activePane === "spacing" || activePane === "shape";
        if (mob && textExp) openPane(null);
        else {
          if (activePane === "fonts") closeFonts();
          if (activePane === "effects") closeFx();
          if (activePane === "color") closeColors();
        }
        const imgExp = activePane === "bgr" || activePane === "filters" || activePane === "recolor" || activePane === "outline";
        if (!im && imgExp) {
          if (mob) openPane(null);
          else {
            if (activePane === "bgr") closeBgr();
            if (activePane === "filters") closeFilters();
            if (activePane === "recolor") closeRecolor();
            if (activePane === "outline") openPane(null);
          }
        }
        hideSpop();
        return;
      }
      if (!ui2.spop.hidden) syncSpop();
      ui2.alignBtn.hidden = t2.textLines.length < 2;
      currentFamily = t2.fontFamily || currentFamily;
      currentWeight = parseInt(t2.fontWeight, 10) || (t2.fontWeight === "bold" ? 700 : 400);
      markFontRows();
      const gang = editor.activeTexts();
      if (gang.length > 1) {
        const fams = new Set(gang.map((x2) => x2.fontFamily));
        if (fams.size > 1) ui2.fontBtn.querySelector('[data-ref="family"]').textContent = "Multiple fonts";
        const sizes = new Set(gang.map((x2) => Math.round(x2.fontSize)));
        ui2.sizeVal.value = sizes.size > 1 ? "\u2014" : String(Math.round(t2.fontSize));
      } else {
        ui2.sizeVal.value = String(Math.round(t2.fontSize));
      }
      syncColorUI();
      const wt2 = parseInt(t2.fontWeight, 10) || (t2.fontWeight === "bold" ? 700 : 400);
      ui2.boldBtn.classList.toggle("is-on", wt2 >= 600);
      ui2.boldBtn.disabled = nearestWeight(t2.fontFamily, 700) < 600;
      ui2.boldBtn.dataset.tip = ui2.boldBtn.disabled ? "No bold weight for this font" : "Bold";
      ui2.italicBtn.classList.toggle("is-on", t2.fontStyle === "italic");
      ui2.underlineBtn.classList.toggle("is-on", !!t2.underline);
      ui2.strikeBtn.classList.toggle("is-on", !!t2.linethrough);
      ui2.caseBtn.classList.toggle("is-on", t2.__caseOrig != null && t2.text === t2.__caseOrig.toUpperCase());
      ui2.bulletsBtn.classList.toggle("is-on", !!t2.__bullets);
      if (activePane === "effects") syncFxPane();
    }
    editor.on("selection", syncSelection);
    const ctxGroupItems = {
      text: [...ui2.ctxTextGroup.children],
      image: [...ui2.ctxImageGroup.children],
      shape: [...ui2.ctxShapeGroup.children],
      line: [...ui2.ctxLineGroup.children]
    };
    function hideMorePanel() {
      ui2.ctxMorePanel.hidden = true;
      ui2.ctxMoreBtn.classList.remove("is-on");
    }
    function restoreGroup(group, items) {
      let prev = null;
      for (const n2 of items) {
        if (n2.parentNode !== group || n2.previousElementSibling !== prev) {
          group.insertBefore(n2, prev ? prev.nextElementSibling : group.firstElementChild);
        }
        prev = n2;
      }
    }
    function layoutCtxOverflow() {
      hideMorePanel();
      if (!ui2.ctxMorePanel.children.length && ui2.ctxbar.scrollWidth <= ui2.ctxbar.clientWidth + 1) {
        ui2.ctxMoreBtn.hidden = true;
        return;
      }
      restoreGroup(ui2.ctxTextGroup, ctxGroupItems.text);
      restoreGroup(ui2.ctxImageGroup, ctxGroupItems.image);
      restoreGroup(ui2.ctxShapeGroup, ctxGroupItems.shape);
      restoreGroup(ui2.ctxLineGroup, ctxGroupItems.line);
      ui2.ctxMoreBtn.hidden = true;
      if (!ui2.ctxbar.classList.contains("is-visible")) return;
      if (ui2.root.clientWidth < 768) return;
      const group = !ui2.ctxTextGroup.hidden ? ui2.ctxTextGroup : !ui2.ctxImageGroup.hidden ? ui2.ctxImageGroup : !ui2.ctxShapeGroup.hidden ? ui2.ctxShapeGroup : !ui2.ctxLineGroup.hidden ? ui2.ctxLineGroup : null;
      if (!group) return;
      let guard = group.children.length;
      while (ui2.ctxbar.scrollWidth > ui2.ctxbar.clientWidth + 1 && group.children.length > 1 && guard--) {
        ui2.ctxMoreBtn.hidden = false;
        ui2.ctxMorePanel.prepend(group.lastElementChild);
      }
      const last = group.lastElementChild;
      if (!ui2.ctxMoreBtn.hidden && last && last.classList.contains("nsv2-vdiv")) ui2.ctxMorePanel.prepend(last);
    }
    ui2.ctxMoreBtn.addEventListener("click", () => {
      if (!ui2.ctxMorePanel.hidden) return hideMorePanel();
      ui2.ctxMorePanel.hidden = false;
      ui2.ctxMoreBtn.classList.add("is-on");
      const btn = ui2.ctxMoreBtn.getBoundingClientRect();
      const areaR = ui2.area.getBoundingClientRect();
      ui2.ctxMorePanel.style.top = btn.bottom - areaR.top + 6 + "px";
      ui2.ctxMorePanel.style.left = Math.max(8, Math.min(btn.right - areaR.left - ui2.ctxMorePanel.offsetWidth, areaR.width - ui2.ctxMorePanel.offsetWidth - 8)) + "px";
    });
    ui2.root.addEventListener("pointerdown", (e24) => {
      if (ui2.ctxMorePanel.hidden) return;
      if (e24.target.closest(".nsv2-ctx-more-panel") || e24.target.closest(".nsv2-ctx-more")) return;
      hideMorePanel();
    });
    editor.on("selection", layoutCtxOverflow);
    new ResizeObserver(layoutCtxOverflow).observe(ui2.ctxbar);
    const stepSize = (d2) => {
      const t2 = editor.activeText();
      if (!t2) return;
      editor.setTextProp({ fontSize: Math.min(600, Math.max(8, Math.round(t2.fontSize) + d2)) });
      syncSelection();
    };
    ui2.sizeDown.addEventListener("click", () => stepSize(-4));
    ui2.sizeUp.addEventListener("click", () => stepSize(4));
    ui2.fmtChip.addEventListener("click", () => openPane(activePane === "format" ? null : "format"));
    ui2.spacingChip.addEventListener("click", () => openPane(activePane === "spacing" ? null : "spacing"));
    ui2.shapeChip.addEventListener("click", () => {
      const opening = activePane !== "shape";
      openPane(opening ? "shape" : null);
      if (opening) syncFxPane();
    });
    function fillSizeTray(scroll) {
      const t2 = editor.activeText();
      const cur = t2 ? Math.round(t2.fontSize) : 120;
      const row = ui2.sliderRow("Size", 8, 400, 1, cur);
      const apply = (v2) => {
        v2 = Math.min(600, Math.max(8, Math.round(v2) || 8));
        editor.setTextProp({ fontSize: v2 });
        row.num.value = String(v2);
        ui2.sizeVal.value = String(v2);
      };
      row.range.addEventListener("input", () => apply(row.range.valueAsNumber));
      row.num.addEventListener("change", () => {
        apply(parseFloat(row.num.value));
        row.range.value = row.num.value;
      });
      row.wrap.classList.add("nsv2-mtray-sliderrow");
      scroll.appendChild(row.wrap);
    }
    const toggleSizeTray = () => {
      ui2.sizeVal.blur();
      if (mtrayKind === "size") return closeMtray();
      if (!editor.activeText()) return;
      openMtray("size", fillSizeTray);
    };
    ui2.sizeWrap.addEventListener("pointerdown", (e24) => {
      if (!isMobileView() || e24.pointerType === "touch") return;
      e24.preventDefault();
      toggleSizeTray();
    });
    ui2.sizeWrap.addEventListener("touchend", (e24) => {
      if (!isMobileView()) return;
      e24.preventDefault();
      toggleSizeTray();
    });
    ui2.sizeVal.addEventListener("pointerdown", (e24) => {
      if (!isMobileView() || e24.pointerType === "touch") return;
      e24.preventDefault();
      toggleSizeTray();
    });
    ui2.sizeVal.addEventListener("touchend", (e24) => {
      if (!isMobileView()) return;
      e24.preventDefault();
      toggleSizeTray();
    });
    ui2.sizeVal.addEventListener("change", () => {
      const v2 = parseInt(ui2.sizeVal.value, 10);
      if (!isNaN(v2)) editor.setTextProp({ fontSize: Math.min(600, Math.max(8, v2)) });
      syncSelection();
    });
    ui2.boldBtn.addEventListener("click", () => {
      const t2 = editor.activeText();
      if (!t2) return;
      const wt2 = parseInt(t2.fontWeight, 10) || (t2.fontWeight === "bold" ? 700 : 400);
      editor.setTextProp({ fontWeight: nearestWeight(t2.fontFamily, wt2 >= 600 ? 400 : 700) });
      syncSelection();
    });
    ui2.italicBtn.addEventListener("click", () => {
      const t2 = editor.activeText();
      if (!t2) return;
      editor.setTextProp({ fontStyle: t2.fontStyle === "italic" ? "normal" : "italic" });
      syncSelection();
    });
    ui2.underlineBtn.addEventListener("click", () => {
      const t2 = editor.activeText();
      if (t2) {
        editor.setTextProp({ underline: !t2.underline });
        syncSelection();
      }
    });
    ui2.strikeBtn.addEventListener("click", () => {
      const t2 = editor.activeText();
      if (t2) {
        editor.setTextProp({ linethrough: !t2.linethrough });
        syncSelection();
      }
    });
    ui2.caseBtn.addEventListener("click", () => {
      const t2 = editor.activeText();
      if (!t2) return;
      if (t2.__caseOrig != null && t2.text === t2.__caseOrig.toUpperCase()) {
        editor.setTextProp({ text: t2.__caseOrig });
        t2.__caseOrig = null;
      } else if (t2.text === t2.text.toUpperCase() && t2.text !== t2.text.toLowerCase()) {
        editor.setTextProp({ text: t2.text.toLowerCase() });
        t2.__caseOrig = null;
      } else {
        t2.__caseOrig = t2.text;
        editor.setTextProp({ text: t2.text.toUpperCase() });
      }
      syncSelection();
    });
    ui2.bulletsBtn.addEventListener("click", () => {
      const t2 = editor.activeText();
      if (!t2) return;
      editor.setBullets(!t2.__bullets);
      syncSelection();
    });
    const ALIGNS = ["left", "center", "right"];
    ui2.alignBtn.addEventListener("click", () => {
      const t2 = editor.activeText();
      if (!t2) return;
      const next = ALIGNS[(ALIGNS.indexOf(t2.textAlign) + 1) % ALIGNS.length];
      editor.setTextProp({ textAlign: next });
    });
    ui2.deleteBtn.addEventListener("click", () => editor.deleteActive());
    const fxDefaultColor = (key, t2) => {
      const fillHex = cssToSolidHex(t2 && (t2.__baseFill || t2.fill) || "#0f172a") || "#0f172a";
      const fillLum = hexLum(fillHex);
      const boardLum = hexLum(editor._boardBg || "#ffffff");
      const pick2 = (cands, targets) => {
        let best = cands[0], bs2 = -1;
        for (const c2 of cands) {
          const cl = hexLum(c2);
          const sc2 = Math.min.apply(null, targets.map((x2) => Math.abs(cl - x2)));
          if (sc2 > bs2) {
            bs2 = sc2;
            best = c2;
          }
        }
        return best;
      };
      if (key === "glow") return "#019AFF";
      if (key === "hollow") return pick2([fillHex, "#0f172a", "#ffffff", "#8b98ab"], [boardLum]);
      if (key === "background") return pick2(["#0f172a", "#e8f1f8", "#8b98ab"], [fillLum, boardLum]);
      const CANDS = {
        outline: ["#0f172a", "#ffffff", "#8b98ab"],
        drop: ["#0f172a", "#94a3b8", "#e2e8f0"],
        splice: ["#475569", "#94a3b8", "#e2e8f0"],
        echo: ["#334155", "#94a3b8", "#dbe4ee"]
      };
      return pick2(CANDS[key] || ["#0f172a", "#ffffff", "#8b98ab"], [fillLum, boardLum]);
    };
    let paneBeforeFx = null;
    function twoStepSheet({ pane, tiles, title, defaultTitle, adjustable }) {
      let step = "pick";
      const set = (s3) => {
        step = s3;
        const mobile = isMobileView();
        pane.classList.toggle("is-pick", mobile && step === "pick");
        pane.classList.toggle("is-adjust", mobile && step === "adjust");
        const on2 = tiles.querySelector(".nsv2-fx-tile.is-active .nsv2-fx-label");
        title.textContent = mobile && step === "adjust" && on2 ? on2.textContent : defaultTitle;
      };
      return {
        reset: () => set("pick"),
        // Pane sync: keeps badge/title honest; returns whether controls may show.
        sync(canAdjust) {
          if (step === "adjust" && !canAdjust) step = "pick";
          set(step);
          return !isMobileView() || step === "adjust";
        },
        // Tile tap pre-hook: the SELECTED, adjustable tile tapped again → step 2
        // (no re-apply — the caller returns when this is true).
        tap(tile) {
          if (!isMobileView() || !tile.classList.contains("is-active") || !adjustable(tile)) return false;
          set("adjust");
          return true;
        },
        // ‹ pre-hook: in step 2 go back to the tiles instead of closing.
        back() {
          if (!isMobileView() || step !== "adjust") return false;
          set("pick");
          return true;
        }
      };
    }
    const fxSteps = twoStepSheet({
      pane: ui2.effectsPane,
      tiles: ui2.fxTiles,
      title: ui2.fxTitle,
      defaultTitle: "Effects",
      adjustable: (tile) => tile.dataset.fx !== "none"
    });
    function closeFx() {
      if (isMobileView()) {
        if (fxSteps.back()) return syncFxPane();
        fxSteps.reset();
        return openPane(null);
      }
      openPane(paneBeforeFx === "effects" ? null : paneBeforeFx || "text");
    }
    function syncFxPane() {
      const t2 = editor.activeText();
      const active = t2 && t2.__effect || "none";
      ui2.fxTiles.querySelectorAll(".nsv2-fx-tile").forEach((tile) => {
        tile.classList.toggle("is-active", tile.dataset.fx === active);
      });
      if (t2 && t2.__effectColor) {
        if (/^#/.test(t2.__effectColor)) ui2.fxColorInput.value = t2.__effectColor;
        ui2.fxColorChip.style.background = t2.__effectColor;
        ui2.fxPopCurrent.style.background = t2.__effectColor;
      }
      const fx = t2 && t2.__effect || null;
      const placed = !!fx && placeControls(ui2.fxTiles, ui2.fxControls, ".nsv2-fx-tile", '[data-fx="' + fx + '"]');
      ui2.fxControls.hidden = !placed || !fxSteps.sync(!!fx && fx !== "none");
      ui2.fxColorChip2.hidden = fx !== "echo";
      ui2.fxColorLabel.textContent = fx === "echo" ? "Colors" : "Color";
      if (fx === "echo" && t2 && t2.__fxEcho2) ui2.fxColorChip2.style.background = t2.__fxEcho2;
      ui2.fxSize.wrap.hidden = !["outline", "hollow", "splice"].includes(fx);
      const isDrop = fx === "drop";
      const isBg = fx === "background";
      const hasDirOff = isDrop || fx === "echo" || fx === "splice";
      ui2.fxDir.wrap.hidden = ui2.fxOff.wrap.hidden = !hasDirOff;
      ui2.fxBlur.wrap.hidden = true;
      ui2.fxTransp.wrap.hidden = true;
      ui2.fxRound.wrap.hidden = ui2.fxSpread.wrap.hidden = !isBg;
      const setRow = (row, v2) => {
        row.range.value = String(v2);
        row.num.value = String(v2);
      };
      setRow(ui2.fxSize, t2 && t2.__effectSize != null ? t2.__effectSize : 12);
      if (hasDirOff) {
        setRow(ui2.fxDir, t2.__fxDirection != null ? t2.__fxDirection : 45);
        setRow(ui2.fxOff, t2.__fxOffset != null ? t2.__fxOffset : 50);
      }
      if (isBg) {
        setRow(ui2.fxRound, t2.__fxRound != null ? t2.__fxRound : 22);
        setRow(ui2.fxSpread, t2.__fxSpread != null ? t2.__fxSpread : 50);
      }
      const sh = t2 && t2.__shape || null;
      currentShapeKind = sh ? sh.kind : "none";
      ui2.shapeTiles.querySelectorAll(".nsv2-fx-tile").forEach((tile) => {
        tile.classList.toggle("is-active", tile.dataset.shape === currentShapeKind);
      });
      const amt = sh ? sh.amount : 0;
      ui2.fxCurveRange.value = String(amt);
      ui2.fxCurveVal.value = String(amt);
      const shapeSheetOpen = !isMobileView() || activePane === "shape";
      ui2.fxCurveRow.hidden = currentShapeKind === "none" || !shapeSheetOpen || !placeControls(ui2.shapeTiles, ui2.fxCurveRow, ".nsv2-fx-tile", '[data-shape="' + currentShapeKind + '"]');
    }
    function openFx() {
      if (activePane !== "effects") paneBeforeFx = activePane;
      openPane("effects");
      fxSteps.reset();
      syncFxPane();
    }
    ui2.effectsBtn.addEventListener("click", () => activePane === "effects" ? closeFx() : openFx());
    ui2.fxBackBtn.addEventListener("click", closeFx);
    ui2.fxTiles.addEventListener("click", (e24) => {
      const tile = e24.target.closest(".nsv2-fx-tile");
      if (!tile) return;
      const key = tile.dataset.fx;
      if (fxSteps.tap(tile)) {
        syncFxPane();
        return;
      }
      if (key !== "none") {
        const c2 = fxDefaultColor(key, editor.activeText());
        ui2.fxColorInput.value = c2;
        ui2.fxColorChip.style.background = c2;
        ui2.fxPopCurrent.style.background = c2;
        editor.applyTextEffect(key, c2);
        track("effect_apply");
      } else {
        editor.applyTextEffect("none");
      }
      syncFxPane();
      syncSelection();
    });
    let fxColorTarget = 1;
    function applyFxColor(c2) {
      const t2 = editor.activeText();
      if (!t2 || !t2.__effect) return;
      if (fxColorTarget === 2) {
        for (const x2 of editor.activeTexts()) {
          x2.__fxEcho2 = c2;
          editor._applyTextEffectTo(x2, "echo", x2.__effectColor || void 0);
        }
        ui2.fxColorChip2.style.background = c2;
      } else {
        editor.applyTextEffect(t2.__effect, c2);
        ui2.fxColorChip.style.background = c2;
        if (/^#/.test(c2)) ui2.fxColorInput.value = c2;
      }
      ui2.fxPopCurrent.style.background = c2;
      markFxPopActive(c2);
    }
    function markFxPopActive(c2) {
      const lc2 = (c2 || "").toLowerCase();
      for (const sw of [...ui2.fxDesignGrid.children, ...ui2.fxDefaultGrid.children]) {
        sw.classList.toggle("is-active", sw.dataset.c.toLowerCase() === lc2);
      }
    }
    function openFxColorPop() {
      const t2 = editor.activeText();
      if (!t2 || !t2.__effect) return;
      const frag = document.createDocumentFragment();
      for (const c2 of collectDesignColors().slice(0, 14)) {
        const sw = document.createElement("button");
        sw.type = "button";
        sw.className = "nsv2-swatch";
        sw.dataset.c = c2;
        sw.style.background = c2;
        frag.appendChild(sw);
      }
      ui2.fxDesignGrid.replaceChildren(frag);
      ui2.fxDesignLabel.hidden = ui2.fxDesignGrid.hidden = !ui2.fxDesignGrid.childElementCount;
      const cur = fxColorTarget === 2 ? t2.__fxEcho2 : t2.__effectColor;
      markFxPopActive(cur);
      if (cur) ui2.fxPopCurrent.style.background = cur;
      ui2.fxColorPop.hidden = false;
      const r2 = (fxColorTarget === 2 ? ui2.fxColorChip2 : ui2.fxColorChip).getBoundingClientRect();
      const p2 = ui2.fxColorPop;
      const w2 = Math.min(272, window.innerWidth - 16);
      p2.style.width = w2 + "px";
      p2.style.left = Math.max(8, Math.min(r2.right - w2, window.innerWidth - w2 - 8)) + "px";
      const h2 = p2.offsetHeight;
      const below = r2.bottom + 8 + h2 <= window.innerHeight - 8;
      p2.style.top = (below ? r2.bottom + 8 : Math.max(8, r2.top - 8 - h2)) + "px";
      const got = p2.getBoundingClientRect();
      p2.style.left = parseFloat(p2.style.left) - (got.left - parseFloat(p2.style.left)) + "px";
      p2.style.top = parseFloat(p2.style.top) - (got.top - parseFloat(p2.style.top)) + "px";
    }
    function closeFxColorPop() {
      ui2.fxColorPop.hidden = true;
    }
    const chipClick = (target2) => (ev) => {
      const t2 = editor.activeText();
      if (!t2 || !t2.__effect) return;
      fxColorTarget = target2;
      const cur = target2 === 2 ? t2.__fxEcho2 : t2.__effectColor;
      cpick.open({
        anchor: ev.currentTarget,
        value: /^#[0-9a-f]{6}$/i.test(cur || "") ? cur : "#000000",
        designColors: collectDesignColors(),
        palette: DEFAULT_PALETTE,
        onChange: (hex3) => applyFxColor(hex3)
      });
    };
    ui2.fxColorChip.addEventListener("click", chipClick(1));
    ui2.fxColorChip2.addEventListener("click", chipClick(2));
    listen(document, "pointerdown", (e24) => {
      if (ui2.fxColorPop.hidden) return;
      if (!ui2.fxColorPop.contains(e24.target) && e24.target !== ui2.fxColorChip && e24.target !== ui2.fxColorChip2) closeFxColorPop();
    }, true);
    ui2.fxColorPop.addEventListener("click", (e24) => {
      const sw = e24.target.closest(".nsv2-swatch[data-c]");
      if (sw) applyFxColor(sw.dataset.c);
    });
    ui2.panel.addEventListener("scroll", closeFxColorPop, true);
    listen(window, "resize", closeFxColorPop);
    ui2.fxPopCustom.addEventListener("click", () => ui2.fxColorInput.click());
    ui2.fxColorInput.addEventListener("input", () => applyFxColor(ui2.fxColorInput.value));
    ui2.fxPopDropper.addEventListener("click", async () => {
      try {
        const r2 = await openEyeDropper();
        if (r2 && r2.sRGBHex) applyFxColor(r2.sRGBHex);
      } catch {
      }
    });
    const applyFxSize = (v2) => {
      const n2 = Math.max(0, Math.min(100, parseInt(v2, 10) || 0));
      ui2.fxSize.range.value = String(n2);
      ui2.fxSize.num.value = String(n2);
      for (const x2 of editor.activeTexts()) {
        if (x2.__effect) editor._applyTextEffectTo(x2, x2.__effect, x2.__effectColor || void 0, n2);
      }
    };
    ui2.fxSize.range.addEventListener("input", () => applyFxSize(ui2.fxSize.range.value));
    ui2.fxSize.num.addEventListener("change", () => applyFxSize(ui2.fxSize.num.value));
    const wireFxParam = (row, prop, lo2, hi2) => {
      const apply = (v2) => {
        const n2 = Math.max(lo2, Math.min(hi2, parseInt(v2, 10) || 0));
        row.range.value = String(n2);
        row.num.value = String(n2);
        for (const x2 of editor.activeTexts()) {
          if (!x2.__effect) continue;
          x2[prop] = n2;
          editor._applyTextEffectTo(x2, x2.__effect, x2.__effectColor || void 0);
        }
      };
      row.range.addEventListener("input", () => apply(row.range.value));
      row.num.addEventListener("change", () => apply(row.num.value));
    };
    wireFxParam(ui2.fxDir, "__fxDirection", -180, 180);
    wireFxParam(ui2.fxOff, "__fxOffset", 0, 100);
    wireFxParam(ui2.fxBlur, "__fxBlur", 0, 100);
    wireFxParam(ui2.fxTransp, "__fxTransparency", 0, 100);
    wireFxParam(ui2.fxRound, "__fxRound", 0, 100);
    wireFxParam(ui2.fxSpread, "__fxSpread", 0, 100);
    let currentShapeKind = "none";
    ui2.shapeTiles.addEventListener("click", (e24) => {
      const tile = e24.target.closest(".nsv2-fx-tile");
      if (!tile) return;
      currentShapeKind = tile.dataset.shape;
      const cur = parseInt(ui2.fxCurveRange.value, 10) || 0;
      editor.setShape(currentShapeKind, currentShapeKind === "none" ? 0 : cur || 50);
      if (currentShapeKind !== "none") track("shape_apply");
      syncFxPane();
    });
    const applyShapeFromUi = (v2, preview) => {
      const n2 = Math.max(-100, Math.min(100, parseInt(v2, 10) || 0));
      ui2.fxCurveRange.value = String(n2);
      ui2.fxCurveVal.value = String(n2);
      if (currentShapeKind !== "none") editor.setShape(currentShapeKind, n2, !!preview);
    };
    ui2.fxCurveRange.addEventListener("input", () => applyShapeFromUi(ui2.fxCurveRange.value, true));
    ui2.fxCurveRange.addEventListener("change", () => applyShapeFromUi(ui2.fxCurveRange.value));
    ui2.fxCurveVal.addEventListener("change", () => applyShapeFromUi(ui2.fxCurveVal.value));
    let bgrObject = null;
    function liveBgrObject() {
      if (!bgrObject) return null;
      const objs = editor.canvas.getObjects();
      if (objs.includes(bgrObject)) return bgrObject;
      const want = bgrObject.__bgr && bgrObject.__bgr.imgixUrl;
      const imgs = objs.filter((o2) => o2.isType && o2.isType("image"));
      bgrObject = imgs.find((o2) => want && o2.__bgr && o2.__bgr.imgixUrl === want) || (imgs.length === 1 ? imgs[0] : null);
      return bgrObject;
    }
    let paneBeforeBgr = null;
    function closeBgr() {
      bgrObject = null;
      openPane(paneBeforeBgr === "bgr" ? null : paneBeforeBgr || null);
    }
    function makeTile(key, label) {
      const tile = document.createElement("button");
      tile.type = "button";
      tile.className = "nsv2-fx-tile nsv2-bgr-tile is-loading";
      tile.dataset.model = key;
      tile.innerHTML = '<span class="nsv2-fx-box"><span class="nsv2-bgr-spin"></span><img alt="" hidden>' + (key === "original" ? "" : '<span class="nsv2-fx-adjust">' + icons.sliders + "</span>") + // mobile two-step badge (filters)
      '</span><span class="nsv2-fx-label">' + label + "</span>";
      return tile;
    }
    function markBgrTiles() {
      const chosen = bgrObject && bgrObject.__bgr && bgrObject.__bgr.model || "original";
      ui2.bgrTiles.querySelectorAll(".nsv2-bgr-tile").forEach((tl) => {
        tl.classList.toggle("is-active", tl.dataset.model === chosen);
      });
    }
    function tileReady(tile, url) {
      const img = tile.querySelector("img");
      img.src = url;
      img.hidden = false;
      tile.classList.remove("is-loading");
    }
    function openBgr(im) {
      if (activePane !== "bgr") paneBeforeBgr = activePane;
      bgrObject = im;
      openPane("bgr");
      const bgr = im.__bgr;
      ui2.bgrTiles.innerHTML = "";
      const original = makeTile("original", "Original");
      tileReady(original, im.__originalSrc);
      ui2.bgrTiles.appendChild(original);
      for (const m of BGR_MODELS) {
        if (m.lambda && bgr.isVector) continue;
        const tile = makeTile(m.key, m.label);
        ui2.bgrTiles.appendChild(tile);
        const validated = im.__bgrValidated = im.__bgrValidated || {};
        const cached = bgr.versions[m.key];
        const resolve = cached && validated[m.key] === cached ? Promise.resolve(cached) : (cached ? Promise.resolve(cached) : m.lambda ? gramPreview(bgr.imgixUrl).then((url) => loadImageWithRetry(url)).then(rejectEmptyRemoval) : loadImageWithRetry(candidateUrl(bgr.imgixUrl, m, DISPLAY_W, !!im.__trimmed))).then((url) => rejectMisframedRender(url, im.__originalSrc));
        resolve.then((url) => {
          bgr.versions[m.key] = url;
          validated[m.key] = url;
          if (bgrObject !== im || activePane !== "bgr") return;
          tileReady(tile, url);
          markBgrTiles();
        }).catch((err) => {
          console.warn("studio-v2: bgr option failed", m.key, err);
          tile.remove();
          if (/misframed/.test(String(err && err.message))) {
            delete bgr.versions[m.key];
            if (bgr.model === m.key) bgr.model = null;
          }
        });
      }
      markBgrTiles();
    }
    ui2.removeBgBtn.addEventListener("click", () => {
      const im = editor.activeImage();
      if (!im || !im.__bgr || im.__bgr.status !== "ready") return;
      activePane === "bgr" ? closeBgr() : openBgr(im);
    });
    ui2.bgrBackBtn.addEventListener("click", closeBgr);
    async function rejectMisframedRender(url, refSrc) {
      try {
        if (!refSrc) return url;
        const load = (src) => new Promise((res, rej) => {
          const im = new Image();
          im.crossOrigin = "anonymous";
          im.onload = () => res(im);
          im.onerror = rej;
          im.src = src;
        });
        const [cand, ref] = await Promise.all([load(url), load(refSrc)]);
        const S2 = 220;
        const draw = (im) => {
          const c2 = document.createElement("canvas");
          c2.width = S2;
          c2.height = S2;
          const x2 = c2.getContext("2d", { willReadFrequently: true });
          const s3 = Math.min(S2 / (im.naturalWidth || 1), S2 / (im.naturalHeight || 1));
          const w2 = Math.round((im.naturalWidth || 1) * s3);
          const h2 = Math.round((im.naturalHeight || 1) * s3);
          x2.drawImage(im, Math.floor((S2 - w2) / 2), Math.floor((S2 - h2) / 2), w2, h2);
          return x2.getImageData(0, 0, S2, S2).data;
        };
        const a2 = draw(cand);
        const b2 = draw(ref);
        let n2 = 0;
        let match = 0;
        for (let i2 = 0; i2 < a2.length; i2 += 4) {
          if (a2[i2 + 3] < 230) continue;
          n2++;
          if (b2[i2 + 3] > 40 && Math.abs(a2[i2] - b2[i2]) < 56 && Math.abs(a2[i2 + 1] - b2[i2 + 1]) < 56 && Math.abs(a2[i2 + 2] - b2[i2 + 2]) < 56)
            match++;
        }
        if (n2 < 400) return url;
        if (match / n2 < 0.8) throw new Error("misframed render (grid parity: color)");
        const lum = (d2) => {
          const out = new Float32Array(S2 * S2);
          for (let i2 = 0; i2 < S2 * S2; i2++) {
            const o2 = i2 * 4;
            out[i2] = (0.3 * d2[o2] + 0.59 * d2[o2 + 1] + 0.11 * d2[o2 + 2]) * (d2[o2 + 3] / 255);
          }
          return out;
        };
        const edges = (d2) => {
          const l2 = lum(d2);
          const e24 = new Uint8Array(S2 * S2);
          for (let y2 = 1; y2 < S2 - 1; y2++)
            for (let x2 = 1; x2 < S2 - 1; x2++) {
              const i2 = y2 * S2 + x2;
              if (Math.abs(l2[i2 + 1] - l2[i2 - 1]) + Math.abs(l2[i2 + S2] - l2[i2 - S2]) > 60) e24[i2] = 1;
            }
          return e24;
        };
        const ce2 = edges(a2);
        const reEdge = edges(b2);
        const reDil = new Uint8Array(S2 * S2);
        for (let y2 = 0; y2 < S2; y2++)
          for (let x2 = 0; x2 < S2; x2++) {
            if (!reEdge[y2 * S2 + x2]) continue;
            for (let dy = -2; dy <= 2; dy++)
              for (let dx = -2; dx <= 2; dx++) {
                const ny = y2 + dy;
                const nx = x2 + dx;
                if (ny >= 0 && ny < S2 && nx >= 0 && nx < S2) reDil[ny * S2 + nx] = 1;
              }
          }
        let en2 = 0;
        let ehit = 0;
        for (let i2 = 0; i2 < S2 * S2; i2++) if (ce2[i2]) {
          en2++;
          if (reDil[i2]) ehit++;
        }
        if (en2 >= 300 && ehit / en2 < 0.85) throw new Error("misframed render (grid parity: edges)");
        return url;
      } catch (e24) {
        if (e24 && /misframed/.test(String(e24.message))) throw e24;
        return url;
      }
    }
    async function rejectEmptyRemoval(url) {
      try {
        const img = new Image();
        img.crossOrigin = "anonymous";
        await new Promise((res, rej) => {
          img.onload = res;
          img.onerror = rej;
          img.src = url + (url.includes("?") ? "&" : "?") + "w=160";
        });
        const cv2 = document.createElement("canvas");
        cv2.width = img.naturalWidth || 1;
        cv2.height = img.naturalHeight || 1;
        const cx = cv2.getContext("2d");
        cx.drawImage(img, 0, 0);
        const d2 = cx.getImageData(0, 0, cv2.width, cv2.height).data;
        for (let i2 = 3; i2 < d2.length; i2 += 4) if (d2[i2] > 8) return url;
        throw new Error("empty removal (no ink)");
      } catch (e24) {
        if (e24 && /empty removal/.test(String(e24.message))) throw e24;
        return url;
      }
    }
    async function applyBgrModel(im, key) {
      im.__bgr.model = key === "original" || !key ? null : key;
      await withObjBusy(im, () => editor.replaceImageSource(im, composedSrc(im)));
      editor.shrinkWrapWindow(im);
      if (im.__bgr.model) {
        addRecentUpload(im.__bgr.imgixUrl, im.__bgr.fileName, {
          model: im.__bgr.model,
          url: im.__bgr.versions[im.__bgr.model]
        });
      }
      editor.canvas.requestRenderAll();
      refreshChatBase(im);
    }
    ui2.bgrTiles.addEventListener("click", async (e24) => {
      const tile = e24.target.closest(".nsv2-bgr-tile");
      if (!tile || tile.classList.contains("is-loading") || !bgrObject) return;
      const im = liveBgrObject();
      const key = tile.dataset.model;
      if (key !== "original" && !im.__bgr.versions[key]) return;
      await applyBgrModel(im, key);
      markBgrTiles();
    });
    function composedSrc(im) {
      const bgr = im.__bgr;
      let base;
      if (bgr && bgr.model) base = bgr.versions[bgr.model];
      else base = im.__originalSrc;
      if (im.__superRes && bgr && bgr.status === "ready") {
        if (base === im.__originalSrc && /^(blob|data):/.test(String(base))) base = hostedDisplayUrl(bgr.imgixUrl);
        if (!/^(blob|data):/.test(String(base))) base = base + (base.indexOf("?") > -1 ? "&" : "?") + "upscale=true";
      }
      return base;
    }
    editor.printSourceFor = (im) => {
      const display = composedSrc(im);
      const print = printVariant(display);
      return print === display ? null : { print, display };
    };
    async function normalizeLegacyFilter(im) {
      await withObjBusy(im, () => editor.replaceImageSource(im, composedSrc(im)));
    }
    let filterObject = null;
    let paneBeforeFilters = null;
    const filterSteps = twoStepSheet({
      pane: ui2.filtersPane,
      tiles: ui2.filterTiles,
      title: ui2.filtersTitle,
      defaultTitle: "Filters",
      adjustable: (tile) => tile.dataset.model !== "original"
      // Original has no Intensity
    });
    function closeFilters() {
      filterSteps.reset();
      filterObject = null;
      openPane(paneBeforeFilters === "filters" ? null : paneBeforeFilters || null);
    }
    function markFilterTiles() {
      const chosen = filterObject && filterObject.__filter || "original";
      ui2.filterTiles.querySelectorAll(".nsv2-bgr-tile").forEach((tl) => {
        tl.classList.toggle("is-active", tl.dataset.model === chosen);
      });
    }
    const ADJ_ROWS = [
      ["temp", "adjTemp"],
      ["tint", "adjTint"],
      ["bri", "adjBri"],
      ["con", "adjCon"],
      ["hi", "adjHi"],
      ["sh", "adjSh"],
      ["wh", "adjWh"],
      ["bl", "adjBl"],
      ["vib", "adjVib"],
      ["sat", "adjSat"],
      ["hue", "adjHue"],
      ["sharp", "adjSharp"],
      ["clar", "adjClar"],
      ["vig", "adjVig"],
      ["blur", "adjBlur"],
      ["noise", "adjNoise"],
      ["pix", "adjPix"]
    ];
    const ADJ_ON_RELEASE = { blur: true, vig: true };
    function syncAdjustUI(im) {
      const a2 = im && im.__adjust || {};
      for (const [key, ref] of ADJ_ROWS) {
        const v2 = a2[key] || 0;
        ui2[ref].range.value = String(v2);
        ui2[ref].num.value = String(v2);
      }
      ui2.adjInvert.classList.toggle("is-on", !!a2.invert);
      ui2.adjInvert.setAttribute("aria-pressed", String(!!a2.invert));
    }
    function collectAdjust() {
      const a2 = { invert: ui2.adjInvert.classList.contains("is-on") };
      for (const [key, ref] of ADJ_ROWS) a2[key] = Math.round(parseFloat(ui2[ref].range.value) || 0);
      return a2;
    }
    for (const [key, ref] of ADJ_ROWS) {
      const live = !ADJ_ON_RELEASE[key];
      ui2[ref].range.addEventListener("input", () => {
        ui2[ref].num.value = ui2[ref].range.value;
        if (!live) return;
        const im = editor.activeImage();
        if (im) editor.setImageAdjust(im, collectAdjust());
      });
      if (!live) {
        ui2[ref].range.addEventListener("change", () => {
          const im = editor.activeImage();
          if (im) editor.setImageAdjust(im, collectAdjust());
        });
      }
      ui2[ref].num.addEventListener("change", () => {
        ui2[ref].range.value = String(parseFloat(ui2[ref].num.value) || 0);
        const im = editor.activeImage();
        if (im) editor.setImageAdjust(im, collectAdjust());
      });
    }
    ui2.adjInvert.addEventListener("click", () => {
      const im = editor.activeImage();
      if (!im) return;
      ui2.adjInvert.classList.toggle("is-on");
      ui2.adjInvert.setAttribute("aria-pressed", String(ui2.adjInvert.classList.contains("is-on")));
      editor.setImageAdjust(im, collectAdjust());
    });
    ui2.adjReset.addEventListener("click", () => {
      const im = editor.activeImage();
      if (!im) return;
      editor.setImageAdjust(im, null);
      syncAdjustUI(im);
    });
    {
      const ADJ_PARAMS = [
        ["Temperature", ui2.adjTemp.wrap],
        ["Tint", ui2.adjTint.wrap],
        ["Brightness", ui2.adjBri.wrap],
        ["Contrast", ui2.adjCon.wrap],
        ["Highlights", ui2.adjHi.wrap],
        ["Shadows", ui2.adjSh.wrap],
        ["Whites", ui2.adjWh.wrap],
        ["Blacks", ui2.adjBl.wrap],
        ["Vibrance", ui2.adjVib.wrap],
        ["Saturation", ui2.adjSat.wrap],
        ["Hue", ui2.adjHue.wrap],
        ["Sharpness", ui2.adjSharp.wrap],
        ["Clarity", ui2.adjClar.wrap],
        ["Vignette", ui2.adjVig.wrap],
        ["Blur", ui2.adjBlur.wrap],
        ["Noise", ui2.adjNoise.wrap],
        ["Pixelate", ui2.adjPix.wrap],
        ["Invert", ui2.adjustPane.querySelector(".nsv2-adj-invert")]
      ];
      const pills = document.createElement("div");
      pills.className = "nsv2-adj-pills";
      const setActive = (label) => {
        for (const [lab, wrap] of ADJ_PARAMS) wrap.classList.toggle("is-adj-active", lab === label);
        for (const p2 of pills.children) p2.classList.toggle("is-active", p2.textContent === label);
      };
      for (const [label] of ADJ_PARAMS) {
        const p2 = document.createElement("button");
        p2.type = "button";
        p2.className = "nsv2-fpill";
        p2.textContent = label;
        p2.addEventListener("click", () => setActive(label));
        pills.appendChild(p2);
      }
      ui2.adjustPane.insertBefore(pills, ui2.adjReset);
      setActive("Temperature");
    }
    let paneBeforeAdjust = null;
    function closeAdjust() {
      openPane(paneBeforeAdjust === "adjust" ? null : paneBeforeAdjust || null);
    }
    ui2.adjustBtn.addEventListener("click", () => {
      if (activePane === "adjust") return closeAdjust();
      const im = editor.activeImage();
      if (!im) return;
      paneBeforeAdjust = activePane;
      syncAdjustUI(im);
      openPane("adjust");
    });
    ui2.adjustBackBtn.addEventListener("click", closeAdjust);
    ui2.outlineBackBtn.addEventListener("click", () => openPane(null));
    function syncUpscaleUI(im) {
      const on2 = !!(im && im.__superRes);
      ui2.upscaleBtn.classList.toggle("is-on", on2);
      ui2.upscaleBtn.setAttribute("aria-pressed", String(on2));
    }
    ui2.upscaleBtn.addEventListener("click", async () => {
      const im = editor.activeImage();
      if (!im || !im.__bgr || im.__bgr.status !== "ready") return;
      im.__superRes = !im.__superRes;
      refreshChatBase(im);
      syncUpscaleUI(im);
      await withObjBusy(im, () => editor.replaceImageSource(im, composedSrc(im)));
    });
    function openFilters(im) {
      if (activePane !== "filters") paneBeforeFilters = activePane;
      filterObject = im;
      filterSteps.reset();
      syncFilterStrengthUI(im);
      syncUpscaleUI(im);
      openPane("filters");
      ui2.filterTiles.innerHTML = "";
      const thumb = editor.filterThumbCanvas(im, 320);
      for (const f2 of FILTERS) {
        const tile = makeTile(f2.key, f2.label);
        ui2.filterTiles.appendChild(tile);
        try {
          const c2 = f2.params ? applyPresetToCanvas(thumb, f2.params, 100) : thumb;
          tileReady(tile, c2.toDataURL());
        } catch (err) {
          console.warn("studio-v2: filter tile failed", f2.key, err);
          tile.remove();
        }
      }
      markFilterTiles();
    }
    const DEFAULT_PALETTE = [
      "#000000",
      "#545454",
      "#737373",
      "#a6a6a6",
      "#d9d9d9",
      "#f2f2f2",
      "#ffffff",
      "#ff0000",
      "#ff3131",
      "#ff5757",
      "#ff66c4",
      "#cb6ce6",
      "#8c52ff",
      "#5e17eb",
      "#00c2cb",
      "#0cc0df",
      "#5ce1e6",
      "#38b6ff",
      "#5271ff",
      "#004aad",
      "#0a1172",
      "#00bf63",
      "#7ed957",
      "#c1ff72",
      "#ffde59",
      "#ffbd59",
      "#ff914d",
      "#ff751f"
    ];
    function paletteSwatch(c2) {
      const sw = document.createElement("button");
      sw.type = "button";
      sw.className = "nsv2-swatch";
      sw.dataset.c = c2;
      sw.style.background = c2;
      sw.title = c2;
      return sw;
    }
    for (const c2 of DEFAULT_PALETTE) ui2.recolorGrid.appendChild(paletteSwatch(c2));
    ui2.filtersBtn.addEventListener("click", () => {
      const im = editor.activeImage();
      if (!im || !im.__bgr || im.__bgr.status !== "ready") return;
      activePane === "filters" ? closeFilters() : openFilters(im);
    });
    ui2.filtersBackBtn.addEventListener("click", () => {
      if (filterSteps.back()) return syncFilterStrengthUI(filterObject);
      closeFilters();
    });
    function placeControls(grid, controls, tileSel, activeSel) {
      if (isMobileView()) {
        if (!grid.querySelector(tileSel + activeSel)) return false;
        if (controls.previousElementSibling !== grid) grid.after(controls);
        return true;
      }
      return placeAfterRow(grid, controls, tileSel, activeSel);
    }
    function placeAfterRow(grid, controls, tileSel, activeSel) {
      const tiles = [...grid.querySelectorAll(tileSel)];
      const idx = tiles.findIndex((tl) => tl.matches(activeSel));
      if (idx < 0) return false;
      const cols = (getComputedStyle(grid).gridTemplateColumns || "").split(" ").length || 1;
      const rowEnd = tiles[Math.min(tiles.length - 1, Math.floor(idx / cols) * cols + (cols - 1))];
      if (controls.previousElementSibling !== rowEnd) rowEnd.after(controls);
      return true;
    }
    function syncFilterStrengthUI(im) {
      const active = im && im.__filter;
      const placed = !!active && placeControls(ui2.filterTiles, ui2.filterCtrls, ".nsv2-bgr-tile", '[data-model="' + (im && im.__filter) + '"]');
      ui2.filterCtrls.hidden = !placed || !filterSteps.sync(!!active);
      const v2 = im && im.__filterStrength != null ? im.__filterStrength : 100;
      ui2.filterStrength.range.value = String(v2);
      ui2.filterStrength.num.value = String(v2);
      const duo = active === "duotone";
      ui2.filterDuoRow.hidden = !duo;
      if (duo) {
        const c2 = im && im.__filterColors || { a: "#003087", b: "#00c5ff" };
        ui2.duoShadow.dataset.c = c2.a;
        ui2.duoShadow.style.background = c2.a;
        ui2.duoHighlight.dataset.c = c2.b;
        ui2.duoHighlight.style.background = c2.b;
      }
    }
    function applyDuoColors() {
      const im = filterObject;
      if (!im || im.__filter !== "duotone") return;
      im.__filterColors = { a: ui2.duoShadow.dataset.c, b: ui2.duoHighlight.dataset.c };
      im.__filterCS = true;
      editor.restageImage(im);
    }
    const duoChipClick = (chip) => () => {
      cpick.open({
        anchor: chip,
        value: chip.dataset.c,
        designColors: collectDesignColors(),
        palette: DEFAULT_PALETTE,
        onChange: (hex3) => {
          chip.dataset.c = hex3;
          chip.style.background = hex3;
          applyDuoColors();
        }
      });
    };
    ui2.duoShadow.addEventListener("click", duoChipClick(ui2.duoShadow));
    ui2.duoHighlight.addEventListener("click", duoChipClick(ui2.duoHighlight));
    function applyFilterStrength(v2) {
      const im = filterObject;
      if (!im || !im.__filter) return;
      im.__filterStrength = Math.max(0, Math.min(100, Math.round(v2)));
      editor.restageImage(im);
    }
    ui2.filterStrength.range.addEventListener("input", () => {
      ui2.filterStrength.num.value = ui2.filterStrength.range.value;
      applyFilterStrength(parseFloat(ui2.filterStrength.range.value));
    });
    ui2.filterStrength.num.addEventListener("change", () => {
      applyFilterStrength(parseFloat(ui2.filterStrength.num.value) || 100);
      syncFilterStrengthUI(filterObject);
    });
    ui2.filterTiles.addEventListener("click", async (e24) => {
      const tile = e24.target.closest(".nsv2-bgr-tile");
      if (!tile || tile.classList.contains("is-loading") || !filterObject) return;
      if (filterSteps.tap(tile)) return syncFilterStrengthUI(filterObject);
      const im = filterObject;
      const key = tile.dataset.model;
      const legacy = im.__filter && !im.__filterCS;
      im.__filter = key === "original" ? null : key;
      im.__filterStrength = 100;
      im.__filterCS = true;
      syncFilterStrengthUI(im);
      if (legacy) await normalizeLegacyFilter(im);
      else editor.restageImage(im);
      markFilterTiles();
    });
    let recolorObject = null;
    function liveRecolorObject() {
      if (!recolorObject) return null;
      const objs = editor.canvas.getObjects();
      if (objs.includes(recolorObject)) return recolorObject;
      const want = recolorObject.__bgr && recolorObject.__bgr.imgixUrl;
      const imgs = objs.filter((o2) => o2.isType && o2.isType("image"));
      recolorObject = imgs.find((o2) => want && o2.__bgr && o2.__bgr.imgixUrl === want) || (imgs.length === 1 ? imgs[0] : null);
      return recolorObject;
    }
    let paneBeforeRecolor = null;
    let recolorSwatches = [];
    let recolorSelected = null;
    function closeRecolor() {
      recolorObject = null;
      openPane(paneBeforeRecolor === "recolor" ? null : paneBeforeRecolor || null);
    }
    function recolorReplFor(im) {
      return (im.__recolorRepl || []).slice();
    }
    function markRecolorUI() {
      const im = liveRecolorObject();
      const repl = im ? recolorReplFor(im) : [];
      ui2.recolorSrcRow.querySelectorAll(".nsv2-swatch").forEach((sw) => {
        sw.classList.toggle("is-active", sw.dataset.c === recolorSelected);
        try {
          const r2 = (Array.isArray(repl) ? repl : []).find((x2) => x2 && x2.targetColor === sw.dataset.c) || null;
          if (r2 && r2.mode === "transparent") {
            sw.classList.add("nsv2-swatch--transparent");
            sw.style.background = "";
          } else {
            sw.classList.remove("nsv2-swatch--transparent");
            sw.style.background = r2 && r2.mode === "recolor" && r2.newColor || sw.dataset.c;
          }
          sw.classList.toggle("is-replaced", !!r2);
        } catch (e24) {
        }
      });
      const cur = repl.find((r2) => r2.targetColor === recolorSelected) || null;
      ui2.recolorToLabel.textContent = recolorSelected ? "Change " + nearestColorName(recolorSelected) + " to" : "Change to";
      const curHex = cur && cur.mode === "recolor" && cur.newColor ? cur.newColor.toLowerCase() : null;
      for (const grid of [ui2.recolorGrid, ui2.recolorAllGrid, ui2.recolorDesignGrid]) {
        grid.querySelectorAll(".nsv2-swatch").forEach((sw) => {
          const swHex = (cssToSolidHex(sw.dataset.c || "") || "").toLowerCase();
          sw.classList.toggle("is-active", !!curHex && swHex === curHex);
        });
      }
      ui2.recolorTransparent.classList.toggle("is-active", !!cur && cur.mode === "transparent");
      if (cur && cur.mode === "transparent") {
        ui2.recolorCurrent.className = "nsv2-swatch nsv2-swatch--transparent is-active";
        ui2.recolorCurrent.style.background = "";
      } else {
        ui2.recolorCurrent.className = "nsv2-swatch is-active";
        ui2.recolorCurrent.style.background = curHex || recolorSelected || "#ffffff";
      }
    }
    function renderRecolorDesignColors() {
      const frag = document.createDocumentFragment();
      for (const c2 of collectDesignColors().slice(0, 14)) {
        const sw = document.createElement("button");
        sw.type = "button";
        sw.className = "nsv2-swatch";
        sw.dataset.c = c2;
        sw.style.background = c2;
        frag.appendChild(sw);
      }
      ui2.recolorDesignGrid.replaceChildren(frag);
      ui2.recolorDesignLabel.hidden = ui2.recolorDesignGrid.hidden = !frag.childElementCount && true;
      ui2.recolorDesignLabel.hidden = ui2.recolorDesignGrid.hidden = ui2.recolorDesignGrid.childElementCount === 0;
    }
    function renderRecolorSources() {
      ui2.recolorSrcRow.innerHTML = "";
      for (const s3 of recolorSwatches) {
        const sw = document.createElement("button");
        sw.type = "button";
        sw.className = "nsv2-swatch";
        sw.dataset.c = s3.hex.toLowerCase();
        sw.style.background = s3.hex;
        sw.title = nearestColorName(s3.hex) + " \xB7 " + s3.coveragePercent + "%";
        ui2.recolorSrcRow.appendChild(sw);
      }
      markRecolorUI();
    }
    function openRecolor(im) {
      if (activePane !== "recolor") paneBeforeRecolor = activePane;
      recolorObject = im;
      openPane("recolor");
      recolorSwatches = detectImageColors(editor.recolorBaseElement(im));
      recolorSelected = recolorSwatches.length ? recolorSwatches[0].hex.toLowerCase() : null;
      renderRecolorDesignColors();
      renderRecolorSources();
    }
    ui2.colorReplaceBtn.addEventListener("click", () => {
      const im = editor.activeImage();
      if (!im) return;
      activePane === "recolor" ? closeRecolor() : openRecolor(im);
    });
    ui2.recolorBackBtn.addEventListener("click", closeRecolor);
    ui2.recolorSrcRow.addEventListener("click", (e24) => {
      const sw = e24.target.closest(".nsv2-swatch");
      if (!sw) return;
      recolorSelected = sw.dataset.c;
      markRecolorUI();
    });
    async function applyRecolorChoice(mode2, newColor) {
      const im = liveRecolorObject();
      if (!im || !recolorSelected) return;
      const repl = recolorReplFor(im).filter((r2) => r2.targetColor !== recolorSelected);
      const cur = recolorReplFor(im).find((r2) => r2.targetColor === recolorSelected);
      const same = cur && (mode2 === "transparent" ? cur.mode === "transparent" : cur.mode === "recolor" && cur.newColor === newColor);
      if (!same) {
        repl.push(
          mode2 === "transparent" ? { targetColor: recolorSelected, mode: "transparent" } : { targetColor: recolorSelected, mode: "recolor", newColor }
        );
      }
      const palette = recolorSwatches.map((s3) => s3.hex);
      await withObjBusy(im, async () => editor.setImageRecolor(im, repl, palette));
      markRecolorUI();
    }
    const recolorSwatchClick = (e24) => {
      const sw = e24.target.closest(".nsv2-swatch");
      if (!sw || !sw.dataset.c) return;
      const hex3 = cssToSolidHex(sw.dataset.c);
      if (hex3) applyRecolorChoice("recolor", hex3.toLowerCase());
    };
    ui2.recolorGrid.addEventListener("click", recolorSwatchClick);
    ui2.recolorAllGrid.addEventListener("click", recolorSwatchClick);
    ui2.recolorDesignGrid.addEventListener("click", recolorSwatchClick);
    ui2.recolorTransparent.addEventListener("click", () => applyRecolorChoice("transparent"));
    ui2.recolorCustomBtn.addEventListener("click", () => ui2.recolorCustomInput.click());
    ui2.recolorSeeAll.addEventListener("click", () => {
      const showAll = ui2.recolorAllGrid.hidden;
      if (showAll && !ui2.recolorAllGrid.childElementCount) fillGradedPalette(ui2.recolorAllGrid);
      ui2.recolorAllGrid.hidden = !showAll;
      ui2.recolorGrid.hidden = showAll;
      ui2.recolorSeeAll.textContent = showAll ? "Show less" : "See all";
      markRecolorUI();
    });
    ui2.recolorDropperBtn.addEventListener("click", async () => {
      try {
        const r2 = await openEyeDropper();
        const hex3 = r2 && r2.sRGBHex ? cssToSolidHex(r2.sRGBHex) : null;
        if (hex3) applyRecolorChoice("recolor", hex3.toLowerCase());
      } catch (_2) {
      }
    });
    ui2.recolorCustomInput.addEventListener("input", () => {
      applyRecolorChoice("recolor", ui2.recolorCustomInput.value.toLowerCase());
    });
    ui2.recolorResetBtn.addEventListener("click", async () => {
      const im = liveRecolorObject();
      if (!im) return;
      await withObjBusy(im, async () => editor.setImageRecolor(im, null));
      markRecolorUI();
    });
    function nudgeActive(dx, dy, commit) {
      const active = editor.canvas.getActiveObject();
      if (!active || active.__locked) return false;
      active.set({ left: active.left + dx, top: active.top + dy });
      active.setCoords();
      editor.canvas.requestRenderAll();
      if (commit) editor.canvas.fire("object:modified", { target: active });
      else ui2.qa.hidden = true;
      return true;
    }
    ui2.nudgeChip.addEventListener("click", () => openPane(activePane === "nudge" ? null : "nudge"));
    {
      const DIR = { up: [0, -1], down: [0, 1], left: [-1, 0], right: [1, 0] };
      const STEP = 5, HOLD_MS = 90;
      let holdT = 0, repeatT = 0, moved = false;
      const stop = () => {
        clearTimeout(holdT);
        clearInterval(repeatT);
        holdT = 0;
        repeatT = 0;
        if (moved) {
          moved = false;
          const a2 = editor.canvas.getActiveObject();
          if (a2) editor.canvas.fire("object:modified", { target: a2 });
        }
      };
      Object.entries(ui2.nudgeBtns).forEach(([dir, b2]) => {
        const [dx, dy] = DIR[dir];
        b2.addEventListener("pointerdown", (e24) => {
          e24.preventDefault();
          stop();
          nudgeActive(dx * STEP, dy * STEP, true);
          holdT = setTimeout(() => {
            repeatT = setInterval(() => {
              if (nudgeActive(dx * STEP, dy * STEP, false)) moved = true;
              else stop();
            }, HOLD_MS);
          }, 350);
        });
        ["pointerup", "pointercancel", "pointerleave"].forEach((ev) => b2.addEventListener(ev, stop));
        b2.addEventListener("contextmenu", (e24) => e24.preventDefault());
      });
    }
    function hideSpop() {
      ui2.spop.hidden = true;
      ui2.spacingBtn.classList.remove("is-on");
    }
    function syncSpop() {
      const t2 = editor.activeText();
      if (!t2) return;
      ui2.lineSp.wrap.hidden = t2.textLines.length < 2;
      const cs2 = Math.round(t2.charSpacing || 0);
      const lh = Math.round((t2.lineHeight || 1.16) * 100) / 100;
      ui2.letterSp.range.value = String(cs2);
      ui2.letterSp.num.value = String(cs2);
      ui2.lineSp.range.value = String(lh);
      ui2.lineSp.num.value = String(lh);
    }
    ui2.spacingBtn.addEventListener("click", () => {
      if (!ui2.spop.hidden) return hideSpop();
      const t2 = editor.activeText();
      if (!t2) return;
      syncSpop();
      ui2.spop.hidden = false;
      ui2.spacingBtn.classList.add("is-on");
      const br2 = ui2.spacingBtn.getBoundingClientRect();
      const ar2 = ui2.area.getBoundingClientRect();
      const w2 = ui2.spop.offsetWidth;
      const x2 = Math.min(Math.max(8, br2.left - ar2.left - w2 / 2 + br2.width / 2), ui2.area.clientWidth - w2 - 8);
      ui2.spop.style.transform = "translate(" + x2 + "px, " + (br2.bottom - ar2.top + 8) + "px)";
    });
    const applyLetter = (v2) => {
      const n2 = Math.min(800, Math.max(-200, parseFloat(v2) || 0));
      ui2.letterSp.range.value = String(n2);
      ui2.letterSp.num.value = String(n2);
      editor.setTextProp({ charSpacing: n2 });
    };
    const applyLine = (v2) => {
      const n2 = Math.min(2.5, Math.max(0.75, parseFloat(v2) || 1.16));
      ui2.lineSp.range.value = String(n2);
      ui2.lineSp.num.value = String(Math.round(n2 * 100) / 100);
      editor.setTextProp({ lineHeight: n2 });
    };
    ui2.letterSp.range.addEventListener("input", () => applyLetter(ui2.letterSp.range.value));
    ui2.letterSp.num.addEventListener("change", () => applyLetter(ui2.letterSp.num.value));
    ui2.lineSp.range.addEventListener("input", () => applyLine(ui2.lineSp.range.value));
    ui2.lineSp.num.addEventListener("change", () => applyLine(ui2.lineSp.num.value));
    listen(document, "pointerdown", (e24) => {
      if (!ui2.spop.hidden && !ui2.spop.contains(e24.target) && !ui2.spacingBtn.contains(e24.target)) hideSpop();
    });
    let paneBeforeCrop = null;
    function endCropUI() {
      ui2.cropBar.hidden = true;
      if (activePane === "crop") openPane(paneBeforeCrop === "crop" ? null : paneBeforeCrop || null);
    }
    function markCropRatios(key) {
      ui2.cropRatios.querySelectorAll(".nsv2-crop-tile").forEach((tile) => {
        tile.classList.toggle("is-active", tile.dataset.ratio === key);
      });
    }
    let cropRatioKey = "free";
    function cropRatioNumber() {
      if (cropRatioKey === "free") return null;
      if (cropRatioKey === "orig") {
        const im = editor._crop && editor._crop.img;
        const el2 = im && (im._originalElement || im._element);
        return el2 ? (el2.naturalWidth || el2.width) / (el2.naturalHeight || el2.height) : null;
      }
      const [rw, rh] = cropRatioKey.split(":").map(Number);
      return rw / rh;
    }
    ui2.cropBtn.addEventListener("click", () => {
      if (editor._crop) return cancelCrop();
      if (!editor.startCrop()) return;
      ui2.cropBar.hidden = false;
      paneBeforeCrop = activePane;
      openPane("crop");
      cropRatioKey = "free";
      markCropRatios("free");
      ui2.cropRotate.range.value = "0";
      ui2.cropRotate.num.value = "0";
      ui2.cropScale.range.value = "100";
      ui2.cropScale.num.value = "100";
    });
    ui2.smartCropBtn.addEventListener("click", async () => {
      if (!editor._crop || ui2.smartCropBtn.classList.contains("is-busy")) return;
      ui2.smartCropBtn.classList.add("is-busy");
      try {
        await withObjBusy(editor._crop.img, () => editor.smartCrop(cropRatioNumber()));
      } finally {
        ui2.smartCropBtn.classList.remove("is-busy");
      }
    });
    ui2.cropApplyBtn.addEventListener("click", () => {
      editor.applyCrop();
      endCropUI();
      syncSelection();
    });
    const cancelCrop = () => {
      editor.cancelCrop();
      endCropUI();
    };
    ui2.cropCancelBtn.addEventListener("click", cancelCrop);
    ui2.cropBackBtn.addEventListener("click", cancelCrop);
    ui2.revertBtn.addEventListener("click", async () => {
      const im = editor.activeImage();
      if (!im) return;
      await withObjBusy(im, async () => {
        const first = im.__aiEdit && im.__aiEdit.originalUploadReference;
        if (first) {
          const orig = im.__aiEdit.originalUpload || {};
          const fileName = orig.fileName || decodeURIComponent(String(first).split("/").pop().split("?")[0] || "image.png");
          im.__bgr = { status: "ready", imgixUrl: first, fileName, isVector: !!orig.isVector, versions: {}, model: null };
          im.__originalSrc = hostedDisplayUrl(first);
          im.__fileName = fileName;
          im.__aiEdit = null;
        }
        await editor.revertImage();
      });
      syncSelection();
      showToast("Reverted", { label: "Undo", onAction: () => {
        editor.undo();
        syncSelection();
      } });
    });
    ui2.beforeSheetDone = () => {
      if (activePane !== "crop" || !editor._crop) return true;
      editor.applyCrop();
      endCropUI();
      syncSelection();
      return false;
    };
    ui2.beforeSheetClose = () => {
      if (activePane !== "crop" || !editor._crop) return true;
      cancelCrop();
      return false;
    };
    ui2.root.addEventListener(
      "pointerdown",
      (e24) => {
        if (!editor._crop) return;
        const t2 = e24.target;
        if (t2.closest(".nsv2-cropbar")) return;
        if (t2.closest('[data-pane="crop"]')) return;
        if (t2.closest(".nsv2-sheet-done")) return;
        if (ui2.cropBtn.contains(t2)) return;
        if (t2.closest(".nsv2-topbar") || t2.closest(".nsv2-rail") || t2.closest(".nsv2-panel") || t2.closest(".nsv2-ctxbar") || t2.closest(".nsv2-ctx-more-panel")) {
          cancelCrop();
        }
      },
      true
    );
    ui2.cropRatios.addEventListener("click", (e24) => {
      const tile = e24.target.closest(".nsv2-crop-tile");
      if (!tile || !editor._crop) return;
      const key = tile.dataset.ratio;
      cropRatioKey = key;
      markCropRatios(key);
      const { img, rect } = editor._crop;
      if (key === "free") {
        editor._crop.ratioLocked = false;
        cv.requestRenderAll();
        return;
      }
      let ratio;
      if (key === "orig") {
        const el2 = img._originalElement || img._element;
        ratio = (el2.naturalWidth || el2.width) / (el2.naturalHeight || el2.height);
      } else {
        const [rw, rh] = key.split(":").map(Number);
        ratio = rw / rh;
      }
      const maxW = img.getScaledWidth();
      const maxH = img.getScaledHeight();
      let w2 = maxW, h2 = w2 / ratio;
      if (h2 > maxH) {
        h2 = maxH;
        w2 = h2 * ratio;
      }
      rect.set({ scaleX: 1, scaleY: 1, width: w2, height: h2, left: img.left, top: img.top });
      editor._crop.ratioLocked = true;
      rect.setCoords();
      editor._syncCropClip();
      cv.requestRenderAll();
    });
    const applyCropRotate = (v2) => {
      const n2 = Math.min(180, Math.max(-180, parseFloat(v2) || 0));
      ui2.cropRotate.range.value = String(n2);
      ui2.cropRotate.num.value = String(Math.round(n2 * 10) / 10);
      editor.setCropRotation(n2);
    };
    const applyCropScale = (v2) => {
      const n2 = Math.min(300, Math.max(10, parseFloat(v2) || 100));
      ui2.cropScale.range.value = String(n2);
      ui2.cropScale.num.value = String(Math.round(n2));
      editor.setCropScale(n2);
    };
    ui2.cropScale.range.addEventListener("input", () => applyCropScale(ui2.cropScale.range.value));
    ui2.cropScale.num.addEventListener("change", () => applyCropScale(ui2.cropScale.num.value));
    ui2.cropRotate.range.addEventListener("input", () => applyCropRotate(ui2.cropRotate.range.value));
    ui2.cropRotate.num.addEventListener("change", () => applyCropRotate(ui2.cropRotate.num.value));
    ui2.cropRotateReset.addEventListener("click", () => applyCropRotate(0));
    function hideRpop() {
      ui2.rpop.hidden = true;
    }
    const radiusTarget = () => {
      const sh = activeElShape();
      if (sh) return { type: "shape", obj: sh };
      const im = editor.activeImage();
      return im ? { type: "image", obj: im } : null;
    };
    const applyRadius = (v2) => {
      const n2 = Math.min(100, Math.max(0, parseInt(v2, 10) || 0));
      ui2.radiusSp.range.value = String(n2);
      ui2.radiusSp.num.value = String(n2);
      const t2 = radiusTarget();
      if (!t2) return;
      if (t2.type === "shape") editor.setElRound(t2.obj, n2);
      else editor.setImageRadius(n2);
    };
    function openRadiusUI(btn) {
      const t2 = radiusTarget();
      if (!t2) return;
      const cur = t2.type === "shape" ? Math.round(t2.obj.__el.round || 0) : t2.obj.__radius || 0;
      if (isMobileView()) {
        if (mtrayKind === "radius") return closeMtray();
        openMtray("radius", (scroll) => {
          const row = ui2.sliderRow("Corner radius", 0, 100, 1, cur);
          row.range.addEventListener("input", () => {
            applyRadius(row.range.value);
            row.num.value = row.range.value;
          });
          row.num.addEventListener("change", () => {
            applyRadius(row.num.value);
            row.range.value = row.num.value;
          });
          row.wrap.classList.add("nsv2-mtray-sliderrow");
          scroll.appendChild(row.wrap);
        });
        return;
      }
      if (!ui2.rpop.hidden) return hideRpop();
      ui2.radiusSp.range.value = String(cur);
      ui2.radiusSp.num.value = String(cur);
      ui2.rpop.hidden = false;
      placeSpop(ui2.rpop, btn);
    }
    ui2.radiusBtn.addEventListener("click", () => openRadiusUI(ui2.radiusBtn));
    ui2.radiusSp.range.addEventListener("input", () => applyRadius(ui2.radiusSp.range.value));
    ui2.radiusSp.num.addEventListener("change", () => applyRadius(ui2.radiusSp.num.value));
    listen(document, "pointerdown", (e24) => {
      if (!ui2.rpop.hidden && !ui2.rpop.contains(e24.target) && !ui2.radiusBtn.contains(e24.target) && !ui2.elRoundBtn.contains(e24.target)) hideRpop();
    });
    const cpick = buildColorPicker(ui2.root);
    ui2.root.addEventListener("click", (e24) => {
      const input = e24.target.closest('input[type="color"]');
      if (!input) return;
      e24.preventDefault();
      cpick.open({
        anchor: input,
        value: input.value,
        designColors: collectDesignColors(),
        palette: DEFAULT_PALETTE,
        // custom-+ buttons already sit INSIDE a swatch view — go straight to
        // the spectrum; everything else (gradient stops etc.) opens the Canva
        // swatch-first view (Owen 9-09).
        view: input.dataset.spectrumDirect ? "spectrum" : "swatches",
        // Color|Gradient tabs (Owen 9-09 video): text-color custom picks carry
        // the pane's gradient section into the sheet (move-on-open pattern)
        gradient: colorTarget === "text" && input === ui2.customColorInput ? { nodes: [ui2.gradsLabel, ui2.gradGrid, ui2.gradEdit] } : null,
        onChange: (hex3) => {
          input.value = hex3;
          input.dispatchEvent(new Event("input", { bubbles: true }));
        }
      });
    });
    ui2.panel.addEventListener("scroll", () => cpick.close(), true);
    listen(window, "resize", () => cpick.close());
    let chat = null;
    let chatParked = false;
    function chatBaseFor(im) {
      let b2 = composedSrc(im);
      if (/^(blob|data):/.test(String(b2))) b2 = hostedDisplayUrl(im.__bgr.imgixUrl);
      return b2;
    }
    function refreshChatBase(im) {
      if (!chat || chat.mode !== "edit" || chat.im !== im || chat.turns.length) return;
      const b2 = chatBaseFor(im);
      if (b2 === chat.baseUrl) return;
      chat.baseUrl = b2;
      renderThread();
    }
    const createThread = { turns: [], versions: [], sel: -1 };
    let aiTick = null;
    cleanups.push(() => {
      if (aiTick) {
        clearInterval(aiTick);
        aiTick = null;
      }
    });
    let aiBusyT0 = 0;
    function paintHint() {
      const hint = ui2.aiThread.querySelector(".nsv2-ai-busy-hint");
      if (hint && chat) {
        const t2 = chat.turns[chat.turns.length - 1];
        hint.textContent = (chat.mode === "create" && !(t2 && t2.refine) ? "Usually 15\u201325 seconds" : "Usually 10\u201320 seconds") + " \xB7 " + Math.round((Date.now() - aiBusyT0) / 1e3) + "s";
      }
    }
    const msg = (cls, text) => {
      const d2 = document.createElement("div");
      d2.className = "nsv2-ai-msg " + cls + " w3_bg";
      if (text != null) d2.textContent = text;
      return d2;
    };
    const bot = (text) => {
      const d2 = msg("nsv2-ai-bot");
      d2.innerHTML = '<span class="nsv2-ai-avatar">' + icons.ai + '</span><span class="nsv2-ai-bot-txt"></span>';
      d2.querySelector(".nsv2-ai-bot-txt").textContent = text;
      return d2;
    };
    const you = (text) => {
      const d2 = msg("nsv2-ai-you");
      const b2 = document.createElement("span");
      b2.className = "nsv2-ai-you-bubble";
      b2.textContent = text;
      d2.appendChild(b2);
      return d2;
    };
    const skeleton = (n2) => {
      const g2 = msg("nsv2-ai-grid is-" + n2 + " is-skel");
      for (let i2 = 0; i2 < n2; i2++) g2.appendChild(Object.assign(document.createElement("div"), { className: "nsv2-ai-tile is-skeleton" }));
      return g2;
    };
    function aiPill(label, onTap) {
      const b2 = document.createElement("button");
      b2.type = "button";
      b2.className = "nsv2-ai-pill";
      b2.textContent = label;
      b2.addEventListener("click", onTap);
      return b2;
    }
    function aiTile(entry, picked, plain) {
      const b2 = document.createElement("button");
      b2.type = "button";
      b2.className = "nsv2-ai-tile" + (picked ? " is-picked" : "") + (plain ? " is-plain" : "");
      b2.dataset.url = entry.url;
      b2.dataset.name = entry.fileName || "ai-image.png";
      if (entry.prompt) b2.title = entry.prompt;
      const img = document.createElement("img");
      img.src = entry.thumbnailUrl || entry.url;
      img.loading = "lazy";
      img.addEventListener("load", () => {
        const th = ui2.aiThread;
        if (th.scrollHeight - th.scrollTop - th.clientHeight < 160) th.scrollTop = th.scrollHeight;
      });
      b2.appendChild(img);
      return b2;
    }
    function renderThread() {
      if (!chat) return;
      const th = ui2.aiThread;
      th.innerHTML = "";
      if (chat.mode === "edit") {
        th.appendChild(msg("nsv2-pane-label nsv2-ai-cap", "Original"));
        const card = msg("nsv2-ai-img-card is-loading" + (chat.versions.length ? " is-pickable" : "") + (chat.versions.length && chat.sel < 0 ? " is-sel" : ""));
        const img = document.createElement("img");
        img.alt = "";
        img.onload = img.onerror = () => card.classList.remove("is-loading");
        img.src = chat.baseUrl;
        if (img.complete && img.naturalWidth) card.classList.remove("is-loading");
        card.appendChild(img);
        if (chat.versions.length) {
          card.title = "Start the next edit from the original";
          card.addEventListener("click", () => select(-1));
        }
        th.appendChild(card);
        if (!chat.turns.length) {
          th.appendChild(bot("What should change? Tell me, or start with a quick edit."));
          const pills = msg("nsv2-ai-pills");
          AI_EDIT_CHIPS.slice(0, 4).forEach((c2) => pills.appendChild(aiPill(c2, () => send(c2))));
          th.appendChild(pills);
        }
      } else {
        th.appendChild(bot("What should we create? Describe it, or start with one of these."));
        if (!chat.turns.length) {
          const pills = msg("nsv2-ai-pills");
          AI_CREATE_STARTERS.forEach((c2) => pills.appendChild(aiPill(c2, () => send(c2))));
          th.appendChild(pills);
          const hist = aiHistory();
          if (hist.length) {
            th.appendChild(msg("nsv2-pane-label", "Recently generated"));
            const g2 = msg("nsv2-ai-recent");
            hist.slice(0, 12).forEach((r2) => {
              const t2 = aiTile(r2, false, true);
              t2.addEventListener("click", () => adoptResult(r2));
              g2.appendChild(t2);
            });
            th.appendChild(g2);
          }
        }
      }
      chat.turns.forEach((t2, ti2) => {
        th.appendChild(you(t2.prompt));
        if (t2.status === "busy") {
          th.appendChild(skeleton(chat.mode === "create" && !t2.refine ? AI_BATCH : 1));
          const b2 = msg("nsv2-ai-busy");
          b2.innerHTML = '<span class="nsv2-ai-busy-txt"></span><span class="nsv2-ai-busy-hint"></span>';
          b2.querySelector(".nsv2-ai-busy-txt").textContent = chat.mode === "create" && !t2.refine ? "Creating your options\u2026" : "Working on your edit\u2026";
          th.appendChild(b2);
        } else if (t2.status === "stopped") {
          th.appendChild(bot("Stopped."));
        } else if (t2.status === "error") {
          const e24 = msg("nsv2-ai-error", t2.error + " ");
          const again = document.createElement("button");
          again.type = "button";
          again.className = "nsv2-ai-link";
          again.textContent = "Try again";
          again.addEventListener("click", () => send(t2.prompt, { fresh: t2.fresh }));
          e24.appendChild(again);
          th.appendChild(e24);
        } else {
          th.appendChild(bot(chat.mode === "create" ? t2.refine ? "Here\u2019s the refined version." : "Here are a few options. Tap one to pick it." : "Here\u2019s your edit."));
          const g2 = msg("nsv2-ai-grid is-" + Math.min(t2.results.length, 4));
          const v2 = t2.ver != null ? chat.versions[t2.ver] : null;
          const selected = t2.ver != null && t2.ver === chat.sel;
          t2.results.forEach((r2) => {
            const tile = aiTile({ ...r2, prompt: t2.prompt }, selected && !!v2 && v2.url === r2.url, chat.mode === "create" && !t2.refine);
            tile.addEventListener("click", () => pick(t2, r2));
            g2.appendChild(tile);
          });
          th.appendChild(g2);
          const row = msg("nsv2-ai-actions");
          if (selected) {
            const use = document.createElement("button");
            use.type = "button";
            use.className = "nsv2-cta nsv2-ai-use";
            use.innerHTML = "<span></span>";
            use.querySelector("span").textContent = chat.mode === "edit" ? "Apply to image" : "Add to canvas";
            use.addEventListener("click", useVersion);
            row.appendChild(use);
          }
          if (row.childNodes.length) th.appendChild(row);
        }
      });
      paintHint();
      renderBasis();
      const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      th.scrollTo({ top: th.scrollHeight, behavior: reduce ? "auto" : "smooth" });
    }
    function setPlaceholder() {
      if (!chat) return;
      ui2.aiInput.placeholder = chat.mode === "edit" ? "Describe what you want to change" : chat.sel >= 0 ? "Describe a change\u2026" : "Describe the art you want";
    }
    function renderBasis() {
      if (!chat) return;
      const el2 = ui2.aiBasis;
      el2.innerHTML = "";
      const n2 = chat.versions.length;
      const show = chat.mode === "edit" ? n2 > 0 : chat.sel >= 0;
      el2.hidden = !show;
      setPlaceholder();
      if (!show) return;
      const v2 = chat.sel >= 0 ? chat.versions[chat.sel] : null;
      const thumb = document.createElement("img");
      thumb.alt = "";
      thumb.src = v2 ? v2.url : chat.baseUrl;
      const txt = document.createElement("div");
      txt.className = "nsv2-ai-ctx-txt";
      txt.innerHTML = "<b></b><span></span>";
      txt.querySelector("b").textContent = chat.mode === "edit" ? v2 ? "Editing this version" : "Editing the original" : "Refining this one";
      txt.querySelector("span").textContent = chat.mode === "edit" ? "Type a change below, or apply it as is." : "Type a change below, or add it to the canvas as is.";
      el2.append(thumb, txt);
      if (chat.mode === "create") {
        const x2 = document.createElement("button");
        x2.type = "button";
        x2.className = "nsv2-icon-btn nsv2-ai-ctx-x";
        x2.title = "New idea";
        x2.setAttribute("aria-label", "New idea \u2014 describe something else");
        x2.innerHTML = icons.close;
        x2.addEventListener("click", () => select(-1));
        el2.appendChild(x2);
      }
    }
    async function hostForEdit(v2) {
      if (v2.hosted) return v2.hosted;
      const blob = await (await fetch(v2.url)).blob();
      const safe = (v2.name || "ai-image.png").replace(/[^A-Za-z0-9._-]+/g, "_");
      const up = await uploadFileToS3(new File([blob], safe, { type: blob.type || "image/png" }));
      v2.hosted = hostedDisplayUrl(up.imgixUrl);
      return v2.hosted;
    }
    function select(sel) {
      if (!chat || chat.busy) return;
      chat.sel = sel;
      renderThread();
    }
    function pick(turn, r2) {
      if (!chat || chat.busy || turn.ver == null) return;
      const v2 = chat.versions[turn.ver];
      v2.url = r2.url;
      v2.name = r2.fileName || v2.name;
      chat.sel = turn.ver;
      renderThread();
    }
    function adoptResult(r2) {
      if (!chat || chat.busy) return;
      chat.turns.push({ prompt: r2.prompt || "Recently generated", status: "done", results: [r2], ver: chat.versions.length });
      chat.versions.push({ url: r2.url, name: r2.fileName, prompts: [r2.prompt || ""], turn: chat.turns.length - 1 });
      chat.sel = chat.versions.length - 1;
      renderThread();
    }
    function syncSend() {
      ui2.aiSend.classList.toggle("is-ready", !!(ui2.aiInput.value || "").trim());
      ui2.aiInput.style.height = "auto";
      ui2.aiInput.style.height = Math.min(ui2.aiInput.scrollHeight, 132) + "px";
    }
    function setBusy(on2) {
      clearInterval(aiTick);
      aiTick = null;
      ui2.aiSend.hidden = on2;
      ui2.aiStop.hidden = !on2;
      ui2.aiThread.classList.toggle("is-busy", on2);
      if (on2) {
        aiBusyT0 = Date.now();
        paintHint();
        aiTick = setInterval(paintHint, 1e3);
      }
    }
    async function send(promptRaw, opts2 = {}) {
      if (!chat || chat.busy) return;
      const prompt = String(promptRaw != null ? promptRaw : ui2.aiInput.value || "").trim();
      if (!prompt) return;
      if (!canUseAi()) return askDialog("Daily AI limit reached \u2014 try again tomorrow.", { cancel: null });
      ui2.aiInput.value = "";
      syncSend();
      ui2.aiFootErr.hidden = true;
      const turn = { prompt, status: "busy", results: [], ver: null, fresh: !!opts2.fresh };
      chat.turns.push(turn);
      chat.busy = true;
      chat.ctrl = new AbortController();
      setBusy(true);
      renderThread();
      const live = () => chat && chat.turns.includes(turn);
      try {
        if (chat.mode === "edit") {
          const from = chat.sel;
          const source = from < 0 ? chat.baseUrl : chat.versions[from].url;
          const lineage = from < 0 ? [] : chat.versions[from].prompts.slice();
          const url = await aiEdit(source, prompt, lineage, chat.ctrl.signal);
          consumeAi();
          await waitForRender(url);
          if (!live()) return;
          turn.results = [{ url }];
          chat.versions.push({ url, prompts: lineage.concat(prompt), turn: chat.turns.indexOf(turn) });
          turn.ver = chat.versions.length - 1;
          chat.sel = turn.ver;
        } else if (chat.sel >= 0 && !opts2.fresh) {
          turn.refine = true;
          renderThread();
          const from = chat.versions[chat.sel];
          const source = await hostForEdit(from);
          if (!live()) return;
          const lineage = (from.chain || []).slice();
          const url = await aiEdit(source, prompt, lineage, chat.ctrl.signal);
          consumeAi();
          await waitForRender(url);
          if (!live()) return;
          turn.results = [{ url, fileName: "ai-refine.png" }];
          chat.versions.push({ url, hosted: url, name: "ai-refine-" + Date.now() + ".png", prompts: [prompt], chain: lineage.concat(prompt), turn: chat.turns.indexOf(turn) });
          turn.ver = chat.versions.length - 1;
          chat.sel = turn.ver;
        } else {
          const items = await aiCreate(prompt, { fresh: !!opts2.fresh, signal: chat.ctrl.signal });
          consumeAi();
          if (!live()) return;
          const shown = new Set(chat.turns.flatMap((t2) => t2.results.map((r2) => r2.url)));
          const fresh = items.filter((it2) => !shown.has(it2.url));
          if (!fresh.length) {
            turn.status = "error";
            turn.error = opts2.fresh ? "No new options came back \u2014 add a detail and try again." : "Nothing came back \u2014 try rewording it.";
            return;
          }
          turn.results = fresh;
          aiHistoryAdd(fresh, prompt);
          chat.versions.push({ url: fresh[0].url, name: fresh[0].fileName, prompts: [prompt], turn: chat.turns.indexOf(turn) });
          turn.ver = chat.versions.length - 1;
          chat.sel = turn.ver;
        }
        turn.status = "done";
      } catch (err) {
        if (!live()) return;
        if (chat.ctrl && chat.ctrl.signal.aborted) {
          turn.status = "stopped";
        } else {
          console.error("studio-v2: ai chat failed", err);
          turn.status = "error";
          turn.error = err && err.aiRefused ? "The AI couldn\u2019t do that one \u2014 try rewording it." : "That didn\u2019t come back \u2014 try again.";
        }
      } finally {
        if (chat) {
          chat.busy = false;
          chat.ctrl = null;
          setBusy(false);
          renderThread();
          if (chatParked && turn.status !== "stopped") {
            const ok = turn.status === "done";
            showToast(ok ? chat.mode === "edit" ? "Your AI edit is ready" : "Your AI results are ready" : "That AI run didn\u2019t come back", { label: "View", onAction: () => unparkChat() }, ok ? 8e3 : 6e3);
          }
        }
      }
    }
    async function applyEditVersion(im, resultUrl, count) {
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), 45e3);
      let blob;
      try {
        blob = await (await fetch(resultUrl, { signal: ctrl.signal })).blob();
      } finally {
        clearTimeout(timer);
      }
      const base = (im.__bgr && im.__bgr.fileName || "design").replace(/\.[a-z0-9]+$/i, "").replace(/[^A-Za-z0-9_-]+/g, "_").slice(-40);
      const up = await uploadBlobAs(base + "-ai-edit____image_" + Date.now() + "_" + Math.floor(Math.random() * 1e4) + ".png", blob, "image/png");
      const prevOrig = im.__aiEdit && im.__aiEdit.originalUploadReference || im.__bgr && im.__bgr.imgixUrl || "";
      const prevUp = im.__aiEdit && im.__aiEdit.originalUpload || (im.__bgr ? { fileName: im.__bgr.fileName || "", isVector: !!im.__bgr.isVector } : null);
      await loadImageWithRetry(hostedDisplayUrl(up.imgixUrl));
      await withObjBusy(im, async () => {
        im.__bgr = { status: "ready", imgixUrl: up.imgixUrl, fileName: up.fileName, isVector: false, versions: {}, model: null };
        im.__originalSrc = hostedDisplayUrl(up.imgixUrl);
        im.__fileName = up.fileName;
        im.__aiEdit = { count, originalUploadReference: prevOrig, originalUpload: prevUp };
        im.__superRes = false;
        await editor.adoptNewSource(im, composedSrc(im));
      });
      addRecentUpload(up.imgixUrl, up.fileName);
      if (opts.customerId) {
        try {
          const crc = await crc32Blob(blob);
          await registerUpload(opts.customerId, { url: up.imgixUrl, fileName: up.fileName, crc, variantTitle: "" });
        } catch (err) {
          console.error("studio-v2: ai edit saveData failed", err);
        }
      }
      syncSelection();
    }
    function placingPill(text) {
      const p2 = document.createElement("div");
      p2.className = "nsv2-placing-pill";
      p2.textContent = text;
      ui2.area.appendChild(p2);
      return p2;
    }
    async function placeAiResult(url, name) {
      if (!kindAllowed("image")) return refuse("image");
      const pill = placingPill("Adding image to your canvas\u2026");
      try {
        const blob = await (await fetch(url)).blob();
        const safe = (name || "ai-image.png").replace(/[^A-Za-z0-9._-]+/g, "_");
        const up = await uploadFileToS3(new File([blob], safe, { type: blob.type || "image/png" }));
        const img = await editor.addImageFromUrl(hostedDisplayUrl(up.imgixUrl), safe);
        img.__bgr = { status: "ready", imgixUrl: up.imgixUrl, fileName: up.fileName, isVector: false, versions: {}, model: null };
        img.__aiCreated = true;
        addRecentUpload(up.imgixUrl, safe);
        trackAdd("ai_create");
        syncSelection();
        autoRemoveBg(img);
      } catch (err) {
        console.error("studio-v2: ai place failed", err);
        pill.classList.add("is-error");
        pill.textContent = "Couldn\u2019t add that image \u2014 try again.";
        setTimeout(() => pill.remove(), 2600);
        throw err;
      } finally {
        if (!pill.classList.contains("is-error")) pill.remove();
      }
    }
    async function autoRemoveBg(im) {
      try {
        const m = BGR_MODELS[0];
        const url = await loadImageWithRetry(candidateUrl(im.__bgr.imgixUrl, m, DISPLAY_W)).then(rejectEmptyRemoval).then((u2) => rejectMisframedRender(u2, im.__originalSrc));
        if (!editor.canvas.getObjects().includes(im)) return;
        im.__bgr.versions[m.key] = url;
        (im.__bgrValidated = im.__bgrValidated || {})[m.key] = url;
        await applyBgrModel(im, m.key);
        syncSelection();
        showToast("Background removed", {
          label: "Keep background",
          onAction: async () => {
            if (!editor.canvas.getObjects().includes(im)) return;
            await applyBgrModel(im, "original");
            syncSelection();
          }
        });
      } catch (err) {
        console.warn("studio-v2: ai auto bg-remove skipped", err);
      }
    }
    async function useVersion() {
      if (!chat || chat.busy || chat.sel < 0) return;
      const v2 = chat.versions[chat.sel];
      const mode2 = chat.mode;
      const im = chat.im;
      chat.busy = true;
      setBusy(true);
      ui2.aiThread.classList.add("is-using");
      ui2.aiFootErr.hidden = true;
      const useBtn = ui2.aiThread.querySelector(".nsv2-ai-use");
      const useLabel = useBtn && useBtn.querySelector("span");
      const idleText = useLabel ? useLabel.textContent : "";
      if (useBtn) {
        useBtn.classList.add("is-busy");
        useBtn.setAttribute("aria-busy", "true");
        if (useLabel) useLabel.textContent = mode2 === "edit" ? "Applying\u2026" : "Adding\u2026";
      }
      try {
        if (mode2 === "edit") {
          if (!editor.canvas.getObjects().includes(im)) throw new Error("image gone");
          await applyEditVersion(im, v2.url, v2.prompts.length);
          chat.applied = true;
        } else {
          await placeAiResult(v2.url, v2.name);
        }
        closeChat(true);
        if (mode2 === "edit") showToast("Edit applied", { label: "Undo", onAction: () => {
          editor.undo();
          syncSelection();
        } });
        else if (ui2.toast.hidden) showToast("Added to your canvas", { label: "Undo", onAction: () => {
          editor.undo();
          syncSelection();
        } });
      } catch (err) {
        console.error("studio-v2: ai use failed", err);
        if (chat) {
          ui2.aiFootErr.textContent = mode2 === "edit" ? "Couldn\u2019t apply that version \u2014 please try again." : "Couldn\u2019t add that image \u2014 please try again.";
          ui2.aiFootErr.hidden = false;
        }
      } finally {
        if (chat) {
          chat.busy = false;
          setBusy(false);
        }
        ui2.aiThread.classList.remove("is-using");
        if (useBtn) {
          useBtn.classList.remove("is-busy");
          useBtn.removeAttribute("aria-busy");
          if (useLabel) useLabel.textContent = idleText;
        }
      }
    }
    const aiSheetHead = makeSheetHead({ title: "Create with AI", onClose: () => closeChat(false), onDone: () => closeChat(false) });
    ui2.aiDrawer.insertBefore(aiSheetHead.el, ui2.aiDrawer.firstChild);
    cleanups.push(attachSwipeDismiss(aiSheetHead.handle, ui2.aiDrawer, () => closeChat(false), "translate"));
    let aiHideT = 0;
    function openChat(mode2, im) {
      if (!toolAllowed("ai")) return;
      if (chat && chatParked && chat.mode === mode2 && (mode2 === "create" || chat.im === im)) {
        unparkChat();
        return;
      }
      if (chat && chat.busy) return;
      if (chat) closeChat(true);
      closePanel();
      if (mode2 === "edit") {
        const baseUrl = chatBaseFor(im);
        chat = { mode: mode2, im, baseUrl, turns: [], versions: [], sel: -1, busy: false, ctrl: null, applied: false };
        ui2.aiTitle.textContent = "Edit with AI";
      } else {
        chat = { mode: "create", im: null, baseUrl: null, turns: createThread.turns, versions: createThread.versions, sel: createThread.sel, busy: false, ctrl: null, applied: false };
        ui2.aiTitle.textContent = "Create with AI";
      }
      aiSheetHead.set({ title: ui2.aiTitle.textContent });
      ui2.aiInput.value = "";
      syncSend();
      ui2.aiFootErr.hidden = true;
      setBusy(false);
      clearTimeout(aiHideT);
      ui2.aiDrawer.classList.remove("is-closing");
      ui2.aiDrawer.hidden = false;
      ui2.root.classList.add("is-ai-open");
      ui2.toolBtns.ai.classList.toggle("is-active", mode2 === "create");
      renderThread();
      if (!isMobileView()) ui2.aiInput.focus();
    }
    async function closeChat(force) {
      if (!chat) return;
      const unsaved = chat.mode === "edit" && chat.versions.length && !chat.applied;
      if (!force && unsaved && !await askDialog("Leave the AI Editor? Your edit hasn\u2019t been applied.", { ok: "Leave", cancel: "Stay" })) return;
      if (!chat) return;
      if (chat.ctrl) chat.ctrl.abort();
      if (chat.mode === "create") {
        createThread.turns = chat.turns;
        createThread.versions = chat.versions;
        createThread.sel = chat.sel;
      }
      chat = null;
      chatParked = false;
      clearInterval(aiTick);
      aiTick = null;
      hideAiDrawer();
      ui2.root.classList.remove("is-ai-open");
      ui2.toolBtns.ai.classList.remove("is-active");
    }
    function parkChat() {
      if (!chat || chatParked) return;
      chatParked = true;
      hideAiDrawer();
      ui2.root.classList.remove("is-ai-open");
      ui2.toolBtns.ai.classList.remove("is-active");
    }
    function unparkChat() {
      if (!chat || !chatParked) return false;
      chatParked = false;
      closePanel();
      clearTimeout(aiHideT);
      ui2.aiDrawer.classList.remove("is-closing");
      ui2.aiDrawer.hidden = false;
      ui2.root.classList.add("is-ai-open");
      ui2.toolBtns.ai.classList.toggle("is-active", chat.mode === "create");
      return true;
    }
    function hideAiDrawer() {
      clearTimeout(aiHideT);
      if (!isSheetLayout()) {
        ui2.aiDrawer.classList.remove("is-closing");
        ui2.aiDrawer.hidden = true;
        return;
      }
      ui2.aiDrawer.classList.add("is-closing");
      const done = () => {
        clearTimeout(aiHideT);
        ui2.aiDrawer.removeEventListener("animationend", done);
        if (ui2.aiDrawer.classList.contains("is-closing")) {
          ui2.aiDrawer.classList.remove("is-closing");
          ui2.aiDrawer.hidden = true;
        }
      };
      ui2.aiDrawer.addEventListener("animationend", done);
      aiHideT = setTimeout(done, 420);
    }
    ui2.toolBtns.ai.addEventListener("click", () => chat && chat.mode === "create" && !chatParked ? closeChat(false) : openChat("create"));
    ui2.aiEditBtn.addEventListener("click", () => {
      const im = editor.activeImage();
      if (!im || !im.__bgr || im.__bgr.status !== "ready") return;
      openChat("edit", im);
    });
    ui2.qaAi.addEventListener("click", () => ui2.aiEditBtn.click());
    ui2.aiClose.addEventListener("click", () => closeChat(false));
    ui2.aiSend.addEventListener("click", () => send());
    ui2.aiStop.addEventListener("click", () => {
      if (chat && chat.ctrl) chat.ctrl.abort();
    });
    ui2.aiInput.addEventListener("input", syncSend);
    ui2.aiInput.addEventListener("keydown", (e24) => {
      if (e24.key === "Enter" && !e24.shiftKey && !isMobileView()) {
        e24.preventDefault();
        send();
      }
    });
    ui2.aiDrawer.addEventListener("keydown", (e24) => {
      if (e24.key === "Escape" && chat && !chatParked) {
        e24.preventDefault();
        closeChat(false);
      }
    });
    const cv = editor.canvas;
    let pasteAtPoint = null;
    function hideMenu() {
      ui2.menu.hidden = true;
    }
    const menuHead = makeSheetHead({ title: "More", onClose: () => hideMenu(), done: false });
    ui2.menu.insertBefore(menuHead.el, ui2.menu.firstChild);
    function openMenu(x2, y2) {
      const mAct = cv.getActiveObject();
      const hasSel = !!mAct;
      ui2.menuPaste.disabled = !editor.hasClipboard();
      ui2.menuCopy.hidden = !hasSel;
      ui2.menuDup.hidden = !hasSel;
      ui2.menuDel.hidden = !hasSel;
      ui2.menuGroup.hidden = !editor.activeSelection();
      ui2.menuUngroup.hidden = !(mAct && mAct.isType && mAct.isType("group") && !mAct.__el);
      ui2.alignWrap.hidden = !hasSel;
      ui2.alignWrap.classList.remove("is-open");
      ui2.menu.querySelectorAll('[data-act^="layer:"], [data-act^="flip:"], [data-act="lock"]').forEach((b2) => {
        b2.hidden = !hasSel;
      });
      const lockA = editor.canvas.getActiveObject();
      ui2.menuLock.querySelector(".nsv2-menu-lab > span").textContent = lockA && lockA.__locked ? "Unlock" : "Lock";
      ui2.menu.querySelectorAll(":scope > .nsv2-menu-div").forEach((d2) => {
        d2.hidden = !hasSel;
      });
      ui2.menu.hidden = false;
      const mw = ui2.menu.offsetWidth, mh = ui2.menu.offsetHeight;
      const px = Math.max(8, Math.min(Math.max(8, x2), ui2.area.clientWidth - mw - 8));
      const py = Math.max(8, Math.min(Math.max(8, y2), ui2.area.clientHeight - mh - 8));
      ui2.menu.style.transform = "translate(" + px + "px, " + py + "px)";
    }
    const alignSub = ui2.menu.querySelector(".nsv2-menu-sub");
    const alignSubMenu = alignSub && alignSub.querySelector(".nsv2-menu--sub");
    if (alignSubMenu) {
      alignSub.querySelector(":scope > .nsv2-menu-item").addEventListener("click", () => {
        if (!isMobileView()) return;
        const open = alignSub.classList.toggle("is-open");
        if (open) alignSubMenu.scrollIntoView({ block: "nearest" });
      });
      alignSub.addEventListener("mouseenter", () => {
        if (isMobileView()) return;
        alignSubMenu.style.left = "";
        alignSubMenu.style.right = "";
        alignSubMenu.style.top = "";
        const a2 = ui2.area.getBoundingClientRect();
        const row = alignSub.getBoundingClientRect();
        const mw = alignSubMenu.offsetWidth, mh = alignSubMenu.offsetHeight;
        if (row.right - 6 + mw > a2.right - 8) {
          alignSubMenu.style.left = "auto";
          alignSubMenu.style.right = "calc(100% - 6px)";
        }
        let top = -6;
        const over = row.top + top + mh - (a2.bottom - 8);
        if (over > 0) top -= over;
        if (row.top + top < a2.top + 8) top = a2.top + 8 - row.top;
        alignSubMenu.style.top = Math.round(top) + "px";
      });
    }
    function positionQa() {
      const o2 = cv.getActiveObject();
      if (!o2 || editor._crop || editor._dragChrome || editor._gesture) {
        ui2.qa.hidden = true;
        if (editor._crop || editor._dragChrome) hideMenu();
        return;
      }
      ui2.qa.hidden = false;
      ui2.qa.classList.toggle("is-locked", !!o2.__locked);
      ui2.qaAi.hidden = !(o2.isType && o2.isType("image") && !o2.__el) || !!o2.__base;
      ui2.qaDup.hidden = !!o2.__base;
      ui2.qaDel.hidden = !!o2.__base;
      const single = editor._boardObjects().length < 2;
      ui2.qaUp.hidden = single;
      ui2.qaDown.hidden = single;
      const br2 = o2.getBoundingRect();
      const z2 = cv.getZoom();
      const vpt = cv.viewportTransform;
      const cRect = cv.upperCanvasEl.getBoundingClientRect();
      const aRect = ui2.area.getBoundingClientRect();
      const offX = cRect.left - aRect.left;
      const offY = cRect.top - aRect.top;
      const cx = offX + (br2.left + br2.width / 2) * z2 + vpt[4];
      const R3 = 18;
      const pad = o2.padding || 0;
      let topBound = offY + br2.top * z2 + vpt[5] - pad;
      let bottomBound = offY + (br2.top + br2.height) * z2 + vpt[5] + pad;
      const mtrCtl = o2.controls && o2.controls.mtr;
      if (mtrCtl) {
        const knobHome = bottomBound + 31 + 15;
        const areaH = ui2.area.clientHeight;
        const wasFlipped = !!mtrCtl.__nsFlipped;
        const flip = wasFlipped ? knobHome > areaH - 40 : knobHome > areaH - 8;
        if (flip !== wasFlipped) {
          mtrCtl.__nsFlipped = flip;
          mtrCtl.y = flip ? -0.5 : 0.5;
          mtrCtl.offsetY = flip ? -(31 + ui2.qa.offsetHeight + 16) : 31;
          o2.setCoords();
          cv.requestRenderAll();
        }
      }
      const flipped = !!(mtrCtl && mtrCtl.__nsFlipped);
      const mtr = o2.oCoords && o2.oCoords.mtr;
      if (mtr && !flipped) {
        topBound = Math.min(topBound, offY + mtr.y - R3);
        bottomBound = Math.max(bottomBound, offY + mtr.y + R3);
      }
      const w2 = ui2.qa.offsetWidth, h2 = ui2.qa.offsetHeight;
      const x2 = Math.min(Math.max(8, cx - w2 / 2), ui2.area.clientWidth - w2 - 8);
      const minY = 56;
      const maxY = ui2.area.clientHeight - h2 - 8;
      const GAP = 16;
      let y2 = topBound - h2 - GAP;
      if (y2 < minY) y2 = bottomBound + GAP;
      if (y2 > maxY) y2 = Math.max(minY, topBound - h2 - GAP);
      y2 = Math.min(Math.max(minY, y2), maxY);
      ui2.qa.style.transform = "translate(" + x2 + "px, " + y2 + "px)";
    }
    editor.canvas.on("before:render", () => {
      editor.canvas.__mtrScreen = null;
    });
    editor.canvas.on("after:render", () => {
      const m = editor.canvas.__mtrScreen;
      if (!m) {
        if (!ui2.rotKnob.hidden) ui2.rotKnob.hidden = true;
        return;
      }
      const cr2 = editor.canvas.upperCanvasEl.getBoundingClientRect();
      const ar2 = ui2.area.getBoundingClientRect();
      ui2.rotKnob.style.left = cr2.left - ar2.left + m.left + "px";
      ui2.rotKnob.style.top = cr2.top - ar2.top + m.top + "px";
      ui2.rotKnob.classList.toggle("is-hot", !!m.hot);
      if (ui2.rotKnob.hidden) ui2.rotKnob.hidden = false;
    });
    editor.on("selection", positionQa);
    editor.on("zoom", positionQa);
    editor.on("gesture", (on2) => {
      ui2.root.classList.toggle("is-gesturing", !!on2);
      if (on2) hideMenu();
      positionQa();
    });
    editor.on("history", positionQa);
    cv.on("object:moving", () => {
      ui2.qa.hidden = true;
      hideMenu();
    });
    ["object:scaling", "object:rotating", "object:resizing"].forEach(
      (ev) => cv.on(ev, () => {
        ui2.qa.classList.add("is-quiet");
        hideMenu();
      })
    );
    cv.on("object:modified", () => {
      ui2.qa.classList.remove("is-quiet");
      positionQa();
    });
    cv.on("mouse:up", () => positionQa());
    ui2.qaDown.addEventListener("click", () => editor.layerDown());
    ui2.qaUp.addEventListener("click", () => editor.layerUp());
    ui2.qaDup.addEventListener("click", () => editor.duplicateActive());
    ui2.qaDel.addEventListener("click", () => editor.deleteActive());
    ui2.qaMore.addEventListener("click", () => {
      if (!ui2.menu.hidden) return hideMenu();
      const qr2 = ui2.qa.getBoundingClientRect();
      const ar2 = ui2.area.getBoundingClientRect();
      openMenu(qr2.right - ar2.left - 220, qr2.bottom - ar2.top + 8);
    });
    cv.on("contextmenu", (opt) => {
      const e24 = opt.e;
      if (editor._crop) return;
      const pt2 = cv.getScenePoint ? cv.getScenePoint(e24) : null;
      let target2 = opt.target;
      if (!target2 && pt2) {
        target2 = [...cv.getObjects()].reverse().find((o2) => !o2.excludeFromExport && o2.containsPoint && o2.containsPoint(pt2));
      }
      const ar2 = ui2.area.getBoundingClientRect();
      if (!target2) {
        cv.discardActiveObject();
        cv.requestRenderAll();
        syncSelection();
        if (!editor.hasClipboard()) {
          hideMenu();
          return;
        }
        pasteAtPoint = pt2;
        openMenu(e24.clientX - ar2.left + 4, e24.clientY - ar2.top + 4);
        return;
      }
      pasteAtPoint = null;
      cv.setActiveObject(target2);
      cv.requestRenderAll();
      syncSelection();
      positionQa();
      openMenu(e24.clientX - ar2.left + 4, e24.clientY - ar2.top + 4);
    });
    listen(document, "pointerdown", (e24) => {
      if (!ui2.menu.hidden && !ui2.menu.contains(e24.target) && !ui2.qaMore.contains(e24.target)) hideMenu();
    });
    ui2.qaLock.addEventListener("click", () => {
      const a2 = editor.canvas.getActiveObject();
      if (a2) editor.setLocked(a2, false);
    });
    ui2.menu.addEventListener("click", async (e24) => {
      const item = e24.target.closest(".nsv2-menu-item");
      if (!item || !item.dataset.act) return;
      const act = item.dataset.act;
      if (act === "copy") await editor.copyActive();
      else if (act === "paste") {
        await editor.paste(pasteAtPoint);
        pasteAtPoint = null;
      } else if (act === "duplicate") await editor.duplicateActive();
      else if (act === "group") editor.groupSelection();
      else if (act === "ungroup") editor.ungroupSelection();
      else if (act === "delete") editor.deleteActive();
      else if (act === "layer:front") editor.layerToFront();
      else if (act === "layer:up") editor.layerUp();
      else if (act === "layer:down") editor.layerDown();
      else if (act === "layer:back") editor.layerToBack();
      else if (act === "lock") {
        const a2 = editor.canvas.getActiveObject();
        if (a2) editor.setLocked(a2, !a2.__locked);
      } else if (act === "flip:h") editor.flip("h");
      else if (act === "flip:v") editor.flip("v");
      else if (act.startsWith("align:")) editor.alignToPage(act.slice(6));
      hideMenu();
    });
    const onKeydown = (e24) => {
      if (!ui2.root.isConnected) return;
      const tag = (e24.target.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || e24.target.isContentEditable) return;
      const active = editor.canvas.getActiveObject();
      if (active && active.isEditing) return;
      if (editor._crop) {
        if (e24.key === "Enter") {
          e24.preventDefault();
          editor.applyCrop();
          endCropUI();
          syncSelection();
        } else if (e24.key === "Escape") {
          e24.preventDefault();
          editor.cancelCrop();
          endCropUI();
        }
        return;
      }
      const mod = e24.metaKey || e24.ctrlKey;
      if (mod && e24.key.toLowerCase() === "z") {
        e24.preventDefault();
        if (e24.shiftKey) editor.redo();
        else editor.undo();
        syncSelection();
      } else if (mod && e24.key.toLowerCase() === "y") {
        e24.preventDefault();
        editor.redo();
        syncSelection();
      } else if (mod && e24.key.toLowerCase() === "a") {
        e24.preventDefault();
        editor.selectAll();
        syncSelection();
      } else if (mod && e24.key.toLowerCase() === "c" && active) {
        e24.preventDefault();
        editor.copyActive();
      } else if (mod && e24.key.toLowerCase() === "x" && active) {
        e24.preventDefault();
        editor.copyActive();
        editor.deleteActive();
        syncSelection();
      } else if (mod && e24.key.toLowerCase() === "v" && editor.hasClipboard()) {
        e24.preventDefault();
        editor.paste();
      } else if (mod && e24.key.toLowerCase() === "d" && active) {
        e24.preventDefault();
        editor.duplicateActive();
      } else if (mod && e24.key.toLowerCase() === "g" && active) {
        e24.preventDefault();
        if (e24.shiftKey) editor.ungroupSelection();
        else editor.groupSelection();
        syncSelection();
      } else if (mod && (e24.key === "=" || e24.key === "+")) {
        e24.preventDefault();
        zoomAnimateKeepCenter(editor.userZoom * 1.2);
      } else if (mod && e24.key === "-") {
        e24.preventDefault();
        zoomAnimateKeepCenter(editor.userZoom / 1.2);
      } else if (mod && e24.key === "0") {
        e24.preventDefault();
        zoomAnimateKeepCenter(1);
      } else if (mod && e24.key === "1") {
        e24.preventDefault();
        zoomAnimateKeepCenter(1 / editor.fitScale);
      } else if (e24.key === " " && !e24.repeat) {
        e24.preventDefault();
        beginPanMode();
      } else if (active && (e24.key === "]" || e24.key === "}")) {
        e24.preventDefault();
        e24.shiftKey ? editor.layerToFront() : editor.layerUp();
      } else if (active && (e24.key === "[" || e24.key === "{")) {
        e24.preventDefault();
        e24.shiftKey ? editor.layerToBack() : editor.layerDown();
      } else if (active && e24.shiftKey && !mod && e24.key.toLowerCase() === "h") {
        e24.preventDefault();
        editor.flip("h");
      } else if (active && e24.shiftKey && !mod && e24.key.toLowerCase() === "v") {
        e24.preventDefault();
        editor.flip("v");
      } else if (e24.key === "Delete" || e24.key === "Backspace") {
        if (active) {
          e24.preventDefault();
          editor.deleteActive();
        }
      } else if (e24.key.startsWith("Arrow")) {
        if (!active || active.__locked) return;
        e24.preventDefault();
        const step = e24.shiftKey ? 10 : 1;
        nudgeActive(
          e24.key === "ArrowLeft" ? -step : e24.key === "ArrowRight" ? step : 0,
          e24.key === "ArrowUp" ? -step : e24.key === "ArrowDown" ? step : 0,
          true
        );
      } else if (e24.key === "Escape") {
        const tr2 = editor.canvas._currentTransform;
        if (tr2 && tr2.target && tr2.original) {
          e24.preventDefault();
          const o2 = tr2.original;
          tr2.target.set({
            left: o2.left,
            top: o2.top,
            scaleX: o2.scaleX,
            scaleY: o2.scaleY,
            angle: o2.angle,
            skewX: o2.skewX,
            skewY: o2.skewY,
            flipX: o2.flipX,
            flipY: o2.flipY
          });
          tr2.target.setCoords();
          if (tr2.target.__shape) editor._shapeApply(tr2.target);
          editor.canvas._currentTransform = null;
          editor._snapGuides = null;
          editor._snapTargets = null;
          if (editor._restoreDragChrome) editor._restoreDragChrome();
          editor.canvas.requestRenderAll();
          return;
        }
        editor.canvas.discardActiveObject();
        editor.canvas.requestRenderAll();
        hideMenu();
      }
    };
    let panHeld = false, panDrag = null;
    function beginPanMode() {
      if (panHeld) return;
      panHeld = true;
      ui2.root.classList.add("is-panning");
      editor.canvas.skipTargetFind = true;
    }
    function endPanMode() {
      if (!panHeld) return;
      panHeld = false;
      panDrag = null;
      ui2.root.classList.remove("is-panning", "is-pan-drag");
      editor.canvas.skipTargetFind = false;
      editor.canvas.requestRenderAll();
    }
    const onKeyup = (e24) => {
      if (e24.key === " ") endPanMode();
    };
    const onPanDown = (e24) => {
      if (!panHeld || e24.button !== 0) return;
      e24.preventDefault();
      e24.stopPropagation();
      const s3 = ui2.boardScroll;
      panDrag = { x: e24.clientX, y: e24.clientY, sl: s3.scrollLeft, st: s3.scrollTop };
      ui2.root.classList.add("is-pan-drag");
    };
    const onPanMove = (e24) => {
      if (!panDrag) return;
      e24.preventDefault();
      editor.beginGesture();
      const s3 = ui2.boardScroll;
      s3.scrollLeft = panDrag.sl - (e24.clientX - panDrag.x);
      s3.scrollTop = panDrag.st - (e24.clientY - panDrag.y);
      editor.canvas.calcOffset();
    };
    const onPanUp = () => {
      if (panDrag) {
        panDrag = null;
        ui2.root.classList.remove("is-pan-drag");
      }
    };
    ui2.boardScroll.addEventListener("pointerdown", onPanDown, true);
    listen(window, "pointermove", onPanMove, true);
    listen(window, "pointerup", onPanUp, true);
    listen(window, "blur", endPanMode);
    const onPaste = (e24) => {
      if (!ui2.root.isConnected || !e24.clipboardData) return;
      const tag = (e24.target && e24.target.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || e24.target && e24.target.isContentEditable) return;
      const act = editor.canvas.getActiveObject();
      if (act && act.isEditing) return;
      const files = [];
      for (const f2 of Array.from(e24.clipboardData.files || [])) if (/^image\//.test(f2.type)) files.push(f2);
      if (!files.length) for (const it2 of Array.from(e24.clipboardData.items || [])) {
        if (it2.kind === "file" && /^image\//.test(it2.type)) {
          const f2 = it2.getAsFile();
          if (f2) files.push(f2);
        }
      }
      if (!files.length) return;
      e24.preventDefault();
      if (!kindAllowed("image")) return refuse("image");
      files.forEach((f2, i2) => {
        const ext = (f2.type.split("/")[1] || "png").replace("jpeg", "jpg").replace(/[^a-z0-9]/gi, "");
        const name = f2.name && f2.name !== "image.png" ? f2.name : "pasted-" + Date.now() + (i2 ? "-" + i2 : "") + "." + ext;
        addUpload(new File([f2], name, { type: f2.type }));
      });
    };
    listen(document, "paste", onPaste);
    listen(document, "keyup", onKeyup);
    listen(document, "keydown", onKeydown);
    const dropVeil = document.createElement("div");
    dropVeil.className = "nsv2-dropveil";
    dropVeil.hidden = true;
    dropVeil.innerHTML = '<div class="nsv2-dropveil-card"><span class="nsv2-dropveil-ic">' + icons.uploads + '</span><div class="nsv2-dropveil-title">Drop your file(s)</div><div class="nsv2-dropveil-sub">anywhere to add them to your design</div></div>';
    ui2.root.appendChild(dropVeil);
    let dragDepth = 0;
    const hideVeil = () => {
      dragDepth = 0;
      dropVeil.hidden = true;
    };
    const dragHasFiles = (e24) => e24.dataTransfer && Array.from(e24.dataTransfer.types || []).includes("Files");
    ui2.root.addEventListener("dragenter", (e24) => {
      if (!dragHasFiles(e24)) return;
      e24.preventDefault();
      if (!kindAllowed("image")) return;
      dragDepth++;
      dropVeil.hidden = false;
    });
    ui2.root.addEventListener("dragover", (e24) => {
      if (!dragHasFiles(e24)) return;
      e24.preventDefault();
    });
    ui2.root.addEventListener("dragleave", (e24) => {
      if (!dragHasFiles(e24)) return;
      if (--dragDepth <= 0) hideVeil();
    });
    ui2.root.addEventListener("drop", (e24) => {
      if (!dragHasFiles(e24)) return;
      e24.preventDefault();
      hideVeil();
      if (!kindAllowed("image")) return refuse("image");
      Array.from(e24.dataTransfer && e24.dataTransfer.files || []).forEach(intake);
    });
    const layerRowObj = /* @__PURE__ */ new WeakMap();
    function layerObjects() {
      return editor.canvas.getObjects().filter((o2) => !o2.excludeFromExport).reverse();
    }
    function renderLayers() {
      if (activePane !== "layers") return;
      const objs = layerObjects();
      ui2.layersEmpty.hidden = !!objs.length;
      const frag = document.createDocumentFragment();
      const active = editor.canvas.getActiveObject();
      const activeSet = new Set(
        active ? active.isType && active.isType("activeselection") && active.getObjects ? active.getObjects() : [active] : []
      );
      const layerPreview = (o2) => {
        const prev = document.createElement("img");
        prev.className = "nsv2-layer-prev";
        prev.alt = "";
        try {
          const maxDim = Math.max(o2.getScaledWidth(), o2.getScaledHeight());
          prev.src = o2.toDataURL({ format: "png", multiplier: Math.min(1, 150 / Math.max(1, maxDim)) });
        } catch (e24) {
        }
        return prev;
      };
      const addRow = (o2, depth) => {
        const isGroup = o2.isType && o2.isType("group") && !o2.__el;
        const row = document.createElement("div");
        row.className = "nsv2-layer-row" + (depth ? " nsv2-layer-row--child" : "") + (activeSet.has(o2) ? " is-active" : "");
        row.draggable = depth === 0 && !(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
        if (depth) row.style.marginLeft = 26 * depth + "px";
        const grip = document.createElement("span");
        grip.className = "nsv2-layer-grip";
        grip.innerHTML = icons.grip;
        row.append(grip);
        if (o2.__locked) {
          const lk = document.createElement("button");
          lk.type = "button";
          lk.className = "nsv2-layer-lockic";
          lk.innerHTML = icons.lock;
          lk.title = "Unlock";
          row.append(lk);
        }
        const well = document.createElement("span");
        well.className = "nsv2-layer-well" + (editor._boardBg ? "" : " nsv2-layer-well--checker");
        if (editor._boardBg) well.style.background = editor._boardBg;
        well.appendChild(layerPreview(o2));
        row.append(well);
        const tools = document.createElement("div");
        tools.className = "nsv2-layer-tools";
        if (isGroup) {
          const open = o2.__layersOpen !== false;
          const chev = document.createElement("button");
          chev.type = "button";
          chev.className = "nsv2-layer-chev" + (open ? " is-open" : "");
          chev.innerHTML = icons.chevronRight;
          chev.title = open ? "Collapse group" : "Expand group";
          tools.appendChild(chev);
        }
        if (!o2.__base) {
          const opts2 = document.createElement("button");
          opts2.type = "button";
          opts2.className = "nsv2-layer-opts";
          opts2.innerHTML = icons.dotsV;
          opts2.title = "Options";
          tools.appendChild(opts2);
        }
        row.appendChild(tools);
        layerRowObj.set(row, o2);
        frag.appendChild(row);
        if (isGroup && o2.__layersOpen !== false) {
          for (const c2 of [...o2.getObjects()].reverse()) addRow(c2, depth + 1);
        }
      };
      for (const o2 of objs) addRow(o2, 0);
      ui2.layersList.replaceChildren(frag);
    }
    let layersTimer = null;
    const layersChanged = () => {
      if (activePane !== "layers") return;
      clearTimeout(layersTimer);
      layersTimer = setTimeout(renderLayers, 180);
    };
    editor.canvas.on("object:added", layersChanged);
    editor.canvas.on("object:removed", layersChanged);
    editor.canvas.on("object:modified", layersChanged);
    editor.on("selection", layersChanged);
    ui2.layersList.addEventListener("click", (e24) => {
      const lockBtn = e24.target.closest(".nsv2-layer-lockic");
      if (lockBtn) {
        const lrow = lockBtn.closest(".nsv2-layer-row");
        const lo2 = lrow && layerRowObj.get(lrow);
        if (lo2) editor.setLocked(lo2, false);
        return;
      }
      const chev = e24.target.closest(".nsv2-layer-chev");
      if (chev) {
        const grow = chev.closest(".nsv2-layer-row");
        const g2 = grow && layerRowObj.get(grow);
        if (g2) {
          g2.__layersOpen = g2.__layersOpen === false;
          renderLayers();
        }
        return;
      }
      const optsBtn = e24.target.closest(".nsv2-layer-opts");
      if (optsBtn) {
        const orow = optsBtn.closest(".nsv2-layer-row");
        const o3 = orow && layerRowObj.get(orow);
        if (o3) {
          editor.canvas.setActiveObject(o3);
          editor.canvas.requestRenderAll();
          syncSelection();
          const rr2 = optsBtn.getBoundingClientRect();
          const ar2 = ui2.area.getBoundingClientRect();
          openMenu(rr2.right - ar2.left - 220, rr2.bottom - ar2.top + 6);
        }
        return;
      }
      const row = e24.target.closest(".nsv2-layer-row");
      const o2 = row && layerRowObj.get(row);
      if (!o2) return;
      editor.canvas.setActiveObject(o2);
      editor.canvas.requestRenderAll();
      syncSelection();
      renderLayers();
    });
    let dragLayerRow = null;
    ui2.layersList.addEventListener("dragstart", (e24) => {
      dragLayerRow = e24.target.closest(".nsv2-layer-row");
      if (dragLayerRow) {
        dragLayerRow.classList.add("is-dragging");
        e24.dataTransfer.effectAllowed = "move";
        try {
          e24.dataTransfer.setData("text/plain", "layer");
        } catch (err) {
        }
      }
    });
    ui2.layersList.addEventListener("dragover", (e24) => {
      if (!dragLayerRow) return;
      e24.preventDefault();
      const over = e24.target.closest(".nsv2-layer-row");
      if (!over || over === dragLayerRow) return;
      const r2 = over.getBoundingClientRect();
      if (e24.clientY < r2.top + r2.height / 2) over.before(dragLayerRow);
      else over.after(dragLayerRow);
    });
    ui2.layersList.addEventListener("drop", (e24) => e24.preventDefault());
    ui2.layersList.addEventListener("dragend", () => {
      if (!dragLayerRow) return;
      dragLayerRow.classList.remove("is-dragging");
      dragLayerRow = null;
      applyLayerOrder();
    });
    let touchRow = null, touchPid = null;
    ui2.layersList.addEventListener("pointerdown", (e24) => {
      if (e24.pointerType === "mouse") return;
      const grip = e24.target.closest && e24.target.closest(".nsv2-layer-grip");
      const row = grip && grip.closest(".nsv2-layer-row");
      if (!row || row.classList.contains("nsv2-layer-row--child")) return;
      touchRow = row;
      touchPid = e24.pointerId;
      row.classList.add("is-dragging");
      row.style.pointerEvents = "none";
      try {
        row.setPointerCapture(e24.pointerId);
      } catch (err) {
      }
      e24.preventDefault();
    });
    const touchDragMove = (e24) => {
      if (!touchRow || e24.pointerId !== touchPid) return;
      e24.preventDefault();
      const el2 = document.elementFromPoint(e24.clientX, e24.clientY);
      const over = el2 && el2.closest && el2.closest(".nsv2-layer-row:not(.nsv2-layer-row--child)");
      if (!over || over === touchRow || !ui2.layersList.contains(over)) return;
      const r2 = over.getBoundingClientRect();
      if (e24.clientY < r2.top + r2.height / 2) over.before(touchRow);
      else over.after(touchRow);
    };
    const touchDragEnd = (e24) => {
      if (!touchRow || e24.pointerId !== touchPid) return;
      touchRow.classList.remove("is-dragging");
      touchRow.style.pointerEvents = "";
      touchRow = null;
      touchPid = null;
      applyLayerOrder();
    };
    ui2.layersList.addEventListener("pointermove", touchDragMove);
    ui2.layersList.addEventListener("pointerup", touchDragEnd);
    ui2.layersList.addEventListener("pointercancel", touchDragEnd);
    function applyLayerOrder() {
      const rows = [...ui2.layersList.children];
      const n2 = rows.length;
      let moved = false;
      const topRows = rows.filter((r2) => !r2.classList.contains("nsv2-layer-row--child"));
      const nTop = topRows.length;
      topRows.forEach((row, i2) => {
        const o2 = layerRowObj.get(row);
        if (!o2) return;
        const target2 = nTop - 1 - i2;
        if (editor.canvas.getObjects().indexOf(o2) !== target2) {
          editor.canvas.moveObjectTo(o2, target2);
          moved = true;
        }
      });
      if (moved) {
        editor.canvas.requestRenderAll();
        editor.canvas.fire("object:modified", {});
      }
    }
    function syncHistory() {
      ui2.undoBtn.disabled = !editor.canUndo;
      ui2.redoBtn.disabled = !editor.canRedo;
    }
    editor.on("history", syncHistory);
    ui2.undoBtn.addEventListener("click", () => editor.undo());
    ui2.redoBtn.addEventListener("click", () => editor.redo());
    syncHistory();
    ui2.ctxSelGroup.addEventListener("click", (e24) => {
      const a2 = e24.target.closest("[data-align-pos]");
      if (a2) return editor.alignSelection(a2.dataset.alignPos);
      const d2 = e24.target.closest("[data-dist-axis]");
      if (d2) editor.distributeSelection(d2.dataset.distAxis);
    });
    const ENTRY_KEY = "nsv2Entry";
    try {
      if (!sessionStorage.getItem(ENTRY_KEY)) {
        let entry = null;
        const explicit = new URLSearchParams(window.location.search).get("from");
        if (explicit && /^\/(?!\/)/.test(explicit)) entry = explicit;
        else if (document.referrer) {
          const r2 = new URL(document.referrer);
          if (r2.origin === window.location.origin && r2.pathname !== window.location.pathname) entry = r2.pathname + r2.search;
        }
        if (entry) sessionStorage.setItem(ENTRY_KEY, entry);
      }
    } catch (e24) {
    }
    const brandHome = !opts.onHome;
    if (brandHome) {
      const icon = opts.homeIcon || "https://ninjatransfers.com/cdn/shop/files/Ninja_Transfers_Head_2x_37a0a33c-929c-4dcf-be28-034b8e4c5682.png?width=96";
      ui2.homeBtn.classList.add("nsv2-home-btn--brand");
      ui2.homeBtn.title = "Ninja Transfers home";
      ui2.homeBtn.setAttribute("aria-label", "Ninja Transfers home");
      ui2.homeBtn.innerHTML = '<img src="' + icon.replace(/"/g, "&quot;") + '" width="28" height="28" alt="" decoding="async">';
    }
    ui2.homeBtn.addEventListener("click", () => {
      track("exit");
      if (opts.onHome) return opts.onHome();
      if (brandHome) {
        window.location.href = "/";
        return;
      }
      let entry = null;
      try {
        entry = sessionStorage.getItem(ENTRY_KEY);
      } catch (e24) {
      }
      window.location.href = entry || "/";
    });
    let customSize = false;
    const dispW = () => fmtNum(fromIn(editor.designWIn));
    const dispH = () => fmtNum(fromIn(editor.designHIn));
    const presetKey = (w2, h2) => {
      const k2 = w2 + "x" + h2;
      return [...ui2.sizeSel.options].some((o2) => o2.value === k2) ? k2 : "";
    };
    function syncCanvasSize() {
      ui2.sizeW.value = dispW();
      ui2.sizeH.value = dispH();
      const key = presetKey(dispW(), dispH());
      const custom = customSize || !key;
      ui2.sizeSel.value = custom ? "custom" : key;
      ui2.sizeCustom.hidden = !custom;
    }
    function applyCanvasSize() {
      const clamp = (v2, prev) => {
        const n2 = parseFloat(v2);
        return isNaN(n2) ? prev : Math.min(board.max, Math.max(board.min, n2));
      };
      editor.setCanvasSize(toIn(clamp(ui2.sizeW.value, fromIn(editor.designWIn))), toIn(clamp(ui2.sizeH.value, fromIn(editor.designHIn))));
      syncCanvasSize();
    }
    ui2.sizeW.addEventListener("change", applyCanvasSize);
    ui2.sizeH.addEventListener("change", applyCanvasSize);
    ui2.sizeSel.addEventListener("change", () => {
      if (ui2.sizeSel.value === "custom") {
        customSize = true;
        syncCanvasSize();
        ui2.sizeW.focus();
        return;
      }
      customSize = false;
      const [w2, h2] = ui2.sizeSel.value.split("x").map(parseFloat);
      editor.setCanvasSize(toIn(w2), toIn(h2));
      syncCanvasSize();
    });
    editor.on("canvassize", () => {
      syncCanvasSize();
      if (editor.lastCanvasFit && editor.lastCanvasFit.scaled) {
        editor.lastCanvasFit = null;
        showFitNotice("Design scaled to fit the new canvas size.", false);
      }
    });
    syncCanvasSize();
    let fitNoticeT = 0;
    function showFitNotice(msg2, withAction) {
      clearTimeout(fitNoticeT);
      ui2.fitAlertMsg.textContent = msg2;
      ui2.fitAlertAct.hidden = !withAction;
      ui2.fitAlert.classList.toggle("is-stacked", !ui2.bgAlert.hidden);
      ui2.fitAlert.hidden = false;
      if (!withAction) fitNoticeT = setTimeout(() => {
        ui2.fitAlert.hidden = true;
      }, 3200);
    }
    ui2.fitAlertAct.addEventListener("click", () => {
      editor.fitContentToBoard();
      ui2.fitAlert.hidden = true;
    });
    ui2.fitAlertX.addEventListener("click", () => {
      ui2.fitAlert.hidden = true;
    });
    let toastT = 0, toastOnAct = null;
    function showToast(msg2, act, ms2 = 4500) {
      clearTimeout(toastT);
      ui2.toastMsg.textContent = msg2;
      toastOnAct = act && act.onAction ? act.onAction : null;
      ui2.toastAct.textContent = act && act.label ? act.label : "";
      ui2.toastAct.hidden = !toastOnAct;
      ui2.toast.classList.toggle("is-stacked", !ui2.bgAlert.hidden || !ui2.fitAlert.hidden);
      ui2.toast.hidden = false;
      toastT = setTimeout(() => {
        ui2.toast.hidden = true;
      }, ms2);
    }
    ui2.toastAct.addEventListener("click", () => {
      const f2 = toastOnAct;
      ui2.toast.hidden = true;
      clearTimeout(toastT);
      if (f2) f2();
    });
    ui2.toastX.addEventListener("click", () => {
      ui2.toast.hidden = true;
      clearTimeout(toastT);
    });
    editor.on("deleted", (d2) => {
      const n2 = d2 && d2.count ? d2.count : 1;
      showToast(n2 > 1 ? n2 + " elements deleted" : "Deleted", { label: "Undo", onAction: () => {
        editor.undo();
        syncSelection();
      } });
    });
    async function confirmOverhangBeforeExport() {
      if (!editor.contentOverhang()) return true;
      const r2 = await askDialog("Part of your design is outside the canvas and won\u2019t print.", { ok: "Fit to canvas", cancel: "Export anyway" });
      if (r2 === true) editor.fitContentToBoard();
      return true;
    }
    function syncCanvasBg() {
      const c2 = editor.boardBg;
      ui2.bgSwatch.classList.toggle("has-color", !!c2);
      ui2.bgSwatch.style.background = c2 || "";
      if (!c2) ui2.bgAlert.hidden = true;
      else if (!bgAlertShown) {
        bgAlertShown = true;
        ui2.bgAlert.hidden = false;
      }
      if (c2) ui2.bgColorInput.value = c2;
    }
    ui2.bgBtn.addEventListener("click", (e24) => {
      if (e24.target === ui2.bgColorInput) {
        e24.preventDefault();
      }
      if (activePane === "color" && colorTarget === "canvasBg") return closeColors();
      colorTarget = "canvasBg";
      openColors();
    });
    ui2.bgColorInput.addEventListener("input", () => {
      editor.setCanvasBackground(ui2.bgColorInput.value);
      syncCanvasBg();
    });
    let bgAlertShown = false;
    ui2.bgAlert.querySelector(".nsv2-bg-alert-x").addEventListener("click", () => {
      ui2.bgAlert.hidden = true;
    });
    ui2.bgClear.addEventListener("click", () => {
      editor.setCanvasBackground(null);
      syncCanvasBg();
    });
    editor.on("canvasbg", syncCanvasBg);
    editor.on("canvasbg", () => {
      if (activePane === "layers") renderLayers();
    });
    syncCanvasBg();
    const captureCenter = () => {
      const s3 = ui2.boardScroll;
      return {
        fx: s3.scrollWidth > s3.clientWidth ? (s3.scrollLeft + s3.clientWidth / 2) / s3.scrollWidth : 0.5,
        fy: s3.scrollHeight > s3.clientHeight ? (s3.scrollTop + s3.clientHeight / 2) / s3.scrollHeight : 0.5
      };
    };
    const restoreCenter = ({ fx, fy }) => {
      const s3 = ui2.boardScroll;
      const bw = editor.designW * editor.fitScale * editor.userZoom;
      const bh = editor.designH * editor.fitScale * editor.userZoom;
      s3.scrollLeft = bw <= s3.clientWidth ? (s3.scrollWidth - s3.clientWidth) / 2 : fx * s3.scrollWidth - s3.clientWidth / 2;
      s3.scrollTop = bh <= s3.clientHeight ? (s3.scrollHeight - s3.clientHeight) / 2 : fy * s3.scrollHeight - s3.clientHeight / 2;
      editor.canvas.calcOffset();
    };
    const zoomKeepCenter = (fn2) => {
      const c2 = captureCenter();
      fn2();
      restoreCenter(c2);
    };
    const zoomAnimateKeepCenter = (targetUserZoom) => {
      const c2 = captureCenter();
      editor.animateZoom(targetUserZoom, () => restoreCenter(c2));
    };
    const frameCoalesce = () => {
      let raf = 0, fn2 = null;
      return (f2) => {
        fn2 = f2;
        if (!raf) raf = requestAnimationFrame(() => {
          raf = 0;
          const g2 = fn2;
          fn2 = null;
          if (g2) g2();
        });
      };
    };
    const sliderFrame = frameCoalesce();
    const zoomCtl = (() => {
      const row = ui2.sliderRow("Zoom", 1, 400, 1, editor.zoomPercent);
      row.wrap.classList.add("nsv2-mtray-sliderrow");
      const stepBtn = (txt, factor) => {
        const b2 = document.createElement("button");
        b2.type = "button";
        b2.className = "nsv2-zoom-step";
        b2.textContent = txt;
        b2.title = factor > 1 ? "Zoom in" : "Zoom out";
        b2.addEventListener("click", () => zoomAnimateKeepCenter(editor.userZoom * factor));
        return b2;
      };
      row.range.before(stepBtn("\u2212", 1 / 1.2));
      row.range.after(stepBtn("+", 1.2));
      const fit = document.createElement("button");
      fit.type = "button";
      fit.className = "nsv2-zoom-fitbtn";
      fit.innerHTML = icons.expand;
      fit.title = "Fit";
      const sync = () => {
        row.range.min = String(Math.max(1, Math.round(editor.fitScale * 25)));
        row.range.max = String(Math.max(2, Math.round(editor.fitScale * 400)));
        row.range.value = String(editor.zoomPercent);
        row.num.value = String(editor.zoomPercent);
      };
      row.range.addEventListener("input", () => {
        const v2 = row.range.valueAsNumber;
        sliderFrame(() => {
          zoomKeepCenter(() => editor.setZoomPercent(v2));
          row.num.value = String(editor.zoomPercent);
        });
      });
      row.num.addEventListener("change", () => {
        const p2 = parseFloat(row.num.value) || editor.zoomPercent;
        zoomAnimateKeepCenter(p2 / 100 / editor.fitScale);
      });
      fit.addEventListener("click", () => zoomAnimateKeepCenter(1));
      editor.on("zoom", sync);
      sync();
      ui2.zoom.append(row.wrap, fit);
      const barEl = () => document.getElementById("PBarNextFrameWrapper");
      const barCovers = (bar) => {
        const cs2 = getComputedStyle(bar);
        return cs2.display !== "none" && cs2.visibility !== "hidden" && parseFloat(cs2.opacity) > 0;
      };
      const liftAbovePreviewBar = () => {
        const bar = barEl();
        const r2 = bar && barCovers(bar) ? bar.getBoundingClientRect() : null;
        const overlap = r2 && r2.height > 0 ? ui2.area.getBoundingClientRect().bottom - r2.top : 0;
        ui2.zoom.style.bottom = overlap > 2 ? Math.round(overlap + 12) + "px" : "";
        return !!bar;
      };
      let barWatched = null;
      const watchBar = () => {
        const bar = barEl();
        if (!bar || bar === barWatched) return !!bar;
        barWatched = bar;
        if (window.ResizeObserver) {
          const ro2 = new ResizeObserver(liftAbovePreviewBar);
          ro2.observe(bar);
          cleanups.push(() => ro2.disconnect());
        }
        if (window.MutationObserver) {
          const mo2 = new MutationObserver(liftAbovePreviewBar);
          mo2.observe(bar, { attributes: true, childList: true, subtree: true });
          cleanups.push(() => mo2.disconnect());
        }
        listen(bar, "transitionend", liftAbovePreviewBar);
        return true;
      };
      listen(window, "resize", liftAbovePreviewBar);
      liftAbovePreviewBar();
      watchBar();
      if (window.MutationObserver) {
        const arrival = new MutationObserver(() => {
          if (barEl() && watchBar()) liftAbovePreviewBar();
        });
        arrival.observe(document.body, { childList: true });
        cleanups.push(() => arrival.disconnect());
      }
      return { row, fit, home: () => ui2.zoom.append(row.wrap, fit) };
    })();
    function fillZoomTray(scroll) {
      scroll.append(zoomCtl.row.wrap, zoomCtl.fit);
    }
    zoomCtlHome = () => zoomCtl.home();
    const openZoomTray = () => {
      if (mtrayKind === "zoom") return closeMtray();
      openMtray("zoom", fillZoomTray);
    };
    {
      const scroll = ui2.boardScroll;
      scroll.addEventListener("touchstart", (e24) => {
        if (e24.touches.length !== 1) return;
        let target2 = null;
        try {
          const f2 = editor.canvas.findTarget(e24);
          target2 = f2 && typeof f2 === "object" ? "target" in f2 ? f2.target : null : f2;
        } catch (err) {
        }
        const sc2 = ui2.boardScroll;
        const zoomedIn = sc2.scrollWidth > sc2.clientWidth + 1 || sc2.scrollHeight > sc2.clientHeight + 1;
        const act = editor.canvas.getActiveObject();
        const isActive = target2 && act && (target2 === act || act.getObjects && act.getObjects().includes(target2));
        editor.canvas.allowTouchScrolling = !(target2 && (!zoomedIn || isActive));
      }, { capture: true, passive: true });
      const sceneAt = (clientX, clientY) => {
        const cr2 = editor.canvas.upperCanvasEl.getBoundingClientRect();
        const scale = editor.fitScale * editor.userZoom;
        return {
          x: (clientX - cr2.left - editor.apronX) / scale,
          y: (clientY - cr2.top - editor.apronY) / scale
        };
      };
      const pinScene = (scene, clientX, clientY) => {
        const r2 = scroll.getBoundingClientRect();
        const cr2 = editor.canvas.upperCanvasEl.getBoundingClientRect();
        const scale = editor.fitScale * editor.userZoom;
        const contLeft = cr2.left - r2.left + scroll.scrollLeft;
        const contTop = cr2.top - r2.top + scroll.scrollTop;
        const bw = editor.designW * scale;
        const bh = editor.designH * scale;
        const wantX = contLeft + editor.apronX + scene.x * scale - (clientX - r2.left);
        const wantY = contTop + editor.apronY + scene.y * scale - (clientY - r2.top);
        scroll.scrollLeft = bw <= scroll.clientWidth ? (scroll.scrollWidth - scroll.clientWidth) / 2 : wantX;
        scroll.scrollTop = bh <= scroll.clientHeight ? (scroll.scrollHeight - scroll.clientHeight) / 2 : wantY;
        editor.canvas.calcOffset();
      };
      let pinch0 = null;
      const spread = (e24) => {
        const [a2, b2] = e24.touches;
        return Math.hypot(a2.clientX - b2.clientX, a2.clientY - b2.clientY);
      };
      const mid = (e24) => {
        const [a2, b2] = e24.touches;
        return { x: (a2.clientX + b2.clientX) / 2, y: (a2.clientY + b2.clientY) / 2 };
      };
      scroll.addEventListener("touchstart", (e24) => {
        if (e24.touches.length === 2) {
          const m = mid(e24);
          pinch0 = { d: spread(e24), z: editor.userZoom, scene: sceneAt(m.x, m.y) };
        }
      }, { passive: true });
      const pinchFrame = frameCoalesce();
      scroll.addEventListener("touchmove", (e24) => {
        if (e24.touches.length === 2 && pinch0 && pinch0.d > 0) {
          e24.preventDefault();
          editor.beginGesture();
          const target2 = Math.min(4, Math.max(0.25, pinch0.z * (spread(e24) / pinch0.d)));
          const m = mid(e24);
          const anchor = pinch0.scene;
          pinchFrame(() => {
            editor._cancelZoomAnim();
            if (Math.abs(target2 - editor.userZoom) > 4e-3) {
              editor.userZoom = target2;
              editor._applyZoom();
            }
            pinScene(anchor, m.x, m.y);
          });
        }
      }, { passive: false });
      const wheelFrame = frameCoalesce();
      let wheelDelta = 0, wheelPt = null;
      scroll.addEventListener("wheel", (e24) => {
        if (!(e24.ctrlKey || e24.metaKey)) return;
        e24.preventDefault();
        editor.beginGesture();
        const unit = e24.deltaMode === 1 ? 16 : e24.deltaMode === 2 ? 400 : 1;
        wheelDelta += e24.deltaY * unit;
        wheelPt = { x: e24.clientX, y: e24.clientY };
        wheelFrame(() => {
          const dy = wheelDelta;
          wheelDelta = 0;
          if (!dy || !wheelPt) return;
          editor._cancelZoomAnim();
          const scene = sceneAt(wheelPt.x, wheelPt.y);
          const target2 = Math.min(4, Math.max(0.25, editor.userZoom * Math.exp(-dy * 15e-4)));
          if (Math.abs(target2 - editor.userZoom) < 5e-4) return;
          editor.userZoom = target2;
          editor._applyZoom();
          pinScene(scene, wheelPt.x, wheelPt.y);
        });
      }, { passive: false });
      const endPinch = (e24) => {
        if (!e24.touches || e24.touches.length < 2) pinch0 = null;
      };
      scroll.addEventListener("touchend", endPinch);
      scroll.addEventListener("touchcancel", endPinch);
      let lastTap = null;
      scroll.addEventListener("touchend", (e24) => {
        if (e24.touches.length || e24.changedTouches.length !== 1) {
          lastTap = null;
          return;
        }
        const t2 = e24.changedTouches[0];
        let target2 = null;
        try {
          const f2 = editor.canvas.findTarget(e24);
          target2 = f2 && typeof f2 === "object" ? "target" in f2 ? f2.target : null : f2;
        } catch (err) {
        }
        if (target2) {
          lastTap = null;
          return;
        }
        const now = Date.now();
        if (lastTap && now - lastTap.t < 320 && Math.hypot(t2.clientX - lastTap.x, t2.clientY - lastTap.y) < 30) {
          lastTap = null;
          const scene = sceneAt(t2.clientX, t2.clientY);
          const atFit = Math.abs(editor.userZoom - 1) < 0.05;
          editor.animateZoom(atFit ? 1 / editor.fitScale : 1, () => pinScene(scene, t2.clientX, t2.clientY));
        } else {
          lastTap = { t: now, x: t2.clientX, y: t2.clientY };
        }
      });
    }
    const VIEW_KEY = "nsv2ViewPrefs";
    const GR = gridRange();
    let viewPrefs = { grid: false, gridSizeIn: toIn(GR.def), rulers: false };
    try {
      Object.assign(viewPrefs, JSON.parse(localStorage.getItem(VIEW_KEY) || "{}"));
    } catch (e24) {
    }
    const saveViewPrefs = () => {
      try {
        localStorage.setItem(VIEW_KEY, JSON.stringify(viewPrefs));
      } catch (e24) {
      }
    };
    function syncGridUI() {
      ui2.gridToggle.classList.toggle("is-on", viewPrefs.grid);
      ui2.gridToggle.setAttribute("aria-pressed", String(viewPrefs.grid));
      ui2.gridBtn.classList.toggle("is-on", viewPrefs.grid);
      ui2.rulerBtn.classList.toggle("is-on", viewPrefs.rulers);
      ui2.gridSize.range.value = String(fmtNum(fromIn(viewPrefs.gridSizeIn)));
      ui2.gridSize.num.value = String(fmtNum(fromIn(viewPrefs.gridSizeIn)));
    }
    function applyViewPrefs() {
      editor.setGrid({ on: viewPrefs.grid, sizeIn: viewPrefs.gridSizeIn });
      ui2.rulerX.hidden = ui2.rulerY.hidden = ui2.rulerCorner.hidden = !viewPrefs.rulers;
      ui2.root.classList.toggle("nsv2-rulers-on", viewPrefs.rulers);
      editor.fitToContainer();
      drawRulers();
      saveViewPrefs();
    }
    function placeGridRow() {
      const inSheet = isMobileView() && ui2.gridBtn.closest(".nsv2-canvas-pane");
      if (inSheet && viewPrefs.grid) {
        if (ui2.gridSize.wrap.parentElement !== ui2.ctxCanvasGroup) ui2.ctxCanvasGroup.appendChild(ui2.gridSize.wrap);
      } else if (ui2.gridSize.wrap.parentElement !== ui2.gridPop) {
        ui2.gridPop.appendChild(ui2.gridSize.wrap);
      }
    }
    ui2.gridBtn.addEventListener("click", () => {
      if (isMobileView() && ui2.gridBtn.closest(".nsv2-canvas-pane")) {
        ui2.gridPop.hidden = true;
        viewPrefs.grid = !viewPrefs.grid;
        syncGridUI();
        applyViewPrefs();
        placeGridRow();
        return;
      }
      if (!ui2.gridPop.hidden) return ui2.gridPop.hidden = true;
      syncGridUI();
      ui2.gridPop.hidden = false;
      const br2 = ui2.gridBtn.getBoundingClientRect();
      const ar2 = ui2.area.getBoundingClientRect();
      const w2 = ui2.gridPop.offsetWidth;
      const x2 = Math.min(Math.max(8, br2.left - ar2.left - w2 / 2 + br2.width / 2), ui2.area.clientWidth - w2 - 8);
      ui2.gridPop.style.transform = "translate(" + x2 + "px, " + (br2.bottom - ar2.top + 8) + "px)";
    });
    listen(document, "pointerdown", (e24) => {
      if (!ui2.gridPop.hidden && !ui2.gridPop.contains(e24.target) && !ui2.gridBtn.contains(e24.target)) ui2.gridPop.hidden = true;
    });
    ui2.gridToggle.addEventListener("click", () => {
      viewPrefs.grid = !viewPrefs.grid;
      syncGridUI();
      applyViewPrefs();
    });
    ui2.rulerBtn.addEventListener("click", () => {
      viewPrefs.rulers = !viewPrefs.rulers;
      syncGridUI();
      applyViewPrefs();
    });
    const applyGridSize = (v2) => {
      viewPrefs.gridSizeIn = toIn(Math.max(GR.min, Math.min(GR.max, roundStep(parseFloat(v2) || GR.def, GR.step))));
      syncGridUI();
      applyViewPrefs();
    };
    ui2.gridSize.range.addEventListener("input", () => applyGridSize(ui2.gridSize.range.value));
    ui2.gridSize.num.addEventListener("change", () => applyGridSize(ui2.gridSize.num.value));
    syncGridUI();
    editor.on("canvaspane", placeGridRow);
    function drawRulers() {
      if (!viewPrefs.rulers) return;
      const dpr = window.devicePixelRatio || 1;
      const sRect = ui2.boardScroll.getBoundingClientRect();
      const aRect = ui2.area.getBoundingClientRect();
      const cRect = editor.canvas.upperCanvasEl.getBoundingClientRect();
      const scale = editor.canvas.getZoom();
      const apronX = editor.apronX;
      const apronY = editor.apronY;
      const setup = (cv2, wPx, hPx, left, top2) => {
        cv2.style.left = left + "px";
        cv2.style.top = top2 + "px";
        cv2.style.width = wPx + "px";
        cv2.style.height = hPx + "px";
        cv2.width = Math.max(1, Math.round(wPx * dpr));
        cv2.height = Math.max(1, Math.round(hPx * dpr));
        const ctx = cv2.getContext("2d");
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, wPx, hPx);
        ctx.strokeStyle = "#94a3b8";
        ctx.fillStyle = "#64748b";
        ctx.lineWidth = 1;
        ctx.font = "9.5px system-ui, sans-serif";
        return ctx;
      };
      const R3 = 22;
      const sTopRaw = sRect.top - aRect.top;
      const sLeft = sRect.left - aRect.left;
      const barBottom = isMobileView() ? 0 : ui2.ctxbar.offsetHeight || 0;
      const top = Math.max(sTopRaw, barBottom);
      ui2.rulerCorner.style.left = sLeft + "px";
      ui2.rulerCorner.style.top = top + "px";
      const inchPx = toIn(1) * 50 * scale;
      const steps = rulerSteps();
      let labelIn = steps.slice(0, -1).find((s22) => s22 * inchPx >= 34) || steps[steps.length - 1];
      let minorIn = labelIn / 4;
      if (minorIn * inchPx < 7) minorIn = labelIn / 2;
      if (minorIn * inchPx < 7) minorIn = labelIn;
      {
        const wPx = sRect.width;
        const ctx = setup(ui2.rulerX, wPx, R3, sLeft, top);
        const originX = cRect.left - sRect.left + apronX;
        const maxIn = fromIn(editor.designWIn);
        for (let v2 = 0; v2 <= maxIn + 1e-6; v2 += minorIn) {
          const x2 = originX + v2 * inchPx;
          if (x2 < R3 - 4 || x2 > wPx + 4) continue;
          const whole = Math.abs(v2 / labelIn - Math.round(v2 / labelIn)) < 1e-6;
          ctx.beginPath();
          ctx.moveTo(Math.round(x2) + 0.5, whole ? 8 : 15);
          ctx.lineTo(Math.round(x2) + 0.5, R3);
          ctx.stroke();
          if (whole) ctx.fillText(String(Math.round(v2)), x2 + 3, 10);
        }
      }
      {
        const hPx = Math.max(1, sRect.height - (top - sTopRaw));
        const ctx = setup(ui2.rulerY, R3, hPx, sLeft, top);
        const originY = cRect.top - aRect.top - top + apronY;
        const maxIn = fromIn(editor.designHIn);
        for (let v2 = 0; v2 <= maxIn + 1e-6; v2 += minorIn) {
          const y2 = originY + v2 * inchPx;
          if (y2 < R3 - 4 || y2 > hPx + 4) continue;
          const whole = Math.abs(v2 / labelIn - Math.round(v2 / labelIn)) < 1e-6;
          ctx.beginPath();
          ctx.moveTo(whole ? 8 : 15, Math.round(y2) + 0.5);
          ctx.lineTo(R3, Math.round(y2) + 0.5);
          ctx.stroke();
          if (whole) {
            ctx.save();
            ctx.translate(9, y2 + 3);
            ctx.rotate(-Math.PI / 2);
            ctx.fillText(String(Math.round(v2)), 0, 0);
            ctx.restore();
          }
        }
      }
    }
    editor.on("zoom", drawRulers);
    editor.on("canvassize", drawRulers);
    listen(window, "resize", drawRulers);
    queueMicrotask(applyViewPrefs);
    const clientToScene = (e24) => {
      const r2 = editor.canvas.upperCanvasEl.getBoundingClientRect();
      const vpt = editor.canvas.viewportTransform;
      return { x: (e24.clientX - r2.left - vpt[4]) / vpt[0], y: (e24.clientY - r2.top - vpt[5]) / vpt[3] };
    };
    const findTargetAt = (e24) => {
      const f2 = editor.canvas.findTarget ? editor.canvas.findTarget(e24) : null;
      if (!f2 || typeof f2 !== "object") return f2 || null;
      return "target" in f2 ? f2.target || null : f2.isType ? f2 : null;
    };
    const guidePrev = document.createElement("div");
    guidePrev.className = "nsv2-guide-preview";
    guidePrev.hidden = true;
    ui2.area.appendChild(guidePrev);
    const guideBadge = document.createElement("div");
    guideBadge.className = "nsv2-guide-badge";
    guideBadge.hidden = true;
    ui2.area.appendChild(guideBadge);
    function positionGuideBadge(axis, e24, t2) {
      const a2 = ui2.area.getBoundingClientRect();
      guideBadge.textContent = (Math.round(t2 / 50 * 1e3) / 1e3).toFixed(3).replace(/0+$/, "").replace(/\.$/, "") + '"';
      guideBadge.hidden = false;
      const rul = (axis === "v" ? ui2.rulerX : ui2.rulerY).getBoundingClientRect();
      if (axis === "v") {
        guideBadge.style.left = Math.round(e24.clientX - a2.left + 4) + "px";
        guideBadge.style.top = Math.round(rul.height ? rul.top - a2.top : 2) + "px";
      } else {
        guideBadge.style.left = Math.round((rul.width ? rul.left - a2.left : 2) + 2) + "px";
        guideBadge.style.top = Math.round(e24.clientY - a2.top - 20) + "px";
      }
    }
    function positionGuidePreview(axis, e24) {
      const a2 = ui2.area.getBoundingClientRect();
      guidePrev.hidden = false;
      if (axis === "v") {
        guidePrev.style.cssText = "left:" + Math.round(e24.clientX - a2.left) + "px;top:0;width:1px;height:100%";
      } else {
        guidePrev.style.cssText = "top:" + Math.round(e24.clientY - a2.top) + "px;left:0;height:1px;width:100%";
      }
      guidePrev.hidden = false;
    }
    function guideDragLoop(axis, existingIndex) {
      document.body.style.cursor = axis === "v" ? "col-resize" : "row-resize";
      ui2.area.classList.add(axis === "v" ? "is-guide-drag-v" : "is-guide-drag-h");
      const move = (e24) => {
        const p2 = clientToScene(e24);
        const t2 = axis === "v" ? p2.x : p2.y;
        positionGuidePreview(axis, e24);
        positionGuideBadge(axis, e24, t2);
        if (existingIndex != null) editor.moveGuide(axis, existingIndex, t2);
        e24.preventDefault();
      };
      const up = (e24) => {
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", up);
        guidePrev.hidden = true;
        guideBadge.hidden = true;
        document.body.style.cursor = "";
        ui2.area.classList.remove("is-guide-drag-v", "is-guide-drag-h");
        const p2 = clientToScene(e24);
        const t2 = axis === "v" ? p2.x : p2.y;
        const max = axis === "v" ? editor.designW : editor.designH;
        const onBoard = t2 >= 0 && t2 <= max;
        if (existingIndex != null) {
          if (!onBoard) editor.removeGuide(axis, existingIndex);
          else {
            editor.moveGuide(axis, existingIndex, t2);
            editor._record();
          }
        } else if (onBoard) {
          editor.addGuide(axis, t2);
        }
      };
      listen(window, "pointermove", move);
      listen(window, "pointerup", up);
    }
    ui2.rulerX.addEventListener("pointerdown", (e24) => {
      e24.preventDefault();
      guideDragLoop("h", null);
    });
    ui2.rulerY.addEventListener("pointerdown", (e24) => {
      e24.preventDefault();
      guideDragLoop("v", null);
    });
    editor.canvas.upperCanvasEl.addEventListener(
      "pointerdown",
      (e24) => {
        const z2 = editor.canvas.getZoom() || 1;
        const hit = editor.hitGuide(clientToScene(e24), 8 / z2);
        if (!hit) return;
        const target2 = findTargetAt(e24);
        if (target2 && hit.d > 4 / z2) return;
        e24.preventDefault();
        e24.stopPropagation();
        guideDragLoop(hit.axis, hit.i);
      },
      true
    );
    editor.canvas.upperCanvasEl.addEventListener("mousemove", (e24) => {
      if (e24.buttons) return;
      const z2 = editor.canvas.getZoom() || 1;
      const hit = editor.hitGuide(clientToScene(e24), 8 / z2);
      let axis = null;
      if (hit) {
        const target2 = findTargetAt(e24);
        if (!target2 || hit.d <= 4 / z2) axis = hit.axis;
      }
      ui2.area.classList.toggle("is-guide-hover-v", axis === "v");
      ui2.area.classList.toggle("is-guide-hover-h", axis === "h");
    });
    editor.canvas.upperCanvasEl.addEventListener("mouseleave", () => {
      ui2.area.classList.remove("is-guide-hover-v", "is-guide-hover-h");
    });
    ui2.boardScroll.addEventListener("scroll", () => {
      editor.beginGesture();
      drawRulers();
      editor.canvas.calcOffset();
      positionQa();
    });
    const USE_PRODUCTS = opts.useProducts || [
      { title: "DTF Transfers", url: "/products/dtf-transfers", img: "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/DTF-by-size.png" },
      { title: "UV DTF PermaStickers\u2122", url: "/products/uv-dtf-stickers-decals-by-size", img: "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/UV-by-size-hero-v4-1.jpg" },
      { title: "Transfer Stickers", url: "/products/transfer-stickers-by-size", img: "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/transfer-stickersninja-transfers-551688.jpg" },
      { title: "Spangle Transfers", url: "/products/spangle-transfers", img: "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/DTF_Spangle_Transfers_579ce79c-f7e0-4ad4-a21e-96c57347c601.png" },
      { title: "3D Puff Transfers", url: "/products/3d-puff-transfers", img: "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/3d_Puff_Transfer_2700f976-338f-45e1-8cbb-21e2e08ac09e.png" },
      { title: "3D Glitter Puff", url: "/products/3d-glitter-puff-transfers", img: "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/Glitter_puff_Transfers.png" }
    ];
    let useModalBuilt = false;
    function openUseModal() {
      if (!useModalBuilt) {
        useModalBuilt = true;
        const frag = document.createDocumentFragment();
        for (const p2 of USE_PRODUCTS) {
          const tile = document.createElement("button");
          tile.type = "button";
          tile.className = "nsv2-use-tile";
          tile.innerHTML = '<img loading="lazy" src="' + p2.img + (p2.img.includes("?") ? "&" : "?") + 'width=180" alt=""><span>' + p2.title + "</span>";
          tile.addEventListener("click", () => chooseUseProduct(p2, tile));
          frag.appendChild(tile);
        }
        ui2.useGrid.appendChild(frag);
      }
      ui2.useBusy.hidden = true;
      ui2.useGrid.hidden = false;
      ui2.useModal.hidden = false;
    }
    function closeUseModal() {
      ui2.useModal.hidden = true;
    }
    async function chooseUseProduct(product, tile) {
      if (!ui2.useBusy.hidden) return;
      await confirmOverhangBeforeExport();
      ui2.useGrid.querySelectorAll(".nsv2-use-tile").forEach((t2) => t2.classList.toggle("is-picked", t2 === tile));
      ui2.useBusy.hidden = false;
      try {
        const result = await exportAndUpload(editor, { customerId: opts.customerId });
        trackUse();
        try {
          localStorage.removeItem(DRAFT_KEY);
        } catch (e24) {
        }
        window.location.href = product.url + result.handoffQuery;
      } catch (err) {
        console.error("studio-v2: Use Design failed", err);
        diagFail("export_fail", err);
        ui2.useBusy.textContent = "Something went wrong \u2014 try again";
        setTimeout(() => {
          ui2.useBusy.hidden = true;
          ui2.useBusy.textContent = "Preparing your design\u2026";
        }, 2500);
      }
    }
    ui2.useClose.addEventListener("click", closeUseModal);
    ui2.useModal.addEventListener("click", (e24) => {
      if (e24.target === ui2.useModal && ui2.useBusy.hidden) closeUseModal();
    });
    ui2.useBtn.addEventListener("click", async () => {
      if (!editor.canvas.getObjects().length) return;
      if (typeof opts.onUseDesign === "function") {
        if (ui2.useBtn.classList.contains("is-busy")) return;
        await confirmOverhangBeforeExport();
        ui2.useBtn.classList.add("is-busy");
        const label = ui2.useBtn.querySelector("span");
        const prev = label.textContent;
        label.textContent = "Saving\u2026";
        try {
          const exportOpts = { customerId: opts.customerId };
          const all = editor.canvas.getObjects();
          const base = baseImg ? all.find((o2) => o2.__base) : null;
          const wantPx = base && baseImg.pxW > 0 ? Math.round(baseImg.pxW * editor.designW / Math.max(1, base.getScaledWidth())) : 0;
          if (wantPx) exportOpts.targetPx = Math.max(600, Math.min(9e3, wantPx));
          const out = await exportAndUpload(editor, exportOpts);
          if (baseImg) {
            out.baseUrl = baseImg.url;
            out.textCount = all.filter((o2) => !o2.__base).length;
          }
          if (wantPx && out.exportPx > 0) out.artScale = out.exportPx / wantPx;
          trackUse();
          await opts.onUseDesign(out);
          label.textContent = prev;
        } catch (err) {
          console.error("studio-v2: Use Design failed", err);
          diagFail("export_fail", err);
          label.textContent = "Try again";
          setTimeout(() => label.textContent = prev, 2500);
        } finally {
          ui2.useBtn.classList.remove("is-busy");
        }
        return;
      }
      openUseModal();
    });
    ui2.designNameInput.hidden = chromeHidden("name");
    const PARKED_KEY = "nsv2ParkedSave";
    let savesInFlight = 0;
    listen(window, "beforeunload", (e24) => {
      if (!savesInFlight) return;
      e24.preventDefault();
      e24.returnValue = "";
    });
    async function parkSaveAndLogin() {
      if (ui2.saveBtn.classList.contains("is-busy")) return;
      if (!editor.canvas.getObjects().length) return;
      ui2.saveBtn.classList.add("is-busy");
      savesInFlight++;
      const label = ui2.saveBtn.querySelector("span");
      const prev = label.textContent;
      label.textContent = "Saving\u2026";
      try {
        const name = ui2.designNameInput.value.trim() || "Untitled design";
        const parked = await uploadDesignArtifacts(editor, { name });
        savesInFlight--;
        localStorage.setItem(PARKED_KEY, JSON.stringify(parked));
        try {
          localStorage.setItem(DRAFT_KEY, editor.designJSON());
        } catch (e24) {
        }
        label.textContent = "Sign in to finish\u2026";
        gotoLogin("designs");
      } catch (err) {
        savesInFlight = Math.max(0, savesInFlight - 1);
        console.error("studio-v2: parked save failed", err);
        diagFail("save_fail", err);
        label.textContent = "Try again";
        setTimeout(() => label.textContent = prev, 2500);
        ui2.saveBtn.classList.remove("is-busy");
      }
    }
    try {
      const rp = sessionStorage.getItem(RETURN_PANE_KEY);
      if (rp) {
        sessionStorage.removeItem(RETURN_PANE_KEY);
        setTimeout(() => openPane(rp), 600);
      }
    } catch (e24) {
    }
    if (!registry) {
      try {
        const parked = JSON.parse(localStorage.getItem(PARKED_KEY) || "null");
        if (parked && parked.stateUrl) {
          if (parked.name) ui2.designNameInput.value = parked.name;
          setTimeout(() => {
            if (!editor.canvas.getObjects().length) {
              loadDesignFromUrl(editor, parked.stateUrl).catch((err) => console.warn("studio-v2: parked restore failed", err));
            }
          }, 800);
        }
      } catch (e24) {
      }
    }
    if (registry) {
      try {
        const raw = localStorage.getItem(PARKED_KEY);
        if (raw) {
          localStorage.removeItem(PARKED_KEY);
          const parked = JSON.parse(raw);
          registerParked(registry, parked).then(() => {
            adoptSave({ fileName: parked.fileName, name: parked.name });
            noteSessionSave({ previewUrl: parked.previewUrl, fileName: parked.fileName });
            const label = ui2.saveBtn.querySelector("span");
            const prev = label.textContent;
            label.textContent = "Saved \u2713";
            setTimeout(() => label.textContent = prev, 2500);
          }).catch((err) => console.error("studio-v2: parked save registration failed", err));
          setTimeout(() => {
            if (!editor.canvas.getObjects().length && parked.stateUrl) {
              loadDesignFromUrl(editor, parked.stateUrl).catch((err) => console.warn("studio-v2: parked restore failed", err));
            }
          }, 800);
        }
      } catch (e24) {
      }
    }
    let currentSave = null;
    function adoptSave(meta) {
      currentSave = meta ? { fileName: meta.fileName, name: meta.name || "" } : null;
      if (meta && meta.name) ui2.designNameInput.value = meta.name;
      try {
        if (currentSave) localStorage.setItem(SAVE_KEY, JSON.stringify(currentSave));
        else localStorage.removeItem(SAVE_KEY);
      } catch (e24) {
      }
    }
    const currentName = () => ui2.designNameInput.value.trim() || "Untitled design";
    const copyName = (n2) => /\scopy$/.test(n2) ? n2 : n2 + " copy";
    async function doSave(overwrite, nameOverride) {
      ui2.savePop.hidden = true;
      if (ui2.saveBtn.classList.contains("is-busy")) return;
      ui2.saveBtn.classList.add("is-busy");
      savesInFlight++;
      const label = ui2.saveBtn.querySelector("span");
      const prev = label.textContent;
      label.textContent = "Saving\u2026";
      let pendingName = "";
      try {
        if (nameOverride) ui2.designNameInput.value = nameOverride;
        const name = currentName();
        const replaced = overwrite && currentSave ? currentSave.fileName : null;
        const result = await saveDesign(editor, {
          registry,
          name,
          prevFileName: replaced,
          onState: (art) => {
            pendingName = art.fileName;
            notePendingSave(art.fileName);
          }
          // card appears NOW; the print file follows
        });
        adoptSave({ fileName: result.fileName, name });
        noteSessionSave(result, replaced);
        label.textContent = "Saved \u2713";
        setTimeout(() => label.textContent = prev, 2e3);
        return true;
      } catch (err) {
        if (pendingName) dropPendingSave(pendingName);
        console.error("studio-v2: save failed", err);
        diagFail("save_fail", err);
        label.textContent = "Try again";
        setTimeout(() => label.textContent = prev, 2500);
        return false;
      } finally {
        savesInFlight = Math.max(0, savesInFlight - 1);
        ui2.saveBtn.classList.remove("is-busy");
      }
    }
    const closeFileMenu = () => {
      ui2.fileMenu.hidden = true;
      ui2.fileBtn.classList.remove("is-open");
    };
    function syncFileMenu() {
      const hasObjects = editor.canvas.getObjects().length > 0;
      ui2.fileNew.disabled = !hasObjects;
      ui2.fileOpen.disabled = !registry;
      ui2.fileSave.disabled = !hasObjects;
      ui2.fileSaveAs.disabled = !registry || !hasObjects;
      ui2.fileDup.disabled = !registry || !hasObjects;
      ui2.fileSignIn.hidden = !!registry;
    }
    ui2.fileBtn.addEventListener("click", () => {
      const open = ui2.fileMenu.hidden;
      if (open) {
        syncFileMenu();
        try {
          const n2 = diagCount();
          ui2.fileBuild.textContent = "Build " + (window.NinjaStudio && window.NinjaStudio.version || "dev") + (n2 ? " \xB7 " + n2 + " errors" : "");
        } catch (e24) {
        }
      }
      ui2.fileMenu.hidden = !open;
      ui2.fileBtn.classList.toggle("is-open", open);
    });
    listen(document, "pointerdown", (e24) => {
      if (!ui2.fileMenu.hidden && !ui2.fileWrap.contains(e24.target)) closeFileMenu();
    });
    function clearToNewDesign() {
      editor.canvas.discardActiveObject();
      editor.canvas.getObjects().slice().forEach((o2) => editor.canvas.remove(o2));
      editor.setCanvasBackground(null);
      adoptSave(null);
      ui2.designNameInput.value = "";
      try {
        localStorage.removeItem(DRAFT_KEY);
      } catch (e24) {
      }
      editor.canvas.renderAll();
      syncSelection();
    }
    ui2.fileNew.addEventListener("click", async () => {
      closeFileMenu();
      if (!editor.canvas.getObjects().length) return clearToNewDesign();
      if (registry) {
        const choice = await askDialog(
          currentSave ? "Save changes to \u201C" + (currentSave.name || "Untitled design") + "\u201D before starting a new one?" : "Save your current design before starting a new one?",
          { ok: currentSave ? "Save" : "Save & new", alt: "Discard" }
        );
        if (!choice) return;
        if (choice === true) {
          let overwrite = false;
          let name;
          if (currentSave) {
            const how = await askDialog("Update \u201C" + (currentSave.name || "Untitled design") + "\u201D or save as a new design?", {
              ok: "Update",
              alt: "Save as new"
            });
            if (!how) return;
            if (how === true) overwrite = true;
            else {
              name = await askName("Save as", { value: copyName(currentName()), ok: "Save & new" });
              if (name == null) return;
            }
          } else {
            name = await askName("Name your design", { value: currentName(), ok: "Save & new" });
            if (name == null) return;
          }
          const ok = await doSave(overwrite, name);
          if (!ok) return;
        }
      } else if (!await askDialog("Start a new design? Your current canvas will be replaced.", { ok: "New design" })) {
        return;
      }
      clearToNewDesign();
    });
    ui2.fileOpen.addEventListener("click", () => {
      closeFileMenu();
      openPane("designs");
    });
    ui2.fileSignIn.addEventListener("click", () => {
      closeFileMenu();
      gotoLogin();
    });
    ui2.uploadsSignin.hidden = !!opts.customerId || !!opts.persistRegistry;
    ui2.uploadsSigninBtn.addEventListener("click", () => gotoLogin("uploads"));
    ui2.fileSave.addEventListener("click", () => {
      closeFileMenu();
      ui2.saveBtn.click();
    });
    ui2.fileSaveAs.addEventListener("click", async () => {
      closeFileMenu();
      if (ui2.saveBtn.classList.contains("is-busy")) return;
      const name = await askName("Save as", { value: copyName(currentName()), ok: "Save copy" });
      if (name != null) doSave(false, name);
    });
    const OUTLINE_MODE_KEY = "nsv2OutlineTracksScale";
    const syncOutlineMode = () => ui2.fileOutlineMode.classList.toggle("is-on", !!editor.outlineTracksScale);
    try {
      const stored = localStorage.getItem(OUTLINE_MODE_KEY);
      editor.setOutlineTracksScale(stored == null ? true : stored === "1");
    } catch (e24) {
      editor.setOutlineTracksScale(true);
    }
    syncOutlineMode();
    ui2.fileOutlineMode.addEventListener("click", () => {
      editor.setOutlineTracksScale(!editor.outlineTracksScale);
      try {
        localStorage.setItem(OUTLINE_MODE_KEY, editor.outlineTracksScale ? "1" : "0");
      } catch (e24) {
      }
      syncOutlineMode();
    });
    ui2.fileDup.addEventListener("click", async () => {
      closeFileMenu();
      if (ui2.saveBtn.classList.contains("is-busy")) return;
      const name = await askName("Duplicate design", { value: copyName(currentName()), ok: "Duplicate" });
      if (name != null) doSave(false, name);
    });
    ui2.saveBtn.addEventListener("click", async () => {
      if (ui2.saveBtn.classList.contains("is-busy")) return;
      if (!editor.canvas.getObjects().length) return;
      if (!registry) {
        const name = await askName("Name your design", { value: currentName(), ok: "Save & sign in" });
        if (name == null) return;
        ui2.designNameInput.value = name;
        return parkSaveAndLogin();
      }
      if (!currentSave) {
        const name = await askName("Name your design", { value: currentName(), ok: "Save" });
        if (name == null) return;
        return doSave(false, name);
      }
      if (!ui2.savePop.hidden) return ui2.savePop.hidden = true;
      ui2.saveUpdateBtn.textContent = "Update \u201C" + (currentSave.name || "Untitled design") + "\u201D";
      ui2.savePop.hidden = false;
    });
    ui2.saveUpdateBtn.addEventListener("click", () => doSave(true));
    ui2.saveNewBtn.addEventListener("click", async () => {
      ui2.savePop.hidden = true;
      const name = await askName("Save as a new design", { value: copyName(currentName()), ok: "Save copy" });
      if (name != null) doSave(false, name);
    });
    listen(document, "pointerdown", (e24) => {
      if (!ui2.savePop.hidden && !ui2.saveWrap.contains(e24.target)) ui2.savePop.hidden = true;
    }, true);
    const bootState = opts.designState || (() => {
      try {
        return new URLSearchParams(window.location.search).get("ds_state");
      } catch (e24) {
        return null;
      }
    })();
    if (bootState) {
      let trusted = false;
      try {
        const u2 = new URL(bootState, window.location.href);
        trusted = u2.protocol === "https:" && (isBucketHost(u2.host) || u2.host === cfg.imgixHost);
      } catch (e24) {
      }
      if (trusted) {
        withBootVeil(
          loadDesignFromUrl(editor, bootState.split(cfg.imgixHost).join(cfg.s3Host), modeSanitize).then((meta) => {
            if (!lastStripped) adoptSave(meta);
            trackOpenSaved();
          }).catch((err) => console.error("studio-v2: boot design load failed", err))
        );
      } else {
        console.warn("studio-v2: ds_state ignored (untrusted host)", bootState);
      }
    }
    function withBootVeil(loadPromise) {
      const veil = document.createElement("div");
      veil.className = "nsv2-boot-veil";
      veil.innerHTML = '<span class="nsv2-boot-spin"></span>';
      ui2.area.appendChild(veil);
      const lift = () => {
        veil.classList.add("is-out");
        setTimeout(() => veil.remove(), 300);
      };
      Promise.race([
        Promise.resolve(loadPromise).then(() => editor.whenRestoreSettled()),
        new Promise((r2) => setTimeout(r2, 5e3))
      ]).then(lift, lift);
    }
    let draftTimer = null;
    editor.on("history", () => {
      clearTimeout(draftTimer);
      draftTimer = setTimeout(() => {
        try {
          if (editor.canvas.getObjects().some((o2) => !o2.__base)) localStorage.setItem(DRAFT_KEY, editor.designJSON());
          else localStorage.removeItem(DRAFT_KEY);
        } catch (e24) {
        }
      }, 1500);
    });
    let bootRestored = false;
    if (!bootState) {
      try {
        const draft = localStorage.getItem(DRAFT_KEY);
        if (draft && !editor.canvas.getObjects().length) {
          const data = JSON.parse(draft);
          bootRestored = true;
          withBootVeil(loadDesignData(editor, modeSanitize(data)).then(repointBaseToHost).catch((err) => console.warn("studio-v2: draft restore failed", err)));
          try {
            const meta = JSON.parse(localStorage.getItem(SAVE_KEY) || "null");
            if (meta && meta.fileName) adoptSave(meta);
          } catch (e24) {
          }
        }
      } catch (e24) {
      }
    }
    async function repointBaseToHost() {
      if (!baseImg) return;
      const base = editor.canvas.getObjects().find((o2) => o2.__base);
      if (!base) return;
      const want = baseDisplayUrl(baseImg.url);
      const el2 = base._originalElement || base._element;
      const have = el2 && el2.src || (typeof base.getSrc === "function" ? base.getSrc() : "") || "";
      if (have === want) return;
      await editor.replaceImageSource(base, want);
      editor.canvas.discardActiveObject();
      editor.canvas.requestRenderAll();
      editor.resetHistory();
      syncSelection();
    }
    function baseDisplayUrl(src) {
      if (!/^https?:/.test(src)) return src;
      let u2;
      try {
        u2 = new URL(src);
      } catch (e24) {
        return src;
      }
      if (u2.host.indexOf("imgix") === -1) return hostedDisplayUrl(src);
      ["dpr", "q", "auto", "h"].forEach((k2) => u2.searchParams.delete(k2));
      u2.searchParams.set("fm", "png");
      u2.searchParams.set("fit", "max");
      u2.searchParams.set("w", String(DISPLAY_W));
      return u2.toString();
    }
    async function placeBaseImage() {
      const bare = baseImg.url.split("?")[0];
      const name = baseImg.name || bare.split("/").pop();
      const img = await editor.addImageFromUrl(baseDisplayUrl(baseImg.url), name);
      img.__bgr = { status: "ready", imgixUrl: bare, fileName: name, isVector: false, versions: {}, model: null };
      const s3 = 0.58 * Math.min(editor.designW / Math.max(1, img.width), editor.designH / Math.max(1, img.height));
      img.set({ scaleX: s3, scaleY: s3, left: editor.designW / 2, top: editor.designH / 2 });
      editor.setBase(img);
      editor.canvas.discardActiveObject();
      editor.canvas.requestRenderAll();
      editor.resetHistory();
      syncSelection();
    }
    if (baseImg && !bootState && !bootRestored) {
      withBootVeil(placeBaseImage().catch((err) => console.error("studio-v2: base image failed to load", err)));
    }
    if (mode) {
      const solo = [...mode.tools].filter((t2) => TOOL_KIND[t2]);
      if (solo.length === 1 && ui2.root.clientWidth >= 768) openPane(solo[0]);
    }
    try {
      (window.NinjaStudio || (window.NinjaStudio = {})).__editor = editor;
    } catch (e24) {
    }
    installDiagnostics();
    track("open_" + surface);
    const warmGlyphs = () => prewarmGlyphEngine();
    if ("requestIdleCallback" in window) requestIdleCallback(warmGlyphs, { timeout: 8e3 });
    else setTimeout(warmGlyphs, 4e3);
    const shell = installShell({
      host,
      root: ui2.root,
      ui: ui2,
      editor,
      api: {
        openPane,
        closePanel,
        getActivePane: () => activePane,
        discardSelection: () => {
          editor.canvas.discardActiveObject();
          editor.canvas.requestRenderAll();
          syncSelection();
        },
        openMoreMenu: () => {
          const o2 = editor.canvas.getActiveObject();
          if (!o2) return;
          const ar2 = ui2.area.getBoundingClientRect();
          openMenu(ar2.width / 2 - 112, ar2.height - 320);
        },
        openZoomTray,
        toolAllowed
        // mode gate for the stripe's Layers chip
      }
    });
    return {
      editor,
      addText: (family) => {
        if (!kindAllowed("text")) return refuse("text");
        const t2 = editor.addText(family || currentFamily);
        trackAdd("text_add");
        return t2;
      },
      destroy() {
        for (const [t2, ty, fn2, o2] of tracked.splice(0)) t2.removeEventListener(ty, fn2, o2);
        for (const fn2 of cleanups.splice(0)) {
          try {
            fn2();
          } catch (e24) {
          }
        }
        endPanMode();
        shell.destroy();
        editor.destroy();
        ui2.root.remove();
        host.classList.remove("nsv2-host");
      }
    };
  }
  return __toCommonJS(src_exports);
})();
NinjaStudio.version='20261023-165542';
